// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zUserSettings = /*#__PURE__*/ z.object({
    theme: /*#__PURE__*/ z.enum(['dark', 'light']),
    notifications: /*#__PURE__*/ z.boolean(),
    defaultExchange: /*#__PURE__*/ z.string(),
    defaultLeverage: /*#__PURE__*/ z.number().gte(1).lte(125),
    timezone: /*#__PURE__*/ z.string(),
    uiMode: /*#__PURE__*/ z.enum(['simple', 'detailed']).optional(),
    activeModuleId: /*#__PURE__*/ z.string().max(50).optional()
});

export const zAdminUserOrganization = /*#__PURE__*/ z.object({
    orgId: /*#__PURE__*/ z.number(),
    orgName: /*#__PURE__*/ z.string(),
    orgSlug: /*#__PURE__*/ z.string()
});

export const zDecision = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    action: /*#__PURE__*/ z.enum([
        'approve',
        'reject',
        'modify'
    ]),
    notes: /*#__PURE__*/ z.string(),
    decidedBy: /*#__PURE__*/ z.string(),
    decidedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    modifications: /*#__PURE__*/ z.unknown().optional()
});

export const zWorkflowContract = /*#__PURE__*/ z.object({
    jsonSchema: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    schema: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    templateId: /*#__PURE__*/ z.string().optional(),
    example: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    strict: /*#__PURE__*/ z.boolean().optional()
});

export const zInputContractMap = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), zWorkflowContract);

export const zTemplateVariableConfig = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    default: /*#__PURE__*/ z.string().optional()
});

export const zSpawnPolicyConfig = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.string(),
    min: /*#__PURE__*/ z.number().optional(),
    max: /*#__PURE__*/ z.number().optional()
});

export const zTaskProfileConfig = /*#__PURE__*/ z.object({
    primaryCapability: /*#__PURE__*/ z.enum([
        'reasoning',
        'vision',
        'fast',
        'code',
        'long-context'
    ]),
    secondaryCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
        'reasoning',
        'vision',
        'fast',
        'code',
        'long-context'
    ])),
    latencyClass: /*#__PURE__*/ z.enum([
        'realtime',
        'interactive',
        'batch'
    ]),
    requiresToolCalling: /*#__PURE__*/ z.boolean(),
    requiresVision: /*#__PURE__*/ z.boolean(),
    preferredCost: /*#__PURE__*/ z.enum([
        'free',
        'low',
        'medium',
        'high'
    ]),
    minContextWindow: /*#__PURE__*/ z.number(),
    requiresStructuredOutput: /*#__PURE__*/ z.boolean()
});

export const zHeartbeatConfig = /*#__PURE__*/ z.object({
    every_n_calls: /*#__PURE__*/ z.number().optional(),
    every_t_seconds: /*#__PURE__*/ z.number().optional()
});

export const zTemplateUpgradeEvaluation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    versionId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    evaluationRunId: /*#__PURE__*/ z.number().nullable(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    daemonRunId: /*#__PURE__*/ z.number().nullable(),
    agentSessionId: /*#__PURE__*/ z.number().nullable(),
    toolExecutionId: /*#__PURE__*/ z.number().nullable(),
    skillUsageEventId: /*#__PURE__*/ z.number().nullable(),
    strategyRunId: /*#__PURE__*/ z.number().nullable(),
    forwardRunId: /*#__PURE__*/ z.number().nullable(),
    workerRunId: /*#__PURE__*/ z.number().nullable(),
    createdByUserId: /*#__PURE__*/ z.number().nullable(),
    runContext: /*#__PURE__*/ z.enum(['production', 'test']),
    evaluator: /*#__PURE__*/ z.enum([
        'golden_fixture',
        'strategy_evaluation',
        'indicator_validation',
        'llm_judge',
        'human_review',
        'paper_trading',
        'live_trading',
        'competition_rating',
        'security_review',
        'quality_review',
        'persona_validity',
        'calibration'
    ]),
    verdict: /*#__PURE__*/ z.enum([
        'pass',
        'warn',
        'fail'
    ]).nullable(),
    score: /*#__PURE__*/ z.string().nullable(),
    effectiveFingerprint: /*#__PURE__*/ z.string(),
    detail: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    evaluatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zRuntimePolicyRetireCounts = /*#__PURE__*/ z.object({
    conversationsMoved: /*#__PURE__*/ z.number(),
    entitiesMoved: /*#__PURE__*/ z.number(),
    allowedRemoved: /*#__PURE__*/ z.number(),
    fallbacksCleared: /*#__PURE__*/ z.number()
});

export const zRuntimePolicySurface = /*#__PURE__*/ z.enum([
    'conversation',
    'workforce',
    'workflow',
    'analysis',
    'evaluation',
    'judge',
    'codegen',
    'system',
    'research'
]);

export const zRuntimePolicySurfaceRule = /*#__PURE__*/ z.object({
    surface: zRuntimePolicySurface,
    organizationId: /*#__PURE__*/ z.number().nullable(),
    defaultPolicyId: /*#__PURE__*/ z.number(),
    allowedPolicyIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    system: /*#__PURE__*/ z.object({
        defaultPolicyId: /*#__PURE__*/ z.number(),
        allowedPolicyIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number())
    }).nullable()
});

export const zEvaluationTemplate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    templateRef: /*#__PURE__*/ z.string().nullable(),
    name: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    visibility: /*#__PURE__*/ z.enum(['private', 'org']),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'deprecated',
        'retired'
    ]),
    subjectKind: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]),
    templateKind: /*#__PURE__*/ z.enum(['leaf', 'group']),
    spec: /*#__PURE__*/ z.object({
        schemaVersion: /*#__PURE__*/ z.enum(['evaluation-template-spec/v1']),
        subjectKind: /*#__PURE__*/ z.string().min(1),
        items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.object({
                kind: /*#__PURE__*/ z.enum(['criterion']),
                evaluatorKey: /*#__PURE__*/ z.string().min(1),
                modality: /*#__PURE__*/ z.string().min(1).optional(),
                thresholds: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional().default({}),
                params: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
                minTrials: /*#__PURE__*/ z.int().gte(0).optional().default(0),
                required: /*#__PURE__*/ z.boolean().optional().default(true)
            }), /*#__PURE__*/ z.object({
                kind: /*#__PURE__*/ z.enum(['template_ref']),
                childTemplateRef: /*#__PURE__*/ z.string().min(1),
                childVersion: /*#__PURE__*/ z.int().gt(0),
                required: /*#__PURE__*/ z.boolean().optional().default(true)
            })])).min(1)
    }),
    currentVersionId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zEvaluationTemplateVersion = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    templateId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    state: /*#__PURE__*/ z.enum(['draft', 'locked']),
    subjectKind: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]),
    templateKind: /*#__PURE__*/ z.enum(['leaf', 'group']),
    spec: /*#__PURE__*/ z.object({
        schemaVersion: /*#__PURE__*/ z.enum(['evaluation-template-spec/v1']),
        subjectKind: /*#__PURE__*/ z.string().min(1),
        items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.object({
                kind: /*#__PURE__*/ z.enum(['criterion']),
                evaluatorKey: /*#__PURE__*/ z.string().min(1),
                modality: /*#__PURE__*/ z.string().min(1).optional(),
                thresholds: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional().default({}),
                params: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
                minTrials: /*#__PURE__*/ z.int().gte(0).optional().default(0),
                required: /*#__PURE__*/ z.boolean().optional().default(true)
            }), /*#__PURE__*/ z.object({
                kind: /*#__PURE__*/ z.enum(['template_ref']),
                childTemplateRef: /*#__PURE__*/ z.string().min(1),
                childVersion: /*#__PURE__*/ z.int().gt(0),
                required: /*#__PURE__*/ z.boolean().optional().default(true)
            })])).min(1)
    }),
    createdAt: /*#__PURE__*/ z.string()
});

export const zCatalogSourceFragmentSummary = /*#__PURE__*/ z.object({
    fragmentType: /*#__PURE__*/ z.string(),
    sourcePath: /*#__PURE__*/ z.string().nullable(),
    sourceUrl: /*#__PURE__*/ z.string().nullable(),
    sourceRef: /*#__PURE__*/ z.string().nullable(),
    title: /*#__PURE__*/ z.string().nullable(),
    contentHash: /*#__PURE__*/ z.string().nullable(),
    contentType: /*#__PURE__*/ z.string().nullable(),
    targetTypeHint: /*#__PURE__*/ z.string().nullable(),
    classification: /*#__PURE__*/ z.string().nullable(),
    rationale: /*#__PURE__*/ z.string().nullable()
});

export const zCatalogIntegrityCheckSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    checkType: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'passed',
        'warning',
        'blocked'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    message: /*#__PURE__*/ z.string(),
    recommendation: /*#__PURE__*/ z.string().nullable(),
    checkedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    sourceFragment: /*#__PURE__*/ zCatalogSourceFragmentSummary.nullable()
});

export const zCatalogSource = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    sourceType: /*#__PURE__*/ z.string(),
    canonicalKey: /*#__PURE__*/ z.string(),
    sourceUrl: /*#__PURE__*/ z.string().nullable(),
    sourceRepoUrl: /*#__PURE__*/ z.string().nullable(),
    sourcePath: /*#__PURE__*/ z.string().nullable(),
    sourceRef: /*#__PURE__*/ z.string().nullable(),
    packageName: /*#__PURE__*/ z.string().nullable(),
    provider: /*#__PURE__*/ z.string().nullable(),
    externalId: /*#__PURE__*/ z.string().nullable(),
    title: /*#__PURE__*/ z.string().nullable(),
    contentHash: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    firstSeenAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    lastSeenAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    lastCheckedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    nextRefreshAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    refreshIntervalDays: /*#__PURE__*/ z.number(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zCatalogRunLink = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number(),
    daemonName: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string(),
    startedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    completedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    error: /*#__PURE__*/ z.string().nullable()
});

export const zCatalogFindingSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number(),
    daemonName: /*#__PURE__*/ z.string(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    category: /*#__PURE__*/ z.enum([
        'vulnerability',
        'quality-issue',
        'optimization',
        'insight',
        'alert',
        'template-ecosystem',
        'promotion_candidate',
        'intent_classification_review',
        'edge_decay',
        'survivorship_bias_report'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    title: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    recommendation: /*#__PURE__*/ z.string().nullable(),
    evidence: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    affectedFiles: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    affectedSymbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zCatalogCandidate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    sourceId: /*#__PURE__*/ z.number(),
    targetType: /*#__PURE__*/ z.string(),
    targetId: /*#__PURE__*/ z.number().nullable(),
    proposedAction: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    confidence: /*#__PURE__*/ z.string().nullable(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    diffSummary: /*#__PURE__*/ z.string().nullable(),
    sourceContentHash: /*#__PURE__*/ z.string().nullable(),
    discoveredByEntityId: /*#__PURE__*/ z.number().nullable(),
    discoveredRunId: /*#__PURE__*/ z.number().nullable(),
    reportId: /*#__PURE__*/ z.number().nullable(),
    findingId: /*#__PURE__*/ z.number().nullable(),
    securityReviewedRunId: /*#__PURE__*/ z.number().nullable(),
    qualityReviewedRunId: /*#__PURE__*/ z.number().nullable(),
    queuedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    reviewReadyAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    appliedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    idempotencyKey: /*#__PURE__*/ z.string(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zWorkOutputPart = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    workOutputId: /*#__PURE__*/ z.number(),
    runId: /*#__PURE__*/ z.number().nullish(),
    workflowId: /*#__PURE__*/ z.number().nullish(),
    stepId: /*#__PURE__*/ z.string().nullish(),
    sourceType: /*#__PURE__*/ z.string(),
    sourceId: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.string(),
    key: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    portType: /*#__PURE__*/ z.string().nullish(),
    payload: /*#__PURE__*/ z.unknown().optional(),
    payloadUrl: /*#__PURE__*/ z.string().nullish(),
    mimeType: /*#__PURE__*/ z.string().nullish(),
    sizeBytes: /*#__PURE__*/ z.number().nullish(),
    visibility: /*#__PURE__*/ z.string().nullish(),
    source: /*#__PURE__*/ z.string().nullish(),
    schema: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    ttlHours: /*#__PURE__*/ z.number().nullish(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zSafeOutputConstraint = /*#__PURE__*/ z.object({
    maxValue: /*#__PURE__*/ z.number().optional(),
    allowedValues: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    maxLength: /*#__PURE__*/ z.number().optional(),
    maxCalls: /*#__PURE__*/ z.number().optional(),
    appliesTo: /*#__PURE__*/ z.enum([
        'all',
        'cloud',
        'local'
    ]).optional()
});

export const zJsonObject = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zWorkflowScheduleConfig = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'cron',
        'interval',
        'event'
    ]),
    cron: /*#__PURE__*/ z.string().optional(),
    intervalMs: /*#__PURE__*/ z.number().optional(),
    eventTrigger: /*#__PURE__*/ z.string().optional(),
    eventFilter: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.boolean()
    ])).optional(),
    enabled: /*#__PURE__*/ z.boolean()
});

export const zMarketplaceAcquisitionVersion = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    note: /*#__PURE__*/ z.string().nullable(),
    publishedAt: /*#__PURE__*/ z.string().nullable()
});

export const zConversationIntentKind = /*#__PURE__*/ z.enum([
    'direct_answer',
    'workflow',
    'task',
    'project',
    'marketplace',
    'ambiguous',
    'template',
    'workforce'
]);

export const zParameterDefinition = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.enum([
        'number',
        'integer',
        'boolean',
        'select'
    ]),
    default: /*#__PURE__*/ z.unknown().optional(),
    min: /*#__PURE__*/ z.number().optional(),
    max: /*#__PURE__*/ z.number().optional(),
    step: /*#__PURE__*/ z.number().optional(),
    options: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).optional(),
    description: /*#__PURE__*/ z.string().optional()
});

export const zStrategy = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    author: /*#__PURE__*/ z.string().optional(),
    type: /*#__PURE__*/ z.enum([
        'trend_following',
        'mean_reversion',
        'momentum',
        'volatility',
        'scalping',
        'custom'
    ]),
    timeframes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
        '1m',
        '3m',
        '5m',
        '15m',
        '30m',
        '1h',
        '2h',
        '4h',
        '6h',
        '12h',
        '1d',
        '1w'
    ])),
    parameters: /*#__PURE__*/ z.array(zParameterDefinition)
});

export const zAgentRecommendation = /*#__PURE__*/ z.object({
    action: /*#__PURE__*/ z.enum([
        'buy',
        'sell',
        'hold',
        'close',
        'reduce',
        'increase'
    ]),
    symbol: /*#__PURE__*/ z.string(),
    confidence: /*#__PURE__*/ z.number(),
    reason: /*#__PURE__*/ z.string(),
    suggestedSize: /*#__PURE__*/ z.number().optional(),
    stopLoss: /*#__PURE__*/ z.number().optional(),
    takeProfit: /*#__PURE__*/ z.number().optional(),
    priority: /*#__PURE__*/ z.number()
});

export const zAllocationRecommendation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    portfolioId: /*#__PURE__*/ z.number(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    generatedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'modified',
        'expired'
    ]).nullable(),
    allocations: /*#__PURE__*/ z.unknown().optional(),
    rationale: /*#__PURE__*/ z.string().nullable(),
    riskWarnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    reviewedBy: /*#__PURE__*/ z.string().nullable(),
    reviewedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    reviewNotes: /*#__PURE__*/ z.string().nullable()
});

export const zStrategyRunBenchmark = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1).max(40),
    exchange: /*#__PURE__*/ z.string().min(1).max(20),
    defaulted: /*#__PURE__*/ z.boolean(),
    source: /*#__PURE__*/ z.string().max(64).optional(),
    stats: /*#__PURE__*/ z.object({
        status: /*#__PURE__*/ z.enum(['computed', 'absent']),
        reasonCode: /*#__PURE__*/ z.enum([
            'no_benchmark_resolved',
            'no_benchmark_series',
            'insufficient_overlap',
            'degenerate_benchmark_variance',
            'no_strategy_returns'
        ]).nullable(),
        observations: /*#__PURE__*/ z.int().gte(0),
        periodsPerYear: /*#__PURE__*/ z.number().gt(0),
        strategyReturn: /*#__PURE__*/ z.number().nullable(),
        benchmarkReturn: /*#__PURE__*/ z.number().nullable(),
        excessReturn: /*#__PURE__*/ z.number().nullable(),
        trackingError: /*#__PURE__*/ z.number().nullable(),
        informationRatio: /*#__PURE__*/ z.number().nullable(),
        alpha: /*#__PURE__*/ z.number().nullable(),
        beta: /*#__PURE__*/ z.number().nullable(),
        upCapture: /*#__PURE__*/ z.number().nullable(),
        downCapture: /*#__PURE__*/ z.number().nullable()
    }),
    universeBuyHoldReturn: /*#__PURE__*/ z.number().nullish()
});

export const zStrategyRunSeriesPoint = /*#__PURE__*/ z.object({
    time: /*#__PURE__*/ z.number(),
    value: /*#__PURE__*/ z.number()
});

export const zStrategyTemplateMarketDataReadiness = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'ready',
        'research_only',
        'blocked'
    ]),
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    timeframe: /*#__PURE__*/ z.string(),
    windowStart: /*#__PURE__*/ z.string(),
    windowEnd: /*#__PURE__*/ z.string(),
    rowCount: /*#__PURE__*/ z.int().gte(0),
    expectedBars: /*#__PURE__*/ z.int().gt(0).nullable(),
    missingIntervalCount: /*#__PURE__*/ z.int().gte(0),
    missingIntervals: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        previousTime: /*#__PURE__*/ z.string(),
        nextTime: /*#__PURE__*/ z.string(),
        skippedIntervals: /*#__PURE__*/ z.int().gte(0)
    })),
    firstBar: /*#__PURE__*/ z.string().nullable(),
    lastBar: /*#__PURE__*/ z.string().nullable(),
    windowStartCovered: /*#__PURE__*/ z.boolean(),
    windowEndCovered: /*#__PURE__*/ z.boolean(),
    staleLastBar: /*#__PURE__*/ z.boolean(),
    pointInTime: /*#__PURE__*/ z.enum(['verified', 'unverified']),
    providerUnlockIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.string(),
        severity: /*#__PURE__*/ z.enum(['blocker', 'warning']),
        message: /*#__PURE__*/ z.string()
    })),
    lineage: /*#__PURE__*/ z.object({
        coverage: /*#__PURE__*/ z.enum([
            'full',
            'partial',
            'none'
        ]),
        providerRefs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).max(5),
        adjustmentPolicies: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).max(3),
        availabilityViolations: /*#__PURE__*/ z.int().gte(0),
        pitSafeProvider: /*#__PURE__*/ z.boolean()
    }).nullish()
});

export const zStrategyTemplateRealtimeMarketDataReadiness = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'ready',
        'research_only',
        'blocked'
    ]),
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    timeframe: /*#__PURE__*/ z.string(),
    evaluatedAt: /*#__PURE__*/ z.string(),
    lastBarTime: /*#__PURE__*/ z.string().nullable(),
    lastBarAgeMs: /*#__PURE__*/ z.number().nullable(),
    stalenessBudgetMs: /*#__PURE__*/ z.number().nullable(),
    barFresh: /*#__PURE__*/ z.boolean(),
    provider: /*#__PURE__*/ z.object({
        providerRef: /*#__PURE__*/ z.string().nullable(),
        realtimeCapable: /*#__PURE__*/ z.boolean(),
        streamTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }),
    feed: /*#__PURE__*/ z.object({
        running: /*#__PURE__*/ z.boolean().nullable(),
        channels: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.boolean()),
        source: /*#__PURE__*/ z.enum(['server_aggregator', 'unknown'])
    }),
    realtimeCertified: /*#__PURE__*/ z.literal(false),
    providerUnlockIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.string(),
        severity: /*#__PURE__*/ z.enum(['blocker', 'warning']),
        message: /*#__PURE__*/ z.string()
    }))
});

export const zFinanceResearchDaemonLink = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean(),
    requiresApproval: /*#__PURE__*/ z.boolean()
});

export const zFinanceResearchRunSummaryIndicator = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum(['indicator']),
    runtimeAvailable: /*#__PURE__*/ z.boolean().optional(),
    librariesProbed: /*#__PURE__*/ z.number().optional(),
    librariesAvailable: /*#__PURE__*/ z.number().optional(),
    candidates: /*#__PURE__*/ z.object({
        draftValidatable: /*#__PURE__*/ z.number(),
        researchOnly: /*#__PURE__*/ z.number(),
        blocked: /*#__PURE__*/ z.number()
    }).optional(),
    registration: /*#__PURE__*/ z.object({
        created: /*#__PURE__*/ z.number(),
        metadataUpdated: /*#__PURE__*/ z.number(),
        versionAdded: /*#__PURE__*/ z.number(),
        alreadyRegistered: /*#__PURE__*/ z.number(),
        rejected: /*#__PURE__*/ z.number()
    }).optional(),
    validation: /*#__PURE__*/ z.object({
        ran: /*#__PURE__*/ z.number(),
        passed: /*#__PURE__*/ z.number()
    }).optional(),
    proposals: /*#__PURE__*/ z.object({
        proposed: /*#__PURE__*/ z.number(),
        alreadyProposed: /*#__PURE__*/ z.number(),
        rejected: /*#__PURE__*/ z.number(),
        skipped: /*#__PURE__*/ z.number()
    }).optional(),
    pendingDecisionIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zFinanceResearchRunSummaryStrategy = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum(['strategy']),
    registration: /*#__PURE__*/ z.object({
        created: /*#__PURE__*/ z.number(),
        metadataUpdated: /*#__PURE__*/ z.number(),
        versionAdded: /*#__PURE__*/ z.number(),
        alreadyRegistered: /*#__PURE__*/ z.number(),
        rejected: /*#__PURE__*/ z.number(),
        batches: /*#__PURE__*/ z.number().optional(),
        templatesCreated: /*#__PURE__*/ z.number().optional(),
        versionsAppended: /*#__PURE__*/ z.number().optional()
    }).optional(),
    compilation: /*#__PURE__*/ z.object({
        compiledCandidates: /*#__PURE__*/ z.number(),
        alreadyCompiled: /*#__PURE__*/ z.number(),
        requiresHumanReview: /*#__PURE__*/ z.number()
    }).optional(),
    humanReviewCount: /*#__PURE__*/ z.number().optional(),
    warningsCount: /*#__PURE__*/ z.number().optional()
});

export const zFinanceResearchRunSummaryPlanner = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum(['planner']),
    planner: /*#__PURE__*/ z.object({
        candidatesEvaluated: /*#__PURE__*/ z.number(),
        enqueuedCount: /*#__PURE__*/ z.number(),
        skippedCount: /*#__PURE__*/ z.number(),
        dedupHits: /*#__PURE__*/ z.number(),
        budgetMax: /*#__PURE__*/ z.number(),
        budgetUsed: /*#__PURE__*/ z.number(),
        runRequestsBlocked: /*#__PURE__*/ z.number(),
        topEnqueued: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            definitionId: /*#__PURE__*/ z.number(),
            requestId: /*#__PURE__*/ z.string(),
            scope: /*#__PURE__*/ z.string(),
            wtn: /*#__PURE__*/ z.number()
        }))
    }).optional()
});

export const zFinanceResearchRunSummaryComposer = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum(['composer']),
    composer: /*#__PURE__*/ z.object({
        candidatesEvaluated: /*#__PURE__*/ z.number(),
        composedCount: /*#__PURE__*/ z.number(),
        dedupHits: /*#__PURE__*/ z.number(),
        budgetMax: /*#__PURE__*/ z.number(),
        budgetUsed: /*#__PURE__*/ z.number(),
        runRequestsBlocked: /*#__PURE__*/ z.number(),
        skippedCount: /*#__PURE__*/ z.number(),
        topComposed: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            bucketId: /*#__PURE__*/ z.string(),
            bucketHash: /*#__PURE__*/ z.string(),
            mode: /*#__PURE__*/ z.string(),
            componentCount: /*#__PURE__*/ z.number(),
            allocationMethod: /*#__PURE__*/ z.string(),
            persistStatus: /*#__PURE__*/ z.string(),
            runRequestStatus: /*#__PURE__*/ z.string().nullable(),
            evaluationRecorded: /*#__PURE__*/ z.boolean()
        }))
    }).optional()
});

export const zFinanceResearchRunSummaryDegradation = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum(['degradation']),
    degradation: /*#__PURE__*/ z.object({
        bucketsScanned: /*#__PURE__*/ z.number(),
        bucketsSkipped: /*#__PURE__*/ z.number(),
        signalsCount: /*#__PURE__*/ z.number(),
        observationsCreated: /*#__PURE__*/ z.number(),
        pendingDecisionsCreated: /*#__PURE__*/ z.number(),
        decisionsDeduped: /*#__PURE__*/ z.number(),
        unsupportedActionsCount: /*#__PURE__*/ z.number(),
        evalRefreshCount: /*#__PURE__*/ z.number(),
        runRequestsBlocked: /*#__PURE__*/ z.number(),
        topSignals: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            bucketId: /*#__PURE__*/ z.string(),
            signal: /*#__PURE__*/ z.string(),
            severity: /*#__PURE__*/ z.string(),
            componentDefinitionId: /*#__PURE__*/ z.number().nullable()
        })),
        knowledge: /*#__PURE__*/ z.object({
            hypothesesCreated: /*#__PURE__*/ z.number(),
            hypothesesDeduped: /*#__PURE__*/ z.number(),
            edgesCreated: /*#__PURE__*/ z.number(),
            replaceDecisionsCreated: /*#__PURE__*/ z.number(),
            artifactCreated: /*#__PURE__*/ z.boolean()
        }).nullable()
    }).optional()
});

export const zFinanceResearchRunSummary = /*#__PURE__*/ z.discriminatedUnion('kind', [
    /*#__PURE__*/ zFinanceResearchRunSummaryIndicator.extend({ kind: /*#__PURE__*/ z.literal('indicator') }),
    /*#__PURE__*/ zFinanceResearchRunSummaryStrategy.extend({ kind: /*#__PURE__*/ z.literal('strategy') }),
    /*#__PURE__*/ zFinanceResearchRunSummaryPlanner.extend({ kind: /*#__PURE__*/ z.literal('planner') }),
    /*#__PURE__*/ zFinanceResearchRunSummaryComposer.extend({ kind: /*#__PURE__*/ z.literal('composer') }),
    /*#__PURE__*/ zFinanceResearchRunSummaryDegradation.extend({ kind: /*#__PURE__*/ z.literal('degradation') })
]);

export const zFinanceResearchLastRun = /*#__PURE__*/ z.object({
    workflowRunId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    triggeredBy: /*#__PURE__*/ z.string().nullable(),
    startedAt: /*#__PURE__*/ z.string().nullable(),
    completedAt: /*#__PURE__*/ z.string().nullable(),
    error: /*#__PURE__*/ z.string().nullable(),
    summary: zFinanceResearchRunSummary
});

export const zFinancePlannerAdvancedComponents = /*#__PURE__*/ z.object({
    muHat: /*#__PURE__*/ z.number(),
    sigmaHat: /*#__PURE__*/ z.number(),
    gateThreshold: /*#__PURE__*/ z.number(),
    expectedImprovement: /*#__PURE__*/ z.number(),
    gateProx: /*#__PURE__*/ z.number(),
    ucbBonus: /*#__PURE__*/ z.number(),
    kappa: /*#__PURE__*/ z.number(),
    eventRel: /*#__PURE__*/ z.number(),
    bucketNeed: /*#__PURE__*/ z.number(),
    normCost: /*#__PURE__*/ z.number(),
    drs: /*#__PURE__*/ z.number(),
    redundancyPenalty: /*#__PURE__*/ z.number(),
    nonStationarityDiscount: /*#__PURE__*/ z.number(),
    numerator: /*#__PURE__*/ z.number()
});

export const zFinancePlannerPendingRequest = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string()
});

export const zFinanceBucketSimulation = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'simulated',
        'evidence_only',
        'blocked'
    ]),
    basis: /*#__PURE__*/ z.enum(['portfolio_return_simulation', 'component_evidence_only']),
    allocationMethod: /*#__PURE__*/ z.enum([
        'bucket_definition',
        'equal_weight',
        'inverse_volatility'
    ]).optional(),
    allocationFallbackReason: /*#__PURE__*/ z.string().optional(),
    windowStart: /*#__PURE__*/ z.string().optional(),
    windowEnd: /*#__PURE__*/ z.string().optional(),
    observedBars: /*#__PURE__*/ z.number().optional(),
    periodsPerYear: /*#__PURE__*/ z.number().optional(),
    componentCount: /*#__PURE__*/ z.number(),
    observedComponents: /*#__PURE__*/ z.number(),
    missingComponents: /*#__PURE__*/ z.number(),
    excludedPausedComponents: /*#__PURE__*/ z.number(),
    annualizedReturn: /*#__PURE__*/ z.number().optional(),
    annualizedVolatility: /*#__PURE__*/ z.number().optional(),
    sharpe: /*#__PURE__*/ z.number().optional(),
    maxDrawdown: /*#__PURE__*/ z.number().optional(),
    correlation: /*#__PURE__*/ z.object({
        pairCount: /*#__PURE__*/ z.number(),
        observedPairs: /*#__PURE__*/ z.number(),
        avgAbsPairwise: /*#__PURE__*/ z.number().optional(),
        maxAbsPairwise: /*#__PURE__*/ z.number().optional()
    }).optional(),
    hrpStatus: /*#__PURE__*/ z.enum(['applied', 'unavailable']).optional(),
    hrpReason: /*#__PURE__*/ z.string().optional(),
    topDiagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    warningsCount: /*#__PURE__*/ z.number().optional()
});

export const zFinanceBucketAllocationEvidence = /*#__PURE__*/ z.object({
    basis: /*#__PURE__*/ z.enum([
        'return_series',
        'persisted_scalar',
        'none'
    ]),
    observedComponents: /*#__PURE__*/ z.number(),
    missingComponents: /*#__PURE__*/ z.number(),
    windowStart: /*#__PURE__*/ z.string().optional(),
    windowEnd: /*#__PURE__*/ z.string().optional(),
    observedBars: /*#__PURE__*/ z.number().optional(),
    periodsPerYear: /*#__PURE__*/ z.number().optional(),
    correlation: /*#__PURE__*/ z.object({
        pairCount: /*#__PURE__*/ z.number(),
        observedPairs: /*#__PURE__*/ z.number(),
        avgAbsPairwise: /*#__PURE__*/ z.number().optional(),
        maxAbsPairwise: /*#__PURE__*/ z.number().optional()
    }).optional(),
    hrpStatus: /*#__PURE__*/ z.enum(['applied', 'unavailable']),
    hrpReason: /*#__PURE__*/ z.string().optional(),
    topDiagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zFinanceBucketEvaluation = /*#__PURE__*/ z.object({
    evaluationId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    verdict: /*#__PURE__*/ z.string(),
    recommendation: /*#__PURE__*/ z.string(),
    recommendationReason: /*#__PURE__*/ z.string(),
    overallScore: /*#__PURE__*/ z.number().nullable(),
    evaluatedAt: /*#__PURE__*/ z.string().nullable(),
    runRef: /*#__PURE__*/ z.string().nullable(),
    evaluatorRef: /*#__PURE__*/ z.string().nullable(),
    allocationMethod: /*#__PURE__*/ z.string().optional(),
    allocationFallbackReason: /*#__PURE__*/ z.string().optional(),
    correlationPairsWithEvidence: /*#__PURE__*/ z.number().optional(),
    correlationPairsMissingEvidence: /*#__PURE__*/ z.number().optional(),
    correlationMaxAbsCorrelation: /*#__PURE__*/ z.number().optional(),
    correlationRejectedCount: /*#__PURE__*/ z.number().optional(),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    blockers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    simulation: /*#__PURE__*/ zFinanceBucketSimulation.optional(),
    allocationEvidence: /*#__PURE__*/ zFinanceBucketAllocationEvidence.optional()
});

export const zFinanceBucketRunRequest = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    dataReadiness: /*#__PURE__*/ z.string(),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    createdAt: /*#__PURE__*/ z.string()
});

export const zFinanceBucketRun = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string(),
    verdict: /*#__PURE__*/ z.string().nullable(),
    recommendation: /*#__PURE__*/ z.string().nullable(),
    passed: /*#__PURE__*/ z.boolean().nullable(),
    researchOnly: /*#__PURE__*/ z.boolean(),
    finishedAt: /*#__PURE__*/ z.string().nullable()
});

export const zFinanceBucketScore = /*#__PURE__*/ z.object({
    value: /*#__PURE__*/ z.number(),
    uncertainty: /*#__PURE__*/ z.number(),
    computedAt: /*#__PURE__*/ z.string()
});

export const zFinanceDegradationReplacement = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.number(),
    skillValue: /*#__PURE__*/ z.number()
});

export const zFinanceDegradationSignal = /*#__PURE__*/ z.object({
    signal: /*#__PURE__*/ z.enum([
        'component_sqs_drift',
        'bucket_score_deterioration',
        'bucket_eval_missing',
        'bucket_eval_stale',
        'component_run_failed',
        'component_request_blocked',
        'correlation_breach',
        'degrades_after_event_edge'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    componentDefinitionId: /*#__PURE__*/ z.number().nullable(),
    detail: /*#__PURE__*/ z.string()
});

export const zFinanceDegradationLastScan = /*#__PURE__*/ z.object({
    scannedAt: /*#__PURE__*/ z.string().nullable(),
    signals: /*#__PURE__*/ z.array(zFinanceDegradationSignal),
    unsupportedActions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zFinanceIndicatorDecisionVerdict = /*#__PURE__*/ z.object({
    recommendation: /*#__PURE__*/ z.enum([
        'buy',
        'hold',
        'sell',
        'needs_more_data'
    ]).nullable(),
    latestSignal: /*#__PURE__*/ z.object({
        state: /*#__PURE__*/ z.enum([
            'triggered',
            'not_triggered',
            'unknown'
        ]),
        side: /*#__PURE__*/ z.enum(['long', 'short']).nullable(),
        signalId: /*#__PURE__*/ z.string().nullable(),
        lastSignalAt: /*#__PURE__*/ z.string().nullable(),
        lastBarAt: /*#__PURE__*/ z.string().nullable(),
        trueCount: /*#__PURE__*/ z.number().nullable()
    }).nullable(),
    coverage: /*#__PURE__*/ z.object({
        rowCount: /*#__PURE__*/ z.number().nullable(),
        warmupNullCount: /*#__PURE__*/ z.number().nullable(),
        outputNullCounts: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional(),
        firstBarAt: /*#__PURE__*/ z.string().nullable(),
        lastBarAt: /*#__PURE__*/ z.string().nullable(),
        expectedBars: /*#__PURE__*/ z.number().nullable()
    }).nullable(),
    confidence: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high'
    ]).nullable(),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    blockers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zStrategyDecisionLatestSignal = /*#__PURE__*/ z.object({
    state: /*#__PURE__*/ z.enum(['active', 'unknown']),
    lastBarAt: /*#__PURE__*/ z.string().nullable(),
    entryTriggeredOnLastBar: /*#__PURE__*/ z.boolean(),
    exitTriggeredOnLastBar: /*#__PURE__*/ z.boolean()
});

export const zStrategyDecisionRunSummary = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string(),
    runStatus: /*#__PURE__*/ z.string(),
    verdict: /*#__PURE__*/ z.string().nullable(),
    recommendation: /*#__PURE__*/ z.string().nullable(),
    researchOnly: /*#__PURE__*/ z.boolean(),
    finishedAt: /*#__PURE__*/ z.string().nullable(),
    windowStart: /*#__PURE__*/ z.string().nullable(),
    windowEnd: /*#__PURE__*/ z.string().nullable(),
    scope: /*#__PURE__*/ z.string(),
    runMode: /*#__PURE__*/ z.string()
});

export const zStrategyDecisionRequestSummary = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    requestedAt: /*#__PURE__*/ z.string()
});

export const zStrategyDecisionScoreSummary = /*#__PURE__*/ z.object({
    value: /*#__PURE__*/ z.number(),
    uncertainty: /*#__PURE__*/ z.number(),
    skillProb: /*#__PURE__*/ z.number().nullable(),
    pboPassed: /*#__PURE__*/ z.boolean().nullable(),
    computedAt: /*#__PURE__*/ z.string()
});

export const zStrategyDecisionDataReadinessSummary = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string(),
    pointInTime: /*#__PURE__*/ z.boolean(),
    missingIntervalCount: /*#__PURE__*/ z.number(),
    staleLastBar: /*#__PURE__*/ z.boolean()
});

export const zFinanceOpsIndicatorDecisionVerdict = /*#__PURE__*/ z.object({
    recommendation: /*#__PURE__*/ z.enum([
        'buy',
        'hold',
        'sell',
        'needs_more_data'
    ]).nullable(),
    latestSignal: /*#__PURE__*/ z.object({
        state: /*#__PURE__*/ z.enum([
            'triggered',
            'not_triggered',
            'unknown'
        ]),
        side: /*#__PURE__*/ z.enum(['long', 'short']).nullable(),
        signalId: /*#__PURE__*/ z.string().nullable(),
        lastSignalAt: /*#__PURE__*/ z.string().nullable(),
        lastBarAt: /*#__PURE__*/ z.string().nullable(),
        trueCount: /*#__PURE__*/ z.number().nullable()
    }).nullable(),
    coverage: /*#__PURE__*/ z.object({
        rowCount: /*#__PURE__*/ z.number().nullable(),
        warmupNullCount: /*#__PURE__*/ z.number().nullable(),
        outputNullCounts: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional(),
        firstBarAt: /*#__PURE__*/ z.string().nullable(),
        lastBarAt: /*#__PURE__*/ z.string().nullable(),
        expectedBars: /*#__PURE__*/ z.number().nullable()
    }).nullable(),
    confidence: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high'
    ]).nullable(),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    blockers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zIndicatorImportPersistedArtifact = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string()
});

export const zModelLineageTemplateProvenance = /*#__PURE__*/ z.object({
    strategyTemplateId: /*#__PURE__*/ z.string().nullable(),
    strategyTemplateVersionId: /*#__PURE__*/ z.string().nullable(),
    templateRef: /*#__PURE__*/ z.string().nullable(),
    templateVersion: /*#__PURE__*/ z.int().nullable(),
    linkSource: /*#__PURE__*/ z.enum([
        'fk',
        'inferred',
        'none'
    ])
});

export const zKgRegimeScoreEntry = /*#__PURE__*/ z.object({
    regime: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    value: /*#__PURE__*/ z.number(),
    uncertainty: /*#__PURE__*/ z.number(),
    components: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    computed_at: /*#__PURE__*/ z.string()
});

export const zKgNodeSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    node_type: /*#__PURE__*/ z.string(),
    canonical_key: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'merged',
        'retired'
    ])
});

export const zShadowCertCounters = /*#__PURE__*/ z.object({
    ticks: /*#__PURE__*/ z.int(),
    proposals: /*#__PURE__*/ z.int(),
    fencedAttempts: /*#__PURE__*/ z.int(),
    capitalFacingAttempts: /*#__PURE__*/ z.int(),
    approvedProposals: /*#__PURE__*/ z.int(),
    rejectedProposals: /*#__PURE__*/ z.int(),
    errors: /*#__PURE__*/ z.int()
});

export const zShadowCertThresholds = /*#__PURE__*/ z.object({
    minTicks: /*#__PURE__*/ z.int(),
    minApprovedProposals: /*#__PURE__*/ z.int(),
    maxRejectedProposalRate: /*#__PURE__*/ z.number(),
    maxErrorRate: /*#__PURE__*/ z.number()
});

export const zCodeWorkspace = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    provider: /*#__PURE__*/ z.enum([
        'local_git',
        'github',
        'gitlab',
        'gitea',
        'forgejo',
        'gerrit',
        'confluent_hosted'
    ]),
    providerInstallationId: /*#__PURE__*/ z.string().nullable(),
    providerAccountId: /*#__PURE__*/ z.string().nullable(),
    providerRepositoryId: /*#__PURE__*/ z.string().nullable(),
    credentialRef: /*#__PURE__*/ z.string().nullable(),
    repositoryConnectionId: /*#__PURE__*/ z.number().nullable(),
    repoOwner: /*#__PURE__*/ z.string().nullable(),
    repoName: /*#__PURE__*/ z.string().nullable(),
    repoUrl: /*#__PURE__*/ z.string().nullable(),
    providerHtmlUrl: /*#__PURE__*/ z.string().nullable(),
    defaultBranch: /*#__PURE__*/ z.string(),
    branchPrefix: /*#__PURE__*/ z.string().nullable(),
    isolationTier: /*#__PURE__*/ z.enum([
        'org_default',
        'project',
        'byo'
    ]),
    status: /*#__PURE__*/ z.enum([
        'provisioning',
        'active',
        'out_of_sync',
        'blocked',
        'archived'
    ]),
    statusReason: /*#__PURE__*/ z.string().nullable(),
    defaultHeadSha: /*#__PURE__*/ z.string().nullable(),
    lastObservedDefaultHeadSha: /*#__PURE__*/ z.string().nullable(),
    latestCheckpointId: /*#__PURE__*/ z.number().nullable(),
    latestReconciledAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    buildStatus: /*#__PURE__*/ z.string().nullable(),
    testStatus: /*#__PURE__*/ z.string().nullable(),
    lintStatus: /*#__PURE__*/ z.string().nullable(),
    migrationStatus: /*#__PURE__*/ z.string().nullable(),
    securityStatus: /*#__PURE__*/ z.string().nullable(),
    qualityStatus: /*#__PURE__*/ z.string().nullable(),
    permissionSnapshot: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    protectionSnapshot: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    lastWebhookDeliveryId: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeWorkspaceOperation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    workspaceId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number().nullable(),
    revisionId: /*#__PURE__*/ z.number().nullable(),
    checkpointId: /*#__PURE__*/ z.number().nullable(),
    operationType: /*#__PURE__*/ z.enum([
        'prepare_workspace',
        'sync_provider',
        'create_branch',
        'apply_revision',
        'commit_revision',
        'open_pull_request',
        'merge_pull_request',
        'create_checkpoint',
        'revert_commit',
        'cleanup_workspace'
    ]),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'running',
        'succeeded',
        'failed',
        'blocked',
        'cancelled'
    ]),
    idempotencyKey: /*#__PURE__*/ z.string().nullable(),
    attemptCount: /*#__PURE__*/ z.number(),
    expectedBranch: /*#__PURE__*/ z.string().nullable(),
    expectedHeadSha: /*#__PURE__*/ z.string().nullable(),
    actualHeadSha: /*#__PURE__*/ z.string().nullable(),
    resultCommitSha: /*#__PURE__*/ z.string().nullable(),
    resultCheckpointId: /*#__PURE__*/ z.number().nullable(),
    providerRef: /*#__PURE__*/ z.string().nullable(),
    providerUrl: /*#__PURE__*/ z.string().nullable(),
    workerRunId: /*#__PURE__*/ z.number().nullable(),
    daemonRunId: /*#__PURE__*/ z.number().nullable(),
    sourceEventId: /*#__PURE__*/ z.number().nullable(),
    blockerId: /*#__PURE__*/ z.number().nullable(),
    leaseExpiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    lockedByActorType: /*#__PURE__*/ z.string().nullable(),
    lockedByActorId: /*#__PURE__*/ z.string().nullable(),
    lastHeartbeatAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    requestPayload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    resultPayload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    errorCode: /*#__PURE__*/ z.string().nullable(),
    errorMessage: /*#__PURE__*/ z.string().nullable(),
    startedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    completedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeClientDatabase = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    workspaceId: /*#__PURE__*/ z.number().nullable(),
    scope: /*#__PURE__*/ z.enum(['organization', 'project']),
    provider: /*#__PURE__*/ z.enum(['managed_postgres', 'byo_postgres']),
    isolationTier: /*#__PURE__*/ z.enum([
        'org_default',
        'project',
        'byo'
    ]),
    status: /*#__PURE__*/ z.enum([
        'provisioning',
        'active',
        'failed',
        'disabled',
        'archived'
    ]),
    statusReason: /*#__PURE__*/ z.string().nullable(),
    connectionConfigured: /*#__PURE__*/ z.boolean(),
    connectionSecretProvider: /*#__PURE__*/ z.enum([
        'external_ref',
        'aws_secrets_manager',
        'gcp_secret_manager',
        'vault',
        'local_file',
        'env'
    ]).nullable(),
    connectionFingerprint: /*#__PURE__*/ z.string().nullable(),
    databaseName: /*#__PURE__*/ z.string().nullable(),
    schemaName: /*#__PURE__*/ z.string(),
    appRoleName: /*#__PURE__*/ z.string().nullable(),
    migrationRoleName: /*#__PURE__*/ z.string().nullable(),
    runtimeUrlEnvVar: /*#__PURE__*/ z.string(),
    migrationUrlEnvVar: /*#__PURE__*/ z.string(),
    writePolicy: /*#__PURE__*/ z.object({
        mode: /*#__PURE__*/ z.enum(['migrations_only', 'table_writes']).optional().default('migrations_only'),
        allowSchemaChanges: /*#__PURE__*/ z.boolean().optional().default(false),
        requireReviewGate: /*#__PURE__*/ z.boolean().optional().default(true),
        conflictPolicy: /*#__PURE__*/ z.enum(['do_nothing', 'upsert']).optional().default('do_nothing'),
        maxRowsPerPart: /*#__PURE__*/ z.int().gt(0).lte(10000).optional().default(500),
        allowedSchemas: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(50).optional(),
        allowedTables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(200).optional()
    }).optional().default({
        mode: 'migrations_only',
        allowSchemaChanges: false,
        requireReviewGate: true,
        conflictPolicy: 'do_nothing',
        maxRowsPerPart: 500
    }),
    provisioningMetadata: /*#__PURE__*/ z.object({
        providerTargetRef: /*#__PURE__*/ z.string().optional(),
        connectionRedacted: /*#__PURE__*/ z.string().optional(),
        secretProvider: /*#__PURE__*/ z.enum([
            'external_ref',
            'aws_secrets_manager',
            'gcp_secret_manager',
            'vault',
            'local_file',
            'env'
        ]).optional(),
        provisioner: /*#__PURE__*/ z.string().optional(),
        configuredBy: /*#__PURE__*/ z.enum([
            'server',
            'engine',
            'system'
        ]).optional(),
        configuredAt: /*#__PURE__*/ z.iso.datetime().optional(),
        connectionParsedAt: /*#__PURE__*/ z.iso.datetime().optional(),
        notes: /*#__PURE__*/ z.string().optional()
    }).optional().default({}),
    latestMigrationId: /*#__PURE__*/ z.number().nullable(),
    latestSnapshotId: /*#__PURE__*/ z.number().nullable(),
    provisionedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    validatedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    latestMigrationAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    disabledAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    metadata: /*#__PURE__*/ z.object({
        displayName: /*#__PURE__*/ z.string().min(1).max(120).optional(),
        environment: /*#__PURE__*/ z.string().min(1).max(80).optional(),
        notes: /*#__PURE__*/ z.string().max(2000).optional(),
        tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(60)).max(30).optional()
    }).optional().default({}),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeTuningConversation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    userId: /*#__PURE__*/ z.number(),
    topic: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'user-agent',
        'agent-agent',
        'team',
        'assistant-ui'
    ]),
    templateSlug: /*#__PURE__*/ z.string(),
    subjectType: /*#__PURE__*/ z.string().nullable(),
    subjectId: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'idle',
        'completed',
        'errored'
    ]),
    projectId: /*#__PURE__*/ z.number().nullable(),
    parentConversationId: /*#__PURE__*/ z.number().nullable(),
    lastActivityAt: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zCodeTuningWorkOutput = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    sourceType: /*#__PURE__*/ z.enum(['workstream']),
    sourceId: /*#__PURE__*/ z.string(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    workflowId: /*#__PURE__*/ z.number().nullable(),
    stepId: /*#__PURE__*/ z.string().nullable(),
    taskId: /*#__PURE__*/ z.number().nullable(),
    workerRunId: /*#__PURE__*/ z.number().nullable(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    projectThreadId: /*#__PURE__*/ z.number().nullable(),
    projectChangeId: /*#__PURE__*/ z.number().nullable(),
    title: /*#__PURE__*/ z.string(),
    summary: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'ready',
        'blocked',
        'pending',
        'superseded'
    ]),
    rawPayload: /*#__PURE__*/ z.unknown().optional(),
    metadata: /*#__PURE__*/ z.unknown().optional(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zCodeTuningOutputPart = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    workOutputId: /*#__PURE__*/ z.number(),
    kind: /*#__PURE__*/ z.enum([
        'code_preview',
        'code_patch',
        'code_manifest',
        'code_validation_report'
    ]),
    key: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    portType: /*#__PURE__*/ z.string().nullable(),
    payload: /*#__PURE__*/ z.unknown().optional(),
    payloadUrl: /*#__PURE__*/ z.string().nullable(),
    mimeType: /*#__PURE__*/ z.string().nullable(),
    sizeBytes: /*#__PURE__*/ z.number().nullable(),
    visibility: /*#__PURE__*/ z.string().nullable(),
    source: /*#__PURE__*/ z.string().nullable(),
    schema: /*#__PURE__*/ z.unknown().optional(),
    metadata: /*#__PURE__*/ z.unknown().optional(),
    ttlHours: /*#__PURE__*/ z.number().nullable(),
    parsed: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum(['code_preview']),
            payload: /*#__PURE__*/ z.object({
                surface: /*#__PURE__*/ z.object({
                    title: /*#__PURE__*/ z.string().min(1),
                    route: /*#__PURE__*/ z.string().min(1),
                    kind: /*#__PURE__*/ z.enum([
                        'ui',
                        'api',
                        'workflow',
                        'schema'
                    ])
                }),
                runtime: /*#__PURE__*/ z.object({
                    adapter: /*#__PURE__*/ z.enum([
                        'webcontainer',
                        'sandpack',
                        'docker',
                        'external_link'
                    ]),
                    previewUrl: /*#__PURE__*/ z.string().min(1).optional(),
                    status: /*#__PURE__*/ z.enum([
                        'booting',
                        'ready',
                        'blocked',
                        'disposed'
                    ]),
                    mode: /*#__PURE__*/ z.enum([
                        'mock',
                        'real',
                        'mixed'
                    ])
                }),
                scenarios: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    key: /*#__PURE__*/ z.string().min(1),
                    label: /*#__PURE__*/ z.string().min(1),
                    status: /*#__PURE__*/ z.enum(['ready', 'blocked'])
                })),
                selectedScenario: /*#__PURE__*/ z.string().min(1).optional()
            })
        }),
        /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum(['code_patch']),
            payload: /*#__PURE__*/ z.object({
                baseCommitSha: /*#__PURE__*/ z.string().min(1),
                patch: /*#__PURE__*/ z.string().min(1),
                patchHash: /*#__PURE__*/ z.string().min(1),
                fileChanges: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    path: /*#__PURE__*/ z.string().min(1),
                    changeType: /*#__PURE__*/ z.enum([
                        'added',
                        'modified',
                        'deleted',
                        'renamed'
                    ])
                })),
                notes: /*#__PURE__*/ z.string().optional()
            })
        }),
        /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum(['code_manifest']),
            payload: /*#__PURE__*/ z.object({
                stack: /*#__PURE__*/ z.object({
                    framework: /*#__PURE__*/ z.string().min(1),
                    language: /*#__PURE__*/ z.string().min(1),
                    packageManager: /*#__PURE__*/ z.string().min(1).optional()
                }),
                surfaces: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    title: /*#__PURE__*/ z.string().min(1),
                    route: /*#__PURE__*/ z.string().min(1).optional(),
                    files: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)),
                    scenarios: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional()
                })),
                contracts: /*#__PURE__*/ z.object({
                    mockProviders: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
                    apiRoutes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
                    dataModels: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional()
                }),
                dependencies: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    name: /*#__PURE__*/ z.string().min(1),
                    version: /*#__PURE__*/ z.string().min(1),
                    reason: /*#__PURE__*/ z.string().optional()
                })).optional()
            })
        }),
        /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum(['code_validation_report']),
            payload: /*#__PURE__*/ z.object({
                status: /*#__PURE__*/ z.enum([
                    'passing',
                    'warning',
                    'blocked'
                ]),
                checks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    name: /*#__PURE__*/ z.enum([
                        'typecheck',
                        'build',
                        'lint',
                        'test',
                        'security',
                        'quality',
                        'preview'
                    ]),
                    status: /*#__PURE__*/ z.enum([
                        'passing',
                        'warning',
                        'blocked',
                        'not_run'
                    ]),
                    summary: /*#__PURE__*/ z.string().optional(),
                    logRef: /*#__PURE__*/ z.string().optional()
                })),
                blockingIssues: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    title: /*#__PURE__*/ z.string().min(1),
                    severity: /*#__PURE__*/ z.enum([
                        'low',
                        'medium',
                        'high',
                        'critical'
                    ]),
                    recommendation: /*#__PURE__*/ z.string().min(1)
                })).optional()
            })
        })
    ]).nullable(),
    validationErrors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zCodeTuningVersionSummary = /*#__PURE__*/ z.object({
    output: zCodeTuningWorkOutput,
    partKinds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
        'code_preview',
        'code_patch',
        'code_manifest',
        'code_validation_report'
    ])),
    hasPatch: /*#__PURE__*/ z.boolean(),
    previewStatus: /*#__PURE__*/ z.enum([
        'booting',
        'ready',
        'blocked',
        'disposed'
    ]).nullable(),
    validationStatus: /*#__PURE__*/ z.enum([
        'passing',
        'warning',
        'blocked'
    ]).nullable(),
    reviewRequest: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0),
        gateType: /*#__PURE__*/ z.enum([
            'codegen_review',
            'plan',
            'ui',
            'database',
            'backend',
            'integration',
            'launch',
            'catalog_promotion',
            'platform_change'
        ]),
        actionType: /*#__PURE__*/ z.enum(['codegen:promote']),
        status: /*#__PURE__*/ z.enum([
            'pending',
            'approved',
            'rejected',
            'request_changes',
            'expired',
            'superseded'
        ]),
        workOutputId: /*#__PURE__*/ z.int().gt(0),
        subjectKind: /*#__PURE__*/ z.string().min(1),
        subjectId: /*#__PURE__*/ z.string().min(1),
        subjectVersionHash: /*#__PURE__*/ z.string().nullable(),
        requestedByUserId: /*#__PURE__*/ z.int().gt(0),
        requestedAt: /*#__PURE__*/ z.iso.datetime(),
        expiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
        reviewer: /*#__PURE__*/ z.object({
            actorPlane: /*#__PURE__*/ z.enum([
                'system_daemon',
                'workforce_member',
                'human_user',
                'service_account'
            ]),
            actorKey: /*#__PURE__*/ z.string().nullable(),
            resolvedUserId: /*#__PURE__*/ z.int().gt(0).nullable(),
            delegatedFromUserId: /*#__PURE__*/ z.int().gt(0).nullable(),
            label: /*#__PURE__*/ z.string().nullable()
        }),
        decision: /*#__PURE__*/ z.object({
            action: /*#__PURE__*/ z.enum([
                'approve',
                'reject',
                'request_changes',
                'accept_risk'
            ]),
            decidedByUserId: /*#__PURE__*/ z.int().gt(0),
            decidedAt: /*#__PURE__*/ z.iso.datetime(),
            rationale: /*#__PURE__*/ z.string().nullable(),
            reasonCode: /*#__PURE__*/ z.string().nullable(),
            riskAcceptedUntil: /*#__PURE__*/ z.iso.datetime().nullable()
        }).nullable(),
        versionSnapshot: /*#__PURE__*/ z.object({
            title: /*#__PURE__*/ z.string().min(1),
            summary: /*#__PURE__*/ z.string().nullable(),
            validationStatus: /*#__PURE__*/ z.enum([
                'passing',
                'warning',
                'blocked'
            ]).nullable(),
            patchHash: /*#__PURE__*/ z.string().nullable(),
            previewRoute: /*#__PURE__*/ z.string().nullable(),
            outputUpdatedAt: /*#__PURE__*/ z.iso.datetime().nullable()
        }),
        createdRevisionId: /*#__PURE__*/ z.int().gt(0).nullable()
    }).nullable()
});

export const zCodeTuningVersion = /*#__PURE__*/ zCodeTuningVersionSummary.and(/*#__PURE__*/ z.object({
    parts: /*#__PURE__*/ z.array(zCodeTuningOutputPart),
    preview: /*#__PURE__*/ z.object({
        surface: /*#__PURE__*/ z.object({
            title: /*#__PURE__*/ z.string().min(1),
            route: /*#__PURE__*/ z.string().min(1),
            kind: /*#__PURE__*/ z.enum([
                'ui',
                'api',
                'workflow',
                'schema'
            ])
        }),
        runtime: /*#__PURE__*/ z.object({
            adapter: /*#__PURE__*/ z.enum([
                'webcontainer',
                'sandpack',
                'docker',
                'external_link'
            ]),
            previewUrl: /*#__PURE__*/ z.string().min(1).optional(),
            status: /*#__PURE__*/ z.enum([
                'booting',
                'ready',
                'blocked',
                'disposed'
            ]),
            mode: /*#__PURE__*/ z.enum([
                'mock',
                'real',
                'mixed'
            ])
        }),
        scenarios: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            key: /*#__PURE__*/ z.string().min(1),
            label: /*#__PURE__*/ z.string().min(1),
            status: /*#__PURE__*/ z.enum(['ready', 'blocked'])
        })),
        selectedScenario: /*#__PURE__*/ z.string().min(1).optional()
    }).nullable(),
    patch: /*#__PURE__*/ z.object({
        baseCommitSha: /*#__PURE__*/ z.string().min(1),
        patch: /*#__PURE__*/ z.string().min(1),
        patchHash: /*#__PURE__*/ z.string().min(1),
        fileChanges: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            path: /*#__PURE__*/ z.string().min(1),
            changeType: /*#__PURE__*/ z.enum([
                'added',
                'modified',
                'deleted',
                'renamed'
            ])
        })),
        notes: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    manifest: /*#__PURE__*/ z.object({
        stack: /*#__PURE__*/ z.object({
            framework: /*#__PURE__*/ z.string().min(1),
            language: /*#__PURE__*/ z.string().min(1),
            packageManager: /*#__PURE__*/ z.string().min(1).optional()
        }),
        surfaces: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            title: /*#__PURE__*/ z.string().min(1),
            route: /*#__PURE__*/ z.string().min(1).optional(),
            files: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)),
            scenarios: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional()
        })),
        contracts: /*#__PURE__*/ z.object({
            mockProviders: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
            apiRoutes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
            dataModels: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional()
        }),
        dependencies: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            name: /*#__PURE__*/ z.string().min(1),
            version: /*#__PURE__*/ z.string().min(1),
            reason: /*#__PURE__*/ z.string().optional()
        })).optional()
    }).nullable(),
    validationReport: /*#__PURE__*/ z.object({
        status: /*#__PURE__*/ z.enum([
            'passing',
            'warning',
            'blocked'
        ]),
        checks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            name: /*#__PURE__*/ z.enum([
                'typecheck',
                'build',
                'lint',
                'test',
                'security',
                'quality',
                'preview'
            ]),
            status: /*#__PURE__*/ z.enum([
                'passing',
                'warning',
                'blocked',
                'not_run'
            ]),
            summary: /*#__PURE__*/ z.string().optional(),
            logRef: /*#__PURE__*/ z.string().optional()
        })),
        blockingIssues: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            title: /*#__PURE__*/ z.string().min(1),
            severity: /*#__PURE__*/ z.enum([
                'low',
                'medium',
                'high',
                'critical'
            ]),
            recommendation: /*#__PURE__*/ z.string().min(1)
        })).optional()
    }).nullable()
}));

export const zSystemHealthCheck = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['healthy', 'unhealthy']),
    latency_ms: /*#__PURE__*/ z.number().optional()
});

export const zSystemEngineCheck = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['healthy', 'missing']),
    version: /*#__PURE__*/ z.string().optional(),
    instanceId: /*#__PURE__*/ z.string().optional(),
    lastSeenSeconds: /*#__PURE__*/ z.number().optional()
});

export const zSystemHealth = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['healthy', 'degraded']),
    timestamp: /*#__PURE__*/ z.string(),
    uptime: /*#__PURE__*/ z.number(),
    environment: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.string(),
    checks: /*#__PURE__*/ z.object({
        database: zSystemHealthCheck,
        redis: zSystemHealthCheck,
        engine: zSystemEngineCheck
    })
});

export const zUser = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    email: /*#__PURE__*/ z.email(),
    username: /*#__PURE__*/ z.string().nullable(),
    fullName: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string(),
    organizationId: /*#__PURE__*/ z.number().nullish(),
    organizationName: /*#__PURE__*/ z.string().nullish(),
    organizationPlan: /*#__PURE__*/ z.string().nullish(),
    settings: /*#__PURE__*/ zUserSettings.nullish(),
    isVerified: /*#__PURE__*/ z.boolean().optional(),
    createdAt: /*#__PURE__*/ z.string().optional(),
    permissions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zSignupResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string(),
    user: zUser
});

export const zAuthSignupCreate = /*#__PURE__*/ z.object({
    email: /*#__PURE__*/ z.email(),
    password: /*#__PURE__*/ z.string().min(8),
    username: /*#__PURE__*/ z.string().min(3).max(50).optional(),
    fullName: /*#__PURE__*/ z.string().max(100).optional(),
    invitationToken: /*#__PURE__*/ z.string().optional()
});

export const zAuthToken = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    token: /*#__PURE__*/ z.string(),
    user: zUser
});

export const zAuthLoginCreate = /*#__PURE__*/ z.object({
    email: /*#__PURE__*/ z.email(),
    password: /*#__PURE__*/ z.string().min(1)
});

export const zUserProfileUpdate = /*#__PURE__*/ z.object({
    username: /*#__PURE__*/ z.string().min(3).max(50).optional(),
    fullName: /*#__PURE__*/ z.string().max(100).optional(),
    settings: /*#__PURE__*/ z.object({
        theme: /*#__PURE__*/ z.enum(['dark', 'light']).optional(),
        notifications: /*#__PURE__*/ z.boolean().optional(),
        defaultExchange: /*#__PURE__*/ z.string().optional(),
        defaultLeverage: /*#__PURE__*/ z.number().gte(1).lte(125).optional(),
        timezone: /*#__PURE__*/ z.string().optional(),
        uiMode: /*#__PURE__*/ z.enum(['simple', 'detailed']).optional(),
        activeModuleId: /*#__PURE__*/ z.string().max(50).optional()
    }).optional()
});

export const zActionSuccess = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string()
});

export const zTokenRefresh = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string()
});

export const zVerifyEmailRequest = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string().min(1)
});

export const zResetPasswordRequest = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string().min(1),
    password: /*#__PURE__*/ z.string().min(8)
});

export const zLinkedAccount = /*#__PURE__*/ z.object({
    userId: /*#__PURE__*/ z.number(),
    email: /*#__PURE__*/ z.string(),
    fullName: /*#__PURE__*/ z.string().nullable(),
    organizationName: /*#__PURE__*/ z.string(),
    organizationSlug: /*#__PURE__*/ z.string()
});

export const zAccountSwitchRequest = /*#__PURE__*/ z.object({
    targetUserId: /*#__PURE__*/ z.number()
});

export const zLinkedAccountActionSuccess = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string()
});

export const zAccountLinkRequest = /*#__PURE__*/ z.object({
    userId: /*#__PURE__*/ z.number(),
    linkedUserId: /*#__PURE__*/ z.number()
});

export const zInvitationPreview = /*#__PURE__*/ z.object({
    email: /*#__PURE__*/ z.string(),
    orgName: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.enum([
        'org_admin',
        'trader',
        'analyst',
        'viewer'
    ]),
    inviterName: /*#__PURE__*/ z.string(),
    expiresAt: /*#__PURE__*/ z.string()
});

export const zInvitation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    email: /*#__PURE__*/ z.string(),
    orgId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.enum([
        'org_admin',
        'trader',
        'analyst',
        'viewer'
    ]),
    invitedBy: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'accepted',
        'expired',
        'revoked'
    ]),
    acceptedBy: /*#__PURE__*/ z.number().nullable(),
    acceptedAt: /*#__PURE__*/ z.string().nullable(),
    expiresAt: /*#__PURE__*/ z.string(),
    message: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string(),
    token: /*#__PURE__*/ z.string().nullable()
});

export const zAdminUserRole = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    roleId: /*#__PURE__*/ z.number(),
    roleName: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.enum([
        'global',
        'org',
        'team'
    ]),
    grantedBy: /*#__PURE__*/ z.number().nullable(),
    grantedAt: /*#__PURE__*/ z.string()
});

export const zAdminUserAuditEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    actorId: /*#__PURE__*/ z.number(),
    actorName: /*#__PURE__*/ z.string().nullable(),
    action: /*#__PURE__*/ z.string(),
    details: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.string()
});

export const zAdminUser = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    email: /*#__PURE__*/ z.string(),
    username: /*#__PURE__*/ z.string().nullable(),
    fullName: /*#__PURE__*/ z.string().nullable(),
    avatarUrl: /*#__PURE__*/ z.string().nullable(),
    phone: /*#__PURE__*/ z.string().nullable(),
    bio: /*#__PURE__*/ z.string().nullable(),
    timezone: /*#__PURE__*/ z.string().nullable(),
    jobTitle: /*#__PURE__*/ z.string().nullable(),
    department: /*#__PURE__*/ z.string().nullable(),
    location: /*#__PURE__*/ z.string().nullable(),
    linkedinUrl: /*#__PURE__*/ z.string().nullable(),
    notes: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected'
    ]),
    active: /*#__PURE__*/ z.boolean(),
    verified: /*#__PURE__*/ z.boolean(),
    approvedBy: /*#__PURE__*/ z.number().nullable(),
    approvedAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string(),
    lastLoginAt: /*#__PURE__*/ z.string().nullable(),
    roles: /*#__PURE__*/ z.array(zAdminUserRole).optional(),
    organization: /*#__PURE__*/ zAdminUserOrganization.nullish(),
    auditLog: /*#__PURE__*/ z.array(zAdminUserAuditEntry).optional()
});

export const zUserBulkStatusResult = /*#__PURE__*/ z.object({
    updatedCount: /*#__PURE__*/ z.number(),
    updatedIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number())
});

export const zUserBulkStatusRequest = /*#__PURE__*/ z.object({
    ids: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).min(1).max(100),
    status: /*#__PURE__*/ z.enum(['approved', 'rejected'])
});

export const zAdminUserUpdate = /*#__PURE__*/ z.object({
    username: /*#__PURE__*/ z.string().min(1).max(50).optional(),
    fullName: /*#__PURE__*/ z.string().max(100).optional(),
    phone: /*#__PURE__*/ z.string().max(30).optional(),
    bio: /*#__PURE__*/ z.string().max(1000).optional(),
    timezone: /*#__PURE__*/ z.string().max(50).optional(),
    jobTitle: /*#__PURE__*/ z.string().max(100).optional(),
    department: /*#__PURE__*/ z.string().max(100).optional(),
    location: /*#__PURE__*/ z.string().max(200).optional(),
    linkedinUrl: /*#__PURE__*/ z.string().max(255).optional(),
    notes: /*#__PURE__*/ z.string().max(2000).optional(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected'
    ]).optional(),
    active: /*#__PURE__*/ z.boolean().optional()
});

export const zAdminActionSuccess = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string()
});

export const zUserRoleAssign = /*#__PURE__*/ z.object({
    role: /*#__PURE__*/ z.enum([
        'org_admin',
        'trader',
        'analyst',
        'code_reviewer',
        'viewer'
    ]),
    orgId: /*#__PURE__*/ z.number()
});

export const zAdminUserAuditList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAdminUserAuditEntry)
});

export const zExchangeCredential = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    exchange: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string().nullable(),
    permissions: /*#__PURE__*/ z.object({
        trade: /*#__PURE__*/ z.boolean(),
        withdraw: /*#__PURE__*/ z.boolean()
    }).nullable(),
    isActive: /*#__PURE__*/ z.boolean().nullable(),
    isTestnet: /*#__PURE__*/ z.boolean().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    lastUsedAt: /*#__PURE__*/ z.string().nullable()
});

export const zExchangeCredentialCreate = /*#__PURE__*/ z.object({
    exchange: /*#__PURE__*/ z.string().min(1).max(20),
    label: /*#__PURE__*/ z.string().max(50).optional(),
    apiKey: /*#__PURE__*/ z.string().min(1),
    apiSecret: /*#__PURE__*/ z.string().min(1),
    permissions: /*#__PURE__*/ z.object({
        trade: /*#__PURE__*/ z.boolean(),
        withdraw: /*#__PURE__*/ z.boolean()
    }).optional(),
    isTestnet: /*#__PURE__*/ z.boolean().optional()
});

export const zNotificationConfig = /*#__PURE__*/ z.object({
    telegram: /*#__PURE__*/ z.object({
        botToken: /*#__PURE__*/ z.string().optional(),
        chatId: /*#__PURE__*/ z.string(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    discord: /*#__PURE__*/ z.object({
        webhookUrl: /*#__PURE__*/ z.string().optional(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    slack: /*#__PURE__*/ z.object({
        webhookUrl: /*#__PURE__*/ z.string().optional(),
        channel: /*#__PURE__*/ z.string().optional(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    email: /*#__PURE__*/ z.object({
        host: /*#__PURE__*/ z.string(),
        port: /*#__PURE__*/ z.number(),
        secure: /*#__PURE__*/ z.boolean(),
        user: /*#__PURE__*/ z.string(),
        pass: /*#__PURE__*/ z.string().optional(),
        from: /*#__PURE__*/ z.string(),
        recipients: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    webhook: /*#__PURE__*/ z.object({
        url: /*#__PURE__*/ z.string().optional(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional()
});

export const zNotificationConfigUpdate = /*#__PURE__*/ z.object({
    telegram: /*#__PURE__*/ z.object({
        botToken: /*#__PURE__*/ z.string().min(1).optional(),
        chatId: /*#__PURE__*/ z.string(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    discord: /*#__PURE__*/ z.object({
        webhookUrl: /*#__PURE__*/ z.string().min(1).optional(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    slack: /*#__PURE__*/ z.object({
        webhookUrl: /*#__PURE__*/ z.string().min(1).optional(),
        channel: /*#__PURE__*/ z.string().optional(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    email: /*#__PURE__*/ z.object({
        host: /*#__PURE__*/ z.string(),
        port: /*#__PURE__*/ z.number(),
        secure: /*#__PURE__*/ z.boolean(),
        user: /*#__PURE__*/ z.string(),
        pass: /*#__PURE__*/ z.string().min(1).optional(),
        from: /*#__PURE__*/ z.string(),
        recipients: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional(),
    webhook: /*#__PURE__*/ z.object({
        url: /*#__PURE__*/ z.string().min(1).optional(),
        headers: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional(),
        enabled: /*#__PURE__*/ z.boolean()
    }).optional()
});

export const zNotificationResult = /*#__PURE__*/ z.object({
    channel: /*#__PURE__*/ z.enum([
        'telegram',
        'discord',
        'slack',
        'email',
        'webhook'
    ]),
    success: /*#__PURE__*/ z.boolean(),
    messageId: /*#__PURE__*/ z.string().optional(),
    error: /*#__PURE__*/ z.string().optional(),
    timestamp: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zNotificationSendCreate = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'trade_opened',
        'trade_closed',
        'signal_generated',
        'stop_loss_hit',
        'take_profit_hit',
        'risk_alert',
        'system_alert',
        'price_alert',
        'pattern_detected'
    ]),
    priority: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'critical'
    ]),
    title: /*#__PURE__*/ z.string(),
    message: /*#__PURE__*/ z.string(),
    symbol: /*#__PURE__*/ z.string().optional(),
    data: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zNotificationTestCreate = /*#__PURE__*/ z.object({
    channel: /*#__PURE__*/ z.enum([
        'telegram',
        'discord',
        'slack',
        'email',
        'webhook'
    ]).optional()
});

export const zAgentSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.string(),
    model: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    healthScore: /*#__PURE__*/ z.number(),
    totalCostUSD: /*#__PURE__*/ z.number(),
    tasksCompleted: /*#__PURE__*/ z.number(),
    tasksFailed: /*#__PURE__*/ z.number(),
    spawnedAt: /*#__PURE__*/ z.string(),
    lastHeartbeat: /*#__PURE__*/ z.string().nullable()
});

export const zAgentSpawnResult = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string()
});

export const zAgentSpawnRequest = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string(),
    context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zAgentTerminateRequest = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().optional()
});

export const zAgentExecuteResult = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string()
});

export const zAgentExecuteRequest = /*#__PURE__*/ z.object({
    input: /*#__PURE__*/ z.unknown().optional(),
    context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zAgentHealthReport = /*#__PURE__*/ z.object({
    totalAgents: /*#__PURE__*/ z.number(),
    healthyCount: /*#__PURE__*/ z.number(),
    degradedCount: /*#__PURE__*/ z.number(),
    unhealthyCount: /*#__PURE__*/ z.number(),
    byStatus: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    agents: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        healthScore: /*#__PURE__*/ z.number(),
        lastHeartbeat: /*#__PURE__*/ z.string().nullable()
    }))
});

export const zTradeCandidate = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string(),
    action: /*#__PURE__*/ z.enum([
        'buy',
        'sell',
        'hold',
        'close'
    ]),
    suggestedWeightPct: /*#__PURE__*/ z.number().optional(),
    conviction: /*#__PURE__*/ z.number(),
    rationale: /*#__PURE__*/ z.string(),
    risks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    targetPrice: /*#__PURE__*/ z.number().optional(),
    stopLoss: /*#__PURE__*/ z.number().optional()
});

export const zDecisionAgentSignal = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string(),
    agentId: /*#__PURE__*/ z.string(),
    signal: /*#__PURE__*/ z.string(),
    confidence: /*#__PURE__*/ z.number(),
    data: /*#__PURE__*/ z.unknown().optional()
});

export const zRiskReport = /*#__PURE__*/ z.object({
    portfolioVaR: /*#__PURE__*/ z.number(),
    maxDrawdown: /*#__PURE__*/ z.number(),
    correlationRisk: /*#__PURE__*/ z.string(),
    sectorConcentration: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number())
});

export const zPositionSizeSuggestion = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string(),
    currentWeightPct: /*#__PURE__*/ z.number(),
    suggestedWeightPct: /*#__PURE__*/ z.number(),
    deltaShares: /*#__PURE__*/ z.number(),
    rationale: /*#__PURE__*/ z.string()
});

export const zInvestmentMemo = /*#__PURE__*/ z.object({
    summary: /*#__PURE__*/ z.string(),
    tradeCandidates: /*#__PURE__*/ z.array(zTradeCandidate),
    supportingSignals: /*#__PURE__*/ z.array(zDecisionAgentSignal),
    riskReport: /*#__PURE__*/ zRiskReport.optional(),
    dissentingViews: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    confidenceBreakdown: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    suggestedSizing: /*#__PURE__*/ z.array(zPositionSizeSuggestion).optional()
});

export const zDecisionRequest = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    workflowRunId: /*#__PURE__*/ z.number(),
    gateName: /*#__PURE__*/ z.string(),
    memo: zInvestmentMemo,
    expiresAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    priority: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'urgent'
    ]),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'decided',
        'expired'
    ])
});

export const zDecisionStats = /*#__PURE__*/ z.object({
    total: /*#__PURE__*/ z.number(),
    pending: /*#__PURE__*/ z.number(),
    approved: /*#__PURE__*/ z.number(),
    rejected: /*#__PURE__*/ z.number(),
    modified: /*#__PURE__*/ z.number()
});

export const zDecisionApproveRequest = /*#__PURE__*/ z.object({
    notes: /*#__PURE__*/ z.string().optional()
});

export const zDecisionRejectRequest = /*#__PURE__*/ z.object({
    notes: /*#__PURE__*/ z.string().optional()
});

export const zDecisionModifyRequest = /*#__PURE__*/ z.object({
    modifications: /*#__PURE__*/ z.unknown().optional(),
    notes: /*#__PURE__*/ z.string().optional()
});

export const zExecuteStepStreamRequest = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string(),
    input: /*#__PURE__*/ z.unknown().optional(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    systemPromptOverride: /*#__PURE__*/ z.string().optional(),
    userPromptTemplate: /*#__PURE__*/ z.string().optional(),
    freshSession: /*#__PURE__*/ z.boolean().optional(),
    noTools: /*#__PURE__*/ z.boolean().optional(),
    upstreamOutputs: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    inputMapping: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'static',
            'ref',
            'merge',
            'template'
        ]),
        value: /*#__PURE__*/ z.unknown().optional(),
        stepId: /*#__PURE__*/ z.string().optional(),
        refs: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                stepId: /*#__PURE__*/ z.string(),
                outputKey: /*#__PURE__*/ z.string()
            })),
            /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string())
        ]).optional(),
        template: /*#__PURE__*/ z.string().optional()
    }).optional(),
    contextSpec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zAgentStreamError = /*#__PURE__*/ z.object({
    error: /*#__PURE__*/ z.string().optional(),
    code: /*#__PURE__*/ z.string().optional(),
    message: /*#__PURE__*/ z.string().optional()
});

export const zFollowUpMessageRequest = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zOptimizePromptResult = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum(['queued'])
});

export const zOptimizePromptRequest = /*#__PURE__*/ z.object({
    input: /*#__PURE__*/ z.string()
});

export const zPromptTemplateSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    requiredParams: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    suggestedTemplate: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string()
});

export const zFillTemplateResult = /*#__PURE__*/ z.object({
    template: /*#__PURE__*/ z.string(),
    prompt: /*#__PURE__*/ z.string(),
    suggestedTemplate: /*#__PURE__*/ z.string().optional(),
    suggestedWorkflow: /*#__PURE__*/ z.string().optional()
});

export const zFillTemplateRequest = /*#__PURE__*/ z.object({
    params: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional()
});

export const zToolGap = /*#__PURE__*/ z.object({
    skill: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.enum(['critical', 'degraded']),
    reason: /*#__PURE__*/ z.string()
});

export const zToolGapAnalysis = /*#__PURE__*/ z.object({
    totalGaps: /*#__PURE__*/ z.number(),
    critical: /*#__PURE__*/ z.number(),
    degraded: /*#__PURE__*/ z.number(),
    gaps: /*#__PURE__*/ z.array(zToolGap)
});

export const zAgentTemplateSearchResult = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    departmentId: /*#__PURE__*/ z.string().nullable(),
    platform: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    usageCount: /*#__PURE__*/ z.number().nullable(),
    avgQualityScore: /*#__PURE__*/ z.string().nullable(),
    score: /*#__PURE__*/ z.number(),
    matchType: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ])
});

export const zAgentTemplateVersion = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    templateId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'retired'
    ]),
    configSnapshot: /*#__PURE__*/ z.object({
        goal: /*#__PURE__*/ z.string().nullable(),
        backstory: /*#__PURE__*/ z.string().nullable(),
        instructions: /*#__PURE__*/ z.string().nullable(),
        constraints: /*#__PURE__*/ z.string().nullable(),
        variables: /*#__PURE__*/ z.array(zTemplateVariableConfig).nullable(),
        permissionTier: /*#__PURE__*/ z.string().nullable(),
        spawnPolicy: /*#__PURE__*/ zSpawnPolicyConfig.nullable(),
        taskProfile: /*#__PURE__*/ zTaskProfileConfig.nullable(),
        disableModelInvocation: /*#__PURE__*/ z.boolean().nullable(),
        routingRules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            match: /*#__PURE__*/ z.string(),
            targetTemplate: /*#__PURE__*/ z.string(),
            context: /*#__PURE__*/ z.string().optional()
        })).nullable(),
        maxToolIterations: /*#__PURE__*/ z.number().nullable(),
        defaultSubscriptions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        heartbeatConfig: /*#__PURE__*/ zHeartbeatConfig.nullable(),
        tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }),
    systemPromptHash: /*#__PURE__*/ z.string().nullable(),
    changeSummary: /*#__PURE__*/ z.string().nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    promotedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    retiredAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zAgentTemplateVersionCreate = /*#__PURE__*/ z.object({
    configSnapshot: /*#__PURE__*/ z.object({
        goal: /*#__PURE__*/ z.string().nullish(),
        backstory: /*#__PURE__*/ z.string().nullish(),
        instructions: /*#__PURE__*/ z.string().nullish(),
        constraints: /*#__PURE__*/ z.string().nullish(),
        variables: /*#__PURE__*/ z.array(zTemplateVariableConfig).nullish(),
        permissionTier: /*#__PURE__*/ z.string().nullish(),
        spawnPolicy: /*#__PURE__*/ zSpawnPolicyConfig.nullish(),
        taskProfile: /*#__PURE__*/ zTaskProfileConfig.nullish(),
        disableModelInvocation: /*#__PURE__*/ z.boolean().nullish(),
        routingRules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            match: /*#__PURE__*/ z.string(),
            targetTemplate: /*#__PURE__*/ z.string(),
            context: /*#__PURE__*/ z.string().optional()
        })).nullish(),
        maxToolIterations: /*#__PURE__*/ z.number().nullish(),
        defaultSubscriptions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        heartbeatConfig: /*#__PURE__*/ zHeartbeatConfig.nullish(),
        tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }),
    changeSummary: /*#__PURE__*/ z.string().optional()
});

export const zTemplateCompatibilityChange = /*#__PURE__*/ z.object({
    field: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'warning',
        'error',
        'critical'
    ]),
    baseline: /*#__PURE__*/ z.unknown().optional(),
    candidate: /*#__PURE__*/ z.unknown().optional(),
    message: /*#__PURE__*/ z.string(),
    repairHint: /*#__PURE__*/ z.string().optional()
});

export const zTemplateCompatibilityDiff = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'compatible',
        'needs_review',
        'needs_repair',
        'blocked'
    ]),
    changes: /*#__PURE__*/ z.array(zTemplateCompatibilityChange),
    riskLevel: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'critical'
    ]),
    repairRequired: /*#__PURE__*/ z.boolean()
});

export const zTemplateVersionRef = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.number(),
    templateName: /*#__PURE__*/ z.string(),
    versionId: /*#__PURE__*/ z.number().nullable(),
    version: /*#__PURE__*/ z.number().nullable()
});

export const zAgentTemplateVersionDiff = /*#__PURE__*/ z.object({
    versionA: /*#__PURE__*/ z.number(),
    versionB: /*#__PURE__*/ z.number(),
    diff: zTemplateCompatibilityDiff,
    baseline: zTemplateVersionRef,
    candidate: zTemplateVersionRef
});

export const zAgentTemplateVersionTestResult = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['queued']),
    versionId: /*#__PURE__*/ z.number()
});

export const zAgentTemplateVersionCompareResult = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['queued', 'no_dataset']),
    templateId: /*#__PURE__*/ z.number(),
    versionIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    samples: /*#__PURE__*/ z.number(),
    compareJobId: /*#__PURE__*/ z.string().nullable(),
    expectedRuns: /*#__PURE__*/ z.number()
});

export const zAgentTemplateVersionCompareRequest = /*#__PURE__*/ z.object({
    versionIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).min(1),
    samples: /*#__PURE__*/ z.int().optional()
});

export const zAgentTemplateVersionComparison = /*#__PURE__*/ z.object({
    compareJobId: /*#__PURE__*/ z.string(),
    complete: /*#__PURE__*/ z.boolean(),
    expected: /*#__PURE__*/ z.number(),
    completed: /*#__PURE__*/ z.number(),
    versions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        versionId: /*#__PURE__*/ z.number(),
        avgScore: /*#__PURE__*/ z.number(),
        sampleCount: /*#__PURE__*/ z.number(),
        verdicts: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
        rank: /*#__PURE__*/ z.number(),
        deltaFromBest: /*#__PURE__*/ z.number()
    }))
});

export const zTemplateConsumerImpact = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'workflow_step',
        'task',
        'workforce_member',
        'daemon_assignment',
        'marketplace_listing',
        'entity_relationship'
    ]),
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    parentId: /*#__PURE__*/ z.string().optional(),
    parentName: /*#__PURE__*/ z.string().optional(),
    url: /*#__PURE__*/ z.string().optional(),
    pinnedVersionId: /*#__PURE__*/ z.number().nullish(),
    pinnedVersionStatus: /*#__PURE__*/ z.enum([
        'matches_baseline',
        'pinned_other',
        'unpinned'
    ]),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zTemplateRepairDraft = /*#__PURE__*/ z.object({
    outcome: /*#__PURE__*/ z.enum([
        'workflow_version',
        'task',
        'workforce_route',
        'log_only'
    ]),
    label: /*#__PURE__*/ z.string(),
    consumerKind: /*#__PURE__*/ z.enum([
        'workflow_step',
        'task',
        'workforce_member',
        'daemon_assignment',
        'marketplace_listing',
        'entity_relationship'
    ]).optional(),
    consumerId: /*#__PURE__*/ z.string().optional(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    instructions: /*#__PURE__*/ z.string()
});

export const zTemplateUpgradePreflightResult = /*#__PURE__*/ z.object({
    diff: zTemplateCompatibilityDiff,
    baseline: zTemplateVersionRef,
    candidate: zTemplateVersionRef,
    affectedConsumers: /*#__PURE__*/ z.array(zTemplateConsumerImpact),
    repairDrafts: /*#__PURE__*/ z.array(zTemplateRepairDraft)
});

export const zTemplateUpgradePreflightRequest = /*#__PURE__*/ z.object({
    baselineTemplateId: /*#__PURE__*/ z.int().gt(0),
    candidateTemplateId: /*#__PURE__*/ z.int().gt(0),
    baselineVersionId: /*#__PURE__*/ z.int().gt(0).nullish(),
    candidateVersionId: /*#__PURE__*/ z.int().gt(0).nullish(),
    rollbackVersionId: /*#__PURE__*/ z.int().gt(0).nullish()
});

export const zTemplateUpgradeScoreSet = /*#__PURE__*/ z.object({
    quality: /*#__PURE__*/ z.number().optional(),
    safety: /*#__PURE__*/ z.number().optional(),
    contract: /*#__PURE__*/ z.number().optional(),
    cost: /*#__PURE__*/ z.number().optional(),
    latency: /*#__PURE__*/ z.number().optional(),
    overall: /*#__PURE__*/ z.number().optional()
});

export const zTemplateUpgradeComparison = /*#__PURE__*/ z.object({
    decision: /*#__PURE__*/ z.enum([
        'better',
        'worse',
        'neutral',
        'inconclusive'
    ]),
    confidence: /*#__PURE__*/ z.number().gte(0).lte(1),
    regressionRisks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    changedBehavior: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    rationale: /*#__PURE__*/ z.string().optional()
});

export const zUpgradeCandidate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    entityType: /*#__PURE__*/ z.enum([
        'agent_template',
        'workflow',
        'task',
        'workforce_member',
        'daemon',
        'strategy',
        'tool',
        'skill',
        'code_artifact',
        'custom'
    ]),
    baselineEntityId: /*#__PURE__*/ z.number(),
    baselineVersionId: /*#__PURE__*/ z.number().nullable(),
    candidateEntityId: /*#__PURE__*/ z.number(),
    candidateVersionId: /*#__PURE__*/ z.number().nullable(),
    rollbackVersionId: /*#__PURE__*/ z.number().nullable(),
    status: /*#__PURE__*/ z.enum([
        'discovered',
        'evaluating',
        'needs_repair',
        'ready_for_review',
        'proposed',
        'approved',
        'rejected',
        'superseded'
    ]),
    summary: /*#__PURE__*/ z.string().nullable(),
    idempotencyKey: /*#__PURE__*/ z.string(),
    proposedByType: /*#__PURE__*/ z.string(),
    proposedById: /*#__PURE__*/ z.string().nullable(),
    proposedByName: /*#__PURE__*/ z.string().nullable(),
    baselineScores: zTemplateUpgradeScoreSet,
    candidateScores: zTemplateUpgradeScoreSet,
    comparison: zTemplateUpgradeComparison,
    affectedConsumers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
    compatibilityDiff: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    repairDrafts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
    evidenceLinks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        label: /*#__PURE__*/ z.string(),
        url: /*#__PURE__*/ z.string().optional(),
        type: /*#__PURE__*/ z.string().optional(),
        entityId: /*#__PURE__*/ z.string().optional()
    })),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    proposalInterventionId: /*#__PURE__*/ z.number().nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    proposedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zTemplateUpgradeEvidence = /*#__PURE__*/ z.object({
    templateUpgrade: /*#__PURE__*/ z.object({
        summary: /*#__PURE__*/ z.string(),
        candidateId: /*#__PURE__*/ z.number().optional(),
        evaluationRunId: /*#__PURE__*/ z.number().nullish(),
        baseline: zTemplateVersionRef,
        candidate: zTemplateVersionRef,
        tests: /*#__PURE__*/ z.object({
            total: /*#__PURE__*/ z.number(),
            passed: /*#__PURE__*/ z.number(),
            failed: /*#__PURE__*/ z.number(),
            status: /*#__PURE__*/ z.string()
        }),
        scores: /*#__PURE__*/ z.object({
            baseline: zTemplateUpgradeScoreSet,
            candidate: zTemplateUpgradeScoreSet,
            deltas: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
        }),
        affectedConsumers: /*#__PURE__*/ z.array(zTemplateConsumerImpact),
        compatibilityDiff: zTemplateCompatibilityDiff,
        repairDrafts: /*#__PURE__*/ z.array(zTemplateRepairDraft),
        decisionContext: /*#__PURE__*/ z.object({
            recommendation: /*#__PURE__*/ z.string(),
            comparison: zTemplateUpgradeComparison,
            rollbackVersionId: /*#__PURE__*/ z.number().nullable(),
            highRisk: /*#__PURE__*/ z.boolean()
        }),
        evidenceLinks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            label: /*#__PURE__*/ z.string(),
            url: /*#__PURE__*/ z.string().optional(),
            type: /*#__PURE__*/ z.string().optional(),
            entityId: /*#__PURE__*/ z.string().optional()
        }))
    })
});

export const zTemplateUpgradeProposalResult = /*#__PURE__*/ z.object({
    candidate: zUpgradeCandidate,
    evaluationRun: /*#__PURE__*/ zTemplateUpgradeEvaluation.nullable(),
    actionRequestId: /*#__PURE__*/ z.number().nullable(),
    created: /*#__PURE__*/ z.boolean(),
    duplicateSuppressed: /*#__PURE__*/ z.boolean(),
    evidence: zTemplateUpgradeEvidence
});

export const zTemplateUpgradeProposalRequest = /*#__PURE__*/ zTemplateUpgradePreflightRequest.and(/*#__PURE__*/ z.object({
    summary: /*#__PURE__*/ z.string().max(2000).optional(),
    idempotencyKey: /*#__PURE__*/ z.string().max(256).optional(),
    proposedByType: /*#__PURE__*/ z.string().max(40).optional(),
    proposedById: /*#__PURE__*/ z.string().max(80).optional(),
    proposedByName: /*#__PURE__*/ z.string().max(200).optional(),
    baselineScores: /*#__PURE__*/ zTemplateUpgradeScoreSet.optional(),
    candidateScores: /*#__PURE__*/ zTemplateUpgradeScoreSet.optional(),
    comparison: /*#__PURE__*/ zTemplateUpgradeComparison.optional(),
    replayInputs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).optional(),
    testResults: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).optional(),
    scoreDeltas: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    traces: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).optional(),
    costSummary: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    latencySummary: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    safetyFindings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).optional(),
    evidenceLinks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        label: /*#__PURE__*/ z.string(),
        url: /*#__PURE__*/ z.string().optional(),
        type: /*#__PURE__*/ z.string().optional(),
        entityId: /*#__PURE__*/ z.string().optional()
    })).optional(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
}));

export const zAgentTemplateSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    departmentId: /*#__PURE__*/ z.string().nullable(),
    goal: /*#__PURE__*/ z.string().nullable(),
    tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    workflowCount: /*#__PURE__*/ z.number().optional(),
    spawnPolicy: /*#__PURE__*/ zSpawnPolicyConfig.nullable(),
    platform: /*#__PURE__*/ z.string().nullish(),
    source: /*#__PURE__*/ z.string().nullish(),
    status: /*#__PURE__*/ z.string().nullish(),
    disabled: /*#__PURE__*/ z.boolean(),
    disabledReason: /*#__PURE__*/ z.string().nullish(),
    version: /*#__PURE__*/ z.number().nullish(),
    avgQualityScore: /*#__PURE__*/ z.string().nullish(),
    sourceRepoUrl: /*#__PURE__*/ z.string().nullish(),
    sourceFilePath: /*#__PURE__*/ z.string().nullish()
});

export const zAgentTemplateWorkflowSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string()
});

export const zTemplateApplicability = /*#__PURE__*/ z.object({
    source: /*#__PURE__*/ z.enum([
        'conversation',
        'task',
        'workflow_step',
        'workforce',
        'daemon',
        'subagent'
    ]),
    status: /*#__PURE__*/ z.enum([
        'supported',
        'review_required',
        'not_recommended'
    ]),
    reason: /*#__PURE__*/ z.string()
});

export const zTemplateCompatibility = /*#__PURE__*/ z.object({
    modelCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    minContextWindow: /*#__PURE__*/ z.number().nullable(),
    latencyClass: /*#__PURE__*/ z.string().nullable(),
    preferredCost: /*#__PURE__*/ z.string().nullable(),
    permissionTier: /*#__PURE__*/ z.string().nullable(),
    tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        required: /*#__PURE__*/ z.boolean()
    })),
    mcpConnections: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    outputContracts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        source: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string()
    }))
});

export const zTemplateExample = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string(),
    input: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    expectedOutput: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zTemplateEvaluationHistory = /*#__PURE__*/ z.object({
    promptEvaluations: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        workflowRunId: /*#__PURE__*/ z.number().nullable(),
        stepId: /*#__PURE__*/ z.string().nullable(),
        agentStatus: /*#__PURE__*/ z.string().nullable(),
        contractPassed: /*#__PURE__*/ z.boolean().nullable(),
        promptScore: /*#__PURE__*/ z.string().nullable(),
        humanVerdict: /*#__PURE__*/ z.string().nullable(),
        createdAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ])
    })),
    qualitySnapshots: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        qualityScore: /*#__PURE__*/ z.string().nullable(),
        executionCount: /*#__PURE__*/ z.number().nullable(),
        successRate: /*#__PURE__*/ z.string().nullable(),
        avgDurationMs: /*#__PURE__*/ z.number().nullable(),
        avgConfidence: /*#__PURE__*/ z.string().nullable(),
        periodStart: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]),
        periodEnd: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ])
    })),
    evaluationRuns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        datasetId: /*#__PURE__*/ z.number(),
        datasetName: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string().nullable(),
        totalCases: /*#__PURE__*/ z.number().nullable(),
        passedCases: /*#__PURE__*/ z.number().nullable(),
        failedCases: /*#__PURE__*/ z.number().nullable(),
        avgScore: /*#__PURE__*/ z.string().nullable(),
        completedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]).nullable()
    }))
});

export const zTemplateVersionHistoryItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.string(),
    changeSummary: /*#__PURE__*/ z.string().nullable(),
    systemPromptHash: /*#__PURE__*/ z.string().nullable(),
    promotedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    retiredAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zTemplateUsageImpact = /*#__PURE__*/ z.object({
    workflowCount: /*#__PURE__*/ z.number(),
    workflowStepCount: /*#__PURE__*/ z.number(),
    taskCount: /*#__PURE__*/ z.number(),
    workforceAgentCount: /*#__PURE__*/ z.number(),
    daemonCount: /*#__PURE__*/ z.number(),
    activeWorkflowCount: /*#__PURE__*/ z.number(),
    activeDaemonCount: /*#__PURE__*/ z.number()
});

export const zAgentTemplate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullish(),
    departmentId: /*#__PURE__*/ z.string().nullable(),
    goal: /*#__PURE__*/ z.string().nullable(),
    backstory: /*#__PURE__*/ z.string().nullable(),
    tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    workflows: /*#__PURE__*/ z.array(zAgentTemplateWorkflowSummary).optional(),
    spawnPolicy: /*#__PURE__*/ zSpawnPolicyConfig.nullable(),
    instructions: /*#__PURE__*/ z.string().nullable(),
    constraints: /*#__PURE__*/ z.string().nullish(),
    permissionTier: /*#__PURE__*/ z.string().nullable(),
    platform: /*#__PURE__*/ z.string().nullish(),
    category: /*#__PURE__*/ z.string().nullish(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullish(),
    source: /*#__PURE__*/ z.string().nullish(),
    status: /*#__PURE__*/ z.string().nullish(),
    autoUpgrade: /*#__PURE__*/ z.boolean().nullish(),
    version: /*#__PURE__*/ z.number().nullish(),
    avgQualityScore: /*#__PURE__*/ z.string().nullish(),
    usageCount: /*#__PURE__*/ z.number().nullish(),
    lastUsedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullish(),
    sourceRepoUrl: /*#__PURE__*/ z.string().nullish(),
    sourceFilePath: /*#__PURE__*/ z.string().nullish(),
    taskProfile: /*#__PURE__*/ zTaskProfileConfig.nullish(),
    variables: /*#__PURE__*/ z.array(zTemplateVariableConfig).nullish(),
    defaultSubscriptions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    heartbeatConfig: /*#__PURE__*/ zHeartbeatConfig.nullish(),
    applicability: /*#__PURE__*/ z.array(zTemplateApplicability).optional(),
    compatibility: /*#__PURE__*/ zTemplateCompatibility.optional(),
    examples: /*#__PURE__*/ z.array(zTemplateExample).optional(),
    evaluationHistory: /*#__PURE__*/ zTemplateEvaluationHistory.optional(),
    versionHistory: /*#__PURE__*/ z.array(zTemplateVersionHistoryItem).optional(),
    usageImpact: /*#__PURE__*/ zTemplateUsageImpact.optional(),
    disabled: /*#__PURE__*/ z.boolean(),
    disabledReason: /*#__PURE__*/ z.string().nullish(),
    disableModelInvocation: /*#__PURE__*/ z.boolean().nullish(),
    routingRules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        match: /*#__PURE__*/ z.string(),
        targetTemplate: /*#__PURE__*/ z.string(),
        context: /*#__PURE__*/ z.string().optional()
    })).nullish()
});

export const zAgentTemplateUpsert = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string().optional(),
    departmentId: /*#__PURE__*/ z.string().optional(),
    goal: /*#__PURE__*/ z.string().optional(),
    backstory: /*#__PURE__*/ z.string().optional(),
    instructions: /*#__PURE__*/ z.string().optional(),
    constraints: /*#__PURE__*/ z.string().optional(),
    tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    permissionTier: /*#__PURE__*/ z.string().optional(),
    platform: /*#__PURE__*/ z.string().nullish(),
    variables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string(),
        default: /*#__PURE__*/ z.string().optional()
    })).optional(),
    spawnPolicy: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string(),
        min: /*#__PURE__*/ z.number().optional(),
        max: /*#__PURE__*/ z.number().optional()
    }).optional(),
    defaultSubscriptions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    heartbeatConfig: /*#__PURE__*/ z.object({
        every_n_calls: /*#__PURE__*/ z.int().gt(0).optional(),
        every_t_seconds: /*#__PURE__*/ z.int().gt(0).optional()
    }).optional(),
    autoUpgrade: /*#__PURE__*/ z.boolean().optional(),
    disableModelInvocation: /*#__PURE__*/ z.boolean().optional(),
    routingRules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        match: /*#__PURE__*/ z.string(),
        targetTemplate: /*#__PURE__*/ z.string(),
        context: /*#__PURE__*/ z.string().optional()
    })).optional()
});

export const zAgentTemplateCreate = /*#__PURE__*/ zAgentTemplateUpsert.and(/*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string().min(1)
}));

export const zSetAgentTemplateStatusResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    templateSlug: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    dependentWorkflows: /*#__PURE__*/ z.array(zAgentTemplateWorkflowSummary)
});

export const zAgentTemplateStatusUpdate = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['active', 'disabled']),
    reason: /*#__PURE__*/ z.string().optional()
});

export const zSetAgentTemplateAutoUpgradeResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    templateSlug: /*#__PURE__*/ z.string(),
    autoUpgrade: /*#__PURE__*/ z.boolean()
});

export const zAgentTemplateAutoUpgradeUpdate = /*#__PURE__*/ z.object({
    autoUpgrade: /*#__PURE__*/ z.boolean()
});

export const zSkillSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    moduleId: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean(),
    category: /*#__PURE__*/ z.string(),
    invocationDescription: /*#__PURE__*/ z.string().nullable(),
    priority: /*#__PURE__*/ z.number(),
    contentHash: /*#__PURE__*/ z.string().nullable(),
    securityStatus: /*#__PURE__*/ z.string(),
    qualityStatus: /*#__PURE__*/ z.string(),
    versionId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    versionState: /*#__PURE__*/ z.enum(['draft', 'locked']),
    usedByCount: /*#__PURE__*/ z.number()
});

export const zSkill = /*#__PURE__*/ zSkillSummary.and(/*#__PURE__*/ z.object({
    body: /*#__PURE__*/ z.string(),
    frontmatter: /*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string().optional(),
        description: /*#__PURE__*/ z.string().optional(),
        version: /*#__PURE__*/ z.string().optional(),
        author: /*#__PURE__*/ z.string().optional(),
        platforms: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        applicableWhen: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }),
    examples: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        title: /*#__PURE__*/ z.string().optional(),
        input: /*#__PURE__*/ z.unknown().optional(),
        expected: /*#__PURE__*/ z.unknown().optional(),
        notes: /*#__PURE__*/ z.string().optional()
    })),
    verificationCriteria: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    risks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
}));

export const zSkillLibrary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    sourceType: /*#__PURE__*/ z.enum([
        'git',
        'local',
        'url'
    ]),
    repoUrl: /*#__PURE__*/ z.string().nullable(),
    localPath: /*#__PURE__*/ z.string().nullable(),
    branch: /*#__PURE__*/ z.string().nullable(),
    subdirectory: /*#__PURE__*/ z.string().nullable(),
    enabled: /*#__PURE__*/ z.boolean(),
    autoSync: /*#__PURE__*/ z.boolean(),
    skillCount: /*#__PURE__*/ z.number().nullable(),
    lastSyncedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    lastError: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zSkillLibraryCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().optional(),
    sourceType: /*#__PURE__*/ z.enum([
        'git',
        'local',
        'url'
    ]),
    repoUrl: /*#__PURE__*/ z.string().optional(),
    localPath: /*#__PURE__*/ z.string().optional(),
    branch: /*#__PURE__*/ z.string().optional(),
    subdirectory: /*#__PURE__*/ z.string().optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    autoSync: /*#__PURE__*/ z.boolean().optional()
});

export const zSkillLibraryActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zSkillLibrarySyncResult = /*#__PURE__*/ z.object({
    skillCount: /*#__PURE__*/ z.number(),
    skills: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string()
    })),
    message: /*#__PURE__*/ z.string()
});

export const zSkillLibraryTool = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string().nullable(),
    qualityScore: /*#__PURE__*/ z.string().nullable(),
    executionCount: /*#__PURE__*/ z.number().nullable()
});

export const zToolSummary = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    inputSchema: /*#__PURE__*/ z.unknown().optional(),
    outputSchema: /*#__PURE__*/ z.unknown().optional(),
    deprecated: /*#__PURE__*/ z.boolean(),
    templateCount: /*#__PURE__*/ z.number(),
    source: /*#__PURE__*/ z.string().nullable(),
    sourceLabel: /*#__PURE__*/ z.string(),
    sourceReference: /*#__PURE__*/ z.string().nullable(),
    supportedModels: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zToolDependentTemplate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string()
});

export const zTool = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    inputSchema: /*#__PURE__*/ z.unknown().optional(),
    outputSchema: /*#__PURE__*/ z.unknown().optional(),
    deprecated: /*#__PURE__*/ z.boolean(),
    templates: /*#__PURE__*/ z.array(zToolDependentTemplate),
    source: /*#__PURE__*/ z.string().nullable(),
    sourceLabel: /*#__PURE__*/ z.string(),
    sourceReference: /*#__PURE__*/ z.string().nullable(),
    supportedModels: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zToolUpsert = /*#__PURE__*/ z.object({
    version: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    inputSchema: /*#__PURE__*/ z.unknown().optional(),
    outputSchema: /*#__PURE__*/ z.unknown().optional()
});

export const zToolCreate = /*#__PURE__*/ zToolUpsert.and(/*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1)
}));

export const zSetToolStatusResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    dependentWorkflows: /*#__PURE__*/ z.array(zAgentTemplateWorkflowSummary)
});

export const zToolStatusUpdate = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['approved', 'deprecated'])
});

export const zWorkflowSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().optional(),
    stepCount: /*#__PURE__*/ z.number(),
    schedule: /*#__PURE__*/ z.string().nullish(),
    hasHumanGate: /*#__PURE__*/ z.boolean()
});

export const zWorkflowTriggerResult = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string(),
    workflowId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    startedAt: /*#__PURE__*/ z.string()
});

export const zWorkflowTriggerRequest = /*#__PURE__*/ z.object({
    context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zWorkflowRun = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    workflowId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    triggeredBy: /*#__PURE__*/ z.string(),
    startedAt: /*#__PURE__*/ z.string(),
    completedAt: /*#__PURE__*/ z.string().nullish(),
    totalCostUSD: /*#__PURE__*/ z.number().optional(),
    error: /*#__PURE__*/ z.string().nullish()
});

export const zWorkflowRunDebuggerPayload = /*#__PURE__*/ z.object({
    detail: /*#__PURE__*/ z.enum([
        'summary',
        'debug',
        'full'
    ]),
    generatedAt: /*#__PURE__*/ z.string(),
    run: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        engineRunId: /*#__PURE__*/ z.string().nullable(),
        workflowId: /*#__PURE__*/ z.string().nullable(),
        workflowName: /*#__PURE__*/ z.string(),
        workflowVersion: /*#__PURE__*/ z.number().nullable(),
        status: /*#__PURE__*/ z.string(),
        triggeredBy: /*#__PURE__*/ z.string(),
        startedAt: /*#__PURE__*/ z.string().nullable(),
        completedAt: /*#__PURE__*/ z.string().nullable(),
        durationMs: /*#__PURE__*/ z.number().nullable(),
        totalCostUsd: /*#__PURE__*/ z.string(),
        error: /*#__PURE__*/ z.string().nullable(),
        versionEvidence: /*#__PURE__*/ z.object({
            definitionUpdatedAt: /*#__PURE__*/ z.string().nullable(),
            templateId: /*#__PURE__*/ z.string().nullable()
        }).optional()
    }),
    graph: /*#__PURE__*/ z.object({
        steps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            stepId: /*#__PURE__*/ z.string(),
            stepName: /*#__PURE__*/ z.string(),
            kind: /*#__PURE__*/ z.string(),
            status: /*#__PURE__*/ z.string(),
            startedAt: /*#__PURE__*/ z.string().nullable(),
            completedAt: /*#__PURE__*/ z.string().nullable(),
            durationMs: /*#__PURE__*/ z.number().nullable(),
            retryCount: /*#__PURE__*/ z.number(),
            template: /*#__PURE__*/ z.object({
                id: /*#__PURE__*/ z.string(),
                name: /*#__PURE__*/ z.string().nullable(),
                slug: /*#__PURE__*/ z.string().nullable(),
                permissionTier: /*#__PURE__*/ z.string().nullable()
            }).nullable(),
            verification: /*#__PURE__*/ z.object({
                status: /*#__PURE__*/ z.string(),
                issueCount: /*#__PURE__*/ z.number(),
                issues: /*#__PURE__*/ z.unknown().optional()
            }),
            contract: /*#__PURE__*/ z.object({
                compatible: /*#__PURE__*/ z.boolean(),
                addedFields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                removedFields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                changedTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    path: /*#__PURE__*/ z.string(),
                    contractType: /*#__PURE__*/ z.string(),
                    observedType: /*#__PURE__*/ z.string()
                }))
            }),
            outputSummary: /*#__PURE__*/ z.string(),
            evidence: /*#__PURE__*/ z.unknown().optional(),
            fullIo: /*#__PURE__*/ z.object({
                input: /*#__PURE__*/ z.unknown().optional(),
                output: /*#__PURE__*/ z.unknown().optional(),
                fullText: /*#__PURE__*/ z.string().nullable()
            }).optional(),
            error: /*#__PURE__*/ z.string().nullable(),
            fanOut: /*#__PURE__*/ z.object({
                counts: /*#__PURE__*/ z.object({
                    pending: /*#__PURE__*/ z.int(),
                    running: /*#__PURE__*/ z.int(),
                    succeeded: /*#__PURE__*/ z.int(),
                    failed: /*#__PURE__*/ z.int(),
                    skipped: /*#__PURE__*/ z.int(),
                    retried: /*#__PURE__*/ z.int()
                }),
                units: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    unitId: /*#__PURE__*/ z.string(),
                    unitIndex: /*#__PURE__*/ z.int(),
                    unitType: /*#__PURE__*/ z.string(),
                    personaSlug: /*#__PURE__*/ z.string(),
                    status: /*#__PURE__*/ z.enum([
                        'pending',
                        'running',
                        'succeeded',
                        'failed',
                        'skipped'
                    ]),
                    retryCount: /*#__PURE__*/ z.int(),
                    startedAt: /*#__PURE__*/ z.string().nullable(),
                    completedAt: /*#__PURE__*/ z.string().nullable(),
                    errorSummary: /*#__PURE__*/ z.string().nullable(),
                    confidence: /*#__PURE__*/ z.number().nullable(),
                    evidenceRefs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                    agentRunId: /*#__PURE__*/ z.string().nullable(),
                    output: /*#__PURE__*/ z.object({
                        summary: /*#__PURE__*/ z.string().nullable(),
                        nextActions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                        artifactRefs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
                    }).nullable()
                }))
            }).optional(),
            sourceBundles: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                bundleId: /*#__PURE__*/ z.string(),
                unitId: /*#__PURE__*/ z.string(),
                agentRunId: /*#__PURE__*/ z.string().nullable(),
                fileCount: /*#__PURE__*/ z.int(),
                totalBytes: /*#__PURE__*/ z.int(),
                digestPrefix: /*#__PURE__*/ z.string()
            })).optional(),
            dynamicFanOut: /*#__PURE__*/ z.object({
                considered: /*#__PURE__*/ z.boolean(),
                applied: /*#__PURE__*/ z.boolean(),
                mode: /*#__PURE__*/ z.enum([
                    'off',
                    'auto',
                    'on'
                ]),
                decision: /*#__PURE__*/ z.enum([
                    'execute_single',
                    'execute_fanout',
                    'blocked',
                    'fallback_single'
                ]),
                reasonCodes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                effectiveLimits: /*#__PURE__*/ z.object({
                    maxUnits: /*#__PURE__*/ z.int(),
                    maxConcurrency: /*#__PURE__*/ z.int()
                }),
                policySlug: /*#__PURE__*/ z.string().nullable(),
                unitCount: /*#__PURE__*/ z.int().nullable()
            }).optional()
        })),
        statusCounts: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number())
    }),
    timeline: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        at: /*#__PURE__*/ z.string(),
        type: /*#__PURE__*/ z.string(),
        kind: /*#__PURE__*/ z.string(),
        label: /*#__PURE__*/ z.string(),
        severity: /*#__PURE__*/ z.string(),
        stepId: /*#__PURE__*/ z.string().nullable(),
        refId: /*#__PURE__*/ z.string().nullable()
    })),
    linkedEntities: /*#__PURE__*/ z.object({
        projects: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            name: /*#__PURE__*/ z.string(),
            slug: /*#__PURE__*/ z.string().nullable(),
            status: /*#__PURE__*/ z.string()
        })),
        tasks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            title: /*#__PURE__*/ z.string(),
            status: /*#__PURE__*/ z.string(),
            originLabel: /*#__PURE__*/ z.string().nullable(),
            assigneeLabel: /*#__PURE__*/ z.string().nullable(),
            projectId: /*#__PURE__*/ z.string().nullable()
        })),
        workforce: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            name: /*#__PURE__*/ z.string(),
            department: /*#__PURE__*/ z.string().nullable(),
            status: /*#__PURE__*/ z.string()
        })),
        templates: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            name: /*#__PURE__*/ z.string().nullable(),
            slug: /*#__PURE__*/ z.string().nullable(),
            permissionTier: /*#__PURE__*/ z.string().nullable()
        })),
        artifacts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            title: /*#__PURE__*/ z.string().nullable(),
            kind: /*#__PURE__*/ z.string(),
            scope: /*#__PURE__*/ z.string(),
            subjectType: /*#__PURE__*/ z.string().nullable()
        })),
        decisions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            title: /*#__PURE__*/ z.string(),
            decisionType: /*#__PURE__*/ z.string(),
            conversationId: /*#__PURE__*/ z.string(),
            approvedAt: /*#__PURE__*/ z.string().nullable(),
            rationale: /*#__PURE__*/ z.string().nullable()
        }))
    }),
    actionAvailability: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.boolean()),
    llmCalls: /*#__PURE__*/ z.object({
        totalCount: /*#__PURE__*/ z.int(),
        cappedAt: /*#__PURE__*/ z.int(),
        calls: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string(),
            kind: /*#__PURE__*/ z.enum(['llm_call']),
            provider: /*#__PURE__*/ z.string(),
            model: /*#__PURE__*/ z.string(),
            modelVersion: /*#__PURE__*/ z.string().nullable(),
            stepId: /*#__PURE__*/ z.string().nullable(),
            agentId: /*#__PURE__*/ z.string().nullable(),
            temperature: /*#__PURE__*/ z.string().nullable(),
            maxTokens: /*#__PURE__*/ z.int().nullable(),
            promptTokens: /*#__PURE__*/ z.int().nullable(),
            completionTokens: /*#__PURE__*/ z.int().nullable(),
            costUsd: /*#__PURE__*/ z.string().nullable(),
            finishReason: /*#__PURE__*/ z.string().nullable(),
            durationMs: /*#__PURE__*/ z.int().nullable(),
            startedAt: /*#__PURE__*/ z.string().nullable(),
            traceId: /*#__PURE__*/ z.string().nullable(),
            systemPromptRef: /*#__PURE__*/ z.string().nullable(),
            messagesRef: /*#__PURE__*/ z.string().nullable(),
            responseRef: /*#__PURE__*/ z.string().nullable()
        }))
    }).optional(),
    audit: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        eventType: /*#__PURE__*/ z.string(),
        severity: /*#__PURE__*/ z.string(),
        stepId: /*#__PURE__*/ z.string().nullable(),
        createdAt: /*#__PURE__*/ z.string().nullable(),
        payload: /*#__PURE__*/ z.unknown().optional()
    }))
});

export const zWorkflowRunActionResult = /*#__PURE__*/ z.object({
    action: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    message: /*#__PURE__*/ z.string().optional(),
    engineRunId: /*#__PURE__*/ z.string().optional(),
    run: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        workflowId: /*#__PURE__*/ z.string()
    }).optional(),
    taskDraftUrl: /*#__PURE__*/ z.string().optional(),
    interventionUrl: /*#__PURE__*/ z.string().optional(),
    intervention: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        organizationId: /*#__PURE__*/ z.number(),
        type: /*#__PURE__*/ z.enum([
            'fix',
            'improve',
            'investigate',
            'decision',
            'contract_repair',
            'version_change',
            'worker_unavailable',
            'policy_blocker'
        ]),
        severity: /*#__PURE__*/ z.enum([
            'info',
            'warning',
            'error',
            'critical'
        ]),
        status: /*#__PURE__*/ z.enum([
            'open',
            'reviewing',
            'routed',
            'resolved',
            'rejected'
        ]),
        requestedOutcome: /*#__PURE__*/ z.enum([
            'task',
            'decision',
            'workflow_draft',
            'workflow_version',
            'workforce_route',
            'workstream_link',
            'log_only'
        ]).nullable(),
        title: /*#__PURE__*/ z.string(),
        reason: /*#__PURE__*/ z.string(),
        instructions: /*#__PURE__*/ z.string().nullable(),
        sourceType: /*#__PURE__*/ z.enum([
            'workflow',
            'workflow_run',
            'workflow_step',
            'task',
            'template',
            'project',
            'artifact',
            'workforce',
            'daemon',
            'catalog_item',
            'catalog_version',
            'decision'
        ]),
        sourceId: /*#__PURE__*/ z.string(),
        sourceName: /*#__PURE__*/ z.string(),
        sourceUrl: /*#__PURE__*/ z.string().nullable(),
        assignedToType: /*#__PURE__*/ z.string().nullable(),
        assignedToId: /*#__PURE__*/ z.string().nullable(),
        assignedToName: /*#__PURE__*/ z.string().nullable(),
        failureTaxonomy: /*#__PURE__*/ z.enum([
            'execution_failure',
            'contract_failure',
            'quality_failure',
            'policy_failure'
        ]).nullable(),
        evidence: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
        recommendedOutcomes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
        linkedOutcomes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
        resolvedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]).nullable(),
        resolvedBy: /*#__PURE__*/ z.number().nullable(),
        createdBy: /*#__PURE__*/ z.number(),
        createdAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]),
        updatedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ])
    }).optional()
});

export const zWorkflowRunActionRequest = /*#__PURE__*/ z.object({
    action: /*#__PURE__*/ z.enum([
        'cancel',
        'retry_run',
        'retry_failed_step',
        'retry_from_step',
        'create_task_from_failure',
        'route_to_workforce',
        'escalate_decision',
        'repair_contract',
        'fork_version'
    ]),
    stepId: /*#__PURE__*/ z.string().optional(),
    reason: /*#__PURE__*/ z.string().optional(),
    instructions: /*#__PURE__*/ z.string().optional(),
    outcomePayload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zLlmCallOutlierRow = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    provider: /*#__PURE__*/ z.string(),
    model: /*#__PURE__*/ z.string(),
    modelVersion: /*#__PURE__*/ z.string().nullable(),
    runId: /*#__PURE__*/ z.string().nullable(),
    stepId: /*#__PURE__*/ z.string().nullable(),
    agentId: /*#__PURE__*/ z.string().nullable(),
    promptTokens: /*#__PURE__*/ z.int().nullable(),
    completionTokens: /*#__PURE__*/ z.int().nullable(),
    costUsd: /*#__PURE__*/ z.string().nullable(),
    durationMs: /*#__PURE__*/ z.int().nullable(),
    finishReason: /*#__PURE__*/ z.string().nullable(),
    startedAt: /*#__PURE__*/ z.string().nullable(),
    traceId: /*#__PURE__*/ z.string().nullable()
});

export const zLlmCallOutlierList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zLlmCallOutlierRow),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.int().optional()
    })
});

export const zRunHealthAggregates = /*#__PURE__*/ z.object({
    window: /*#__PURE__*/ z.object({
        since: /*#__PURE__*/ z.string(),
        until: /*#__PURE__*/ z.string()
    }),
    llmCalls: /*#__PURE__*/ z.object({
        totalCalls: /*#__PURE__*/ z.int(),
        errorCalls: /*#__PURE__*/ z.int(),
        nonStopFinishes: /*#__PURE__*/ z.int(),
        avgDurationMs: /*#__PURE__*/ z.int().nullable(),
        p50DurationMs: /*#__PURE__*/ z.int().nullable(),
        totalCostUsd: /*#__PURE__*/ z.string(),
        avgCostUsd: /*#__PURE__*/ z.string().nullable()
    })
});

export const zModelSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    provider: /*#__PURE__*/ z.string(),
    modelName: /*#__PURE__*/ z.string(),
    displayName: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    strengths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    costTier: /*#__PURE__*/ z.string(),
    maxTokens: /*#__PURE__*/ z.number(),
    maxOutputTokens: /*#__PURE__*/ z.number().nullable(),
    maxConcurrentRequests: /*#__PURE__*/ z.number().nullable(),
    supportsVision: /*#__PURE__*/ z.boolean(),
    supportsTools: /*#__PURE__*/ z.boolean(),
    supportsStructuredOutput: /*#__PURE__*/ z.boolean(),
    supportsReasoning: /*#__PURE__*/ z.boolean(),
    supportsStreaming: /*#__PURE__*/ z.boolean(),
    supportsMultimodal: /*#__PURE__*/ z.boolean(),
    supportsRealtime: /*#__PURE__*/ z.boolean(),
    supportsProviderTools: /*#__PURE__*/ z.boolean(),
    supportsPromptCaching: /*#__PURE__*/ z.boolean(),
    supportsFiles: /*#__PURE__*/ z.boolean(),
    supportsWebSearch: /*#__PURE__*/ z.boolean(),
    dataRetentionTier: /*#__PURE__*/ z.string(),
    capabilities: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    enabled: /*#__PURE__*/ z.boolean(),
    findingCount: /*#__PURE__*/ z.number()
});

export const zModel = /*#__PURE__*/ zModelSummary.and(/*#__PURE__*/ z.object({
    findings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        severity: /*#__PURE__*/ z.string(),
        title: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string().nullable(),
        recommendation: /*#__PURE__*/ z.string().nullable(),
        reviewStatus: /*#__PURE__*/ z.string().nullable(),
        createdAt: /*#__PURE__*/ z.string()
    }))
}));

export const zRuntimePolicyModel = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    displayName: /*#__PURE__*/ z.string(),
    provider: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean()
});

export const zModelRuntimePolicy = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number().nullable(),
    scope: /*#__PURE__*/ z.enum(['system', 'org']),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    version: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'archived'
    ]),
    purpose: /*#__PURE__*/ z.enum([
        'interactive',
        'background',
        'evaluation',
        'daemon',
        'workflow',
        'debug',
        'bulk'
    ]),
    riskTier: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'privileged'
    ]),
    latencyClass: /*#__PURE__*/ z.enum([
        'realtime',
        'interactive',
        'batch'
    ]),
    costTier: /*#__PURE__*/ z.enum([
        'free',
        'low',
        'medium',
        'high'
    ]),
    permissionTier: /*#__PURE__*/ z.enum([
        'observer',
        'contributor',
        'operator'
    ]),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    models: /*#__PURE__*/ z.array(zRuntimePolicyModel),
    fallbackPolicyId: /*#__PURE__*/ z.number().nullable(),
    thinking: /*#__PURE__*/ z.enum([
        'model_default',
        'on',
        'off'
    ]),
    wallClockTimeoutMs: /*#__PURE__*/ z.number(),
    providerRequestTimeoutMs: /*#__PURE__*/ z.number(),
    idleTimeoutMs: /*#__PURE__*/ z.number().nullable(),
    maxInputTokens: /*#__PURE__*/ z.number().nullable(),
    maxOutputTokens: /*#__PURE__*/ z.number(),
    maxSystemPromptChars: /*#__PURE__*/ z.number().nullable(),
    maxConcurrentRequests: /*#__PURE__*/ z.number().nullable(),
    maxToolCalls: /*#__PURE__*/ z.number(),
    maxTurns: /*#__PURE__*/ z.number(),
    retryMax: /*#__PURE__*/ z.number(),
    retryBackoffMs: /*#__PURE__*/ z.number(),
    retryBackoffMultiplier: /*#__PURE__*/ z.number(),
    retryJitter: /*#__PURE__*/ z.boolean(),
    spendCapUsd: /*#__PURE__*/ z.number().nullable(),
    permissionMode: /*#__PURE__*/ z.enum([
        'provider_default',
        'read_only',
        'workspace_write',
        'full_auto',
        'bypass_permissions'
    ]),
    allowedProviderTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    streamingEnabled: /*#__PURE__*/ z.boolean(),
    sessionMode: /*#__PURE__*/ z.enum([
        'provider_default',
        'stateless',
        'reuse_session'
    ]),
    promptCachingEnabled: /*#__PURE__*/ z.boolean(),
    providerExtensions: /*#__PURE__*/ z.object({
        claudeCli: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        geminiCli: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        codexCli: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        anthropic: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        openai: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        ollama: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        custom: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
    }),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zModelRuntimePolicyResolveRequest = /*#__PURE__*/ z.object({
    surface: /*#__PURE__*/ z.enum([
        'conversation',
        'workforce',
        'workflow',
        'analysis',
        'evaluation',
        'judge',
        'codegen',
        'system',
        'research'
    ]),
    policyId: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zModelRuntimePolicyUpsert = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum(['system', 'org']).optional().default('org'),
    slug: /*#__PURE__*/ z.string().min(2).max(120),
    name: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().nullish(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'archived'
    ]).optional(),
    purpose: /*#__PURE__*/ z.enum([
        'interactive',
        'background',
        'evaluation',
        'daemon',
        'workflow',
        'debug',
        'bulk'
    ]),
    riskTier: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'privileged'
    ]),
    latencyClass: /*#__PURE__*/ z.enum([
        'realtime',
        'interactive',
        'batch'
    ]),
    costTier: /*#__PURE__*/ z.enum([
        'free',
        'low',
        'medium',
        'high'
    ]),
    permissionTier: /*#__PURE__*/ z.enum([
        'observer',
        'contributor',
        'operator'
    ]),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    modelIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).max(20),
    fallbackPolicyId: /*#__PURE__*/ z.int().gt(0).nullish(),
    thinking: /*#__PURE__*/ z.enum([
        'model_default',
        'on',
        'off'
    ]).optional(),
    wallClockTimeoutMs: /*#__PURE__*/ z.int().gt(0),
    providerRequestTimeoutMs: /*#__PURE__*/ z.int().gt(0),
    idleTimeoutMs: /*#__PURE__*/ z.int().gt(0).nullish(),
    maxInputTokens: /*#__PURE__*/ z.int().gt(0).nullish(),
    maxOutputTokens: /*#__PURE__*/ z.int().gt(0),
    maxSystemPromptChars: /*#__PURE__*/ z.int().gt(0).nullish(),
    maxConcurrentRequests: /*#__PURE__*/ z.int().gt(0).nullish(),
    maxToolCalls: /*#__PURE__*/ z.int().gte(0),
    maxTurns: /*#__PURE__*/ z.int().gt(0),
    retryMax: /*#__PURE__*/ z.int().gte(0),
    retryBackoffMs: /*#__PURE__*/ z.int().gte(0),
    retryBackoffMultiplier: /*#__PURE__*/ z.number().gt(0),
    retryJitter: /*#__PURE__*/ z.boolean().optional(),
    spendCapUsd: /*#__PURE__*/ z.number().gte(0).nullish(),
    permissionMode: /*#__PURE__*/ z.enum([
        'provider_default',
        'read_only',
        'workspace_write',
        'full_auto',
        'bypass_permissions'
    ]),
    allowedProviderTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    streamingEnabled: /*#__PURE__*/ z.boolean().optional(),
    sessionMode: /*#__PURE__*/ z.enum([
        'provider_default',
        'stateless',
        'reuse_session'
    ]),
    promptCachingEnabled: /*#__PURE__*/ z.boolean().optional(),
    providerExtensions: /*#__PURE__*/ z.object({
        claudeCli: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        geminiCli: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        codexCli: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        anthropic: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        openai: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        ollama: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        custom: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
    }).optional()
});

export const zRuntimePolicyOption = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    isDefault: /*#__PURE__*/ z.boolean(),
    models: /*#__PURE__*/ z.array(zRuntimePolicyModel)
});

export const zRuntimePolicySurfaceRuleWrite = /*#__PURE__*/ z.object({
    defaultPolicyId: /*#__PURE__*/ z.int().gt(0),
    allowedPolicyIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).min(1).max(50)
});

export const zDynamicFanOutPolicy = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().nullable(),
    organizationId: /*#__PURE__*/ z.number().nullable(),
    scope: /*#__PURE__*/ z.enum([
        'system',
        'org',
        'workflow',
        'step'
    ]),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    version: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'archived'
    ]),
    workflowMatch: /*#__PURE__*/ z.string().nullable(),
    stepMatch: /*#__PURE__*/ z.string().nullable(),
    mode: /*#__PURE__*/ z.enum([
        'off',
        'auto',
        'on'
    ]),
    fallbackBehavior: /*#__PURE__*/ z.enum(['fallback_single', 'block']),
    maxUnits: /*#__PURE__*/ z.number(),
    maxConcurrency: /*#__PURE__*/ z.number(),
    personaResolutionMode: /*#__PURE__*/ z.enum([
        'inherit_step',
        'same_department',
        'explicit_allowlist'
    ]),
    toolResolutionMode: /*#__PURE__*/ z.enum([
        'none',
        'inherit_step_tools',
        'explicit_allowlist'
    ]),
    allowedPersonaSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    allowedPersonaClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    allowedToolClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    sourcePassthroughEnabled: /*#__PURE__*/ z.boolean(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zDynamicFanOutPolicyResolveRequest = /*#__PURE__*/ z.object({
    workflowName: /*#__PURE__*/ z.string().optional(),
    stepName: /*#__PURE__*/ z.string().optional(),
    templateSlug: /*#__PURE__*/ z.string().optional()
});

export const zDynamicFanOutPolicyUpsert = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'system',
        'org',
        'workflow',
        'step'
    ]).optional().default('org'),
    slug: /*#__PURE__*/ z.string().min(2).max(120),
    name: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().nullish(),
    version: /*#__PURE__*/ z.int().gt(0).optional(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'archived'
    ]).optional(),
    workflowMatch: /*#__PURE__*/ z.string().min(1).max(200).nullish(),
    stepMatch: /*#__PURE__*/ z.string().min(1).max(200).nullish(),
    mode: /*#__PURE__*/ z.enum([
        'off',
        'auto',
        'on'
    ]),
    fallbackBehavior: /*#__PURE__*/ z.enum(['fallback_single', 'block']),
    maxUnits: /*#__PURE__*/ z.int().gte(1).lte(500),
    maxConcurrency: /*#__PURE__*/ z.int().gte(1).lte(50),
    personaResolutionMode: /*#__PURE__*/ z.enum([
        'inherit_step',
        'same_department',
        'explicit_allowlist'
    ]).optional(),
    toolResolutionMode: /*#__PURE__*/ z.enum([
        'none',
        'inherit_step_tools',
        'explicit_allowlist'
    ]).optional(),
    allowedPersonaSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    allowedPersonaClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    allowedToolClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    sourcePassthroughEnabled: /*#__PURE__*/ z.boolean().optional()
});

export const zAiWorkerMcpResponse = /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        id: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.int()
        ]),
        result: /*#__PURE__*/ z.object({
            _meta: /*#__PURE__*/ z.object({
                progressToken: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string(),
                    /*#__PURE__*/ z.int()
                ]).optional(),
                'io.modelcontextprotocol/related-task': /*#__PURE__*/ z.object({
                    taskId: /*#__PURE__*/ z.string()
                }).optional()
            }).optional()
        })
    }),
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        id: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.int()
        ]).optional(),
        error: /*#__PURE__*/ z.object({
            code: /*#__PURE__*/ z.int(),
            message: /*#__PURE__*/ z.string(),
            data: /*#__PURE__*/ z.unknown().optional()
        })
    })
]);

export const zAiWorkerMcpRequest = /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        id: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.int()
        ]),
        method: /*#__PURE__*/ z.string(),
        params: /*#__PURE__*/ z.object({
            _meta: /*#__PURE__*/ z.object({
                progressToken: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string(),
                    /*#__PURE__*/ z.int()
                ]).optional(),
                'io.modelcontextprotocol/related-task': /*#__PURE__*/ z.object({
                    taskId: /*#__PURE__*/ z.string()
                }).optional()
            }).optional()
        }).optional()
    }),
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        method: /*#__PURE__*/ z.string(),
        params: /*#__PURE__*/ z.object({
            _meta: /*#__PURE__*/ z.object({
                progressToken: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string(),
                    /*#__PURE__*/ z.int()
                ]).optional(),
                'io.modelcontextprotocol/related-task': /*#__PURE__*/ z.object({
                    taskId: /*#__PURE__*/ z.string()
                }).optional()
            }).optional()
        }).optional()
    })
]);

export const zHostMetricsExportResult = /*#__PURE__*/ z.object({
    partialSuccess: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zSnapshot = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    runId: /*#__PURE__*/ z.number(),
    templateId: /*#__PURE__*/ z.number(),
    stepId: /*#__PURE__*/ z.string(),
    stepName: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string(),
    output: /*#__PURE__*/ z.unknown().optional(),
    fullText: /*#__PURE__*/ z.string().nullable(),
    outputJson: /*#__PURE__*/ z.unknown().optional(),
    outputParts: /*#__PURE__*/ z.unknown().optional(),
    input: /*#__PURE__*/ z.unknown().optional(),
    model: /*#__PURE__*/ z.string().nullable(),
    costUsd: /*#__PURE__*/ z.string().nullable(),
    durationMs: /*#__PURE__*/ z.number().nullable(),
    label: /*#__PURE__*/ z.string().nullable(),
    pinned: /*#__PURE__*/ z.boolean().nullable(),
    contractHash: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string()
});

export const zOrgRequiredError = /*#__PURE__*/ z.object({
    error: /*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.enum(['ORG_REQUIRED']),
        message: /*#__PURE__*/ z.string()
    })
});

export const zSnapshotCreate = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.int().gt(0),
    stepId: /*#__PURE__*/ z.string().min(1),
    stepName: /*#__PURE__*/ z.string().optional(),
    output: /*#__PURE__*/ z.unknown().optional(),
    fullText: /*#__PURE__*/ z.string().optional(),
    outputParts: /*#__PURE__*/ z.unknown().optional(),
    input: /*#__PURE__*/ z.unknown().optional(),
    model: /*#__PURE__*/ z.string().optional(),
    costUsd: /*#__PURE__*/ z.string().optional(),
    durationMs: /*#__PURE__*/ z.number().optional(),
    label: /*#__PURE__*/ z.string().optional(),
    contract: /*#__PURE__*/ z.unknown().optional()
});

export const zSnapshotPurgeRequest = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.int().gt(0),
    olderThanDays: /*#__PURE__*/ z.int().gt(0).optional(),
    unpinnedOnly: /*#__PURE__*/ z.boolean().optional()
});

export const zSnapshotList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zSnapshot),
    paging: /*#__PURE__*/ z.object({
        hasMore: /*#__PURE__*/ z.boolean()
    })
});

export const zSnapshotUpdate = /*#__PURE__*/ z.object({
    label: /*#__PURE__*/ z.string().optional(),
    pinned: /*#__PURE__*/ z.boolean().optional()
});

export const zSnapshotActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zEvaluationDataset = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    targetType: /*#__PURE__*/ z.enum([
        'agent_template',
        'skill',
        'workflow',
        'tool',
        'model'
    ]),
    targetId: /*#__PURE__*/ z.string(),
    organizationId: /*#__PURE__*/ z.number(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    caseCount: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zEvaluationDatasetCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(255),
    description: /*#__PURE__*/ z.string().optional(),
    targetType: /*#__PURE__*/ z.enum([
        'agent_template',
        'skill',
        'workflow',
        'tool'
    ]),
    targetId: /*#__PURE__*/ z.string().min(1)
});

export const zEvaluationActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zEvaluationCase = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    datasetId: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    input: /*#__PURE__*/ z.unknown().optional(),
    expected: /*#__PURE__*/ z.unknown().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zEvaluationCaseCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(255),
    input: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    expected: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zEvaluationDatasetRunResult = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['queued']),
    datasetId: /*#__PURE__*/ z.number()
});

export const zEvaluationRun = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    datasetId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'running',
        'completed',
        'failed',
        'skipped'
    ]).nullable(),
    totalCases: /*#__PURE__*/ z.number().nullable(),
    passedCases: /*#__PURE__*/ z.number().nullable(),
    failedCases: /*#__PURE__*/ z.number().nullable(),
    avgScore: /*#__PURE__*/ z.string().nullable(),
    results: /*#__PURE__*/ z.unknown().optional(),
    startedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    completedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zReasoningEvaluationCheck = /*#__PURE__*/ z.object({
    key: /*#__PURE__*/ z.enum([
        'answered',
        'direction',
        'noCall',
        'readings',
        'facts',
        'quotes',
        'outcome'
    ]),
    label: /*#__PURE__*/ z.string(),
    rule: /*#__PURE__*/ z.string(),
    reason: /*#__PURE__*/ z.string(),
    value: /*#__PURE__*/ z.number().nullable(),
    n: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'pass',
        'fail',
        'insufficient',
        'reported'
    ])
});

export const zReasoningEvaluation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    title: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    intelSourceId: /*#__PURE__*/ z.number().nullable(),
    handle: /*#__PURE__*/ z.string().nullable(),
    versionId: /*#__PURE__*/ z.string().nullable(),
    split: /*#__PURE__*/ z.string().nullable(),
    ranAt: /*#__PURE__*/ z.string().nullable(),
    policyId: /*#__PURE__*/ z.string().nullable(),
    surface: /*#__PURE__*/ z.string().nullable(),
    report: /*#__PURE__*/ z.object({
        asked: /*#__PURE__*/ z.number(),
        answered: /*#__PURE__*/ z.number(),
        failed: /*#__PURE__*/ z.number(),
        directionFidelity: /*#__PURE__*/ z.object({
            n: /*#__PURE__*/ z.number(),
            matches: /*#__PURE__*/ z.number(),
            share: /*#__PURE__*/ z.number().nullable(),
            majorityDirection: /*#__PURE__*/ z.string().nullish(),
            majorityShare: /*#__PURE__*/ z.number().nullish()
        }),
        noCallShare: /*#__PURE__*/ z.number().nullable(),
        readingF1: /*#__PURE__*/ z.object({
            n: /*#__PURE__*/ z.number(),
            mean: /*#__PURE__*/ z.number().nullable()
        }),
        kindF1: /*#__PURE__*/ z.object({
            n: /*#__PURE__*/ z.number(),
            mean: /*#__PURE__*/ z.number().nullable()
        }),
        outcome: /*#__PURE__*/ z.object({
            n: /*#__PURE__*/ z.number(),
            personaHitRate: /*#__PURE__*/ z.number().nullable(),
            baselineHitRate: /*#__PURE__*/ z.number().nullable(),
            personaMeanSignedReturn: /*#__PURE__*/ z.number().nullish(),
            baselineMeanSignedReturn: /*#__PURE__*/ z.number().nullish(),
            signedReturnN: /*#__PURE__*/ z.number().optional()
        }),
        factValidity: /*#__PURE__*/ z.object({
            relied: /*#__PURE__*/ z.number(),
            contradicted: /*#__PURE__*/ z.number(),
            share: /*#__PURE__*/ z.number().nullable()
        }),
        unfoundQuotes: /*#__PURE__*/ z.number()
    }).nullable(),
    checks: /*#__PURE__*/ z.array(zReasoningEvaluationCheck),
    failedChecks: /*#__PURE__*/ z.number()
});

export const zReasoningEvaluationRule = /*#__PURE__*/ z.object({
    key: /*#__PURE__*/ z.enum([
        'answered',
        'direction',
        'noCall',
        'readings',
        'facts',
        'quotes',
        'outcome'
    ]),
    label: /*#__PURE__*/ z.string(),
    rule: /*#__PURE__*/ z.string(),
    reason: /*#__PURE__*/ z.string(),
    minN: /*#__PURE__*/ z.number()
});

export const zReasoningEvaluationList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zReasoningEvaluation),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        schedule: /*#__PURE__*/ z.string(),
        rules: /*#__PURE__*/ z.array(zReasoningEvaluationRule)
    })
});

export const zReasoningCallFunnel = /*#__PURE__*/ z.object({
    intelSourceId: /*#__PURE__*/ z.number(),
    handle: /*#__PURE__*/ z.string(),
    itemsAnalysed: /*#__PURE__*/ z.number(),
    itemsFailed: /*#__PURE__*/ z.number(),
    itemsByContract: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    calls: /*#__PURE__*/ z.number(),
    callsDismissed: /*#__PURE__*/ z.number(),
    callsWithoutSubject: /*#__PURE__*/ z.number(),
    callsHorizonStated: /*#__PURE__*/ z.number(),
    callsConditional: /*#__PURE__*/ z.number(),
    reasons: /*#__PURE__*/ z.number(),
    reasonsStated: /*#__PURE__*/ z.number(),
    reasonsCued: /*#__PURE__*/ z.number(),
    reasonChecks: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    outcomes: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    undecided: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        reason: /*#__PURE__*/ z.string(),
        count: /*#__PURE__*/ z.number()
    }))
});

export const zReasoningCallSummary = /*#__PURE__*/ z.object({
    sources: /*#__PURE__*/ z.array(zReasoningCallFunnel),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime()
    })
});

export const zReasoningPrincipleFunnel = /*#__PURE__*/ z.object({
    intelSourceId: /*#__PURE__*/ z.number(),
    handle: /*#__PURE__*/ z.string(),
    principles: /*#__PURE__*/ z.number(),
    typed: /*#__PURE__*/ z.number(),
    byClass: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    rejected: /*#__PURE__*/ z.number(),
    untyped: /*#__PURE__*/ z.number(),
    held: /*#__PURE__*/ z.number(),
    checked: /*#__PURE__*/ z.number(),
    checks: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    inSample: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    outOfSample: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    module: /*#__PURE__*/ z.object({
        routed: /*#__PURE__*/ z.number(),
        hypotheses: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
        validated: /*#__PURE__*/ z.object({
            calls: /*#__PURE__*/ z.object({
                held: /*#__PURE__*/ z.number(),
                broke: /*#__PURE__*/ z.number()
            }),
            principles: /*#__PURE__*/ z.object({
                held: /*#__PURE__*/ z.number(),
                broke: /*#__PURE__*/ z.number()
            })
        }),
        drafted: /*#__PURE__*/ z.number(),
        backtested: /*#__PURE__*/ z.number(),
        admitted: /*#__PURE__*/ z.number()
    }).nullable()
});

export const zReasoningPrincipleSummary = /*#__PURE__*/ z.object({
    sources: /*#__PURE__*/ z.array(zReasoningPrincipleFunnel),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime()
    })
});

export const zEvaluationTemplateWithVersions = /*#__PURE__*/ zEvaluationTemplate.and(/*#__PURE__*/ z.object({
    versions: /*#__PURE__*/ z.array(zEvaluationTemplateVersion)
}));

export const zEvaluationTemplateCreate = /*#__PURE__*/ z.object({
    templateRef: /*#__PURE__*/ z.string().min(1).max(160),
    name: /*#__PURE__*/ z.string().min(1).max(255),
    description: /*#__PURE__*/ z.string().nullish(),
    subjectKind: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]),
    templateKind: /*#__PURE__*/ z.enum(['leaf', 'group']).optional(),
    visibility: /*#__PURE__*/ z.enum(['private', 'org']).optional(),
    spec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
});

export const zEvaluationTemplateList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zEvaluationTemplate),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zEvaluationTemplateUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(255).optional(),
    description: /*#__PURE__*/ z.string().nullish(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'deprecated',
        'retired'
    ]).optional(),
    visibility: /*#__PURE__*/ z.enum(['private', 'org']).optional(),
    templateKind: /*#__PURE__*/ z.enum(['leaf', 'group']).optional()
});

export const zEvaluationTemplateVersionCreate = /*#__PURE__*/ z.object({
    spec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
});

export const zEvaluationAssignment = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    templateVersionId: /*#__PURE__*/ z.number()
});

export const zEvaluationTemplateApplyRequest = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]),
    subjectId: /*#__PURE__*/ z.string().min(1),
    targetTransition: /*#__PURE__*/ z.string().min(1).max(120)
});

export const zSubjectEvaluationRow = /*#__PURE__*/ z.object({
    assignment: /*#__PURE__*/ zEvaluationAssignment.and(/*#__PURE__*/ z.object({
        targetTransition: /*#__PURE__*/ z.string()
    })),
    template: /*#__PURE__*/ zEvaluationTemplate.nullable(),
    version: /*#__PURE__*/ zEvaluationTemplateVersion.nullable(),
    promotionVerdict: /*#__PURE__*/ z.object({
        hasPlan: /*#__PURE__*/ z.boolean(),
        satisfied: /*#__PURE__*/ z.boolean(),
        reason: /*#__PURE__*/ z.enum([
            'no_active_assignments',
            'not_evaluated',
            'unsatisfied',
            'satisfied'
        ]),
        gateId: /*#__PURE__*/ z.number().optional(),
        satisfaction: /*#__PURE__*/ z.object({
            satisfied: /*#__PURE__*/ z.boolean(),
            requiredKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
            passedKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
            missingKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
            failingKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
        }).optional()
    })
});

export const zSubjectEvaluations = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.string(),
    subjectId: /*#__PURE__*/ z.string(),
    assignments: /*#__PURE__*/ z.array(zSubjectEvaluationRow)
});

export const zCatalogSourceWithIntegrity = /*#__PURE__*/ zCatalogSource.and(/*#__PURE__*/ z.object({
    fragments: /*#__PURE__*/ z.array(zCatalogSourceFragmentSummary),
    integrity: /*#__PURE__*/ z.object({
        total: /*#__PURE__*/ z.number(),
        blocked: /*#__PURE__*/ z.number(),
        warnings: /*#__PURE__*/ z.number(),
        latest: /*#__PURE__*/ zCatalogIntegrityCheckSummary.nullable()
    })
}));

export const zCatalogSourceList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCatalogSourceWithIntegrity)
});

export const zCatalogErrorResult = /*#__PURE__*/ z.object({
    error: /*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.string(),
        message: /*#__PURE__*/ z.string()
    })
});

export const zCatalogCandidateListItem = /*#__PURE__*/ zCatalogCandidate.and(/*#__PURE__*/ z.object({
    source: /*#__PURE__*/ zCatalogSource.nullable(),
    discoveredByDaemonName: /*#__PURE__*/ z.string().nullable(),
    discoveredRunStatus: /*#__PURE__*/ z.string().nullable(),
    discoveredRunStartedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    discoveredRunCompletedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    evidenceLinks: /*#__PURE__*/ z.object({
        sourceId: /*#__PURE__*/ z.number(),
        sourceUrl: /*#__PURE__*/ z.string().nullable(),
        sourceRepoUrl: /*#__PURE__*/ z.string().nullable(),
        sourcePath: /*#__PURE__*/ z.string().nullable(),
        sourceRef: /*#__PURE__*/ z.string().nullable(),
        canonicalKey: /*#__PURE__*/ z.string().nullable(),
        sourceFragment: /*#__PURE__*/ zCatalogSourceFragmentSummary.nullable()
    }),
    integrityChecks: /*#__PURE__*/ z.array(zCatalogIntegrityCheckSummary)
}));

export const zCatalogCandidateList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCatalogCandidateListItem)
});

export const zCatalogCandidateDecision = /*#__PURE__*/ zCatalogCandidate.and(/*#__PURE__*/ z.object({
    source: /*#__PURE__*/ zCatalogSource.nullish(),
    reviewStages: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        daemonId: /*#__PURE__*/ z.number().nullable(),
        daemonName: /*#__PURE__*/ z.string(),
        eventType: /*#__PURE__*/ z.string().nullable(),
        status: /*#__PURE__*/ z.string(),
        queueStatus: /*#__PURE__*/ z.string().nullable(),
        lastError: /*#__PURE__*/ z.string().nullable(),
        updatedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]).nullable(),
        runIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
        findings: /*#__PURE__*/ z.array(zCatalogFindingSummary)
    })),
    evidenceLinks: /*#__PURE__*/ z.object({
        sourceId: /*#__PURE__*/ z.number(),
        sourceUrl: /*#__PURE__*/ z.string().nullable(),
        sourceRepoUrl: /*#__PURE__*/ z.string().nullable(),
        sourcePath: /*#__PURE__*/ z.string().nullable(),
        sourceRef: /*#__PURE__*/ z.string().nullable(),
        canonicalKey: /*#__PURE__*/ z.string().nullable(),
        sourceFragment: /*#__PURE__*/ zCatalogSourceFragmentSummary.nullable(),
        discoveryRun: /*#__PURE__*/ zCatalogRunLink.nullable(),
        securityReviewRun: /*#__PURE__*/ zCatalogRunLink.nullable(),
        qualityReviewRun: /*#__PURE__*/ zCatalogRunLink.nullable()
    }),
    integrityChecks: /*#__PURE__*/ z.array(zCatalogIntegrityCheckSummary),
    discoveryFinding: /*#__PURE__*/ zCatalogFindingSummary.nullable()
}));

export const zCatalogCandidateDecisionResult = /*#__PURE__*/ z.object({
    data: zCatalogCandidateDecision
});

export const zCatalogReviewQueueItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    eventType: /*#__PURE__*/ z.string(),
    candidateId: /*#__PURE__*/ z.number(),
    targetEntityId: /*#__PURE__*/ z.number().nullable(),
    targetDaemonName: /*#__PURE__*/ z.string(),
    sourceEntityId: /*#__PURE__*/ z.number().nullable(),
    sourceDaemonRunId: /*#__PURE__*/ z.number().nullable(),
    sourceFindingId: /*#__PURE__*/ z.number().nullable(),
    sourceReportId: /*#__PURE__*/ z.number().nullable(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'locked',
        'blocked',
        'completed',
        'failed',
        'cancelled'
    ]),
    priority: /*#__PURE__*/ z.number(),
    attempts: /*#__PURE__*/ z.number(),
    maxAttempts: /*#__PURE__*/ z.number(),
    availableAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    lockedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    lockOwner: /*#__PURE__*/ z.string().nullable(),
    completedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    failedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    lastError: /*#__PURE__*/ z.string().nullable(),
    idempotencyKey: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    targetDaemonId: /*#__PURE__*/ z.number().nullable(),
    targetDaemonEnabled: /*#__PURE__*/ z.boolean().nullable(),
    targetDaemonStatus: /*#__PURE__*/ z.string().nullable(),
    candidateTargetType: /*#__PURE__*/ z.string().nullable(),
    candidateStatus: /*#__PURE__*/ z.string().nullable(),
    candidateSummary: /*#__PURE__*/ z.string().nullable(),
    blocker: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string(),
        title: /*#__PURE__*/ z.string(),
        message: /*#__PURE__*/ z.string(),
        action: /*#__PURE__*/ z.string()
    }).nullable()
});

export const zCatalogReviewQueueList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCatalogReviewQueueItem)
});

export const zCatalogProcessResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        processed: /*#__PURE__*/ z.boolean()
    })
});

export const zCatalogAdoption = /*#__PURE__*/ z.object({
    consumerKey: /*#__PURE__*/ z.string(),
    consumerType: /*#__PURE__*/ z.enum([
        'daemon_skill',
        'template_skill',
        'entity_acquisition',
        'entity_relationship_source',
        'entity_relationship_target'
    ]),
    consumerId: /*#__PURE__*/ z.number(),
    ownerType: /*#__PURE__*/ z.enum([
        'daemon',
        'template',
        'entity_acquisition',
        'entity_relationship'
    ]),
    ownerId: /*#__PURE__*/ z.number(),
    label: /*#__PURE__*/ z.string(),
    targetType: /*#__PURE__*/ z.string(),
    targetId: /*#__PURE__*/ z.number(),
    adoptedVersionId: /*#__PURE__*/ z.number().nullable(),
    adoptedVersion: /*#__PURE__*/ z.number().nullable(),
    latestVersionId: /*#__PURE__*/ z.number().nullable(),
    latestVersion: /*#__PURE__*/ z.number().nullable(),
    latestMaterializedTargetId: /*#__PURE__*/ z.number().nullable(),
    previousVersionId: /*#__PURE__*/ z.number().nullable(),
    previousVersion: /*#__PURE__*/ z.number().nullable(),
    previousMaterializedTargetId: /*#__PURE__*/ z.number().nullable(),
    status: /*#__PURE__*/ z.enum([
        'current',
        'stale',
        'adoptable',
        'untracked'
    ]),
    canUpgrade: /*#__PURE__*/ z.boolean(),
    canRevert: /*#__PURE__*/ z.boolean(),
    proposalRequired: /*#__PURE__*/ z.boolean().optional(),
    proposalInterventionId: /*#__PURE__*/ z.number().nullish()
});

export const zCatalogAdoptionResult = /*#__PURE__*/ z.object({
    data: zCatalogAdoption
});

export const zCatalogRequeueResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        requeued: /*#__PURE__*/ z.number()
    })
});

export const zCatalogItemVersion = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    sourceId: /*#__PURE__*/ z.number(),
    candidateId: /*#__PURE__*/ z.number().nullable(),
    targetType: /*#__PURE__*/ z.string(),
    targetId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    versionHash: /*#__PURE__*/ z.string(),
    payloadSnapshot: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    diffSummary: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'superseded',
        'restored'
    ]),
    restoredFromVersionId: /*#__PURE__*/ z.number().nullable(),
    supersededByVersionId: /*#__PURE__*/ z.number().nullable(),
    promotedBy: /*#__PURE__*/ z.string().nullable(),
    promotedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zCatalogItemVersionWithAdoption = /*#__PURE__*/ zCatalogItemVersion.and(/*#__PURE__*/ z.object({
    adoption: /*#__PURE__*/ z.object({
        isLatest: /*#__PURE__*/ z.boolean(),
        latestVersion: /*#__PURE__*/ z.number(),
        latestVersionId: /*#__PURE__*/ z.number(),
        newerVersionAvailable: /*#__PURE__*/ z.boolean()
    })
}));

export const zCatalogItemVersionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCatalogItemVersionWithAdoption)
});

export const zCatalogAdoptionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCatalogAdoption)
});

export const zCatalogPromotionResult = /*#__PURE__*/ z.object({
    candidate: /*#__PURE__*/ zCatalogCandidate.nullable(),
    version: zCatalogItemVersion,
    materializedTarget: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string(),
        id: /*#__PURE__*/ z.number(),
        version: /*#__PURE__*/ z.number(),
        label: /*#__PURE__*/ z.string()
    }),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    marketplaceEligible: /*#__PURE__*/ z.boolean()
});

export const zCatalogPromotionResponse = /*#__PURE__*/ z.object({
    data: zCatalogPromotionResult
});

export const zCatalogCandidateResult = /*#__PURE__*/ z.object({
    data: zCatalogCandidate
});

export const zCatalogRetryReviewResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        processed: /*#__PURE__*/ z.boolean(),
        queueItemId: /*#__PURE__*/ z.number(),
        targetDaemonName: /*#__PURE__*/ z.string()
    })
});

export const zWorkflowOutputWidgetDefinition = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullish(),
    defaultConfig: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    category: /*#__PURE__*/ z.string().nullish(),
    isSystem: /*#__PURE__*/ z.boolean().optional(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zWorkflowOutputWidgetDefinitionCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1),
    type: /*#__PURE__*/ z.string().min(1),
    description: /*#__PURE__*/ z.string().optional(),
    defaultConfig: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    category: /*#__PURE__*/ z.string().optional()
});

export const zDashboardWidgetLegacy = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    dashboardId: /*#__PURE__*/ z.number(),
    widgetDefinitionId: /*#__PURE__*/ z.number(),
    position: /*#__PURE__*/ z.number(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    definition: /*#__PURE__*/ zWorkflowOutputWidgetDefinition.optional()
});

export const zPinWidgetBody = /*#__PURE__*/ z.object({
    dashboardId: /*#__PURE__*/ z.number(),
    widgetDefinitionId: /*#__PURE__*/ z.number(),
    position: /*#__PURE__*/ z.number(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zUpdateDashboardWidgetBody = /*#__PURE__*/ z.object({
    position: /*#__PURE__*/ z.number().optional(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zOutputPartKind = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    displayName: /*#__PURE__*/ z.string(),
    icon: /*#__PURE__*/ z.string()
});

export const zOutputMetricPoint = /*#__PURE__*/ z.object({
    time: /*#__PURE__*/ z.iso.datetime(),
    value: /*#__PURE__*/ z.number(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish()
});

export const zPortTypeColorMap = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string());

export const zPortCompatibilityResult = /*#__PURE__*/ z.object({
    compatible: /*#__PURE__*/ z.boolean(),
    reason: /*#__PURE__*/ z.string().optional()
});

export const zPortTypeDefinition = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    displayName: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.enum([
        'primitive',
        'collection',
        'json',
        'domain'
    ]),
    color: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().optional(),
    compatibleWith: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zWorkflowDocument = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    workflowDefinitionId: /*#__PURE__*/ z.string().nullable(),
    fileName: /*#__PURE__*/ z.string(),
    mimeType: /*#__PURE__*/ z.string(),
    sizeBytes: /*#__PURE__*/ z.number().optional(),
    uploadedBy: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zWorkflowDocumentUpload = /*#__PURE__*/ z.object({
    fileName: /*#__PURE__*/ z.string().min(1).max(255),
    content: /*#__PURE__*/ z.string().min(1),
    mimeType: /*#__PURE__*/ z.string().min(1).max(100)
});

export const zRuntimePolicyAssignment = /*#__PURE__*/ z.object({
    runtimePolicyId: /*#__PURE__*/ z.int().gt(0)
});

export const zInstructionExportResult = /*#__PURE__*/ z.object({
    content: /*#__PURE__*/ z.string(),
    fileName: /*#__PURE__*/ z.string()
});

export const zInstructionExportBody = /*#__PURE__*/ z.object({
    workflowId: /*#__PURE__*/ z.string().optional(),
    stepIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    scope: /*#__PURE__*/ z.enum([
        'full',
        'selected',
        'blank'
    ]),
    includeRoles: /*#__PURE__*/ z.boolean().optional(),
    includeOutputSchemas: /*#__PURE__*/ z.boolean().optional()
});

export const zWorkflowDefinitionSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    version: /*#__PURE__*/ z.number().nullable(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'archived'
    ]).nullable(),
    schedule: /*#__PURE__*/ z.unknown().optional(),
    humanGates: /*#__PURE__*/ z.unknown().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    runtimePolicyId: /*#__PURE__*/ z.number().nullable(),
    sourceConversationId: /*#__PURE__*/ z.number().nullable(),
    sourceMessageId: /*#__PURE__*/ z.number().nullable(),
    initialSeed: /*#__PURE__*/ z.unknown().optional(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    stepCount: /*#__PURE__*/ z.number()
});

export const zWorkflowDefinitionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowDefinitionSummary),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        has_more: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        server_time: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zWorkflowStep = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    versionId: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    templateId: /*#__PURE__*/ z.number().nullable(),
    subWorkflowDefinitionId: /*#__PURE__*/ z.number().nullable(),
    executionMode: /*#__PURE__*/ z.enum([
        'sequential',
        'parallel',
        'conditional',
        'race'
    ]).nullable(),
    parallelGroup: /*#__PURE__*/ z.string().nullable(),
    order: /*#__PURE__*/ z.number(),
    optional: /*#__PURE__*/ z.boolean(),
    timeoutMs: /*#__PURE__*/ z.number().nullable(),
    retryMax: /*#__PURE__*/ z.number().nullable(),
    retryBackoffMs: /*#__PURE__*/ z.number().nullable(),
    retryBackoffMultiplier: /*#__PURE__*/ z.string().nullable(),
    systemPromptOverride: /*#__PURE__*/ z.string().nullable(),
    additionalInstructions: /*#__PURE__*/ z.string().nullable(),
    toolSelectionMode: /*#__PURE__*/ z.enum([
        'manual',
        'auto',
        'hybrid'
    ]).nullable(),
    outputConfig: /*#__PURE__*/ z.unknown().optional(),
    fanOutConfig: /*#__PURE__*/ z.object({
        planSourceStep: /*#__PURE__*/ z.string().min(1),
        allowedPersonaSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1),
        allowedPersonaClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
        allowedToolClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
        maxUnits: /*#__PURE__*/ z.int().gte(1).lte(500),
        maxConcurrency: /*#__PURE__*/ z.int().gte(1).lte(50),
        unitTimeoutMs: /*#__PURE__*/ z.int().gte(1000).lte(1800000).optional(),
        defaultFailurePolicy: /*#__PURE__*/ z.enum(['fail_all', 'allow_partial']).optional().default('fail_all'),
        defaultRetryMax: /*#__PURE__*/ z.int().gte(0).lte(5).optional().default(0)
    }).nullish(),
    safeOutputs: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), zSafeOutputConstraint).nullish(),
    outputPortType: /*#__PURE__*/ z.string().nullable(),
    outputContract: /*#__PURE__*/ z.unknown().optional(),
    inputContracts: /*#__PURE__*/ z.unknown().optional(),
    contractNegotiationStatus: /*#__PURE__*/ z.enum([
        'pending',
        'negotiated',
        'overridden',
        'error'
    ]).nullable(),
    contractVersion: /*#__PURE__*/ z.number().nullable(),
    conditionField: /*#__PURE__*/ z.string().nullable(),
    conditionOperator: /*#__PURE__*/ z.string().nullable(),
    conditionValue: /*#__PURE__*/ z.unknown().optional(),
    approvalStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected'
    ]).nullable(),
    approvedBy: /*#__PURE__*/ z.number().nullable(),
    templateSlug: /*#__PURE__*/ z.string().nullish(),
    templateName: /*#__PURE__*/ z.string().nullish(),
    pinnedTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zWorkflowEdge = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    versionId: /*#__PURE__*/ z.number(),
    sourceStepId: /*#__PURE__*/ z.number(),
    targetStepId: /*#__PURE__*/ z.number(),
    kind: /*#__PURE__*/ z.enum(['data', 'control']),
    label: /*#__PURE__*/ z.object({
        text: /*#__PURE__*/ z.string()
    }).nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zWorkflowDefinition = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    version: /*#__PURE__*/ z.number().nullable(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'archived'
    ]).nullable(),
    schedule: /*#__PURE__*/ z.unknown().optional(),
    humanGates: /*#__PURE__*/ z.unknown().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    runtimePolicyId: /*#__PURE__*/ z.number().nullable(),
    sourceConversationId: /*#__PURE__*/ z.number().nullable(),
    sourceMessageId: /*#__PURE__*/ z.number().nullable(),
    initialSeed: /*#__PURE__*/ z.unknown().optional(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    steps: /*#__PURE__*/ z.array(zWorkflowStep),
    edges: /*#__PURE__*/ z.array(zWorkflowEdge).optional().default([])
});

export const zWorkflowTemplateResult = /*#__PURE__*/ z.object({
    template: zWorkflowDefinition
});

export const zWorkflowStepPayload = /*#__PURE__*/ z.object({
    fanOutConfig: /*#__PURE__*/ z.object({
        planSourceStep: /*#__PURE__*/ z.string().min(1),
        allowedPersonaSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1),
        allowedPersonaClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
        allowedToolClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
        maxUnits: /*#__PURE__*/ z.int().gte(1).lte(500),
        maxConcurrency: /*#__PURE__*/ z.int().gte(1).lte(50),
        unitTimeoutMs: /*#__PURE__*/ z.int().gte(1000).lte(1800000).optional(),
        defaultFailurePolicy: /*#__PURE__*/ z.enum(['fail_all', 'allow_partial']).optional().default('fail_all'),
        defaultRetryMax: /*#__PURE__*/ z.int().gte(0).lte(5).optional().default(0)
    }).nullish()
});

export const zWorkflowCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1),
    description: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    schedule: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    humanGates: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    steps: /*#__PURE__*/ z.array(zWorkflowStepPayload).optional(),
    runtimePolicyId: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zWorkflowValidationResult = /*#__PURE__*/ z.object({
    valid: /*#__PURE__*/ z.boolean(),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    errors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zStepReorderBody = /*#__PURE__*/ z.object({
    stepIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number())
});

export const zWorkflowStepInput = /*#__PURE__*/ z.object({
    versionId: /*#__PURE__*/ z.number().optional(),
    name: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().nullish(),
    templateId: /*#__PURE__*/ z.number().nullish(),
    subWorkflowDefinitionId: /*#__PURE__*/ z.number().nullish(),
    executionMode: /*#__PURE__*/ z.enum([
        'sequential',
        'parallel',
        'conditional',
        'race'
    ]).nullish(),
    parallelGroup: /*#__PURE__*/ z.string().nullish(),
    order: /*#__PURE__*/ z.number().optional(),
    optional: /*#__PURE__*/ z.boolean().optional(),
    timeoutMs: /*#__PURE__*/ z.number().nullish(),
    retryMax: /*#__PURE__*/ z.number().nullish(),
    retryBackoffMs: /*#__PURE__*/ z.number().nullish(),
    retryBackoffMultiplier: /*#__PURE__*/ z.string().nullish(),
    systemPromptOverride: /*#__PURE__*/ z.string().nullish(),
    additionalInstructions: /*#__PURE__*/ z.string().nullish(),
    toolSelectionMode: /*#__PURE__*/ z.enum([
        'manual',
        'auto',
        'hybrid'
    ]).nullish(),
    outputConfig: /*#__PURE__*/ z.unknown().optional(),
    fanOutConfig: /*#__PURE__*/ z.object({
        planSourceStep: /*#__PURE__*/ z.string().min(1),
        allowedPersonaSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1),
        allowedPersonaClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
        allowedToolClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
        maxUnits: /*#__PURE__*/ z.int().gte(1).lte(500),
        maxConcurrency: /*#__PURE__*/ z.int().gte(1).lte(50),
        unitTimeoutMs: /*#__PURE__*/ z.int().gte(1000).lte(1800000).optional(),
        defaultFailurePolicy: /*#__PURE__*/ z.enum(['fail_all', 'allow_partial']).optional().default('fail_all'),
        defaultRetryMax: /*#__PURE__*/ z.int().gte(0).lte(5).optional().default(0)
    }).nullish(),
    safeOutputs: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), zSafeOutputConstraint).nullish(),
    outputPortType: /*#__PURE__*/ z.string().nullish(),
    outputContract: /*#__PURE__*/ z.unknown().optional(),
    inputContracts: /*#__PURE__*/ z.unknown().optional(),
    contractNegotiationStatus: /*#__PURE__*/ z.enum([
        'pending',
        'negotiated',
        'overridden',
        'error'
    ]).nullish(),
    contractVersion: /*#__PURE__*/ z.number().nullish(),
    conditionField: /*#__PURE__*/ z.string().nullish(),
    conditionOperator: /*#__PURE__*/ z.string().nullish(),
    conditionValue: /*#__PURE__*/ z.unknown().optional(),
    approvalStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected'
    ]).nullish(),
    approvedBy: /*#__PURE__*/ z.number().nullish(),
    templateSlug: /*#__PURE__*/ z.string().nullish(),
    templateName: /*#__PURE__*/ z.string().nullish(),
    pinnedTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zWorkflowScheduleBody = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable();

export const zWorkflowExecutionObservationSchemaDiff = /*#__PURE__*/ z.object({
    compatible: /*#__PURE__*/ z.boolean(),
    addedFields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    removedFields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    changedTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        path: /*#__PURE__*/ z.string(),
        contractType: /*#__PURE__*/ z.string(),
        observedType: /*#__PURE__*/ z.string()
    }))
});

export const zWorkflowExecutionObservation = /*#__PURE__*/ z.object({
    stepId: /*#__PURE__*/ z.string(),
    stepName: /*#__PURE__*/ z.string(),
    observedSchema: /*#__PURE__*/ zJsonObject.nullable(),
    contractSchema: /*#__PURE__*/ zJsonObject.nullable(),
    diff: zWorkflowExecutionObservationSchemaDiff,
    sampleCount: /*#__PURE__*/ z.number(),
    latestRunId: /*#__PURE__*/ z.number().nullable(),
    latestCompletedAt: /*#__PURE__*/ z.string().nullable(),
    verification: /*#__PURE__*/ z.object({
        passed: /*#__PURE__*/ z.number(),
        failed: /*#__PURE__*/ z.number(),
        warning: /*#__PURE__*/ z.number(),
        unknown: /*#__PURE__*/ z.number(),
        issues: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown())
    }),
    samples: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        runId: /*#__PURE__*/ z.number(),
        completedAt: /*#__PURE__*/ z.string().nullable(),
        status: /*#__PURE__*/ z.string(),
        preview: /*#__PURE__*/ z.unknown().optional()
    }))
});

export const zWorkflowExecutionObservationList = /*#__PURE__*/ z.object({
    workflowId: /*#__PURE__*/ z.number(),
    generatedAt: /*#__PURE__*/ z.string(),
    steps: /*#__PURE__*/ z.array(zWorkflowExecutionObservation)
});

export const zWorkflowRunSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    templateId: /*#__PURE__*/ z.number().nullable(),
    status: /*#__PURE__*/ z.string(),
    triggeredBy: /*#__PURE__*/ z.string().nullable(),
    startedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    completedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    error: /*#__PURE__*/ z.string().nullable(),
    totalCostUsd: /*#__PURE__*/ z.string().nullable(),
    trajectoryScore: /*#__PURE__*/ z.string().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    teamId: /*#__PURE__*/ z.number().nullable()
});

export const zWorkflowRunList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowRunSummary)
});

export const zWorkflowDefinitionTriggerResult = /*#__PURE__*/ z.object({
    run: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.enum(['pending']),
        workflowId: /*#__PURE__*/ z.string()
    })
});

export const zWorkflowVersion = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    workflowDefinitionId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    category: /*#__PURE__*/ z.string().nullable(),
    state: /*#__PURE__*/ z.enum(['draft', 'locked']),
    humanGates: /*#__PURE__*/ z.unknown().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    steps: /*#__PURE__*/ z.unknown().optional(),
    changeSummary: /*#__PURE__*/ z.string().nullish(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zWorkflowVersionList = /*#__PURE__*/ z.object({
    versions: /*#__PURE__*/ z.array(zWorkflowVersion)
});

export const zWorkflowVersionResult = /*#__PURE__*/ z.object({
    version: zWorkflowVersion
});

export const zWorkflowVersionDiffChange = /*#__PURE__*/ z.object({
    stepId: /*#__PURE__*/ z.string(),
    stepName: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.enum([
        'added',
        'removed',
        'modified'
    ]),
    before: /*#__PURE__*/ z.unknown().optional(),
    after: /*#__PURE__*/ z.unknown().optional()
});

export const zWorkflowVersionDiffResult = /*#__PURE__*/ z.object({
    version_a: /*#__PURE__*/ z.number(),
    version_b: /*#__PURE__*/ z.number(),
    changes: /*#__PURE__*/ z.array(zWorkflowVersionDiffChange)
});

export const zWorkflowGraphSave = /*#__PURE__*/ z.object({
    steps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        clientId: /*#__PURE__*/ z.number(),
        diagramPosition: /*#__PURE__*/ z.object({
            x: /*#__PURE__*/ z.number(),
            y: /*#__PURE__*/ z.number()
        }).nullish(),
        name: /*#__PURE__*/ z.string().optional(),
        description: /*#__PURE__*/ z.string().nullish(),
        executionMode: /*#__PURE__*/ z.enum([
            'sequential',
            'parallel',
            'conditional',
            'race'
        ]).nullish(),
        optional: /*#__PURE__*/ z.boolean().optional()
    })),
    edges: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        sourceClientId: /*#__PURE__*/ z.number(),
        targetClientId: /*#__PURE__*/ z.number(),
        kind: /*#__PURE__*/ z.enum(['data', 'control']).optional().default('data'),
        label: /*#__PURE__*/ z.object({
            text: /*#__PURE__*/ z.string()
        }).nullish()
    })),
    version: /*#__PURE__*/ z.number().optional()
});

export const zWorkflowCloseSummary = /*#__PURE__*/ z.object({
    summary: /*#__PURE__*/ z.string().nullable()
});

export const zWorkflowUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.string().optional(),
    schedule: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    humanGates: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    version: /*#__PURE__*/ z.number().optional(),
    steps: /*#__PURE__*/ z.array(zWorkflowStepPayload).optional()
});

export const zWorkflowInstance = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    definitionId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    teamId: /*#__PURE__*/ z.number().nullable(),
    name: /*#__PURE__*/ z.string().nullable(),
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'archived'
    ]),
    status: /*#__PURE__*/ z.string().nullable(),
    triggeredBy: /*#__PURE__*/ z.string().nullable(),
    triggerType: /*#__PURE__*/ z.string().nullable(),
    schedule: /*#__PURE__*/ zWorkflowScheduleConfig.nullable(),
    scheduleEnabled: /*#__PURE__*/ z.boolean(),
    nextRunAt: /*#__PURE__*/ z.string().nullable(),
    lastRunAt: /*#__PURE__*/ z.string().nullable(),
    runCount: /*#__PURE__*/ z.number(),
    consecutiveFailures: /*#__PURE__*/ z.number(),
    blockedUntil: /*#__PURE__*/ z.string().nullable(),
    lastErrorCode: /*#__PURE__*/ z.string().nullable(),
    input: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zWorkflowInstanceList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowInstance)
});

export const zWorkflowInstanceResult = /*#__PURE__*/ z.object({
    instance: zWorkflowInstance
});

export const zWorkflowInstanceCreate = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.int().gt(0),
    name: /*#__PURE__*/ z.string().optional(),
    teamId: /*#__PURE__*/ z.int().gt(0).nullish(),
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'archived'
    ]).optional(),
    schedule: /*#__PURE__*/ zWorkflowScheduleConfig.nullish(),
    scheduleEnabled: /*#__PURE__*/ z.boolean().optional(),
    input: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zWorkflowInstanceUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().optional(),
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'archived'
    ]).optional(),
    schedule: /*#__PURE__*/ zWorkflowScheduleConfig.nullish(),
    scheduleEnabled: /*#__PURE__*/ z.boolean().optional(),
    input: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zWorkflowInstanceTriggerResult = /*#__PURE__*/ z.object({
    run: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        workflowId: /*#__PURE__*/ z.string()
    })
});

export const zWorkflowDefinitionSearchResult = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string().nullable(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    visibility: /*#__PURE__*/ z.string().nullable(),
    installCount: /*#__PURE__*/ z.number().nullable(),
    score: /*#__PURE__*/ z.number(),
    matchType: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ]),
    source: /*#__PURE__*/ z.enum([
        'local',
        'builtin',
        'marketplace'
    ])
});

export const zOrganization = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string(),
    logoUrl: /*#__PURE__*/ z.string().nullable(),
    plan: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    features: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.boolean()),
    modules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    memberCount: /*#__PURE__*/ z.int().gte(0),
    teamCount: /*#__PURE__*/ z.int().gte(0),
    ownerName: /*#__PURE__*/ z.string().nullable(),
    ownerId: /*#__PURE__*/ z.number().nullable()
});

export const zOrganizationCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(2).max(120),
    slug: /*#__PURE__*/ z.string().min(2).max(60).regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]$/),
    plan: /*#__PURE__*/ z.enum([
        'free',
        'standard',
        'enterprise'
    ]).optional().default('free'),
    founderEmail: /*#__PURE__*/ z.email(),
    founderRole: /*#__PURE__*/ z.enum(['org_admin']).optional().default('org_admin')
});

export const zUserOrg = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string(),
    plan: /*#__PURE__*/ z.string().nullable(),
    role: /*#__PURE__*/ z.string(),
    settings: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish()
});

export const zOrganizationUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(120).optional(),
    logoUrl: /*#__PURE__*/ z.url().nullish(),
    plan: /*#__PURE__*/ z.enum([
        'free',
        'standard',
        'enterprise'
    ]).optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'suspended',
        'archived'
    ]).optional(),
    features: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.boolean()).optional(),
    modules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zOrgMemberSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    email: /*#__PURE__*/ z.string(),
    username: /*#__PURE__*/ z.string().nullable(),
    fullName: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string(),
    isActive: /*#__PURE__*/ z.boolean().nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zOrgMember = /*#__PURE__*/ z.object({
    userId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.string().nullish(),
    joinedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).optional()
});

export const zAddMemberBody = /*#__PURE__*/ z.object({
    userId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.string().optional()
});

export const zRegulatoryAckResult = /*#__PURE__*/ z.object({
    ok: /*#__PURE__*/ z.boolean(),
    remainingAcks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.string(),
        documentRef: /*#__PURE__*/ z.string()
    }))
});

export const zRegulatoryAckRequest = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'baa',
        'dpa',
        'fedramp',
        'state_coverage'
    ]),
    documentVersion: /*#__PURE__*/ z.string().min(1).max(100),
    expiresAt: /*#__PURE__*/ z.iso.datetime().optional()
});

export const zTeam = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    brief: /*#__PURE__*/ z.string().nullish(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zUserOrgTeam = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    role: /*#__PURE__*/ z.enum(['lead', 'contributor'])
});

export const zTeamCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1),
    description: /*#__PURE__*/ z.string().optional()
});

export const zTeamMember = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]),
    memberId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.enum(['lead', 'contributor']).nullish(),
    joinedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullish()
});

export const zInvitationCreate = /*#__PURE__*/ z.object({
    email: /*#__PURE__*/ z.email(),
    role: /*#__PURE__*/ z.enum([
        'org_admin',
        'trader',
        'analyst',
        'viewer'
    ]),
    message: /*#__PURE__*/ z.string().max(500).optional()
});

export const zIntelAnalysisTemplate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string().nullable(),
    name: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.enum(['system', 'org']),
    status: /*#__PURE__*/ z.enum(['active', 'disabled']),
    disabledReason: /*#__PURE__*/ z.string().nullable(),
    loggingEnabled: /*#__PURE__*/ z.boolean(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    version: /*#__PURE__*/ z.number(),
    activeVersionId: /*#__PURE__*/ z.number().nullable(),
    extendsId: /*#__PURE__*/ z.number().nullable(),
    goal: /*#__PURE__*/ z.string().nullable(),
    backstory: /*#__PURE__*/ z.string().nullable(),
    instructions: /*#__PURE__*/ z.string().nullable(),
    constraints: /*#__PURE__*/ z.string().nullable(),
    variables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string(),
        default: /*#__PURE__*/ z.string().optional()
    })).nullable(),
    permissionTier: /*#__PURE__*/ z.string().nullable(),
    spawnPolicy: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string(),
        min: /*#__PURE__*/ z.number().optional(),
        max: /*#__PURE__*/ z.number().optional()
    }).nullable(),
    taskProfile: /*#__PURE__*/ z.object({
        primaryCapability: /*#__PURE__*/ z.enum([
            'reasoning',
            'vision',
            'fast',
            'code',
            'long-context'
        ]),
        secondaryCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
            'reasoning',
            'vision',
            'fast',
            'code',
            'long-context'
        ])),
        latencyClass: /*#__PURE__*/ z.enum([
            'realtime',
            'interactive',
            'batch'
        ]),
        requiresToolCalling: /*#__PURE__*/ z.boolean(),
        requiresVision: /*#__PURE__*/ z.boolean(),
        preferredCost: /*#__PURE__*/ z.enum([
            'free',
            'low',
            'medium',
            'high'
        ]),
        minContextWindow: /*#__PURE__*/ z.number(),
        requiresStructuredOutput: /*#__PURE__*/ z.boolean()
    }).nullable(),
    disableModelInvocation: /*#__PURE__*/ z.boolean().nullable(),
    routingRules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        match: /*#__PURE__*/ z.string(),
        targetTemplate: /*#__PURE__*/ z.string(),
        context: /*#__PURE__*/ z.string().optional()
    })).nullable(),
    maxToolIterations: /*#__PURE__*/ z.number().nullable(),
    defaultSubscriptions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    heartbeatConfig: /*#__PURE__*/ z.object({
        every_n_calls: /*#__PURE__*/ z.number().optional(),
        every_t_seconds: /*#__PURE__*/ z.number().optional()
    }).nullable(),
    departmentId: /*#__PURE__*/ z.string().nullable(),
    platform: /*#__PURE__*/ z.enum([
        'twitter',
        'youtube',
        'substack',
        'podcast',
        'telegram',
        'discord',
        'tradingview',
        'reddit',
        'medium',
        'wallet',
        'smart_money',
        'exchange_wallet',
        'dao_treasury',
        'lending',
        'dex',
        'perp_dex',
        'options',
        'yield_aggregator',
        'governance',
        'etf',
        'hedge_fund',
        'market_maker',
        'vc',
        'research_firm',
        'analytics',
        'data_aggregator',
        'cex',
        'prediction_market',
        'news_wire',
        'rss'
    ]).nullable(),
    category: /*#__PURE__*/ z.enum([
        'social',
        'on_chain',
        'institutional',
        'research',
        'defi',
        'market_infra'
    ]).nullable(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    source: /*#__PURE__*/ z.string().nullable(),
    sourceRepoUrl: /*#__PURE__*/ z.string().nullable(),
    sourceFilePath: /*#__PURE__*/ z.string().nullable(),
    autoUpgrade: /*#__PURE__*/ z.boolean(),
    embedding: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).nullable()
});

export const zIntelAnalysisTemplateList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelAnalysisTemplate)
});

export const zIntelAnalysisTemplateCreate = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().min(1).max(50),
    category: /*#__PURE__*/ z.string().min(1).max(50),
    name: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().optional(),
    promptTemplate: /*#__PURE__*/ z.string().min(1),
    suggestedRoleId: /*#__PURE__*/ z.string().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zIntelAnalysisTemplateUpdate = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().min(1).max(50).optional(),
    category: /*#__PURE__*/ z.string().min(1).max(50).optional(),
    name: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    description: /*#__PURE__*/ z.string().optional(),
    promptTemplate: /*#__PURE__*/ z.string().min(1).optional(),
    suggestedRoleId: /*#__PURE__*/ z.string().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zIntelAnalysisTemplateActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zIntelPlatform = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    category: /*#__PURE__*/ z.enum([
        'social',
        'on_chain',
        'institutional',
        'research',
        'defi',
        'market_infra'
    ]),
    config: /*#__PURE__*/ z.object({
        api_key_env: /*#__PURE__*/ z.string().optional(),
        rate_limit_per_minute: /*#__PURE__*/ z.number().optional(),
        rate_limit_per_day: /*#__PURE__*/ z.number().optional(),
        batch_size: /*#__PURE__*/ z.number().optional(),
        requires_auth: /*#__PURE__*/ z.boolean().optional(),
        base_url: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    icon: /*#__PURE__*/ z.string().nullable(),
    enabled: /*#__PURE__*/ z.boolean(),
    harvestSchedule: /*#__PURE__*/ z.string().nullable(),
    defaultLookbackDays: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zIntelPlatformList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelPlatform)
});

export const zIntelPlatformCreate = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string().min(1).max(50),
    name: /*#__PURE__*/ z.string().min(1).max(100),
    category: /*#__PURE__*/ z.enum([
        'social',
        'on_chain',
        'defi',
        'institutional',
        'research',
        'market_infra'
    ]),
    config: /*#__PURE__*/ z.object({
        api_key_env: /*#__PURE__*/ z.string().optional(),
        rate_limit_per_minute: /*#__PURE__*/ z.number().optional(),
        rate_limit_per_day: /*#__PURE__*/ z.number().optional(),
        batch_size: /*#__PURE__*/ z.number().optional(),
        requires_auth: /*#__PURE__*/ z.boolean().optional(),
        base_url: /*#__PURE__*/ z.string().optional()
    }).optional(),
    description: /*#__PURE__*/ z.string().optional()
});

export const zIntelPlatformTestResult = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'connected',
        'partial',
        'disconnected'
    ]),
    hasApiKey: /*#__PURE__*/ z.boolean(),
    apiKeyEnv: /*#__PURE__*/ z.string().nullable(),
    fetcherAvailable: /*#__PURE__*/ z.boolean()
});

export const zIntelPlatformUsageResult = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string(),
    dailyQuota: /*#__PURE__*/ z.number().nullable(),
    rateLimitPerMinute: /*#__PURE__*/ z.number().nullable(),
    usage: /*#__PURE__*/ z.object({
        daily_used: /*#__PURE__*/ z.number(),
        minute_used: /*#__PURE__*/ z.number()
    })
});

export const zIntelPlatformUpdate = /*#__PURE__*/ z.object({
    config: /*#__PURE__*/ z.object({
        api_key_env: /*#__PURE__*/ z.string().optional(),
        rate_limit_per_minute: /*#__PURE__*/ z.number().optional(),
        rate_limit_per_day: /*#__PURE__*/ z.number().optional(),
        batch_size: /*#__PURE__*/ z.number().optional(),
        requires_auth: /*#__PURE__*/ z.boolean().optional(),
        base_url: /*#__PURE__*/ z.string().optional()
    }).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    harvestSchedule: /*#__PURE__*/ z.string().optional(),
    defaultLookbackDays: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zIntelSource = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    platform: /*#__PURE__*/ z.string(),
    handle: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.enum([
        'social',
        'on_chain',
        'institutional',
        'research',
        'defi',
        'market_infra'
    ]),
    active: /*#__PURE__*/ z.boolean(),
    externalId: /*#__PURE__*/ z.string().nullable(),
    chain: /*#__PURE__*/ z.string().nullable(),
    profileUrl: /*#__PURE__*/ z.string().nullable(),
    avatarUrl: /*#__PURE__*/ z.string().nullable(),
    dataSourceUrl: /*#__PURE__*/ z.string().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    private: /*#__PURE__*/ z.boolean(),
    typeMetadata: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['social']),
            channel_id: /*#__PURE__*/ z.string().optional(),
            uploads_playlist_id: /*#__PURE__*/ z.string().optional(),
            subscriber_count: /*#__PURE__*/ z.number().optional(),
            video_count: /*#__PURE__*/ z.number().optional(),
            avg_views: /*#__PURE__*/ z.number().optional(),
            country: /*#__PURE__*/ z.string().optional(),
            topics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            verified: /*#__PURE__*/ z.boolean().optional(),
            bio: /*#__PURE__*/ z.string().optional(),
            karma: /*#__PURE__*/ z.number().optional(),
            subreddit: /*#__PURE__*/ z.string().optional(),
            member_count: /*#__PURE__*/ z.number().optional(),
            reputation: /*#__PURE__*/ z.number().optional(),
            ideas_count: /*#__PURE__*/ z.number().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['on_chain']),
            address: /*#__PURE__*/ z.string(),
            chain: /*#__PURE__*/ z.string(),
            label: /*#__PURE__*/ z.string().optional(),
            tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            estimated_balance_usd: /*#__PURE__*/ z.number().optional(),
            tx_count: /*#__PURE__*/ z.number().optional(),
            first_seen_at: /*#__PURE__*/ z.string().optional(),
            last_tx_at: /*#__PURE__*/ z.string().optional(),
            tracked_tokens: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            pnl_usd: /*#__PURE__*/ z.number().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['institutional']),
            legal_name: /*#__PURE__*/ z.string().optional(),
            ticker: /*#__PURE__*/ z.string().optional(),
            aum_usd: /*#__PURE__*/ z.number().optional(),
            headquarters: /*#__PURE__*/ z.string().optional(),
            sec_cik: /*#__PURE__*/ z.string().optional(),
            filing_type: /*#__PURE__*/ z.string().optional(),
            fund_type: /*#__PURE__*/ z.string().optional(),
            known_wallets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            inception_date: /*#__PURE__*/ z.string().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['research']),
            specialization: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            data_products: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            api_endpoint: /*#__PURE__*/ z.string().optional(),
            report_frequency: /*#__PURE__*/ z.string().optional(),
            free_tier: /*#__PURE__*/ z.boolean().optional(),
            coverage: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['defi']),
            protocol_name: /*#__PURE__*/ z.string(),
            tvl_usd: /*#__PURE__*/ z.number().optional(),
            contract_addresses: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional(),
            governance_token: /*#__PURE__*/ z.string().optional(),
            launch_date: /*#__PURE__*/ z.string().optional(),
            audited: /*#__PURE__*/ z.boolean().optional(),
            supported_chains: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['market_infra']),
            exchange_name: /*#__PURE__*/ z.string().optional(),
            market_type: /*#__PURE__*/ z.string().optional(),
            api_endpoint: /*#__PURE__*/ z.string().optional(),
            supported_assets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            data_types: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        })
    ]).nullable(),
    discoveredAt: /*#__PURE__*/ z.string(),
    discoveredVia: /*#__PURE__*/ z.number().nullable(),
    discoveryDepth: /*#__PURE__*/ z.number().nullable(),
    followerCount: /*#__PURE__*/ z.number().nullable(),
    followingCount: /*#__PURE__*/ z.number().nullable(),
    postCount: /*#__PURE__*/ z.number().nullable(),
    engagementRate: /*#__PURE__*/ z.string().nullable(),
    influenceScore: /*#__PURE__*/ z.string().nullable(),
    signalQuality: /*#__PURE__*/ z.string().nullable(),
    contentDepth: /*#__PURE__*/ z.string().nullable(),
    botProbability: /*#__PURE__*/ z.string().nullable(),
    overallScore: /*#__PURE__*/ z.string().nullable(),
    primaryTopics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    totalSignals: /*#__PURE__*/ z.number().nullable(),
    correctSignals: /*#__PURE__*/ z.number().nullable(),
    totalContentHarvested: /*#__PURE__*/ z.number().nullable(),
    totalStrategiesExtracted: /*#__PURE__*/ z.number().nullable(),
    strategiesApproved: /*#__PURE__*/ z.number().nullable(),
    approvalStatus: /*#__PURE__*/ z.enum([
        'seeded',
        'approved',
        'candidate',
        'rejected'
    ]),
    seed: /*#__PURE__*/ z.boolean(),
    lastContentAt: /*#__PURE__*/ z.string().nullable(),
    lastAnalyzedAt: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    consent: /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum([
            'none',
            'creator_licence',
            'platform_permission'
        ]),
        reference: /*#__PURE__*/ z.string().nullable(),
        recordedBy: /*#__PURE__*/ z.number().nullable(),
        recordedAt: /*#__PURE__*/ z.string(),
        line: /*#__PURE__*/ z.string()
    }).nullish(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zIntelSourceDiscoverRequest = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().min(1),
    url: /*#__PURE__*/ z.string().optional(),
    handle: /*#__PURE__*/ z.string().optional()
});

export const zIntelSourceError = /*#__PURE__*/ z.object({
    error: /*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.string(),
        message: /*#__PURE__*/ z.string()
    })
});

export const zIntelSourceCreate = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().min(1),
    handle: /*#__PURE__*/ z.string().min(1),
    name: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.enum([
        'social',
        'on_chain',
        'institutional',
        'research',
        'defi',
        'market_infra'
    ]).optional(),
    externalId: /*#__PURE__*/ z.string().optional(),
    chain: /*#__PURE__*/ z.string().optional(),
    typeMetadata: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['social']),
            channel_id: /*#__PURE__*/ z.string().optional(),
            uploads_playlist_id: /*#__PURE__*/ z.string().optional(),
            subscriber_count: /*#__PURE__*/ z.number().optional(),
            video_count: /*#__PURE__*/ z.number().optional(),
            avg_views: /*#__PURE__*/ z.number().optional(),
            country: /*#__PURE__*/ z.string().optional(),
            topics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            verified: /*#__PURE__*/ z.boolean().optional(),
            bio: /*#__PURE__*/ z.string().optional(),
            karma: /*#__PURE__*/ z.number().optional(),
            subreddit: /*#__PURE__*/ z.string().optional(),
            member_count: /*#__PURE__*/ z.number().optional(),
            reputation: /*#__PURE__*/ z.number().optional(),
            ideas_count: /*#__PURE__*/ z.number().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['on_chain']),
            address: /*#__PURE__*/ z.string(),
            chain: /*#__PURE__*/ z.string(),
            label: /*#__PURE__*/ z.string().optional(),
            tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            estimated_balance_usd: /*#__PURE__*/ z.number().optional(),
            tx_count: /*#__PURE__*/ z.number().optional(),
            first_seen_at: /*#__PURE__*/ z.string().optional(),
            last_tx_at: /*#__PURE__*/ z.string().optional(),
            tracked_tokens: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            pnl_usd: /*#__PURE__*/ z.number().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['institutional']),
            legal_name: /*#__PURE__*/ z.string().optional(),
            ticker: /*#__PURE__*/ z.string().optional(),
            aum_usd: /*#__PURE__*/ z.number().optional(),
            headquarters: /*#__PURE__*/ z.string().optional(),
            sec_cik: /*#__PURE__*/ z.string().optional(),
            filing_type: /*#__PURE__*/ z.string().optional(),
            fund_type: /*#__PURE__*/ z.string().optional(),
            known_wallets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            inception_date: /*#__PURE__*/ z.string().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['research']),
            specialization: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            data_products: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            api_endpoint: /*#__PURE__*/ z.string().optional(),
            report_frequency: /*#__PURE__*/ z.string().optional(),
            free_tier: /*#__PURE__*/ z.boolean().optional(),
            coverage: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['defi']),
            protocol_name: /*#__PURE__*/ z.string(),
            tvl_usd: /*#__PURE__*/ z.number().optional(),
            contract_addresses: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional(),
            governance_token: /*#__PURE__*/ z.string().optional(),
            launch_date: /*#__PURE__*/ z.string().optional(),
            audited: /*#__PURE__*/ z.boolean().optional(),
            supported_chains: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['market_infra']),
            exchange_name: /*#__PURE__*/ z.string().optional(),
            market_type: /*#__PURE__*/ z.string().optional(),
            api_endpoint: /*#__PURE__*/ z.string().optional(),
            supported_assets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            data_types: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        })
    ]).optional(),
    profileUrl: /*#__PURE__*/ z.string().optional(),
    avatarUrl: /*#__PURE__*/ z.string().optional()
});

export const zIntelSourceBatchFetchResult = /*#__PURE__*/ z.object({
    queued: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        intelSourceId: /*#__PURE__*/ z.number(),
        requestId: /*#__PURE__*/ z.string()
    })),
    skipped: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        intelSourceId: /*#__PURE__*/ z.number(),
        reason: /*#__PURE__*/ z.string()
    }))
});

export const zIntelSourceBatchFetchRequest = /*#__PURE__*/ z.object({
    ids: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).min(1).max(100)
});

export const zIntelSourceUpdate = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().min(1).optional(),
    handle: /*#__PURE__*/ z.string().min(1).optional(),
    name: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.enum([
        'social',
        'on_chain',
        'institutional',
        'research',
        'defi',
        'market_infra'
    ]).optional(),
    externalId: /*#__PURE__*/ z.string().optional(),
    chain: /*#__PURE__*/ z.string().optional(),
    typeMetadata: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['social']),
            channel_id: /*#__PURE__*/ z.string().optional(),
            uploads_playlist_id: /*#__PURE__*/ z.string().optional(),
            subscriber_count: /*#__PURE__*/ z.number().optional(),
            video_count: /*#__PURE__*/ z.number().optional(),
            avg_views: /*#__PURE__*/ z.number().optional(),
            country: /*#__PURE__*/ z.string().optional(),
            topics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            verified: /*#__PURE__*/ z.boolean().optional(),
            bio: /*#__PURE__*/ z.string().optional(),
            karma: /*#__PURE__*/ z.number().optional(),
            subreddit: /*#__PURE__*/ z.string().optional(),
            member_count: /*#__PURE__*/ z.number().optional(),
            reputation: /*#__PURE__*/ z.number().optional(),
            ideas_count: /*#__PURE__*/ z.number().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['on_chain']),
            address: /*#__PURE__*/ z.string(),
            chain: /*#__PURE__*/ z.string(),
            label: /*#__PURE__*/ z.string().optional(),
            tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            estimated_balance_usd: /*#__PURE__*/ z.number().optional(),
            tx_count: /*#__PURE__*/ z.number().optional(),
            first_seen_at: /*#__PURE__*/ z.string().optional(),
            last_tx_at: /*#__PURE__*/ z.string().optional(),
            tracked_tokens: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            pnl_usd: /*#__PURE__*/ z.number().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['institutional']),
            legal_name: /*#__PURE__*/ z.string().optional(),
            ticker: /*#__PURE__*/ z.string().optional(),
            aum_usd: /*#__PURE__*/ z.number().optional(),
            headquarters: /*#__PURE__*/ z.string().optional(),
            sec_cik: /*#__PURE__*/ z.string().optional(),
            filing_type: /*#__PURE__*/ z.string().optional(),
            fund_type: /*#__PURE__*/ z.string().optional(),
            known_wallets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            inception_date: /*#__PURE__*/ z.string().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['research']),
            specialization: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            data_products: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            api_endpoint: /*#__PURE__*/ z.string().optional(),
            report_frequency: /*#__PURE__*/ z.string().optional(),
            free_tier: /*#__PURE__*/ z.boolean().optional(),
            coverage: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['defi']),
            protocol_name: /*#__PURE__*/ z.string(),
            tvl_usd: /*#__PURE__*/ z.number().optional(),
            contract_addresses: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional(),
            governance_token: /*#__PURE__*/ z.string().optional(),
            launch_date: /*#__PURE__*/ z.string().optional(),
            audited: /*#__PURE__*/ z.boolean().optional(),
            supported_chains: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['market_infra']),
            exchange_name: /*#__PURE__*/ z.string().optional(),
            market_type: /*#__PURE__*/ z.string().optional(),
            api_endpoint: /*#__PURE__*/ z.string().optional(),
            supported_assets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
            data_types: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
        })
    ]).optional(),
    profileUrl: /*#__PURE__*/ z.string().optional(),
    avatarUrl: /*#__PURE__*/ z.string().optional(),
    active: /*#__PURE__*/ z.boolean().optional()
});

export const zIntelSourceSubscriptionEnqueueResult = /*#__PURE__*/ z.object({
    queued: /*#__PURE__*/ z.literal(true),
    requestId: /*#__PURE__*/ z.string()
});

export const zIntelSourceFetchRequest = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).optional(),
    since: /*#__PURE__*/ z.string().optional()
});

export const zIntelSourceData = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    intelSourceId: /*#__PURE__*/ z.number(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    dataType: /*#__PURE__*/ z.enum([
        'content',
        'event',
        'metric',
        'signal_raw'
    ]),
    platform: /*#__PURE__*/ z.string(),
    asset: /*#__PURE__*/ z.string().nullable(),
    occurredAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    title: /*#__PURE__*/ z.string().nullable(),
    body: /*#__PURE__*/ z.string().nullable(),
    payload: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['content']),
            transcript_segments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                text: /*#__PURE__*/ z.string(),
                start: /*#__PURE__*/ z.number(),
                end: /*#__PURE__*/ z.number()
            })).optional(),
            chart_images: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                url: /*#__PURE__*/ z.string(),
                analyzed: /*#__PURE__*/ z.boolean().optional()
            })).optional(),
            duration_seconds: /*#__PURE__*/ z.number().optional(),
            media_analysis: /*#__PURE__*/ z.object({
                status: /*#__PURE__*/ z.enum([
                    'completed',
                    'retrying',
                    'fell_back_to_excerpt'
                ]),
                attempts: /*#__PURE__*/ z.int().gte(0).optional(),
                model: /*#__PURE__*/ z.string().optional(),
                framesUsed: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).optional(),
                reportArtifactId: /*#__PURE__*/ z.number().optional(),
                analysisTemplateId: /*#__PURE__*/ z.number().nullish(),
                analyzedAt: /*#__PURE__*/ z.string().optional(),
                errorCode: /*#__PURE__*/ z.string().optional(),
                errorMessage: /*#__PURE__*/ z.string().optional(),
                failedAt: /*#__PURE__*/ z.string().optional()
            }).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['event']),
            tx_hash: /*#__PURE__*/ z.string().optional(),
            from: /*#__PURE__*/ z.string().optional(),
            to: /*#__PURE__*/ z.string().optional(),
            value_usd: /*#__PURE__*/ z.number().optional(),
            token_symbol: /*#__PURE__*/ z.string().optional(),
            method_id: /*#__PURE__*/ z.string().optional(),
            function_name: /*#__PURE__*/ z.string().optional(),
            chain: /*#__PURE__*/ z.string().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['metric']),
            metric_name: /*#__PURE__*/ z.string(),
            value: /*#__PURE__*/ z.number(),
            previous_value: /*#__PURE__*/ z.number().optional(),
            change_pct: /*#__PURE__*/ z.number().optional(),
            protocol: /*#__PURE__*/ z.string().optional(),
            chain: /*#__PURE__*/ z.string().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['signal_raw']),
            direction: /*#__PURE__*/ z.string().optional(),
            target_price: /*#__PURE__*/ z.number().optional(),
            stop_price: /*#__PURE__*/ z.number().optional(),
            timeframe: /*#__PURE__*/ z.string().optional()
        })
    ]),
    sourceUrl: /*#__PURE__*/ z.string().nullable(),
    externalId: /*#__PURE__*/ z.string().nullable(),
    contentHash: /*#__PURE__*/ z.string().nullable(),
    provenance: /*#__PURE__*/ z.object({
        fetchRunId: /*#__PURE__*/ z.number().optional(),
        workerId: /*#__PURE__*/ z.string(),
        capability: /*#__PURE__*/ z.string(),
        tool: /*#__PURE__*/ z.enum([
            'youtube_api',
            'youtube_rss',
            'innertube_timedtext',
            'ytdlp_subs',
            'ytdlp_media_stt',
            'ytdlp_metadata',
            'x_api',
            'rss_feed',
            'discord_bot',
            'web_page',
            'github_api',
            'ytdlp_search',
            'legacy_server_fetcher',
            'content_harvester'
        ]),
        fetchedAt: /*#__PURE__*/ z.string(),
        metadataTool: /*#__PURE__*/ z.enum(['youtube_api', 'ytdlp_metadata']).optional(),
        egressIdentity: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    transcriptLanguage: /*#__PURE__*/ z.string().nullable(),
    transcriptKind: /*#__PURE__*/ z.enum(['manual', 'auto']).nullable(),
    transcriptSource: /*#__PURE__*/ z.enum([
        'timedtext',
        'package',
        'ytdlp',
        'stt'
    ]).nullable(),
    engagement: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).nullable(),
    sentiment: /*#__PURE__*/ z.enum([
        'bullish',
        'bearish',
        'neutral'
    ]).nullable(),
    confidence: /*#__PURE__*/ z.string().nullable(),
    mentionedAssets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    mentionedIndicators: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    embedding: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).nullable(),
    processed: /*#__PURE__*/ z.boolean(),
    processingStatus: /*#__PURE__*/ z.enum([
        'pending',
        'harvested',
        'extracting',
        'extracted',
        'completed',
        'failed',
        'actionable',
        'explored',
        'dismissed',
        'style_extracted',
        'style_skipped'
    ]),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zIntelSourceSubscription = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    intelSourceId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'pending_approval',
        'archived'
    ]),
    cadence: /*#__PURE__*/ z.string(),
    nextDueAt: /*#__PURE__*/ z.string().nullable(),
    priority: /*#__PURE__*/ z.number(),
    consecutiveFailures: /*#__PURE__*/ z.number(),
    blockedUntil: /*#__PURE__*/ z.string().nullable(),
    lastErrorCode: /*#__PURE__*/ z.string().nullable(),
    transcriptEnabled: /*#__PURE__*/ z.boolean(),
    expansionEnabled: /*#__PURE__*/ z.boolean(),
    maxDepth: /*#__PURE__*/ z.number(),
    autoFollow: /*#__PURE__*/ z.boolean(),
    rawCaptureEnabled: /*#__PURE__*/ z.boolean(),
    dailyQuotaBudget: /*#__PURE__*/ z.number().nullable(),
    monthlyReadBudget: /*#__PURE__*/ z.number().nullable(),
    readsSpentMonth: /*#__PURE__*/ z.number(),
    lastRunAt: /*#__PURE__*/ z.string().nullable(),
    requestedByUserId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zIntelSourceSubscriptionCreate = /*#__PURE__*/ z.object({
    cadence: /*#__PURE__*/ z.enum([
        '@hourly',
        '@4h',
        '@daily',
        '@weekly'
    ]).optional(),
    transcriptEnabled: /*#__PURE__*/ z.boolean().optional(),
    expansionEnabled: /*#__PURE__*/ z.boolean().optional(),
    maxDepth: /*#__PURE__*/ z.int().gte(1).lte(5).optional(),
    autoFollow: /*#__PURE__*/ z.boolean().optional(),
    priority: /*#__PURE__*/ z.int().gte(0).lte(100).optional(),
    rawCaptureEnabled: /*#__PURE__*/ z.boolean().optional(),
    dailyQuotaBudget: /*#__PURE__*/ z.int().gt(0).nullish(),
    monthlyReadBudget: /*#__PURE__*/ z.int().gt(0).nullish()
});

export const zIntelSourceApprovalResult = /*#__PURE__*/ z.object({
    source: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        approvalStatus: /*#__PURE__*/ z.enum([
            'seeded',
            'approved',
            'candidate',
            'rejected'
        ]),
        platform: /*#__PURE__*/ z.string(),
        handle: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string().nullable()
    }),
    workflowInstanceId: /*#__PURE__*/ z.number().nullable()
});

export const zIntelSourceApprovalRequest = /*#__PURE__*/ z.object({
    action: /*#__PURE__*/ z.enum(['approve', 'reject']),
    createMonitor: /*#__PURE__*/ z.boolean().optional().default(true),
    cadence: /*#__PURE__*/ z.enum([
        '@hourly',
        '@4h',
        '@daily',
        '@weekly'
    ]).optional().default('@daily'),
    transcriptEnabled: /*#__PURE__*/ z.boolean().optional().default(false)
});

export const zIntelSourceConsent = /*#__PURE__*/ z.object({
    intelSourceId: /*#__PURE__*/ z.number(),
    consent: /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum([
            'none',
            'creator_licence',
            'platform_permission'
        ]),
        reference: /*#__PURE__*/ z.string().nullable(),
        recordedBy: /*#__PURE__*/ z.number().nullable(),
        recordedAt: /*#__PURE__*/ z.string()
    }),
    line: /*#__PURE__*/ z.string()
});

export const zIntelSourceConsentRequest = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'none',
        'creator_licence',
        'platform_permission'
    ]),
    reference: /*#__PURE__*/ z.string().max(500).nullish()
});

export const zIntelSourceMonitor = /*#__PURE__*/ z.object({
    workflowInstanceId: /*#__PURE__*/ z.number(),
    workflowDefinitionId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    intelSourceId: /*#__PURE__*/ z.number(),
    source: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        handle: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string().nullable(),
        platform: /*#__PURE__*/ z.string(),
        avatarUrl: /*#__PURE__*/ z.string().nullable()
    }).nullable(),
    name: /*#__PURE__*/ z.string().nullable(),
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'archived'
    ]),
    scheduleEnabled: /*#__PURE__*/ z.boolean(),
    cadence: /*#__PURE__*/ z.string(),
    nextRunAt: /*#__PURE__*/ z.string().nullable(),
    lastRunAt: /*#__PURE__*/ z.string().nullable(),
    runCount: /*#__PURE__*/ z.number(),
    consecutiveFailures: /*#__PURE__*/ z.number(),
    blockedUntil: /*#__PURE__*/ z.string().nullable(),
    lastErrorCode: /*#__PURE__*/ z.string().nullable(),
    transcriptEnabled: /*#__PURE__*/ z.boolean(),
    rawCaptureEnabled: /*#__PURE__*/ z.boolean(),
    expansionEnabled: /*#__PURE__*/ z.boolean(),
    maxDepth: /*#__PURE__*/ z.number(),
    maxNewSourcesPerRun: /*#__PURE__*/ z.number(),
    autoFollow: /*#__PURE__*/ z.boolean(),
    mediaEnabled: /*#__PURE__*/ z.boolean(),
    analysisTemplateId: /*#__PURE__*/ z.number().nullable(),
    mediaCapable: /*#__PURE__*/ z.boolean(),
    latestRunId: /*#__PURE__*/ z.number().nullable(),
    dailyQuotaBudget: /*#__PURE__*/ z.number().nullable(),
    monthlyReadBudget: /*#__PURE__*/ z.number().nullable(),
    requestedByUserId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zIntelSourceMonitorCreate = /*#__PURE__*/ z.object({
    cadence: /*#__PURE__*/ z.string().optional(),
    transcriptEnabled: /*#__PURE__*/ z.boolean().optional(),
    expansionEnabled: /*#__PURE__*/ z.boolean().optional(),
    maxDepth: /*#__PURE__*/ z.int().gte(0).optional(),
    maxNewSourcesPerRun: /*#__PURE__*/ z.int().gte(0).optional(),
    autoFollow: /*#__PURE__*/ z.boolean().optional(),
    rawCaptureEnabled: /*#__PURE__*/ z.boolean().optional(),
    mediaEnabled: /*#__PURE__*/ z.boolean().optional(),
    analysisTemplateId: /*#__PURE__*/ z.int().gt(0).nullish(),
    dailyQuotaBudget: /*#__PURE__*/ z.int().gte(1).nullish(),
    monthlyReadBudget: /*#__PURE__*/ z.int().gte(1).nullish(),
    name: /*#__PURE__*/ z.string().optional()
});

export const zIntelSourceItemInsight = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    contentId: /*#__PURE__*/ z.number(),
    intelSourceId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.string(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    status: /*#__PURE__*/ z.string(),
    routedArtifactType: /*#__PURE__*/ z.string().nullable(),
    routedArtifactId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.string()
});

export const zIntelSourceSubscriptionWithSource = /*#__PURE__*/ zIntelSourceSubscription.and(/*#__PURE__*/ z.object({
    source: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        handle: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string().nullable(),
        platform: /*#__PURE__*/ z.string(),
        avatarUrl: /*#__PURE__*/ z.string().nullable()
    })
}));

export const zIntelSourceSubscriptionUpdate = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'archived'
    ]).optional(),
    cadence: /*#__PURE__*/ z.enum([
        '@hourly',
        '@4h',
        '@daily',
        '@weekly'
    ]).optional(),
    transcriptEnabled: /*#__PURE__*/ z.boolean().optional(),
    expansionEnabled: /*#__PURE__*/ z.boolean().optional(),
    maxDepth: /*#__PURE__*/ z.int().gte(1).lte(5).optional(),
    autoFollow: /*#__PURE__*/ z.boolean().optional(),
    priority: /*#__PURE__*/ z.int().gte(0).lte(100).optional(),
    rawCaptureEnabled: /*#__PURE__*/ z.boolean().optional(),
    dailyQuotaBudget: /*#__PURE__*/ z.int().gt(0).nullish(),
    monthlyReadBudget: /*#__PURE__*/ z.int().gt(0).nullish()
});

export const zIntelSourceFetchRun = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    subscriptionId: /*#__PURE__*/ z.number().nullable(),
    intelSourceId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    workflowInstanceId: /*#__PURE__*/ z.number().nullable(),
    workflowDefinitionId: /*#__PURE__*/ z.number().nullable(),
    trigger: /*#__PURE__*/ z.enum([
        'schedule',
        'manual',
        'backfill',
        'graph_expansion'
    ]),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'dispatched',
        'running',
        'succeeded',
        'partial',
        'failed',
        'cancelled',
        'skipped'
    ]),
    requestId: /*#__PURE__*/ z.string().nullable(),
    itemsListed: /*#__PURE__*/ z.number(),
    itemsNew: /*#__PURE__*/ z.number(),
    itemsDuplicate: /*#__PURE__*/ z.number(),
    transcriptsFetched: /*#__PURE__*/ z.number(),
    quotaUnitsUsed: /*#__PURE__*/ z.number(),
    errorCode: /*#__PURE__*/ z.string().nullable(),
    errorDetail: /*#__PURE__*/ z.string().nullable(),
    startedAt: /*#__PURE__*/ z.string().nullable(),
    finishedAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zIntelSourceMonitorUpdate = /*#__PURE__*/ z.object({
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'archived'
    ]).optional(),
    scheduleEnabled: /*#__PURE__*/ z.boolean().optional(),
    cadence: /*#__PURE__*/ z.string().optional(),
    transcriptEnabled: /*#__PURE__*/ z.boolean().optional(),
    expansionEnabled: /*#__PURE__*/ z.boolean().optional(),
    maxDepth: /*#__PURE__*/ z.int().gte(0).optional(),
    maxNewSourcesPerRun: /*#__PURE__*/ z.int().gte(0).optional(),
    autoFollow: /*#__PURE__*/ z.boolean().optional(),
    rawCaptureEnabled: /*#__PURE__*/ z.boolean().optional(),
    mediaEnabled: /*#__PURE__*/ z.boolean().optional(),
    analysisTemplateId: /*#__PURE__*/ z.int().gt(0).nullish(),
    dailyQuotaBudget: /*#__PURE__*/ z.int().gte(1).nullish(),
    monthlyReadBudget: /*#__PURE__*/ z.int().gte(1).nullish()
});

export const zIntelSourceMonitorFetchResult = /*#__PURE__*/ z.object({
    triggered: /*#__PURE__*/ z.literal(true),
    requestId: /*#__PURE__*/ z.string(),
    workflowId: /*#__PURE__*/ z.string()
});

export const zDashboard = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    ownerType: /*#__PURE__*/ z.enum([
        'user',
        'team',
        'org',
        'system'
    ]),
    ownerId: /*#__PURE__*/ z.number(),
    createdBy: /*#__PURE__*/ z.number(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    moduleId: /*#__PURE__*/ z.string(),
    createdByAgent: /*#__PURE__*/ z.boolean(),
    sourceConversationId: /*#__PURE__*/ z.number().nullable(),
    pinned: /*#__PURE__*/ z.boolean().optional()
});

export const zDashboardCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1),
    description: /*#__PURE__*/ z.string().nullish(),
    ownerType: /*#__PURE__*/ z.enum([
        'user',
        'team',
        'org'
    ]).optional(),
    ownerId: /*#__PURE__*/ z.number().optional()
});

export const zWidgetDefinition = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    defaultConfig: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    isSystem: /*#__PURE__*/ z.boolean()
});

export const zDashboardWidget = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    dashboardId: /*#__PURE__*/ z.number(),
    widgetDefinitionId: /*#__PURE__*/ z.number(),
    position: /*#__PURE__*/ z.number(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    definition: /*#__PURE__*/ zWidgetDefinition.optional()
});

export const zDashboardWithWidgets = /*#__PURE__*/ zDashboard.and(/*#__PURE__*/ z.object({
    widgets: /*#__PURE__*/ z.array(zDashboardWidget)
}));

export const zDashboardUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).optional(),
    description: /*#__PURE__*/ z.string().nullish()
});

export const zWidgetAdd = /*#__PURE__*/ z.object({
    widgetDefinitionId: /*#__PURE__*/ z.number(),
    position: /*#__PURE__*/ z.number(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish()
});

export const zWidgetReorder = /*#__PURE__*/ z.object({
    widgets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        position: /*#__PURE__*/ z.number()
    })).min(1)
});

export const zWidgetUpdate = /*#__PURE__*/ z.object({
    position: /*#__PURE__*/ z.number().optional(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish()
});

export const zDashboardPinState = /*#__PURE__*/ z.object({
    dashboardId: /*#__PURE__*/ z.number(),
    pinned: /*#__PURE__*/ z.boolean()
});

export const zMcpConnection = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    transport: /*#__PURE__*/ z.enum([
        'stdio',
        'sse',
        'http'
    ]),
    command: /*#__PURE__*/ z.string().nullable(),
    serverUrl: /*#__PURE__*/ z.string().nullable(),
    enabled: /*#__PURE__*/ z.boolean(),
    autoConnect: /*#__PURE__*/ z.boolean(),
    toolPrefix: /*#__PURE__*/ z.string().nullable(),
    permissionLevel: /*#__PURE__*/ z.string().nullable(),
    maxCallsPerMinute: /*#__PURE__*/ z.number().nullable(),
    timeoutMs: /*#__PURE__*/ z.number().nullable(),
    trusted: /*#__PURE__*/ z.boolean(),
    trustStatus: /*#__PURE__*/ z.string(),
    toolListHash: /*#__PURE__*/ z.string().nullable(),
    toolListSnapshot: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).nullable(),
    toolListChangedAt: /*#__PURE__*/ z.string().nullable(),
    toolPoisoningFindings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).nullable(),
    lastSecurityScanAt: /*#__PURE__*/ z.string().nullable(),
    connected: /*#__PURE__*/ z.boolean(),
    toolCount: /*#__PURE__*/ z.number().nullable(),
    lastConnectedAt: /*#__PURE__*/ z.string().nullable(),
    lastError: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zMcpConnectionCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().optional(),
    transport: /*#__PURE__*/ z.enum([
        'stdio',
        'sse',
        'http'
    ]),
    command: /*#__PURE__*/ z.string().optional(),
    args: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    serverUrl: /*#__PURE__*/ z.string().optional(),
    env: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    autoConnect: /*#__PURE__*/ z.boolean().optional(),
    toolPrefix: /*#__PURE__*/ z.string().optional(),
    permissionLevel: /*#__PURE__*/ z.string().optional(),
    maxCallsPerMinute: /*#__PURE__*/ z.number().optional(),
    timeoutMs: /*#__PURE__*/ z.number().optional(),
    trusted: /*#__PURE__*/ z.boolean().optional()
});

export const zMcpActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zMcpCommandQueued = /*#__PURE__*/ z.object({
    queued: /*#__PURE__*/ z.boolean(),
    requestId: /*#__PURE__*/ z.string()
});

export const zMcpTool = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string().nullable()
});

export const zWorkforceSearchResult = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    department: /*#__PURE__*/ z.string().nullable(),
    mandate: /*#__PURE__*/ z.string().nullable(),
    type: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string().nullable(),
    lifecycleStatus: /*#__PURE__*/ z.string().nullable(),
    qualityScore: /*#__PURE__*/ z.string().nullable(),
    score: /*#__PURE__*/ z.number(),
    matchType: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ]),
    source: /*#__PURE__*/ z.enum([
        'local',
        'builtin',
        'marketplace'
    ])
});

export const zWorkforceEventCatalogResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string(),
        source: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string()
    }))
});

export const zWorkforcePermissionGrantUsageResult = /*#__PURE__*/ z.object({
    active: /*#__PURE__*/ z.number(),
    allowAlways: /*#__PURE__*/ z.number(),
    allowOnce: /*#__PURE__*/ z.number(),
    usedLast7d: /*#__PURE__*/ z.number(),
    expiringSoon: /*#__PURE__*/ z.number(),
    revokedLast7d: /*#__PURE__*/ z.number(),
    staleUnusedAlways: /*#__PURE__*/ z.number().optional()
});

export const zDaemonLoadBuckets = /*#__PURE__*/ z.object({
    unassigned: /*#__PURE__*/ z.number(),
    assigned: /*#__PURE__*/ z.number(),
    at_capacity: /*#__PURE__*/ z.number(),
    over_capacity: /*#__PURE__*/ z.number(),
    frozen: /*#__PURE__*/ z.number()
});

export const zWorkforceFleetSummaryResult = /*#__PURE__*/ z.object({
    totalDaemons: /*#__PURE__*/ z.number(),
    enabledDaemons: /*#__PURE__*/ z.number(),
    recentFindings: /*#__PURE__*/ z.number(),
    pendingReviews: /*#__PURE__*/ z.number(),
    permissionGrantUsage: zWorkforcePermissionGrantUsageResult,
    globallyEnabled: /*#__PURE__*/ z.boolean(),
    loadBuckets: zDaemonLoadBuckets
});

export const zWorkforceAssignment = /*#__PURE__*/ z.object({
    employeeId: /*#__PURE__*/ z.string(),
    projectId: /*#__PURE__*/ z.string(),
    projectName: /*#__PURE__*/ z.string(),
    projectSlug: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string(),
    teamName: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.string(),
    active: /*#__PURE__*/ z.boolean(),
    since: /*#__PURE__*/ z.string().nullable(),
    endedAt: /*#__PURE__*/ z.string().nullable()
});

export const zWorkforceAssignmentList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkforceAssignment)
});

export const zWorkforceResumeAllResult = /*#__PURE__*/ z.object({
    resumed: /*#__PURE__*/ z.number(),
    skipped: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        name: /*#__PURE__*/ z.string(),
        missing: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    })),
    message: /*#__PURE__*/ z.string()
});

export const zWorkforceTerminateAllResult = /*#__PURE__*/ z.object({
    killed: /*#__PURE__*/ z.number(),
    message: /*#__PURE__*/ z.string()
});

export const zWorkforceRecord = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zFindingReviewUpdate = /*#__PURE__*/ z.object({
    reviewStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'deferred'
    ])
});

export const zDaemonPermissionGrant = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number().nullish(),
    daemonRunId: /*#__PURE__*/ z.number().nullish(),
    organizationId: /*#__PURE__*/ z.number().optional(),
    subjectType: /*#__PURE__*/ z.string().optional(),
    action: /*#__PURE__*/ z.string().optional(),
    resourceType: /*#__PURE__*/ z.string().optional(),
    resourceId: /*#__PURE__*/ z.string().optional(),
    scopeHash: /*#__PURE__*/ z.string().optional(),
    scope: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    decision: /*#__PURE__*/ z.enum(['allow', 'deny']).optional(),
    grantMode: /*#__PURE__*/ z.enum(['once', 'always']).optional(),
    reason: /*#__PURE__*/ z.string().nullish(),
    grantedBy: /*#__PURE__*/ z.string().nullish(),
    usedAt: /*#__PURE__*/ z.string().nullish(),
    expiresAt: /*#__PURE__*/ z.string().nullish(),
    revokedAt: /*#__PURE__*/ z.string().nullish(),
    revokedBy: /*#__PURE__*/ z.string().nullish(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    createdAt: /*#__PURE__*/ z.string().optional(),
    updatedAt: /*#__PURE__*/ z.string().optional()
});

export const zDaemonPermissionGrantList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonPermissionGrant)
});

export const zWorkforceItemResult = /*#__PURE__*/ z.object({
    data: zWorkforceRecord
});

export const zWorkforceRunTriggeredResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string(),
    daemon_id: /*#__PURE__*/ z.number(),
    daemon_name: /*#__PURE__*/ z.string()
});

export const zDaemonRunRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number().optional(),
    workflowDefinitionId: /*#__PURE__*/ z.number().nullish(),
    status: /*#__PURE__*/ z.string().optional(),
    triggeredBy: /*#__PURE__*/ z.string().optional(),
    startedAt: /*#__PURE__*/ z.string().optional(),
    completedAt: /*#__PURE__*/ z.string().nullish(),
    durationMs: /*#__PURE__*/ z.number().nullish(),
    findingsCount: /*#__PURE__*/ z.number().nullish(),
    errorsCount: /*#__PURE__*/ z.number().nullish(),
    qualityScore: /*#__PURE__*/ z.string().nullish(),
    reflection: /*#__PURE__*/ z.object({
        quality_rating: /*#__PURE__*/ z.number().optional(),
        what_worked: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        what_failed: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        next_time: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }).nullish(),
    error: /*#__PURE__*/ z.string().nullish()
});

export const zDaemonRunList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonRunRecord)
});

export const zWorkforceSseResult = /*#__PURE__*/ z.string();

export const zDaemonRunReportRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number().optional(),
    daemonRunId: /*#__PURE__*/ z.number().optional(),
    title: /*#__PURE__*/ z.string(),
    summary: /*#__PURE__*/ z.string().nullish(),
    source: /*#__PURE__*/ z.unknown().optional(),
    toolRuns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).nullish(),
    artifactIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullish(),
    findingIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).nullish(),
    decisionIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).nullish(),
    metrics: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    evidenceHash: /*#__PURE__*/ z.string().nullish(),
    createdAt: /*#__PURE__*/ z.string().optional()
});

export const zDaemonRunReportList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonRunReportRecord)
});

export const zDaemonRunDecisionRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number().optional(),
    daemonId: /*#__PURE__*/ z.number().optional(),
    daemonRunId: /*#__PURE__*/ z.number().optional(),
    title: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullish(),
    severity: /*#__PURE__*/ z.string().optional(),
    recommendation: /*#__PURE__*/ z.string().nullish(),
    actionType: /*#__PURE__*/ z.string().optional(),
    actionPayload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    rationale: /*#__PURE__*/ z.string().nullish(),
    reviewStatus: /*#__PURE__*/ z.string().optional(),
    reviewedBy: /*#__PURE__*/ z.string().nullish(),
    reviewedAt: /*#__PURE__*/ z.string().nullish(),
    consumedAt: /*#__PURE__*/ z.string().nullish(),
    expiresAt: /*#__PURE__*/ z.string().nullish(),
    createdAt: /*#__PURE__*/ z.string().optional(),
    stepIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    llmCallIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zDaemonRunDecisionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonRunDecisionRecord)
});

export const zDaemonExecutionEnvelope = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number().optional(),
    daemonRunId: /*#__PURE__*/ z.number().optional(),
    organizationId: /*#__PURE__*/ z.number().optional(),
    permissionGrantId: /*#__PURE__*/ z.number().nullish(),
    commandName: /*#__PURE__*/ z.string().optional(),
    action: /*#__PURE__*/ z.string().optional(),
    resourceType: /*#__PURE__*/ z.string().optional(),
    resourceId: /*#__PURE__*/ z.string().optional(),
    scopeHash: /*#__PURE__*/ z.string().optional(),
    envelopeHash: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'validated',
        'denied',
        'running',
        'completed',
        'failed'
    ]).optional(),
    risk: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high'
    ]).optional(),
    decisionReason: /*#__PURE__*/ z.string().nullish(),
    policy: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    command: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    result: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    startedAt: /*#__PURE__*/ z.string().nullish(),
    completedAt: /*#__PURE__*/ z.string().nullish(),
    durationMs: /*#__PURE__*/ z.number().nullish(),
    error: /*#__PURE__*/ z.string().nullish(),
    createdAt: /*#__PURE__*/ z.string().optional(),
    updatedAt: /*#__PURE__*/ z.string().optional()
});

export const zDaemonExecutionEnvelopeList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonExecutionEnvelope)
});

export const zWorkforceRunAuditResult = /*#__PURE__*/ z.object({
    data: zWorkforceRecord
});

export const zExecutionPermissionGrantCreate = /*#__PURE__*/ z.object({
    grantMode: /*#__PURE__*/ z.enum(['once', 'always']),
    reason: /*#__PURE__*/ z.string().optional(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().optional()
});

export const zDaemonTriggerRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number().optional(),
    type: /*#__PURE__*/ z.string().optional(),
    cron: /*#__PURE__*/ z.string().nullish(),
    eventPattern: /*#__PURE__*/ z.string().nullish(),
    chainDaemonId: /*#__PURE__*/ z.number().nullish(),
    workflowDefinitionId: /*#__PURE__*/ z.number().nullish(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    priority: /*#__PURE__*/ z.number().optional()
});

export const zDaemonTriggerList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonTriggerRecord)
});

export const zDaemonTriggerCreate = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'cron',
        'event',
        'manual',
        'chained'
    ]),
    cron: /*#__PURE__*/ z.string().optional(),
    eventPattern: /*#__PURE__*/ z.string().optional(),
    eventFilter: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    chainDaemonId: /*#__PURE__*/ z.number().optional(),
    workflowDefinitionId: /*#__PURE__*/ z.number().optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    priority: /*#__PURE__*/ z.number().optional()
});

export const zDaemonTriggerUpdate = /*#__PURE__*/ z.object({
    cron: /*#__PURE__*/ z.string().optional(),
    eventPattern: /*#__PURE__*/ z.string().optional(),
    eventFilter: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    workflowDefinitionId: /*#__PURE__*/ z.number().nullish(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    priority: /*#__PURE__*/ z.number().optional()
});

export const zWorkforceMessageResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zDaemonRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string().nullish(),
    name: /*#__PURE__*/ z.string().nullish(),
    description: /*#__PURE__*/ z.string().nullish(),
    type: /*#__PURE__*/ z.string().optional(),
    mandate: /*#__PURE__*/ z.string().nullish(),
    department: /*#__PURE__*/ z.string().optional(),
    permissionTier: /*#__PURE__*/ z.string().nullish(),
    supervisorDaemonId: /*#__PURE__*/ z.number().nullish(),
    maxRunsPerDay: /*#__PURE__*/ z.number().nullish(),
    capacity: /*#__PURE__*/ z.number().nullish(),
    hiredAt: /*#__PURE__*/ z.string().nullish(),
    probationUntil: /*#__PURE__*/ z.string().nullish(),
    templateId: /*#__PURE__*/ z.number().nullish(),
    runtimePolicyId: /*#__PURE__*/ z.number().nullish(),
    requiresApproval: /*#__PURE__*/ z.boolean().nullish(),
    lifecycleStatus: /*#__PURE__*/ z.string().optional(),
    enabled: /*#__PURE__*/ z.boolean().nullish(),
    status: /*#__PURE__*/ z.string().nullish(),
    lastRunAt: /*#__PURE__*/ z.string().nullish(),
    runCount: /*#__PURE__*/ z.number().nullish(),
    qualityScore: /*#__PURE__*/ z.string().nullish(),
    totalFindingsCount: /*#__PURE__*/ z.number().nullish(),
    organizationId: /*#__PURE__*/ z.number().optional(),
    moduleId: /*#__PURE__*/ z.string().optional()
});

export const zDaemonPaginatedList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonRecord),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        has_more: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        server_time: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zDaemonCreate = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/).optional(),
    name: /*#__PURE__*/ z.string().min(1),
    department: /*#__PURE__*/ z.enum([
        'research',
        'security',
        'quality',
        'testing',
        'docs',
        'performance',
        'infrastructure',
        'custom'
    ]),
    type: /*#__PURE__*/ z.enum([
        'guardian',
        'sentinel',
        'operative'
    ]).optional(),
    mandate: /*#__PURE__*/ z.string().optional(),
    templateId: /*#__PURE__*/ z.int().gt(0).nullish(),
    permissionTier: /*#__PURE__*/ z.enum([
        'observer',
        'contributor',
        'operator'
    ]).optional(),
    requiresApproval: /*#__PURE__*/ z.boolean().optional(),
    workflowDefinitionId: /*#__PURE__*/ z.int().gt(0).nullish(),
    triggers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'cron',
            'event',
            'chained',
            'manual'
        ]),
        cron: /*#__PURE__*/ z.string().optional(),
        eventPattern: /*#__PURE__*/ z.string().optional(),
        eventFilter: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        chainDaemonId: /*#__PURE__*/ z.int().gt(0).optional()
    })).optional(),
    supervisorDaemonId: /*#__PURE__*/ z.int().gt(0).nullish(),
    probationDays: /*#__PURE__*/ z.int().gt(0).nullish(),
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'inactive',
        'archived'
    ]).optional(),
    marketplaceSourceId: /*#__PURE__*/ z.int().gt(0).nullish(),
    description: /*#__PURE__*/ z.string().optional(),
    runtimePolicyId: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zDaemonReadinessReportResult = /*#__PURE__*/ z.object({
    ready: /*#__PURE__*/ z.boolean(),
    activation: /*#__PURE__*/ z.object({
        ok: /*#__PURE__*/ z.boolean(),
        missing: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }),
    checks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        key: /*#__PURE__*/ z.string(),
        ok: /*#__PURE__*/ z.boolean(),
        severity: /*#__PURE__*/ z.enum([
            'critical',
            'high',
            'medium',
            'low'
        ]),
        message: /*#__PURE__*/ z.string()
    })),
    blocking: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        key: /*#__PURE__*/ z.string(),
        ok: /*#__PURE__*/ z.boolean(),
        severity: /*#__PURE__*/ z.enum([
            'critical',
            'high',
            'medium',
            'low'
        ]),
        message: /*#__PURE__*/ z.string()
    })),
    selfReview: /*#__PURE__*/ z.object({
        openHighFindings: /*#__PURE__*/ z.number(),
        lastSecurityRun: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
        lastQualityRun: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable()
    }),
    permissionGrantUsage: zWorkforcePermissionGrantUsageResult
});

export const zDaemonReadinessResult = /*#__PURE__*/ z.object({
    data: zDaemonReadinessReportResult
});

export const zDaemonUpdate = /*#__PURE__*/ z.object({
    mandate: /*#__PURE__*/ z.string().optional(),
    department: /*#__PURE__*/ z.enum([
        'research',
        'security',
        'quality',
        'testing',
        'docs',
        'performance',
        'infrastructure',
        'custom'
    ]).optional(),
    permissionTier: /*#__PURE__*/ z.enum([
        'observer',
        'contributor',
        'operator'
    ]).optional(),
    templateId: /*#__PURE__*/ z.number().nullish(),
    supervisorDaemonId: /*#__PURE__*/ z.number().nullish(),
    requiresApproval: /*#__PURE__*/ z.boolean().optional(),
    maxRunsPerDay: /*#__PURE__*/ z.number().optional(),
    maxRunDurationMs: /*#__PURE__*/ z.number().optional(),
    outputChannels: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'inactive',
        'archived'
    ]).optional()
});

export const zEmployeeRuntimePolicyWrite = /*#__PURE__*/ z.object({
    runtimePolicyId: /*#__PURE__*/ z.int().gt(0)
});

export const zDaemonReflectionRecord = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string(),
    timestamp: /*#__PURE__*/ z.string(),
    duration_ms: /*#__PURE__*/ z.number(),
    findings_count: /*#__PURE__*/ z.number(),
    quality_rating: /*#__PURE__*/ z.number(),
    what_worked: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    what_failed: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    next_time: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zDaemonReflectionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonReflectionRecord)
});

export const zWorkforceTrendResult = /*#__PURE__*/ z.object({
    avgQuality: /*#__PURE__*/ z.number(),
    trend: /*#__PURE__*/ z.enum([
        'improving',
        'stable',
        'declining'
    ]),
    runCount: /*#__PURE__*/ z.number()
});

export const zDaemonFindingRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number().optional(),
    daemonName: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    severity: /*#__PURE__*/ z.string().optional(),
    title: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().nullish(),
    evidence: /*#__PURE__*/ z.unknown().optional(),
    recommendation: /*#__PURE__*/ z.string().nullish(),
    reviewStatus: /*#__PURE__*/ z.string().nullish(),
    reviewedBy: /*#__PURE__*/ z.string().nullish(),
    reviewedAt: /*#__PURE__*/ z.string().nullish(),
    affectedFiles: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullish(),
    createdAt: /*#__PURE__*/ z.string().optional()
});

export const zDaemonFindingList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonFindingRecord)
});

export const zDaemonWorkflowRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().optional(),
    daemonId: /*#__PURE__*/ z.number().optional(),
    workflowDefinitionId: /*#__PURE__*/ z.number().optional(),
    workflowCatalogVersionId: /*#__PURE__*/ z.number().nullish(),
    purpose: /*#__PURE__*/ z.string().nullish(),
    executionOrder: /*#__PURE__*/ z.number().nullish(),
    enabled: /*#__PURE__*/ z.boolean().nullish()
});

export const zDaemonWorkflowList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDaemonWorkflowRecord)
});

export const zDaemonWorkflowAssign = /*#__PURE__*/ z.object({
    workflowDefinitionId: /*#__PURE__*/ z.number(),
    purpose: /*#__PURE__*/ z.enum([
        'primary',
        'review',
        'reporting',
        'remediation'
    ]).optional(),
    executionOrder: /*#__PURE__*/ z.number().optional()
});

export const zDaemonDecision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number(),
    daemonRunId: /*#__PURE__*/ z.number(),
    title: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    severity: /*#__PURE__*/ z.string(),
    actionType: /*#__PURE__*/ z.string(),
    actionPayload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    reviewStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'deferred',
        'quarantined'
    ]),
    withdrawn: /*#__PURE__*/ z.boolean(),
    reviewedByUserId: /*#__PURE__*/ z.number().nullable(),
    proposedByUserId: /*#__PURE__*/ z.number().nullable(),
    reviewedAt: /*#__PURE__*/ z.string().nullable(),
    reviewNotes: /*#__PURE__*/ z.string().nullable(),
    consumedAt: /*#__PURE__*/ z.string().nullable(),
    expiresAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    raisedBy: /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum([
            'person',
            'workforce',
            'agent'
        ]),
        name: /*#__PURE__*/ z.string().nullable()
    }).optional(),
    review: /*#__PURE__*/ z.object({
        canReview: /*#__PURE__*/ z.boolean(),
        blockedReason: /*#__PURE__*/ z.enum([
            'settled',
            'expired',
            'own_request',
            'missing_policy'
        ]).nullable(),
        requiredPolicies: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        via: /*#__PURE__*/ z.enum(['daemon_decision', 'workflow_gate'])
    }).optional(),
    appliesOnApproval: /*#__PURE__*/ z.boolean().optional()
});

export const zDaemonDecisionReviewRequest = /*#__PURE__*/ z.object({
    notes: /*#__PURE__*/ z.string().max(2000).optional()
});

export const zImprovementProposalSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    summary: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'finance_bank_entity',
        'platform_code',
        'template_tuning',
        'data_source',
        'process'
    ]),
    riskClass: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'critical'
    ]),
    status: /*#__PURE__*/ z.enum([
        'idea',
        'specced',
        'implementing',
        'auditing',
        'ready_for_human',
        'approved',
        'rejected',
        'applying',
        'applied',
        'measured',
        'failed',
        'superseded'
    ]),
    confidence: /*#__PURE__*/ z.string().nullable(),
    expectedImpact: /*#__PURE__*/ z.string().nullable(),
    sourceArm: /*#__PURE__*/ z.string().nullable(),
    trialCount: /*#__PURE__*/ z.number(),
    costUsd: /*#__PURE__*/ z.string().nullable(),
    paidModelCostUsd: /*#__PURE__*/ z.string().nullable(),
    parentProposalId: /*#__PURE__*/ z.number().nullable(),
    supersededById: /*#__PURE__*/ z.number().nullable(),
    lineageRootId: /*#__PURE__*/ z.number().nullable(),
    proposedByEntityId: /*#__PURE__*/ z.number().nullable(),
    synthesizedRunId: /*#__PURE__*/ z.number().nullable(),
    specArtifactRef: /*#__PURE__*/ z.object({
        workOutputId: /*#__PURE__*/ z.string().optional(),
        artifactId: /*#__PURE__*/ z.string().optional(),
        path: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    stageAttempts: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).nullable(),
    decisionRef: /*#__PURE__*/ z.object({
        daemonDecisionId: /*#__PURE__*/ z.string().optional(),
        decidedByUserId: /*#__PURE__*/ z.string().optional(),
        decidedAt: /*#__PURE__*/ z.string().optional(),
        rationale: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    hasOpenDesignReview: /*#__PURE__*/ z.boolean().optional(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zImprovementProposalList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zImprovementProposalSummary),
    paging: /*#__PURE__*/ z.object({
        total: /*#__PURE__*/ z.number(),
        limit: /*#__PURE__*/ z.number(),
        offset: /*#__PURE__*/ z.number()
    })
});

export const zImprovementProposal = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    summary: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'finance_bank_entity',
        'platform_code',
        'template_tuning',
        'data_source',
        'process'
    ]),
    riskClass: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'critical'
    ]),
    status: /*#__PURE__*/ z.enum([
        'idea',
        'specced',
        'implementing',
        'auditing',
        'ready_for_human',
        'approved',
        'rejected',
        'applying',
        'applied',
        'measured',
        'failed',
        'superseded'
    ]),
    confidence: /*#__PURE__*/ z.string().nullable(),
    expectedImpact: /*#__PURE__*/ z.string().nullable(),
    sourceArm: /*#__PURE__*/ z.string().nullable(),
    trialCount: /*#__PURE__*/ z.number(),
    costUsd: /*#__PURE__*/ z.string().nullable(),
    paidModelCostUsd: /*#__PURE__*/ z.string().nullable(),
    parentProposalId: /*#__PURE__*/ z.number().nullable(),
    supersededById: /*#__PURE__*/ z.number().nullable(),
    lineageRootId: /*#__PURE__*/ z.number().nullable(),
    proposedByEntityId: /*#__PURE__*/ z.number().nullable(),
    synthesizedRunId: /*#__PURE__*/ z.number().nullable(),
    evidenceRefs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'daemon_finding',
            'intel_insight',
            'intel_content',
            'telemetry',
            'url',
            'prior_proposal'
        ]),
        id: /*#__PURE__*/ z.string().optional(),
        url: /*#__PURE__*/ z.string().optional(),
        note: /*#__PURE__*/ z.string().optional()
    })),
    specArtifactRef: /*#__PURE__*/ z.object({
        workOutputId: /*#__PURE__*/ z.string().optional(),
        artifactId: /*#__PURE__*/ z.string().optional(),
        path: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    acceptanceCriteria: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string(),
        checkType: /*#__PURE__*/ z.string(),
        checkRef: /*#__PURE__*/ z.object({
            command: /*#__PURE__*/ z.string().optional(),
            datasetId: /*#__PURE__*/ z.string().optional(),
            gateKey: /*#__PURE__*/ z.string().optional(),
            fixtureSetId: /*#__PURE__*/ z.string().optional(),
            instructions: /*#__PURE__*/ z.string().optional()
        }).optional(),
        blocking: /*#__PURE__*/ z.boolean()
    })).nullable(),
    implementationRefs: /*#__PURE__*/ z.object({
        catalogCandidateIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        codeReviewGateId: /*#__PURE__*/ z.string().optional(),
        workspaceId: /*#__PURE__*/ z.string().optional(),
        checkpointIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        prUrl: /*#__PURE__*/ z.string().optional(),
        templateVersionId: /*#__PURE__*/ z.string().optional(),
        strategyRunRequestIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }).nullable(),
    auditRefs: /*#__PURE__*/ z.object({
        evaluationRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        reportIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        evidenceHash: /*#__PURE__*/ z.string().optional(),
        holdoutDelta: /*#__PURE__*/ z.number().optional(),
        disclosedScore: /*#__PURE__*/ z.number().optional(),
        holdoutScore: /*#__PURE__*/ z.number().optional()
    }).nullable(),
    decisionRef: /*#__PURE__*/ z.object({
        daemonDecisionId: /*#__PURE__*/ z.string().optional(),
        decidedByUserId: /*#__PURE__*/ z.string().optional(),
        decidedAt: /*#__PURE__*/ z.string().optional(),
        rationale: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    outcome: /*#__PURE__*/ z.object({
        verdict: /*#__PURE__*/ z.enum([
            'adopted',
            'reverted',
            'inconclusive'
        ]).optional(),
        metrics: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        measuredAt: /*#__PURE__*/ z.string().optional()
    }).nullable(),
    stageAttempts: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).nullable(),
    stageLog: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        from: /*#__PURE__*/ z.string(),
        to: /*#__PURE__*/ z.string(),
        at: /*#__PURE__*/ z.string(),
        actorType: /*#__PURE__*/ z.enum([
            'daemon',
            'user',
            'system'
        ]),
        actorId: /*#__PURE__*/ z.string(),
        note: /*#__PURE__*/ z.string().optional()
    })),
    hasOpenDesignReview: /*#__PURE__*/ z.boolean(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zImprovementProposalDecision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'idea',
        'specced',
        'implementing',
        'auditing',
        'ready_for_human',
        'approved',
        'rejected',
        'applying',
        'applied',
        'measured',
        'failed',
        'superseded'
    ]),
    decision: /*#__PURE__*/ z.enum(['approve', 'reject']),
    daemonDecisionId: /*#__PURE__*/ z.number().nullable()
});

export const zImprovementProposalDecisionBody = /*#__PURE__*/ z.object({
    decision: /*#__PURE__*/ z.enum(['approve', 'reject']),
    rationale: /*#__PURE__*/ z.string().min(1).max(5000).optional()
});

export const zImprovementProposalDesignDecision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'idea',
        'specced',
        'implementing',
        'auditing',
        'ready_for_human',
        'approved',
        'rejected',
        'applying',
        'applied',
        'measured',
        'failed',
        'superseded'
    ]),
    decision: /*#__PURE__*/ z.enum(['approve', 'reject']),
    accepted: /*#__PURE__*/ z.boolean()
});

export const zImprovementProposalDesignDecisionBody = /*#__PURE__*/ z.object({
    decision: /*#__PURE__*/ z.enum(['approve', 'reject']),
    rationale: /*#__PURE__*/ z.string().min(1).max(5000).optional()
});

export const zImprovementPipelineStatus = /*#__PURE__*/ z.object({
    active: /*#__PURE__*/ z.boolean(),
    pauseReason: /*#__PURE__*/ z.string().nullable(),
    tier: /*#__PURE__*/ z.enum([
        'T0',
        'T1',
        'T2'
    ]),
    lastConductorRunAt: /*#__PURE__*/ z.string().nullable(),
    stragglersCount: /*#__PURE__*/ z.int()
});

export const zImprovementFlowMetrics = /*#__PURE__*/ z.object({
    intakePerDayByLane: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    stageLatencyP50Sec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number().nullable()),
    stageLatencyP95Sec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number().nullable()),
    wipPerStage: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    expiryRate: /*#__PURE__*/ z.number().nullable(),
    timeToDecisionHrsP50: /*#__PURE__*/ z.number().nullable()
});

export const zImprovementQualityMetrics = /*#__PURE__*/ z.object({
    acceptanceRateOverall: /*#__PURE__*/ z.number().nullable(),
    acceptanceRateByLane: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number().nullable()),
    acceptanceRateByDaemon: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number().nullable()),
    revertRate: /*#__PURE__*/ z.number().nullable(),
    auditFirstPassRate: /*#__PURE__*/ z.number().nullable(),
    strictVsLooseDelta: /*#__PURE__*/ z.number().nullable(),
    integrityViolations30d: /*#__PURE__*/ z.int()
});

export const zImprovementLearningMetrics = /*#__PURE__*/ z.object({
    brierScoreByProposer: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number().nullable()),
    banditArmPosterior: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number().nullable()),
    lineageFertilityTopN: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        proposalId: /*#__PURE__*/ z.number(),
        title: /*#__PURE__*/ z.string(),
        fertileDescendants: /*#__PURE__*/ z.int()
    }))
});

export const zImprovementCostMetrics = /*#__PURE__*/ z.object({
    costPerProposalP50Usd: /*#__PURE__*/ z.number().nullable(),
    costPerProposalP95Usd: /*#__PURE__*/ z.number().nullable(),
    costPerAcceptedProposalP50Usd: /*#__PURE__*/ z.number().nullable(),
    localTokenVolumeTotal: /*#__PURE__*/ z.number().nullable()
});

export const zImprovementHumanLoadMetrics = /*#__PURE__*/ z.object({
    decisionsLast7Days: /*#__PURE__*/ z.int(),
    medianReviewMinutes: /*#__PURE__*/ z.number().nullable(),
    rubberStampDetected: /*#__PURE__*/ z.boolean(),
    fastReviewFraction: /*#__PURE__*/ z.number().nullable()
});

export const zImprovementMetrics = /*#__PURE__*/ z.object({
    pipeline: zImprovementPipelineStatus,
    flow: zImprovementFlowMetrics,
    quality: zImprovementQualityMetrics,
    learning: zImprovementLearningMetrics,
    cost: zImprovementCostMetrics,
    humanLoad: zImprovementHumanLoadMetrics,
    computedAt: /*#__PURE__*/ z.string().nullable()
});

export const zImprovementTierFailingCriterion = /*#__PURE__*/ z.object({
    criterion: /*#__PURE__*/ z.string(),
    detail: /*#__PURE__*/ z.string()
});

export const zImprovementTierLane = /*#__PURE__*/ z.object({
    lane: /*#__PURE__*/ z.enum([
        'finance',
        'codegen',
        'template',
        'data',
        'process'
    ]),
    tier: /*#__PURE__*/ z.enum([
        'T0',
        'T1',
        'T2'
    ]),
    expandEligible: /*#__PURE__*/ z.boolean(),
    nextTier: /*#__PURE__*/ z.enum(['T1', 'T2']).nullable(),
    failingCriteria: /*#__PURE__*/ z.array(zImprovementTierFailingCriterion).optional()
});

export const zImprovementTierStatus = /*#__PURE__*/ z.array(zImprovementTierLane);

export const zImprovementTierExpansion = /*#__PURE__*/ z.object({
    lane: /*#__PURE__*/ z.enum([
        'finance',
        'codegen',
        'template',
        'data',
        'process'
    ]),
    fromTier: /*#__PURE__*/ z.enum([
        'T0',
        'T1',
        'T2'
    ]),
    tier: /*#__PURE__*/ z.enum([
        'T0',
        'T1',
        'T2'
    ]),
    expanded: /*#__PURE__*/ z.boolean()
});

export const zImprovementTierExpandRequest = /*#__PURE__*/ z.object({
    lane: /*#__PURE__*/ z.enum([
        'finance',
        'codegen',
        'template',
        'data',
        'process'
    ]),
    targetTier: /*#__PURE__*/ z.enum(['T1', 'T2'])
});

export const zWorkflowGate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    runId: /*#__PURE__*/ z.string(),
    dbRunId: /*#__PURE__*/ z.number(),
    gateName: /*#__PURE__*/ z.string(),
    afterStepId: /*#__PURE__*/ z.string(),
    priority: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'urgent'
    ]),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'expired'
    ]),
    gateContext: /*#__PURE__*/ z.unknown().optional(),
    decidedByUserId: /*#__PURE__*/ z.number().nullable(),
    decidedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    notes: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    expiresAt: /*#__PURE__*/ z.iso.datetime()
});

export const zWorkflowGateApproveRequest = /*#__PURE__*/ z.object({
    notes: /*#__PURE__*/ z.string().max(2000).optional()
});

export const zWorkflowGateRejectRequest = /*#__PURE__*/ z.object({
    notes: /*#__PURE__*/ z.string().max(2000).optional()
});

export const zMarketplaceListing = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    entityId: /*#__PURE__*/ z.number(),
    entityType: /*#__PURE__*/ z.string(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    contentAccess: /*#__PURE__*/ z.string(),
    publishedBy: /*#__PURE__*/ z.number(),
    title: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string().nullable(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    pricingModel: /*#__PURE__*/ z.string(),
    priceUsd: /*#__PURE__*/ z.string().nullable(),
    featured: /*#__PURE__*/ z.boolean().nullable(),
    status: /*#__PURE__*/ z.string().nullable(),
    publishedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    autoAcquire: /*#__PURE__*/ z.boolean(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zMarketplaceListingCreate = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number(),
    title: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    pricingModel: /*#__PURE__*/ z.enum([
        'free',
        'one_time',
        'subscription'
    ]).optional(),
    priceUsd: /*#__PURE__*/ z.string().optional(),
    contentAccess: /*#__PURE__*/ z.enum(['public', 'private']).optional(),
    autoAcquire: /*#__PURE__*/ z.boolean().optional()
});

export const zMarketplaceActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zEntity = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    type: /*#__PURE__*/ z.string(),
    organizationId: /*#__PURE__*/ z.number(),
    activeVersionId: /*#__PURE__*/ z.number().nullable(),
    scope: /*#__PURE__*/ z.string(),
    visibility: /*#__PURE__*/ z.string(),
    moduleId: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string().nullable(),
    name: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    enabled: /*#__PURE__*/ z.boolean(),
    disabledReason: /*#__PURE__*/ z.string().nullable(),
    loggingEnabled: /*#__PURE__*/ z.boolean(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    updatedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zMarketplaceForkedEntity = /*#__PURE__*/ z.object({
    entity: zEntity,
    versionId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number()
});

export const zMarketplaceForkRequest = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string().min(1).max(140),
    name: /*#__PURE__*/ z.string().min(1).max(220)
});

export const zMarketplaceAcquisition = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number(),
    sourceEntityId: /*#__PURE__*/ z.number(),
    type: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]),
    name: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string().nullable(),
    moduleId: /*#__PURE__*/ z.string(),
    held: zMarketplaceAcquisitionVersion,
    latest: zMarketplaceAcquisitionVersion,
    previous: /*#__PURE__*/ zMarketplaceAcquisitionVersion.nullable(),
    updateAvailable: /*#__PURE__*/ z.boolean(),
    changes: /*#__PURE__*/ z.array(zMarketplaceAcquisitionVersion),
    versions: /*#__PURE__*/ z.array(zMarketplaceAcquisitionVersion).optional(),
    changedParts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullish()
});

export const zMarketplaceAcquisitionMove = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number(),
    type: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]),
    name: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string().nullable(),
    from: zMarketplaceAcquisitionVersion,
    to: zMarketplaceAcquisitionVersion
});

export const zMarketplaceUpdateAllResult = /*#__PURE__*/ z.object({
    updated: /*#__PURE__*/ z.array(zMarketplaceAcquisitionMove),
    failed: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        entityId: /*#__PURE__*/ z.number(),
        name: /*#__PURE__*/ z.string(),
        reason: /*#__PURE__*/ z.string()
    }))
});

export const zMarketplaceUpdateAllRequest = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]).optional()
});

export const zMarketplaceEntityUpdateRequest = /*#__PURE__*/ z.object({
    toVersion: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zMarketplaceNeedsSetupEntity = /*#__PURE__*/ z.object({
    entity: zEntity,
    reason: /*#__PURE__*/ z.enum(['direct', 'dependency'])
});

export const zBindConnectionRequest = /*#__PURE__*/ z.object({
    mcpConnectionId: /*#__PURE__*/ z.number()
});

export const zMarketplaceBundleEntity = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    entityId: /*#__PURE__*/ z.number(),
    entityType: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string().nullable(),
    ordinal: /*#__PURE__*/ z.number()
});

export const zMarketplaceBundle = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    authorOrgSlug: /*#__PURE__*/ z.string().optional(),
    version: /*#__PURE__*/ z.string().optional(),
    installCount: /*#__PURE__*/ z.number(),
    entities: /*#__PURE__*/ z.array(zMarketplaceBundleEntity),
    entityCounts: /*#__PURE__*/ z.object({
        templates: /*#__PURE__*/ z.number(),
        workflows: /*#__PURE__*/ z.number(),
        daemons: /*#__PURE__*/ z.number()
    })
});

export const zMarketplaceBundleCreate = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string().min(1).max(120),
    name: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().optional(),
    visibility: /*#__PURE__*/ z.enum(['public', 'unlisted']).optional()
});

export const zMarketplaceBundleAddEntity = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number(),
    ordinal: /*#__PURE__*/ z.number().optional()
});

export const zEntityVersionSubject = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number(),
    type: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string().nullable(),
    name: /*#__PURE__*/ z.string().nullable(),
    activeVersionId: /*#__PURE__*/ z.number().nullable(),
    acquired: /*#__PURE__*/ z.boolean()
});

export const zEntityVersion = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    entityId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    state: /*#__PURE__*/ z.enum(['draft', 'locked']),
    lockReason: /*#__PURE__*/ z.enum([
        'marketplace',
        'live_trading',
        'frozen'
    ]).nullable(),
    lockedAt: /*#__PURE__*/ z.string().nullable(),
    contentHash: /*#__PURE__*/ z.string().nullable(),
    parentVersionId: /*#__PURE__*/ z.number().nullable(),
    changeSummary: /*#__PURE__*/ z.string().nullable(),
    createdByUserId: /*#__PURE__*/ z.number().nullable(),
    createdByWorkflowRunId: /*#__PURE__*/ z.number().nullable(),
    createdByDaemonRunId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    isActive: /*#__PURE__*/ z.boolean()
});

export const zEntityVersionList = /*#__PURE__*/ z.object({
    entity: zEntityVersionSubject,
    data: /*#__PURE__*/ z.array(zEntityVersion)
});

export const zEntityDraftCreate = /*#__PURE__*/ z.object({
    changeSummary: /*#__PURE__*/ z.string().max(2000).optional()
});

export const zMlHealth = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string().optional(),
    uptime: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number()
    ]).optional()
});

export const zMlRegime = /*#__PURE__*/ z.object({
    regime: /*#__PURE__*/ z.string().optional(),
    confidence: /*#__PURE__*/ z.number().optional(),
    description: /*#__PURE__*/ z.string().optional()
});

export const zMlStrategyScore = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    score: /*#__PURE__*/ z.number().optional(),
    allocation: /*#__PURE__*/ z.number().optional()
});

export const zMlStrategyScores = /*#__PURE__*/ z.object({
    strategies: /*#__PURE__*/ z.array(zMlStrategyScore).optional()
});

export const zWorkerRun = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string(),
    streamId: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'agent',
        'llm',
        'workflow'
    ]),
    templateSlug: /*#__PURE__*/ z.string().nullable(),
    workflowSlug: /*#__PURE__*/ z.string().nullable(),
    workflowId: /*#__PURE__*/ z.number().nullable(),
    status: /*#__PURE__*/ z.enum([
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    organizationId: /*#__PURE__*/ z.number(),
    apiKeyId: /*#__PURE__*/ z.number(),
    startedAt: /*#__PURE__*/ z.string(),
    completedAt: /*#__PURE__*/ z.string().nullable(),
    result: /*#__PURE__*/ z.object({
        output: /*#__PURE__*/ z.unknown().optional(),
        outputContract: /*#__PURE__*/ z.unknown().optional(),
        usage: /*#__PURE__*/ z.object({
            inputTokens: /*#__PURE__*/ z.number(),
            outputTokens: /*#__PURE__*/ z.number(),
            modelStamp: /*#__PURE__*/ z.string()
        })
    }).nullable(),
    failureReason: /*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.string(),
        message: /*#__PURE__*/ z.string(),
        retryable: /*#__PURE__*/ z.boolean(),
        details: /*#__PURE__*/ z.unknown().optional()
    }).nullable(),
    cancelReason: /*#__PURE__*/ z.string().nullable()
});

export const zWorkerRunCreate = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'agent',
        'llm',
        'workflow'
    ]),
    templateSlug: /*#__PURE__*/ z.string().min(1).max(100).optional(),
    workflowSlug: /*#__PURE__*/ z.string().min(1).max(140).optional(),
    workflowId: /*#__PURE__*/ z.int().gt(0).optional(),
    input: /*#__PURE__*/ z.unknown().optional(),
    policyId: /*#__PURE__*/ z.int().gt(0).optional(),
    model: /*#__PURE__*/ z.unknown().optional(),
    prompt: /*#__PURE__*/ z.string().min(1).max(50000).optional(),
    system: /*#__PURE__*/ z.string().max(20000).optional(),
    webhookUrl: /*#__PURE__*/ z.url().optional(),
    webhookSecret: /*#__PURE__*/ z.string().min(16).max(200).optional(),
    idempotencyKey: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    timeoutMs: /*#__PURE__*/ z.int().gte(1000).lte(900000).optional()
});

export const zWorkerRunPending = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum(['pending'])
});

export const zWorkerRunFollowUpRequest = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.unknown().optional(),
    idempotencyKey: /*#__PURE__*/ z.string().min(1).max(200).optional()
});

export const zPlatformMcpResponse = /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        id: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.int()
        ]),
        result: /*#__PURE__*/ z.object({
            _meta: /*#__PURE__*/ z.object({
                progressToken: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string(),
                    /*#__PURE__*/ z.int()
                ]).optional(),
                'io.modelcontextprotocol/related-task': /*#__PURE__*/ z.object({
                    taskId: /*#__PURE__*/ z.string()
                }).optional()
            }).optional()
        })
    }),
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        id: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.int()
        ]).optional(),
        error: /*#__PURE__*/ z.object({
            code: /*#__PURE__*/ z.int(),
            message: /*#__PURE__*/ z.string(),
            data: /*#__PURE__*/ z.unknown().optional()
        })
    })
]);

export const zPlatformMcpRequest = /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        id: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.int()
        ]),
        method: /*#__PURE__*/ z.string(),
        params: /*#__PURE__*/ z.object({
            _meta: /*#__PURE__*/ z.object({
                progressToken: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string(),
                    /*#__PURE__*/ z.int()
                ]).optional(),
                'io.modelcontextprotocol/related-task': /*#__PURE__*/ z.object({
                    taskId: /*#__PURE__*/ z.string()
                }).optional()
            }).optional()
        }).optional()
    }),
    /*#__PURE__*/ z.object({
        jsonrpc: /*#__PURE__*/ z.enum(['2.0']),
        method: /*#__PURE__*/ z.string(),
        params: /*#__PURE__*/ z.object({
            _meta: /*#__PURE__*/ z.object({
                progressToken: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string(),
                    /*#__PURE__*/ z.int()
                ]).optional(),
                'io.modelcontextprotocol/related-task': /*#__PURE__*/ z.object({
                    taskId: /*#__PURE__*/ z.string()
                }).optional()
            }).optional()
        }).optional()
    })
]);

export const zApiKey = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    scope: /*#__PURE__*/ z.enum([
        'worker_sdk',
        'service_account',
        'user',
        'host_reporter'
    ]),
    userId: /*#__PURE__*/ z.number().nullable(),
    name: /*#__PURE__*/ z.string(),
    keyPrefix: /*#__PURE__*/ z.string(),
    environmentId: /*#__PURE__*/ z.number().nullable(),
    metadata: /*#__PURE__*/ z.object({
        tier: /*#__PURE__*/ z.enum([
            'standard',
            'high',
            'enterprise'
        ]).optional(),
        tokenQuotaDailyOverride: /*#__PURE__*/ z.number().optional(),
        allowedTemplateSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        wsEnabled: /*#__PURE__*/ z.boolean().optional(),
        aiWorkerEnabled: /*#__PURE__*/ z.boolean().optional(),
        allowedAiWorkerCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        allowedAiWorkerModelSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        dataAccessEnabled: /*#__PURE__*/ z.boolean().optional(),
        grants: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        consultDailyCap: /*#__PURE__*/ z.int().gte(0).lte(10000).optional(),
        consultTimeoutMs: /*#__PURE__*/ z.int().gte(30000).lte(600000).optional()
    }).nullable(),
    expiresAt: /*#__PURE__*/ z.string().nullable(),
    revokedAt: /*#__PURE__*/ z.string().nullable(),
    lastUsedAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zIssuedApiKey = /*#__PURE__*/ z.object({
    apiKey: zApiKey,
    plaintext: /*#__PURE__*/ z.string()
});

export const zApiKeyCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(100),
    scope: /*#__PURE__*/ z.enum([
        'worker_sdk',
        'service_account',
        'user',
        'host_reporter'
    ]),
    userId: /*#__PURE__*/ z.int().gt(0).optional(),
    environmentSlug: /*#__PURE__*/ z.string().min(1).max(40),
    environmentId: /*#__PURE__*/ z.int().optional(),
    metadata: /*#__PURE__*/ z.object({
        tier: /*#__PURE__*/ z.enum([
            'standard',
            'high',
            'enterprise'
        ]).optional(),
        tokenQuotaDailyOverride: /*#__PURE__*/ z.number().optional(),
        allowedTemplateSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        wsEnabled: /*#__PURE__*/ z.boolean().optional(),
        aiWorkerEnabled: /*#__PURE__*/ z.boolean().optional(),
        allowedAiWorkerCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        allowedAiWorkerModelSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        dataAccessEnabled: /*#__PURE__*/ z.boolean().optional(),
        grants: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        consultDailyCap: /*#__PURE__*/ z.int().gte(0).lte(10000).optional(),
        consultTimeoutMs: /*#__PURE__*/ z.int().gte(30000).lte(600000).optional()
    }).optional(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().optional()
});

export const zApiKeyGrantablePermissions = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zApiKeyUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(100).optional(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().nullish(),
    metadata: /*#__PURE__*/ z.object({
        tier: /*#__PURE__*/ z.enum([
            'standard',
            'high',
            'enterprise'
        ]).optional(),
        tokenQuotaDailyOverride: /*#__PURE__*/ z.number().optional(),
        allowedTemplateSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        wsEnabled: /*#__PURE__*/ z.boolean().optional(),
        aiWorkerEnabled: /*#__PURE__*/ z.boolean().optional(),
        allowedAiWorkerCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        allowedAiWorkerModelSlugs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        dataAccessEnabled: /*#__PURE__*/ z.boolean().optional(),
        grants: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        consultDailyCap: /*#__PURE__*/ z.int().gte(0).lte(10000).optional(),
        consultTimeoutMs: /*#__PURE__*/ z.int().gte(30000).lte(600000).optional()
    }).optional()
});

export const zJourneyContextType = /*#__PURE__*/ z.enum([
    'global',
    'project',
    'project_thread',
    'project_change',
    'workstream',
    'conversation',
    'workflow_run',
    'review_gate',
    'code_workspace',
    'code_workspace_operation'
]);

export const zJourneySummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    actorType: /*#__PURE__*/ z.string(),
    actorId: /*#__PURE__*/ z.string(),
    userId: /*#__PURE__*/ z.number().nullable(),
    contextType: zJourneyContextType,
    contextKey: /*#__PURE__*/ z.string(),
    directionKey: /*#__PURE__*/ z.string().nullable(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    projectThreadId: /*#__PURE__*/ z.number().nullable(),
    projectChangeId: /*#__PURE__*/ z.number().nullable(),
    workstreamId: /*#__PURE__*/ z.number().nullable(),
    conversationId: /*#__PURE__*/ z.number().nullable(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    gateId: /*#__PURE__*/ z.number().nullable(),
    codeWorkspaceId: /*#__PURE__*/ z.number().nullable(),
    codeWorkspaceOperationId: /*#__PURE__*/ z.number().nullable(),
    startedAt: /*#__PURE__*/ z.iso.datetime(),
    lastEventAt: /*#__PURE__*/ z.iso.datetime(),
    endedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    sessionInactivityMs: /*#__PURE__*/ z.number(),
    metadata: /*#__PURE__*/ z.object({
        contextLabel: /*#__PURE__*/ z.string().nullish(),
        directionKey: /*#__PURE__*/ z.string().nullish(),
        source: /*#__PURE__*/ z.string().nullish(),
        sessionHint: /*#__PURE__*/ z.string().nullish()
    })
});

export const zJourneyPageInfo = /*#__PURE__*/ z.object({
    hasNextPage: /*#__PURE__*/ z.boolean(),
    endCursor: /*#__PURE__*/ z.string().nullable()
});

export const zJourneyList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zJourneySummary),
    pageInfo: zJourneyPageInfo
});

export const zJourneyEventSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    journeyId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    eventType: /*#__PURE__*/ z.string(),
    eventName: /*#__PURE__*/ z.string(),
    actorType: /*#__PURE__*/ z.string(),
    actorId: /*#__PURE__*/ z.string(),
    userId: /*#__PURE__*/ z.number().nullable(),
    entityType: /*#__PURE__*/ z.string().nullable(),
    entityId: /*#__PURE__*/ z.string().nullable(),
    correlationId: /*#__PURE__*/ z.string().nullable(),
    causationType: /*#__PURE__*/ z.string().nullable(),
    causationId: /*#__PURE__*/ z.string().nullable(),
    requestId: /*#__PURE__*/ z.string().nullable(),
    retentionClass: /*#__PURE__*/ z.string(),
    containsRawEvidence: /*#__PURE__*/ z.boolean(),
    redactionSummary: /*#__PURE__*/ z.object({
        redacted: /*#__PURE__*/ z.boolean(),
        paths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        rules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        notes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }),
    links: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        entityType: /*#__PURE__*/ z.string(),
        entityId: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.number()
        ]),
        relationship: /*#__PURE__*/ z.string().optional(),
        href: /*#__PURE__*/ z.string().optional(),
        label: /*#__PURE__*/ z.string().optional(),
        metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
    })),
    payload: /*#__PURE__*/ z.object({
        routePattern: /*#__PURE__*/ z.string().nullish(),
        method: /*#__PURE__*/ z.string().nullish(),
        status: /*#__PURE__*/ z.number().nullish(),
        durationMs: /*#__PURE__*/ z.number().nullish(),
        query: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        params: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
    }),
    occurredAt: /*#__PURE__*/ z.iso.datetime(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zJourneyEventList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zJourneyEventSummary),
    pageInfo: zJourneyPageInfo
});

export const zJourneyEventRaw = /*#__PURE__*/ zJourneyEventSummary.and(/*#__PURE__*/ z.object({
    rawEvidence: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
}));

export const zJourneyRawEventList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zJourneyEventRaw),
    pageInfo: zJourneyPageInfo
});

export const zDepartment = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    moduleId: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string(),
    displayName: /*#__PURE__*/ z.string(),
    sortOrder: /*#__PURE__*/ z.int(),
    createdAt: /*#__PURE__*/ z.string()
});

export const zModuleNavItem = /*#__PURE__*/ z.object({
    path: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string(),
    icon: /*#__PURE__*/ z.string().optional(),
    policy: /*#__PURE__*/ z.string().optional()
});

export const zModule = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    displayName: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    icon: /*#__PURE__*/ z.string(),
    navOrder: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'beta',
        'deprecated'
    ]),
    policies: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    nav: /*#__PURE__*/ z.array(zModuleNavItem),
    dependsOn: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zModuleList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zModule)
});

export const zWaitingOnMeItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum(['conversation', 'decision']),
    moduleId: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    subtitle: /*#__PURE__*/ z.string(),
    conversationId: /*#__PURE__*/ z.number().optional(),
    decisionId: /*#__PURE__*/ z.number().optional(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zWaitingOnMe = /*#__PURE__*/ z.object({
    count: /*#__PURE__*/ z.int(),
    items: /*#__PURE__*/ z.array(zWaitingOnMeItem)
});

export const zConversationGroup = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    conversationCount: /*#__PURE__*/ z.number()
});

export const zConversationGroupCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(255)
});

export const zConversationMember = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    conversationId: /*#__PURE__*/ z.number(),
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'persona',
        'workforce_member',
        'external_agent',
        'agent_instance'
    ]),
    memberId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.enum([
        'owner',
        'contributor',
        'observer',
        'lead'
    ]),
    joinedAt: /*#__PURE__*/ z.iso.datetime(),
    leftAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    displayName: /*#__PURE__*/ z.string().optional(),
    threadConversationId: /*#__PURE__*/ z.number().nullish()
});

export const zConversationAttachment = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    conversationId: /*#__PURE__*/ z.string(),
    attachedType: /*#__PURE__*/ z.enum([
        'artifact',
        'memory',
        'task',
        'conversation',
        'project',
        'workflow'
    ]),
    attachedId: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.enum([
        'context',
        'reference',
        'dependency',
        'handoff-payload'
    ]),
    attachedAt: /*#__PURE__*/ z.iso.datetime(),
    attachedBy: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zConversation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    userId: /*#__PURE__*/ z.number(),
    topic: /*#__PURE__*/ z.string().min(1).max(256),
    kind: /*#__PURE__*/ z.enum([
        'user-agent',
        'agent-agent',
        'team',
        'assistant-ui'
    ]),
    templateSlug: /*#__PURE__*/ z.string(),
    subjectType: /*#__PURE__*/ z.string().nullable(),
    subjectId: /*#__PURE__*/ z.string().nullable(),
    runtimePolicyId: /*#__PURE__*/ z.number(),
    promptTemplateVersion: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'idle',
        'completed',
        'errored'
    ]),
    structuredSummary: /*#__PURE__*/ z.object({
        schemaVersion: /*#__PURE__*/ z.literal(1),
        goals: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        decisions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            text: /*#__PURE__*/ z.string(),
            turn: /*#__PURE__*/ z.number(),
            decisionId: /*#__PURE__*/ z.string().nullable()
        })),
        openQuestions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        entities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.string(),
            id: /*#__PURE__*/ z.string(),
            label: /*#__PURE__*/ z.string()
        })),
        references: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum([
                'url',
                'entity',
                'document'
            ]),
            value: /*#__PURE__*/ z.string(),
            label: /*#__PURE__*/ z.string(),
            sourceTurn: /*#__PURE__*/ z.number()
        })),
        userPreferences: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        attachments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum([
                'image',
                'document',
                'audio'
            ]),
            storageRef: /*#__PURE__*/ z.string(),
            textSummary: /*#__PURE__*/ z.string()
        })).optional()
    }).nullable(),
    summarySchemaHash: /*#__PURE__*/ z.string().nullable(),
    summaryModelStamp: /*#__PURE__*/ z.string().nullable(),
    summaryUpdatedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    parentConversationId: /*#__PURE__*/ z.number().nullable(),
    rootTaskId: /*#__PURE__*/ z.number().nullable(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    teamId: /*#__PURE__*/ z.number().nullable(),
    moduleId: /*#__PURE__*/ z.string(),
    needsUser: /*#__PURE__*/ z.boolean(),
    groupId: /*#__PURE__*/ z.number().nullable(),
    pinnedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    lastActivityAt: /*#__PURE__*/ z.iso.datetime(),
    members: /*#__PURE__*/ z.array(zConversationMember).optional(),
    attachments: /*#__PURE__*/ z.array(zConversationAttachment).optional(),
    messageCount: /*#__PURE__*/ z.int().optional()
});

export const zConversationList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zConversation),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zConversationCreate = /*#__PURE__*/ z.object({
    topic: /*#__PURE__*/ z.string().min(1).max(256),
    kind: /*#__PURE__*/ z.enum([
        'user-agent',
        'agent-agent',
        'team',
        'assistant-ui'
    ]).optional().default('user-agent'),
    entryPoint: /*#__PURE__*/ z.string().min(1).max(80).regex(/^[a-z][a-z0-9-]*(\.[a-z][a-z0-9-]*)?$/).optional(),
    templateSlug: /*#__PURE__*/ z.string().min(1).optional(),
    subjectType: /*#__PURE__*/ z.enum([
        'daemon-draft',
        'workflow',
        'template',
        'tool',
        'project',
        'project_thread',
        'project_change',
        'workstream',
        'strategy',
        'dashboard',
        'analysis_template'
    ]).nullish(),
    subjectId: /*#__PURE__*/ z.string().nullish(),
    contextSpec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    runtimePolicyId: /*#__PURE__*/ z.int().gt(0).optional(),
    promptTemplateVersion: /*#__PURE__*/ z.string().nullish(),
    parentConversationId: /*#__PURE__*/ z.string().nullish(),
    projectId: /*#__PURE__*/ z.string().nullish(),
    teamId: /*#__PURE__*/ z.string().nullish()
});

export const zMessageAttachment = /*#__PURE__*/ z.object({
    uploadId: /*#__PURE__*/ z.number(),
    kind: /*#__PURE__*/ z.enum(['image', 'document']),
    name: /*#__PURE__*/ z.string(),
    mediaType: /*#__PURE__*/ z.enum([
        'image/png',
        'image/jpeg',
        'image/webp',
        'image/gif',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/markdown',
        'text/plain'
    ]),
    sizeBytes: /*#__PURE__*/ z.number()
});

export const zConversationMessage = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    conversationId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.enum([
        'user',
        'assistant',
        'system',
        'tool'
    ]),
    content: /*#__PURE__*/ z.string(),
    toolCalls: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        input: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        resultId: /*#__PURE__*/ z.string().optional()
    })).optional(),
    parts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['text']),
            content: /*#__PURE__*/ z.string().min(1)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['section']),
            title: /*#__PURE__*/ z.string().min(1),
            body: /*#__PURE__*/ z.string().optional(),
            items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                label: /*#__PURE__*/ z.string().min(1),
                value: /*#__PURE__*/ z.string().min(1),
                emphasis: /*#__PURE__*/ z.enum([
                    'normal',
                    'strong',
                    'muted',
                    'positive',
                    'warning',
                    'danger'
                ]).optional().default('normal')
            })).optional().default([])
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['table']),
            title: /*#__PURE__*/ z.string().min(1).optional(),
            columns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                id: /*#__PURE__*/ z.string().min(1),
                label: /*#__PURE__*/ z.string().min(1),
                align: /*#__PURE__*/ z.enum([
                    'left',
                    'center',
                    'right'
                ]).optional().default('left')
            })).min(1),
            rows: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.string(),
                /*#__PURE__*/ z.number(),
                /*#__PURE__*/ z.boolean()
            ]).nullable())).optional().default([])
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['checklist']),
            title: /*#__PURE__*/ z.string().min(1).optional(),
            items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                label: /*#__PURE__*/ z.string().min(1),
                detail: /*#__PURE__*/ z.string().optional(),
                status: /*#__PURE__*/ z.enum([
                    'pending',
                    'running',
                    'complete',
                    'blocked',
                    'failed'
                ]).optional().default('pending')
            })).min(1)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['proposal']),
            title: /*#__PURE__*/ z.string().min(1),
            summary: /*#__PURE__*/ z.string().optional(),
            rationale: /*#__PURE__*/ z.string().optional(),
            steps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                title: /*#__PURE__*/ z.string().min(1),
                detail: /*#__PURE__*/ z.string().optional(),
                output: /*#__PURE__*/ z.string().optional()
            })).optional().default([])
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['interaction_request']),
            interactionId: /*#__PURE__*/ z.string().optional(),
            status: /*#__PURE__*/ z.enum([
                'open',
                'submitted',
                'cancelled',
                'expired',
                'superseded'
            ]).optional().default('open'),
            request: /*#__PURE__*/ z.object({
                type: /*#__PURE__*/ z.enum(['conversation.interaction_request']),
                version: /*#__PURE__*/ z.literal(1),
                interactionKey: /*#__PURE__*/ z.string().min(1),
                title: /*#__PURE__*/ z.string().min(1),
                body: /*#__PURE__*/ z.string().optional(),
                targetKind: /*#__PURE__*/ z.enum([
                    'agent',
                    'workflow',
                    'task',
                    'project',
                    'workstream'
                ]).optional(),
                expectedOutput: /*#__PURE__*/ z.string().optional(),
                fields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum([
                            'text',
                            'textarea',
                            'rich_text',
                            'url',
                            'email',
                            'code'
                        ]),
                        placeholder: /*#__PURE__*/ z.string().optional(),
                        defaultValue: /*#__PURE__*/ z.string().optional(),
                        minLength: /*#__PURE__*/ z.int().gte(0).optional(),
                        maxLength: /*#__PURE__*/ z.int().gt(0).optional()
                    }),
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum([
                            'number',
                            'currency',
                            'percent',
                            'slider'
                        ]),
                        defaultValue: /*#__PURE__*/ z.number().optional(),
                        min: /*#__PURE__*/ z.number().optional(),
                        max: /*#__PURE__*/ z.number().optional(),
                        step: /*#__PURE__*/ z.number().gt(0).optional()
                    }),
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum(['boolean']),
                        defaultValue: /*#__PURE__*/ z.boolean().optional()
                    }),
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum([
                            'single_choice',
                            'multi_choice',
                            'select',
                            'radio',
                            'checkboxes'
                        ]),
                        options: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            value: /*#__PURE__*/ z.string().min(1),
                            label: /*#__PURE__*/ z.string().min(1),
                            description: /*#__PURE__*/ z.string().optional()
                        })).min(1),
                        defaultValue: /*#__PURE__*/ z.union([
                            /*#__PURE__*/ z.string(),
                            /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
                        ]).optional()
                    }),
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum(['combobox']),
                        options: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            value: /*#__PURE__*/ z.string().min(1),
                            label: /*#__PURE__*/ z.string().min(1),
                            description: /*#__PURE__*/ z.string().optional()
                        })).optional().default([]),
                        placeholder: /*#__PURE__*/ z.string().optional(),
                        allowCustomValue: /*#__PURE__*/ z.boolean().optional().default(false)
                    }),
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum([
                            'date',
                            'time',
                            'date_range'
                        ]),
                        defaultValue: /*#__PURE__*/ z.union([
                            /*#__PURE__*/ z.string(),
                            /*#__PURE__*/ z.object({
                                start: /*#__PURE__*/ z.string(),
                                end: /*#__PURE__*/ z.string()
                            })
                        ]).optional()
                    }),
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum([
                            'entity_picker',
                            'artifact_picker',
                            'file_picker'
                        ]),
                        entityTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
                        multiple: /*#__PURE__*/ z.boolean().optional().default(false)
                    }),
                    /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.string().min(1),
                        label: /*#__PURE__*/ z.string().min(1),
                        helpText: /*#__PURE__*/ z.string().optional(),
                        required: /*#__PURE__*/ z.boolean().optional().default(false),
                        kind: /*#__PURE__*/ z.enum([
                            'key_value',
                            'repeater',
                            'editable_table'
                        ]),
                        columns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            id: /*#__PURE__*/ z.string().min(1),
                            label: /*#__PURE__*/ z.string().min(1),
                            kind: /*#__PURE__*/ z.enum([
                                'text',
                                'number',
                                'boolean',
                                'select'
                            ]).optional().default('text'),
                            options: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                value: /*#__PURE__*/ z.string().min(1),
                                label: /*#__PURE__*/ z.string().min(1),
                                description: /*#__PURE__*/ z.string().optional()
                            })).optional()
                        })).optional(),
                        minItems: /*#__PURE__*/ z.int().gte(0).optional(),
                        maxItems: /*#__PURE__*/ z.int().gt(0).optional()
                    })
                ])).optional().default([]),
                actions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1),
                    label: /*#__PURE__*/ z.string().min(1),
                    kind: /*#__PURE__*/ z.enum([
                        'submit',
                        'cancel',
                        'decline',
                        'approve',
                        'reject',
                        'edit',
                        'url',
                        'create_task',
                        'create_project',
                        'create_project_thread',
                        'create_project_change',
                        'create_workstream',
                        'start_workflow',
                        'apply_proposal'
                    ]),
                    style: /*#__PURE__*/ z.enum([
                        'primary',
                        'secondary',
                        'danger',
                        'warning'
                    ]).optional().default('secondary'),
                    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
                })).optional().default([{
                        id: 'submit',
                        label: 'Submit',
                        kind: 'submit',
                        style: 'primary'
                    }]),
                submitLabel: /*#__PURE__*/ z.string().optional().default('Submit'),
                why: /*#__PURE__*/ z.string().optional()
            }),
            stateRef: /*#__PURE__*/ z.object({
                entityType: /*#__PURE__*/ z.enum([
                    'state_event',
                    'gate',
                    'blocker',
                    'handoff',
                    'task',
                    'project',
                    'project_thread',
                    'project_change',
                    'project_change_revision',
                    'workflow_run',
                    'conversation_interaction',
                    'action_queue_item'
                ]),
                entityId: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string().min(1),
                    /*#__PURE__*/ z.int().gt(0)
                ]),
                projectId: /*#__PURE__*/ z.int().gt(0).optional(),
                statusField: /*#__PURE__*/ z.string().min(1).optional()
            }).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['artifact_ref']),
            artifactId: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.string(),
                /*#__PURE__*/ z.number()
            ]),
            kind: /*#__PURE__*/ z.string().min(1),
            title: /*#__PURE__*/ z.string().min(1),
            summary: /*#__PURE__*/ z.string().optional(),
            stateRef: /*#__PURE__*/ z.object({
                entityType: /*#__PURE__*/ z.enum([
                    'state_event',
                    'gate',
                    'blocker',
                    'handoff',
                    'task',
                    'project',
                    'project_thread',
                    'project_change',
                    'project_change_revision',
                    'workflow_run',
                    'conversation_interaction',
                    'action_queue_item'
                ]),
                entityId: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string().min(1),
                    /*#__PURE__*/ z.int().gt(0)
                ]),
                projectId: /*#__PURE__*/ z.int().gt(0).optional(),
                statusField: /*#__PURE__*/ z.string().min(1).optional()
            }).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['progress']),
            label: /*#__PURE__*/ z.string().min(1),
            status: /*#__PURE__*/ z.enum([
                'pending',
                'running',
                'complete',
                'blocked',
                'failed'
            ]),
            detail: /*#__PURE__*/ z.string().optional(),
            stateRef: /*#__PURE__*/ z.object({
                entityType: /*#__PURE__*/ z.enum([
                    'state_event',
                    'gate',
                    'blocker',
                    'handoff',
                    'task',
                    'project',
                    'project_thread',
                    'project_change',
                    'project_change_revision',
                    'workflow_run',
                    'conversation_interaction',
                    'action_queue_item'
                ]),
                entityId: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string().min(1),
                    /*#__PURE__*/ z.int().gt(0)
                ]),
                projectId: /*#__PURE__*/ z.int().gt(0).optional(),
                statusField: /*#__PURE__*/ z.string().min(1).optional()
            }).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['warning']),
            severity: /*#__PURE__*/ z.enum([
                'info',
                'warning',
                'error'
            ]),
            message: /*#__PURE__*/ z.string().min(1),
            recommendation: /*#__PURE__*/ z.string().optional(),
            stateRef: /*#__PURE__*/ z.object({
                entityType: /*#__PURE__*/ z.enum([
                    'state_event',
                    'gate',
                    'blocker',
                    'handoff',
                    'task',
                    'project',
                    'project_thread',
                    'project_change',
                    'project_change_revision',
                    'workflow_run',
                    'conversation_interaction',
                    'action_queue_item'
                ]),
                entityId: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string().min(1),
                    /*#__PURE__*/ z.int().gt(0)
                ]),
                projectId: /*#__PURE__*/ z.int().gt(0).optional(),
                statusField: /*#__PURE__*/ z.string().min(1).optional()
            }).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['card']),
            card: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['status_summary']),
                    asOf: /*#__PURE__*/ z.string().min(1),
                    stats: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        key: /*#__PURE__*/ z.string().min(1).max(60),
                        value: /*#__PURE__*/ z.union([
                            /*#__PURE__*/ z.number(),
                            /*#__PURE__*/ z.string()
                        ]),
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        sub: /*#__PURE__*/ z.string().max(160).optional(),
                        tone: /*#__PURE__*/ z.enum([
                            'ok',
                            'warn',
                            'bad',
                            'accent',
                            'neutral'
                        ]).optional()
                    })).min(1).max(8),
                    suggestions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500)
                    })).max(6).optional()
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['entity_list']),
                    entity: /*#__PURE__*/ z.string().min(1).max(60),
                    title: /*#__PURE__*/ z.string().min(1).max(120),
                    total: /*#__PURE__*/ z.int().gte(0),
                    items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.union([
                            /*#__PURE__*/ z.string(),
                            /*#__PURE__*/ z.number()
                        ]),
                        title: /*#__PURE__*/ z.string().min(1).max(200),
                        subtitle: /*#__PURE__*/ z.string().max(240).optional(),
                        status: /*#__PURE__*/ z.object({
                            label: /*#__PURE__*/ z.string().min(1).max(40),
                            tone: /*#__PURE__*/ z.enum([
                                'ok',
                                'warn',
                                'bad',
                                'accent',
                                'neutral'
                            ]).optional()
                        }).optional(),
                        meta: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            label: /*#__PURE__*/ z.string().min(1).max(80),
                            value: /*#__PURE__*/ z.string().max(500),
                            tone: /*#__PURE__*/ z.enum([
                                'ok',
                                'warn',
                                'bad',
                                'accent',
                                'neutral'
                            ]).optional()
                        })).max(6).optional(),
                        message: /*#__PURE__*/ z.string().max(500).optional()
                    })).max(50),
                    actions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500),
                        primary: /*#__PURE__*/ z.boolean().optional(),
                        requiresApproval: /*#__PURE__*/ z.boolean().optional()
                    })).max(4).optional()
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['entity_detail']),
                    entity: /*#__PURE__*/ z.string().min(1).max(60),
                    entityId: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.string(),
                        /*#__PURE__*/ z.number()
                    ]),
                    title: /*#__PURE__*/ z.string().min(1).max(200),
                    subtitle: /*#__PURE__*/ z.string().max(240).optional(),
                    status: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(40),
                        tone: /*#__PURE__*/ z.enum([
                            'ok',
                            'warn',
                            'bad',
                            'accent',
                            'neutral'
                        ]).optional()
                    }).optional(),
                    fields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        value: /*#__PURE__*/ z.string().max(500),
                        tone: /*#__PURE__*/ z.enum([
                            'ok',
                            'warn',
                            'bad',
                            'accent',
                            'neutral'
                        ]).optional()
                    })).max(24),
                    sections: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        title: /*#__PURE__*/ z.string().min(1).max(80),
                        items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            label: /*#__PURE__*/ z.string().min(1).max(80),
                            value: /*#__PURE__*/ z.string().max(500),
                            tone: /*#__PURE__*/ z.enum([
                                'ok',
                                'warn',
                                'bad',
                                'accent',
                                'neutral'
                            ]).optional()
                        })).max(24)
                    })).max(8).optional(),
                    recommendation: /*#__PURE__*/ z.object({
                        text: /*#__PURE__*/ z.string().min(1),
                        reason: /*#__PURE__*/ z.string().min(1)
                    }).optional(),
                    actions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500),
                        primary: /*#__PURE__*/ z.boolean().optional(),
                        requiresApproval: /*#__PURE__*/ z.boolean().optional()
                    })).max(4).optional()
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['strategy_list']),
                    total: /*#__PURE__*/ z.int().gte(0),
                    items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.union([
                            /*#__PURE__*/ z.string(),
                            /*#__PURE__*/ z.number()
                        ]),
                        name: /*#__PURE__*/ z.string().min(1).max(200),
                        asset: /*#__PURE__*/ z.string().max(80),
                        timeframe: /*#__PURE__*/ z.string().max(20),
                        owner: /*#__PURE__*/ z.string().max(120),
                        stage: /*#__PURE__*/ z.enum([
                            'draft',
                            'backtested',
                            'paper',
                            'live',
                            'evaluating'
                        ]),
                        sharpe: /*#__PURE__*/ z.number().nullish(),
                        maxDrawdownPct: /*#__PURE__*/ z.number().nullish(),
                        attention: /*#__PURE__*/ z.enum(['blocked', 'approval']).nullish(),
                        message: /*#__PURE__*/ z.string().max(500).optional()
                    })).max(100),
                    suggestions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500)
                    })).max(6).optional()
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['strategy_detail']),
                    strategyId: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.string(),
                        /*#__PURE__*/ z.number()
                    ]),
                    name: /*#__PURE__*/ z.string().min(1).max(200),
                    asset: /*#__PURE__*/ z.string().max(80),
                    timeframe: /*#__PURE__*/ z.string().max(20),
                    stage: /*#__PURE__*/ z.enum([
                        'draft',
                        'backtested',
                        'paper',
                        'live',
                        'evaluating'
                    ]),
                    summary: /*#__PURE__*/ z.string().max(2000),
                    verdict: /*#__PURE__*/ z.enum([
                        'pass',
                        'needs_work',
                        'blocked'
                    ]),
                    metrics: /*#__PURE__*/ z.object({
                        sharpe: /*#__PURE__*/ z.number().nullable(),
                        maxDrawdownPct: /*#__PURE__*/ z.number().nullable(),
                        winRatePct: /*#__PURE__*/ z.number().nullable(),
                        profitFactor: /*#__PURE__*/ z.number().nullable(),
                        cagrPct: /*#__PURE__*/ z.number().nullable(),
                        trades: /*#__PURE__*/ z.int().nullable(),
                        since: /*#__PURE__*/ z.string().nullable()
                    }),
                    equityCurve: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).max(2000).optional(),
                    benchmarkCurve: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).max(2000).optional(),
                    recommendation: /*#__PURE__*/ z.object({
                        text: /*#__PURE__*/ z.string().min(1),
                        reason: /*#__PURE__*/ z.string().min(1)
                    }),
                    actions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500),
                        primary: /*#__PURE__*/ z.boolean().optional(),
                        requiresApproval: /*#__PURE__*/ z.boolean().optional()
                    })).min(1).max(4)
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['work_progress']),
                    title: /*#__PURE__*/ z.string().min(1).max(160),
                    steps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(160),
                        owner: /*#__PURE__*/ z.string().max(80).optional(),
                        state: /*#__PURE__*/ z.enum([
                            'pending',
                            'running',
                            'done',
                            'failed'
                        ])
                    })).min(1).max(12),
                    runIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()])).max(20)
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['approval_request']),
                    decisionRef: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.object({
                            kind: /*#__PURE__*/ z.enum(['daemon_decision']),
                            decisionId: /*#__PURE__*/ z.int().gt(0)
                        }),
                        /*#__PURE__*/ z.object({
                            kind: /*#__PURE__*/ z.enum(['finance_artifact']),
                            artifactId: /*#__PURE__*/ z.int().gt(0)
                        })
                    ]),
                    title: /*#__PURE__*/ z.string().min(1).max(160),
                    action: /*#__PURE__*/ z.string().min(1).max(500),
                    proposedBy: /*#__PURE__*/ z.object({
                        userId: /*#__PURE__*/ z.int().nullable(),
                        via: /*#__PURE__*/ z.string().min(1).max(80)
                    }),
                    requiredPolicy: /*#__PURE__*/ z.string().min(1).max(80),
                    eligibleApprovers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        userId: /*#__PURE__*/ z.int(),
                        name: /*#__PURE__*/ z.string().max(120),
                        department: /*#__PURE__*/ z.string().max(80).optional()
                    })).max(20),
                    riskCheck: /*#__PURE__*/ z.object({
                        passed: /*#__PURE__*/ z.boolean().nullable(),
                        notes: /*#__PURE__*/ z.string().max(1000)
                    }),
                    explanation: /*#__PURE__*/ z.string().max(2000),
                    state: /*#__PURE__*/ z.enum([
                        'draft',
                        'pending',
                        'approved',
                        'rejected',
                        'cancelled'
                    ]),
                    actions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500),
                        primary: /*#__PURE__*/ z.boolean().optional(),
                        requiresApproval: /*#__PURE__*/ z.boolean().optional()
                    })).max(4).optional(),
                    runtimePolicy: /*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.int().gt(0),
                        name: /*#__PURE__*/ z.string().min(1).max(200),
                        surface: /*#__PURE__*/ z.enum([
                            'conversation',
                            'workforce',
                            'workflow',
                            'analysis',
                            'evaluation',
                            'judge',
                            'codegen',
                            'system',
                            'research'
                        ]),
                        changeable: /*#__PURE__*/ z.boolean()
                    }).optional()
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['clarification']),
                    question: /*#__PURE__*/ z.string().min(1).max(500),
                    options: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500)
                    })).min(1).max(5),
                    allowFreeText: /*#__PURE__*/ z.literal(true)
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['comparison']),
                    window: /*#__PURE__*/ z.object({
                        from: /*#__PURE__*/ z.string(),
                        to: /*#__PURE__*/ z.string()
                    }),
                    columns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        strategyId: /*#__PURE__*/ z.union([
                            /*#__PURE__*/ z.string(),
                            /*#__PURE__*/ z.number()
                        ]),
                        name: /*#__PURE__*/ z.string().min(1)
                    })).min(2).max(6),
                    rows: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        metric: /*#__PURE__*/ z.string().min(1).max(80),
                        values: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.number(), /*#__PURE__*/ z.string()]))
                    })).max(20),
                    read: /*#__PURE__*/ z.string().max(2000),
                    actions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500),
                        primary: /*#__PURE__*/ z.boolean().optional(),
                        requiresApproval: /*#__PURE__*/ z.boolean().optional()
                    })).max(4).optional()
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['proactive_prompt']),
                    context: /*#__PURE__*/ z.object({
                        entity: /*#__PURE__*/ z.string().min(1).max(60),
                        id: /*#__PURE__*/ z.union([
                            /*#__PURE__*/ z.string(),
                            /*#__PURE__*/ z.number()
                        ]).optional()
                    }),
                    text: /*#__PURE__*/ z.string().min(1).max(300),
                    options: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500),
                        skill: /*#__PURE__*/ z.string().max(80).optional(),
                        requiresApproval: /*#__PURE__*/ z.boolean().optional()
                    })).min(1).max(5),
                    dismissible: /*#__PURE__*/ z.literal(true)
                }),
                /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.string().min(1).max(120),
                    moduleId: /*#__PURE__*/ z.string().min(1).max(50),
                    disclosure: /*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.enum(['AI simulation']),
                        text: /*#__PURE__*/ z.string().min(1).max(400),
                        handle: /*#__PURE__*/ z.string().min(1).max(81),
                        platform: /*#__PURE__*/ z.string().min(1).max(40),
                        evaluated: /*#__PURE__*/ z.boolean()
                    }).optional(),
                    type: /*#__PURE__*/ z.enum(['connection_setup']),
                    provider: /*#__PURE__*/ z.string().min(1).max(60),
                    transport: /*#__PURE__*/ z.enum([
                        'mcp',
                        'oauth',
                        'apikey'
                    ]),
                    scopes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(120)).max(20),
                    usedFor: /*#__PURE__*/ z.string().max(300),
                    state: /*#__PURE__*/ z.enum([
                        'proposed',
                        'authorized',
                        'failed'
                    ]),
                    actions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        label: /*#__PURE__*/ z.string().min(1).max(80),
                        message: /*#__PURE__*/ z.string().min(1).max(500),
                        primary: /*#__PURE__*/ z.boolean().optional(),
                        requiresApproval: /*#__PURE__*/ z.boolean().optional()
                    })).max(4).optional()
                })
            ]),
            stateRef: /*#__PURE__*/ z.object({
                entityType: /*#__PURE__*/ z.enum([
                    'state_event',
                    'gate',
                    'blocker',
                    'handoff',
                    'task',
                    'project',
                    'project_thread',
                    'project_change',
                    'project_change_revision',
                    'workflow_run',
                    'conversation_interaction',
                    'action_queue_item'
                ]),
                entityId: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.string().min(1),
                    /*#__PURE__*/ z.int().gt(0)
                ]),
                projectId: /*#__PURE__*/ z.int().gt(0).optional(),
                statusField: /*#__PURE__*/ z.string().min(1).optional()
            }).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['behind_the_scenes']),
            items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(500)).min(1).max(40)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['suggestions']),
            items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                label: /*#__PURE__*/ z.string().min(1).max(80),
                message: /*#__PURE__*/ z.string().min(1).max(500)
            })).min(1).max(6)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['disclosure']),
            disclosure: /*#__PURE__*/ z.object({
                label: /*#__PURE__*/ z.enum(['AI simulation']),
                text: /*#__PURE__*/ z.string().min(1).max(400),
                handle: /*#__PURE__*/ z.string().min(1).max(81),
                platform: /*#__PURE__*/ z.string().min(1).max(40),
                evaluated: /*#__PURE__*/ z.boolean()
            }),
            personaName: /*#__PURE__*/ z.string().min(1).max(200)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['agent_suggestion']),
            personaId: /*#__PURE__*/ z.int().gt(0),
            name: /*#__PURE__*/ z.string().min(1).max(200),
            reason: /*#__PURE__*/ z.string().min(1).max(500)
        })
    ])).optional(),
    tokenCounts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        provider: /*#__PURE__*/ z.string(),
        model: /*#__PURE__*/ z.string(),
        count: /*#__PURE__*/ z.number()
    })).optional(),
    attachments: /*#__PURE__*/ z.array(zMessageAttachment),
    author: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0),
        memberType: /*#__PURE__*/ z.enum([
            'user',
            'persona',
            'workforce_member',
            'external_agent',
            'agent_instance'
        ]),
        memberId: /*#__PURE__*/ z.int().gt(0),
        name: /*#__PURE__*/ z.string().min(1).max(200),
        role: /*#__PURE__*/ z.enum([
            'owner',
            'contributor',
            'observer',
            'lead'
        ])
    }).nullable(),
    to: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0),
        memberType: /*#__PURE__*/ z.enum([
            'user',
            'persona',
            'workforce_member',
            'external_agent',
            'agent_instance'
        ]),
        memberId: /*#__PURE__*/ z.int().gt(0),
        name: /*#__PURE__*/ z.string().min(1).max(200),
        role: /*#__PURE__*/ z.enum([
            'owner',
            'contributor',
            'observer',
            'lead'
        ]),
        status: /*#__PURE__*/ z.enum([
            'pending',
            'running',
            'answered',
            'read',
            'failed'
        ]),
        replyNeeded: /*#__PURE__*/ z.boolean(),
        reason: /*#__PURE__*/ z.string().nullable()
    })),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zIntentSeed = /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum(['direct_answer'])
    }),
    /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum(['workflow']),
        suggestedSchedule: /*#__PURE__*/ z.string().optional(),
        suggestedSteps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }),
    /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum(['task']),
        suggestedTemplateSlug: /*#__PURE__*/ z.string().optional(),
        budgetHint: /*#__PURE__*/ z.object({
            tokens: /*#__PURE__*/ z.number().optional(),
            usd: /*#__PURE__*/ z.number().optional(),
            deadlineHours: /*#__PURE__*/ z.number().optional()
        }).optional()
    }),
    /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum(['project']),
        suggestedName: /*#__PURE__*/ z.string().optional(),
        suggestedWorkstreams: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        suggestedTemplates: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }),
    /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum(['marketplace']),
        query: /*#__PURE__*/ z.string(),
        suggestedTemplateIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    }),
    /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum(['ambiguous']),
        clarificationPrompt: /*#__PURE__*/ z.string()
    })
]);

export const zIntentClassification = /*#__PURE__*/ z.object({
    kind: zConversationIntentKind,
    confidence: /*#__PURE__*/ z.number(),
    rationale: /*#__PURE__*/ z.string(),
    alternatives: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        kind: zConversationIntentKind,
        confidence: /*#__PURE__*/ z.number(),
        suggestedLabel: /*#__PURE__*/ z.string()
    })),
    seed: zIntentSeed
});

export const zDispatchOutcome = /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.object({
        dispatched: /*#__PURE__*/ z.enum(['direct_answer'])
    }),
    /*#__PURE__*/ z.object({
        dispatched: /*#__PURE__*/ z.enum(['workflow']),
        workflowDraftId: /*#__PURE__*/ z.number()
    }),
    /*#__PURE__*/ z.object({
        dispatched: /*#__PURE__*/ z.enum(['task']),
        taskId: /*#__PURE__*/ z.number()
    }),
    /*#__PURE__*/ z.object({
        dispatched: /*#__PURE__*/ z.enum(['project']),
        projectId: /*#__PURE__*/ z.number(),
        workstreamId: /*#__PURE__*/ z.number()
    }),
    /*#__PURE__*/ z.object({
        dispatched: /*#__PURE__*/ z.enum(['marketplace']),
        recommendationId: /*#__PURE__*/ z.number()
    }),
    /*#__PURE__*/ z.object({
        dispatched: /*#__PURE__*/ z.enum(['ambiguous']),
        disambiguationMessageId: /*#__PURE__*/ z.number()
    })
]);

export const zConversationQuickStartResult = /*#__PURE__*/ z.object({
    conversation: zConversation,
    message: zConversationMessage,
    intent: /*#__PURE__*/ zIntentClassification.optional(),
    dispatch: /*#__PURE__*/ zDispatchOutcome.optional()
});

export const zConversationQuickStart = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string().max(8000),
    attachments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).max(5).optional(),
    projectId: /*#__PURE__*/ z.string().regex(/^\d+$/).nullish(),
    teamId: /*#__PURE__*/ z.string().regex(/^\d+$/).nullish(),
    parentConversationId: /*#__PURE__*/ z.string().regex(/^\d+$/).nullish(),
    subjectType: /*#__PURE__*/ z.enum([
        'daemon-draft',
        'workflow',
        'template',
        'tool',
        'project',
        'project_thread',
        'project_change',
        'workstream',
        'strategy'
    ]).nullish(),
    subjectId: /*#__PURE__*/ z.string().nullish(),
    templateSlug: /*#__PURE__*/ z.string().min(1).max(100).optional(),
    entryPoint: /*#__PURE__*/ z.string().min(1).max(80).regex(/^[a-z][a-z0-9-]*(\.[a-z][a-z0-9-]*)?$/).optional(),
    runtimePolicyId: /*#__PURE__*/ z.int().gt(0).optional(),
    topic: /*#__PURE__*/ z.string().min(1).max(256).optional(),
    moduleId: /*#__PURE__*/ z.string().max(50).optional(),
    surface: /*#__PURE__*/ z.enum(['simple', 'detailed']).optional(),
    commandContext: /*#__PURE__*/ z.object({
        version: /*#__PURE__*/ z.literal(1),
        source: /*#__PURE__*/ z.enum(['conversation_composer']),
        activeCommand: /*#__PURE__*/ z.string().min(1).max(40).optional(),
        references: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.string().min(1).max(40),
            id: /*#__PURE__*/ z.string().min(1).max(160),
            label: /*#__PURE__*/ z.string().min(1).max(200),
            moduleId: /*#__PURE__*/ z.string().min(1).max(40),
            metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.string().max(500),
                /*#__PURE__*/ z.number(),
                /*#__PURE__*/ z.boolean()
            ])).optional()
        })).max(24).optional().default([]),
        researchPrompt: /*#__PURE__*/ z.string().min(1).max(2000).optional(),
        routingHints: /*#__PURE__*/ z.object({
            moduleId: /*#__PURE__*/ z.string().min(1).max(40).optional(),
            preferredPersonaSlug: /*#__PURE__*/ z.string().min(1).max(120).optional(),
            preferredIntent: /*#__PURE__*/ z.string().min(1).max(60).optional(),
            artifactKinds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(80)).max(10).optional(),
            workflowRequested: /*#__PURE__*/ z.boolean().optional()
        }).optional(),
        promptContextSections: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            title: /*#__PURE__*/ z.string().min(1).max(160),
            content: /*#__PURE__*/ z.string().min(1).max(4000)
        })).max(8).optional()
    }).optional(),
    contextSpec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zConversationUpdate = /*#__PURE__*/ z.object({
    topic: /*#__PURE__*/ z.string().min(1).max(256).optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'idle',
        'completed',
        'errored'
    ]).optional(),
    templateSlug: /*#__PURE__*/ z.string().min(1).max(100).optional(),
    groupId: /*#__PURE__*/ z.string().nullish(),
    pinned: /*#__PURE__*/ z.boolean().optional()
});

export const zConversationActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zConversationInviteRequest = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'persona',
        'workforce_member',
        'external_agent'
    ]),
    memberId: /*#__PURE__*/ z.int().gt(0),
    role: /*#__PURE__*/ z.enum(['contributor', 'observer']).optional()
});

export const zConversationMemberActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zConversationEntity = /*#__PURE__*/ z.object({
    entity: /*#__PURE__*/ z.string(),
    id: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    subtitle: /*#__PURE__*/ z.string().optional(),
    lastReferencedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zConversationAttachRequest = /*#__PURE__*/ z.object({
    attachedType: /*#__PURE__*/ z.enum([
        'artifact',
        'memory',
        'task',
        'conversation',
        'project',
        'workflow'
    ]),
    attachedId: /*#__PURE__*/ z.int().gt(0),
    role: /*#__PURE__*/ z.enum([
        'context',
        'reference',
        'dependency',
        'handoff-payload'
    ]).optional()
});

export const zConversationAttachmentActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zIntentClassificationDecisionPayload = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.number(),
    approvedAt: /*#__PURE__*/ z.iso.datetime(),
    conversationId: /*#__PURE__*/ z.number(),
    messageId: /*#__PURE__*/ z.number(),
    classification: zIntentClassification,
    inputHash: /*#__PURE__*/ z.string(),
    disambiguatedFromDecisionId: /*#__PURE__*/ z.number().nullable(),
    modelStamp: /*#__PURE__*/ z.string(),
    latencyMs: /*#__PURE__*/ z.number()
});

export const zIntentList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntentClassificationDecisionPayload),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.string()
    })
});

export const zConversationIntentDisambiguateResult = /*#__PURE__*/ z.object({
    decision: zIntentClassificationDecisionPayload,
    dispatch: zDispatchOutcome
});

export const zConversationIntentDisambiguateRequest = /*#__PURE__*/ z.object({
    kind: zConversationIntentKind
});

export const zConversationIntentSettings = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    intentClassificationDisabled: /*#__PURE__*/ z.boolean(),
    lastIntentKind: /*#__PURE__*/ zConversationIntentKind.nullable()
});

export const zConversationReply = /*#__PURE__*/ z.object({
    message: zConversationMessage,
    intent: /*#__PURE__*/ zIntentClassification.optional(),
    dispatch: /*#__PURE__*/ zDispatchOutcome.optional()
});

export const zConversationReplyRequest = /*#__PURE__*/ z.object({
    content: /*#__PURE__*/ z.string().max(8000),
    role: /*#__PURE__*/ z.enum(['user', 'assistant']),
    toolCalls: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        input: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        resultId: /*#__PURE__*/ z.string().optional()
    })).optional(),
    contextSpec: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    commandContext: /*#__PURE__*/ z.object({
        version: /*#__PURE__*/ z.literal(1),
        source: /*#__PURE__*/ z.enum(['conversation_composer']),
        activeCommand: /*#__PURE__*/ z.string().min(1).max(40).optional(),
        references: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.string().min(1).max(40),
            id: /*#__PURE__*/ z.string().min(1).max(160),
            label: /*#__PURE__*/ z.string().min(1).max(200),
            moduleId: /*#__PURE__*/ z.string().min(1).max(40),
            metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.string().max(500),
                /*#__PURE__*/ z.number(),
                /*#__PURE__*/ z.boolean()
            ])).optional()
        })).max(24).optional().default([]),
        researchPrompt: /*#__PURE__*/ z.string().min(1).max(2000).optional(),
        routingHints: /*#__PURE__*/ z.object({
            moduleId: /*#__PURE__*/ z.string().min(1).max(40).optional(),
            preferredPersonaSlug: /*#__PURE__*/ z.string().min(1).max(120).optional(),
            preferredIntent: /*#__PURE__*/ z.string().min(1).max(60).optional(),
            artifactKinds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(80)).max(10).optional(),
            workflowRequested: /*#__PURE__*/ z.boolean().optional()
        }).optional(),
        promptContextSections: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            title: /*#__PURE__*/ z.string().min(1).max(160),
            content: /*#__PURE__*/ z.string().min(1).max(4000)
        })).max(8).optional()
    }).optional(),
    surface: /*#__PURE__*/ z.enum(['simple', 'detailed']).optional(),
    interactionResponse: /*#__PURE__*/ z.object({
        sourceMessageId: /*#__PURE__*/ z.string().min(1),
        interactionId: /*#__PURE__*/ z.string().min(1),
        values: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        freeText: /*#__PURE__*/ z.string().max(8000).optional()
    }).optional(),
    to: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).max(20).optional(),
    answers: /*#__PURE__*/ z.int().gt(0).optional(),
    attachments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).max(5).optional()
});

export const zConversationInteractionSubmitRequest = /*#__PURE__*/ z.object({
    action: /*#__PURE__*/ z.enum([
        'submit',
        'cancel',
        'decline',
        'approve',
        'reject',
        'edit',
        'url',
        'create_task',
        'create_project',
        'create_project_thread',
        'create_project_change',
        'create_workstream',
        'start_workflow',
        'apply_proposal'
    ]).optional().default('submit'),
    values: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
    displayText: /*#__PURE__*/ z.string().min(1).max(8000).optional(),
    idempotencyKey: /*#__PURE__*/ z.string().min(1).max(200),
    surface: /*#__PURE__*/ z.enum(['simple', 'detailed']).optional()
});

export const zConversationMessageList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zConversationMessage),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zConversationClosePanelRequest = /*#__PURE__*/ z.object({
    summary: /*#__PURE__*/ z.string().min(1).max(2000)
});

export const zConversationTypingRequest = /*#__PURE__*/ z.object({
    typing: /*#__PURE__*/ z.boolean()
});

export const zConversationRuntimePolicyWrite = /*#__PURE__*/ z.object({
    runtimePolicyId: /*#__PURE__*/ z.int().gt(0)
});

export const zConversationSettingsPatchResult = /*#__PURE__*/ z.object({
    ok: /*#__PURE__*/ z.boolean()
});

export const zConversationSettingsPatch = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zConversationContextResult = /*#__PURE__*/ z.object({
    lastContextPackPublicView: /*#__PURE__*/ z.object({
        schemaVersion: /*#__PURE__*/ z.literal(1),
        conversationId: /*#__PURE__*/ z.number(),
        organizationId: /*#__PURE__*/ z.number(),
        template: /*#__PURE__*/ z.object({
            slug: /*#__PURE__*/ z.string(),
            name: /*#__PURE__*/ z.string(),
            planMode: /*#__PURE__*/ z.boolean().optional().default(false),
            subAgents: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([])
        }),
        skills: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            slug: /*#__PURE__*/ z.string(),
            kind: /*#__PURE__*/ z.enum(['skill']),
            name: /*#__PURE__*/ z.string(),
            description: /*#__PURE__*/ z.string().nullish(),
            category: /*#__PURE__*/ z.string().optional(),
            priority: /*#__PURE__*/ z.number(),
            versionId: /*#__PURE__*/ z.number().optional(),
            invocationDescription: /*#__PURE__*/ z.string().nullish()
        })),
        tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            name: /*#__PURE__*/ z.string(),
            description: /*#__PURE__*/ z.string().optional(),
            invocationDescription: /*#__PURE__*/ z.string().nullish(),
            inputSchema: /*#__PURE__*/ z.unknown().optional(),
            visibility: /*#__PURE__*/ z.enum([
                'private',
                'org',
                'public',
                'marketplace',
                'system'
            ]).optional(),
            host: /*#__PURE__*/ z.enum([
                'engine',
                'worker',
                'mcp',
                'provider'
            ]).optional()
        })),
        slashCommands: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            slug: /*#__PURE__*/ z.string(),
            kind: /*#__PURE__*/ z.enum(['slash_command']),
            name: /*#__PURE__*/ z.string(),
            description: /*#__PURE__*/ z.string(),
            handlerLocation: /*#__PURE__*/ z.enum([
                'client',
                'server',
                'engine'
            ]),
            argSchemaJson: /*#__PURE__*/ z.unknown().optional()
        })),
        outputContracts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            slug: /*#__PURE__*/ z.string(),
            kind: /*#__PURE__*/ z.enum(['output_contract']),
            name: /*#__PURE__*/ z.string(),
            visibility: /*#__PURE__*/ z.enum([
                'system',
                'public',
                'organization',
                'org',
                'private',
                'marketplace'
            ]),
            wireFormat: /*#__PURE__*/ z.enum(['json', 'tool-call']),
            discriminator: /*#__PURE__*/ z.string().optional(),
            discriminatorValue: /*#__PURE__*/ z.string(),
            payloadSchemaJson: /*#__PURE__*/ z.unknown().optional(),
            promptInstruction: /*#__PURE__*/ z.string(),
            applicabilityRule: /*#__PURE__*/ z.string()
        })),
        settings: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        assembledAt: /*#__PURE__*/ z.string()
    }).nullable(),
    lastContextPackHash: /*#__PURE__*/ z.string().nullable()
});

export const zArtifact = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    organizationId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]),
    subjectType: /*#__PURE__*/ z.string(),
    subjectId: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]),
    title: /*#__PURE__*/ z.string(),
    content: /*#__PURE__*/ z.string(),
    metadata: /*#__PURE__*/ z.object({
        version: /*#__PURE__*/ z.string().optional(),
        tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        references: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        custom: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
    }).nullable(),
    authoredBy: /*#__PURE__*/ z.string().nullable(),
    immutable: /*#__PURE__*/ z.boolean(),
    authorName: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    deletedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zArtifactList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zArtifact),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zArtifactSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    organizationId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]),
    subjectType: /*#__PURE__*/ z.string(),
    subjectId: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]),
    title: /*#__PURE__*/ z.string(),
    metadata: /*#__PURE__*/ z.object({
        version: /*#__PURE__*/ z.string().optional(),
        tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        references: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        custom: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
    }).nullable(),
    authoredBy: /*#__PURE__*/ z.string().nullable(),
    immutable: /*#__PURE__*/ z.boolean(),
    authorName: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    deletedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zArtifactSummaryList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zArtifactSummary),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zUploadPresignResult = /*#__PURE__*/ z.object({
    uploadId: /*#__PURE__*/ z.number(),
    uploadUrl: /*#__PURE__*/ z.string(),
    expiresAt: /*#__PURE__*/ z.iso.datetime()
});

export const zUploadPresignRequest = /*#__PURE__*/ z.object({
    fileName: /*#__PURE__*/ z.string().min(1).max(255),
    mediaType: /*#__PURE__*/ z.string().min(1).max(120),
    sizeBytes: /*#__PURE__*/ z.int().gt(0)
});

export const zUpload = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    kind: /*#__PURE__*/ z.enum(['image', 'document']),
    name: /*#__PURE__*/ z.string(),
    mediaType: /*#__PURE__*/ z.enum([
        'image/png',
        'image/jpeg',
        'image/webp',
        'image/gif',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/markdown',
        'text/plain'
    ]),
    sizeBytes: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'ready',
        'failed'
    ])
});

export const zMemory = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    organizationId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]),
    subjectType: /*#__PURE__*/ z.string(),
    subjectId: /*#__PURE__*/ z.string(),
    factText: /*#__PURE__*/ z.string(),
    sourceConversationId: /*#__PURE__*/ z.string().nullable(),
    promotedFrom: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    createdBy: /*#__PURE__*/ z.string(),
    deletedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zMemoryList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zMemory),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zMemoryCreate = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]),
    subjectType: /*#__PURE__*/ z.enum([
        'conversation_id',
        'team_id',
        'task_id',
        'project_id',
        'agent_template_id',
        'daemon_id',
        'organization_id'
    ]),
    subjectId: /*#__PURE__*/ z.string(),
    factText: /*#__PURE__*/ z.string().min(1).max(5000)
});

export const zMemoryUpdate = /*#__PURE__*/ z.object({
    factText: /*#__PURE__*/ z.string().min(1).max(5000)
});

export const zMemoryActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zMemoryPromoteRequest = /*#__PURE__*/ z.object({
    targetScope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]),
    newSubjectId: /*#__PURE__*/ z.string(),
    newSubjectType: /*#__PURE__*/ z.enum([
        'conversation_id',
        'team_id',
        'task_id',
        'project_id',
        'agent_template_id',
        'daemon_id',
        'organization_id'
    ]).optional()
});

export const zArtifactCreate = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]),
    subjectType: /*#__PURE__*/ z.string(),
    subjectId: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]),
    title: /*#__PURE__*/ z.string().min(1).max(200),
    content: /*#__PURE__*/ z.string().min(1)
});

export const zArtifactUpdate = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    content: /*#__PURE__*/ z.string().min(1).optional(),
    kind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]).optional()
});

export const zArtifactActionResult = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zProjectTeamMember = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    teamId: /*#__PURE__*/ z.number(),
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]),
    memberId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.enum(['lead', 'contributor']),
    joinedAt: /*#__PURE__*/ z.iso.datetime(),
    leftAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zTeamMemberAddRequest = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]),
    memberId: /*#__PURE__*/ z.int().gt(0),
    role: /*#__PURE__*/ z.enum(['lead', 'contributor']).optional()
});

export const zTeamMemberUpdateRoleRequest = /*#__PURE__*/ z.object({
    role: /*#__PURE__*/ z.enum(['lead', 'contributor'])
});

export const zProjectTeam = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    name: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string(),
    brief: /*#__PURE__*/ z.string().nullable(),
    kind: /*#__PURE__*/ z.enum([
        'user',
        'agent_squad',
        'mixed'
    ]),
    visibility: /*#__PURE__*/ z.enum(['public', 'private']),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    deletedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zProjectTeamCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200),
    slug: /*#__PURE__*/ z.string().min(1).max(100),
    brief: /*#__PURE__*/ z.string().max(2000).optional(),
    kind: /*#__PURE__*/ z.enum([
        'user',
        'agent_squad',
        'mixed'
    ]).optional(),
    visibility: /*#__PURE__*/ z.enum(['public', 'private']).optional()
});

export const zProjectTeamUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    brief: /*#__PURE__*/ z.string().max(2000).nullish(),
    kind: /*#__PURE__*/ z.enum([
        'user',
        'agent_squad',
        'mixed'
    ]).optional(),
    visibility: /*#__PURE__*/ z.enum(['public', 'private']).optional()
});

export const zProjectMember = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]),
    memberId: /*#__PURE__*/ z.number(),
    displayName: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.enum([
        'owner',
        'manager',
        'contributor',
        'observer'
    ]),
    autoJoined: /*#__PURE__*/ z.boolean(),
    joinedAt: /*#__PURE__*/ z.iso.datetime(),
    leftAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    invitedBy: /*#__PURE__*/ z.number().nullable(),
    requiresMemberApproval: /*#__PURE__*/ z.boolean()
});

export const zProjectMemberAddRequest = /*#__PURE__*/ z.object({
    memberId: /*#__PURE__*/ z.int().gt(0),
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]),
    role: /*#__PURE__*/ z.enum(['contributor', 'observer']).optional().default('contributor')
});

export const zProjectMemberUpdateRoleRequest = /*#__PURE__*/ z.object({
    role: /*#__PURE__*/ z.enum([
        'manager',
        'contributor',
        'observer'
    ])
});

export const zCoordinationGate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    projectId: /*#__PURE__*/ z.int().gt(0).nullable(),
    workstreamId: /*#__PURE__*/ z.int().gt(0).nullable(),
    gateKind: /*#__PURE__*/ z.string(),
    actionType: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'request_changes',
        'expired',
        'superseded',
        'cancelled'
    ]),
    subject: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string().min(1),
        id: /*#__PURE__*/ z.string().min(1),
        versionHash: /*#__PURE__*/ z.string().nullish()
    }),
    requestedTransition: /*#__PURE__*/ z.object({
        machine: /*#__PURE__*/ z.enum([
            'project',
            'project_thread',
            'project_change',
            'project_change_revision',
            'task',
            'workflow_run',
            'gate',
            'blocker',
            'handoff',
            'conversation_interaction',
            'action_queue_item',
            'improvement_proposal'
        ]).nullable(),
        event: /*#__PURE__*/ z.string().nullable(),
        fromStatus: /*#__PURE__*/ z.string().nullable(),
        toStatus: /*#__PURE__*/ z.string().nullable()
    }),
    requiredDecider: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish(),
        class: /*#__PURE__*/ z.string().nullable(),
        capabilityKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }),
    openedBy: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }),
    assignedActor: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }).nullable(),
    sourceEventId: /*#__PURE__*/ z.int().gt(0).nullable(),
    correlationId: /*#__PURE__*/ z.string().nullable(),
    dedupeKey: /*#__PURE__*/ z.string().nullable(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCoordinationBlocker = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    projectId: /*#__PURE__*/ z.int().gt(0).nullable(),
    blockerType: /*#__PURE__*/ z.enum([
        'missing_input',
        'approval_required',
        'security_gate',
        'quality_gate',
        'validation_failed',
        'tool_permission',
        'dependency_failed',
        'handoff_pending',
        'agent_unavailable',
        'budget_limit',
        'external_service',
        'conflict',
        'unknown'
    ]),
    reasonCode: /*#__PURE__*/ z.string().nullable(),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    priority: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'urgent'
    ]),
    status: /*#__PURE__*/ z.enum([
        'open',
        'acknowledged',
        'assigned',
        'waiting',
        'resolved',
        'dismissed',
        'superseded'
    ]),
    title: /*#__PURE__*/ z.string(),
    summary: /*#__PURE__*/ z.string().nullable(),
    requiredAction: /*#__PURE__*/ z.string().nullable(),
    blockedEntity: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string().min(1),
        id: /*#__PURE__*/ z.string().min(1),
        versionHash: /*#__PURE__*/ z.string().nullish()
    }),
    owner: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }).nullable(),
    reportedBy: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }).nullable(),
    blockingOn: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string().min(1),
        id: /*#__PURE__*/ z.string().min(1),
        versionHash: /*#__PURE__*/ z.string().nullish()
    }).nullable(),
    sourceEventId: /*#__PURE__*/ z.int().gt(0).nullable(),
    resolutionEventId: /*#__PURE__*/ z.int().gt(0).nullable(),
    correlationId: /*#__PURE__*/ z.string().nullable(),
    dedupeKey: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    resolvedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zCoordinationHandoff = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    projectId: /*#__PURE__*/ z.int().gt(0).nullable(),
    subject: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string().min(1),
        id: /*#__PURE__*/ z.string().min(1),
        versionHash: /*#__PURE__*/ z.string().nullish()
    }),
    handoffKind: /*#__PURE__*/ z.string(),
    intent: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'requested',
        'accepted',
        'in_progress',
        'blocked',
        'returned',
        'completed',
        'failed',
        'cancelled',
        'expired',
        'superseded'
    ]),
    sourceActor: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }),
    targetActor: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }),
    targetActorClass: /*#__PURE__*/ z.string().nullable(),
    targetTemplateSlug: /*#__PURE__*/ z.string().nullable(),
    sourceConversationId: /*#__PURE__*/ z.int().gt(0).nullable(),
    targetConversationId: /*#__PURE__*/ z.int().gt(0).nullable(),
    blockerId: /*#__PURE__*/ z.int().gt(0).nullable(),
    gateId: /*#__PURE__*/ z.int().gt(0).nullable(),
    sourceEventId: /*#__PURE__*/ z.int().gt(0).nullable(),
    completedEventId: /*#__PURE__*/ z.int().gt(0).nullable(),
    correlationId: /*#__PURE__*/ z.string().nullable(),
    dedupeKey: /*#__PURE__*/ z.string().nullable(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCoordinationActionQueueItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    projectId: /*#__PURE__*/ z.int().gt(0).nullable(),
    itemType: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'open',
        'claimed',
        'waiting',
        'resolved',
        'cancelled',
        'expired'
    ]),
    subject: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string().min(1),
        id: /*#__PURE__*/ z.string().min(1),
        versionHash: /*#__PURE__*/ z.string().nullish()
    }),
    targetActor: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }).nullable(),
    targetActorClass: /*#__PURE__*/ z.string().nullable(),
    requiredCapabilityKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    priority: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'urgent'
    ]),
    availableAt: /*#__PURE__*/ z.iso.datetime(),
    dueAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    leaseExpiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    claimedBy: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }).nullable(),
    dedupeKey: /*#__PURE__*/ z.string().nullable(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    sourceEventId: /*#__PURE__*/ z.int().gt(0).nullable(),
    resolvedEventId: /*#__PURE__*/ z.int().gt(0).nullable(),
    resolvedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCoordinationStateEvent = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    machineKey: /*#__PURE__*/ z.enum([
        'project',
        'project_thread',
        'project_change',
        'project_change_revision',
        'task',
        'workflow_run',
        'gate',
        'blocker',
        'handoff',
        'conversation_interaction',
        'action_queue_item',
        'improvement_proposal'
    ]).nullable(),
    entityType: /*#__PURE__*/ z.string(),
    entityId: /*#__PURE__*/ z.string(),
    eventType: /*#__PURE__*/ z.string(),
    transitionEvent: /*#__PURE__*/ z.string().nullable(),
    fromStatus: /*#__PURE__*/ z.string().nullable(),
    toStatus: /*#__PURE__*/ z.string().nullable(),
    actorType: /*#__PURE__*/ z.enum([
        'human_user',
        'agent',
        'daemon',
        'system',
        'worker',
        'api',
        'service_account'
    ]),
    actorId: /*#__PURE__*/ z.string().nullable(),
    causationType: /*#__PURE__*/ z.string().nullable(),
    causationId: /*#__PURE__*/ z.string().nullable(),
    correlationId: /*#__PURE__*/ z.string().nullable(),
    traceId: /*#__PURE__*/ z.string().nullable(),
    idempotencyKey: /*#__PURE__*/ z.string().max(240).nullable(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    occurredAt: /*#__PURE__*/ z.iso.datetime()
});

export const zProjectState = /*#__PURE__*/ z.object({
    gates: /*#__PURE__*/ z.array(zCoordinationGate),
    blockers: /*#__PURE__*/ z.array(zCoordinationBlocker),
    handoffs: /*#__PURE__*/ z.array(zCoordinationHandoff),
    actionQueue: /*#__PURE__*/ z.array(zCoordinationActionQueueItem),
    recentEvents: /*#__PURE__*/ z.array(zCoordinationStateEvent),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime()
    })
});

export const zStateEventList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCoordinationStateEvent)
});

export const zProject = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    moduleId: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string(),
    brief: /*#__PURE__*/ z.string().nullable(),
    icon: /*#__PURE__*/ z.string().nullable(),
    color: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'on_hold',
        'archived',
        'closed'
    ]),
    archivedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    closedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    deletedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zProjectList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zProject),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zProjectThread = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    rootConversationId: /*#__PURE__*/ z.number().nullable(),
    title: /*#__PURE__*/ z.string(),
    summary: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'completed',
        'archived'
    ]),
    currentWorkMode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]),
    primaryChangeId: /*#__PURE__*/ z.number().nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zProjectChange = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    projectThreadId: /*#__PURE__*/ z.number(),
    number: /*#__PURE__*/ z.number(),
    title: /*#__PURE__*/ z.string(),
    target: /*#__PURE__*/ z.string().nullable(),
    summary: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'planned',
        'implementing',
        'checking',
        'reviewing',
        'ready_to_merge',
        'merged',
        'blocked',
        'abandoned'
    ]),
    workMode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]),
    backend: /*#__PURE__*/ z.enum([
        'none',
        'local_git',
        'github',
        'gitlab',
        'gitea',
        'forgejo',
        'gerrit'
    ]),
    baseRef: /*#__PURE__*/ z.string().nullable(),
    branchName: /*#__PURE__*/ z.string().nullable(),
    workspaceId: /*#__PURE__*/ z.number().nullable(),
    providerRef: /*#__PURE__*/ z.string().nullable(),
    reviewUrl: /*#__PURE__*/ z.string().nullable(),
    latestCheckStatus: /*#__PURE__*/ z.string().nullable(),
    blockedReason: /*#__PURE__*/ z.string().nullable(),
    currentRevisionId: /*#__PURE__*/ z.number().nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zProjectThreadResource = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    projectThreadId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number().nullable(),
    resourceType: /*#__PURE__*/ z.enum([
        'conversation',
        'artifact',
        'task',
        'workstream',
        'workflow_run',
        'workforce_member',
        'decision',
        'gate',
        'blocker',
        'handoff',
        'state_event',
        'code_workspace',
        'code_checkpoint'
    ]),
    resourceId: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zProjectChangeReadinessCheck = /*#__PURE__*/ z.object({
    changeId: /*#__PURE__*/ z.number(),
    check: /*#__PURE__*/ z.enum([
        'scope',
        'branch',
        'validation',
        'review',
        'blockers'
    ]),
    status: /*#__PURE__*/ z.enum([
        'pass',
        'warning',
        'block'
    ]),
    label: /*#__PURE__*/ z.string(),
    detail: /*#__PURE__*/ z.string()
});

export const zProjectLifecyclePhase = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.enum([
        'plan',
        'build',
        'review',
        'ship',
        'operate'
    ]),
    label: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'ready',
        'active',
        'blocked',
        'empty'
    ]),
    detail: /*#__PURE__*/ z.string(),
    workModes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ])),
    blockerCount: /*#__PURE__*/ z.number(),
    warningCount: /*#__PURE__*/ z.number(),
    outputCount: /*#__PURE__*/ z.number(),
    chips: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        label: /*#__PURE__*/ z.string(),
        tone: /*#__PURE__*/ z.enum([
            'blue',
            'green',
            'red',
            'yellow',
            ''
        ])
    }))
});

export const zProjectWorkModeTemplate = /*#__PURE__*/ z.object({
    mode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]),
    phase: /*#__PURE__*/ z.enum([
        'plan',
        'build',
        'review',
        'ship',
        'operate'
    ]),
    label: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    expectedOutputs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    assistantPrompt: /*#__PURE__*/ z.string(),
    source: /*#__PURE__*/ z.enum([
        'platform_default',
        'project_template',
        'module_override',
        'project_override'
    ]),
    sourceRef: /*#__PURE__*/ z.string().optional(),
    sortOrder: /*#__PURE__*/ z.number()
});

export const zProjectNextAction = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum(['assistant', 'navigation']),
    priority: /*#__PURE__*/ z.number(),
    label: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    prompt: /*#__PURE__*/ z.string(),
    tab: /*#__PURE__*/ z.string().optional()
});

export const zAttentionQueueItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'blocker',
        'approval',
        'failed-gate',
        'gate',
        'stalled-agent',
        'artifact',
        'stale'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'r',
        'y',
        'b',
        'g',
        'n'
    ]),
    title: /*#__PURE__*/ z.string(),
    ownerInitials: /*#__PURE__*/ z.string(),
    ownerIsAgent: /*#__PURE__*/ z.boolean(),
    threadId: /*#__PURE__*/ z.number().nullable(),
    threadTitle: /*#__PURE__*/ z.string().nullable(),
    changeId: /*#__PURE__*/ z.number().nullable(),
    ageLabel: /*#__PURE__*/ z.string()
});

export const zAgentHealth = /*#__PURE__*/ z.object({
    running: /*#__PURE__*/ z.number(),
    idle: /*#__PURE__*/ z.number(),
    doneToday: /*#__PURE__*/ z.number(),
    failed: /*#__PURE__*/ z.number(),
    stalled: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        role: /*#__PURE__*/ z.string(),
        threadId: /*#__PURE__*/ z.number(),
        count: /*#__PURE__*/ z.number()
    }))
});

export const zProjectCounts = /*#__PURE__*/ z.object({
    threads: /*#__PURE__*/ z.number(),
    changes: /*#__PURE__*/ z.number(),
    blockedChanges: /*#__PURE__*/ z.number(),
    artifacts: /*#__PURE__*/ z.number(),
    tasks: /*#__PURE__*/ z.number(),
    awaitingTasks: /*#__PURE__*/ z.number(),
    workforce: /*#__PURE__*/ z.number()
});

export const zProjectActivityItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.enum([
        'thread',
        'change',
        'resource'
    ]),
    title: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    timestamp: /*#__PURE__*/ z.iso.datetime(),
    projectThreadId: /*#__PURE__*/ z.number().optional(),
    projectChangeId: /*#__PURE__*/ z.number().optional(),
    resourceType: /*#__PURE__*/ z.enum([
        'conversation',
        'artifact',
        'task',
        'workstream',
        'workflow_run',
        'workforce_member',
        'decision',
        'gate',
        'blocker',
        'handoff',
        'state_event',
        'code_workspace',
        'code_checkpoint'
    ]).optional(),
    resourceId: /*#__PURE__*/ z.string().optional()
});

export const zProjectThreadOwner = /*#__PURE__*/ z.object({
    threadId: /*#__PURE__*/ z.number(),
    initials: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string(),
    isAgent: /*#__PURE__*/ z.boolean()
});

export const zProjectCommandCenter = /*#__PURE__*/ z.object({
    project: zProject,
    threads: /*#__PURE__*/ z.array(zProjectThread),
    activeThreads: /*#__PURE__*/ z.array(zProjectThread),
    changes: /*#__PURE__*/ z.array(zProjectChange),
    activeChanges: /*#__PURE__*/ z.array(zProjectChange),
    resources: /*#__PURE__*/ z.array(zProjectThreadResource),
    resourceCounts: /*#__PURE__*/ z.object({
        conversation: /*#__PURE__*/ z.number().optional(),
        artifact: /*#__PURE__*/ z.number().optional(),
        task: /*#__PURE__*/ z.number().optional(),
        workstream: /*#__PURE__*/ z.number().optional(),
        workflow_run: /*#__PURE__*/ z.number().optional(),
        workforce_member: /*#__PURE__*/ z.number().optional(),
        decision: /*#__PURE__*/ z.number().optional(),
        gate: /*#__PURE__*/ z.number().optional(),
        blocker: /*#__PURE__*/ z.number().optional(),
        handoff: /*#__PURE__*/ z.number().optional(),
        state_event: /*#__PURE__*/ z.number().optional(),
        code_workspace: /*#__PURE__*/ z.number().optional(),
        code_checkpoint: /*#__PURE__*/ z.number().optional()
    }),
    readinessChecks: /*#__PURE__*/ z.array(zProjectChangeReadinessCheck),
    lifecycle: /*#__PURE__*/ z.array(zProjectLifecyclePhase),
    workModeTemplates: /*#__PURE__*/ z.array(zProjectWorkModeTemplate),
    nextActions: /*#__PURE__*/ z.array(zProjectNextAction),
    attentionQueue: /*#__PURE__*/ z.array(zAttentionQueueItem),
    agentHealth: zAgentHealth,
    mostRecentThread: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        title: /*#__PURE__*/ z.string(),
        updatedAt: /*#__PURE__*/ z.iso.datetime(),
        isBlocked: /*#__PURE__*/ z.boolean()
    }).nullable(),
    counts: zProjectCounts,
    activity: /*#__PURE__*/ z.array(zProjectActivityItem),
    blockers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        changeId: /*#__PURE__*/ z.number(),
        title: /*#__PURE__*/ z.string(),
        reason: /*#__PURE__*/ z.string()
    })),
    threadOwners: /*#__PURE__*/ z.array(zProjectThreadOwner),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime()
    })
});

export const zProjectWorkModeTemplateInput = /*#__PURE__*/ z.object({
    mode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]),
    phase: /*#__PURE__*/ z.enum([
        'plan',
        'build',
        'review',
        'ship',
        'operate'
    ]),
    label: /*#__PURE__*/ z.string().min(1).max(120),
    description: /*#__PURE__*/ z.string().min(1).max(2000),
    expectedOutputs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(120)).min(1),
    assistantPrompt: /*#__PURE__*/ z.string().min(1).max(4000),
    source: /*#__PURE__*/ z.enum([
        'platform_default',
        'project_template',
        'module_override',
        'project_override'
    ]).optional(),
    sourceRef: /*#__PURE__*/ z.string().max(160).nullish(),
    sortOrder: /*#__PURE__*/ z.int().gte(0).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional()
});

export const zProjectThreadCreate = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string().min(1).max(200),
    summary: /*#__PURE__*/ z.string().max(4000).optional(),
    rootConversationId: /*#__PURE__*/ z.int().gt(0).optional(),
    currentWorkMode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]).optional()
});

export const zProjectThreadUpdate = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    summary: /*#__PURE__*/ z.string().max(4000).nullish(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'completed',
        'archived'
    ]).optional(),
    currentWorkMode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]).optional(),
    primaryChangeId: /*#__PURE__*/ z.int().gt(0).nullish()
});

export const zProjectChangeGate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    gateType: /*#__PURE__*/ z.string(),
    actionType: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    blockingMode: /*#__PURE__*/ z.string(),
    reviewer: /*#__PURE__*/ z.object({
        initials: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        isAgent: /*#__PURE__*/ z.boolean()
    }).nullable(),
    reviewerLabel: /*#__PURE__*/ z.string().nullable(),
    decisionAction: /*#__PURE__*/ z.string().nullable(),
    decisionReason: /*#__PURE__*/ z.string().nullable(),
    decidedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zProjectChangeRevision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number(),
    sequence: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'generated',
        'validating',
        'validated',
        'failed',
        'superseded'
    ]),
    summary: /*#__PURE__*/ z.string().nullable(),
    patchArtifactId: /*#__PURE__*/ z.number().nullable(),
    validationReportArtifactId: /*#__PURE__*/ z.number().nullable(),
    sourceConversationId: /*#__PURE__*/ z.number().nullable(),
    sourceWorkflowRunId: /*#__PURE__*/ z.number().nullable(),
    sourceTaskIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).nullable(),
    baseCommitSha: /*#__PURE__*/ z.string().nullable(),
    commitSha: /*#__PURE__*/ z.string().nullable(),
    patchHash: /*#__PURE__*/ z.string().nullable(),
    linesAdded: /*#__PURE__*/ z.number().nullable(),
    linesRemoved: /*#__PURE__*/ z.number().nullable(),
    filesChanged: /*#__PURE__*/ z.number().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zProjectChangeView = /*#__PURE__*/ zProjectChange.and(/*#__PURE__*/ z.object({
    displayStatus: /*#__PURE__*/ z.enum([
        'draft',
        'open',
        'review',
        'blocked',
        'merged',
        'stalled',
        'closed'
    ]),
    author: /*#__PURE__*/ z.object({
        initials: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        isAgent: /*#__PURE__*/ z.boolean()
    }),
    branch: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        name: /*#__PURE__*/ z.string(),
        href: /*#__PURE__*/ z.string().nullable()
    }),
    gates: /*#__PURE__*/ z.object({
        passed: /*#__PURE__*/ z.number(),
        total: /*#__PURE__*/ z.number(),
        segments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
            'ok',
            'bad',
            'pending'
        ]))
    }),
    diff: /*#__PURE__*/ z.object({
        added: /*#__PURE__*/ z.number(),
        removed: /*#__PURE__*/ z.number(),
        files: /*#__PURE__*/ z.number()
    }).nullable(),
    reviewers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        initials: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        isAgent: /*#__PURE__*/ z.boolean(),
        state: /*#__PURE__*/ z.enum([
            'pending',
            'approved',
            'changes-requested',
            'requested'
        ])
    })),
    gateChecks: /*#__PURE__*/ z.array(zProjectChangeGate).optional(),
    revisions: /*#__PURE__*/ z.array(zProjectChangeRevision).optional(),
    resources: /*#__PURE__*/ z.array(zProjectThreadResource).optional(),
    activity: /*#__PURE__*/ z.array(zProjectActivityItem).optional(),
    thread: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        title: /*#__PURE__*/ z.string(),
        rootConversationId: /*#__PURE__*/ z.number().nullable()
    }).optional()
}));

export const zProjectChangesResult = /*#__PURE__*/ z.object({
    stats: /*#__PURE__*/ z.object({
        total: /*#__PURE__*/ z.number(),
        blocked: /*#__PURE__*/ z.number(),
        inReview: /*#__PURE__*/ z.number(),
        inFlight: /*#__PURE__*/ z.number(),
        merged: /*#__PURE__*/ z.number()
    }),
    branches: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        count: /*#__PURE__*/ z.number()
    })),
    changes: /*#__PURE__*/ z.array(zProjectChangeView)
});

export const zProjectLogCommit = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    kind: /*#__PURE__*/ z.enum([
        'change',
        'decision',
        'artifact',
        'workflow',
        'gate'
    ]),
    tone: /*#__PURE__*/ z.enum([
        'g',
        'b',
        'y',
        'r',
        'n'
    ]),
    number: /*#__PURE__*/ z.number().optional(),
    label: /*#__PURE__*/ z.string(),
    subLabel: /*#__PURE__*/ z.string().optional(),
    timestamp: /*#__PURE__*/ z.iso.datetime(),
    href: /*#__PURE__*/ z.string().nullable(),
    changeId: /*#__PURE__*/ z.number().optional(),
    leftPct: /*#__PURE__*/ z.number()
});

export const zProjectLogLane = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'completed',
        'archived'
    ]),
    ownerInitials: /*#__PURE__*/ z.string(),
    ownerLabel: /*#__PURE__*/ z.string(),
    ownerIsAgent: /*#__PURE__*/ z.boolean(),
    changeCount: /*#__PURE__*/ z.number(),
    idleLabel: /*#__PURE__*/ z.string().optional(),
    phase: /*#__PURE__*/ z.string(),
    endStatus: /*#__PURE__*/ z.string().optional(),
    commits: /*#__PURE__*/ z.array(zProjectLogCommit),
    threadHref: /*#__PURE__*/ z.string()
});

export const zProjectLogDecisionCard = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum([
        'blocker',
        'gate',
        'next-action'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'r',
        'y',
        'b',
        'g',
        'n'
    ]),
    title: /*#__PURE__*/ z.string(),
    ageLabel: /*#__PURE__*/ z.string(),
    threadId: /*#__PURE__*/ z.number().nullable(),
    threadTitle: /*#__PURE__*/ z.string().nullable()
});

export const zProjectLogResult = /*#__PURE__*/ z.object({
    project: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        name: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.enum([
            'active',
            'on_hold',
            'archived',
            'closed'
        ])
    }),
    range: /*#__PURE__*/ z.object({
        start: /*#__PURE__*/ z.iso.datetime(),
        end: /*#__PURE__*/ z.iso.datetime(),
        ticks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            label: /*#__PURE__*/ z.string(),
            isoDate: /*#__PURE__*/ z.string(),
            isPast: /*#__PURE__*/ z.boolean(),
            isToday: /*#__PURE__*/ z.boolean(),
            isWeekend: /*#__PURE__*/ z.boolean()
        }))
    }),
    threads: /*#__PURE__*/ z.array(zProjectLogLane),
    decisions: /*#__PURE__*/ z.array(zProjectLogDecisionCard)
});

export const zProjectChangeCreate = /*#__PURE__*/ z.object({
    projectThreadId: /*#__PURE__*/ z.int().gt(0),
    title: /*#__PURE__*/ z.string().min(1).max(200),
    target: /*#__PURE__*/ z.string().max(4000).optional(),
    summary: /*#__PURE__*/ z.string().max(4000).optional(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'planned',
        'implementing',
        'checking',
        'reviewing',
        'ready_to_merge',
        'merged',
        'blocked',
        'abandoned'
    ]).optional(),
    workMode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]).optional(),
    backend: /*#__PURE__*/ z.enum([
        'none',
        'local_git',
        'github',
        'gitlab',
        'gitea',
        'forgejo',
        'gerrit'
    ]).optional(),
    baseRef: /*#__PURE__*/ z.string().max(200).optional(),
    branchName: /*#__PURE__*/ z.string().max(200).optional()
});

export const zProjectChangeUpdate = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    target: /*#__PURE__*/ z.string().max(4000).nullish(),
    summary: /*#__PURE__*/ z.string().max(4000).nullish(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'planned',
        'implementing',
        'checking',
        'reviewing',
        'ready_to_merge',
        'merged',
        'blocked',
        'abandoned'
    ]).optional(),
    workMode: /*#__PURE__*/ z.enum([
        'brainstorm',
        'discovery',
        'design',
        'implementation',
        'review',
        'launch',
        'support',
        'expansion',
        'refactor',
        'fix'
    ]).optional(),
    backend: /*#__PURE__*/ z.enum([
        'none',
        'local_git',
        'github',
        'gitlab',
        'gitea',
        'forgejo',
        'gerrit'
    ]).optional(),
    baseRef: /*#__PURE__*/ z.string().max(200).nullish(),
    branchName: /*#__PURE__*/ z.string().max(200).nullish(),
    providerRef: /*#__PURE__*/ z.string().max(200).nullish(),
    reviewUrl: /*#__PURE__*/ z.url().nullish(),
    latestCheckStatus: /*#__PURE__*/ z.string().max(40).nullish(),
    blockedReason: /*#__PURE__*/ z.string().max(4000).nullish()
});

export const zProjectChangeRevisionCreate = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'draft',
        'generated',
        'validating',
        'validated',
        'failed',
        'superseded'
    ]).optional(),
    summary: /*#__PURE__*/ z.string().max(4000).optional(),
    patchArtifactId: /*#__PURE__*/ z.int().gt(0).optional(),
    validationReportArtifactId: /*#__PURE__*/ z.int().gt(0).optional(),
    sourceConversationId: /*#__PURE__*/ z.int().gt(0).optional(),
    sourceWorkflowRunId: /*#__PURE__*/ z.int().gt(0).optional(),
    sourceTaskIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).optional(),
    baseCommitSha: /*#__PURE__*/ z.string().max(80).optional(),
    commitSha: /*#__PURE__*/ z.string().max(80).optional(),
    patchHash: /*#__PURE__*/ z.string().max(128).optional(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zProjectThreadResourceCreate = /*#__PURE__*/ z.object({
    projectThreadId: /*#__PURE__*/ z.int().gt(0),
    projectChangeId: /*#__PURE__*/ z.int().gt(0).optional(),
    resourceType: /*#__PURE__*/ z.enum([
        'conversation',
        'artifact',
        'task',
        'workstream',
        'workflow_run',
        'workforce_member',
        'decision',
        'gate',
        'blocker',
        'handoff',
        'state_event',
        'code_workspace',
        'code_checkpoint'
    ]),
    resourceId: /*#__PURE__*/ z.string().min(1).max(200),
    role: /*#__PURE__*/ z.string().max(80).optional(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zProjectCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200),
    slug: /*#__PURE__*/ z.string().min(1).max(100),
    moduleId: /*#__PURE__*/ z.string().min(1),
    brief: /*#__PURE__*/ z.string().max(2000).optional(),
    icon: /*#__PURE__*/ z.string().max(50).optional(),
    color: /*#__PURE__*/ z.string().max(20).optional()
});

export const zProjectUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    slug: /*#__PURE__*/ z.string().min(1).max(100).optional(),
    brief: /*#__PURE__*/ z.string().max(2000).nullish(),
    icon: /*#__PURE__*/ z.string().max(50).nullish(),
    color: /*#__PURE__*/ z.string().max(20).nullish()
});

export const zProjectCloseRequest = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().max(500).optional()
});

export const zProjectSummary = /*#__PURE__*/ z.object({
    project: zProject,
    memberCount: /*#__PURE__*/ z.number(),
    membersByRole: /*#__PURE__*/ z.object({
        owner: /*#__PURE__*/ z.number(),
        manager: /*#__PURE__*/ z.number(),
        contributor: /*#__PURE__*/ z.number(),
        observer: /*#__PURE__*/ z.number()
    }),
    threadCount: /*#__PURE__*/ z.number(),
    changeCount: /*#__PURE__*/ z.number(),
    conversationCount: /*#__PURE__*/ z.number(),
    taskCount: /*#__PURE__*/ z.number(),
    teamCount: /*#__PURE__*/ z.number(),
    workstreamCount: /*#__PURE__*/ z.number(),
    memoryCount: /*#__PURE__*/ z.number(),
    artifactCount: /*#__PURE__*/ z.number(),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime()
    })
});

export const zActionQueueList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCoordinationActionQueueItem)
});

export const zActionQueueClaimInput = /*#__PURE__*/ z.object({
    leaseMs: /*#__PURE__*/ z.int().gte(30000).lte(86400000).optional(),
    correlationId: /*#__PURE__*/ z.string().max(160).nullish()
});

export const zActionQueueResolveInput = /*#__PURE__*/ z.object({
    correlationId: /*#__PURE__*/ z.string().max(160).nullish()
});

export const zGateDecisionInput = /*#__PURE__*/ z.object({
    action: /*#__PURE__*/ z.enum([
        'approve',
        'reject',
        'request_changes',
        'accept_risk',
        'cancel',
        'expire'
    ]),
    rationale: /*#__PURE__*/ z.string().max(4000).nullish(),
    reasonCode: /*#__PURE__*/ z.string().max(120).nullish(),
    riskAcceptanceUntil: /*#__PURE__*/ z.iso.datetime().nullish(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zBlockerTransitionInput = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'open',
        'acknowledged',
        'assigned',
        'waiting',
        'resolved',
        'dismissed',
        'superseded'
    ]),
    reason: /*#__PURE__*/ z.string().max(4000).nullish(),
    ownerActor: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'human_user',
            'agent',
            'daemon',
            'system',
            'worker',
            'api',
            'service_account'
        ]),
        id: /*#__PURE__*/ z.string().min(1).nullish()
    }).nullish(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zHandoffTransitionInput = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'requested',
        'accepted',
        'in_progress',
        'blocked',
        'returned',
        'completed',
        'failed',
        'cancelled',
        'expired',
        'superseded'
    ]),
    resultSummary: /*#__PURE__*/ z.string().max(4000).nullish(),
    resultArtifactId: /*#__PURE__*/ z.int().gt(0).nullish(),
    blockerId: /*#__PURE__*/ z.int().gt(0).nullish(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zTaskDecision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    conversationId: /*#__PURE__*/ z.number(),
    decisionType: /*#__PURE__*/ z.string(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    approvedBy: /*#__PURE__*/ z.number(),
    approvedAt: /*#__PURE__*/ z.iso.datetime(),
    sourceMessageId: /*#__PURE__*/ z.number().nullable(),
    rationale: /*#__PURE__*/ z.string().nullable()
});

export const zTask = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    createdBy: /*#__PURE__*/ z.number(),
    createdByType: /*#__PURE__*/ z.enum(['user', 'agent_instance']),
    originType: /*#__PURE__*/ z.enum([
        'manual',
        'conversation',
        'project',
        'workflow_step',
        'daemon_finding',
        'artifact',
        'api',
        'decision'
    ]),
    originId: /*#__PURE__*/ z.string().nullable(),
    originLabel: /*#__PURE__*/ z.string().nullable(),
    originMetadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    assigneeType: /*#__PURE__*/ z.enum([
        'user',
        'workforce_member',
        'daemon',
        'template',
        'tool',
        'workflow'
    ]),
    assigneeId: /*#__PURE__*/ z.string().nullable(),
    assigneeLabel: /*#__PURE__*/ z.string().nullable(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    teamId: /*#__PURE__*/ z.number().nullable(),
    parentTaskId: /*#__PURE__*/ z.number().nullable(),
    rootTaskId: /*#__PURE__*/ z.number().nullable(),
    title: /*#__PURE__*/ z.string(),
    goal: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'in_progress',
        'awaiting_approval',
        'awaiting_user',
        'completed',
        'failed',
        'cancelled'
    ]),
    baseTemplateId: /*#__PURE__*/ z.number(),
    sessionId: /*#__PURE__*/ z.number().nullable(),
    deadlineAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    tokenBudget: /*#__PURE__*/ z.number().nullable(),
    spendBudgetUsd: /*#__PURE__*/ z.string().nullable(),
    tokensUsed: /*#__PURE__*/ z.number(),
    spendUsd: /*#__PURE__*/ z.string(),
    softStopFired: /*#__PURE__*/ z.boolean(),
    requiredTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    inputContract: /*#__PURE__*/ zWorkflowContract.nullable(),
    outputContract: /*#__PURE__*/ zWorkflowContract.nullable(),
    executionContract: /*#__PURE__*/ zWorkflowContract.nullable(),
    resultContract: /*#__PURE__*/ zWorkflowContract.nullable(),
    inputContext: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    approvalRequired: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    approvalTimeoutHours: /*#__PURE__*/ z.number().nullable(),
    awaitingApprovalSince: /*#__PURE__*/ z.iso.datetime().nullable(),
    autoCompleteOnAgentDone: /*#__PURE__*/ z.boolean(),
    result: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    resultSummary: /*#__PURE__*/ z.string().nullable(),
    resultArtifactId: /*#__PURE__*/ z.number().nullable(),
    failureReason: /*#__PURE__*/ z.enum([
        'budget_exhausted_tokens',
        'budget_exhausted_spend',
        'deadline',
        'approval_rejected',
        'approval_timeout',
        'fatal_error'
    ]).nullable(),
    completedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    completedBy: /*#__PURE__*/ z.number().nullable(),
    retryCount: /*#__PURE__*/ z.number(),
    lastRetriedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    relations: /*#__PURE__*/ z.object({
        parentTask: /*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            title: /*#__PURE__*/ z.string(),
            status: /*#__PURE__*/ z.string()
        }).nullable(),
        childTasks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            title: /*#__PURE__*/ z.string(),
            status: /*#__PURE__*/ z.string(),
            assigneeLabel: /*#__PURE__*/ z.string().nullable(),
            resultSummary: /*#__PURE__*/ z.string().nullable()
        })),
        executionConversation: /*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            topic: /*#__PURE__*/ z.string(),
            status: /*#__PURE__*/ z.string(),
            lastActivityAt: /*#__PURE__*/ z.iso.datetime().nullable(),
            summary: /*#__PURE__*/ z.unknown().optional()
        }).nullable(),
        project: /*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            name: /*#__PURE__*/ z.string(),
            slug: /*#__PURE__*/ z.string()
        }).nullable(),
        team: /*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            name: /*#__PURE__*/ z.string(),
            slug: /*#__PURE__*/ z.string()
        }).nullable(),
        template: /*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            name: /*#__PURE__*/ z.string(),
            slug: /*#__PURE__*/ z.string()
        }).nullable(),
        resultArtifact: /*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.number(),
            title: /*#__PURE__*/ z.string(),
            kind: /*#__PURE__*/ z.string()
        }).nullable(),
        boundaryGuidance: /*#__PURE__*/ z.object({
            childTasksAreAccountabilityOnly: /*#__PURE__*/ z.boolean(),
            workflowRecommended: /*#__PURE__*/ z.boolean(),
            reason: /*#__PURE__*/ z.string().nullable()
        })
    }).nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zTaskApproveActionRequest = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.string()
});

export const zTaskRejectActionRequest = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.string(),
    reason: /*#__PURE__*/ z.string().optional()
});

export const zTaskCompleteRequest = /*#__PURE__*/ z.object({
    promotedMemoryIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
    result: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    resultSummary: /*#__PURE__*/ z.string().nullish(),
    createResultArtifact: /*#__PURE__*/ z.boolean().optional().default(false),
    resultArtifactTitle: /*#__PURE__*/ z.string().nullish(),
    resultArtifactKind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]).optional()
});

export const zTaskReassignRequest = /*#__PURE__*/ z.object({
    assigneeType: /*#__PURE__*/ z.enum([
        'user',
        'workforce_member',
        'daemon',
        'template',
        'tool',
        'workflow'
    ]),
    assigneeId: /*#__PURE__*/ z.string().nullish(),
    assigneeLabel: /*#__PURE__*/ z.string().nullish(),
    baseTemplateId: /*#__PURE__*/ z.int().gt(0).optional(),
    teamId: /*#__PURE__*/ z.int().gt(0).nullish()
});

export const zTaskTransferTeamRequest = /*#__PURE__*/ z.object({
    toTeamId: /*#__PURE__*/ z.int().gt(0)
});

export const zTaskList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zTask),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zTaskCreate = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string().min(1).max(500),
    goal: /*#__PURE__*/ z.string().min(1).max(10000),
    baseTemplateId: /*#__PURE__*/ z.int().gt(0),
    projectId: /*#__PURE__*/ z.int().gt(0).nullish(),
    teamId: /*#__PURE__*/ z.int().gt(0).nullish(),
    parentTaskId: /*#__PURE__*/ z.int().gt(0).nullish(),
    deadlineAt: /*#__PURE__*/ z.iso.datetime().nullish(),
    tokenBudget: /*#__PURE__*/ z.int().gt(0).nullish(),
    spendBudgetUsd: /*#__PURE__*/ z.string().nullish(),
    requiredTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullish(),
    inputContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    outputContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    executionContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    resultContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    inputContext: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    approvalRequired: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    approvalTimeoutHours: /*#__PURE__*/ z.int().gt(0).nullish(),
    autoCompleteOnAgentDone: /*#__PURE__*/ z.boolean().optional(),
    originType: /*#__PURE__*/ z.enum([
        'manual',
        'conversation',
        'project',
        'workflow_step',
        'daemon_finding',
        'artifact',
        'api'
    ]).optional(),
    originId: /*#__PURE__*/ z.string().nullish(),
    originLabel: /*#__PURE__*/ z.string().nullish(),
    originMetadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    assigneeType: /*#__PURE__*/ z.enum([
        'user',
        'workforce_member',
        'daemon',
        'template',
        'tool',
        'workflow'
    ]).optional(),
    assigneeId: /*#__PURE__*/ z.string().nullish(),
    assigneeLabel: /*#__PURE__*/ z.string().nullish()
});

export const zTaskUpdate = /*#__PURE__*/ z.object({
    title: /*#__PURE__*/ z.string().min(1).max(500).optional(),
    goal: /*#__PURE__*/ z.string().min(1).max(10000).optional(),
    deadlineAt: /*#__PURE__*/ z.iso.datetime().nullish(),
    tokenBudget: /*#__PURE__*/ z.int().gt(0).nullish(),
    spendBudgetUsd: /*#__PURE__*/ z.string().nullish(),
    requiredTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullish(),
    inputContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    outputContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    executionContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    resultContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    inputContext: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    approvalRequired: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    approvalTimeoutHours: /*#__PURE__*/ z.int().gt(0).nullish(),
    autoCompleteOnAgentDone: /*#__PURE__*/ z.boolean().optional(),
    originType: /*#__PURE__*/ z.enum([
        'manual',
        'conversation',
        'project',
        'workflow_step',
        'daemon_finding',
        'artifact',
        'api'
    ]).optional(),
    originId: /*#__PURE__*/ z.string().nullish(),
    originLabel: /*#__PURE__*/ z.string().nullish(),
    originMetadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    assigneeType: /*#__PURE__*/ z.enum([
        'user',
        'workforce_member',
        'daemon',
        'template',
        'tool',
        'workflow'
    ]).optional(),
    assigneeId: /*#__PURE__*/ z.string().nullish(),
    assigneeLabel: /*#__PURE__*/ z.string().nullish()
});

export const zIntervention = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    type: /*#__PURE__*/ z.enum([
        'fix',
        'improve',
        'investigate',
        'decision',
        'contract_repair',
        'version_change',
        'worker_unavailable',
        'policy_blocker'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'warning',
        'error',
        'critical'
    ]),
    status: /*#__PURE__*/ z.enum([
        'open',
        'reviewing',
        'routed',
        'resolved',
        'rejected'
    ]),
    requestedOutcome: /*#__PURE__*/ z.enum([
        'task',
        'decision',
        'workflow_draft',
        'workflow_version',
        'workforce_route',
        'workstream_link',
        'log_only'
    ]).nullable(),
    title: /*#__PURE__*/ z.string(),
    reason: /*#__PURE__*/ z.string(),
    instructions: /*#__PURE__*/ z.string().nullable(),
    sourceType: /*#__PURE__*/ z.enum([
        'workflow',
        'workflow_run',
        'workflow_step',
        'task',
        'template',
        'project',
        'artifact',
        'workforce',
        'daemon',
        'catalog_item',
        'catalog_version',
        'decision'
    ]),
    sourceId: /*#__PURE__*/ z.string(),
    sourceName: /*#__PURE__*/ z.string(),
    sourceUrl: /*#__PURE__*/ z.string().nullable(),
    assignedToType: /*#__PURE__*/ z.string().nullable(),
    assignedToId: /*#__PURE__*/ z.string().nullable(),
    assignedToName: /*#__PURE__*/ z.string().nullable(),
    failureTaxonomy: /*#__PURE__*/ z.string().nullable(),
    evidence: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    recommendedOutcomes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
    linkedOutcomes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
    resolvedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    resolvedBy: /*#__PURE__*/ z.number().nullable(),
    createdBy: /*#__PURE__*/ z.number(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zInterventionCreate = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'fix',
        'improve',
        'investigate',
        'decision',
        'contract_repair',
        'version_change',
        'worker_unavailable',
        'policy_blocker'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'warning',
        'error',
        'critical'
    ]).optional(),
    requestedOutcome: /*#__PURE__*/ z.enum([
        'task',
        'decision',
        'workflow_draft',
        'workflow_version',
        'workforce_route',
        'workstream_link',
        'log_only'
    ]).nullish(),
    title: /*#__PURE__*/ z.string().min(1).max(500),
    reason: /*#__PURE__*/ z.string().min(1).max(10000),
    instructions: /*#__PURE__*/ z.string().max(10000).nullish(),
    sourceType: /*#__PURE__*/ z.enum([
        'workflow',
        'workflow_run',
        'workflow_step',
        'task',
        'template',
        'project',
        'artifact',
        'workforce',
        'daemon',
        'catalog_item',
        'catalog_version',
        'decision'
    ]),
    sourceId: /*#__PURE__*/ z.string().min(1),
    sourceName: /*#__PURE__*/ z.string().nullish(),
    sourceUrl: /*#__PURE__*/ z.string().nullish(),
    assignedToType: /*#__PURE__*/ z.string().nullish(),
    assignedToId: /*#__PURE__*/ z.string().nullish(),
    assignedToName: /*#__PURE__*/ z.string().nullish(),
    failureTaxonomy: /*#__PURE__*/ z.enum([
        'execution_failure',
        'contract_failure',
        'quality_failure',
        'policy_failure'
    ]).optional(),
    evidence: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    recommendedOutcomes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).optional()
});

export const zInterventionEvent = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    interventionId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    actorUserId: /*#__PURE__*/ z.number().nullable(),
    eventType: /*#__PURE__*/ z.string(),
    fromStatus: /*#__PURE__*/ z.enum([
        'open',
        'reviewing',
        'routed',
        'resolved',
        'rejected'
    ]).nullable(),
    toStatus: /*#__PURE__*/ z.enum([
        'open',
        'reviewing',
        'routed',
        'resolved',
        'rejected'
    ]).nullable(),
    message: /*#__PURE__*/ z.string().nullable(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zInterventionRouteRequest = /*#__PURE__*/ z.object({
    outcome: /*#__PURE__*/ z.enum([
        'task',
        'decision',
        'workflow_draft',
        'workflow_version',
        'workforce_route',
        'workstream_link',
        'log_only'
    ]),
    instructions: /*#__PURE__*/ z.string().max(10000).nullish(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zInterventionResolveRequest = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string().max(2000).optional(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zInterventionRejectRequest = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().min(1).max(2000)
});

export const zWorkstreamMember = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    workstreamId: /*#__PURE__*/ z.number(),
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]),
    memberId: /*#__PURE__*/ z.number(),
    displayName: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.enum([
        'owner',
        'contributor',
        'observer'
    ]),
    joinedAt: /*#__PURE__*/ z.iso.datetime(),
    leftAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zWorkstreamMemberAdd = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]),
    memberId: /*#__PURE__*/ z.int().gt(0),
    role: /*#__PURE__*/ z.enum([
        'owner',
        'contributor',
        'observer'
    ]).optional().default('contributor')
});

export const zWorkstreamDecision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    conversationId: /*#__PURE__*/ z.number(),
    decisionType: /*#__PURE__*/ z.string(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    approvedBy: /*#__PURE__*/ z.number(),
    approvedAt: /*#__PURE__*/ z.iso.datetime(),
    sourceMessageId: /*#__PURE__*/ z.number().nullable(),
    rationale: /*#__PURE__*/ z.string().nullable()
});

export const zDecisionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkstreamDecision),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zWorkstream = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    focus: /*#__PURE__*/ z.enum([
        'feature',
        'marketing',
        'research',
        'ops',
        'support',
        'general'
    ]),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'archived',
        'completed'
    ]),
    managerAgentId: /*#__PURE__*/ z.number().nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    deletedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zWorkstreamList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkstream),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        hasMore: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.iso.datetime(),
        total: /*#__PURE__*/ z.number().optional()
    })
});

export const zWorkstreamCreate = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.int().gt(0),
    projectChangeId: /*#__PURE__*/ z.int().gt(0),
    name: /*#__PURE__*/ z.string().min(1).max(200),
    description: /*#__PURE__*/ z.string().max(2000).optional(),
    focus: /*#__PURE__*/ z.enum([
        'feature',
        'marketing',
        'research',
        'ops',
        'support',
        'general'
    ]).optional().default('general')
});

export const zWorkstreamUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    description: /*#__PURE__*/ z.string().max(2000).nullish(),
    focus: /*#__PURE__*/ z.enum([
        'feature',
        'marketing',
        'research',
        'ops',
        'support',
        'general'
    ]).optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'archived',
        'completed'
    ]).optional()
});

export const zApproverDelegation = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    delegatorUserId: /*#__PURE__*/ z.number(),
    delegateUserId: /*#__PURE__*/ z.number(),
    approvalPattern: /*#__PURE__*/ z.string(),
    expiresAt: /*#__PURE__*/ z.iso.datetime(),
    grantedAt: /*#__PURE__*/ z.iso.datetime(),
    revokedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    grantedBy: /*#__PURE__*/ z.number().nullable()
});

export const zApproverDelegationCreate = /*#__PURE__*/ z.object({
    delegateUserId: /*#__PURE__*/ z.int().gt(0),
    approvalPattern: /*#__PURE__*/ z.string().min(1).max(200),
    expiresAt: /*#__PURE__*/ z.iso.datetime()
});

export const zPromotionCandidate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'deferred'
    ]),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    reviewedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    reviewedBy: /*#__PURE__*/ z.string().nullable(),
    templateId: /*#__PURE__*/ z.string().nullable(),
    recommendedModule: /*#__PURE__*/ z.string().nullable(),
    eventTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    promotionCount: /*#__PURE__*/ z.number(),
    projectCount: /*#__PURE__*/ z.number()
});

export const zPromotionAcceptResult = /*#__PURE__*/ z.object({
    candidate: zPromotionCandidate,
    patch: /*#__PURE__*/ z.object({
        filePath: /*#__PURE__*/ z.string(),
        fileExists: /*#__PURE__*/ z.boolean(),
        addedEventTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        patch: /*#__PURE__*/ z.string()
    })
});

export const zDaemonFinding = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    daemonId: /*#__PURE__*/ z.number(),
    daemonName: /*#__PURE__*/ z.string(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    category: /*#__PURE__*/ z.enum([
        'vulnerability',
        'quality-issue',
        'optimization',
        'insight',
        'alert',
        'template-ecosystem',
        'promotion_candidate',
        'intent_classification_review',
        'edge_decay',
        'survivorship_bias_report'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    title: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    evidence: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    recommendation: /*#__PURE__*/ z.string().nullable(),
    autoFixAvailable: /*#__PURE__*/ z.boolean().nullable(),
    autoFixApplied: /*#__PURE__*/ z.boolean().nullable(),
    reviewStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'deferred',
        'quarantined'
    ]).nullable(),
    reviewedBy: /*#__PURE__*/ z.string().nullable(),
    reviewedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    affectedFiles: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    affectedSymbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zDeadLetterEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number().nullable(),
    stream: /*#__PURE__*/ z.string(),
    consumerGroup: /*#__PURE__*/ z.string(),
    consumerName: /*#__PURE__*/ z.string().nullable(),
    messageId: /*#__PURE__*/ z.string(),
    idempotencyKey: /*#__PURE__*/ z.string().nullable(),
    failureReason: /*#__PURE__*/ z.enum([
        'parse_error',
        'validation_error',
        'no_payload',
        'poison_max_deliveries',
        'handler_drop'
    ]),
    deliveryCount: /*#__PURE__*/ z.number(),
    errorMessage: /*#__PURE__*/ z.string().nullable(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    rawPayload: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'quarantined',
        'replaying',
        'replayed',
        'discarded'
    ]),
    replayedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    replayedByUserId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime()
});

export const zDeadLetterEntryList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDeadLetterEntry),
    total: /*#__PURE__*/ z.number()
});

export const zRuntimeFlag = /*#__PURE__*/ z.object({
    key: /*#__PURE__*/ z.enum([
        'platform.server_runs_schedulers',
        'platform.server_runs_market_data_aggregator',
        'platform.finance_pynecore_validation_enabled',
        'platform.finance_signal_aggregation_enabled',
        'platform.finance_signal_outcome_scoring_enabled',
        'platform.finance_strategy_runner_enabled',
        'platform.tool_scout_enabled',
        'finance.live_trading_enabled',
        'marketplace.auto_upgrade_acquisitions'
    ]),
    label: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.enum(['platform', 'organization']),
    defaultValue: /*#__PURE__*/ z.boolean(),
    risk: /*#__PURE__*/ z.enum([
        'safe',
        'caution',
        'dangerous'
    ]),
    appliesAt: /*#__PURE__*/ z.enum([
        'immediate',
        'next-tick',
        'restart'
    ]),
    envVar: /*#__PURE__*/ z.string().nullable(),
    value: /*#__PURE__*/ z.boolean(),
    source: /*#__PURE__*/ z.enum([
        'db',
        'env',
        'default'
    ]),
    organizationId: /*#__PURE__*/ z.number().nullable()
});

export const zRuntimeFlagList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zRuntimeFlag)
});

export const zRuntimeFlagUpdate = /*#__PURE__*/ z.object({
    value: /*#__PURE__*/ z.boolean()
});

export const zSystemHostSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.string().nullable(),
    online: /*#__PURE__*/ z.boolean(),
    lastSeenAt: /*#__PURE__*/ z.string().nullable(),
    cpuCount: /*#__PURE__*/ z.number().nullable(),
    cpuBusy: /*#__PURE__*/ z.number().nullable(),
    memoryUsed: /*#__PURE__*/ z.number().nullable(),
    memoryTotalBytes: /*#__PURE__*/ z.number().nullable(),
    diskUsedMax: /*#__PURE__*/ z.number().nullable(),
    loadPerCpu: /*#__PURE__*/ z.number().nullable(),
    uptimeSeconds: /*#__PURE__*/ z.number().nullable(),
    gpuBusy: /*#__PURE__*/ z.number().nullable(),
    temperatureMax: /*#__PURE__*/ z.number().nullable(),
    cpuTrend: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    memoryTrend: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number())
});

export const zSystemDatabaseSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.enum(['app', 'market']),
    hostId: /*#__PURE__*/ z.string().nullable(),
    sizeBytes: /*#__PURE__*/ z.number().nullable(),
    growthBytesPerDay: /*#__PURE__*/ z.number().nullable(),
    connections: /*#__PURE__*/ z.number().nullable(),
    maxConnections: /*#__PURE__*/ z.number().nullable(),
    cacheHit: /*#__PURE__*/ z.number().nullable(),
    transactionsPerSecond: /*#__PURE__*/ z.number().nullable(),
    xidAge: /*#__PURE__*/ z.number().nullable()
});

export const zSystemFinding = /*#__PURE__*/ z.object({
    code: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.enum(['warning', 'danger']),
    scope: /*#__PURE__*/ z.enum([
        'host',
        'database',
        'engine',
        'data'
    ]),
    target: /*#__PURE__*/ z.string(),
    message: /*#__PURE__*/ z.string(),
    value: /*#__PURE__*/ z.number()
});

export const zSystemEngineJob = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    schedule: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean(),
    runningSeconds: /*#__PURE__*/ z.number().nullable(),
    lastStartedAt: /*#__PURE__*/ z.string().nullable(),
    lastFinishedAt: /*#__PURE__*/ z.string().nullable(),
    lastDurationMs: /*#__PURE__*/ z.number().nullable(),
    longestRecentMs: /*#__PURE__*/ z.number().nullable(),
    typicalMs: /*#__PURE__*/ z.number().nullable(),
    lastOutcome: /*#__PURE__*/ z.enum(['succeeded', 'failed']).nullable(),
    lastError: /*#__PURE__*/ z.string().nullable(),
    runs: /*#__PURE__*/ z.number(),
    failures: /*#__PURE__*/ z.number(),
    skippedLastDay: /*#__PURE__*/ z.object({
        still_running: /*#__PURE__*/ z.number(),
        other_replica: /*#__PURE__*/ z.number(),
        egress_hold: /*#__PURE__*/ z.number()
    }),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zSystemDataFreshness = /*#__PURE__*/ z.object({
    source: /*#__PURE__*/ z.string(),
    part: /*#__PURE__*/ z.string().nullable(),
    newestAt: /*#__PURE__*/ z.string().nullable(),
    ageSeconds: /*#__PURE__*/ z.number().nullable(),
    series: /*#__PURE__*/ z.number(),
    staleAfterSeconds: /*#__PURE__*/ z.number().nullable(),
    checkedAt: /*#__PURE__*/ z.string().nullable()
});

export const zSystemOverview = /*#__PURE__*/ z.object({
    store: /*#__PURE__*/ z.object({
        configured: /*#__PURE__*/ z.boolean(),
        reachable: /*#__PURE__*/ z.boolean(),
        message: /*#__PURE__*/ z.string().nullable()
    }),
    generatedAt: /*#__PURE__*/ z.string(),
    hosts: /*#__PURE__*/ z.array(zSystemHostSummary),
    databases: /*#__PURE__*/ z.array(zSystemDatabaseSummary),
    findings: /*#__PURE__*/ z.array(zSystemFinding),
    engineJobs: /*#__PURE__*/ z.array(zSystemEngineJob),
    dataFreshness: /*#__PURE__*/ z.array(zSystemDataFreshness)
});

export const zSystemHost = /*#__PURE__*/ zSystemHostSummary.and(/*#__PURE__*/ z.object({
    kernel: /*#__PURE__*/ z.string().nullable(),
    architecture: /*#__PURE__*/ z.string().nullable(),
    filesystems: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        mountpoint: /*#__PURE__*/ z.string(),
        sizeBytes: /*#__PURE__*/ z.number().nullable(),
        availBytes: /*#__PURE__*/ z.number().nullable(),
        usedRatio: /*#__PURE__*/ z.number().nullable()
    })),
    hasGpu: /*#__PURE__*/ z.boolean()
}));

export const zMetricSeriesSet = /*#__PURE__*/ z.object({
    range: /*#__PURE__*/ z.enum([
        '1h',
        '6h',
        '24h',
        '7d',
        '30d',
        '90d',
        '1y'
    ]),
    stepSeconds: /*#__PURE__*/ z.int(),
    start: /*#__PURE__*/ z.string(),
    end: /*#__PURE__*/ z.string(),
    unit: /*#__PURE__*/ z.enum([
        'ratio',
        'bytes',
        'bytes_per_second',
        'per_second',
        'count',
        'seconds',
        'celsius',
        'watts',
        'cores'
    ]),
    series: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        key: /*#__PURE__*/ z.string(),
        label: /*#__PURE__*/ z.string(),
        stat: /*#__PURE__*/ z.enum([
            'avg',
            'max',
            'min'
        ]),
        points: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            t: /*#__PURE__*/ z.number(),
            v: /*#__PURE__*/ z.number()
        }))
    }))
});

export const zSystemDatabase = /*#__PURE__*/ zSystemDatabaseSummary.and(/*#__PURE__*/ z.object({
    connectionsByState: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        state: /*#__PURE__*/ z.string(),
        count: /*#__PURE__*/ z.number()
    })),
    longestTransactionSeconds: /*#__PURE__*/ z.number().nullable(),
    longestQuerySeconds: /*#__PURE__*/ z.number().nullable(),
    schemas: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        bytes: /*#__PURE__*/ z.number()
    })),
    relations: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        bytes: /*#__PURE__*/ z.number(),
        kind: /*#__PURE__*/ z.string(),
        growthBytesPerDay: /*#__PURE__*/ z.number().nullable()
    })),
    compression: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        beforeBytes: /*#__PURE__*/ z.number(),
        afterBytes: /*#__PURE__*/ z.number(),
        chunks: /*#__PURE__*/ z.object({
            compressed: /*#__PURE__*/ z.number(),
            partial: /*#__PURE__*/ z.number(),
            uncompressed: /*#__PURE__*/ z.number()
        }).nullable(),
        dueChunks: /*#__PURE__*/ z.number()
    })),
    deadTuples: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        count: /*#__PURE__*/ z.number()
    })),
    unusedIndexes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        bytes: /*#__PURE__*/ z.number()
    })),
    jobs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        relation: /*#__PURE__*/ z.string(),
        failures: /*#__PURE__*/ z.number(),
        lastOk: /*#__PURE__*/ z.boolean(),
        overdueSeconds: /*#__PURE__*/ z.number(),
        scheduled: /*#__PURE__*/ z.boolean()
    })),
    statementsCollected: /*#__PURE__*/ z.boolean(),
    statementTable: /*#__PURE__*/ z.object({
        entries: /*#__PURE__*/ z.number(),
        max: /*#__PURE__*/ z.number(),
        evictions: /*#__PURE__*/ z.number(),
        textBytes: /*#__PURE__*/ z.number()
    }).nullable()
}));

export const zSystemStatement = /*#__PURE__*/ z.object({
    queryId: /*#__PURE__*/ z.string(),
    query: /*#__PURE__*/ z.string(),
    calls: /*#__PURE__*/ z.number(),
    totalMs: /*#__PURE__*/ z.number(),
    meanMs: /*#__PURE__*/ z.number(),
    rows: /*#__PURE__*/ z.number(),
    blocksRead: /*#__PURE__*/ z.number(),
    tempBlocksWritten: /*#__PURE__*/ z.number()
});

export const zSystemRedis = /*#__PURE__*/ z.object({
    servers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        hostId: /*#__PURE__*/ z.string(),
        usedMemoryBytes: /*#__PURE__*/ z.number().nullable(),
        peakMemoryBytes: /*#__PURE__*/ z.number().nullable(),
        fragmentationRatio: /*#__PURE__*/ z.number().nullable(),
        clients: /*#__PURE__*/ z.number().nullable(),
        blockedClients: /*#__PURE__*/ z.number().nullable(),
        commandsPerSecond: /*#__PURE__*/ z.number().nullable(),
        hitRatio: /*#__PURE__*/ z.number().nullable(),
        evictedLastHour: /*#__PURE__*/ z.number().nullable(),
        keys: /*#__PURE__*/ z.number().nullable()
    })),
    streams: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        length: /*#__PURE__*/ z.number(),
        groups: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            name: /*#__PURE__*/ z.string(),
            pending: /*#__PURE__*/ z.number(),
            lag: /*#__PURE__*/ z.number().nullable()
        }))
    }))
});

export const zOrder = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    clientOrderId: /*#__PURE__*/ z.string().nullable(),
    exchangeOrderId: /*#__PURE__*/ z.string().nullable(),
    symbol: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.enum(['buy', 'sell']),
    type: /*#__PURE__*/ z.string(),
    quantity: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number()
    ]),
    filledQuantity: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number()
    ]).optional(),
    price: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number()
    ]).nullable(),
    avgFillPrice: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number()
    ]).nullish(),
    status: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zOrderCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    side: /*#__PURE__*/ z.enum(['buy', 'sell']),
    type: /*#__PURE__*/ z.enum([
        'market',
        'limit',
        'stop_market',
        'stop_limit',
        'trailing_stop'
    ]),
    quantity: /*#__PURE__*/ z.number().gt(0),
    price: /*#__PURE__*/ z.number().gt(0).optional(),
    stopPrice: /*#__PURE__*/ z.number().gt(0).optional(),
    stopLoss: /*#__PURE__*/ z.number().gt(0).optional(),
    takeProfit: /*#__PURE__*/ z.number().gt(0).optional(),
    leverage: /*#__PURE__*/ z.number().gte(1).lte(125).optional(),
    reduceOnly: /*#__PURE__*/ z.boolean().optional(),
    postOnly: /*#__PURE__*/ z.boolean().optional(),
    strategyId: /*#__PURE__*/ z.number().optional(),
    timeInForce: /*#__PURE__*/ z.enum([
        'GTC',
        'IOC',
        'FOK'
    ]).optional(),
    idempotency_key: /*#__PURE__*/ z.string().min(8).max(240).optional()
});

export const zTrade = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    symbol: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.string(),
    entryPrice: /*#__PURE__*/ z.string().nullable(),
    exitPrice: /*#__PURE__*/ z.string().nullable(),
    quantity: /*#__PURE__*/ z.string(),
    netPnl: /*#__PURE__*/ z.string().nullable(),
    pnlPercent: /*#__PURE__*/ z.string().nullable(),
    entryTime: /*#__PURE__*/ z.string(),
    exitTime: /*#__PURE__*/ z.string().nullable(),
    exitReason: /*#__PURE__*/ z.string().nullable()
});

export const zPosition = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    symbol: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.string(),
    quantity: /*#__PURE__*/ z.string(),
    entryPrice: /*#__PURE__*/ z.string(),
    currentPrice: /*#__PURE__*/ z.string().nullable(),
    unrealizedPnl: /*#__PURE__*/ z.string().nullable(),
    unrealizedPnlPercent: /*#__PURE__*/ z.string().nullable(),
    leverage: /*#__PURE__*/ z.number().nullable(),
    stopLoss: /*#__PURE__*/ z.string().nullable(),
    takeProfit: /*#__PURE__*/ z.string().nullable(),
    openedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zPositionCloseRequest = /*#__PURE__*/ z.object({
    quantity: /*#__PURE__*/ z.number().gt(0).optional()
});

export const zRiskLimit = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organization_id: /*#__PURE__*/ z.int().gt(0),
    scope: /*#__PURE__*/ z.enum([
        'org',
        'account',
        'strategy'
    ]),
    scope_id: /*#__PURE__*/ z.string().nullable(),
    metric: /*#__PURE__*/ z.enum([
        'max_leverage',
        'max_open_positions',
        'position_size_pct',
        'gross_exposure_pct',
        'net_exposure_pct',
        'daily_loss_pct',
        'max_drawdown_pct',
        'max_consecutive_losses',
        'single_name_concentration_pct',
        'requires_stop_loss'
    ]),
    threshold_soft: /*#__PURE__*/ z.string().nullable(),
    threshold_hard: /*#__PURE__*/ z.string().nullable(),
    action: /*#__PURE__*/ z.enum([
        'alert',
        'block',
        'halt'
    ]),
    enabled: /*#__PURE__*/ z.boolean(),
    description: /*#__PURE__*/ z.string().nullable(),
    created_by_user_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    created_at: /*#__PURE__*/ z.iso.datetime().nullable(),
    updated_at: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zRiskLimitList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zRiskLimit),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        has_more: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        server_time: /*#__PURE__*/ z.string()
    })
});

export const zRiskLimitCreate = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'org',
        'account',
        'strategy'
    ]),
    scope_id: /*#__PURE__*/ z.string().nullish().default(null),
    metric: /*#__PURE__*/ z.enum([
        'max_leverage',
        'max_open_positions',
        'position_size_pct',
        'gross_exposure_pct',
        'net_exposure_pct',
        'daily_loss_pct',
        'max_drawdown_pct',
        'max_consecutive_losses',
        'single_name_concentration_pct',
        'requires_stop_loss'
    ]),
    threshold_soft: /*#__PURE__*/ z.string().nullish().default(null),
    threshold_hard: /*#__PURE__*/ z.string().nullish().default(null),
    action: /*#__PURE__*/ z.enum([
        'alert',
        'block',
        'halt'
    ]).optional().default('block'),
    enabled: /*#__PURE__*/ z.boolean().optional().default(true),
    description: /*#__PURE__*/ z.string().nullish().default(null)
});

export const zRiskLimitUpdate = /*#__PURE__*/ z.object({
    threshold_soft: /*#__PURE__*/ z.string().nullish(),
    threshold_hard: /*#__PURE__*/ z.string().nullish(),
    action: /*#__PURE__*/ z.enum([
        'alert',
        'block',
        'halt'
    ]).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    description: /*#__PURE__*/ z.string().nullish()
});

export const zRiskBreach = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organization_id: /*#__PURE__*/ z.int().gt(0),
    risk_limit_id: /*#__PURE__*/ z.int().gt(0),
    scope: /*#__PURE__*/ z.enum([
        'org',
        'account',
        'strategy'
    ]),
    scope_id: /*#__PURE__*/ z.string().nullable(),
    metric: /*#__PURE__*/ z.enum([
        'max_leverage',
        'max_open_positions',
        'position_size_pct',
        'gross_exposure_pct',
        'net_exposure_pct',
        'daily_loss_pct',
        'max_drawdown_pct',
        'max_consecutive_losses',
        'single_name_concentration_pct',
        'requires_stop_loss'
    ]),
    observed_value: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    status: /*#__PURE__*/ z.enum([
        'open',
        'alerted',
        'escalated',
        'accepted',
        'resolved'
    ]),
    halted: /*#__PURE__*/ z.boolean(),
    opened_at: /*#__PURE__*/ z.iso.datetime().nullable(),
    resolved_at: /*#__PURE__*/ z.iso.datetime().nullable(),
    accepted_by_user_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    escalation_decision_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    created_at: /*#__PURE__*/ z.iso.datetime().nullable(),
    updated_at: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zRiskBreachList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zRiskBreach),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        has_more: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        server_time: /*#__PURE__*/ z.string()
    })
});

export const zRiskBreachEscalate = /*#__PURE__*/ z.object({
    decision_id: /*#__PURE__*/ z.int().gt(0)
});

export const zRiskBreachForHalt = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organization_id: /*#__PURE__*/ z.int().gt(0),
    risk_limit_id: /*#__PURE__*/ z.int().gt(0),
    scope: /*#__PURE__*/ z.enum([
        'org',
        'account',
        'strategy'
    ]),
    scope_id: /*#__PURE__*/ z.string().nullable(),
    metric: /*#__PURE__*/ z.enum([
        'max_leverage',
        'max_open_positions',
        'position_size_pct',
        'gross_exposure_pct',
        'net_exposure_pct',
        'daily_loss_pct',
        'max_drawdown_pct',
        'max_consecutive_losses',
        'single_name_concentration_pct',
        'requires_stop_loss'
    ]),
    observed_value: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    status: /*#__PURE__*/ z.enum([
        'open',
        'alerted',
        'escalated',
        'accepted',
        'resolved'
    ]),
    halted: /*#__PURE__*/ z.boolean(),
    opened_at: /*#__PURE__*/ z.iso.datetime().nullable(),
    resolved_at: /*#__PURE__*/ z.iso.datetime().nullable(),
    accepted_by_user_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    escalation_decision_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    created_at: /*#__PURE__*/ z.iso.datetime().nullable(),
    updated_at: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zRiskHaltList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zRiskBreachForHalt),
    paging: /*#__PURE__*/ z.object({
        cursors: /*#__PURE__*/ z.object({
            before: /*#__PURE__*/ z.string().nullable(),
            after: /*#__PURE__*/ z.string().nullable()
        }),
        has_more: /*#__PURE__*/ z.boolean(),
        next: /*#__PURE__*/ z.string().nullable()
    }),
    meta: /*#__PURE__*/ z.object({
        server_time: /*#__PURE__*/ z.string()
    })
});

export const zRiskHaltActivate = /*#__PURE__*/ z.object({
    breach_id: /*#__PURE__*/ z.int().gt(0),
    decision_id: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zRiskStatus = /*#__PURE__*/ z.object({
    halted: /*#__PURE__*/ z.boolean(),
    open_breach_count: /*#__PURE__*/ z.int(),
    halted_breach_count: /*#__PURE__*/ z.int()
});

export const zActiveStrategyConfig = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    userId: /*#__PURE__*/ z.number().nullable(),
    name: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.string().nullable(),
    description: /*#__PURE__*/ z.string().nullable(),
    type: /*#__PURE__*/ z.enum([
        'trend_following',
        'mean_reversion',
        'momentum',
        'volatility_breakout',
        'scalping',
        'swing',
        'arbitrage',
        'custom'
    ]),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ])),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    timeframes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    exchanges: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    riskPerTrade: /*#__PURE__*/ z.string().nullable(),
    maxPositions: /*#__PURE__*/ z.number().nullable(),
    maxDailyTrades: /*#__PURE__*/ z.number().nullable(),
    isActive: /*#__PURE__*/ z.boolean().nullable(),
    isPaperTrading: /*#__PURE__*/ z.boolean().nullable(),
    cachedMetrics: /*#__PURE__*/ z.object({
        totalTrades: /*#__PURE__*/ z.number().optional(),
        winRate: /*#__PURE__*/ z.number().optional(),
        profitFactor: /*#__PURE__*/ z.number().optional(),
        sharpeRatio: /*#__PURE__*/ z.number().optional(),
        maxDrawdown: /*#__PURE__*/ z.number().optional(),
        netProfitPercent: /*#__PURE__*/ z.number().optional()
    }).nullish(),
    status: /*#__PURE__*/ z.enum([
        'development',
        'paper_trading',
        'paper_trading_completed',
        'retired',
        'live'
    ]).nullable(),
    deployMode: /*#__PURE__*/ z.enum([
        'live',
        'paper',
        'alert_only'
    ]).nullable(),
    isDeployed: /*#__PURE__*/ z.boolean().nullable(),
    lifecycleState: /*#__PURE__*/ z.enum([
        'candidate',
        'research_brief',
        'backtest_pending',
        'backtest_done_pass',
        'backtest_done_fail',
        'risk_pending',
        'risk_cleared',
        'risk_rejected',
        'paper_trading',
        'paper_trading_completed',
        'pending_live_approval',
        'live_trading',
        'retired',
        'archived',
        'watchlist'
    ]),
    paperTradeStartedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    liveTradeStartedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    source: /*#__PURE__*/ z.string().nullable(),
    sourceUrl: /*#__PURE__*/ z.string().nullable(),
    thesis: /*#__PURE__*/ z.string().nullable(),
    marketConditions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    assetClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    logicDoc: /*#__PURE__*/ z.unknown().optional(),
    signalDoc: /*#__PURE__*/ z.unknown().optional(),
    sourceDoc: /*#__PURE__*/ z.unknown().optional(),
    runtimeState: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    parentVersionId: /*#__PURE__*/ z.number().nullable(),
    baselineSharpe: /*#__PURE__*/ z.string().nullable(),
    baselineWinRate: /*#__PURE__*/ z.string().nullable(),
    currentSharpe: /*#__PURE__*/ z.string().nullable(),
    currentWinRate: /*#__PURE__*/ z.string().nullable(),
    totalSignals: /*#__PURE__*/ z.number().nullable(),
    totalTrades: /*#__PURE__*/ z.number().nullable(),
    totalPnl: /*#__PURE__*/ z.string().nullable(),
    deployedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    retiredAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    lastOptimizationAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    teamId: /*#__PURE__*/ z.number().nullable(),
    visibility: /*#__PURE__*/ z.string().nullable(),
    pricingModel: /*#__PURE__*/ z.string().nullable(),
    priceUsd: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime(),
    lastSignalAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zStrategySignal = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'long',
        'short',
        'close_long',
        'close_short',
        'none'
    ]),
    symbol: /*#__PURE__*/ z.string(),
    timeframe: /*#__PURE__*/ z.enum([
        '1m',
        '3m',
        '5m',
        '15m',
        '30m',
        '1h',
        '2h',
        '4h',
        '6h',
        '12h',
        '1d',
        '1w'
    ]),
    timestamp: /*#__PURE__*/ z.iso.datetime(),
    price: /*#__PURE__*/ z.number(),
    confidence: /*#__PURE__*/ z.number(),
    stopLoss: /*#__PURE__*/ z.number().optional(),
    takeProfit: /*#__PURE__*/ z.number().optional(),
    quantity: /*#__PURE__*/ z.number().optional(),
    strategyId: /*#__PURE__*/ z.string(),
    strategyName: /*#__PURE__*/ z.string(),
    strategyVersion: /*#__PURE__*/ z.string(),
    reason: /*#__PURE__*/ z.string().optional(),
    indicators: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional()
});

export const zStrategyState = /*#__PURE__*/ z.object({
    isActive: /*#__PURE__*/ z.boolean(),
    currentPosition: /*#__PURE__*/ z.enum([
        'long',
        'short',
        'flat'
    ]),
    entryPrice: /*#__PURE__*/ z.number().optional(),
    entryTime: /*#__PURE__*/ z.iso.datetime().optional(),
    indicators: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    lastSignal: /*#__PURE__*/ zStrategySignal.optional()
});

export const zActiveStrategy = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    timeframes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    isActive: /*#__PURE__*/ z.boolean(),
    lifecycleState: /*#__PURE__*/ z.string().optional(),
    deployMode: /*#__PURE__*/ z.enum([
        'live',
        'paper',
        'alert_only'
    ]).nullish(),
    deployedAt: /*#__PURE__*/ z.string().nullish(),
    currentSharpe: /*#__PURE__*/ z.string().nullish(),
    currentWinRate: /*#__PURE__*/ z.string().nullish(),
    totalSignals: /*#__PURE__*/ z.number().nullish(),
    totalPnl: /*#__PURE__*/ z.string().nullish(),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ])).optional(),
    config: /*#__PURE__*/ zActiveStrategyConfig.optional(),
    state: /*#__PURE__*/ zStrategyState.optional(),
    info: /*#__PURE__*/ zStrategy.nullish()
});

export const zActiveStrategyCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).min(1),
    timeframes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).min(1),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ])).optional(),
    riskPerTrade: /*#__PURE__*/ z.number().gte(0.1).lte(10).optional(),
    maxPositions: /*#__PURE__*/ z.number().gte(1).lte(10).optional()
});

export const zActiveStrategyParametersUpdate = /*#__PURE__*/ z.object({
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ]))
});

export const zStrategyDeploymentActionResult = /*#__PURE__*/ z.object({
    strategy: zActiveStrategyConfig,
    message: /*#__PURE__*/ z.string()
});

export const zStrategyDeployCreate = /*#__PURE__*/ z.object({
    mode: /*#__PURE__*/ z.enum([
        'paper',
        'live',
        'alert_only'
    ]).optional()
});

export const zStrategyDeploymentStatus = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'development',
        'paper_trading',
        'paper_trading_completed',
        'retired',
        'live'
    ]).nullable(),
    isDeployed: /*#__PURE__*/ z.boolean().nullable(),
    deployMode: /*#__PURE__*/ z.enum([
        'live',
        'paper',
        'alert_only'
    ]).nullable(),
    currentSharpe: /*#__PURE__*/ z.string().nullable(),
    currentWinRate: /*#__PURE__*/ z.string().nullable(),
    totalSignals: /*#__PURE__*/ z.number().nullable(),
    totalTrades: /*#__PURE__*/ z.number().nullable(),
    totalPnl: /*#__PURE__*/ z.string().nullable(),
    deployedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    organizationId: /*#__PURE__*/ z.number()
});

export const zStrategyLogicDoc = /*#__PURE__*/ z.object({
    thesis: /*#__PURE__*/ z.string(),
    investmentRationale: /*#__PURE__*/ z.string(),
    entryRules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        condition: /*#__PURE__*/ z.string(),
        indicator: /*#__PURE__*/ z.string().optional(),
        parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional(),
        description: /*#__PURE__*/ z.string()
    })),
    exitRules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        condition: /*#__PURE__*/ z.string(),
        indicator: /*#__PURE__*/ z.string().optional(),
        parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional(),
        description: /*#__PURE__*/ z.string()
    })),
    riskManagement: /*#__PURE__*/ z.object({
        stopLossType: /*#__PURE__*/ z.string(),
        stopLossParams: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
        takeProfitType: /*#__PURE__*/ z.string(),
        takeProfitParams: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
        positionSizing: /*#__PURE__*/ z.string(),
        maxDrawdownLimit: /*#__PURE__*/ z.number()
    }),
    marketConditions: /*#__PURE__*/ z.object({
        idealRegimes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        avoidRegimes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        idealVolatility: /*#__PURE__*/ z.enum([
            'low',
            'medium',
            'high',
            'any'
        ])
    }),
    assetClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    timeframes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    theoreticalBasis: /*#__PURE__*/ z.string().optional(),
    academicReferences: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zSignalGenerationDoc = /*#__PURE__*/ z.object({
    dataSources: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'candles',
            'onchain',
            'sentiment',
            'macro',
            'options',
            'orderflow'
        ]),
        required: /*#__PURE__*/ z.boolean(),
        description: /*#__PURE__*/ z.string()
    })),
    indicators: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
        calculation: /*#__PURE__*/ z.string(),
        purpose: /*#__PURE__*/ z.string()
    })),
    signalTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum([
            'long',
            'short',
            'close_long',
            'close_short'
        ]),
        conditions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        confidenceModel: /*#__PURE__*/ z.string()
    })),
    tunableParameters: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        currentValue: /*#__PURE__*/ z.number(),
        range: /*#__PURE__*/ z.object({
            min: /*#__PURE__*/ z.number(),
            max: /*#__PURE__*/ z.number(),
            step: /*#__PURE__*/ z.number()
        }),
        sensitivity: /*#__PURE__*/ z.enum([
            'low',
            'medium',
            'high'
        ]),
        description: /*#__PURE__*/ z.string()
    })),
    expectedPerformance: /*#__PURE__*/ z.object({
        winRate: /*#__PURE__*/ z.number(),
        sharpeRatio: /*#__PURE__*/ z.number(),
        signalFrequency: /*#__PURE__*/ z.string(),
        avgHoldingPeriod: /*#__PURE__*/ z.string()
    }),
    computeRequirements: /*#__PURE__*/ z.object({
        minCandles: /*#__PURE__*/ z.number(),
        updateFrequency: /*#__PURE__*/ z.string(),
        latencySensitive: /*#__PURE__*/ z.boolean()
    })
});

export const zSourceReferenceDoc = /*#__PURE__*/ z.object({
    origin: /*#__PURE__*/ z.enum([
        'ai_discovered',
        'quant_research',
        'user_provided',
        'system_builtin',
        'imported',
        'github',
        'tradingview'
    ]),
    sourceUrl: /*#__PURE__*/ z.string().optional(),
    sourceAgent: /*#__PURE__*/ z.string().optional(),
    sourceWorkflow: /*#__PURE__*/ z.string().optional(),
    discoveredAt: /*#__PURE__*/ z.string().optional(),
    validationHistory: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        stage: /*#__PURE__*/ z.enum([
            'backtest',
            'walk_forward',
            'paper',
            'live'
        ]),
        date: /*#__PURE__*/ z.string(),
        result: /*#__PURE__*/ z.enum(['pass', 'fail']),
        metrics: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional(),
        notes: /*#__PURE__*/ z.string().optional()
    })),
    versionChangelog: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        version: /*#__PURE__*/ z.string(),
        date: /*#__PURE__*/ z.string(),
        changedBy: /*#__PURE__*/ z.string(),
        changeType: /*#__PURE__*/ z.enum([
            'params',
            'rules',
            'deployment',
            'retirement'
        ]),
        description: /*#__PURE__*/ z.string()
    })),
    performanceEvolution: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        date: /*#__PURE__*/ z.string(),
        sharpe: /*#__PURE__*/ z.number(),
        winRate: /*#__PURE__*/ z.number(),
        drawdown: /*#__PURE__*/ z.number()
    }))
});

export const zStrategyDocsResult = /*#__PURE__*/ z.object({
    logicDoc: zStrategyLogicDoc,
    signalDoc: zSignalGenerationDoc,
    sourceDoc: zSourceReferenceDoc
});

export const zStrategyDeploymentReadinessResult = /*#__PURE__*/ z.object({
    ready: /*#__PURE__*/ z.boolean(),
    issues: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zBacktestMetrics = /*#__PURE__*/ z.object({
    totalTrades: /*#__PURE__*/ z.number(),
    winningTrades: /*#__PURE__*/ z.number(),
    losingTrades: /*#__PURE__*/ z.number(),
    winRate: /*#__PURE__*/ z.number(),
    avgWin: /*#__PURE__*/ z.number(),
    avgLoss: /*#__PURE__*/ z.number(),
    profitFactor: /*#__PURE__*/ z.number(),
    sharpeRatio: /*#__PURE__*/ z.number(),
    sortinoRatio: /*#__PURE__*/ z.number().optional(),
    maxDrawdown: /*#__PURE__*/ z.number(),
    maxDrawdownPercent: /*#__PURE__*/ z.number(),
    netProfit: /*#__PURE__*/ z.number(),
    netProfitPercent: /*#__PURE__*/ z.number(),
    avgTradeDuration: /*#__PURE__*/ z.number().optional(),
    expectancy: /*#__PURE__*/ z.number().optional()
});

export const zBacktestTrade = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    symbol: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.enum(['long', 'short']),
    entryDate: /*#__PURE__*/ z.iso.datetime(),
    entryPrice: /*#__PURE__*/ z.number(),
    exitDate: /*#__PURE__*/ z.iso.datetime(),
    exitPrice: /*#__PURE__*/ z.number(),
    quantity: /*#__PURE__*/ z.number(),
    pnl: /*#__PURE__*/ z.number(),
    pnlPercent: /*#__PURE__*/ z.number(),
    commission: /*#__PURE__*/ z.number(),
    exitReason: /*#__PURE__*/ z.enum([
        'signal',
        'stop_loss',
        'take_profit',
        'trailing_stop',
        'end_of_test'
    ]),
    mae: /*#__PURE__*/ z.number().optional(),
    mfe: /*#__PURE__*/ z.number().optional()
});

export const zBacktestRunResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    result: /*#__PURE__*/ z.object({
        metrics: zBacktestMetrics,
        tradesCount: /*#__PURE__*/ z.number(),
        trades: /*#__PURE__*/ z.array(zBacktestTrade),
        equityCurve: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            date: /*#__PURE__*/ z.iso.datetime(),
            equity: /*#__PURE__*/ z.number()
        })),
        monthlyReturns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            month: /*#__PURE__*/ z.string(),
            return: /*#__PURE__*/ z.number()
        })).optional()
    })
});

export const zBacktestCreate = /*#__PURE__*/ z.object({
    strategyName: /*#__PURE__*/ z.string().min(1),
    symbol: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    startDate: /*#__PURE__*/ z.string(),
    endDate: /*#__PURE__*/ z.string(),
    initialCapital: /*#__PURE__*/ z.number().gte(100).optional().default(10000),
    commission: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0.1),
    slippage: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0.05),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ])).optional(),
    riskPerTrade: /*#__PURE__*/ z.number().gte(0.1).lte(10).optional()
});

export const zIngestionJobRunHandle = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    workflowId: /*#__PURE__*/ z.string()
});

export const zIngestionJob = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int(),
    name: /*#__PURE__*/ z.string(),
    definitionId: /*#__PURE__*/ z.int(),
    definitionName: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    scheduleEnabled: /*#__PURE__*/ z.boolean(),
    schedule: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    lifecycleStatus: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'archived'
    ]),
    lastRunAt: /*#__PURE__*/ z.string().nullable(),
    nextRunAt: /*#__PURE__*/ z.string().nullable(),
    runCount: /*#__PURE__*/ z.int(),
    consecutiveFailures: /*#__PURE__*/ z.int(),
    blockedUntil: /*#__PURE__*/ z.string().nullable(),
    lastErrorCode: /*#__PURE__*/ z.string().nullable(),
    run: /*#__PURE__*/ zIngestionJobRunHandle.optional()
});

export const zIngestionJobRunRequest = /*#__PURE__*/ z.object({
    context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zCandle = /*#__PURE__*/ z.object({
    time: /*#__PURE__*/ z.string(),
    open: /*#__PURE__*/ z.number(),
    high: /*#__PURE__*/ z.number(),
    low: /*#__PURE__*/ z.number(),
    close: /*#__PURE__*/ z.number(),
    volume: /*#__PURE__*/ z.number()
});

export const zOrderBookLevel = /*#__PURE__*/ z.object({
    price: /*#__PURE__*/ z.number(),
    quantity: /*#__PURE__*/ z.number()
});

export const zOrderBookResult = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    timestamp: /*#__PURE__*/ z.string(),
    bids: /*#__PURE__*/ z.array(zOrderBookLevel),
    asks: /*#__PURE__*/ z.array(zOrderBookLevel),
    bestBid: /*#__PURE__*/ z.number(),
    bestAsk: /*#__PURE__*/ z.number(),
    spread: /*#__PURE__*/ z.number(),
    midPrice: /*#__PURE__*/ z.number()
});

export const zBackfillCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.enum([
        '1m',
        '3m',
        '5m',
        '15m',
        '30m',
        '1h',
        '2h',
        '4h',
        '6h',
        '12h',
        '1d',
        '1w'
    ]),
    startDate: /*#__PURE__*/ z.string(),
    endDate: /*#__PURE__*/ z.string().optional()
});

export const zMarketDataAvailabilityResult = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string(),
    timeframe: /*#__PURE__*/ z.string(),
    requestedRange: /*#__PURE__*/ z.object({
        start: /*#__PURE__*/ z.string(),
        end: /*#__PURE__*/ z.string()
    }),
    hasData: /*#__PURE__*/ z.boolean(),
    count: /*#__PURE__*/ z.number(),
    firstCandle: /*#__PURE__*/ z.string().nullable(),
    lastCandle: /*#__PURE__*/ z.string().nullable()
});

export const zEconomicEvent = /*#__PURE__*/ z.object({
    releaseId: /*#__PURE__*/ z.string(),
    releaseName: /*#__PURE__*/ z.string(),
    date: /*#__PURE__*/ z.string()
});

export const zEconomicCalendar = /*#__PURE__*/ z.object({
    events: /*#__PURE__*/ z.array(zEconomicEvent),
    degraded: /*#__PURE__*/ z.boolean().optional()
});

export const zAnalysisAgentResult = /*#__PURE__*/ z.object({
    agent: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.string(),
    confidence: /*#__PURE__*/ z.number(),
    reasoning: /*#__PURE__*/ z.string(),
    recommendations: /*#__PURE__*/ z.array(zAgentRecommendation),
    executionTimeMs: /*#__PURE__*/ z.number()
});

export const zAnalysisAgentRunResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    result: /*#__PURE__*/ z.object({
        timestamp: /*#__PURE__*/ z.string(),
        symbol: /*#__PURE__*/ z.string(),
        consensusAction: /*#__PURE__*/ z.enum([
            'buy',
            'sell',
            'hold',
            'close'
        ]).nullable(),
        consensusConfidence: /*#__PURE__*/ z.number(),
        conflictingSignals: /*#__PURE__*/ z.boolean(),
        finalRecommendation: /*#__PURE__*/ zAgentRecommendation.nullable(),
        agentResults: /*#__PURE__*/ z.array(zAnalysisAgentResult)
    })
});

export const zAnalysisAgentRunCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    prices: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).min(20),
    volumes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).optional(),
    indicators: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional(),
    regime: /*#__PURE__*/ z.string().optional(),
    equity: /*#__PURE__*/ z.number().optional()
});

export const zAnalysisAgentStatus = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean(),
    priority: /*#__PURE__*/ z.number()
});

export const zAnalysisAgentStatusResult = /*#__PURE__*/ z.object({
    agentCount: /*#__PURE__*/ z.number(),
    enabledCount: /*#__PURE__*/ z.number(),
    agents: /*#__PURE__*/ z.array(zAnalysisAgentStatus)
});

export const zAnalysisAgentEnabledUpdate = /*#__PURE__*/ z.object({
    enabled: /*#__PURE__*/ z.boolean()
});

export const zSessionName = /*#__PURE__*/ z.enum([
    'asia',
    'europe',
    'us',
    'overlap_asia_europe',
    'overlap_europe_us'
]);

export const zSessionInfo = /*#__PURE__*/ z.object({
    name: zSessionName,
    startHour: /*#__PURE__*/ z.number(),
    endHour: /*#__PURE__*/ z.number(),
    description: /*#__PURE__*/ z.string()
});

export const zCurrentSession = /*#__PURE__*/ z.object({
    timestamp: /*#__PURE__*/ z.string(),
    currentSessions: /*#__PURE__*/ z.array(zSessionName),
    isOverlapPeriod: /*#__PURE__*/ z.boolean(),
    sessionInfo: /*#__PURE__*/ z.array(zSessionInfo)
});

export const zSessionTimesResult = /*#__PURE__*/ z.object({
    asia: zSessionInfo,
    europe: zSessionInfo,
    us: zSessionInfo,
    overlap_asia_europe: zSessionInfo,
    overlap_europe_us: zSessionInfo
});

export const zOpeningRangeResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    openingRange: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    currentPrice: /*#__PURE__*/ z.number(),
    breakoutSignal: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
});

export const zSessionCandle = /*#__PURE__*/ z.object({
    time: /*#__PURE__*/ z.string(),
    open: /*#__PURE__*/ z.number(),
    high: /*#__PURE__*/ z.number(),
    low: /*#__PURE__*/ z.number(),
    close: /*#__PURE__*/ z.number(),
    volume: /*#__PURE__*/ z.number()
});

export const zSessionAnalysisCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    candles: /*#__PURE__*/ z.array(zSessionCandle),
    session: zSessionName,
    rangeMinutes: /*#__PURE__*/ z.number().gte(5).lte(120).optional()
});

export const zSessionStatsResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    session: zSessionName,
    statistics: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    patterns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()))
});

export const zOrderBookAnalysis = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string(),
    timestamp: /*#__PURE__*/ z.string(),
    imbalance: /*#__PURE__*/ z.object({
        ratio: /*#__PURE__*/ z.number(),
        direction: /*#__PURE__*/ z.enum([
            'buy_pressure',
            'sell_pressure',
            'neutral'
        ]),
        strength: /*#__PURE__*/ z.number()
    }),
    liquidityLevels: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        price: /*#__PURE__*/ z.number(),
        volume: /*#__PURE__*/ z.number(),
        significance: /*#__PURE__*/ z.enum(['major', 'minor']),
        type: /*#__PURE__*/ z.enum(['support', 'resistance']),
        distance: /*#__PURE__*/ z.number()
    })),
    bidWall: /*#__PURE__*/ z.object({
        price: /*#__PURE__*/ z.number(),
        volume: /*#__PURE__*/ z.number()
    }).optional(),
    askWall: /*#__PURE__*/ z.object({
        price: /*#__PURE__*/ z.number(),
        volume: /*#__PURE__*/ z.number()
    }).optional(),
    depthScore: /*#__PURE__*/ z.number(),
    spreadQuality: /*#__PURE__*/ z.string()
});

export const zOrderBookAnalyzeCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    bids: /*#__PURE__*/ z.array(/*#__PURE__*/ z.array(/*#__PURE__*/ z.number())),
    asks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.array(/*#__PURE__*/ z.number()))
});

export const zOrderBookHeatmapCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    bids: /*#__PURE__*/ z.array(/*#__PURE__*/ z.array(/*#__PURE__*/ z.number())),
    asks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.array(/*#__PURE__*/ z.number())),
    priceRange: /*#__PURE__*/ z.number().optional()
});

export const zConfluenceSourceType = /*#__PURE__*/ z.enum([
    'strategy',
    'indicator',
    'pattern',
    'ml',
    'agent'
]);

export const zConfluenceSignalDirection = /*#__PURE__*/ z.enum([
    'long',
    'short',
    'close_long',
    'close_short',
    'none'
]);

export const zConfluenceSource = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    type: zConfluenceSourceType,
    signal: zConfluenceSignalDirection,
    strength: /*#__PURE__*/ z.number().gte(-1).lte(1),
    confidence: /*#__PURE__*/ z.number().gte(0).lte(1),
    weight: /*#__PURE__*/ z.number().gte(0).optional()
});

export const zConfluenceAnalysisResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    analysis: /*#__PURE__*/ z.object({
        symbol: /*#__PURE__*/ z.string(),
        timeframe: /*#__PURE__*/ z.string(),
        timestamp: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]),
        sources: /*#__PURE__*/ z.array(zConfluenceSource),
        overallSignal: zConfluenceSignalDirection,
        overallStrength: /*#__PURE__*/ z.number(),
        overallConfidence: /*#__PURE__*/ z.number(),
        agreementRatio: /*#__PURE__*/ z.number(),
        conflictLevel: /*#__PURE__*/ z.enum([
            'none',
            'low',
            'medium',
            'high'
        ]),
        recommendation: /*#__PURE__*/ z.enum([
            'strong_buy',
            'buy',
            'neutral',
            'sell',
            'strong_sell'
        ]),
        confluenceScore: /*#__PURE__*/ z.number(),
        meetsMinimumConfluence: /*#__PURE__*/ z.boolean().optional()
    })
});

export const zConfluenceAnalyzeCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    sources: /*#__PURE__*/ z.array(zConfluenceSource)
});

export const zConfluenceFromSignalsCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    signals: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        strategy: /*#__PURE__*/ z.string(),
        signal: /*#__PURE__*/ z.string(),
        confidence: /*#__PURE__*/ z.number()
    })).optional(),
    mlPrediction: /*#__PURE__*/ z.object({
        model: /*#__PURE__*/ z.string().optional(),
        direction: /*#__PURE__*/ z.string(),
        confidence: /*#__PURE__*/ z.number()
    }).optional(),
    patterns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string(),
        confidence: /*#__PURE__*/ z.number(),
        bullish: /*#__PURE__*/ z.boolean()
    })).optional()
});

export const zDiscoverySummaryResult = /*#__PURE__*/ z.object({
    stats: /*#__PURE__*/ z.object({
        contributors: /*#__PURE__*/ z.number(),
        content: /*#__PURE__*/ z.number(),
        strategies: /*#__PURE__*/ z.number(),
        approvedStrategies: /*#__PURE__*/ z.number(),
        signals: /*#__PURE__*/ z.number()
    }),
    topContributors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        intelSourceId: /*#__PURE__*/ z.string(),
        handle: /*#__PURE__*/ z.string(),
        platform: /*#__PURE__*/ z.string(),
        strategiesDiscovered: /*#__PURE__*/ z.number(),
        strategiesApproved: /*#__PURE__*/ z.number(),
        avgSharpe: /*#__PURE__*/ z.number()
    })),
    recentActivity: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        date: /*#__PURE__*/ z.string(),
        harvested: /*#__PURE__*/ z.number(),
        extracted: /*#__PURE__*/ z.number(),
        organizationId: /*#__PURE__*/ z.number()
    }))
});

export const zDiscoveryRunNowResult = /*#__PURE__*/ z.object({
    workflowName: /*#__PURE__*/ z.string(),
    run: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        workflowId: /*#__PURE__*/ z.string()
    })
});

export const zDiscoveryRunNowRequest = /*#__PURE__*/ z.object({
    workflowName: /*#__PURE__*/ z.string().optional(),
    context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zStrategyDefinitionValidateResult = /*#__PURE__*/ z.object({
    valid: /*#__PURE__*/ z.boolean(),
    errors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    definitionHash: /*#__PURE__*/ z.string().optional(),
    readiness: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    extensionIssues: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).optional(),
    evaluation: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    adapterResolution: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zStrategyDefinitionInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zDiscoveryRecord = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyDefinitionPersistResult = /*#__PURE__*/ z.object({
    data: zDiscoveryRecord,
    definitionHash: /*#__PURE__*/ z.string()
});

export const zDiscoveryCreatedResult = /*#__PURE__*/ z.object({
    data: zDiscoveryRecord
});

export const zStrategyDefinitionValidationRunInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyCorpusIngestionResult = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyCorpusIngestionInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zDiscoveryPaginatedList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDiscoveryRecord),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zStrategyDefinitionEvaluationInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyBucketDefinitionInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyBucketPersistResult = /*#__PURE__*/ z.object({
    data: zDiscoveryRecord,
    bucketHash: /*#__PURE__*/ z.string()
});

export const zStrategyBucketPatchInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyBucketBacktestResult = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    persistStatus: /*#__PURE__*/ z.string()
});

export const zStrategyBucketBacktestInput = /*#__PURE__*/ z.object({
    initialCapital: /*#__PURE__*/ z.number().gt(0).optional()
});

export const zStrategyBucketEvaluationInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyExtensionDescriptorInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyAdapterResolutionRequestInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyAdapterResolutionInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zDataBlockerInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zDiscoveryList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDiscoveryRecord)
});

export const zContributorCreate = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.enum([
        'twitter',
        'youtube',
        'substack',
        'podcast',
        'telegram',
        'discord',
        'tradingview'
    ]),
    handle: /*#__PURE__*/ z.string().min(1).max(100),
    name: /*#__PURE__*/ z.string().optional(),
    profileUrl: /*#__PURE__*/ z.url().optional(),
    seed: /*#__PURE__*/ z.boolean().optional()
});

export const zDiscoverySourceDetailResult = /*#__PURE__*/ z.object({
    contributor: zDiscoveryRecord,
    strategies: /*#__PURE__*/ z.array(zDiscoveryRecord),
    signals: /*#__PURE__*/ z.array(zDiscoveryRecord),
    accuracy: /*#__PURE__*/ z.unknown().optional()
});

export const zDiscoveryContentStatsResult = /*#__PURE__*/ z.object({
    byPlatform: /*#__PURE__*/ z.array(zDiscoveryRecord),
    recentActivity: /*#__PURE__*/ z.array(zDiscoveryRecord)
});

export const zDiscoveryContentDetailResult = /*#__PURE__*/ z.object({
    content: zDiscoveryRecord,
    strategies: /*#__PURE__*/ z.array(zDiscoveryRecord)
});

export const zDiscoveryStrategyStatsResult = /*#__PURE__*/ z.object({
    byCategory: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        category: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.number(),
        approved: /*#__PURE__*/ z.number(),
        avgSharpe: /*#__PURE__*/ z.number()
    })),
    topContributors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        intelSourceId: /*#__PURE__*/ z.string(),
        handle: /*#__PURE__*/ z.string(),
        platform: /*#__PURE__*/ z.string(),
        strategiesDiscovered: /*#__PURE__*/ z.number(),
        strategiesApproved: /*#__PURE__*/ z.number(),
        avgSharpe: /*#__PURE__*/ z.number()
    })),
    recentDiscoveries: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        date: /*#__PURE__*/ z.string(),
        discovered: /*#__PURE__*/ z.number(),
        approved: /*#__PURE__*/ z.number()
    }))
});

export const zDiscoveredStrategyStatusUpdate = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'approved',
        'rejected',
        'integrated'
    ]),
    rejectionReason: /*#__PURE__*/ z.string().optional()
});

export const zAssetSentimentResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        asset: /*#__PURE__*/ z.string(),
        bullishSignals: /*#__PURE__*/ z.number(),
        bearishSignals: /*#__PURE__*/ z.number(),
        neutralSignals: /*#__PURE__*/ z.number(),
        weightedSentiment: /*#__PURE__*/ z.number(),
        intelSources: /*#__PURE__*/ z.number()
    })
});

export const zSignalAccuracyList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        asset: /*#__PURE__*/ z.string(),
        total: /*#__PURE__*/ z.number(),
        correct24h: /*#__PURE__*/ z.number(),
        accuracy24h: /*#__PURE__*/ z.number()
    }))
});

export const zSignalActivityList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        date: /*#__PURE__*/ z.string(),
        signals: /*#__PURE__*/ z.number(),
        bullish: /*#__PURE__*/ z.number(),
        bearish: /*#__PURE__*/ z.number()
    }))
});

export const zIntelSourceSignal = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    intelSourceId: /*#__PURE__*/ z.number(),
    dataId: /*#__PURE__*/ z.number().nullable(),
    sourceType: /*#__PURE__*/ z.enum(['content', 'event']).nullable(),
    derivationMethod: /*#__PURE__*/ z.enum(['explicit', 'implicit']).nullable(),
    asset: /*#__PURE__*/ z.string(),
    signalType: /*#__PURE__*/ z.enum([
        'buy',
        'sell',
        'hold',
        'bullish',
        'bearish',
        'neutral'
    ]),
    sentiment: /*#__PURE__*/ z.enum([
        'bullish',
        'bearish',
        'neutral'
    ]).nullable(),
    confidence: /*#__PURE__*/ z.string().nullable(),
    reasoning: /*#__PURE__*/ z.string().nullable(),
    targetPrice: /*#__PURE__*/ z.string().nullable(),
    stopPrice: /*#__PURE__*/ z.string().nullable(),
    timeframe: /*#__PURE__*/ z.string().nullable(),
    priceAtSignal: /*#__PURE__*/ z.string().nullable(),
    price1hLater: /*#__PURE__*/ z.string().nullable(),
    price4hLater: /*#__PURE__*/ z.string().nullable(),
    price24hLater: /*#__PURE__*/ z.string().nullable(),
    price7dLater: /*#__PURE__*/ z.string().nullable(),
    wasCorrect1h: /*#__PURE__*/ z.boolean().nullable(),
    wasCorrect4h: /*#__PURE__*/ z.boolean().nullable(),
    wasCorrect24h: /*#__PURE__*/ z.boolean().nullable(),
    wasCorrect7d: /*#__PURE__*/ z.boolean().nullable(),
    change1h: /*#__PURE__*/ z.string().nullable(),
    change4h: /*#__PURE__*/ z.string().nullable(),
    change24h: /*#__PURE__*/ z.string().nullable(),
    change7d: /*#__PURE__*/ z.string().nullable(),
    targetHit: /*#__PURE__*/ z.boolean().nullable(),
    targetHitAt: /*#__PURE__*/ z.string().nullable(),
    stopHit: /*#__PURE__*/ z.boolean().nullable(),
    stopHitAt: /*#__PURE__*/ z.string().nullable(),
    signalScore: /*#__PURE__*/ z.string().nullable(),
    rawSignalText: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    signalAt: /*#__PURE__*/ z.string(),
    lastPriceUpdateAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zSignalList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSourceSignal)
});

export const zTradingViewWebhookResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    alertId: /*#__PURE__*/ z.string().optional(),
    action: /*#__PURE__*/ z.string().optional(),
    symbol: /*#__PURE__*/ z.string().optional(),
    message: /*#__PURE__*/ z.string().optional()
});

export const zPineScriptCreate = /*#__PURE__*/ z.object({
    webhookUrl: /*#__PURE__*/ z.url(),
    secretKey: /*#__PURE__*/ z.string().min(1),
    strategy: /*#__PURE__*/ z.string().min(1)
});

export const zTradingViewConfig = /*#__PURE__*/ z.object({
    allowedIps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    secretConfigured: /*#__PURE__*/ z.boolean()
});

export const zTradingViewTokenResult = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string(),
    webhookUrl: /*#__PURE__*/ z.url()
});

export const zWatchlistEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    ticker: /*#__PURE__*/ z.string(),
    companyName: /*#__PURE__*/ z.string().nullable(),
    addedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    addedByRunId: /*#__PURE__*/ z.number().nullable(),
    addedByUserId: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'archived',
        'under-review'
    ]).nullable(),
    latestAnalysisId: /*#__PURE__*/ z.number().nullable(),
    latestRecommendation: /*#__PURE__*/ z.enum([
        'STRONG_BUY',
        'BUY',
        'HOLD',
        'SELL',
        'STRONG_SELL'
    ]).nullable(),
    latestCompositeScore: /*#__PURE__*/ z.string().nullable(),
    analysisCount: /*#__PURE__*/ z.number().nullable(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    notes: /*#__PURE__*/ z.string().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    teamId: /*#__PURE__*/ z.number().nullable()
});

export const zWatchlistAdd = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string(),
    companyName: /*#__PURE__*/ z.string().optional(),
    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
});

export const zWatchlistAnalysis = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    ticker: /*#__PURE__*/ z.string(),
    analyzedAt: /*#__PURE__*/ z.iso.datetime(),
    workflowRunId: /*#__PURE__*/ z.number().nullable(),
    recommendation: /*#__PURE__*/ z.enum([
        'STRONG_BUY',
        'BUY',
        'HOLD',
        'SELL',
        'STRONG_SELL'
    ]).nullable(),
    targetPriceUsd: /*#__PURE__*/ z.string().nullable(),
    confidenceScore: /*#__PURE__*/ z.string().nullable(),
    compositeScore: /*#__PURE__*/ z.string().nullable(),
    scoreFundamental: /*#__PURE__*/ z.string().nullable(),
    scoreTechnical: /*#__PURE__*/ z.string().nullable(),
    scoreGrowth: /*#__PURE__*/ z.string().nullable(),
    scoreRisk: /*#__PURE__*/ z.string().nullable(),
    scoreMomentum: /*#__PURE__*/ z.string().nullable(),
    fullReport: /*#__PURE__*/ z.unknown().optional(),
    bullCase: /*#__PURE__*/ z.string().nullable(),
    bearCase: /*#__PURE__*/ z.string().nullable(),
    researchPoints: /*#__PURE__*/ z.unknown().optional(),
    organizationId: /*#__PURE__*/ z.number(),
    teamId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zPortfolio = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    ownerType: /*#__PURE__*/ z.enum(['organization', 'user']),
    ownerId: /*#__PURE__*/ z.string(),
    ownerName: /*#__PURE__*/ z.string().nullable(),
    portfolioType: /*#__PURE__*/ z.enum(['testing', 'production']),
    riskProfileTier: /*#__PURE__*/ z.enum([
        'conservative',
        'balanced',
        'growth',
        'aggressive'
    ]),
    riskProfileConfig: /*#__PURE__*/ z.unknown().optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'archived'
    ]).nullable(),
    currency: /*#__PURE__*/ z.string().nullable(),
    managedByAgent: /*#__PURE__*/ z.boolean().nullable(),
    lastAgentReviewAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    agentRecommendationPending: /*#__PURE__*/ z.boolean().nullable(),
    organizationId: /*#__PURE__*/ z.number(),
    teamId: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zPerformanceMetrics = /*#__PURE__*/ z.object({
    totalReturn: /*#__PURE__*/ z.number().optional(),
    annualizedReturn: /*#__PURE__*/ z.number().optional(),
    volatility: /*#__PURE__*/ z.number().optional(),
    sharpeRatio: /*#__PURE__*/ z.number().optional(),
    maxDrawdown: /*#__PURE__*/ z.number().optional()
});

export const zPortfolioComparison = /*#__PURE__*/ z.object({
    portfolio: zPortfolio,
    holdingsCount: /*#__PURE__*/ z.number(),
    metrics: zPerformanceMetrics
});

export const zRiskProfile = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().optional()
});

export const zPortfolioCreate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    ownerType: /*#__PURE__*/ z.enum(['organization', 'user']).optional().default('user'),
    portfolioType: /*#__PURE__*/ z.enum(['testing', 'production']).optional(),
    riskTier: /*#__PURE__*/ z.enum([
        'conservative',
        'balanced',
        'growth',
        'aggressive'
    ]).optional().default('balanced')
});

export const zHolding = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    portfolioId: /*#__PURE__*/ z.number(),
    ticker: /*#__PURE__*/ z.string(),
    companyName: /*#__PURE__*/ z.string().nullable(),
    shares: /*#__PURE__*/ z.string(),
    averageCostUsd: /*#__PURE__*/ z.string().nullable(),
    targetWeightPct: /*#__PURE__*/ z.string().nullable(),
    latestAnalysisId: /*#__PURE__*/ z.number().nullable(),
    addedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    updatedAt: /*#__PURE__*/ z.iso.datetime().nullable()
});

export const zPortfolioUpdate = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'archived'
    ]).optional(),
    riskTier: /*#__PURE__*/ z.enum([
        'conservative',
        'balanced',
        'growth',
        'aggressive'
    ]).optional()
});

export const zPortfolioSnapshot = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().optional(),
    portfolioId: /*#__PURE__*/ z.number(),
    triggerType: /*#__PURE__*/ z.enum([
        'scheduled',
        'rebalance',
        'manual',
        'market-close'
    ]).nullable(),
    totalValueUsd: /*#__PURE__*/ z.string().nullable(),
    cashValueUsd: /*#__PURE__*/ z.string().nullable(),
    equityValueUsd: /*#__PURE__*/ z.string().nullable(),
    dayPnlUsd: /*#__PURE__*/ z.string().nullable(),
    dayPnlPct: /*#__PURE__*/ z.string().nullable(),
    totalPnlUsd: /*#__PURE__*/ z.string().nullable(),
    totalPnlPct: /*#__PURE__*/ z.string().nullable(),
    annualizedReturn: /*#__PURE__*/ z.string().nullable(),
    volatilityAnnual: /*#__PURE__*/ z.string().nullable(),
    sharpeRatio: /*#__PURE__*/ z.string().nullable(),
    maxDrawdownPct: /*#__PURE__*/ z.string().nullable(),
    currentDrawdown: /*#__PURE__*/ z.string().nullable(),
    holdingsSnapshot: /*#__PURE__*/ z.unknown().optional(),
    sectorBreakdown: /*#__PURE__*/ z.unknown().optional(),
    topHoldings: /*#__PURE__*/ z.unknown().optional(),
    snapshotAt: /*#__PURE__*/ z.iso.datetime()
});

export const zRecommendationAction = /*#__PURE__*/ z.object({
    recommendationId: /*#__PURE__*/ z.number(),
    decidedBy: /*#__PURE__*/ z.string().optional(),
    notes: /*#__PURE__*/ z.string().optional()
});

export const zHoldingCreate = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string(),
    quantity: /*#__PURE__*/ z.number(),
    avgCostBasis: /*#__PURE__*/ z.number().optional()
});

export const zHoldingUpdate = /*#__PURE__*/ z.object({
    quantity: /*#__PURE__*/ z.number().optional(),
    avgCostBasis: /*#__PURE__*/ z.number().optional()
});

export const zContractEvent = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    runId: /*#__PURE__*/ z.number(),
    stepId: /*#__PURE__*/ z.string(),
    eventType: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'warning',
        'error',
        'critical'
    ]),
    details: /*#__PURE__*/ z.unknown().optional(),
    createdAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ])
});

export const zContractEventList = /*#__PURE__*/ z.object({
    events: /*#__PURE__*/ z.array(zContractEvent)
});

export const zContractSuggestion = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.string(),
    processorType: /*#__PURE__*/ z.string().optional(),
    missingFields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    mappings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        source: /*#__PURE__*/ z.string(),
        target: /*#__PURE__*/ z.string()
    })).optional(),
    autoApplicable: /*#__PURE__*/ z.boolean().optional()
});

export const zContractEdgeHealth = /*#__PURE__*/ z.object({
    sourceStepId: /*#__PURE__*/ z.string(),
    sourceStepName: /*#__PURE__*/ z.string(),
    targetStepId: /*#__PURE__*/ z.string(),
    targetStepName: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'compatible',
        'mismatch',
        'unknown',
        'resolved',
        'dispute'
    ]),
    missingFields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    suggestions: /*#__PURE__*/ z.array(zContractSuggestion).optional()
});

export const zContractHealth = /*#__PURE__*/ z.object({
    health: /*#__PURE__*/ z.object({
        totalEdges: /*#__PURE__*/ z.number(),
        compatible: /*#__PURE__*/ z.number(),
        mismatches: /*#__PURE__*/ z.number(),
        disputes: /*#__PURE__*/ z.number(),
        unknown: /*#__PURE__*/ z.number(),
        healthRatio: /*#__PURE__*/ z.number(),
        edges: /*#__PURE__*/ z.array(zContractEdgeHealth),
        recentViolations: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
        recentEvents: /*#__PURE__*/ z.array(zContractEvent)
    })
});

export const zContractApplyRequest = /*#__PURE__*/ z.object({
    workflowId: /*#__PURE__*/ z.int().gt(0),
    sourceStepId: /*#__PURE__*/ z.int().gt(0),
    mappings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        source: /*#__PURE__*/ z.string(),
        target: /*#__PURE__*/ z.string()
    })).min(1)
});

export const zAlertCondition = /*#__PURE__*/ z.enum([
    'crosses_above',
    'crosses_below',
    'greater_than',
    'less_than',
    'percent_change_up',
    'percent_change_down'
]);

export const zAlertCheckResult = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    triggered: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        condition: zAlertCondition,
        targetPrice: /*#__PURE__*/ z.number()
    }))
});

export const zAlertCheckCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    price: /*#__PURE__*/ z.number()
});

export const zAlertChannel = /*#__PURE__*/ z.enum([
    'telegram',
    'discord',
    'email',
    'webhook'
]);

export const zPriceAlert = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    symbol: /*#__PURE__*/ z.string(),
    condition: zAlertCondition,
    price: /*#__PURE__*/ z.number(),
    percentChange: /*#__PURE__*/ z.number().optional(),
    message: /*#__PURE__*/ z.string().optional(),
    channels: /*#__PURE__*/ z.array(zAlertChannel).optional(),
    enabled: /*#__PURE__*/ z.boolean(),
    triggered: /*#__PURE__*/ z.boolean()
});

export const zAlertStats = /*#__PURE__*/ z.object({
    total: /*#__PURE__*/ z.number(),
    enabled: /*#__PURE__*/ z.number(),
    triggered: /*#__PURE__*/ z.number(),
    bySymbol: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).optional()
});

export const zPriceAlertCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    condition: zAlertCondition,
    price: /*#__PURE__*/ z.number(),
    percentChange: /*#__PURE__*/ z.number().optional(),
    message: /*#__PURE__*/ z.string().optional(),
    channels: /*#__PURE__*/ z.array(zAlertChannel).optional()
});

export const zAlertEnabledUpdate = /*#__PURE__*/ z.object({
    enabled: /*#__PURE__*/ z.boolean()
});

export const zAlertRuleKind = /*#__PURE__*/ z.enum([
    'price_cross',
    'price_change_pct',
    'funding_threshold',
    'open_interest_change_pct',
    'regime_transition',
    'insight_from_source',
    'wallet_activity'
]);

export const zAlertRuleParams = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zAlertRuleChannel = /*#__PURE__*/ z.enum([
    'telegram',
    'discord',
    'slack',
    'email',
    'webhook'
]);

export const zAlertRule = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    kind: zAlertRuleKind,
    symbol: /*#__PURE__*/ z.string().nullable(),
    exchange: /*#__PURE__*/ z.string().nullable(),
    timeframe: /*#__PURE__*/ z.string().nullable(),
    params: zAlertRuleParams,
    channels: /*#__PURE__*/ z.array(zAlertRuleChannel),
    cooldownSeconds: /*#__PURE__*/ z.number(),
    enabled: /*#__PURE__*/ z.boolean(),
    lastValue: /*#__PURE__*/ z.number().nullable(),
    lastFiredAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string()
});

export const zAlertRuleCreate = /*#__PURE__*/ z.object({
    kind: zAlertRuleKind,
    symbol: /*#__PURE__*/ z.string().min(1).max(20).nullish(),
    exchange: /*#__PURE__*/ z.string().min(1).max(20).nullish(),
    timeframe: /*#__PURE__*/ z.string().min(1).max(10).nullish(),
    params: zAlertRuleParams,
    channels: /*#__PURE__*/ z.array(zAlertRuleChannel).optional(),
    cooldownSeconds: /*#__PURE__*/ z.int().gte(0).lte(2592000).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional()
});

export const zAlertRuleUpdate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1).max(20).nullish(),
    exchange: /*#__PURE__*/ z.string().min(1).max(20).nullish(),
    timeframe: /*#__PURE__*/ z.string().min(1).max(10).nullish(),
    params: /*#__PURE__*/ zAlertRuleParams.optional(),
    channels: /*#__PURE__*/ z.array(zAlertRuleChannel).optional(),
    cooldownSeconds: /*#__PURE__*/ z.int().gte(0).lte(2592000).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional()
});

export const zMarketEventReactionId = /*#__PURE__*/ z.enum([
    'flash_crash',
    'whale_dump',
    'funding_spike',
    'regulatory_news',
    'circuit_breaker',
    'black_swan',
    'wallet_move'
]);

export const zMarketEventReactionType = /*#__PURE__*/ z.object({
    id: zMarketEventReactionId,
    title: /*#__PURE__*/ z.string(),
    summary: /*#__PURE__*/ z.string(),
    threshold: /*#__PURE__*/ z.object({
        meaning: /*#__PURE__*/ z.string(),
        default: /*#__PURE__*/ z.number(),
        min: /*#__PURE__*/ z.number(),
        max: /*#__PURE__*/ z.number()
    }),
    defaultSymbol: /*#__PURE__*/ z.string().nullable(),
    needsSymbol: /*#__PURE__*/ z.boolean(),
    playbookName: /*#__PURE__*/ z.string(),
    steps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zMarketEventReaction = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int(),
    reaction: zMarketEventReactionId,
    title: /*#__PURE__*/ z.string(),
    symbol: /*#__PURE__*/ z.string().nullable(),
    ruleId: /*#__PURE__*/ z.int(),
    playbookEntityId: /*#__PURE__*/ z.int(),
    playbookName: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean(),
    lastFiredAt: /*#__PURE__*/ z.string().nullable()
});

export const zMarketEventReactionCreate = /*#__PURE__*/ z.object({
    reaction: zMarketEventReactionId,
    symbol: /*#__PURE__*/ z.string().min(1).max(20).optional(),
    threshold: /*#__PURE__*/ z.number().gt(0).optional()
});

export const zWalletRuleSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int(),
    description: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean()
});

export const zWalletWatch = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int(),
    chain: /*#__PURE__*/ z.string(),
    address: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string().nullable(),
    reason: /*#__PURE__*/ z.string().nullable(),
    source: /*#__PURE__*/ z.enum([
        'user',
        'workflow',
        'reaction'
    ]),
    sourceRef: /*#__PURE__*/ z.string().nullable(),
    followed: /*#__PURE__*/ z.boolean(),
    createdAt: /*#__PURE__*/ z.string(),
    removedAt: /*#__PURE__*/ z.string().nullable(),
    lastActivityAt: /*#__PURE__*/ z.string().nullable(),
    rules: /*#__PURE__*/ z.array(zWalletRuleSummary)
});

export const zWalletWatchCreate = /*#__PURE__*/ z.object({
    chain: /*#__PURE__*/ z.enum([
        'ethereum',
        'base',
        'optimism',
        'arbitrum',
        'polygon',
        'solana',
        'hyperliquid',
        'polymarket'
    ]),
    address: /*#__PURE__*/ z.string().min(1).max(100),
    label: /*#__PURE__*/ z.string().max(200).optional(),
    reason: /*#__PURE__*/ z.string().max(1000).optional()
});

export const zWalletMove = /*#__PURE__*/ z.object({
    at: /*#__PURE__*/ z.string(),
    activity: /*#__PURE__*/ z.enum([
        'transfer_in',
        'transfer_out',
        'exchange_deposit',
        'exchange_withdrawal',
        'fill'
    ]),
    asset: /*#__PURE__*/ z.string(),
    symbol: /*#__PURE__*/ z.string().nullable(),
    amount: /*#__PURE__*/ z.number(),
    amountUsd: /*#__PURE__*/ z.number().nullable(),
    counterparty: /*#__PURE__*/ z.string().nullable(),
    counterpartyLabel: /*#__PURE__*/ z.string().nullable(),
    reference: /*#__PURE__*/ z.string(),
    backfill: /*#__PURE__*/ z.boolean(),
    firedRuleIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int())
});

export const zWalletWatchDetail = /*#__PURE__*/ z.object({
    watch: zWalletWatch,
    moves: /*#__PURE__*/ z.array(zWalletMove),
    movesUnavailable: /*#__PURE__*/ z.boolean()
});

export const zStrategyRunRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    definitionId: /*#__PURE__*/ z.number().nullable(),
    bucketDefinitionId: /*#__PURE__*/ z.number().nullable(),
    adapterResolutionId: /*#__PURE__*/ z.number().nullable(),
    createdByWorkflowRunId: /*#__PURE__*/ z.number().nullable(),
    workOutputId: /*#__PURE__*/ z.number().nullable(),
    outputPartId: /*#__PURE__*/ z.number().nullable(),
    runId: /*#__PURE__*/ z.string(),
    schemaVersion: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    runMode: /*#__PURE__*/ z.enum([
        'research',
        'backtest',
        'walk_forward',
        'cross_validation',
        'monte_carlo',
        'paper',
        'shadow',
        'canary',
        'live'
    ]),
    runStatus: /*#__PURE__*/ z.enum([
        'scheduled',
        'running',
        'finished',
        'failed',
        'killed'
    ]),
    researchOnly: /*#__PURE__*/ z.boolean(),
    passed: /*#__PURE__*/ z.boolean().nullable(),
    verdict: /*#__PURE__*/ z.string().nullable(),
    recommendation: /*#__PURE__*/ z.string().nullable(),
    strategyEntityId: /*#__PURE__*/ z.number().nullable(),
    bucketEntityId: /*#__PURE__*/ z.number().nullable(),
    effectiveFingerprint: /*#__PURE__*/ z.string().nullable(),
    paramSetHash: /*#__PURE__*/ z.string().nullable(),
    dataSnapshotId: /*#__PURE__*/ z.string().nullable(),
    costModelId: /*#__PURE__*/ z.string().nullable(),
    randomSeed: /*#__PURE__*/ z.number().nullable(),
    codeVersion: /*#__PURE__*/ z.string().nullable(),
    windowStart: /*#__PURE__*/ z.iso.datetime().nullable(),
    windowEnd: /*#__PURE__*/ z.iso.datetime().nullable(),
    dataFrequency: /*#__PURE__*/ z.string().nullable(),
    nObservations: /*#__PURE__*/ z.number().nullable(),
    statisticBasis: /*#__PURE__*/ z.string().nullable(),
    sharpe: /*#__PURE__*/ z.string().nullable(),
    sortino: /*#__PURE__*/ z.string().nullable(),
    maxDrawdown: /*#__PURE__*/ z.string().nullable(),
    cagr: /*#__PURE__*/ z.string().nullable(),
    totalReturn: /*#__PURE__*/ z.string().nullable(),
    totalFeesPaid: /*#__PURE__*/ z.string().nullable(),
    maxGrossExposure: /*#__PURE__*/ z.string().nullable(),
    winRate: /*#__PURE__*/ z.string().nullable(),
    profitFactor: /*#__PURE__*/ z.string().nullable(),
    totalTrades: /*#__PURE__*/ z.number().nullable(),
    fillRate: /*#__PURE__*/ z.string().nullable(),
    probabilisticSharpe: /*#__PURE__*/ z.string().nullable(),
    deflatedSharpe: /*#__PURE__*/ z.string().nullable(),
    pbo: /*#__PURE__*/ z.string().nullable(),
    walkForwardEfficiency: /*#__PURE__*/ z.string().nullable(),
    multipleTestingPvalue: /*#__PURE__*/ z.string().nullable(),
    errorRateControl: /*#__PURE__*/ z.string().nullable(),
    trialsCount: /*#__PURE__*/ z.number().nullable(),
    totalCostBps: /*#__PURE__*/ z.string().nullable(),
    marketImpactBps: /*#__PURE__*/ z.string().nullable(),
    feeBps: /*#__PURE__*/ z.string().nullable(),
    borrowCostBps: /*#__PURE__*/ z.string().nullable(),
    slippageModelKind: /*#__PURE__*/ z.string().nullable(),
    feeModelKind: /*#__PURE__*/ z.string().nullable(),
    fillModelKind: /*#__PURE__*/ z.string().nullable(),
    fillTiming: /*#__PURE__*/ z.string().nullable(),
    assumedFeeTier: /*#__PURE__*/ z.string().nullable(),
    costAssumptionSource: /*#__PURE__*/ z.string().nullable(),
    benchmarkSymbol: /*#__PURE__*/ z.string().nullable(),
    benchmarkExchange: /*#__PURE__*/ z.string().nullable(),
    benchmarkRelativeStatus: /*#__PURE__*/ z.enum(['computed', 'absent']).nullable(),
    excessReturn: /*#__PURE__*/ z.string().nullable(),
    trackingError: /*#__PURE__*/ z.string().nullable(),
    informationRatio: /*#__PURE__*/ z.string().nullable(),
    benchmarkAlpha: /*#__PURE__*/ z.string().nullable(),
    benchmarkBeta: /*#__PURE__*/ z.string().nullable(),
    upCapture: /*#__PURE__*/ z.string().nullable(),
    downCapture: /*#__PURE__*/ z.string().nullable(),
    evaluationId: /*#__PURE__*/ z.string().nullable(),
    sourcePayload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    artifactRefs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        artifactId: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/),
        kind: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'equity_curve',
                'returns_series',
                'trades_ledger',
                'orders_ledger',
                'fills_log',
                'positions_timeline',
                'drawdown_episodes',
                'signal_table',
                'exposure_series',
                'drawdown_series',
                'buy_hold_equity',
                'oos_returns_series',
                'per_trial_returns_matrix',
                'cpcv_paths',
                'tearsheet',
                'dataset_snapshot',
                'model_blob',
                'config_blob'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]),
        uri: /*#__PURE__*/ z.string().min(1),
        contentDigest: /*#__PURE__*/ z.string().min(1),
        rowCount: /*#__PURE__*/ z.int().gte(0).optional(),
        timeAxisRef: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/).optional(),
        format: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'parquet',
                'csv',
                'json'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional()
    })),
    dataProvenance: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        requirementId: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/),
        domain: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'ohlcv',
                'corporate_actions',
                'fundamentals',
                'estimates',
                'macro',
                'rates',
                'fx_forwards',
                'futures_chain',
                'options_chain',
                'options_greeks',
                'borrow',
                'l2_orderbook',
                'trades',
                'funding',
                'open_interest',
                'on_chain',
                'sentiment',
                'news',
                'constituents',
                'benchmark',
                'calendar',
                'custom'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]),
        vendor: /*#__PURE__*/ z.string().min(1).optional(),
        dataAdapterRef: /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/).optional(),
        dataVintageId: /*#__PURE__*/ z.string().min(1).optional(),
        asOfTransactionTime: /*#__PURE__*/ z.string().min(1).optional(),
        coverageStart: /*#__PURE__*/ z.string().min(1).optional(),
        coverageEnd: /*#__PURE__*/ z.string().min(1).optional(),
        frequency: /*#__PURE__*/ z.string().min(1).optional(),
        contentHash: /*#__PURE__*/ z.string().min(1).optional(),
        pointInTimeCorrect: /*#__PURE__*/ z.boolean().optional().default(false),
        survivorshipBiasFree: /*#__PURE__*/ z.boolean().optional().default(false),
        delistingReturnsIncluded: /*#__PURE__*/ z.boolean().optional().default(false),
        productionReady: /*#__PURE__*/ z.boolean().optional().default(false),
        asOfPolicy: /*#__PURE__*/ z.object({
            validTimeField: /*#__PURE__*/ z.string().min(1).optional(),
            transactionTimeField: /*#__PURE__*/ z.string().min(1).optional(),
            asOfTimestamp: /*#__PURE__*/ z.string().min(1).optional(),
            joinDirection: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'backward',
                    'forward',
                    'nearest'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            maxStaleness: /*#__PURE__*/ z.string().min(1).optional()
        }).optional(),
        dataVintage: /*#__PURE__*/ z.object({
            dataVintageId: /*#__PURE__*/ z.string().min(1).optional(),
            vintageDate: /*#__PURE__*/ z.string().min(1).optional(),
            realtimeStart: /*#__PURE__*/ z.string().min(1).optional(),
            realtimeEnd: /*#__PURE__*/ z.string().min(1).optional(),
            dataRevisionPolicy: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'as_originally_reported',
                    'as_of_vintage',
                    'latest_restated'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional()
        }).optional(),
        availability: /*#__PURE__*/ z.object({
            periodEndDate: /*#__PURE__*/ z.string().min(1).optional(),
            availabilityDate: /*#__PURE__*/ z.string().min(1).optional(),
            availabilityLagDays: /*#__PURE__*/ z.int().gte(0).optional(),
            availabilityMode: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum(['point_in_time_release_date', 'fixed_lag']),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional()
        }).optional(),
        adjustmentPolicy: /*#__PURE__*/ z.object({
            priceSeries: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'raw',
                    'split_adjusted',
                    'split_dividend_adjusted',
                    'total_return',
                    'scaled_raw'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            adjustmentAsOf: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'decision_date',
                    'dataset_vintage',
                    'latest'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            returnSeriesType: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum(['price_return', 'total_return']),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional()
        }).optional(),
        warmupBars: /*#__PURE__*/ z.int().gte(0).optional(),
        warmupBarsRead: /*#__PURE__*/ z.int().gte(0).optional(),
        firstSignalBar: /*#__PURE__*/ z.string().min(1).optional(),
        universe: /*#__PURE__*/ z.object({
            key: /*#__PURE__*/ z.string().min(1),
            pointInTime: /*#__PURE__*/ z.boolean(),
            survivorshipFree: /*#__PURE__*/ z.boolean(),
            asOf: /*#__PURE__*/ z.string().min(1),
            declared: /*#__PURE__*/ z.boolean().optional(),
            missingMembers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
            memberCount: /*#__PURE__*/ z.int().gte(0).optional(),
            ranking: /*#__PURE__*/ z.object({
                by: /*#__PURE__*/ z.enum(['dollar_volume']),
                limit: /*#__PURE__*/ z.int().gte(1).lte(1000),
                lookbackBars: /*#__PURE__*/ z.int().gte(1).lte(500),
                rebalance: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.enum(['weekly']),
                    /*#__PURE__*/ z.enum(['monthly']),
                    /*#__PURE__*/ z.enum(['quarterly'])
                ])
            }).optional(),
            memberVendors: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string().min(1)).optional()
        }).optional()
    })),
    sourceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    evidenceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    startedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    finishedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    evaluatedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zStrategyRunPersistResult = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'created',
        'updated',
        'existing'
    ]),
    data: zStrategyRunRecord
});

export const zStrategyRunInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyRunRequestRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    definitionId: /*#__PURE__*/ z.number().nullable(),
    bucketDefinitionId: /*#__PURE__*/ z.number().nullable(),
    createdByWorkflowRunId: /*#__PURE__*/ z.number().nullable(),
    createdByUserId: /*#__PURE__*/ z.number().nullable(),
    experimentId: /*#__PURE__*/ z.number().nullable(),
    requestId: /*#__PURE__*/ z.string(),
    idempotencyKey: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled',
        'awaiting_preregistration'
    ]),
    targetKind: /*#__PURE__*/ z.enum([
        'bucket',
        'indicator',
        'definition'
    ]),
    scope: /*#__PURE__*/ z.string(),
    runMode: /*#__PURE__*/ z.enum([
        'research',
        'backtest',
        'walk_forward',
        'cross_validation',
        'monte_carlo',
        'paper',
        'shadow',
        'canary',
        'live'
    ]),
    requestedEngine: /*#__PURE__*/ z.string(),
    requestedAdapterRef: /*#__PURE__*/ z.string().nullable(),
    workerTemplateSlug: /*#__PURE__*/ z.string().nullable(),
    workflowDefinitionId: /*#__PURE__*/ z.number().nullable(),
    workerTimeoutMs: /*#__PURE__*/ z.number().nullable(),
    priority: /*#__PURE__*/ z.string(),
    researchOnly: /*#__PURE__*/ z.boolean(),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    providerUnlockIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    timeframe: /*#__PURE__*/ z.string().nullable(),
    runConfig: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    sourcePayload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    sourceHash: /*#__PURE__*/ z.string(),
    dispatchedWorkflowRunId: /*#__PURE__*/ z.number().nullable(),
    dispatchedWorkerRunId: /*#__PURE__*/ z.string().nullable(),
    requestedAt: /*#__PURE__*/ z.iso.datetime(),
    dispatchedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    completedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zStrategyRunRequestPersistResult = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'created',
        'updated',
        'existing'
    ]),
    data: zStrategyRunRequestRecord
});

export const zStrategyRunRequestInput = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

export const zStrategyRunList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zStrategyRunRecord),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zStrategyRunRequestList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zStrategyRunRequestRecord),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zStrategyRunListItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    runMode: /*#__PURE__*/ z.string(),
    runStatus: /*#__PURE__*/ z.enum([
        'scheduled',
        'running',
        'finished',
        'failed',
        'killed'
    ]),
    definitionVersion: /*#__PURE__*/ z.number().nullable(),
    researchOnly: /*#__PURE__*/ z.boolean(),
    passed: /*#__PURE__*/ z.boolean().nullable(),
    verdict: /*#__PURE__*/ z.string().nullable(),
    sharpe: /*#__PURE__*/ z.number().nullable(),
    maxDrawdown: /*#__PURE__*/ z.number().nullable(),
    totalReturn: /*#__PURE__*/ z.number().nullable(),
    totalTrades: /*#__PURE__*/ z.number().nullable(),
    windowStart: /*#__PURE__*/ z.string().nullable(),
    windowEnd: /*#__PURE__*/ z.string().nullable(),
    dataFrequency: /*#__PURE__*/ z.string().nullable(),
    ownParameters: /*#__PURE__*/ z.boolean(),
    startedAt: /*#__PURE__*/ z.string().nullable(),
    finishedAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string()
});

export const zStrategyRunPortfolioStatistics = /*#__PURE__*/ z.object({
    startEquity: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    endEquity: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    totalReturn: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    totalNetProfit: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    compoundingAnnualReturn: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    annualStandardDeviation: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    annualVariance: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    sharpeRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    probabilisticSharpeRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    deflatedSharpeRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    sortinoRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    annualizationFactor: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    calmarRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    informationRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    trackingError: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    alpha: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    beta: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    upCapture: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    downCapture: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    drawdown: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    maxDrawdown: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    drawdownRecovery: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    portfolioTurnover: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    valueAtRisk95: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    valueAtRisk99: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    winRate: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    lossRate: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    profitLossRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    totalFeesPaid: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    returnsSkewness: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    returnsKurtosis: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    numReturnObservations: /*#__PURE__*/ z.int().gte(0).optional(),
    probabilisticSharpeRatioDaily: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    deflatedSharpeRatioDaily: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    carryApplied: /*#__PURE__*/ z.boolean().optional(),
    carryTotalFrac: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional()
});

export const zStrategyRunTradeStatistics = /*#__PURE__*/ z.object({
    profitFactor: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    winLossRatio: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    winRate: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    totalTrades: /*#__PURE__*/ z.int().gte(0).optional(),
    totalWinningTrades: /*#__PURE__*/ z.int().gte(0).optional(),
    totalLosingTrades: /*#__PURE__*/ z.int().gte(0).optional(),
    maxConsecutiveWinningTrades: /*#__PURE__*/ z.int().gte(0).optional(),
    maxConsecutiveLosingTrades: /*#__PURE__*/ z.int().gte(0).optional(),
    maximumClosedTradeDrawdown: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    maximumIntraTradeDrawdown: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    maximumEndTradeDrawdown: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    averageEndTradeDrawdown: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    averageMAE: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    averageMFE: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    largestMAE: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    largestMFE: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    totalFees: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    totalCommission: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    averageTrade: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    averageWinningTrade: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    averageLosingTrade: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    largestWinningTrade: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    largestLosingTrade: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    grossProfit: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    grossLoss: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    netProfit: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    longTrades: /*#__PURE__*/ z.int().gte(0).optional(),
    shortTrades: /*#__PURE__*/ z.int().gte(0).optional(),
    longNetProfit: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    shortNetProfit: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    maxRunUp: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
        /*#__PURE__*/ z.number()
    ]).optional(),
    fillGroupingMethod: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.enum([
            'fill_to_fill',
            'flat_to_flat',
            'flat_to_reduced'
        ]),
        /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
    ]).optional(),
    fillMatchingMethod: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.enum(['fifo', 'lifo']),
        /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
    ]).optional(),
    rebalanceCount: /*#__PURE__*/ z.int().gte(0).optional()
});

export const zStrategyRunArtifactIndexEntry = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.string(),
    artifactId: /*#__PURE__*/ z.string().nullable(),
    artifactKey: /*#__PURE__*/ z.string(),
    rowCount: /*#__PURE__*/ z.number().nullable(),
    format: /*#__PURE__*/ z.string(),
    contentDigest: /*#__PURE__*/ z.string()
});

export const zStrategyRunResultResult = /*#__PURE__*/ z.object({
    header: /*#__PURE__*/ zStrategyRunListItem.and(/*#__PURE__*/ z.object({
        definitionId: /*#__PURE__*/ z.string().nullable(),
        bucketDefinitionId: /*#__PURE__*/ z.string().nullable(),
        schemaVersion: /*#__PURE__*/ z.string(),
        recommendation: /*#__PURE__*/ z.string().nullable(),
        definitionHash: /*#__PURE__*/ z.string().nullable(),
        paramSetHash: /*#__PURE__*/ z.string().nullable(),
        codeVersion: /*#__PURE__*/ z.string().nullable(),
        nObservations: /*#__PURE__*/ z.number().nullable(),
        statisticBasis: /*#__PURE__*/ z.string().nullable(),
        evaluatedAt: /*#__PURE__*/ z.string().nullable()
    })),
    summary: /*#__PURE__*/ z.object({
        portfolioStatistics: zStrategyRunPortfolioStatistics,
        tradeStatistics: zStrategyRunTradeStatistics,
        executionRealism: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        executionFeasibility: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        searchProvenance: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        robustness: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()),
        runConfig: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        costAssumptionsApplied: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
        dataProvenance: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()),
        benchmark: /*#__PURE__*/ zStrategyRunBenchmark.nullable(),
        warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        blockers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        researchOnlyReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }),
    artifacts: /*#__PURE__*/ z.array(zStrategyRunArtifactIndexEntry)
});

export const zStrategyRunArtifactResult = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.string(),
    format: /*#__PURE__*/ z.string(),
    mode: /*#__PURE__*/ z.enum([
        'series',
        'table',
        'raw'
    ]),
    artifactId: /*#__PURE__*/ z.string().nullable(),
    totalRows: /*#__PURE__*/ z.number().nullable(),
    points: /*#__PURE__*/ z.array(zStrategyRunSeriesPoint).nullable(),
    downsampled: /*#__PURE__*/ z.boolean().nullable(),
    resolution: /*#__PURE__*/ z.number().nullable(),
    columns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).nullable(),
    rows: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).nullable(),
    offset: /*#__PURE__*/ z.number().nullable(),
    limit: /*#__PURE__*/ z.number().nullable(),
    payload: /*#__PURE__*/ z.unknown().optional()
});

export const zStrategyRunAnalytics = /*#__PURE__*/ z.object({
    schemaVersion: /*#__PURE__*/ z.enum(['finance-run-analytics/v1']),
    runId: /*#__PURE__*/ z.string(),
    initialCapital: /*#__PURE__*/ z.number(),
    periodsPerYear: /*#__PURE__*/ z.number().nullable(),
    bars: /*#__PURE__*/ z.int().gte(0),
    firstBar: /*#__PURE__*/ z.string().nullable(),
    lastBar: /*#__PURE__*/ z.string().nullable(),
    keyStats: /*#__PURE__*/ z.object({
        netProfit: /*#__PURE__*/ z.number(),
        netProfitPct: /*#__PURE__*/ z.number().nullable(),
        maxDrawdown: /*#__PURE__*/ z.number(),
        maxDrawdownPct: /*#__PURE__*/ z.number(),
        closedTrades: /*#__PURE__*/ z.int().gte(0),
        openTrades: /*#__PURE__*/ z.int().gte(0),
        profitableTrades: /*#__PURE__*/ z.int().gte(0),
        profitablePct: /*#__PURE__*/ z.number().nullable(),
        profitFactor: /*#__PURE__*/ z.number().nullable()
    }),
    returns: /*#__PURE__*/ z.object({
        totalReturn: /*#__PURE__*/ z.number().nullable(),
        cagr: /*#__PURE__*/ z.number().nullable(),
        sharpe: /*#__PURE__*/ z.number().nullable(),
        sortino: /*#__PURE__*/ z.number().nullable(),
        volatilityAnnual: /*#__PURE__*/ z.number().nullable()
    }),
    periodical: /*#__PURE__*/ z.object({
        daily: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        weekly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        monthly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        quarterly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        yearly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional()
    }),
    benchmarking: /*#__PURE__*/ z.object({
        buyHoldReturn: /*#__PURE__*/ z.number(),
        outperformance: /*#__PURE__*/ z.number(),
        monthlyCorrelation: /*#__PURE__*/ z.number().nullable(),
        monthly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            strategy: /*#__PURE__*/ z.number().nullable(),
            buyHold: /*#__PURE__*/ z.number().nullable()
        }))
    }).nullable(),
    exposure: /*#__PURE__*/ z.object({
        average: /*#__PURE__*/ z.number(),
        max: /*#__PURE__*/ z.number(),
        timeInMarket: /*#__PURE__*/ z.number()
    }).nullable(),
    growthAndDecline: /*#__PURE__*/ z.object({
        runUps: /*#__PURE__*/ z.object({
            count: /*#__PURE__*/ z.int().gte(0),
            averageBars: /*#__PURE__*/ z.number().nullable(),
            maxAmount: /*#__PURE__*/ z.number().nullable(),
            maxPct: /*#__PURE__*/ z.number().nullable(),
            averageAmount: /*#__PURE__*/ z.number().nullable(),
            averagePct: /*#__PURE__*/ z.number().nullable(),
            currentAmount: /*#__PURE__*/ z.number().nullable(),
            currentPct: /*#__PURE__*/ z.number().nullable()
        }),
        drawdowns: /*#__PURE__*/ z.object({
            count: /*#__PURE__*/ z.int().gte(0),
            averageBars: /*#__PURE__*/ z.number().nullable(),
            maxAmount: /*#__PURE__*/ z.number().nullable(),
            maxPct: /*#__PURE__*/ z.number().nullable(),
            averageAmount: /*#__PURE__*/ z.number().nullable(),
            averagePct: /*#__PURE__*/ z.number().nullable(),
            currentAmount: /*#__PURE__*/ z.number().nullable(),
            currentPct: /*#__PURE__*/ z.number().nullable()
        }),
        maxDrawdownPctOfInitial: /*#__PURE__*/ z.number(),
        episodes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum(['run_up', 'drawdown']),
            start: /*#__PURE__*/ z.string(),
            end: /*#__PURE__*/ z.string(),
            amount: /*#__PURE__*/ z.number(),
            pct: /*#__PURE__*/ z.number(),
            bars: /*#__PURE__*/ z.int().gte(0),
            current: /*#__PURE__*/ z.boolean()
        }))
    }),
    profitsAndLosses: /*#__PURE__*/ z.object({
        long: /*#__PURE__*/ z.object({
            trades: /*#__PURE__*/ z.int().gte(0),
            netProfit: /*#__PURE__*/ z.number(),
            grossProfit: /*#__PURE__*/ z.number(),
            grossLoss: /*#__PURE__*/ z.number(),
            winners: /*#__PURE__*/ z.int().gte(0)
        }),
        short: /*#__PURE__*/ z.object({
            trades: /*#__PURE__*/ z.int().gte(0),
            netProfit: /*#__PURE__*/ z.number(),
            grossProfit: /*#__PURE__*/ z.number(),
            grossLoss: /*#__PURE__*/ z.number(),
            winners: /*#__PURE__*/ z.int().gte(0)
        }),
        commission: /*#__PURE__*/ z.number(),
        bySignal: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            key: /*#__PURE__*/ z.string(),
            label: /*#__PURE__*/ z.string(),
            trades: /*#__PURE__*/ z.int().gte(0),
            winners: /*#__PURE__*/ z.int().gte(0),
            losers: /*#__PURE__*/ z.int().gte(0),
            netProfit: /*#__PURE__*/ z.number()
        }))
    }),
    trades: /*#__PURE__*/ z.object({
        list: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            tradeNo: /*#__PURE__*/ z.int(),
            symbol: /*#__PURE__*/ z.string().nullable(),
            side: /*#__PURE__*/ z.enum(['long', 'short']),
            status: /*#__PURE__*/ z.enum(['closed', 'open']),
            entryTime: /*#__PURE__*/ z.string().nullable(),
            exitTime: /*#__PURE__*/ z.string().nullable(),
            entryPrice: /*#__PURE__*/ z.number().nullable(),
            exitPrice: /*#__PURE__*/ z.number().nullable(),
            size: /*#__PURE__*/ z.number().nullable(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number(),
            cumulativePnl: /*#__PURE__*/ z.number().nullable(),
            runUp: /*#__PURE__*/ z.number().nullable(),
            drawdown: /*#__PURE__*/ z.number().nullable(),
            barsHeld: /*#__PURE__*/ z.number().nullable(),
            fees: /*#__PURE__*/ z.number(),
            exitReason: /*#__PURE__*/ z.string().nullable(),
            entrySignals: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
        })),
        distribution: /*#__PURE__*/ z.object({
            bins: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                from: /*#__PURE__*/ z.number(),
                to: /*#__PURE__*/ z.number(),
                count: /*#__PURE__*/ z.int().gte(0)
            })),
            winners: /*#__PURE__*/ z.int().gte(0),
            losers: /*#__PURE__*/ z.int().gte(0),
            breakEvens: /*#__PURE__*/ z.int().gte(0),
            expectancy: /*#__PURE__*/ z.number().nullable(),
            averageWin: /*#__PURE__*/ z.number().nullable(),
            averageLoss: /*#__PURE__*/ z.number().nullable(),
            largestProfit: /*#__PURE__*/ z.number().nullable(),
            largestLoss: /*#__PURE__*/ z.number().nullable(),
            outliersPnl: /*#__PURE__*/ z.number(),
            outliers: /*#__PURE__*/ z.int().gte(0)
        }),
        streaks: /*#__PURE__*/ z.object({
            longestWin: /*#__PURE__*/ z.int().gte(0),
            longestLoss: /*#__PURE__*/ z.int().gte(0),
            averageWin: /*#__PURE__*/ z.number().nullable(),
            averageLoss: /*#__PURE__*/ z.number().nullable(),
            series: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                tradeNo: /*#__PURE__*/ z.int(),
                streak: /*#__PURE__*/ z.int(),
                amount: /*#__PURE__*/ z.number()
            }))
        }),
        timePatterns: /*#__PURE__*/ z.object({
            byEntryHour: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                key: /*#__PURE__*/ z.string(),
                label: /*#__PURE__*/ z.string(),
                trades: /*#__PURE__*/ z.int().gte(0),
                winners: /*#__PURE__*/ z.int().gte(0),
                losers: /*#__PURE__*/ z.int().gte(0),
                netProfit: /*#__PURE__*/ z.number()
            })),
            byEntryWeekday: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                key: /*#__PURE__*/ z.string(),
                label: /*#__PURE__*/ z.string(),
                trades: /*#__PURE__*/ z.int().gte(0),
                winners: /*#__PURE__*/ z.int().gte(0),
                losers: /*#__PURE__*/ z.int().gte(0),
                netProfit: /*#__PURE__*/ z.number()
            })),
            byEntryMonth: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                key: /*#__PURE__*/ z.string(),
                label: /*#__PURE__*/ z.string(),
                trades: /*#__PURE__*/ z.int().gte(0),
                winners: /*#__PURE__*/ z.int().gte(0),
                losers: /*#__PURE__*/ z.int().gte(0),
                netProfit: /*#__PURE__*/ z.number()
            })),
            averageBarsHeld: /*#__PURE__*/ z.number().nullable(),
            averageBarsHeldWinners: /*#__PURE__*/ z.number().nullable(),
            averageBarsHeldLosers: /*#__PURE__*/ z.number().nullable()
        })
    })
});

export const zStrategyDefinitionSummary = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.string(),
    base: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    category: /*#__PURE__*/ z.string().nullable(),
    assetClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    timeframe: /*#__PURE__*/ z.string().nullable(),
    lifecycle: /*#__PURE__*/ z.string().nullable(),
    score: /*#__PURE__*/ z.object({
        value: /*#__PURE__*/ z.number(),
        grade: /*#__PURE__*/ z.enum([
            'A',
            'B',
            'C',
            'D',
            'F'
        ]),
        partial: /*#__PURE__*/ z.boolean(),
        missing: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        parts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            part: /*#__PURE__*/ z.enum([
                'profitability',
                'riskAdjusted',
                'reliability',
                'drawdown'
            ]),
            weight: /*#__PURE__*/ z.number(),
            points: /*#__PURE__*/ z.number().nullable()
        })),
        period: /*#__PURE__*/ z.object({
            days: /*#__PURE__*/ z.number(),
            from: /*#__PURE__*/ z.string(),
            to: /*#__PURE__*/ z.string()
        }).nullable(),
        evidenceRunId: /*#__PURE__*/ z.string().nullable(),
        computedAt: /*#__PURE__*/ z.string()
    }).nullable(),
    tier: /*#__PURE__*/ z.object({
        worksNow: /*#__PURE__*/ z.boolean(),
        provenRegimes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }).nullable(),
    latestRun: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        runMode: /*#__PURE__*/ z.string(),
        finishedAt: /*#__PURE__*/ z.string().nullable(),
        sharpe: /*#__PURE__*/ z.number().nullable(),
        maxDrawdown: /*#__PURE__*/ z.number().nullable(),
        totalReturn: /*#__PURE__*/ z.number().nullable(),
        totalTrades: /*#__PURE__*/ z.number().nullable()
    }).nullable()
});

export const zStrategyDefinitionGroup = /*#__PURE__*/ z.object({
    key: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    variants: /*#__PURE__*/ z.int(),
    weak: /*#__PURE__*/ z.int(),
    grades: /*#__PURE__*/ z.object({
        A: /*#__PURE__*/ z.int(),
        B: /*#__PURE__*/ z.int(),
        C: /*#__PURE__*/ z.int(),
        D: /*#__PURE__*/ z.int(),
        F: /*#__PURE__*/ z.int(),
        unscored: /*#__PURE__*/ z.int()
    }),
    best: zStrategyDefinitionSummary
});

export const zStrategyDefinitionGroupList = /*#__PURE__*/ z.object({
    groups: /*#__PURE__*/ z.array(zStrategyDefinitionGroup),
    total: /*#__PURE__*/ z.int(),
    hiddenGroups: /*#__PURE__*/ z.int()
});

export const zStrategyDefinitionRunList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zStrategyRunListItem),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zStrategyDefinitionParamSet = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.number(),
    /*#__PURE__*/ z.string(),
    /*#__PURE__*/ z.boolean()
]));

export const zCreateStrategyDefinitionRunResult = /*#__PURE__*/ z.object({
    runRequestId: /*#__PURE__*/ z.string(),
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    researchOnly: /*#__PURE__*/ z.boolean(),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    paramSet: zStrategyDefinitionParamSet,
    paramSetHash: /*#__PURE__*/ z.string().nullable()
});

export const zStrategyParamSetViolation = /*#__PURE__*/ z.object({
    key: /*#__PURE__*/ z.string(),
    code: /*#__PURE__*/ z.enum([
        'unknown_parameter',
        'type_mismatch',
        'out_of_range',
        'not_allowed_value'
    ]),
    message: /*#__PURE__*/ z.string()
});

export const zStrategyDefinitionRunErrorResult = /*#__PURE__*/ z.object({
    error: /*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.string(),
        message: /*#__PURE__*/ z.string(),
        violations: /*#__PURE__*/ z.array(zStrategyParamSetViolation).optional()
    })
});

export const zCreateStrategyDefinitionRunRequest = /*#__PURE__*/ z.object({
    paramSet: /*#__PURE__*/ zStrategyDefinitionParamSet.optional(),
    window: /*#__PURE__*/ z.object({
        start: /*#__PURE__*/ z.iso.datetime(),
        end: /*#__PURE__*/ z.iso.datetime()
    }).optional(),
    dataFrequency: /*#__PURE__*/ z.string().min(1).max(20).optional(),
    initialCapital: /*#__PURE__*/ z.number().gt(0).optional(),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(40)).min(1).max(50).optional(),
    runMode: /*#__PURE__*/ z.enum(['research', 'backtest']),
    costs: /*#__PURE__*/ z.object({
        commissionBpsPerSide: /*#__PURE__*/ z.number().gte(0).lte(500),
        halfSpreadBps: /*#__PURE__*/ z.number().gte(0).lte(500)
    }).optional()
});

export const zAmendStrategyDefinitionParametersResult = /*#__PURE__*/ z.object({
    strategyDefinitionId: /*#__PURE__*/ z.string(),
    definitionVersion: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    created: /*#__PURE__*/ z.boolean(),
    parameters: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        type: /*#__PURE__*/ z.string(),
        default: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.number(),
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.boolean()
        ]),
        min: /*#__PURE__*/ z.number().optional(),
        max: /*#__PURE__*/ z.number().optional(),
        step: /*#__PURE__*/ z.number().optional(),
        unit: /*#__PURE__*/ z.string().optional(),
        description: /*#__PURE__*/ z.string().optional(),
        source: /*#__PURE__*/ z.string()
    }))
});

export const zStrategyParameterPatch = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(160),
    default: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ]).optional(),
    min: /*#__PURE__*/ z.number().optional(),
    max: /*#__PURE__*/ z.number().optional(),
    step: /*#__PURE__*/ z.number().gt(0).optional(),
    optimizationGrid: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ])).max(100).optional(),
    unit: /*#__PURE__*/ z.string().max(40).optional(),
    description: /*#__PURE__*/ z.string().max(500).optional()
});

export const zAmendStrategyDefinitionParametersRequest = /*#__PURE__*/ z.object({
    parameters: /*#__PURE__*/ z.array(zStrategyParameterPatch).min(1).max(100)
});

export const zForkStrategyDefinitionResult = /*#__PURE__*/ z.object({
    strategyDefinitionId: /*#__PURE__*/ z.string(),
    sourceCandidateId: /*#__PURE__*/ z.string(),
    definitionVersion: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    indicatorRowCount: /*#__PURE__*/ z.number()
});

export const zStrategyTemplateRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    entityId: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    version: /*#__PURE__*/ z.number(),
    templateRef: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string(),
    family: /*#__PURE__*/ z.string(),
    requiredIndicatorFamilies: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.enum([
            'price',
            'volume',
            'volatility',
            'momentum',
            'trend',
            'breadth',
            'fundamental',
            'macro',
            'options',
            'on_chain',
            'sentiment',
            'custom'
        ]), /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)])),
    parameterSchema: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.string().optional(),
        default: /*#__PURE__*/ z.unknown().optional(),
        min: /*#__PURE__*/ z.number().optional(),
        max: /*#__PURE__*/ z.number().optional(),
        description: /*#__PURE__*/ z.string().optional(),
        optimizationHints: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
    })),
    indicators: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
    entryRuleSkeletons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
    exitRuleSkeletons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())),
    marketSupport: /*#__PURE__*/ z.object({
        assetClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.enum([
                'equity',
                'etf',
                'future',
                'forex',
                'crypto_spot',
                'crypto_perp',
                'option',
                'index',
                'rate',
                'commodity',
                'multi_asset',
                'synthetic'
            ]), /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)])).optional().default([]),
        timeframes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([])
    }),
    knownFailureModes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.string().min(1),
        description: /*#__PURE__*/ z.string().min(1),
        mitigation: /*#__PURE__*/ z.string().optional()
    })),
    mutationHooks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        hookId: /*#__PURE__*/ z.string().min(1),
        recipeRef: /*#__PURE__*/ z.string().optional(),
        description: /*#__PURE__*/ z.string().min(1),
        params: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({})
    })),
    scoringObjectiveDefaults: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    provenance: /*#__PURE__*/ z.object({
        sourceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
        evidenceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
        extractor: /*#__PURE__*/ z.string().optional(),
        extractionHash: /*#__PURE__*/ z.string().optional(),
        confidence: /*#__PURE__*/ z.number().gte(0).lte(1).optional()
    })
});

export const zStrategyTemplateList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zStrategyTemplateRecord)
});

export const zStrategyTemplateGetResult = /*#__PURE__*/ z.object({
    data: zStrategyTemplateRecord
});

export const zStrategyTemplateFeatureBindingReadiness = /*#__PURE__*/ z.object({
    alias: /*#__PURE__*/ z.string(),
    canonicalRef: /*#__PURE__*/ z.string().nullable(),
    sourceTier: /*#__PURE__*/ z.enum([
        'in_adapter',
        'precomputed_frame',
        'unknown'
    ]),
    readiness: /*#__PURE__*/ z.enum([
        'ready',
        'missing_implementation',
        'disabled_implementation',
        'research_only'
    ]),
    reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    researchOnly: /*#__PURE__*/ z.boolean(),
    liveness: /*#__PURE__*/ z.object({
        ttlMs: /*#__PURE__*/ z.int().gt(0),
        certified: /*#__PURE__*/ z.boolean()
    }).nullable(),
    variant: /*#__PURE__*/ z.object({
        scope: /*#__PURE__*/ z.string().nullable(),
        regime: /*#__PURE__*/ z.string()
    }).nullable()
});

export const zStrategyTemplatePreviewResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        definition: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        indicatorBindings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            alias: /*#__PURE__*/ z.string().min(1),
            source: /*#__PURE__*/ z.enum(['inline', 'catalog']).optional().default('inline'),
            indicatorDefinitionRef: /*#__PURE__*/ z.string().optional(),
            indicatorDefinitionId: /*#__PURE__*/ z.int().gt(0).optional(),
            indicatorImplementationRef: /*#__PURE__*/ z.string().optional(),
            indicatorImplementationId: /*#__PURE__*/ z.int().gt(0).optional(),
            parameterValues: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
            inputBinding: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.object({
                field: /*#__PURE__*/ z.string().optional(),
                symbol: /*#__PURE__*/ z.string().optional(),
                timeframe: /*#__PURE__*/ z.string().optional(),
                window: /*#__PURE__*/ z.int().gt(0).optional(),
                lag: /*#__PURE__*/ z.int().gte(0).optional(),
                transform: /*#__PURE__*/ z.string().optional(),
                value: /*#__PURE__*/ z.unknown().optional(),
                path: /*#__PURE__*/ z.string().optional()
            })).optional().default({}),
            outputAliases: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional().default({}),
            liveness: /*#__PURE__*/ z.object({
                ttlMs: /*#__PURE__*/ z.int().gt(0),
                certified: /*#__PURE__*/ z.boolean(),
                certifiedBy: /*#__PURE__*/ z.string().max(300).optional(),
                certifiedAt: /*#__PURE__*/ z.string().max(40).optional()
            }).optional(),
            timeframe: /*#__PURE__*/ z.string().min(1).optional(),
            barSource: /*#__PURE__*/ z.enum(['ohlc', 'heikin_ashi']).optional(),
            readiness: /*#__PURE__*/ z.object({
                status: /*#__PURE__*/ z.enum([
                    'ready',
                    'missing_implementation',
                    'disabled_implementation',
                    'research_only'
                ]).optional().default('ready'),
                reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([])
            }).optional().default({ status: 'ready', reasons: [] })
        })),
        mergedParameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        provenance: /*#__PURE__*/ z.object({
            templateRef: /*#__PURE__*/ z.string(),
            version: /*#__PURE__*/ z.number(),
            extractor: /*#__PURE__*/ z.string()
        }),
        featureBindings: /*#__PURE__*/ z.array(zStrategyTemplateFeatureBindingReadiness),
        marketDataReadiness: /*#__PURE__*/ zStrategyTemplateMarketDataReadiness.nullable(),
        realtimeMarketDataReadiness: /*#__PURE__*/ zStrategyTemplateRealtimeMarketDataReadiness.nullable()
    })
});

export const zStrategyTemplatePreviewRequest = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.int().gt(0).optional(),
    templateRef: /*#__PURE__*/ z.string().min(1).max(160).optional(),
    version: /*#__PURE__*/ z.int().gt(0).optional(),
    overrides: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    assetClass: /*#__PURE__*/ z.string().optional(),
    timeframe: /*#__PURE__*/ z.string().optional(),
    windowStart: /*#__PURE__*/ z.iso.datetime().optional(),
    windowEnd: /*#__PURE__*/ z.iso.datetime().optional(),
    name: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().optional(),
    testIntent: /*#__PURE__*/ z.string().optional(),
    exchange: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    require_realtime_data: /*#__PURE__*/ z.boolean().optional()
});

export const zStrategyTemplateEnqueueResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        strategyDefinitionId: /*#__PURE__*/ z.number(),
        runRequestId: /*#__PURE__*/ z.number(),
        requestId: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        indicatorBindingCount: /*#__PURE__*/ z.number()
    })
});

export const zStrategyTemplateEnqueueRequest = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.int().gt(0).optional(),
    templateRef: /*#__PURE__*/ z.string().min(1).max(160).optional(),
    version: /*#__PURE__*/ z.int().gt(0).optional(),
    overrides: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    assetClass: /*#__PURE__*/ z.string().optional(),
    timeframe: /*#__PURE__*/ z.string().optional(),
    name: /*#__PURE__*/ z.string().optional(),
    description: /*#__PURE__*/ z.string().optional(),
    testIntent: /*#__PURE__*/ z.string().optional(),
    scope: /*#__PURE__*/ z.enum([
        'backtest',
        'validation',
        'smoke',
        'in_sample',
        'out_of_sample',
        'walk_forward',
        'cross_validation',
        'parameter_sweep',
        'forward_test',
        'monte_carlo',
        'robustness'
    ]).optional(),
    runMode: /*#__PURE__*/ z.enum(['research', 'backtest']).optional(),
    windowStart: /*#__PURE__*/ z.iso.datetime().optional(),
    windowEnd: /*#__PURE__*/ z.iso.datetime().optional(),
    exchange: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    require_realtime_data: /*#__PURE__*/ z.boolean().optional()
});

export const zFinanceProviderUnlockPromptRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    unlockId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    need: /*#__PURE__*/ z.string(),
    userPrompt: /*#__PURE__*/ z.string(),
    scopeKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    assetClasses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    unlocksScopes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    requiredSecrets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    requiredData: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    providerOptions: /*#__PURE__*/ z.object({
        free: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        paid: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }),
    risks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    recommendedSafeDefault: /*#__PURE__*/ z.string(),
    biasIfMissing: /*#__PURE__*/ z.string(),
    sourcePayload: /*#__PURE__*/ z.object({
        unlockId: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/),
        need: /*#__PURE__*/ z.string().min(1),
        unlocksScopes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1),
        userPrompt: /*#__PURE__*/ z.string().min(1),
        requiredSecrets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
        requiredData: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
        providerOptions: /*#__PURE__*/ z.object({
            free: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
            paid: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([])
        }),
        risks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
        recommendedSafeDefault: /*#__PURE__*/ z.string().min(1),
        biasIfMissing: /*#__PURE__*/ z.string().min(1)
    }),
    sourceHash: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zFinanceProviderUnlockPromptList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zFinanceProviderUnlockPromptRecord),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zFinanceProviderUnlockPromptDetailResult = /*#__PURE__*/ z.object({
    data: zFinanceProviderUnlockPromptRecord
});

export const zFinanceStrategyCostModelRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    createdByWorkflowRunId: /*#__PURE__*/ z.number().nullable(),
    costModelId: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string().nullable(),
    modelHash: /*#__PURE__*/ z.string().nullable(),
    realismLevel: /*#__PURE__*/ z.string().nullable(),
    brokerageModel: /*#__PURE__*/ z.string().nullable(),
    slippageModelKind: /*#__PURE__*/ z.string().nullable(),
    feeModelKind: /*#__PURE__*/ z.string().nullable(),
    fillModelKind: /*#__PURE__*/ z.string().nullable(),
    fillTiming: /*#__PURE__*/ z.string().nullable(),
    costAssumptionSource: /*#__PURE__*/ z.string().nullable(),
    model: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum(['strategy_cost_model']).optional().default('strategy_cost_model'),
        schemaVersion: /*#__PURE__*/ z.enum(['finance-strategy-cost-model/v1']).optional().default('finance-strategy-cost-model/v1'),
        costModelId: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/),
        version: /*#__PURE__*/ z.string().min(1),
        name: /*#__PURE__*/ z.string().min(1).optional(),
        realismLevel: /*#__PURE__*/ z.enum([
            'none',
            'default_broker',
            'custom'
        ]).optional().default('custom'),
        brokerageModel: /*#__PURE__*/ z.string().optional(),
        slippageModel: /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'none',
                    'fixed_basis_points',
                    'constant_percent',
                    'fixed_spread',
                    'spread_fraction',
                    'proportional_price',
                    'volume_share',
                    'square_root_impact',
                    'almgren_chriss',
                    'custom'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
            costAssumptionSource: /*#__PURE__*/ z.enum([
                'none',
                'measured',
                'vendor_feed',
                'static_assumption',
                'heuristic'
            ]).optional().default('none'),
            applyOnOpen: /*#__PURE__*/ z.boolean().optional(),
            allowFillBeyondLimit: /*#__PURE__*/ z.boolean().optional()
        }).nullish().default({
            kind: 'none',
            config: {},
            costAssumptionSource: 'none'
        }),
        feeModel: /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'none',
                    'per_share',
                    'per_trade',
                    'per_dollar',
                    'per_contract',
                    'maker_taker',
                    'tiered',
                    'proportional_plus_fixed',
                    'brokerage_named',
                    'custom'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
            currency: /*#__PURE__*/ z.string().min(1).optional(),
            regulatoryFees: /*#__PURE__*/ z.object({
                side: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.enum([
                        'buy',
                        'sell',
                        'both'
                    ]),
                    /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
                ]).optional(),
                secFeeBps: /*#__PURE__*/ z.number().gte(0).optional(),
                finraTafPerShare: /*#__PURE__*/ z.number().gte(0).optional(),
                exchangeFeePerShare: /*#__PURE__*/ z.number().gte(0).optional(),
                clearingFeePerTrade: /*#__PURE__*/ z.number().gte(0).optional()
            }).optional(),
            costAssumptionSource: /*#__PURE__*/ z.enum([
                'none',
                'measured',
                'vendor_feed',
                'static_assumption',
                'heuristic'
            ]).optional().default('none')
        }).nullish().default({
            kind: 'none',
            config: {},
            costAssumptionSource: 'none'
        }),
        latencyModel: /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'zero',
                    'fixed_ms',
                    'uniform_ms',
                    'normal_ms',
                    'distribution',
                    'custom'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
            fixedLatencyMs: /*#__PURE__*/ z.number().gte(0).optional(),
            latencyMeanMs: /*#__PURE__*/ z.number().gte(0).optional(),
            latencyStdMs: /*#__PURE__*/ z.number().gte(0).optional(),
            adverseSelectionBps: /*#__PURE__*/ z.number().optional(),
            costAssumptionSource: /*#__PURE__*/ z.enum([
                'none',
                'measured',
                'vendor_feed',
                'static_assumption',
                'heuristic'
            ]).optional().default('none')
        }).nullish().default({
            kind: 'zero',
            config: {},
            costAssumptionSource: 'none'
        }),
        fillModel: /*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'immediate',
                    'equity',
                    'future',
                    'future_option',
                    'best_price',
                    'parametric',
                    'size_aware',
                    'partial',
                    'volume_sensitive',
                    'session_aware',
                    'competition_aware',
                    'custom'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            fillTiming: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'same_bar_close',
                    'next_bar_open',
                    'next_bar_vwap',
                    'mid',
                    'worst_of_bar',
                    'quote_cross'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            idealizedFills: /*#__PURE__*/ z.boolean().optional().default(false),
            config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
            queue: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({})
        }).nullish().default({
            kind: 'immediate',
            fillTiming: 'next_bar_open',
            idealizedFills: false,
            config: {},
            queue: {}
        }),
        borrowCostModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        financingCostModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        settlementModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
        sourceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/)).optional().default([]),
        evidenceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/)).optional().default([])
    }),
    sourceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    evidenceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zFinanceStrategyCostModelPersistResult = /*#__PURE__*/ z.object({
    data: zFinanceStrategyCostModelRecord,
    status: /*#__PURE__*/ z.enum(['created', 'existing'])
});

export const zFinanceStrategyCostModelList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zFinanceStrategyCostModelRecord),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zFinanceStrategyCostModelDetailResult = /*#__PURE__*/ z.object({
    data: zFinanceStrategyCostModelRecord
});

export const zFinanceStrategyLifecycleTransitionRecord = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    definitionId: /*#__PURE__*/ z.number().nullable(),
    bucketDefinitionId: /*#__PURE__*/ z.number().nullable(),
    fromState: /*#__PURE__*/ z.enum([
        'candidate',
        'research_brief',
        'backtest_pending',
        'backtest_done_pass',
        'backtest_done_fail',
        'risk_pending',
        'risk_cleared',
        'risk_rejected',
        'paper_trading',
        'paper_trading_completed',
        'pending_live_approval',
        'live_trading',
        'retired',
        'archived',
        'watchlist'
    ]).nullable(),
    toState: /*#__PURE__*/ z.enum([
        'candidate',
        'research_brief',
        'backtest_pending',
        'backtest_done_pass',
        'backtest_done_fail',
        'risk_pending',
        'risk_cleared',
        'risk_rejected',
        'paper_trading',
        'paper_trading_completed',
        'pending_live_approval',
        'live_trading',
        'retired',
        'archived',
        'watchlist'
    ]),
    fromScope: /*#__PURE__*/ z.string().nullable(),
    toScope: /*#__PURE__*/ z.string().nullable(),
    transitionType: /*#__PURE__*/ z.string(),
    gateResult: /*#__PURE__*/ z.object({
        gateName: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/),
        requirement: /*#__PURE__*/ z.string().min(1),
        observedValue: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
            /*#__PURE__*/ z.number(),
            /*#__PURE__*/ z.boolean(),
            /*#__PURE__*/ z.string()
        ]).optional(),
        statistic: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'mean',
                'median',
                'p5',
                'p95',
                'min',
                'max',
                'std',
                'latest',
                'all'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        comparator: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                '>=',
                '>',
                '<=',
                '<',
                '==',
                '!=',
                'in',
                'all_pass'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        threshold: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
            /*#__PURE__*/ z.number(),
            /*#__PURE__*/ z.boolean(),
            /*#__PURE__*/ z.string()
        ]).optional(),
        passed: /*#__PURE__*/ z.boolean(),
        sourceRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/)).optional().default([]),
        evaluatedAt: /*#__PURE__*/ z.string().min(1).optional(),
        details: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({})
    }).nullable(),
    sourceRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    actorId: /*#__PURE__*/ z.number().nullable(),
    reason: /*#__PURE__*/ z.string(),
    occurredAt: /*#__PURE__*/ z.iso.datetime(),
    transitionAuthority: /*#__PURE__*/ z.enum([
        'approved_writer',
        'research_auto',
        'route_human',
        'system',
        'legacy_backfill'
    ]).nullable(),
    actorKind: /*#__PURE__*/ z.enum([
        'human',
        'daemon',
        'system'
    ]).nullable(),
    approvalDecisionId: /*#__PURE__*/ z.number().nullable(),
    approvedBy: /*#__PURE__*/ z.number().nullable(),
    approvedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zFinanceStrategyLifecycleTransitionCreateResult = /*#__PURE__*/ z.object({
    data: zFinanceStrategyLifecycleTransitionRecord
});

export const zFinanceStrategyLifecycleTransitionCreateInput = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.int().gt(0).optional(),
    bucketDefinitionId: /*#__PURE__*/ z.int().gt(0).optional(),
    fromState: /*#__PURE__*/ z.enum([
        'candidate',
        'research_brief',
        'backtest_pending',
        'backtest_done_pass',
        'backtest_done_fail',
        'risk_pending',
        'risk_cleared',
        'risk_rejected',
        'paper_trading',
        'paper_trading_completed',
        'pending_live_approval',
        'live_trading',
        'retired',
        'archived',
        'watchlist'
    ]).optional(),
    toState: /*#__PURE__*/ z.enum([
        'candidate',
        'research_brief',
        'backtest_pending',
        'backtest_done_pass',
        'backtest_done_fail',
        'risk_pending',
        'risk_cleared',
        'risk_rejected',
        'paper_trading',
        'paper_trading_completed',
        'pending_live_approval',
        'live_trading',
        'retired',
        'archived',
        'watchlist'
    ]),
    fromScope: /*#__PURE__*/ z.string().min(1).max(240).optional(),
    toScope: /*#__PURE__*/ z.string().min(1).max(240).optional(),
    transitionType: /*#__PURE__*/ z.string().min(1).max(40),
    gateResult: /*#__PURE__*/ z.object({
        gateName: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/),
        requirement: /*#__PURE__*/ z.string().min(1),
        observedValue: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
            /*#__PURE__*/ z.number(),
            /*#__PURE__*/ z.boolean(),
            /*#__PURE__*/ z.string()
        ]).optional(),
        statistic: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'mean',
                'median',
                'p5',
                'p95',
                'min',
                'max',
                'std',
                'latest',
                'all'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        comparator: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                '>=',
                '>',
                '<=',
                '<',
                '==',
                '!=',
                'in',
                'all_pass'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        threshold: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string().regex(/^-?\d+(\.\d+)?$/),
            /*#__PURE__*/ z.number(),
            /*#__PURE__*/ z.boolean(),
            /*#__PURE__*/ z.string()
        ]).optional(),
        passed: /*#__PURE__*/ z.boolean(),
        sourceRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/)).optional().default([]),
        evaluatedAt: /*#__PURE__*/ z.string().min(1).optional(),
        details: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({})
    }).optional(),
    sourceRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
    reason: /*#__PURE__*/ z.string().min(1),
    occurredAt: /*#__PURE__*/ z.string().min(1).optional()
});

export const zFinanceStrategyLifecycleTransitionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zFinanceStrategyLifecycleTransitionRecord),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zFinanceStrategyLifecycleCommitInput = /*#__PURE__*/ z.object({
    approvalDecisionId: /*#__PURE__*/ z.int().gt(0),
    definitionId: /*#__PURE__*/ z.int().gt(0).optional(),
    bucketDefinitionId: /*#__PURE__*/ z.int().gt(0).optional(),
    toState: /*#__PURE__*/ z.enum([
        'paper_trading',
        'pending_live_approval',
        'live_trading'
    ]),
    fromState: /*#__PURE__*/ z.enum([
        'candidate',
        'research_brief',
        'backtest_pending',
        'backtest_done_pass',
        'backtest_done_fail',
        'risk_pending',
        'risk_cleared',
        'risk_rejected',
        'paper_trading',
        'paper_trading_completed',
        'pending_live_approval',
        'live_trading',
        'retired',
        'archived',
        'watchlist'
    ]).optional(),
    fromScope: /*#__PURE__*/ z.string().min(1).max(240).optional(),
    toScope: /*#__PURE__*/ z.string().min(1).max(240).optional(),
    sourceRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional().default([]),
    reason: /*#__PURE__*/ z.string().min(1)
});

export const zFinanceArtifactPreviewResult = /*#__PURE__*/ z.object({
    previewKind: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.string(),
    subtype: /*#__PURE__*/ z.string().optional(),
    title: /*#__PURE__*/ z.string(),
    fields: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    supported: /*#__PURE__*/ z.literal(true),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    allowedActions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zFinanceArtifactUnsupportedPreviewResult = /*#__PURE__*/ z.object({
    previewKind: /*#__PURE__*/ z.enum(['unsupported']),
    type: /*#__PURE__*/ z.string().nullable(),
    reason: /*#__PURE__*/ z.enum([
        'unsupported_finance_type',
        'invalid_payload',
        'not_finance'
    ]),
    message: /*#__PURE__*/ z.string(),
    supported: /*#__PURE__*/ z.literal(false)
});

export const zFinanceResearchWorkflowEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    category: /*#__PURE__*/ z.string().nullable(),
    lastRunAt: /*#__PURE__*/ z.string().nullable(),
    daemon: /*#__PURE__*/ zFinanceResearchDaemonLink.nullable(),
    linkEnabled: /*#__PURE__*/ z.boolean().nullable(),
    lastRun: /*#__PURE__*/ zFinanceResearchLastRun.nullable()
});

export const zFinanceResearchWorkflowList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zFinanceResearchWorkflowEntry)
});

export const zFinanceResearchRunStartResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        requestId: /*#__PURE__*/ z.string(),
        workflowDefinitionId: /*#__PURE__*/ z.number(),
        status: /*#__PURE__*/ z.enum(['pending']),
        startedAt: /*#__PURE__*/ z.string(),
        daemonRunId: /*#__PURE__*/ z.unknown()
    })
});

export const zFinancePlannerWtnComponents = /*#__PURE__*/ z.object({
    decayedScore: /*#__PURE__*/ z.number(),
    uncertaintyTerm: /*#__PURE__*/ z.number(),
    stalenessTerm: /*#__PURE__*/ z.number(),
    ladderTerm: /*#__PURE__*/ z.number(),
    redundancyPenalty: /*#__PURE__*/ z.number(),
    readinessFactor: /*#__PURE__*/ z.number(),
    ageDays: /*#__PURE__*/ z.number(),
    halfLifeDays: /*#__PURE__*/ z.number()
});

export const zFinancePlannerEvidence = /*#__PURE__*/ z.object({
    scoreId: /*#__PURE__*/ z.number(),
    scoreValue: /*#__PURE__*/ z.number(),
    scoreUncertainty: /*#__PURE__*/ z.number(),
    scoreComputedAt: /*#__PURE__*/ z.string(),
    sourceRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    familyCumulativeTrials: /*#__PURE__*/ z.number()
});

export const zFinancePlannerCandidate = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.number(),
    definitionName: /*#__PURE__*/ z.string(),
    lifecycleState: /*#__PURE__*/ z.string(),
    sourceCandidateId: /*#__PURE__*/ z.string().nullable(),
    wtn: /*#__PURE__*/ z.number(),
    action: /*#__PURE__*/ z.enum([
        'enqueue_next_scope',
        'retest_stale',
        'improve_params',
        'combine',
        'paper_trade_approval',
        'await_pending_run',
        'needs_data',
        'needs_adapter',
        'reject_low_score',
        'hold_fresh_evidence'
    ]),
    nextScope: /*#__PURE__*/ z.string().nullable(),
    advancedScope: /*#__PURE__*/ z.string().nullable(),
    selectionMode: /*#__PURE__*/ z.enum(['exploit', 'explore']).nullable(),
    components: zFinancePlannerWtnComponents,
    advancedComponents: /*#__PURE__*/ zFinancePlannerAdvancedComponents.nullable(),
    reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    evidence: zFinancePlannerEvidence,
    pendingRequest: /*#__PURE__*/ zFinancePlannerPendingRequest.nullable(),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zFinancePlannerRecommendationsResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        generatedAt: /*#__PURE__*/ z.string(),
        modelVersion: /*#__PURE__*/ z.string(),
        totals: /*#__PURE__*/ z.object({
            scored: /*#__PURE__*/ z.number(),
            enqueueEligible: /*#__PURE__*/ z.number(),
            excludedPending: /*#__PURE__*/ z.number(),
            blocked: /*#__PURE__*/ z.number()
        }),
        candidates: /*#__PURE__*/ z.array(zFinancePlannerCandidate)
    })
});

export const zFinanceBucketComponent = /*#__PURE__*/ z.object({
    componentId: /*#__PURE__*/ z.string(),
    role: /*#__PURE__*/ z.string(),
    definitionId: /*#__PURE__*/ z.number(),
    weight: /*#__PURE__*/ z.number(),
    allocationMethod: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum(['active', 'paused']),
    statusReason: /*#__PURE__*/ z.string().optional(),
    name: /*#__PURE__*/ z.string().optional(),
    skillValue: /*#__PURE__*/ z.number().optional(),
    skillComputedAt: /*#__PURE__*/ z.string().optional()
});

export const zFinanceDegradationDecision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    actionType: /*#__PURE__*/ z.enum([
        'reweight_bucket',
        'replace_component',
        'pause_component'
    ]),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]),
    reviewStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'deferred'
    ]),
    title: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.string(),
    expiresAt: /*#__PURE__*/ z.string().nullable(),
    reviewedAt: /*#__PURE__*/ z.string().nullable(),
    consumedAt: /*#__PURE__*/ z.string().nullable(),
    componentDefinitionId: /*#__PURE__*/ z.number().nullable(),
    sqsDelta: /*#__PURE__*/ z.number().nullable(),
    basisHash: /*#__PURE__*/ z.string().nullable(),
    reasonCodes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    replacement: /*#__PURE__*/ zFinanceDegradationReplacement.nullable(),
    rationale: /*#__PURE__*/ z.string().nullable()
});

export const zFinanceDegradationHypothesis = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    hypothesisType: /*#__PURE__*/ z.string(),
    statement: /*#__PURE__*/ z.string(),
    priorBelief: /*#__PURE__*/ z.number(),
    posteriorBelief: /*#__PURE__*/ z.number().nullable(),
    status: /*#__PURE__*/ z.string(),
    openedAt: /*#__PURE__*/ z.string()
});

export const zFinanceBucketDegradation = /*#__PURE__*/ z.object({
    pendingDecisions: /*#__PURE__*/ z.array(zFinanceDegradationDecision),
    recentResolvedDecisions: /*#__PURE__*/ z.array(zFinanceDegradationDecision),
    hypotheses: /*#__PURE__*/ z.array(zFinanceDegradationHypothesis),
    lastScan: /*#__PURE__*/ zFinanceDegradationLastScan.nullable()
});

export const zFinanceBucketEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    bucketId: /*#__PURE__*/ z.string(),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    mode: /*#__PURE__*/ z.string(),
    lifecycleState: /*#__PURE__*/ z.string(),
    validationStatus: /*#__PURE__*/ z.string(),
    definitionVersion: /*#__PURE__*/ z.number(),
    bucketHash: /*#__PURE__*/ z.string(),
    components: /*#__PURE__*/ z.array(zFinanceBucketComponent),
    compositionEvaluation: /*#__PURE__*/ zFinanceBucketEvaluation.nullable(),
    latestBucketEval: /*#__PURE__*/ zFinanceBucketEvaluation.nullable(),
    latestRunRequest: /*#__PURE__*/ zFinanceBucketRunRequest.nullable(),
    latestRun: /*#__PURE__*/ zFinanceBucketRun.nullable(),
    bucketLevelScore: /*#__PURE__*/ zFinanceBucketScore.nullable(),
    degradation: zFinanceBucketDegradation,
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zFinanceDegradationTotals = /*#__PURE__*/ z.object({
    pendingDecisions: /*#__PURE__*/ z.number(),
    bucketsWithPendingDecisions: /*#__PURE__*/ z.number(),
    openHypotheses: /*#__PURE__*/ z.number(),
    lastScanAt: /*#__PURE__*/ z.string().nullable(),
    lastScanDiagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    unsupportedActionsCount: /*#__PURE__*/ z.number()
});

export const zFinanceBucketCompositionResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        buckets: /*#__PURE__*/ z.array(zFinanceBucketEntry),
        totals: /*#__PURE__*/ z.object({
            buckets: /*#__PURE__*/ z.number(),
            withQueuedEval: /*#__PURE__*/ z.number(),
            withCompletedEval: /*#__PURE__*/ z.number(),
            blocked: /*#__PURE__*/ z.number()
        }),
        degradationTotals: zFinanceDegradationTotals
    })
});

export const zFinanceBucketDecisionApplyResult = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.string(),
    actionType: /*#__PURE__*/ z.enum([
        'reweight_bucket',
        'replace_component',
        'pause_component'
    ]),
    bucketDefinitionId: /*#__PURE__*/ z.string(),
    bucketId: /*#__PURE__*/ z.string(),
    newDefinitionVersion: /*#__PURE__*/ z.number(),
    consumedAt: /*#__PURE__*/ z.string()
});

export const zFinanceProposeReweightResult = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.string(),
    bucketDefinitionId: /*#__PURE__*/ z.string(),
    bucketId: /*#__PURE__*/ z.string(),
    basisHash: /*#__PURE__*/ z.string(),
    reviewStatus: /*#__PURE__*/ z.enum(['pending']),
    deduped: /*#__PURE__*/ z.boolean()
});

export const zFinanceProposeReweightBody = /*#__PURE__*/ z.object({
    bucketDefinitionId: /*#__PURE__*/ z.int().gt(0),
    weights: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        definitionId: /*#__PURE__*/ z.int().gt(0),
        weight: /*#__PURE__*/ z.number().gte(0).lte(1)
    })).min(1).max(8),
    rationale: /*#__PURE__*/ z.string().max(2000).optional()
});

export const zFinanceIndicatorDecisionStatus = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    runRequestId: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zFinanceIndicatorDecisionEnqueueResult = /*#__PURE__*/ z.object({
    data: zFinanceIndicatorDecisionStatus
});

export const zFinanceIndicatorDecisionSummary = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string().nullable(),
    timeframe: /*#__PURE__*/ z.string().nullable(),
    windowStart: /*#__PURE__*/ z.string().nullable(),
    windowEnd: /*#__PURE__*/ z.string().nullable(),
    indicatorCanonicalKey: /*#__PURE__*/ z.string().nullable(),
    requestedAt: /*#__PURE__*/ z.string(),
    completedAt: /*#__PURE__*/ z.string().nullable(),
    decision: /*#__PURE__*/ zFinanceIndicatorDecisionVerdict.nullable(),
    runVerdict: /*#__PURE__*/ z.string().nullable()
});

export const zFinanceIndicatorDecisionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zFinanceIndicatorDecisionSummary)
});

export const zFinanceIndicatorDecisionGetResult = /*#__PURE__*/ z.object({
    data: zFinanceIndicatorDecisionSummary
});

export const zStrategyDecisionSignalDiagnosticSummary = /*#__PURE__*/ z.object({
    signalId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.enum(['entry', 'exit']),
    trueCount: /*#__PURE__*/ z.number(),
    computed: /*#__PURE__*/ z.boolean()
});

export const zStrategyDecision = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.number(),
    definitionName: /*#__PURE__*/ z.string(),
    lifecycleState: /*#__PURE__*/ z.string(),
    recommendation: /*#__PURE__*/ z.enum([
        'buy',
        'hold',
        'sell',
        'avoid',
        'needs_more_data'
    ]),
    reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    confidence: /*#__PURE__*/ z.enum(['low', 'medium']),
    latestSignal: /*#__PURE__*/ zStrategyDecisionLatestSignal.nullable(),
    run: /*#__PURE__*/ zStrategyDecisionRunSummary.nullable(),
    runRequest: /*#__PURE__*/ zStrategyDecisionRequestSummary.nullable(),
    score: /*#__PURE__*/ zStrategyDecisionScoreSummary.nullable(),
    dataReadiness: /*#__PURE__*/ zStrategyDecisionDataReadinessSummary.nullable(),
    signalDiagnosticsSummary: /*#__PURE__*/ z.array(zStrategyDecisionSignalDiagnosticSummary),
    riskFlags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    blockers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    limitations: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    nonExecuting: /*#__PURE__*/ z.literal(true)
});

export const zStrategyDecisionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zStrategyDecision),
    totals: /*#__PURE__*/ z.object({
        definitions: /*#__PURE__*/ z.number(),
        withCompletedRun: /*#__PURE__*/ z.number(),
        needsMoreData: /*#__PURE__*/ z.number()
    })
});

export const zFinanceStrategyDecisionGetResult = /*#__PURE__*/ z.object({
    data: zStrategyDecision
});

export const zStrategyDecisionEvaluateResult = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zStrategyDecisionEvaluateRequest = /*#__PURE__*/ z.object({
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1).max(5),
    timeframe: /*#__PURE__*/ z.string().min(1),
    windowStart: /*#__PURE__*/ z.iso.datetime(),
    windowEnd: /*#__PURE__*/ z.iso.datetime(),
    exchange: /*#__PURE__*/ z.string().optional(),
    paramSet: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ])).optional()
});

export const zStrategyEvaluationSatisfaction = /*#__PURE__*/ z.object({
    satisfied: /*#__PURE__*/ z.boolean(),
    requiredKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    passedKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    missingKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    failingKeys: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zStrategyEvaluationRunResult = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['no_assignments', 'evaluated']),
    gateId: /*#__PURE__*/ z.number().optional(),
    satisfaction: /*#__PURE__*/ zStrategyEvaluationSatisfaction.optional()
});

export const zStrategyEvaluationRunRequest = /*#__PURE__*/ z.object({
    targetTransition: /*#__PURE__*/ z.string().min(1).max(120)
});

export const zFinanceOpsResearchArtifactRow = /*#__PURE__*/ z.object({
    artifactId: /*#__PURE__*/ z.number(),
    type: /*#__PURE__*/ z.string(),
    subtype: /*#__PURE__*/ z.string().nullable(),
    title: /*#__PURE__*/ z.string(),
    recommendationAction: /*#__PURE__*/ z.string().nullable(),
    confidence: /*#__PURE__*/ z.string().nullable(),
    horizon: /*#__PURE__*/ z.string().nullable(),
    sourceCount: /*#__PURE__*/ z.number(),
    blockerCount: /*#__PURE__*/ z.number(),
    observedAt: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string()
});

export const zFinanceOpsIndicatorDecisionRow = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string().nullable(),
    timeframe: /*#__PURE__*/ z.string().nullable(),
    windowStart: /*#__PURE__*/ z.string().nullable(),
    windowEnd: /*#__PURE__*/ z.string().nullable(),
    indicatorCanonicalKey: /*#__PURE__*/ z.string().nullable(),
    requestedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]),
    completedAt: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.iso.datetime()
    ]).nullable(),
    decision: /*#__PURE__*/ zFinanceOpsIndicatorDecisionVerdict.nullable(),
    runVerdict: /*#__PURE__*/ z.string().nullable()
});

export const zFinanceOpsStrategyDecisionRow = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.number(),
    definitionName: /*#__PURE__*/ z.string(),
    lifecycleState: /*#__PURE__*/ z.string(),
    recommendation: /*#__PURE__*/ z.enum([
        'buy',
        'hold',
        'sell',
        'avoid',
        'needs_more_data'
    ]),
    reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    confidence: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high'
    ]),
    latestSignal: /*#__PURE__*/ z.object({
        state: /*#__PURE__*/ z.string(),
        lastBarAt: /*#__PURE__*/ z.string().nullable(),
        entryTriggeredOnLastBar: /*#__PURE__*/ z.boolean(),
        exitTriggeredOnLastBar: /*#__PURE__*/ z.boolean()
    }).nullable(),
    run: /*#__PURE__*/ z.object({
        runId: /*#__PURE__*/ z.string(),
        runStatus: /*#__PURE__*/ z.string(),
        verdict: /*#__PURE__*/ z.string().nullable(),
        recommendation: /*#__PURE__*/ z.string().nullable(),
        researchOnly: /*#__PURE__*/ z.boolean(),
        finishedAt: /*#__PURE__*/ z.string().nullable(),
        windowStart: /*#__PURE__*/ z.string().nullable(),
        windowEnd: /*#__PURE__*/ z.string().nullable(),
        scope: /*#__PURE__*/ z.string(),
        runMode: /*#__PURE__*/ z.string()
    }).nullable(),
    runRequest: /*#__PURE__*/ z.object({
        requestId: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.enum([
            'queued',
            'blocked',
            'dispatched',
            'running',
            'completed',
            'failed',
            'cancelled'
        ]),
        dataReadiness: /*#__PURE__*/ z.enum([
            'unknown',
            'ready',
            'research_only',
            'blocked'
        ]),
        blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        requestedAt: /*#__PURE__*/ z.string()
    }).nullable(),
    score: /*#__PURE__*/ z.object({
        value: /*#__PURE__*/ z.number(),
        uncertainty: /*#__PURE__*/ z.number(),
        skillProb: /*#__PURE__*/ z.number().nullable(),
        pboPassed: /*#__PURE__*/ z.boolean().nullable(),
        computedAt: /*#__PURE__*/ z.string()
    }).nullable(),
    dataReadiness: /*#__PURE__*/ z.object({
        status: /*#__PURE__*/ z.string(),
        pointInTime: /*#__PURE__*/ z.boolean(),
        missingIntervalCount: /*#__PURE__*/ z.number(),
        staleLastBar: /*#__PURE__*/ z.boolean()
    }).nullable(),
    signalDiagnosticsSummary: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        signalId: /*#__PURE__*/ z.string(),
        scope: /*#__PURE__*/ z.string(),
        trueCount: /*#__PURE__*/ z.number(),
        computed: /*#__PURE__*/ z.boolean()
    })),
    riskFlags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    blockers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    limitations: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    nonExecuting: /*#__PURE__*/ z.literal(true)
});

export const zFinanceOpsTemplateTestingRunRow = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled'
    ]),
    dataReadiness: /*#__PURE__*/ z.enum([
        'unknown',
        'ready',
        'research_only',
        'blocked'
    ]),
    scope: /*#__PURE__*/ z.string(),
    runMode: /*#__PURE__*/ z.string(),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    timeframe: /*#__PURE__*/ z.string().nullable(),
    requestedAt: /*#__PURE__*/ z.string(),
    blockedReasonCount: /*#__PURE__*/ z.number()
});

export const zFinanceOpsMarketDataUnlockRow = /*#__PURE__*/ z.object({
    unlockId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    assetClass: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    requiredSecretCount: /*#__PURE__*/ z.number()
});

export const zFinanceOpsPlannerCandidateRow = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.number(),
    definitionName: /*#__PURE__*/ z.string(),
    action: /*#__PURE__*/ z.string(),
    wtn: /*#__PURE__*/ z.number(),
    nextScope: /*#__PURE__*/ z.string().nullable(),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zFinanceOpsBucketRow = /*#__PURE__*/ z.object({
    bucketId: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    lifecycleState: /*#__PURE__*/ z.string(),
    validationStatus: /*#__PURE__*/ z.string(),
    latestEvalVerdict: /*#__PURE__*/ z.string().nullable(),
    latestEvalRecommendation: /*#__PURE__*/ z.string().nullable(),
    bucketLevelScoreValue: /*#__PURE__*/ z.number().nullable(),
    pendingDecisionCount: /*#__PURE__*/ z.number()
});

export const zFinanceOpsApprovalRow = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.string(),
    actionType: /*#__PURE__*/ z.string(),
    createdAt: /*#__PURE__*/ z.string(),
    expiresAt: /*#__PURE__*/ z.string().nullable(),
    reviewStatus: /*#__PURE__*/ z.enum(['pending', 'approved'])
});

export const zFinanceOpsResearchWorkflowRow = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    lastRunAt: /*#__PURE__*/ z.string().nullable(),
    lastRunStatus: /*#__PURE__*/ z.string().nullable(),
    lastRunSummaryKind: /*#__PURE__*/ z.string().nullable(),
    pendingDecisionCount: /*#__PURE__*/ z.number()
});

export const zFinanceOpsContentBlockedSourceRow = /*#__PURE__*/ z.object({
    intelSourceId: /*#__PURE__*/ z.string(),
    handle: /*#__PURE__*/ z.string(),
    lastErrorCode: /*#__PURE__*/ z.string().nullable(),
    blockedUntil: /*#__PURE__*/ z.string().nullable(),
    consecutiveFailures: /*#__PURE__*/ z.number()
});

export const zFinanceOpsContentExpansionCandidateRow = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    handle: /*#__PURE__*/ z.string(),
    platform: /*#__PURE__*/ z.string(),
    discoveryDepth: /*#__PURE__*/ z.number().nullable()
});

export const zFinanceOperationsSummaryResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        generatedAt: /*#__PURE__*/ z.string(),
        nonExecuting: /*#__PURE__*/ z.literal(true),
        research: /*#__PURE__*/ z.object({
            items: /*#__PURE__*/ z.array(zFinanceOpsResearchArtifactRow),
            error: /*#__PURE__*/ z.string().optional()
        }),
        indicatorDecisions: /*#__PURE__*/ z.object({
            items: /*#__PURE__*/ z.array(zFinanceOpsIndicatorDecisionRow),
            error: /*#__PURE__*/ z.string().optional()
        }),
        strategyDecisions: /*#__PURE__*/ z.object({
            items: /*#__PURE__*/ z.array(zFinanceOpsStrategyDecisionRow),
            totals: /*#__PURE__*/ z.object({
                definitions: /*#__PURE__*/ z.number(),
                withCompletedRun: /*#__PURE__*/ z.number(),
                needsMoreData: /*#__PURE__*/ z.number()
            }),
            error: /*#__PURE__*/ z.string().optional()
        }),
        templateTesting: /*#__PURE__*/ z.object({
            items: /*#__PURE__*/ z.array(zFinanceOpsTemplateTestingRunRow),
            totals: /*#__PURE__*/ z.object({
                queued: /*#__PURE__*/ z.number(),
                running: /*#__PURE__*/ z.number(),
                blocked: /*#__PURE__*/ z.number(),
                completed: /*#__PURE__*/ z.number(),
                failed: /*#__PURE__*/ z.number()
            }),
            error: /*#__PURE__*/ z.string().optional()
        }),
        marketData: /*#__PURE__*/ z.object({
            items: /*#__PURE__*/ z.array(zFinanceOpsMarketDataUnlockRow),
            dataBlockersCount: /*#__PURE__*/ z.number(),
            error: /*#__PURE__*/ z.string().optional()
        }),
        planner: /*#__PURE__*/ z.object({
            totals: /*#__PURE__*/ z.object({
                scored: /*#__PURE__*/ z.number(),
                enqueueEligible: /*#__PURE__*/ z.number(),
                excludedPending: /*#__PURE__*/ z.number(),
                blocked: /*#__PURE__*/ z.number()
            }),
            candidates: /*#__PURE__*/ z.array(zFinanceOpsPlannerCandidateRow),
            error: /*#__PURE__*/ z.string().optional()
        }),
        buckets: /*#__PURE__*/ z.object({
            totals: /*#__PURE__*/ z.object({
                buckets: /*#__PURE__*/ z.number(),
                withQueuedEval: /*#__PURE__*/ z.number(),
                withCompletedEval: /*#__PURE__*/ z.number(),
                blocked: /*#__PURE__*/ z.number()
            }),
            degradationTotals: /*#__PURE__*/ z.object({
                pendingDecisions: /*#__PURE__*/ z.number(),
                bucketsWithPendingDecisions: /*#__PURE__*/ z.number(),
                openHypotheses: /*#__PURE__*/ z.number()
            }),
            items: /*#__PURE__*/ z.array(zFinanceOpsBucketRow),
            error: /*#__PURE__*/ z.string().optional()
        }),
        approvals: /*#__PURE__*/ z.object({
            count: /*#__PURE__*/ z.number(),
            items: /*#__PURE__*/ z.array(zFinanceOpsApprovalRow),
            error: /*#__PURE__*/ z.string().optional()
        }),
        researchWorkflows: /*#__PURE__*/ z.object({
            items: /*#__PURE__*/ z.array(zFinanceOpsResearchWorkflowRow),
            error: /*#__PURE__*/ z.string().optional()
        }),
        contentIngestion: /*#__PURE__*/ z.object({
            subscriptionHealth: /*#__PURE__*/ z.object({
                active: /*#__PURE__*/ z.number(),
                paused: /*#__PURE__*/ z.number(),
                blocked: /*#__PURE__*/ z.number(),
                pendingApproval: /*#__PURE__*/ z.number(),
                archived: /*#__PURE__*/ z.number()
            }),
            fetchRuns24h: /*#__PURE__*/ z.object({
                succeeded: /*#__PURE__*/ z.number(),
                partial: /*#__PURE__*/ z.number(),
                failed: /*#__PURE__*/ z.number(),
                queuedOrRunning: /*#__PURE__*/ z.number(),
                totalReadsBilled: /*#__PURE__*/ z.number(),
                totalEstimatedCostUsd: /*#__PURE__*/ z.number(),
                totalQuotaUnitsUsed: /*#__PURE__*/ z.number()
            }),
            blockedSources: /*#__PURE__*/ z.array(zFinanceOpsContentBlockedSourceRow),
            transcriptFailures24h: /*#__PURE__*/ z.number(),
            expansionCandidates: /*#__PURE__*/ z.object({
                count: /*#__PURE__*/ z.number(),
                items: /*#__PURE__*/ z.array(zFinanceOpsContentExpansionCandidateRow)
            }),
            insightsBacklog: /*#__PURE__*/ z.number(),
            error: /*#__PURE__*/ z.string().optional()
        }),
        sectionErrors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    })
});

export const zFinanceCommandLookupOption = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'indicator',
        'strategy',
        'ticker',
        'research',
        'timeframe'
    ]),
    id: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().optional(),
    source: /*#__PURE__*/ z.string(),
    installed: /*#__PURE__*/ z.boolean(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.boolean()
    ]))
});

export const zFinanceCommandLookupResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        command: /*#__PURE__*/ z.enum([
            'indicator',
            'strategy',
            'ticker',
            'research',
            'timeframe'
        ]),
        options: /*#__PURE__*/ z.array(zFinanceCommandLookupOption),
        truncated: /*#__PURE__*/ z.boolean()
    })
});

export const zFinanceConversationPersona = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string(),
    iconHint: /*#__PURE__*/ z.string(),
    seedMessage: /*#__PURE__*/ z.string(),
    artifactTypesProduced: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zCandidateParameter = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.enum([
        'integer',
        'float',
        'boolean',
        'string'
    ]),
    default: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.boolean()
    ]).optional(),
    min: /*#__PURE__*/ z.number().optional(),
    max: /*#__PURE__*/ z.number().optional()
});

export const zIndicatorCandidate = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum(['finance.indicator_candidate']),
    schemaVersion: /*#__PURE__*/ z.literal(1),
    alias: /*#__PURE__*/ z.string(),
    requestedName: /*#__PURE__*/ z.string(),
    canonicalKeyGuess: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    formula: /*#__PURE__*/ z.string().optional(),
    pseudocode: /*#__PURE__*/ z.string().optional(),
    lookbackWindow: /*#__PURE__*/ z.string().optional(),
    dataRequirements: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    providerRequirements: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    parameters: /*#__PURE__*/ z.array(zCandidateParameter),
    resolution: /*#__PURE__*/ z.enum([
        'exact_catalog_match',
        'compatible_existing',
        'new_definition',
        'new_definition_and_implementation',
        'unsupported'
    ]),
    lookaheadPolicy: /*#__PURE__*/ z.enum(['research_only', 'production_ready']),
    status: /*#__PURE__*/ z.enum([
        'proposed',
        'needs_review',
        'rejected'
    ]),
    executable: /*#__PURE__*/ z.literal(false),
    rationale: /*#__PURE__*/ z.string().optional(),
    provenance: /*#__PURE__*/ z.object({
        producedBy: /*#__PURE__*/ z.enum([
            'llm',
            'user',
            'system'
        ]),
        untrusted: /*#__PURE__*/ z.boolean(),
        notes: /*#__PURE__*/ z.string().optional()
    }),
    sourceMessageIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()]))
});

export const zPineInput = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string(),
    inputType: /*#__PURE__*/ z.string(),
    defaultValue: /*#__PURE__*/ z.string().nullable()
});

export const zPineScriptAnalysis = /*#__PURE__*/ z.object({
    pineVersion: /*#__PURE__*/ z.number().nullable(),
    declarationKind: /*#__PURE__*/ z.enum([
        'indicator',
        'strategy',
        'library',
        'unknown'
    ]),
    title: /*#__PURE__*/ z.string().nullable(),
    inputs: /*#__PURE__*/ z.array(zPineInput),
    plots: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    signals: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    timeframeAssumptions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    dataRequirements: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    repaintingWarnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    unsupportedFeatures: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zPineImportSource = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum(['pasted', 'url']),
    host: /*#__PURE__*/ z.string().optional(),
    bytes: /*#__PURE__*/ z.number()
});

export const zPineCatalogMatch = /*#__PURE__*/ z.object({
    pineFunction: /*#__PURE__*/ z.string(),
    canonicalKey: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    installed: /*#__PURE__*/ z.boolean(),
    matchedOn: /*#__PURE__*/ z.string()
});

export const zIndicatorImportPreviewResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        candidate: zIndicatorCandidate,
        analysis: zPineScriptAnalysis,
        warnings: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        source: zPineImportSource,
        catalogMatches: /*#__PURE__*/ z.array(zPineCatalogMatch),
        artifact: /*#__PURE__*/ zIndicatorImportPersistedArtifact.nullable()
    })
});

export const zIndicatorImportPreviewBody = /*#__PURE__*/ z.object({
    source: /*#__PURE__*/ z.string().min(1).max(64000).optional(),
    url: /*#__PURE__*/ z.string().min(8).max(2000).optional(),
    alias: /*#__PURE__*/ z.string().min(1).max(60).optional(),
    persist: /*#__PURE__*/ z.boolean().optional()
});

export const zTranspileDefinitionSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    canonicalKey: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string()
});

export const zTranspileImplementationSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    implementationKey: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    parityTestStatus: /*#__PURE__*/ z.string()
});

export const zTranspileCrossCheck = /*#__PURE__*/ z.object({
    inputsMatched: /*#__PURE__*/ z.int(),
    outputsDeclared: /*#__PURE__*/ z.int()
});

export const zIndicatorImportTranspileResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        definition: zTranspileDefinitionSummary,
        implementation: zTranspileImplementationSummary,
        artifact: zIndicatorImportPersistedArtifact,
        transpileNotes: /*#__PURE__*/ z.string().optional(),
        crossCheck: zTranspileCrossCheck
    })
});

export const zIndicatorImportTranspileBody = /*#__PURE__*/ z.object({
    source: /*#__PURE__*/ z.string().min(1).max(64000).optional(),
    url: /*#__PURE__*/ z.string().min(8).max(2000).optional(),
    alias: /*#__PURE__*/ z.string().min(1).max(60).optional()
});

export const zIndicatorImplementationEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    implementationKey: /*#__PURE__*/ z.string(),
    runtime: /*#__PURE__*/ z.string(),
    adapterRef: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string(),
    parityTestStatus: /*#__PURE__*/ z.string(),
    pitSafety: /*#__PURE__*/ z.string(),
    transpiled: /*#__PURE__*/ z.boolean()
});

export const zIndicatorCatalogEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    kind: /*#__PURE__*/ z.enum(['definition', 'candidate']),
    canonicalKey: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    shortName: /*#__PURE__*/ z.string().nullable(),
    category: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    visibility: /*#__PURE__*/ z.string(),
    installed: /*#__PURE__*/ z.boolean(),
    implementations: /*#__PURE__*/ z.array(zIndicatorImplementationEntry),
    artifactId: /*#__PURE__*/ z.string().optional()
});

export const zIndicatorCatalogList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        entries: /*#__PURE__*/ z.array(zIndicatorCatalogEntry),
        truncated: /*#__PURE__*/ z.boolean()
    })
});

export const zFinanceIndicatorPromotionApplyResult = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.string(),
    implementationKey: /*#__PURE__*/ z.string(),
    definitionCanonicalKey: /*#__PURE__*/ z.string(),
    promotedAt: /*#__PURE__*/ z.string()
});

export const zTickerResearchNote = /*#__PURE__*/ z.object({
    artifactId: /*#__PURE__*/ z.number(),
    title: /*#__PURE__*/ z.string(),
    mentionCount: /*#__PURE__*/ z.number(),
    corroboratingSources: /*#__PURE__*/ z.number()
});

export const zTickerResearchNoteCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1).max(20),
    sinceDays: /*#__PURE__*/ z.int().gte(1).lte(30).optional()
});

export const zVarEstimate = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    manifest: /*#__PURE__*/ z.object({
        subjectScope: /*#__PURE__*/ z.enum([
            'account',
            'portfolio',
            'strategy'
        ]),
        subjectId: /*#__PURE__*/ z.int().gt(0),
        estimatorVersion: /*#__PURE__*/ z.string().min(1).max(16),
        asOf: /*#__PURE__*/ z.string(),
        estimationStart: /*#__PURE__*/ z.string(),
        assetCount: /*#__PURE__*/ z.int().gte(0),
        barCount: /*#__PURE__*/ z.int().gte(0),
        status: /*#__PURE__*/ z.enum([
            'ready',
            'research_only',
            'blocked'
        ]),
        navBase: /*#__PURE__*/ z.string().nullable(),
        factorModelId: /*#__PURE__*/ z.int().gt(0).nullable(),
        contentDigest: /*#__PURE__*/ z.string().min(1).max(80),
        diagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            code: /*#__PURE__*/ z.enum([
                'insufficient_bars',
                'insufficient_assets',
                'no_factor_model_parametric_dropped',
                'no_nav_dollar_var_omitted',
                'short_history_research_only',
                'zero_weight_subject',
                'unmodelled_symbols_partial'
            ]),
            severity: /*#__PURE__*/ z.enum([
                'blocker',
                'warning',
                'info'
            ]),
            message: /*#__PURE__*/ z.string().max(500)
        }))
    }),
    method: /*#__PURE__*/ z.enum([
        'parametric',
        'historical',
        'monte_carlo'
    ]),
    confidence: /*#__PURE__*/ z.enum(['0.95', '0.99']),
    horizon: /*#__PURE__*/ z.enum([
        '1d',
        '5d',
        '10d',
        '20d'
    ]),
    result: /*#__PURE__*/ z.object({
        method: /*#__PURE__*/ z.enum([
            'parametric',
            'historical',
            'monte_carlo'
        ]),
        confidence: /*#__PURE__*/ z.enum(['0.95', '0.99']),
        horizon: /*#__PURE__*/ z.enum([
            '1d',
            '5d',
            '10d',
            '20d'
        ]),
        varFraction: /*#__PURE__*/ z.number().gte(0),
        cvarFraction: /*#__PURE__*/ z.number().gte(0),
        varAmountBase: /*#__PURE__*/ z.number().gte(0).nullable(),
        cvarAmountBase: /*#__PURE__*/ z.number().gte(0).nullable(),
        components: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            componentKind: /*#__PURE__*/ z.enum(['name', 'factor']),
            symbol: /*#__PURE__*/ z.string().min(1).max(40).optional(),
            exchange: /*#__PURE__*/ z.string().min(1).max(20).optional(),
            factorBlock: /*#__PURE__*/ z.enum([
                'beta_market',
                'size',
                'sector',
                'volatility',
                'liquidity',
                'funding',
                'momentum',
                'value',
                'quality'
            ]).optional(),
            factorName: /*#__PURE__*/ z.string().min(1).max(60).optional(),
            weight: /*#__PURE__*/ z.number().nullable(),
            marginalVar: /*#__PURE__*/ z.number(),
            componentVar: /*#__PURE__*/ z.number(),
            componentVarShare: /*#__PURE__*/ z.number()
        }))
    })
});

export const zVarBacktest = /*#__PURE__*/ z.object({
    subjectScope: /*#__PURE__*/ z.enum([
        'account',
        'portfolio',
        'strategy'
    ]),
    subjectId: /*#__PURE__*/ z.int().gt(0),
    method: /*#__PURE__*/ z.enum([
        'parametric',
        'historical',
        'monte_carlo'
    ]),
    confidence: /*#__PURE__*/ z.enum(['0.95', '0.99']),
    horizon: /*#__PURE__*/ z.enum([
        '1d',
        '5d',
        '10d',
        '20d'
    ]),
    test: /*#__PURE__*/ z.enum(['kupiec_pof', 'christoffersen_independence']),
    observations: /*#__PURE__*/ z.int().gte(0),
    exceptions: /*#__PURE__*/ z.int().gte(0),
    expectedExceptions: /*#__PURE__*/ z.number().gte(0),
    testStatistic: /*#__PURE__*/ z.number().nullable(),
    pValue: /*#__PURE__*/ z.number().gte(0).lte(1).nullable(),
    trafficLight: /*#__PURE__*/ z.enum([
        'green',
        'yellow',
        'red'
    ]).nullable(),
    payload: /*#__PURE__*/ z.object({
        exceptionTimestamps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        transitionCounts: /*#__PURE__*/ z.object({
            n00: /*#__PURE__*/ z.int(),
            n01: /*#__PURE__*/ z.int(),
            n10: /*#__PURE__*/ z.int(),
            n11: /*#__PURE__*/ z.int()
        }).nullable()
    })
});

export const zVarComponentRow = /*#__PURE__*/ z.object({
    componentKind: /*#__PURE__*/ z.enum(['name', 'factor']),
    symbol: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    exchange: /*#__PURE__*/ z.string().min(1).max(20).optional(),
    factorBlock: /*#__PURE__*/ z.enum([
        'beta_market',
        'size',
        'sector',
        'volatility',
        'liquidity',
        'funding',
        'momentum',
        'value',
        'quality'
    ]).optional(),
    factorName: /*#__PURE__*/ z.string().min(1).max(60).optional(),
    weight: /*#__PURE__*/ z.number().nullable(),
    marginalVar: /*#__PURE__*/ z.number(),
    componentVar: /*#__PURE__*/ z.number(),
    componentVarShare: /*#__PURE__*/ z.number()
});

export const zStressScenarioSpec = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'historical_episode',
        'correlation_to_one',
        'factor_shock',
        'sector_shock',
        'rate_twist',
        'idiosyncratic'
    ]),
    episodeStart: /*#__PURE__*/ z.string().nullable(),
    episodeEnd: /*#__PURE__*/ z.string().nullable(),
    targetCorrelation: /*#__PURE__*/ z.number().gte(0).lte(1).optional(),
    shocks: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        target: /*#__PURE__*/ z.enum([
            'symbol',
            'sector',
            'factor',
            'rate',
            'all'
        ]),
        ref: /*#__PURE__*/ z.string().min(1).max(80).optional(),
        shock: /*#__PURE__*/ z.number(),
        sigmaUnits: /*#__PURE__*/ z.boolean().optional().default(false)
    })).optional().default([]),
    rateMoveBp: /*#__PURE__*/ z.number().optional(),
    sourceExchange: /*#__PURE__*/ z.string().min(1).max(20).optional(),
    sourceTimeframe: /*#__PURE__*/ z.string().min(1).max(10).optional()
});

export const zStressResultContract = /*#__PURE__*/ z.object({
    organizationId: /*#__PURE__*/ z.int().gt(0),
    scenarioKey: /*#__PURE__*/ z.string().min(1),
    kind: /*#__PURE__*/ z.enum([
        'historical_episode',
        'correlation_to_one',
        'factor_shock',
        'sector_shock',
        'rate_twist',
        'idiosyncratic'
    ]),
    asOf: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'ready',
        'degraded',
        'blocked'
    ]),
    lossPct: /*#__PURE__*/ z.number(),
    payload: /*#__PURE__*/ z.object({
        scenarioKey: /*#__PURE__*/ z.string(),
        kind: /*#__PURE__*/ z.enum([
            'historical_episode',
            'correlation_to_one',
            'factor_shock',
            'sector_shock',
            'rate_twist',
            'idiosyncratic'
        ]),
        status: /*#__PURE__*/ z.enum([
            'ready',
            'degraded',
            'blocked'
        ]),
        lossPct: /*#__PURE__*/ z.number(),
        lossNotional: /*#__PURE__*/ z.number().nullable(),
        stressedVol: /*#__PURE__*/ z.number().gte(0).nullable(),
        baselineVol: /*#__PURE__*/ z.number().gte(0).nullable(),
        contributions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            symbol: /*#__PURE__*/ z.string(),
            exchange: /*#__PURE__*/ z.string(),
            weight: /*#__PURE__*/ z.number(),
            shockedReturn: /*#__PURE__*/ z.number(),
            pnlContribution: /*#__PURE__*/ z.number(),
            unmodelled: /*#__PURE__*/ z.boolean()
        })),
        riskByBlock: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()).nullable(),
        diagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            code: /*#__PURE__*/ z.enum([
                'no_factor_model_bound',
                'no_holdings',
                'no_panel_for_episode',
                'unmodelled_symbols',
                'sector_metadata_missing',
                'factor_not_in_model',
                'partial_episode_coverage'
            ]),
            severity: /*#__PURE__*/ z.enum([
                'blocker',
                'warning',
                'info'
            ]),
            message: /*#__PURE__*/ z.string().max(500)
        }))
    }),
    contentDigest: /*#__PURE__*/ z.string().min(1),
    computedAt: /*#__PURE__*/ z.string()
});

export const zAttributionRun = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    manifest: /*#__PURE__*/ z.object({
        subjectKind: /*#__PURE__*/ z.enum(['portfolio', 'strategy_run']),
        benchmarkSymbol: /*#__PURE__*/ z.string().min(1).max(40),
        methods: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum(['brinson', 'factor'])).min(1),
        estimatorVersion: /*#__PURE__*/ z.string().min(1).max(16),
        asOf: /*#__PURE__*/ z.string(),
        windowStart: /*#__PURE__*/ z.string(),
        periodCount: /*#__PURE__*/ z.int().gte(0),
        groupCount: /*#__PURE__*/ z.int().gte(0),
        portfolioReturn: /*#__PURE__*/ z.number(),
        benchmarkReturn: /*#__PURE__*/ z.number(),
        activeReturn: /*#__PURE__*/ z.number(),
        reconciliationResidual: /*#__PURE__*/ z.number(),
        contentDigest: /*#__PURE__*/ z.string().min(1).max(80),
        diagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            code: /*#__PURE__*/ z.enum([
                'no_benchmark_resolved',
                'benchmark_candles_missing',
                'no_group_weights',
                'factor_model_missing',
                'sector_metadata_missing',
                'reconciliation_residual_exceeds_tolerance',
                'insufficient_periods'
            ]),
            severity: /*#__PURE__*/ z.enum([
                'blocker',
                'warning',
                'info'
            ]),
            message: /*#__PURE__*/ z.string().max(500)
        }))
    }),
    effects: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        method: /*#__PURE__*/ z.enum(['brinson', 'factor']),
        effectKind: /*#__PURE__*/ z.enum([
            'allocation',
            'selection',
            'interaction',
            'factor_return',
            'specific',
            'total'
        ]),
        groupDimension: /*#__PURE__*/ z.enum([
            'sector',
            'asset_class',
            'custom',
            'factor'
        ]),
        groupKey: /*#__PURE__*/ z.string().max(120),
        groupLabel: /*#__PURE__*/ z.string().max(200).nullable(),
        periodIndex: /*#__PURE__*/ z.int(),
        effectReturn: /*#__PURE__*/ z.number(),
        portfolioWeight: /*#__PURE__*/ z.number().nullable(),
        benchmarkWeight: /*#__PURE__*/ z.number().nullable(),
        portfolioGroupReturn: /*#__PURE__*/ z.number().nullable(),
        benchmarkGroupReturn: /*#__PURE__*/ z.number().nullable()
    }))
});

export const zAttributionEffectRow = /*#__PURE__*/ z.object({
    method: /*#__PURE__*/ z.enum(['brinson', 'factor']),
    effectKind: /*#__PURE__*/ z.enum([
        'allocation',
        'selection',
        'interaction',
        'factor_return',
        'specific',
        'total'
    ]),
    groupDimension: /*#__PURE__*/ z.enum([
        'sector',
        'asset_class',
        'custom',
        'factor'
    ]),
    groupKey: /*#__PURE__*/ z.string().max(120),
    groupLabel: /*#__PURE__*/ z.string().max(200).nullable(),
    periodIndex: /*#__PURE__*/ z.int(),
    effectReturn: /*#__PURE__*/ z.number(),
    portfolioWeight: /*#__PURE__*/ z.number().nullable(),
    benchmarkWeight: /*#__PURE__*/ z.number().nullable(),
    portfolioGroupReturn: /*#__PURE__*/ z.number().nullable(),
    benchmarkGroupReturn: /*#__PURE__*/ z.number().nullable()
});

export const zTcaScorecardComponents = /*#__PURE__*/ z.object({
    realizedTotalCostBps: /*#__PURE__*/ z.number().nullable(),
    realizedSlippageBps: /*#__PURE__*/ z.number().nullable(),
    realizedFeeBps: /*#__PURE__*/ z.number().nullable(),
    realizedSpreadCostBps: /*#__PURE__*/ z.number().nullable(),
    realizedOpportunityCostBps: /*#__PURE__*/ z.number().nullable(),
    avgDelayCostBps: /*#__PURE__*/ z.number().nullable(),
    avgExecutionCostBps: /*#__PURE__*/ z.number().nullable(),
    modeledTotalCostBps: /*#__PURE__*/ z.number().nullable(),
    modeledSource: /*#__PURE__*/ z.string().nullable(),
    normalizedCostRatio: /*#__PURE__*/ z.number().gte(0),
    normalizedCostDenominator: /*#__PURE__*/ z.number().gt(0),
    within_model: /*#__PURE__*/ z.boolean(),
    classification: /*#__PURE__*/ z.enum([
        'within_model',
        'degraded',
        'breached',
        'insufficient_data'
    ]),
    toleranceFraction: /*#__PURE__*/ z.number().gte(0),
    orderCount: /*#__PURE__*/ z.int().gte(0),
    fillCount: /*#__PURE__*/ z.int().gte(0),
    ordersWithArrival: /*#__PURE__*/ z.int().gte(0),
    ordersWithClose: /*#__PURE__*/ z.int().gte(0),
    windowStart: /*#__PURE__*/ z.iso.datetime().nullable(),
    windowEnd: /*#__PURE__*/ z.iso.datetime().nullable(),
    scorerVersion: /*#__PURE__*/ z.string()
});

export const zTcaScorecard = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int(),
    organizationId: /*#__PURE__*/ z.int(),
    subjectKind: /*#__PURE__*/ z.string(),
    subjectId: /*#__PURE__*/ z.int(),
    scope: /*#__PURE__*/ z.string(),
    regime: /*#__PURE__*/ z.string(),
    normalizedValue: /*#__PURE__*/ z.number(),
    sampleSize: /*#__PURE__*/ z.int(),
    modelVersion: /*#__PURE__*/ z.string(),
    computedAt: /*#__PURE__*/ z.iso.datetime(),
    inputsHash: /*#__PURE__*/ z.string(),
    components: zTcaScorecardComponents,
    classification: /*#__PURE__*/ z.enum([
        'within_model',
        'degraded',
        'breached',
        'insufficient_data'
    ])
});

export const zCrowdingScore = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int(),
    organizationId: /*#__PURE__*/ z.int(),
    subjectKind: /*#__PURE__*/ z.string(),
    subjectId: /*#__PURE__*/ z.int(),
    scope: /*#__PURE__*/ z.string(),
    regime: /*#__PURE__*/ z.string(),
    compositeZ: /*#__PURE__*/ z.number().nullable(),
    skillProb: /*#__PURE__*/ z.number().nullable(),
    pboPassed: /*#__PURE__*/ z.boolean().nullable(),
    sampleSize: /*#__PURE__*/ z.int(),
    modelVersion: /*#__PURE__*/ z.string(),
    computedAt: /*#__PURE__*/ z.iso.datetime(),
    components: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        key: /*#__PURE__*/ z.enum([
            'valuation_spread',
            'short_interest_utilization',
            'factor_momentum',
            'intra_quintile_correlation',
            'factor_volatility',
            'comomentum_winner',
            'comomentum_loser',
            'absorption_ratio',
            'vpin',
            'order_flow_imbalance',
            'private_slippage_drift',
            'name_overlap_public_basket',
            'crowd_claims_prior'
        ]),
        z: /*#__PURE__*/ z.number().nullable(),
        raw: /*#__PURE__*/ z.number().nullable(),
        available: /*#__PURE__*/ z.boolean(),
        note: /*#__PURE__*/ z.string().max(160).optional()
    }))
});

export const zCapitalAllocationDigest = /*#__PURE__*/ z.object({
    contentDigest: /*#__PURE__*/ z.string(),
    poolKey: /*#__PURE__*/ z.string(),
    latestComputedAt: /*#__PURE__*/ z.string()
});

export const zCapitalAllocationProposal = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0).optional(),
    organizationId: /*#__PURE__*/ z.int().gt(0).optional(),
    status: /*#__PURE__*/ z.enum([
        'proposed',
        'submitted',
        'approved',
        'rejected',
        'superseded'
    ]),
    manifest: /*#__PURE__*/ z.object({
        poolKey: /*#__PURE__*/ z.string().min(1).max(80),
        poolCapitalBase: /*#__PURE__*/ z.number().gte(0),
        baseCurrency: /*#__PURE__*/ z.string().min(1).max(10),
        allocatorVersion: /*#__PURE__*/ z.string().min(1).max(16),
        asOf: /*#__PURE__*/ z.string(),
        constraints: /*#__PURE__*/ z.object({
            maxSleeveWeight: /*#__PURE__*/ z.number().gte(0).lte(1).optional(),
            maxTurnover: /*#__PURE__*/ z.number().gte(0).optional(),
            longOnly: /*#__PURE__*/ z.boolean().optional().default(true),
            riskAversion: /*#__PURE__*/ z.number().gt(0).optional().default(1),
            minSleeveWeight: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0)
        }),
        objective: /*#__PURE__*/ z.enum(['marginal_utility']),
        solverPath: /*#__PURE__*/ z.enum(['constrained_qp', 'inverse_vol_fallback']),
        contentDigest: /*#__PURE__*/ z.string().min(1).max(80),
        diagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            code: /*#__PURE__*/ z.enum([
                'no_eligible_sleeves',
                'capacity_curve_missing',
                'capacity_curve_research_only',
                'score_stale',
                'covariance_unavailable',
                'solver_unavailable_used_fallback',
                'capacity_cap_binding',
                'pool_undersubscribed',
                'turnover_band_binding'
            ]),
            severity: /*#__PURE__*/ z.enum([
                'blocker',
                'warning',
                'info'
            ]),
            message: /*#__PURE__*/ z.string().max(500)
        }))
    }),
    sleeves: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        sleeveKind: /*#__PURE__*/ z.enum([
            'bucket',
            'strategy',
            'external'
        ]),
        sleeveRef: /*#__PURE__*/ z.string().min(1).max(120),
        weight: /*#__PURE__*/ z.number().gte(0).lte(1),
        allocatedNotionalBase: /*#__PURE__*/ z.number().gte(0),
        priorNotionalBase: /*#__PURE__*/ z.number().gte(0),
        standaloneSharpe: /*#__PURE__*/ z.number().nullable(),
        marginalSharpeAtAlloc: /*#__PURE__*/ z.number().nullable(),
        sqsValue: /*#__PURE__*/ z.number().nullable(),
        uncertainty: /*#__PURE__*/ z.number().nullable(),
        capacityBinding: /*#__PURE__*/ z.boolean(),
        capacityCurveId: /*#__PURE__*/ z.int().gt(0).nullable(),
        sourceScoreId: /*#__PURE__*/ z.int().gt(0).nullable()
    }))
});

export const zCapitalAllocationSleeve = /*#__PURE__*/ z.object({
    sleeveKind: /*#__PURE__*/ z.enum([
        'bucket',
        'strategy',
        'external'
    ]),
    sleeveRef: /*#__PURE__*/ z.string().min(1).max(120),
    weight: /*#__PURE__*/ z.number().gte(0).lte(1),
    allocatedNotionalBase: /*#__PURE__*/ z.number().gte(0),
    priorNotionalBase: /*#__PURE__*/ z.number().gte(0),
    standaloneSharpe: /*#__PURE__*/ z.number().nullable(),
    marginalSharpeAtAlloc: /*#__PURE__*/ z.number().nullable(),
    sqsValue: /*#__PURE__*/ z.number().nullable(),
    uncertainty: /*#__PURE__*/ z.number().nullable(),
    capacityBinding: /*#__PURE__*/ z.boolean(),
    capacityCurveId: /*#__PURE__*/ z.int().gt(0).nullable(),
    sourceScoreId: /*#__PURE__*/ z.int().gt(0).nullable()
});

export const zCapitalAllocationSubmitResult = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.int().gt(0),
    outcome: /*#__PURE__*/ z.enum(['created', 'existing']),
    reviewStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'deferred',
        'consumed'
    ])
});

export const zCapacityCurve = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    manifest: /*#__PURE__*/ z.object({
        sleeveKind: /*#__PURE__*/ z.enum([
            'bucket',
            'strategy',
            'external'
        ]),
        sleeveRef: /*#__PURE__*/ z.string().min(1).max(120),
        kind: /*#__PURE__*/ z.enum([
            'impact_sqrt',
            'config_prior',
            'flat'
        ]),
        estimatorVersion: /*#__PURE__*/ z.string().min(1).max(16),
        asOf: /*#__PURE__*/ z.string(),
        sharpe0: /*#__PURE__*/ z.number(),
        impactCoefficient: /*#__PURE__*/ z.number().gte(0),
        advNotional: /*#__PURE__*/ z.number().gte(0).nullable(),
        notionalCap: /*#__PURE__*/ z.number().gte(0),
        sharpeFloor: /*#__PURE__*/ z.number(),
        status: /*#__PURE__*/ z.enum([
            'ready',
            'research_only',
            'blocked'
        ]),
        contentDigest: /*#__PURE__*/ z.string().min(1).max(80),
        diagnostics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            code: /*#__PURE__*/ z.enum([
                'insufficient_runs',
                'no_slippage_used_prior',
                'no_adv_input',
                'short_history_research_only'
            ]),
            severity: /*#__PURE__*/ z.enum([
                'blocker',
                'warning',
                'info'
            ]),
            message: /*#__PURE__*/ z.string().max(500)
        }))
    })
});

export const zNetLiquidation = /*#__PURE__*/ z.object({
    account_id: /*#__PURE__*/ z.number(),
    base_currency: /*#__PURE__*/ z.string(),
    cash_base: /*#__PURE__*/ z.string(),
    positions_mark_base: /*#__PURE__*/ z.string(),
    net_liquidation_base: /*#__PURE__*/ z.string(),
    unrealized_pnl_base: /*#__PURE__*/ z.string(),
    realized_pnl_base: /*#__PURE__*/ z.string(),
    marks_valued_at: /*#__PURE__*/ z.string().nullable()
});

export const zTradingAccount = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organization_id: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    account_type: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    base_currency: /*#__PURE__*/ z.string(),
    cash_balance_base: /*#__PURE__*/ z.string(),
    net_liquidation: zNetLiquidation
});

export const zCashMovementResult = /*#__PURE__*/ z.object({
    applied: /*#__PURE__*/ z.boolean()
});

export const zFxCashLeg = /*#__PURE__*/ z.object({
    currency: /*#__PURE__*/ z.string(),
    amount: /*#__PURE__*/ z.string(),
    rate: /*#__PURE__*/ z.string().nullable(),
    amount_base: /*#__PURE__*/ z.string().nullable(),
    source: /*#__PURE__*/ z.string(),
    unavailable: /*#__PURE__*/ z.boolean(),
    reason_code: /*#__PURE__*/ z.string().nullable()
});

export const zAccountFxCash = /*#__PURE__*/ z.object({
    account_id: /*#__PURE__*/ z.number(),
    base_currency: /*#__PURE__*/ z.string(),
    as_of: /*#__PURE__*/ z.string(),
    legs: /*#__PURE__*/ z.array(zFxCashLeg),
    total_base: /*#__PURE__*/ z.string().nullable(),
    all_translated: /*#__PURE__*/ z.boolean()
});

export const zPositionLot = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    account_id: /*#__PURE__*/ z.number(),
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.enum(['long', 'short']),
    original_quantity: /*#__PURE__*/ z.string(),
    remaining_quantity: /*#__PURE__*/ z.string(),
    cost_basis_per_unit: /*#__PURE__*/ z.string(),
    acquisition_fee: /*#__PURE__*/ z.string(),
    currency: /*#__PURE__*/ z.string(),
    acquired_at: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum(['open', 'closed'])
});

export const zLotDisposal = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    lot_id: /*#__PURE__*/ z.number(),
    disposed_quantity: /*#__PURE__*/ z.string(),
    proceeds_per_unit: /*#__PURE__*/ z.string(),
    cost_basis_per_unit: /*#__PURE__*/ z.string(),
    realized_pnl: /*#__PURE__*/ z.string(),
    holding_term: /*#__PURE__*/ z.enum(['short', 'long']),
    holding_days: /*#__PURE__*/ z.number(),
    acquired_at: /*#__PURE__*/ z.string(),
    disposed_at: /*#__PURE__*/ z.string()
});

export const zBookSnapshot = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    account_id: /*#__PURE__*/ z.number(),
    symbol: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.enum(['long', 'short']),
    currency: /*#__PURE__*/ z.string(),
    snapshot_type: /*#__PURE__*/ z.enum(['sod', 'eod']),
    as_of: /*#__PURE__*/ z.string(),
    open_lot_count: /*#__PURE__*/ z.number(),
    total_quantity: /*#__PURE__*/ z.string(),
    total_cost_basis: /*#__PURE__*/ z.string(),
    mark_price: /*#__PURE__*/ z.string().nullable(),
    unrealized_pnl: /*#__PURE__*/ z.string().nullable(),
    struck_at: /*#__PURE__*/ z.string()
});

export const zDtiKillSwitchResult = /*#__PURE__*/ z.object({
    forwardRunId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum(['paused', 'active'])
});

export const zDtiKillSwitchRequest = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().max(500).optional()
});

export const zDtiResumeRequest = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().max(500).optional()
});

export const zCreateDiscretionaryRunResult = /*#__PURE__*/ z.object({
    forwardRunId: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum(['active']),
    personaTemplateId: /*#__PURE__*/ z.number(),
    agentId: /*#__PURE__*/ z.number()
});

export const zCreateDiscretionaryRunRequest = /*#__PURE__*/ z.object({
    personaSlug: /*#__PURE__*/ z.string().min(1),
    primarySymbol: /*#__PURE__*/ z.string().min(1),
    exchange: /*#__PURE__*/ z.string().min(1).optional().default('us'),
    baseTimeframe: /*#__PURE__*/ z.string().min(1).optional().default('1d'),
    timeframeStack: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([
        '1D',
        '4H',
        '1H'
    ]),
    minConviction: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0.5),
    minConfluenceScore: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0.6),
    calibratedSetups: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
    calibratedRegimes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
    maxPositionFrac: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0.1),
    minRiskReward: /*#__PURE__*/ z.number().gte(0).optional().default(1.5),
    governanceCeilingNAV: /*#__PURE__*/ z.number().gte(0).optional().default(1),
    monitor: /*#__PURE__*/ z.object({
        backtestMeanReturn: /*#__PURE__*/ z.number(),
        backtestVolatility: /*#__PURE__*/ z.number().gt(0),
        deflatedSharpeRatio: /*#__PURE__*/ z.number(),
        annualizationFactor: /*#__PURE__*/ z.number().gt(0),
        sourceExchange: /*#__PURE__*/ z.string().min(1),
        sourceTimeframe: /*#__PURE__*/ z.string().min(1),
        validatedRegimes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
        sprtAlpha: /*#__PURE__*/ z.number().optional(),
        sprtBeta: /*#__PURE__*/ z.number().optional(),
        sprtDeltaSR: /*#__PURE__*/ z.number().optional(),
        cusumHOverride: /*#__PURE__*/ z.number().optional()
    }),
    daemonSlug: /*#__PURE__*/ z.string().optional(),
    personaVersion: /*#__PURE__*/ z.string().optional(),
    styleVersion: /*#__PURE__*/ z.string().optional(),
    initialCash: /*#__PURE__*/ z.number().gt(0).optional()
});

export const zIntelSourceStyleProfileResult = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    meta: /*#__PURE__*/ z.object({
        intelSourceId: /*#__PURE__*/ z.string(),
        version: /*#__PURE__*/ z.int(),
        builtAt: /*#__PURE__*/ z.string().nullable(),
        insightCount: /*#__PURE__*/ z.int()
    })
});

export const zIntelSourceViewConfirmationHorizon = /*#__PURE__*/ z.object({
    horizonDays: /*#__PURE__*/ z.int(),
    matched: /*#__PURE__*/ z.int(),
    missed: /*#__PURE__*/ z.int(),
    neutralBand: /*#__PURE__*/ z.int(),
    hitRate: /*#__PURE__*/ z.number().nullable(),
    sampleSize: /*#__PURE__*/ z.int()
});

export const zIntelSourceViewConfirmationAgreement = /*#__PURE__*/ z.object({
    meanAgreement: /*#__PURE__*/ z.number().nullable(),
    sampleSize: /*#__PURE__*/ z.int()
});

export const zIntelSourceViewConfirmationPending = /*#__PURE__*/ z.object({
    count: /*#__PURE__*/ z.int(),
    nextDueAt: /*#__PURE__*/ z.string().nullable()
});

export const zIntelSourceViewConfirmationResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        horizons: /*#__PURE__*/ z.array(zIntelSourceViewConfirmationHorizon),
        agreement: zIntelSourceViewConfirmationAgreement,
        pending: zIntelSourceViewConfirmationPending
    })
});

export const zAuditLedgerEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    organization_id: /*#__PURE__*/ z.number(),
    chain_seq: /*#__PURE__*/ z.number(),
    prev_hash: /*#__PURE__*/ z.string().nullable(),
    row_hash: /*#__PURE__*/ z.string(),
    entry_kind: /*#__PURE__*/ z.string(),
    severity: /*#__PURE__*/ z.string(),
    subject_kind: /*#__PURE__*/ z.string(),
    order_id: /*#__PURE__*/ z.number().nullable(),
    position_id: /*#__PURE__*/ z.number().nullable(),
    daemon_decision_id: /*#__PURE__*/ z.number().nullable(),
    strategy_definition_id: /*#__PURE__*/ z.number().nullable(),
    portfolio_id: /*#__PURE__*/ z.number().nullable(),
    actor_kind: /*#__PURE__*/ z.string(),
    actor_user_id: /*#__PURE__*/ z.number().nullable(),
    actor_daemon_id: /*#__PURE__*/ z.number().nullable(),
    actor_label: /*#__PURE__*/ z.string().nullable(),
    payload: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    effective_at: /*#__PURE__*/ z.string(),
    recorded_at: /*#__PURE__*/ z.string(),
    clock_source: /*#__PURE__*/ z.string()
});

export const zAuditLedgerEntryList = /*#__PURE__*/ z.object({
    entries: /*#__PURE__*/ z.array(zAuditLedgerEntry),
    next_cursor_seq: /*#__PURE__*/ z.number().nullable()
});

export const zAuditLedgerHead = /*#__PURE__*/ z.object({
    organization_id: /*#__PURE__*/ z.number(),
    head_seq: /*#__PURE__*/ z.number(),
    head_hash: /*#__PURE__*/ z.string(),
    entry_count: /*#__PURE__*/ z.number(),
    created_at: /*#__PURE__*/ z.string().nullable(),
    updated_at: /*#__PURE__*/ z.string().nullable()
});

export const zAuditLedgerChainVerificationResult = /*#__PURE__*/ z.object({
    valid: /*#__PURE__*/ z.boolean(),
    entries_checked: /*#__PURE__*/ z.number(),
    first_broken_seq: /*#__PURE__*/ z.number().nullable(),
    reason: /*#__PURE__*/ z.string().nullable()
});

export const zExecutionDeployment = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    run_id: /*#__PURE__*/ z.string(),
    organization_id: /*#__PURE__*/ z.int().gt(0),
    definition_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    bucket_definition_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    scope: /*#__PURE__*/ z.string(),
    run_mode: /*#__PURE__*/ z.string(),
    run_status: /*#__PURE__*/ z.string().nullable(),
    requested_adapter_ref: /*#__PURE__*/ z.string().nullable(),
    venue: /*#__PURE__*/ z.string().nullable(),
    notional_budget: /*#__PURE__*/ z.number().nullable(),
    order_count: /*#__PURE__*/ z.int().gte(0),
    placed_count: /*#__PURE__*/ z.int().gte(0),
    blocked_reasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    created_at: /*#__PURE__*/ z.string(),
    finished_at: /*#__PURE__*/ z.string().nullable()
});

export const zExecutionDeploymentCreate = /*#__PURE__*/ z.object({
    definition_id: /*#__PURE__*/ z.int().gt(0).optional(),
    bucket_definition_id: /*#__PURE__*/ z.int().gt(0).optional(),
    venue: /*#__PURE__*/ z.enum(['paper', 'live']),
    notional_budget: /*#__PURE__*/ z.number().gt(0).optional()
});

export const zExecutionDeploymentList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zExecutionDeployment),
    total: /*#__PURE__*/ z.int().gte(0),
    limit: /*#__PURE__*/ z.int().gt(0),
    offset: /*#__PURE__*/ z.int().gte(0)
});

export const zExecutionDeploymentOrder = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    strategy_run_id: /*#__PURE__*/ z.int().gt(0).nullable(),
    client_order_id: /*#__PURE__*/ z.string(),
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.string(),
    type: /*#__PURE__*/ z.string(),
    quantity: /*#__PURE__*/ z.string(),
    filled_quantity: /*#__PURE__*/ z.string().nullable(),
    avg_fill_price: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.string().nullable(),
    reject_reason: /*#__PURE__*/ z.string().nullable(),
    submitted_at: /*#__PURE__*/ z.string().nullable(),
    filled_at: /*#__PURE__*/ z.string().nullable(),
    fills: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0),
        price: /*#__PURE__*/ z.string(),
        quantity: /*#__PURE__*/ z.string(),
        commission: /*#__PURE__*/ z.string().nullable(),
        commission_asset: /*#__PURE__*/ z.string().nullable(),
        filled_at: /*#__PURE__*/ z.string().nullable()
    }))
});

export const zExecutionDeploymentRun = /*#__PURE__*/ z.object({
    run: zExecutionDeployment,
    orders: /*#__PURE__*/ z.array(zExecutionDeploymentOrder)
});

export const zMarkResult = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'position',
        'holding',
        'symbol'
    ]),
    scopeId: /*#__PURE__*/ z.number().nullable(),
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    asOf: /*#__PURE__*/ z.iso.datetime(),
    status: /*#__PURE__*/ z.enum([
        'marked',
        'stale',
        'unmarked'
    ]),
    source: /*#__PURE__*/ z.enum([
        'candle_close',
        'candle_close_stale',
        'manual_override',
        'unmarked'
    ]),
    markPriceUsd: /*#__PURE__*/ z.number().nullable(),
    marketValueUsd: /*#__PURE__*/ z.number().nullable(),
    quantity: /*#__PURE__*/ z.number(),
    barTime: /*#__PURE__*/ z.iso.datetime().nullable(),
    providerRef: /*#__PURE__*/ z.string().nullable(),
    dataAvailableAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    adjustmentPolicy: /*#__PURE__*/ z.string(),
    pointInTime: /*#__PURE__*/ z.enum(['verified', 'unverified']),
    reasonCode: /*#__PURE__*/ z.string().nullable()
});

export const zPortfolioValuationResult = /*#__PURE__*/ z.object({
    portfolioId: /*#__PURE__*/ z.number(),
    asOf: /*#__PURE__*/ z.iso.datetime(),
    equityValueUsd: /*#__PURE__*/ z.number(),
    markedCount: /*#__PURE__*/ z.number(),
    staleCount: /*#__PURE__*/ z.number(),
    unmarkedCount: /*#__PURE__*/ z.number(),
    marks: /*#__PURE__*/ z.array(zMarkResult)
});

export const zModelLineageAuthoring = /*#__PURE__*/ z.object({
    workflowRunId: /*#__PURE__*/ z.string().nullable(),
    authoringModel: /*#__PURE__*/ z.string().nullable(),
    authoringStepId: /*#__PURE__*/ z.string().nullable(),
    authoringAgentId: /*#__PURE__*/ z.string().nullable(),
    daemonRunId: /*#__PURE__*/ z.string().nullable(),
    daemonId: /*#__PURE__*/ z.string().nullable(),
    daemonName: /*#__PURE__*/ z.string().nullable(),
    authoringCostUsd: /*#__PURE__*/ z.string().nullable(),
    authoringQualityScore: /*#__PURE__*/ z.string().nullable(),
    workOutputId: /*#__PURE__*/ z.string().nullable(),
    outputPartId: /*#__PURE__*/ z.string().nullable()
});

export const zModelLineageDataVintageRef = /*#__PURE__*/ z.object({
    dataSnapshotId: /*#__PURE__*/ z.string(),
    providers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    pointInTimeCorrect: /*#__PURE__*/ z.boolean().nullable(),
    survivorshipBiasFree: /*#__PURE__*/ z.boolean().nullable(),
    runCount: /*#__PURE__*/ z.int().gte(0)
});

export const zModelLineageDataVintage = /*#__PURE__*/ z.object({
    vintages: /*#__PURE__*/ z.array(zModelLineageDataVintageRef),
    hasMultipleVintages: /*#__PURE__*/ z.boolean(),
    costModelIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zModelLineageScoreEntry = /*#__PURE__*/ z.object({
    scoreType: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    regime: /*#__PURE__*/ z.string(),
    value: /*#__PURE__*/ z.number(),
    uncertainty: /*#__PURE__*/ z.number(),
    skillProb: /*#__PURE__*/ z.number().nullable(),
    skillProbSource: /*#__PURE__*/ z.enum(['dsr', 'psr']).nullable(),
    pboPassed: /*#__PURE__*/ z.boolean().nullable(),
    sourceRunIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    computedAt: /*#__PURE__*/ z.string()
});

export const zModelLineageScoreSummary = /*#__PURE__*/ z.object({
    scores: /*#__PURE__*/ z.array(zModelLineageScoreEntry)
});

export const zModelLineageExecutionFootprint = /*#__PURE__*/ z.object({
    executionIntentCount: /*#__PURE__*/ z.int().gte(0),
    orderCount: /*#__PURE__*/ z.int().gte(0),
    fillCount: /*#__PURE__*/ z.int().gte(0),
    everTraded: /*#__PURE__*/ z.boolean(),
    lastFillAt: /*#__PURE__*/ z.string().nullish()
});

export const zModelLineageRecord = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.enum(['strategy_definition', 'strategy_bucket_definition']),
    subjectId: /*#__PURE__*/ z.string(),
    definitionVersion: /*#__PURE__*/ z.int(),
    slug: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    category: /*#__PURE__*/ z.string().nullable(),
    definitionHash: /*#__PURE__*/ z.string(),
    paramSetHashes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    lifecycleState: /*#__PURE__*/ z.string(),
    validationStatus: /*#__PURE__*/ z.string(),
    transitionCount: /*#__PURE__*/ z.int(),
    lastApprovalDecisionId: /*#__PURE__*/ z.string().nullable(),
    lastTransitionAt: /*#__PURE__*/ z.string().nullable(),
    authoring: zModelLineageAuthoring,
    templateProvenance: /*#__PURE__*/ zModelLineageTemplateProvenance.nullable(),
    dataVintage: zModelLineageDataVintage,
    codeVersions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    randomSeeds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int()),
    adapterRefs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    runCount: /*#__PURE__*/ z.int(),
    lastRunId: /*#__PURE__*/ z.string().nullable(),
    lastRunFinishedAt: /*#__PURE__*/ z.string().nullable(),
    scoreSummary: zModelLineageScoreSummary,
    executionFootprint: zModelLineageExecutionFootprint,
    lineageHash: /*#__PURE__*/ z.string().length(64),
    computedAt: /*#__PURE__*/ z.string()
});

export const zModelLineageRecordList = /*#__PURE__*/ z.object({
    records: /*#__PURE__*/ z.array(zModelLineageRecord),
    total: /*#__PURE__*/ z.int()
});

export const zModelLineageEdge = /*#__PURE__*/ z.object({
    edgeKind: /*#__PURE__*/ z.enum([
        'authored_by',
        'compiled_from',
        'evaluated_by',
        'used_data_vintage',
        'used_adapter',
        'scored_by',
        'derived_edge',
        'lifecycle_transition',
        'approved_by',
        'executed_as',
        'filled_by',
        'audited_by'
    ]),
    srcKind: /*#__PURE__*/ z.string(),
    srcId: /*#__PURE__*/ z.string(),
    dstKind: /*#__PURE__*/ z.string(),
    dstId: /*#__PURE__*/ z.string().nullable(),
    dstRef: /*#__PURE__*/ z.string().nullable(),
    attributes: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.boolean()
    ]).nullable()),
    ordinal: /*#__PURE__*/ z.int()
});

export const zModelLineageGraph = /*#__PURE__*/ z.object({
    record: zModelLineageRecord,
    edges: /*#__PURE__*/ z.array(zModelLineageEdge)
});

export const zKgScoreTypeRegimeProfile = /*#__PURE__*/ z.object({
    score_type: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    global: /*#__PURE__*/ zKgRegimeScoreEntry.nullable(),
    by_regime: /*#__PURE__*/ z.array(zKgRegimeScoreEntry),
    is_regime_conditional: /*#__PURE__*/ z.boolean()
});

export const zKgRegimeProfile = /*#__PURE__*/ z.object({
    subject_kind: /*#__PURE__*/ z.string(),
    subject_id: /*#__PURE__*/ z.int().gt(0),
    by_score_type: /*#__PURE__*/ z.array(zKgScoreTypeRegimeProfile),
    has_regime_conditional_scores: /*#__PURE__*/ z.boolean()
});

export const zKgEdgeEntry = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    edge_type: /*#__PURE__*/ z.string(),
    src_kind: /*#__PURE__*/ z.string(),
    src_id: /*#__PURE__*/ z.string(),
    dst_kind: /*#__PURE__*/ z.string(),
    dst_id: /*#__PURE__*/ z.string(),
    directed: /*#__PURE__*/ z.boolean(),
    strength: /*#__PURE__*/ z.number().nullable(),
    confidence: /*#__PURE__*/ z.number().nullable(),
    evidence_count: /*#__PURE__*/ z.int().gte(0),
    regime: /*#__PURE__*/ z.string().nullable(),
    valid_from: /*#__PURE__*/ z.string().nullable(),
    valid_until: /*#__PURE__*/ z.string().nullable(),
    last_evidence_at: /*#__PURE__*/ z.string().nullable(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'contradicted',
        'retired',
        'superseded'
    ]),
    linked_node: /*#__PURE__*/ zKgNodeSummary.nullable()
});

export const zKgNodeEdges = /*#__PURE__*/ z.object({
    node: zKgNodeSummary,
    edges: /*#__PURE__*/ z.array(zKgEdgeEntry),
    total: /*#__PURE__*/ z.int().gte(0)
});

export const zKgSearchResult = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    node_type: /*#__PURE__*/ z.string(),
    canonical_key: /*#__PURE__*/ z.string(),
    label: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'merged',
        'retired'
    ]),
    score: /*#__PURE__*/ z.number(),
    match_type: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ])
});

export const zKgSearchResultList = /*#__PURE__*/ z.object({
    results: /*#__PURE__*/ z.array(zKgSearchResult)
});

export const zBrokerCredential = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    provider: /*#__PURE__*/ z.enum([
        'alpaca',
        'binance',
        'paper',
        'bybit',
        'ibkr',
        'hyperliquid'
    ]),
    environment: /*#__PURE__*/ z.enum(['paper', 'live']),
    venue_kind: /*#__PURE__*/ z.enum([
        'cash_equity',
        'crypto_spot',
        'crypto_perp',
        'paper'
    ]),
    label: /*#__PURE__*/ z.string().nullable(),
    api_key_tail: /*#__PURE__*/ z.string(),
    base_url: /*#__PURE__*/ z.string().nullable(),
    is_enabled: /*#__PURE__*/ z.boolean(),
    asset_classes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
        'equity',
        'etf',
        'index',
        'crypto',
        'fx',
        'commodity'
    ])),
    last_verified_at: /*#__PURE__*/ z.string().nullable(),
    created_at: /*#__PURE__*/ z.string(),
    updated_at: /*#__PURE__*/ z.string()
});

export const zBrokerCredentialCreate = /*#__PURE__*/ z.object({
    provider: /*#__PURE__*/ z.enum([
        'alpaca',
        'binance',
        'paper',
        'bybit',
        'ibkr',
        'hyperliquid'
    ]),
    environment: /*#__PURE__*/ z.enum(['paper', 'live']),
    venue_kind: /*#__PURE__*/ z.enum([
        'cash_equity',
        'crypto_spot',
        'crypto_perp',
        'paper'
    ]),
    label: /*#__PURE__*/ z.string().min(1).max(80).optional(),
    api_key: /*#__PURE__*/ z.string().min(1).max(400),
    api_secret: /*#__PURE__*/ z.string().min(1).max(400),
    base_url: /*#__PURE__*/ z.url().max(200).optional(),
    asset_classes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
        'equity',
        'etf',
        'index',
        'crypto',
        'fx',
        'commodity'
    ])).min(1)
});

export const zBrokerCredentialList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zBrokerCredential)
});

export const zBrokerCredentialUpdate = /*#__PURE__*/ z.object({
    label: /*#__PURE__*/ z.string().min(1).max(80).optional(),
    is_enabled: /*#__PURE__*/ z.boolean().optional(),
    api_key: /*#__PURE__*/ z.string().min(1).max(400).optional(),
    api_secret: /*#__PURE__*/ z.string().min(1).max(400).optional(),
    base_url: /*#__PURE__*/ z.url().max(200).optional(),
    asset_classes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
        'equity',
        'etf',
        'index',
        'crypto',
        'fx',
        'commodity'
    ])).min(1).optional()
});

export const zBrokerCredentialVerifyResult = /*#__PURE__*/ z.object({
    ok: /*#__PURE__*/ z.boolean(),
    error: /*#__PURE__*/ z.string().nullable()
});

export const zExecutionAlgo = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    organization_id: /*#__PURE__*/ z.string(),
    user_id: /*#__PURE__*/ z.string(),
    strategy_run_id: /*#__PURE__*/ z.string().nullable(),
    symbol: /*#__PURE__*/ z.string(),
    side: /*#__PURE__*/ z.enum(['buy', 'sell']),
    asset_class: /*#__PURE__*/ z.string(),
    total_quantity: /*#__PURE__*/ z.string(),
    algo_type: /*#__PURE__*/ z.enum([
        'twap',
        'vwap',
        'market_making'
    ]),
    params: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum(['execution_algo_params']),
        schemaVersion: /*#__PURE__*/ z.enum(['finance-execution-algo/v1']),
        startAt: /*#__PURE__*/ z.iso.datetime(),
        endAt: /*#__PURE__*/ z.iso.datetime(),
        sliceIntervalSeconds: /*#__PURE__*/ z.int().gt(0).lte(3600),
        orderTypePolicy: /*#__PURE__*/ z.enum(['marketable_limit', 'market']).optional().default('marketable_limit'),
        slippageCapBps: /*#__PURE__*/ z.number().gt(0).lte(1000).optional(),
        participationCapPct: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0.15),
        minClip: /*#__PURE__*/ z.number().gt(0),
        maxClip: /*#__PURE__*/ z.number().gt(0),
        timeJitterPct: /*#__PURE__*/ z.number().gte(0).lte(0.5).optional().default(0.2),
        sizeJitterPct: /*#__PURE__*/ z.number().gte(0).lte(0.9).optional().default(0),
        volumeProfile: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number().gte(0)).optional(),
        arrivalPrice: /*#__PURE__*/ z.number().gt(0).optional(),
        degradedReason: /*#__PURE__*/ z.string().optional(),
        hedgeContext: /*#__PURE__*/ z.object({
            policy: /*#__PURE__*/ z.enum([
                'delta',
                'whalley_wilmott',
                'learned_ntb'
            ]),
            greek: /*#__PURE__*/ z.enum([
                'delta',
                'gamma',
                'vega'
            ]),
            regimeAtDecision: /*#__PURE__*/ z.string(),
            policyVersion: /*#__PURE__*/ z.string(),
            decisionId: /*#__PURE__*/ z.string()
        }).optional(),
        quotePolicy: /*#__PURE__*/ z.object({
            policyVersion: /*#__PURE__*/ z.string(),
            quoteMode: /*#__PURE__*/ z.enum(['post_only_ladder', 'styled_paper_rest']),
            regimeAtDecision: /*#__PURE__*/ z.string().max(30),
            decisionId: /*#__PURE__*/ z.string(),
            baselineIsNoSkew: /*#__PURE__*/ z.boolean()
        }).optional()
    }),
    status: /*#__PURE__*/ z.enum([
        'working',
        'completed',
        'cancelled',
        'expired',
        'failed',
        'paused'
    ]),
    next_slice_due_at: /*#__PURE__*/ z.string().nullable(),
    slices_submitted: /*#__PURE__*/ z.number(),
    last_error: /*#__PURE__*/ z.string().nullable(),
    created_at: /*#__PURE__*/ z.string(),
    updated_at: /*#__PURE__*/ z.string(),
    completed_at: /*#__PURE__*/ z.string().nullable()
});

export const zExecutionAlgoCreate = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1).max(20),
    side: /*#__PURE__*/ z.enum(['buy', 'sell']),
    asset_class: /*#__PURE__*/ z.enum(['crypto', 'equity']),
    total_quantity: /*#__PURE__*/ z.number().gt(0),
    algo_type: /*#__PURE__*/ z.enum([
        'twap',
        'vwap',
        'market_making'
    ]),
    params: /*#__PURE__*/ z.object({
        type: /*#__PURE__*/ z.enum(['execution_algo_params']),
        schemaVersion: /*#__PURE__*/ z.enum(['finance-execution-algo/v1']),
        startAt: /*#__PURE__*/ z.iso.datetime(),
        endAt: /*#__PURE__*/ z.iso.datetime(),
        sliceIntervalSeconds: /*#__PURE__*/ z.int().gt(0).lte(3600),
        orderTypePolicy: /*#__PURE__*/ z.enum(['marketable_limit', 'market']).optional().default('marketable_limit'),
        slippageCapBps: /*#__PURE__*/ z.number().gt(0).lte(1000).optional(),
        participationCapPct: /*#__PURE__*/ z.number().gte(0).lte(1).optional().default(0.15),
        minClip: /*#__PURE__*/ z.number().gt(0),
        maxClip: /*#__PURE__*/ z.number().gt(0),
        timeJitterPct: /*#__PURE__*/ z.number().gte(0).lte(0.5).optional().default(0.2),
        sizeJitterPct: /*#__PURE__*/ z.number().gte(0).lte(0.9).optional().default(0),
        volumeProfile: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number().gte(0)).optional(),
        arrivalPrice: /*#__PURE__*/ z.number().gt(0).optional(),
        degradedReason: /*#__PURE__*/ z.string().optional(),
        hedgeContext: /*#__PURE__*/ z.object({
            policy: /*#__PURE__*/ z.enum([
                'delta',
                'whalley_wilmott',
                'learned_ntb'
            ]),
            greek: /*#__PURE__*/ z.enum([
                'delta',
                'gamma',
                'vega'
            ]),
            regimeAtDecision: /*#__PURE__*/ z.string(),
            policyVersion: /*#__PURE__*/ z.string(),
            decisionId: /*#__PURE__*/ z.string()
        }).optional(),
        quotePolicy: /*#__PURE__*/ z.object({
            policyVersion: /*#__PURE__*/ z.string(),
            quoteMode: /*#__PURE__*/ z.enum(['post_only_ladder', 'styled_paper_rest']),
            regimeAtDecision: /*#__PURE__*/ z.string().max(30),
            decisionId: /*#__PURE__*/ z.string(),
            baselineIsNoSkew: /*#__PURE__*/ z.boolean()
        }).optional()
    })
});

export const zExecutionAlgoList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zExecutionAlgo)
});

export const zExecutionAlgoWithSummary = /*#__PURE__*/ zExecutionAlgo.and(/*#__PURE__*/ z.object({
    worked_quantity: /*#__PURE__*/ z.number(),
    in_flight_count: /*#__PURE__*/ z.number()
}));

export const zForwardRunCreateResult = /*#__PURE__*/ z.object({
    forwardRunId: /*#__PURE__*/ z.string(),
    created: /*#__PURE__*/ z.boolean()
});

export const zCreateForwardRunBody = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.string().min(1),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1),
    exchange: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    initialCapital: /*#__PURE__*/ z.number().gt(0).optional(),
    participationCap: /*#__PURE__*/ z.number().gte(0).lte(1).optional(),
    costModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    runConfig: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zCreateBucketForwardRunBody = /*#__PURE__*/ z.object({
    bucketDefinitionId: /*#__PURE__*/ z.string().min(1),
    componentSymbols: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1)),
    componentRunConfigs: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())).optional(),
    exchange: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    initialCapital: /*#__PURE__*/ z.number().gt(0).optional(),
    participationCap: /*#__PURE__*/ z.number().gte(0).lte(1).optional(),
    costModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    maxDroppedWeightFrac: /*#__PURE__*/ z.number().gte(0).lte(1).optional(),
    runConfig: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zForwardRunListItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    definitionId: /*#__PURE__*/ z.string().nullable(),
    bucketDefinitionId: /*#__PURE__*/ z.string().nullable(),
    scope: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum([
        'warming_up',
        'active',
        'paused',
        'stopped'
    ]),
    requestId: /*#__PURE__*/ z.string(),
    baseRunId: /*#__PURE__*/ z.string().nullable(),
    initialCash: /*#__PURE__*/ z.number().nullable(),
    cash: /*#__PURE__*/ z.number().nullable(),
    equity: /*#__PURE__*/ z.number().nullable(),
    startedAt: /*#__PURE__*/ z.string().nullable(),
    watermarkBar: /*#__PURE__*/ z.string().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zForwardRunList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zForwardRunListItem),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zForwardRun = /*#__PURE__*/ zForwardRunListItem.and(/*#__PURE__*/ z.object({
    positions: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
    honestyManifest: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
}));

export const zShadowDaemonCert = /*#__PURE__*/ z.object({
    daemonId: /*#__PURE__*/ z.int(),
    daemonSlug: /*#__PURE__*/ z.string(),
    certStatus: /*#__PURE__*/ z.enum([
        'off',
        'collecting',
        'eligible',
        'certified',
        'blocked'
    ]),
    mode: /*#__PURE__*/ z.enum([
        'off',
        'collecting',
        'certified'
    ]),
    counters: /*#__PURE__*/ zShadowCertCounters.nullable(),
    thresholds: /*#__PURE__*/ zShadowCertThresholds.nullable(),
    updatedAt: /*#__PURE__*/ z.string().nullable(),
    certDecisionId: /*#__PURE__*/ z.int().nullable()
});

export const zShadowDaemonCertList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zShadowDaemonCert)
});

export const zShadowDaemonCertData = /*#__PURE__*/ z.object({
    data: zShadowDaemonCert
});

export const zShadowDaemonEnrollUpdate = /*#__PURE__*/ z.object({
    mode: /*#__PURE__*/ z.enum(['off', 'collecting'])
});

export const zProjectCodeOperationalMetrics = /*#__PURE__*/ z.object({
    reviewRequestCount: /*#__PURE__*/ z.number(),
    pendingReviewCount: /*#__PURE__*/ z.number(),
    oldestPendingReviewAgeMs: /*#__PURE__*/ z.number().nullable(),
    averageDecisionLatencyMs: /*#__PURE__*/ z.number().nullable(),
    riskAcceptanceExpiringCount: /*#__PURE__*/ z.number(),
    nextRiskAcceptanceExpiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    daemonEvidenceAverageLatencyMs: /*#__PURE__*/ z.number().nullable(),
    requestChangesLoopCount: /*#__PURE__*/ z.number(),
    sourceSyncPendingCount: /*#__PURE__*/ z.number(),
    sourceSyncAverageLatencyMs: /*#__PURE__*/ z.number().nullable()
});

export const zCodeWorkspaceState = /*#__PURE__*/ z.object({
    workspace: /*#__PURE__*/ zCodeWorkspace.nullable()
});

export const zCodeRepositoryConnection = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    provider: /*#__PURE__*/ z.enum([
        'local_git',
        'github',
        'gitlab',
        'gitea',
        'forgejo',
        'gerrit',
        'confluent_hosted'
    ]),
    status: /*#__PURE__*/ z.enum([
        'active',
        'disabled',
        'archived'
    ]),
    providerInstallationId: /*#__PURE__*/ z.string().nullable(),
    providerAccountId: /*#__PURE__*/ z.string().nullable(),
    providerRepositoryId: /*#__PURE__*/ z.string().nullable(),
    repoOwner: /*#__PURE__*/ z.string().nullable(),
    repoName: /*#__PURE__*/ z.string().nullable(),
    repoUrl: /*#__PURE__*/ z.string().nullable(),
    providerHtmlUrl: /*#__PURE__*/ z.string().nullable(),
    defaultBranch: /*#__PURE__*/ z.string(),
    localPath: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeRepositoryConnectionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCodeRepositoryConnection)
});

export const zCodeRepositoryConnectionCreateInput = /*#__PURE__*/ z.object({
    provider: /*#__PURE__*/ z.enum([
        'local_git',
        'github',
        'gitlab',
        'gitea',
        'forgejo',
        'gerrit',
        'confluent_hosted'
    ]),
    defaultBranch: /*#__PURE__*/ z.string().min(1).max(200).optional().default('main'),
    providerInstallationId: /*#__PURE__*/ z.string().max(512).nullish(),
    providerAccountId: /*#__PURE__*/ z.string().max(512).nullish(),
    providerRepositoryId: /*#__PURE__*/ z.string().max(512).nullish(),
    repoOwner: /*#__PURE__*/ z.string().max(200).nullish(),
    repoName: /*#__PURE__*/ z.string().max(200).nullish(),
    repoUrl: /*#__PURE__*/ z.string().max(2000).nullish(),
    providerHtmlUrl: /*#__PURE__*/ z.string().max(2000).nullish(),
    localPath: /*#__PURE__*/ z.string().max(2000).nullish(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zCodeWorkspaceEnableResult = /*#__PURE__*/ z.object({
    workspace: zCodeWorkspace,
    operation: /*#__PURE__*/ zCodeWorkspaceOperation.nullable(),
    created: /*#__PURE__*/ z.boolean()
});

export const zCodeWorkspaceEnableInput = /*#__PURE__*/ z.object({
    provider: /*#__PURE__*/ z.enum([
        'local_git',
        'github',
        'gitlab',
        'gitea',
        'forgejo',
        'gerrit',
        'confluent_hosted'
    ]),
    repositoryConnectionId: /*#__PURE__*/ z.int().gt(0),
    branchPrefix: /*#__PURE__*/ z.string().max(200).nullish(),
    isolationTier: /*#__PURE__*/ z.enum([
        'org_default',
        'project',
        'byo'
    ]).optional().default('org_default'),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zCodeCheckpoint = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    workspaceId: /*#__PURE__*/ z.number().nullable(),
    projectId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number().nullable(),
    revisionId: /*#__PURE__*/ z.number().nullable(),
    checkpointType: /*#__PURE__*/ z.enum([
        'baseline',
        'generated',
        'approved',
        'merged',
        'rollback'
    ]),
    status: /*#__PURE__*/ z.enum([
        'valid',
        'superseded',
        'failed',
        'blocked'
    ]),
    label: /*#__PURE__*/ z.string().nullable(),
    branchName: /*#__PURE__*/ z.string(),
    baseCommitSha: /*#__PURE__*/ z.string().nullable(),
    commitSha: /*#__PURE__*/ z.string(),
    treeSha: /*#__PURE__*/ z.string().nullable(),
    patchArtifactId: /*#__PURE__*/ z.number().nullable(),
    migrationArtifactId: /*#__PURE__*/ z.number().nullable(),
    validationReportArtifactId: /*#__PURE__*/ z.number().nullable(),
    statusSnapshot: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    rollbackOfCheckpointId: /*#__PURE__*/ z.number().nullable(),
    providerRef: /*#__PURE__*/ z.string().nullable(),
    providerUrl: /*#__PURE__*/ z.string().nullable(),
    createdByActorType: /*#__PURE__*/ z.string(),
    createdByActorId: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeWorkspaceCheckpointsList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCodeCheckpoint),
    pageInfo: /*#__PURE__*/ z.object({
        hasNextPage: /*#__PURE__*/ z.boolean(),
        endCursor: /*#__PURE__*/ z.iso.datetime().nullable()
    })
});

export const zCodeWorkspaceOperationsList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCodeWorkspaceOperation),
    pageInfo: /*#__PURE__*/ z.object({
        hasNextPage: /*#__PURE__*/ z.boolean(),
        endCursor: /*#__PURE__*/ z.iso.datetime().nullable()
    })
});

export const zCodeWorkspaceOperationResult = /*#__PURE__*/ z.object({
    operation: zCodeWorkspaceOperation
});

export const zCodeWorkspaceMaterializeInput = /*#__PURE__*/ z.object({
    revisionId: /*#__PURE__*/ z.int().gt(0),
    expectedHeadSha: /*#__PURE__*/ z.string().regex(/^[0-9a-f]{7,64}$\/i/).nullish(),
    branchName: /*#__PURE__*/ z.string().min(1).max(200).optional()
});

export const zCodeWorkspaceOpenReviewInput = /*#__PURE__*/ z.object({
    expectedHeadSha: /*#__PURE__*/ z.string().regex(/^[0-9a-f]{7,64}$\/i/).nullish(),
    title: /*#__PURE__*/ z.string().max(200).optional(),
    body: /*#__PURE__*/ z.string().max(8000).optional()
});

export const zCodeWorkspaceRollbackInput = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().max(4000).optional(),
    expectedHeadSha: /*#__PURE__*/ z.string().regex(/^[0-9a-f]{7,64}$\/i/).nullish()
});

export const zCodeClientDatabaseMigration = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    clientDatabaseId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    workspaceId: /*#__PURE__*/ z.number().nullable(),
    projectChangeId: /*#__PURE__*/ z.number().nullable(),
    revisionId: /*#__PURE__*/ z.number().nullable(),
    outputDeliveryId: /*#__PURE__*/ z.number().nullable(),
    outputPartId: /*#__PURE__*/ z.number().nullable(),
    migrationKind: /*#__PURE__*/ z.enum([
        'schema',
        'seed',
        'table_write',
        'sync_payload'
    ]),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'applied',
        'failed',
        'skipped'
    ]),
    migrationName: /*#__PURE__*/ z.string().nullable(),
    migrationHash: /*#__PURE__*/ z.string().nullable(),
    migrationFilePath: /*#__PURE__*/ z.string().nullable(),
    migrationFileHash: /*#__PURE__*/ z.string().nullable(),
    idempotencyKey: /*#__PURE__*/ z.string().nullable(),
    sourcePartKind: /*#__PURE__*/ z.string().nullable(),
    schemaName: /*#__PURE__*/ z.string().nullable(),
    tableName: /*#__PURE__*/ z.string().nullable(),
    statementCount: /*#__PURE__*/ z.number().nullable(),
    rowCount: /*#__PURE__*/ z.number().nullable(),
    requestPayload: /*#__PURE__*/ z.object({
        partKind: /*#__PURE__*/ z.string().optional(),
        partKey: /*#__PURE__*/ z.string().optional(),
        targetId: /*#__PURE__*/ z.number().optional(),
        deliveryId: /*#__PURE__*/ z.number().optional(),
        processorType: /*#__PURE__*/ z.string().optional(),
        tableName: /*#__PURE__*/ z.string().nullish(),
        schemaName: /*#__PURE__*/ z.string().nullish(),
        migrationFilePath: /*#__PURE__*/ z.string().nullish(),
        migrationFileHash: /*#__PURE__*/ z.string().regex(/^[a-f0-9]{64}$\/i/).nullish(),
        decisionMode: /*#__PURE__*/ z.string().optional(),
        decision: /*#__PURE__*/ z.object({
            action: /*#__PURE__*/ z.enum([
                'configured',
                'enabled',
                'disabled',
                'archived',
                'secret_rotated'
            ]).optional(),
            reason: /*#__PURE__*/ z.string().optional(),
            mode: /*#__PURE__*/ z.enum([
                'missing_scope',
                'needs_target',
                'row_limit_exceeded',
                'byo_payload',
                'target_not_active',
                'unsupported_or_policy_blocked',
                'review_gate_required',
                'queued_table_write',
                'migration_payload',
                'applied',
                'failed',
                'pending',
                'skipped'
            ]).optional(),
            targetId: /*#__PURE__*/ z.number().optional(),
            migrationKind: /*#__PURE__*/ z.enum([
                'schema',
                'seed',
                'table_write',
                'sync_payload'
            ]).optional(),
            schemaName: /*#__PURE__*/ z.string().optional(),
            tableName: /*#__PURE__*/ z.string().optional(),
            rowCount: /*#__PURE__*/ z.number().optional(),
            maxRows: /*#__PURE__*/ z.number().optional(),
            isolationTier: /*#__PURE__*/ z.enum([
                'org_default',
                'project',
                'byo'
            ]).optional(),
            scope: /*#__PURE__*/ z.enum(['organization', 'project']).optional(),
            provider: /*#__PURE__*/ z.enum(['managed_postgres', 'byo_postgres']).optional(),
            status: /*#__PURE__*/ z.enum([
                'provisioning',
                'active',
                'failed',
                'disabled',
                'archived'
            ]).optional(),
            projectId: /*#__PURE__*/ z.number().optional(),
            secretMode: /*#__PURE__*/ z.enum([
                'stored_external_ref',
                'provided_external_ref',
                'managed_provisioning',
                'existing_secret_ref'
            ]).optional(),
            writePolicy: /*#__PURE__*/ z.object({
                mode: /*#__PURE__*/ z.enum(['migrations_only', 'table_writes']).optional(),
                allowSchemaChanges: /*#__PURE__*/ z.boolean().optional(),
                requireReviewGate: /*#__PURE__*/ z.boolean().optional(),
                conflictPolicy: /*#__PURE__*/ z.enum(['do_nothing', 'upsert']).optional(),
                maxRowsPerPart: /*#__PURE__*/ z.int().gt(0).lte(10000).optional(),
                allowedSchemas: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(50).optional(),
                allowedTables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(200).optional()
            }).nullish()
        }).optional(),
        mode: /*#__PURE__*/ z.string().optional(),
        rowCount: /*#__PURE__*/ z.number().optional()
    }).optional().default({}),
    resultPayload: /*#__PURE__*/ z.object({
        partKind: /*#__PURE__*/ z.string().optional(),
        partKey: /*#__PURE__*/ z.string().optional(),
        targetId: /*#__PURE__*/ z.number().optional(),
        deliveryId: /*#__PURE__*/ z.number().optional(),
        processorType: /*#__PURE__*/ z.string().optional(),
        tableName: /*#__PURE__*/ z.string().nullish(),
        schemaName: /*#__PURE__*/ z.string().nullish(),
        migrationFilePath: /*#__PURE__*/ z.string().nullish(),
        migrationFileHash: /*#__PURE__*/ z.string().regex(/^[a-f0-9]{64}$\/i/).nullish(),
        decisionMode: /*#__PURE__*/ z.string().optional(),
        decision: /*#__PURE__*/ z.object({
            action: /*#__PURE__*/ z.enum([
                'configured',
                'enabled',
                'disabled',
                'archived',
                'secret_rotated'
            ]).optional(),
            reason: /*#__PURE__*/ z.string().optional(),
            mode: /*#__PURE__*/ z.enum([
                'missing_scope',
                'needs_target',
                'row_limit_exceeded',
                'byo_payload',
                'target_not_active',
                'unsupported_or_policy_blocked',
                'review_gate_required',
                'queued_table_write',
                'migration_payload',
                'applied',
                'failed',
                'pending',
                'skipped'
            ]).optional(),
            targetId: /*#__PURE__*/ z.number().optional(),
            migrationKind: /*#__PURE__*/ z.enum([
                'schema',
                'seed',
                'table_write',
                'sync_payload'
            ]).optional(),
            schemaName: /*#__PURE__*/ z.string().optional(),
            tableName: /*#__PURE__*/ z.string().optional(),
            rowCount: /*#__PURE__*/ z.number().optional(),
            maxRows: /*#__PURE__*/ z.number().optional(),
            isolationTier: /*#__PURE__*/ z.enum([
                'org_default',
                'project',
                'byo'
            ]).optional(),
            scope: /*#__PURE__*/ z.enum(['organization', 'project']).optional(),
            provider: /*#__PURE__*/ z.enum(['managed_postgres', 'byo_postgres']).optional(),
            status: /*#__PURE__*/ z.enum([
                'provisioning',
                'active',
                'failed',
                'disabled',
                'archived'
            ]).optional(),
            projectId: /*#__PURE__*/ z.number().optional(),
            secretMode: /*#__PURE__*/ z.enum([
                'stored_external_ref',
                'provided_external_ref',
                'managed_provisioning',
                'existing_secret_ref'
            ]).optional(),
            writePolicy: /*#__PURE__*/ z.object({
                mode: /*#__PURE__*/ z.enum(['migrations_only', 'table_writes']).optional(),
                allowSchemaChanges: /*#__PURE__*/ z.boolean().optional(),
                requireReviewGate: /*#__PURE__*/ z.boolean().optional(),
                conflictPolicy: /*#__PURE__*/ z.enum(['do_nothing', 'upsert']).optional(),
                maxRowsPerPart: /*#__PURE__*/ z.int().gt(0).lte(10000).optional(),
                allowedSchemas: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(50).optional(),
                allowedTables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(200).optional()
            }).nullish()
        }).optional(),
        mode: /*#__PURE__*/ z.string().optional(),
        rowCount: /*#__PURE__*/ z.number().optional()
    }).optional().default({}),
    errorMessage: /*#__PURE__*/ z.string().nullable(),
    startedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    completedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeClientDatabaseSnapshot = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    clientDatabaseId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number().nullable(),
    workspaceId: /*#__PURE__*/ z.number().nullable(),
    codeCheckpointId: /*#__PURE__*/ z.number().nullable(),
    migrationId: /*#__PURE__*/ z.number().nullable(),
    snapshotType: /*#__PURE__*/ z.enum([
        'schema_marker',
        'logical_export',
        'manual_marker',
        'config_marker'
    ]),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'available',
        'failed',
        'expired'
    ]),
    schemaHash: /*#__PURE__*/ z.string().nullable(),
    migrationVersion: /*#__PURE__*/ z.string().nullable(),
    artifactId: /*#__PURE__*/ z.number().nullable(),
    payloadUrl: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.object({
        source: /*#__PURE__*/ z.enum([
            'client_db_processor',
            'manual',
            'launch',
            'rollback'
        ]).optional(),
        codeCheckpointId: /*#__PURE__*/ z.number().optional(),
        migrationId: /*#__PURE__*/ z.number().optional(),
        outputDeliveryId: /*#__PURE__*/ z.number().optional(),
        outputPartId: /*#__PURE__*/ z.number().optional(),
        projectChangeId: /*#__PURE__*/ z.number().nullish(),
        migrationFilePath: /*#__PURE__*/ z.string().nullish(),
        migrationFileHash: /*#__PURE__*/ z.string().regex(/^[a-f0-9]{64}$\/i/).nullish(),
        decision: /*#__PURE__*/ z.object({
            action: /*#__PURE__*/ z.enum([
                'configured',
                'enabled',
                'disabled',
                'archived',
                'secret_rotated'
            ]).optional(),
            reason: /*#__PURE__*/ z.string().optional(),
            mode: /*#__PURE__*/ z.enum([
                'missing_scope',
                'needs_target',
                'row_limit_exceeded',
                'byo_payload',
                'target_not_active',
                'unsupported_or_policy_blocked',
                'review_gate_required',
                'queued_table_write',
                'migration_payload',
                'applied',
                'failed',
                'pending',
                'skipped'
            ]).optional(),
            targetId: /*#__PURE__*/ z.number().optional(),
            migrationKind: /*#__PURE__*/ z.enum([
                'schema',
                'seed',
                'table_write',
                'sync_payload'
            ]).optional(),
            schemaName: /*#__PURE__*/ z.string().optional(),
            tableName: /*#__PURE__*/ z.string().optional(),
            rowCount: /*#__PURE__*/ z.number().optional(),
            maxRows: /*#__PURE__*/ z.number().optional(),
            isolationTier: /*#__PURE__*/ z.enum([
                'org_default',
                'project',
                'byo'
            ]).optional(),
            scope: /*#__PURE__*/ z.enum(['organization', 'project']).optional(),
            provider: /*#__PURE__*/ z.enum(['managed_postgres', 'byo_postgres']).optional(),
            status: /*#__PURE__*/ z.enum([
                'provisioning',
                'active',
                'failed',
                'disabled',
                'archived'
            ]).optional(),
            projectId: /*#__PURE__*/ z.number().optional(),
            secretMode: /*#__PURE__*/ z.enum([
                'stored_external_ref',
                'provided_external_ref',
                'managed_provisioning',
                'existing_secret_ref'
            ]).optional(),
            writePolicy: /*#__PURE__*/ z.object({
                mode: /*#__PURE__*/ z.enum(['migrations_only', 'table_writes']).optional(),
                allowSchemaChanges: /*#__PURE__*/ z.boolean().optional(),
                requireReviewGate: /*#__PURE__*/ z.boolean().optional(),
                conflictPolicy: /*#__PURE__*/ z.enum(['do_nothing', 'upsert']).optional(),
                maxRowsPerPart: /*#__PURE__*/ z.int().gt(0).lte(10000).optional(),
                allowedSchemas: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(50).optional(),
                allowedTables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(200).optional()
            }).nullish()
        }).optional(),
        migrationStatus: /*#__PURE__*/ z.enum([
            'pending',
            'applied',
            'failed',
            'skipped'
        ]).optional(),
        errorMessage: /*#__PURE__*/ z.string().optional(),
        rowCount: /*#__PURE__*/ z.number().optional(),
        isolationTier: /*#__PURE__*/ z.enum([
            'org_default',
            'project',
            'byo'
        ]).optional(),
        status: /*#__PURE__*/ z.enum([
            'provisioning',
            'active',
            'failed',
            'disabled',
            'archived'
        ]).optional(),
        note: /*#__PURE__*/ z.string().optional()
    }).optional().default({}),
    createdByActorType: /*#__PURE__*/ z.enum([
        'server',
        'engine',
        'human_user',
        'agent',
        'system'
    ]),
    createdByActorId: /*#__PURE__*/ z.string().nullable(),
    capturedAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeClientDatabaseState = /*#__PURE__*/ z.object({
    database: /*#__PURE__*/ zCodeClientDatabase.nullable(),
    migrations: /*#__PURE__*/ z.array(zCodeClientDatabaseMigration),
    migrationsPageInfo: /*#__PURE__*/ z.object({
        limit: /*#__PURE__*/ z.int().gt(0).lte(200),
        nextCursor: /*#__PURE__*/ z.string().nullable(),
        hasMore: /*#__PURE__*/ z.boolean()
    }),
    snapshots: /*#__PURE__*/ z.array(zCodeClientDatabaseSnapshot),
    snapshotsPageInfo: /*#__PURE__*/ z.object({
        limit: /*#__PURE__*/ z.int().gt(0).lte(200),
        nextCursor: /*#__PURE__*/ z.string().nullable(),
        hasMore: /*#__PURE__*/ z.boolean()
    })
});

export const zCodeClientDatabaseConfigureInput = /*#__PURE__*/ z.object({
    isolationTier: /*#__PURE__*/ z.enum([
        'org_default',
        'project',
        'byo'
    ]).optional().default('org_default'),
    connectionString: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
    connectionSecretRef: /*#__PURE__*/ z.string().min(1).max(1024).optional(),
    connectionSecretProvider: /*#__PURE__*/ z.enum([
        'external_ref',
        'aws_secrets_manager',
        'gcp_secret_manager',
        'vault',
        'local_file',
        'env'
    ]).optional(),
    connectionFingerprint: /*#__PURE__*/ z.string().regex(/^[a-f0-9]{64}$\/i/).optional(),
    databaseName: /*#__PURE__*/ z.string().min(1).max(120).optional(),
    schemaName: /*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/).optional(),
    appRoleName: /*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/).optional(),
    migrationRoleName: /*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/).optional(),
    runtimeUrlEnvVar: /*#__PURE__*/ z.string().min(1).max(120).regex(/^[A-Z][A-Z0-9_]*$/).optional().default('DATABASE_URL'),
    migrationUrlEnvVar: /*#__PURE__*/ z.string().min(1).max(120).regex(/^[A-Z][A-Z0-9_]*$/).optional().default('MIGRATION_DATABASE_URL'),
    writePolicy: /*#__PURE__*/ z.object({
        mode: /*#__PURE__*/ z.enum(['migrations_only', 'table_writes']).optional().default('migrations_only'),
        allowSchemaChanges: /*#__PURE__*/ z.boolean().optional().default(false),
        requireReviewGate: /*#__PURE__*/ z.boolean().optional().default(true),
        conflictPolicy: /*#__PURE__*/ z.enum(['do_nothing', 'upsert']).optional().default('do_nothing'),
        maxRowsPerPart: /*#__PURE__*/ z.int().gt(0).lte(10000).optional().default(500),
        allowedSchemas: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(50).optional(),
        allowedTables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(63).regex(/^[a-z_][a-z0-9_]*$/)).max(200).optional()
    }).optional().default({
        mode: 'migrations_only',
        allowSchemaChanges: false,
        requireReviewGate: true,
        conflictPolicy: 'do_nothing',
        maxRowsPerPart: 500
    }),
    metadata: /*#__PURE__*/ z.object({
        displayName: /*#__PURE__*/ z.string().min(1).max(120).optional(),
        environment: /*#__PURE__*/ z.string().min(1).max(80).optional(),
        notes: /*#__PURE__*/ z.string().max(2000).optional(),
        tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(60)).max(30).optional()
    }).optional().default({})
});

export const zCodeTuningWorkstream = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number(),
    name: /*#__PURE__*/ z.string(),
    description: /*#__PURE__*/ z.string().nullable(),
    focus: /*#__PURE__*/ z.enum([
        'feature',
        'marketing',
        'research',
        'ops',
        'support',
        'general'
    ]),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'archived',
        'completed'
    ]),
    managerAgentId: /*#__PURE__*/ z.number().nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string(),
    deletedAt: /*#__PURE__*/ z.string().nullable()
});

export const zCodeTuningMessage = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    conversationId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.enum([
        'system',
        'user',
        'assistant',
        'tool'
    ]),
    content: /*#__PURE__*/ z.string(),
    contentForReplay: /*#__PURE__*/ z.string().nullable(),
    parts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()),
    createdAt: /*#__PURE__*/ z.string()
});

export const zCodeTuningProjectChangeRevision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number(),
    organizationId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number(),
    sequence: /*#__PURE__*/ z.number(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'generated',
        'validating',
        'validated',
        'failed',
        'superseded'
    ]),
    summary: /*#__PURE__*/ z.string().nullable(),
    patchArtifactId: /*#__PURE__*/ z.number().nullable(),
    validationReportArtifactId: /*#__PURE__*/ z.number().nullable(),
    sourceConversationId: /*#__PURE__*/ z.number().nullable(),
    sourceWorkflowRunId: /*#__PURE__*/ z.number().nullable(),
    sourceTaskIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()).nullable(),
    baseCommitSha: /*#__PURE__*/ z.string().nullable(),
    commitSha: /*#__PURE__*/ z.string().nullable(),
    patchHash: /*#__PURE__*/ z.string().nullable(),
    metadata: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
    createdBy: /*#__PURE__*/ z.number().nullable(),
    createdAt: /*#__PURE__*/ z.string(),
    updatedAt: /*#__PURE__*/ z.string()
});

export const zCodeTuningView = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.number(),
    workstream: zCodeTuningWorkstream,
    conversation: /*#__PURE__*/ zCodeTuningConversation.nullable(),
    messages: /*#__PURE__*/ z.array(zCodeTuningMessage),
    latestVersion: zCodeTuningVersion,
    versions: /*#__PURE__*/ z.array(zCodeTuningVersionSummary),
    changeRevisions: /*#__PURE__*/ z.array(zCodeTuningProjectChangeRevision),
    meta: /*#__PURE__*/ z.object({
        serverTime: /*#__PURE__*/ z.string()
    })
});

export const zCodeWorkforceEnable = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.number(),
    workstreamId: /*#__PURE__*/ z.number(),
    pmAgentId: /*#__PURE__*/ z.number(),
    pmMemberId: /*#__PURE__*/ z.number(),
    created: /*#__PURE__*/ z.boolean(),
    activityResourceId: /*#__PURE__*/ z.number().nullable(),
    activityCreated: /*#__PURE__*/ z.boolean()
});

export const zCodeGenerationRunQueued = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string().min(1),
    workflowId: /*#__PURE__*/ z.string().min(1),
    status: /*#__PURE__*/ z.enum(['pending']),
    projectId: /*#__PURE__*/ z.number(),
    workstreamId: /*#__PURE__*/ z.number(),
    projectChangeId: /*#__PURE__*/ z.number(),
    projectThreadId: /*#__PURE__*/ z.number()
});

export const zCodeGenerationRunCreateInput = /*#__PURE__*/ z.object({
    codegenConfig: /*#__PURE__*/ z.object({
        manifest: /*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string().min(1),
            displayName: /*#__PURE__*/ z.string().min(1),
            description: /*#__PURE__*/ z.string().optional(),
            icon: /*#__PURE__*/ z.string().optional(),
            navOrder: /*#__PURE__*/ z.int().optional(),
            status: /*#__PURE__*/ z.enum([
                'active',
                'preview',
                'archived'
            ]),
            policies: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
            nav: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).optional(),
            dependsOn: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional()
        }),
        entities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            id: /*#__PURE__*/ z.string().min(1),
            displayName: /*#__PURE__*/ z.string().min(1),
            kind: /*#__PURE__*/ z.enum([
                'list',
                'transactional',
                'enum'
            ]),
            description: /*#__PURE__*/ z.string().optional()
        })),
        tables: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            name: /*#__PURE__*/ z.string().min(1),
            schema: /*#__PURE__*/ z.string().optional(),
            columns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                name: /*#__PURE__*/ z.string().min(1),
                type: /*#__PURE__*/ z.enum([
                    'text',
                    'integer',
                    'bigint',
                    'boolean',
                    'timestamp',
                    'jsonb',
                    'numeric',
                    'pgEnum'
                ]),
                nullable: /*#__PURE__*/ z.boolean().optional(),
                defaultValue: /*#__PURE__*/ z.string().optional(),
                sensitivity: /*#__PURE__*/ z.enum([
                    'pii',
                    'phi',
                    'privileged',
                    'restricted'
                ]).optional(),
                pgEnumValues: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).optional(),
                references: /*#__PURE__*/ z.object({
                    table: /*#__PURE__*/ z.string().min(1),
                    column: /*#__PURE__*/ z.string().min(1),
                    onDelete: /*#__PURE__*/ z.enum([
                        'cascade',
                        'set null',
                        'restrict'
                    ]).optional()
                }).optional(),
                primaryKey: /*#__PURE__*/ z.boolean().optional(),
                unique: /*#__PURE__*/ z.boolean().optional()
            })).min(1),
            indexes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                name: /*#__PURE__*/ z.string().min(1),
                columns: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1)).min(1),
                unique: /*#__PURE__*/ z.boolean().optional()
            })).optional(),
            rls: /*#__PURE__*/ z.object({
                orgScoped: /*#__PURE__*/ z.boolean()
            }).optional()
        })),
        routes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            entityId: /*#__PURE__*/ z.string().min(1),
            operation: /*#__PURE__*/ z.enum([
                'list',
                'get',
                'create',
                'update',
                'delete',
                'action'
            ]),
            path: /*#__PURE__*/ z.string().min(1),
            method: /*#__PURE__*/ z.enum([
                'GET',
                'POST',
                'PATCH',
                'DELETE'
            ]),
            operationId: /*#__PURE__*/ z.string().min(1),
            policy: /*#__PURE__*/ z.string().min(1),
            actionName: /*#__PURE__*/ z.string().optional()
        })),
        pages: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            entityId: /*#__PURE__*/ z.string().min(1),
            type: /*#__PURE__*/ z.enum([
                'list',
                'detail',
                'new'
            ]),
            fields: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                name: /*#__PURE__*/ z.string().min(1),
                label: /*#__PURE__*/ z.string().min(1),
                helpText: /*#__PURE__*/ z.string().optional()
            }))
        })),
        stack: /*#__PURE__*/ z.object({
            frontend: /*#__PURE__*/ z.string().min(1),
            backend: /*#__PURE__*/ z.string().min(1),
            database: /*#__PURE__*/ z.string().min(1),
            runtime: /*#__PURE__*/ z.string().min(1),
            packageManager: /*#__PURE__*/ z.string().min(1).optional(),
            repoShape: /*#__PURE__*/ z.string().min(1).optional()
        }).optional(),
        mockData: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.array(/*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()))).optional()
    }),
    sourceArtifacts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.enum([
            'code_idea_brief',
            'code_requirements_pack',
            'code_ux_plan',
            'code_architecture_plan',
            'code_data_model',
            'code_module_selection_plan',
            'codegen_manifest',
            'code_ui_plan',
            'code_ui_source',
            'code_ui_runtime_source',
            'code_ui_dashboard_source',
            'code_ui_bootstrap_source',
            'code_ui_app_source',
            'code_ui_styles_source',
            'code_backend_plan',
            'code_backend_source',
            'code_backend_api_source',
            'code_backend_data_source',
            'code_backend_runtime_source',
            'code_migration_plan',
            'code_database_pass',
            'code_ui_pass',
            'code_backend_pass',
            'code_integration_report',
            'code_validation_report',
            'code_security_review_report',
            'code_quality_review_report',
            'code_review_gate_decision',
            'code_approval_request',
            'code_approval_decision',
            'code_remediation_plan',
            'code_launch_report',
            'code_incident_report'
        ]),
        status: /*#__PURE__*/ z.enum([
            'draft',
            'ready',
            'blocked',
            'superseded'
        ]).optional().default('ready'),
        title: /*#__PURE__*/ z.string().min(1),
        artifactId: /*#__PURE__*/ z.int().gt(0).optional(),
        workOutputId: /*#__PURE__*/ z.int().gt(0).optional(),
        outputPartId: /*#__PURE__*/ z.int().gt(0).optional(),
        workflowRunId: /*#__PURE__*/ z.int().gt(0).optional(),
        taskId: /*#__PURE__*/ z.int().gt(0).optional(),
        summary: /*#__PURE__*/ z.string().min(1).max(2000).optional(),
        producedBy: /*#__PURE__*/ z.string().min(1).optional()
    })).min(1),
    title: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    summary: /*#__PURE__*/ z.string().max(2000).optional(),
    mode: /*#__PURE__*/ z.enum([
        'mock',
        'real',
        'mixed'
    ]).optional().default('mock'),
    emitSchemaLayer: /*#__PURE__*/ z.boolean().optional(),
    emitServerLayer: /*#__PURE__*/ z.boolean().optional(),
    emitFrontend: /*#__PURE__*/ z.boolean().optional(),
    targetRepo: /*#__PURE__*/ z.string().min(1).max(2000).optional(),
    baseCommitSha: /*#__PURE__*/ z.string().min(1).max(80).optional()
});

export const zCodeReviewRequestSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    gateType: /*#__PURE__*/ z.enum([
        'codegen_review',
        'plan',
        'ui',
        'database',
        'backend',
        'integration',
        'launch',
        'catalog_promotion',
        'platform_change'
    ]),
    actionType: /*#__PURE__*/ z.enum(['codegen:promote']),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'request_changes',
        'expired',
        'superseded'
    ]),
    workOutputId: /*#__PURE__*/ z.int().gt(0),
    subjectKind: /*#__PURE__*/ z.string().min(1),
    subjectId: /*#__PURE__*/ z.string().min(1),
    subjectVersionHash: /*#__PURE__*/ z.string().nullable(),
    requestedByUserId: /*#__PURE__*/ z.int().gt(0),
    requestedAt: /*#__PURE__*/ z.iso.datetime(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    reviewer: /*#__PURE__*/ z.object({
        actorPlane: /*#__PURE__*/ z.enum([
            'system_daemon',
            'workforce_member',
            'human_user',
            'service_account'
        ]),
        actorKey: /*#__PURE__*/ z.string().nullable(),
        resolvedUserId: /*#__PURE__*/ z.int().gt(0).nullable(),
        delegatedFromUserId: /*#__PURE__*/ z.int().gt(0).nullable(),
        label: /*#__PURE__*/ z.string().nullable()
    }),
    decision: /*#__PURE__*/ z.object({
        action: /*#__PURE__*/ z.enum([
            'approve',
            'reject',
            'request_changes',
            'accept_risk'
        ]),
        decidedByUserId: /*#__PURE__*/ z.int().gt(0),
        decidedAt: /*#__PURE__*/ z.iso.datetime(),
        rationale: /*#__PURE__*/ z.string().nullable(),
        reasonCode: /*#__PURE__*/ z.string().nullable(),
        riskAcceptedUntil: /*#__PURE__*/ z.iso.datetime().nullable()
    }).nullable(),
    versionSnapshot: /*#__PURE__*/ z.object({
        title: /*#__PURE__*/ z.string().min(1),
        summary: /*#__PURE__*/ z.string().nullable(),
        validationStatus: /*#__PURE__*/ z.enum([
            'passing',
            'warning',
            'blocked'
        ]).nullable(),
        patchHash: /*#__PURE__*/ z.string().nullable(),
        previewRoute: /*#__PURE__*/ z.string().nullable(),
        outputUpdatedAt: /*#__PURE__*/ z.iso.datetime().nullable()
    }),
    createdRevisionId: /*#__PURE__*/ z.int().gt(0).nullable()
});

export const zCodeReviewRequestList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCodeReviewRequestSummary),
    pageInfo: /*#__PURE__*/ z.object({
        hasNextPage: /*#__PURE__*/ z.boolean(),
        endCursor: /*#__PURE__*/ z.string().nullable()
    })
});

export const zCodeReviewRequest = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    gateType: /*#__PURE__*/ z.enum([
        'codegen_review',
        'plan',
        'ui',
        'database',
        'backend',
        'integration',
        'launch',
        'catalog_promotion',
        'platform_change'
    ]),
    actionType: /*#__PURE__*/ z.enum(['codegen:promote']),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'request_changes',
        'expired',
        'superseded'
    ]),
    workOutputId: /*#__PURE__*/ z.int().gt(0),
    subjectKind: /*#__PURE__*/ z.string().min(1),
    subjectId: /*#__PURE__*/ z.string().min(1),
    subjectVersionHash: /*#__PURE__*/ z.string().nullable(),
    requestedByUserId: /*#__PURE__*/ z.int().gt(0),
    requestedAt: /*#__PURE__*/ z.iso.datetime(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().nullable(),
    reviewer: /*#__PURE__*/ z.object({
        actorPlane: /*#__PURE__*/ z.enum([
            'system_daemon',
            'workforce_member',
            'human_user',
            'service_account'
        ]),
        actorKey: /*#__PURE__*/ z.string().nullable(),
        resolvedUserId: /*#__PURE__*/ z.int().gt(0).nullable(),
        delegatedFromUserId: /*#__PURE__*/ z.int().gt(0).nullable(),
        label: /*#__PURE__*/ z.string().nullable()
    }),
    decision: /*#__PURE__*/ z.object({
        action: /*#__PURE__*/ z.enum([
            'approve',
            'reject',
            'request_changes',
            'accept_risk'
        ]),
        decidedByUserId: /*#__PURE__*/ z.int().gt(0),
        decidedAt: /*#__PURE__*/ z.iso.datetime(),
        rationale: /*#__PURE__*/ z.string().nullable(),
        reasonCode: /*#__PURE__*/ z.string().nullable(),
        riskAcceptedUntil: /*#__PURE__*/ z.iso.datetime().nullable()
    }).nullable(),
    versionSnapshot: /*#__PURE__*/ z.object({
        title: /*#__PURE__*/ z.string().min(1),
        summary: /*#__PURE__*/ z.string().nullable(),
        validationStatus: /*#__PURE__*/ z.enum([
            'passing',
            'warning',
            'blocked'
        ]).nullable(),
        patchHash: /*#__PURE__*/ z.string().nullable(),
        previewRoute: /*#__PURE__*/ z.string().nullable(),
        outputUpdatedAt: /*#__PURE__*/ z.iso.datetime().nullable()
    }),
    createdRevisionId: /*#__PURE__*/ z.int().gt(0).nullable(),
    organizationId: /*#__PURE__*/ z.int().gt(0),
    projectId: /*#__PURE__*/ z.int().gt(0),
    workstreamId: /*#__PURE__*/ z.int().gt(0),
    projectChangeId: /*#__PURE__*/ z.int().gt(0),
    projectThreadId: /*#__PURE__*/ z.int().gt(0).nullable(),
    requiredReviewerClass: /*#__PURE__*/ z.string().nullable(),
    separationOfDutiesKey: /*#__PURE__*/ z.string().nullable(),
    blockedReasons: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
    evidence: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0),
        reviewRequestId: /*#__PURE__*/ z.int().gt(0),
        sourceType: /*#__PURE__*/ z.enum([
            'daemon_run',
            'daemon_finding',
            'work_output',
            'output_part',
            'workflow_run',
            'artifact',
            'task',
            'project_change_revision',
            'manual_note'
        ]),
        sourceId: /*#__PURE__*/ z.string().min(1),
        evidenceKind: /*#__PURE__*/ z.string().min(1),
        actorPlane: /*#__PURE__*/ z.enum([
            'system_daemon',
            'workforce_member',
            'human_user',
            'service_account'
        ]),
        actorKey: /*#__PURE__*/ z.string().nullable(),
        actorSlug: /*#__PURE__*/ z.string().nullable(),
        actorProfileSlug: /*#__PURE__*/ z.string().nullable(),
        trustScope: /*#__PURE__*/ z.enum([
            'system',
            'org',
            'project'
        ]),
        subjectKind: /*#__PURE__*/ z.string().min(1),
        subjectId: /*#__PURE__*/ z.string().min(1),
        subjectVersionHash: /*#__PURE__*/ z.string().nullable(),
        status: /*#__PURE__*/ z.string().nullable(),
        severity: /*#__PURE__*/ z.enum([
            'info',
            'low',
            'medium',
            'high',
            'critical'
        ]).nullable(),
        summary: /*#__PURE__*/ z.string().nullable(),
        reviewSummary: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
        rawEvidenceAvailable: /*#__PURE__*/ z.boolean(),
        createdAt: /*#__PURE__*/ z.iso.datetime()
    })),
    createdAt: /*#__PURE__*/ z.iso.datetime(),
    updatedAt: /*#__PURE__*/ z.iso.datetime()
});

export const zCodeReviewGateConflict = /*#__PURE__*/ z.object({
    code: /*#__PURE__*/ z.enum([
        'PROJECT_CODE_REVIEW_ALREADY_PENDING',
        'PROJECT_CODE_REVIEW_REQUIRED',
        'PROJECT_CODE_REVIEW_NOT_PENDING',
        'PROJECT_CODE_REVIEW_EXPIRED',
        'PROJECT_CODE_REVIEW_PERSONA_MISSING'
    ]),
    message: /*#__PURE__*/ z.string(),
    field: /*#__PURE__*/ z.string().optional()
});

export const zCodeReviewRequestCreate = /*#__PURE__*/ z.object({
    reviewerUserId: /*#__PURE__*/ z.int().gt(0),
    note: /*#__PURE__*/ z.string().max(2000).nullish(),
    expiresAt: /*#__PURE__*/ z.iso.datetime().nullish()
});

export const zCodeReviewRequestDecisionInput = /*#__PURE__*/ z.object({
    action: /*#__PURE__*/ z.enum([
        'approve',
        'reject',
        'request_changes',
        'accept_risk'
    ]),
    rationale: /*#__PURE__*/ z.string().max(4000).nullish(),
    reasonCode: /*#__PURE__*/ z.string().max(120).nullish(),
    riskAcceptedUntil: /*#__PURE__*/ z.iso.datetime().nullish()
});

export const zCodePreviewSessionCapabilities = /*#__PURE__*/ z.object({
    hotReload: /*#__PURE__*/ z.boolean(),
    reconnectable: /*#__PURE__*/ z.boolean(),
    backendPreview: /*#__PURE__*/ z.boolean()
});

export const zCodePreviewSession = /*#__PURE__*/ z.object({
    sessionId: /*#__PURE__*/ z.string(),
    projectId: /*#__PURE__*/ z.number(),
    workstreamId: /*#__PURE__*/ z.number(),
    versionId: /*#__PURE__*/ z.number(),
    mode: /*#__PURE__*/ z.enum([
        'mock',
        'real',
        'mixed'
    ]),
    status: /*#__PURE__*/ z.enum([
        'booting',
        'rehydrating',
        'ready',
        'blocked',
        'expired'
    ]),
    previewUrl: /*#__PURE__*/ z.string(),
    eventsUrl: /*#__PURE__*/ z.string(),
    heartbeatUrl: /*#__PURE__*/ z.string(),
    expiresAt: /*#__PURE__*/ z.string(),
    capabilities: zCodePreviewSessionCapabilities
});

export const zRateLimitExceeded = /*#__PURE__*/ z.object({
    error: /*#__PURE__*/ z.object({
        code: /*#__PURE__*/ z.enum(['RATE_LIMIT_EXCEEDED']),
        message: /*#__PURE__*/ z.string()
    })
});

export const zCodePreviewSessionCreateBody = /*#__PURE__*/ z.object({
    versionId: /*#__PURE__*/ z.int().gt(0).optional(),
    mode: /*#__PURE__*/ z.enum([
        'mock',
        'real',
        'mixed'
    ]).optional()
});

export const zCodePreviewSessionDispose = /*#__PURE__*/ z.object({
    sessionId: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.enum(['expired'])
});

export const zCodeWorkspaceWebhookResult = /*#__PURE__*/ z.object({
    accepted: /*#__PURE__*/ z.boolean(),
    ignored: /*#__PURE__*/ z.boolean(),
    queuedOperationId: /*#__PURE__*/ z.number().nullable()
});

export const zApiDecision = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string().nullable(),
    actionType: /*#__PURE__*/ z.string(),
    raisedByMe: /*#__PURE__*/ z.boolean().optional(),
    eligibleApprovers: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        userId: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string().nullable(),
        department: /*#__PURE__*/ z.string().nullable()
    })).optional(),
    status: /*#__PURE__*/ z.string().optional(),
    decidedAt: /*#__PURE__*/ z.string().nullish(),
    applied: /*#__PURE__*/ z.unknown().optional()
});

export const zApiPaging = /*#__PURE__*/ z.object({
    cursors: /*#__PURE__*/ z.object({
        before: /*#__PURE__*/ z.string().nullable(),
        after: /*#__PURE__*/ z.string().nullable()
    }),
    hasMore: /*#__PURE__*/ z.boolean(),
    next: /*#__PURE__*/ z.string().nullable()
});

export const zApiMeta = /*#__PURE__*/ z.object({
    serverTime: /*#__PURE__*/ z.string(),
    total: /*#__PURE__*/ z.int().gte(0).optional()
});

export const zApiDecisionList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zApiDecision),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiError = /*#__PURE__*/ z.object({
    code: /*#__PURE__*/ z.string(),
    message: /*#__PURE__*/ z.string(),
    field: /*#__PURE__*/ z.string().optional()
});

export const zApiDecisionReview = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string().nullish(),
    state: /*#__PURE__*/ z.enum([
        'approved',
        'rejected',
        'already_decided',
        'refused'
    ]),
    status: /*#__PURE__*/ z.string().optional(),
    appliedSummary: /*#__PURE__*/ z.string().optional(),
    createdIds: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    applyFailed: /*#__PURE__*/ z.string().optional(),
    reason: /*#__PURE__*/ z.string().optional()
});

export const zApiDecisionReviewResult = /*#__PURE__*/ z.object({
    data: zApiDecisionReview,
    meta: zApiMeta
});

export const zApiDecisionApproveRequest = /*#__PURE__*/ z.object({
    note: /*#__PURE__*/ z.string().min(1).max(2000).optional()
});

export const zApiDecisionRejectRequest = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().min(1).max(2000)
});

export const zApiOutputPart = /*#__PURE__*/ z.object({
    part: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        kind: /*#__PURE__*/ z.string(),
        title: /*#__PURE__*/ z.string().nullable(),
        runId: /*#__PURE__*/ z.string().nullable(),
        workflowId: /*#__PURE__*/ z.string().nullable(),
        mimeType: /*#__PURE__*/ z.string().nullable(),
        payloadUrl: /*#__PURE__*/ z.string().nullable(),
        sizeBytes: /*#__PURE__*/ z.int().gte(0),
        createdAt: /*#__PURE__*/ z.string()
    }),
    payload: /*#__PURE__*/ z.unknown().optional(),
    excerpt: /*#__PURE__*/ z.unknown().optional(),
    artifactId: /*#__PURE__*/ z.string().nullish()
});

export const zApiOutputPartResult = /*#__PURE__*/ z.object({
    data: zApiOutputPart,
    meta: zApiMeta
});

export const zApiDashboard = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    url: /*#__PURE__*/ z.string(),
    widgetCount: /*#__PURE__*/ z.int().gte(0),
    widgets: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        position: /*#__PURE__*/ z.number(),
        title: /*#__PURE__*/ z.string().nullable(),
        type: /*#__PURE__*/ z.string(),
        kind: /*#__PURE__*/ z.string().nullable(),
        config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        data: /*#__PURE__*/ z.unknown().optional()
    }))
});

export const zApiDashboardResult = /*#__PURE__*/ z.object({
    data: zApiDashboard,
    meta: zApiMeta
});

export const zApiIntelSourceSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    platform: /*#__PURE__*/ z.string().nullable(),
    following: /*#__PURE__*/ z.boolean()
});

export const zApiIntelSourceList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zApiIntelSourceSummary),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiIntelSourceItem = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    publishedAt: /*#__PURE__*/ z.string(),
    analyzed: /*#__PURE__*/ z.boolean(),
    insights: /*#__PURE__*/ z.int().gte(0)
});

export const zApiIntelSourceItemList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zApiIntelSourceItem),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiDecisionCancel = /*#__PURE__*/ z.object({
    decisionId: /*#__PURE__*/ z.string(),
    cancelled: /*#__PURE__*/ z.literal(true)
});

export const zApiDecisionCancelResult = /*#__PURE__*/ z.object({
    data: zApiDecisionCancel,
    meta: zApiMeta
});

export const zApiStrategySummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    stage: /*#__PURE__*/ z.string()
});

export const zApiStrategyList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zApiStrategySummary),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiStrategy = /*#__PURE__*/ z.object({
    strategy: zApiStrategySummary,
    metrics: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
    regimes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()),
    robustAcrossRegimes: /*#__PURE__*/ z.boolean().nullable(),
    robustness: /*#__PURE__*/ z.string().optional(),
    template: /*#__PURE__*/ z.unknown().optional(),
    parameters: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).optional(),
    definition: /*#__PURE__*/ z.unknown().optional(),
    readiness: /*#__PURE__*/ z.unknown().optional(),
    verdict: /*#__PURE__*/ z.string()
});

export const zApiStrategyResult = /*#__PURE__*/ z.object({
    data: zApiStrategy,
    meta: zApiMeta
});

export const zApiStrategyBucketSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    name: /*#__PURE__*/ z.string(),
    legs: /*#__PURE__*/ z.int().gte(0)
});

export const zApiStrategyBucketList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zApiStrategyBucketSummary),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiStrategyBucket = /*#__PURE__*/ z.object({
    bucket: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        mode: /*#__PURE__*/ z.string().nullable()
    }),
    legs: /*#__PURE__*/ z.int().gte(0),
    legDetails: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        strategyId: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        role: /*#__PURE__*/ z.string().nullable(),
        direction: /*#__PURE__*/ z.string().nullable(),
        weight: /*#__PURE__*/ z.number().nullable(),
        status: /*#__PURE__*/ z.string().nullable(),
        bestRegime: /*#__PURE__*/ z.string().nullable(),
        latestBacktest: /*#__PURE__*/ z.object({
            runId: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.string(),
                /*#__PURE__*/ z.number()
            ]).nullable(),
            sharpe: /*#__PURE__*/ z.number().nullable(),
            maxDrawdownPct: /*#__PURE__*/ z.number().nullable(),
            trades: /*#__PURE__*/ z.number().nullable()
        }).nullable()
    }))
});

export const zApiStrategyBucketResult = /*#__PURE__*/ z.object({
    data: zApiStrategyBucket,
    meta: zApiMeta
});

export const zApiBacktestComparison = /*#__PURE__*/ z.object({
    items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        found: /*#__PURE__*/ z.boolean(),
        strategy: /*#__PURE__*/ z.string().nullable(),
        status: /*#__PURE__*/ z.string().nullable(),
        mode: /*#__PURE__*/ z.string().nullable(),
        timeframe: /*#__PURE__*/ z.string().nullable(),
        window: /*#__PURE__*/ z.object({
            from: /*#__PURE__*/ z.string().nullable(),
            to: /*#__PURE__*/ z.string().nullable()
        }).nullable(),
        metrics: /*#__PURE__*/ z.object({
            sharpe: /*#__PURE__*/ z.number().nullable(),
            maxDrawdownPct: /*#__PURE__*/ z.number().nullable(),
            trades: /*#__PURE__*/ z.number().nullable(),
            winRatePct: /*#__PURE__*/ z.number().nullish()
        }).nullable(),
        stats: /*#__PURE__*/ z.object({
            sortino: /*#__PURE__*/ z.number().nullable(),
            totalReturnPct: /*#__PURE__*/ z.number().nullable(),
            probabilisticSharpe: /*#__PURE__*/ z.number().nullable(),
            deflatedSharpe: /*#__PURE__*/ z.number().nullable(),
            pbo: /*#__PURE__*/ z.number().nullable(),
            walkForwardEfficiency: /*#__PURE__*/ z.number().nullable(),
            researchOnly: /*#__PURE__*/ z.boolean().nullable(),
            verdict: /*#__PURE__*/ z.string().nullable()
        }).nullable(),
        series: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.int().gte(0))
    })),
    leaders: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string().nullable())
});

export const zApiBacktestComparisonResult = /*#__PURE__*/ z.object({
    data: zApiBacktestComparison,
    meta: zApiMeta
});

export const zApiMarketRegime = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    timeframe: /*#__PURE__*/ z.string(),
    axis: /*#__PURE__*/ z.string(),
    regime: /*#__PURE__*/ z.string(),
    confidence: /*#__PURE__*/ z.number().nullable(),
    asOf: /*#__PURE__*/ z.string(),
    features: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable()
});

export const zApiMarketRegimeList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zApiMarketRegime),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiBacktestSummary = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    title: /*#__PURE__*/ z.string(),
    strategy: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    mode: /*#__PURE__*/ z.string(),
    scope: /*#__PURE__*/ z.string(),
    usingDbCandles: /*#__PURE__*/ z.boolean().nullable(),
    ranAt: /*#__PURE__*/ z.string().nullable(),
    sharpe: /*#__PURE__*/ z.number().nullable(),
    maxDrawdownPct: /*#__PURE__*/ z.number().nullable(),
    trades: /*#__PURE__*/ z.number().nullable()
});

export const zApiBacktestList = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zApiBacktestSummary),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiBacktestRun = /*#__PURE__*/ z.object({
    queued: /*#__PURE__*/ z.boolean(),
    reused: /*#__PURE__*/ z.boolean().optional(),
    run: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        finishedAt: /*#__PURE__*/ z.string().nullish(),
        sharpe: /*#__PURE__*/ z.number().nullish(),
        maxDrawdown: /*#__PURE__*/ z.number().nullish()
    }).optional(),
    status: /*#__PURE__*/ z.string().optional(),
    mode: /*#__PURE__*/ z.string().optional(),
    requestId: /*#__PURE__*/ z.string().optional(),
    window: /*#__PURE__*/ z.object({
        from: /*#__PURE__*/ z.string(),
        to: /*#__PURE__*/ z.string()
    }).optional(),
    timeframe: /*#__PURE__*/ z.string().optional(),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    exchange: /*#__PURE__*/ z.string().optional()
});

export const zApiBacktestRunResult = /*#__PURE__*/ z.object({
    data: zApiBacktestRun,
    meta: zApiMeta
});

export const zApiBacktestCreate = /*#__PURE__*/ z.object({
    mode: /*#__PURE__*/ z.enum([
        'backtest',
        'walk_forward',
        'parameter_sweep',
        'robustness'
    ]).optional().default('backtest'),
    symbols: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(40)).min(1).max(100).optional(),
    universe: /*#__PURE__*/ z.enum([
        'nasdaq100',
        'sp500',
        'crypto_top'
    ]).optional(),
    timeframe: /*#__PURE__*/ z.string().regex(/^\d+(m|h|d|w|M)$/).optional(),
    from: /*#__PURE__*/ z.string().min(1).optional(),
    to: /*#__PURE__*/ z.string().min(1).optional(),
    exchange: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    searchSpace: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.object({
        low: /*#__PURE__*/ z.number().optional(),
        high: /*#__PURE__*/ z.number().optional(),
        type: /*#__PURE__*/ z.enum(['int', 'float']).optional(),
        choices: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()])).min(1).optional()
    })).optional(),
    maxTrials: /*#__PURE__*/ z.int().gte(2).lte(200).optional(),
    variants: /*#__PURE__*/ z.int().gte(2).lte(500).optional(),
    paramSet: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string().max(200),
        /*#__PURE__*/ z.boolean()
    ])).optional(),
    strategyId: /*#__PURE__*/ z.string().regex(/^(def|run):\d+$/)
});

export const zApiBacktest = /*#__PURE__*/ z.object({
    backtest: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        mode: /*#__PURE__*/ z.string(),
        scope: /*#__PURE__*/ z.string(),
        usingDbCandles: /*#__PURE__*/ z.boolean().nullable(),
        window: /*#__PURE__*/ z.object({
            from: /*#__PURE__*/ z.string().nullable(),
            to: /*#__PURE__*/ z.string().nullable()
        }),
        timeframe: /*#__PURE__*/ z.string(),
        metrics: /*#__PURE__*/ z.object({
            sharpe: /*#__PURE__*/ z.number().nullable(),
            maxDrawdownPct: /*#__PURE__*/ z.number().nullable(),
            trades: /*#__PURE__*/ z.number().nullable(),
            winRatePct: /*#__PURE__*/ z.number().nullish()
        }),
        stats: /*#__PURE__*/ z.object({
            sortino: /*#__PURE__*/ z.number().nullable(),
            totalReturnPct: /*#__PURE__*/ z.number().nullable(),
            probabilisticSharpe: /*#__PURE__*/ z.number().nullable(),
            deflatedSharpe: /*#__PURE__*/ z.number().nullable(),
            pbo: /*#__PURE__*/ z.number().nullable(),
            walkForwardEfficiency: /*#__PURE__*/ z.number().nullable(),
            researchOnly: /*#__PURE__*/ z.boolean().nullable(),
            verdict: /*#__PURE__*/ z.string().nullable()
        }).nullable(),
        benchmark: /*#__PURE__*/ z.object({
            symbol: /*#__PURE__*/ z.string(),
            defaulted: /*#__PURE__*/ z.boolean(),
            strategyReturn: /*#__PURE__*/ z.number().nullable(),
            benchmarkReturn: /*#__PURE__*/ z.number().nullable(),
            excessReturn: /*#__PURE__*/ z.number().nullable(),
            universeBuyHoldReturn: /*#__PURE__*/ z.number().nullable()
        }).nullable()
    }),
    scores: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        scoreType: /*#__PURE__*/ z.string(),
        regime: /*#__PURE__*/ z.string(),
        value: /*#__PURE__*/ z.number(),
        uncertainty: /*#__PURE__*/ z.number(),
        skillProb: /*#__PURE__*/ z.number().nullable(),
        skillProbSource: /*#__PURE__*/ z.string().nullable(),
        pboPassed: /*#__PURE__*/ z.boolean().nullable(),
        sampleSize: /*#__PURE__*/ z.number().nullable(),
        status: /*#__PURE__*/ z.string(),
        computedAt: /*#__PURE__*/ z.string()
    })),
    series: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.int().gte(0))
});

export const zApiBacktestResult = /*#__PURE__*/ z.object({
    data: zApiBacktest,
    meta: zApiMeta
});

export const zApiBacktestSeriesPage = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiBacktestAnalytics = /*#__PURE__*/ z.object({
    schemaVersion: /*#__PURE__*/ z.enum(['finance-run-analytics/v1']),
    runId: /*#__PURE__*/ z.string(),
    initialCapital: /*#__PURE__*/ z.number(),
    periodsPerYear: /*#__PURE__*/ z.number().nullable(),
    bars: /*#__PURE__*/ z.int().gte(0),
    firstBar: /*#__PURE__*/ z.string().nullable(),
    lastBar: /*#__PURE__*/ z.string().nullable(),
    keyStats: /*#__PURE__*/ z.object({
        netProfit: /*#__PURE__*/ z.number(),
        netProfitPct: /*#__PURE__*/ z.number().nullable(),
        maxDrawdown: /*#__PURE__*/ z.number(),
        maxDrawdownPct: /*#__PURE__*/ z.number(),
        closedTrades: /*#__PURE__*/ z.int().gte(0),
        openTrades: /*#__PURE__*/ z.int().gte(0),
        profitableTrades: /*#__PURE__*/ z.int().gte(0),
        profitablePct: /*#__PURE__*/ z.number().nullable(),
        profitFactor: /*#__PURE__*/ z.number().nullable()
    }),
    returns: /*#__PURE__*/ z.object({
        totalReturn: /*#__PURE__*/ z.number().nullable(),
        cagr: /*#__PURE__*/ z.number().nullable(),
        sharpe: /*#__PURE__*/ z.number().nullable(),
        sortino: /*#__PURE__*/ z.number().nullable(),
        volatilityAnnual: /*#__PURE__*/ z.number().nullable()
    }),
    periodical: /*#__PURE__*/ z.object({
        daily: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        weekly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        monthly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        quarterly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional(),
        yearly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            start: /*#__PURE__*/ z.string(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number().nullable()
        })).optional()
    }),
    benchmarking: /*#__PURE__*/ z.object({
        buyHoldReturn: /*#__PURE__*/ z.number(),
        outperformance: /*#__PURE__*/ z.number(),
        monthlyCorrelation: /*#__PURE__*/ z.number().nullable(),
        monthly: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            period: /*#__PURE__*/ z.string(),
            strategy: /*#__PURE__*/ z.number().nullable(),
            buyHold: /*#__PURE__*/ z.number().nullable()
        }))
    }).nullable(),
    exposure: /*#__PURE__*/ z.object({
        average: /*#__PURE__*/ z.number(),
        max: /*#__PURE__*/ z.number(),
        timeInMarket: /*#__PURE__*/ z.number()
    }).nullable(),
    growthAndDecline: /*#__PURE__*/ z.object({
        runUps: /*#__PURE__*/ z.object({
            count: /*#__PURE__*/ z.int().gte(0),
            averageBars: /*#__PURE__*/ z.number().nullable(),
            maxAmount: /*#__PURE__*/ z.number().nullable(),
            maxPct: /*#__PURE__*/ z.number().nullable(),
            averageAmount: /*#__PURE__*/ z.number().nullable(),
            averagePct: /*#__PURE__*/ z.number().nullable(),
            currentAmount: /*#__PURE__*/ z.number().nullable(),
            currentPct: /*#__PURE__*/ z.number().nullable()
        }),
        drawdowns: /*#__PURE__*/ z.object({
            count: /*#__PURE__*/ z.int().gte(0),
            averageBars: /*#__PURE__*/ z.number().nullable(),
            maxAmount: /*#__PURE__*/ z.number().nullable(),
            maxPct: /*#__PURE__*/ z.number().nullable(),
            averageAmount: /*#__PURE__*/ z.number().nullable(),
            averagePct: /*#__PURE__*/ z.number().nullable(),
            currentAmount: /*#__PURE__*/ z.number().nullable(),
            currentPct: /*#__PURE__*/ z.number().nullable()
        }),
        maxDrawdownPctOfInitial: /*#__PURE__*/ z.number(),
        episodes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            kind: /*#__PURE__*/ z.enum(['run_up', 'drawdown']),
            start: /*#__PURE__*/ z.string(),
            end: /*#__PURE__*/ z.string(),
            amount: /*#__PURE__*/ z.number(),
            pct: /*#__PURE__*/ z.number(),
            bars: /*#__PURE__*/ z.int().gte(0),
            current: /*#__PURE__*/ z.boolean()
        }))
    }),
    profitsAndLosses: /*#__PURE__*/ z.object({
        long: /*#__PURE__*/ z.object({
            trades: /*#__PURE__*/ z.int().gte(0),
            netProfit: /*#__PURE__*/ z.number(),
            grossProfit: /*#__PURE__*/ z.number(),
            grossLoss: /*#__PURE__*/ z.number(),
            winners: /*#__PURE__*/ z.int().gte(0)
        }),
        short: /*#__PURE__*/ z.object({
            trades: /*#__PURE__*/ z.int().gte(0),
            netProfit: /*#__PURE__*/ z.number(),
            grossProfit: /*#__PURE__*/ z.number(),
            grossLoss: /*#__PURE__*/ z.number(),
            winners: /*#__PURE__*/ z.int().gte(0)
        }),
        commission: /*#__PURE__*/ z.number(),
        bySignal: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            key: /*#__PURE__*/ z.string(),
            label: /*#__PURE__*/ z.string(),
            trades: /*#__PURE__*/ z.int().gte(0),
            winners: /*#__PURE__*/ z.int().gte(0),
            losers: /*#__PURE__*/ z.int().gte(0),
            netProfit: /*#__PURE__*/ z.number()
        }))
    }),
    trades: /*#__PURE__*/ z.object({
        list: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            tradeNo: /*#__PURE__*/ z.int(),
            symbol: /*#__PURE__*/ z.string().nullable(),
            side: /*#__PURE__*/ z.enum(['long', 'short']),
            status: /*#__PURE__*/ z.enum(['closed', 'open']),
            entryTime: /*#__PURE__*/ z.string().nullable(),
            exitTime: /*#__PURE__*/ z.string().nullable(),
            entryPrice: /*#__PURE__*/ z.number().nullable(),
            exitPrice: /*#__PURE__*/ z.number().nullable(),
            size: /*#__PURE__*/ z.number().nullable(),
            pnl: /*#__PURE__*/ z.number(),
            returnPct: /*#__PURE__*/ z.number(),
            cumulativePnl: /*#__PURE__*/ z.number().nullable(),
            runUp: /*#__PURE__*/ z.number().nullable(),
            drawdown: /*#__PURE__*/ z.number().nullable(),
            barsHeld: /*#__PURE__*/ z.number().nullable(),
            fees: /*#__PURE__*/ z.number(),
            exitReason: /*#__PURE__*/ z.string().nullable(),
            entrySignals: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
        })),
        distribution: /*#__PURE__*/ z.object({
            bins: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                from: /*#__PURE__*/ z.number(),
                to: /*#__PURE__*/ z.number(),
                count: /*#__PURE__*/ z.int().gte(0)
            })),
            winners: /*#__PURE__*/ z.int().gte(0),
            losers: /*#__PURE__*/ z.int().gte(0),
            breakEvens: /*#__PURE__*/ z.int().gte(0),
            expectancy: /*#__PURE__*/ z.number().nullable(),
            averageWin: /*#__PURE__*/ z.number().nullable(),
            averageLoss: /*#__PURE__*/ z.number().nullable(),
            largestProfit: /*#__PURE__*/ z.number().nullable(),
            largestLoss: /*#__PURE__*/ z.number().nullable(),
            outliersPnl: /*#__PURE__*/ z.number(),
            outliers: /*#__PURE__*/ z.int().gte(0)
        }),
        streaks: /*#__PURE__*/ z.object({
            longestWin: /*#__PURE__*/ z.int().gte(0),
            longestLoss: /*#__PURE__*/ z.int().gte(0),
            averageWin: /*#__PURE__*/ z.number().nullable(),
            averageLoss: /*#__PURE__*/ z.number().nullable(),
            series: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                tradeNo: /*#__PURE__*/ z.int(),
                streak: /*#__PURE__*/ z.int(),
                amount: /*#__PURE__*/ z.number()
            }))
        }),
        timePatterns: /*#__PURE__*/ z.object({
            byEntryHour: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                key: /*#__PURE__*/ z.string(),
                label: /*#__PURE__*/ z.string(),
                trades: /*#__PURE__*/ z.int().gte(0),
                winners: /*#__PURE__*/ z.int().gte(0),
                losers: /*#__PURE__*/ z.int().gte(0),
                netProfit: /*#__PURE__*/ z.number()
            })),
            byEntryWeekday: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                key: /*#__PURE__*/ z.string(),
                label: /*#__PURE__*/ z.string(),
                trades: /*#__PURE__*/ z.int().gte(0),
                winners: /*#__PURE__*/ z.int().gte(0),
                losers: /*#__PURE__*/ z.int().gte(0),
                netProfit: /*#__PURE__*/ z.number()
            })),
            byEntryMonth: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                key: /*#__PURE__*/ z.string(),
                label: /*#__PURE__*/ z.string(),
                trades: /*#__PURE__*/ z.int().gte(0),
                winners: /*#__PURE__*/ z.int().gte(0),
                losers: /*#__PURE__*/ z.int().gte(0),
                netProfit: /*#__PURE__*/ z.number()
            })),
            averageBarsHeld: /*#__PURE__*/ z.number().nullable(),
            averageBarsHeldWinners: /*#__PURE__*/ z.number().nullable(),
            averageBarsHeldLosers: /*#__PURE__*/ z.number().nullable()
        })
    })
});

export const zApiBacktestAnalyticsResult = /*#__PURE__*/ z.object({
    data: zApiBacktestAnalytics,
    meta: zApiMeta
});

export const zApiCandle = /*#__PURE__*/ z.object({
    time: /*#__PURE__*/ z.string(),
    open: /*#__PURE__*/ z.number(),
    high: /*#__PURE__*/ z.number(),
    low: /*#__PURE__*/ z.number(),
    close: /*#__PURE__*/ z.number(),
    volume: /*#__PURE__*/ z.number()
});

export const zApiCandleColumns = /*#__PURE__*/ z.object({
    s: /*#__PURE__*/ z.enum(['ok', 'no_data']),
    t: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    o: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    h: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    l: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    c: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    v: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number()),
    nextTime: /*#__PURE__*/ z.number().nullable()
});

export const zApiCandleWindow = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.array(zApiCandle),
        zApiCandleColumns
    ]),
    paging: zApiPaging,
    meta: zApiMeta
});

export const zApiRunEvent = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string(),
    progress: /*#__PURE__*/ z.number().nullable(),
    done: /*#__PURE__*/ z.boolean(),
    data: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
});

/**
 * Ready to serve traffic
 */
export const zGetSystemHealthResponse = zSystemHealth;

export const zCreateSignupBody = zAuthSignupCreate;

/**
 * Account created: approved into the inviting organization (or pending, with AUTH_OPEN_SIGNUP)
 */
export const zCreateSignupResponse = zSignupResult;

export const zCreateLoginBody = zAuthLoginCreate;

/**
 * Login successful
 */
export const zCreateLoginResponse = zAuthToken;

/**
 * Current user with active org feature flags
 */
export const zGetMeResponse = /*#__PURE__*/ z.object({
    user: zUser,
    features: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.boolean())
});

export const zUpdateMeBody = zUserProfileUpdate;

/**
 * Profile updated
 */
export const zUpdateMeResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    user: zUser
});

/**
 * Logged out — the refresh token is revoked and its cookie cleared
 */
export const zCreateLogoutResponse = zActionSuccess;

/**
 * New access token; the rotated refresh token is set in the httpOnly `cf_refresh` cookie
 */
export const zRefreshTokenResponse = zTokenRefresh;

export const zVerifyEmailBody = zVerifyEmailRequest;

/**
 * Email verified
 */
export const zVerifyEmailResponse = zActionSuccess;

export const zResetPasswordBody = zResetPasswordRequest;

/**
 * Password updated
 */
export const zResetPasswordResponse = zActionSuccess;

export const zUnlinkAccountBody = zAccountLinkRequest;

/**
 * Accounts unlinked
 */
export const zUnlinkAccountResponse = zLinkedAccountActionSuccess;

/**
 * Linked accounts
 */
export const zListLinkedAccountsResponse = /*#__PURE__*/ z.array(zLinkedAccount);

export const zLinkAccountBody = zAccountLinkRequest;

/**
 * Accounts linked
 */
export const zLinkAccountResponse = zLinkedAccountActionSuccess;

export const zSwitchAccountBody = zAccountSwitchRequest;

/**
 * Switched account
 */
export const zSwitchAccountResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    token: /*#__PURE__*/ z.string(),
    user: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        email: /*#__PURE__*/ z.email(),
        username: /*#__PURE__*/ z.string().nullable(),
        fullName: /*#__PURE__*/ z.string().nullable(),
        status: /*#__PURE__*/ z.string(),
        organizationId: /*#__PURE__*/ z.number().nullish(),
        organizationName: /*#__PURE__*/ z.string().nullish(),
        organizationPlan: /*#__PURE__*/ z.string().nullish(),
        settings: /*#__PURE__*/ z.object({
            theme: /*#__PURE__*/ z.enum(['dark', 'light']),
            notifications: /*#__PURE__*/ z.boolean(),
            defaultExchange: /*#__PURE__*/ z.string(),
            defaultLeverage: /*#__PURE__*/ z.number(),
            timezone: /*#__PURE__*/ z.string(),
            uiMode: /*#__PURE__*/ z.enum(['simple', 'detailed']).optional(),
            activeModuleId: /*#__PURE__*/ z.string().optional()
        }).nullish(),
        isVerified: /*#__PURE__*/ z.boolean().optional(),
        createdAt: /*#__PURE__*/ z.string().optional(),
        permissions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
    })
});

export const zPreviewInvitationPath = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string()
});

/**
 * Invitation preview
 */
export const zPreviewInvitationResponse = zInvitationPreview;

export const zAcceptInvitationPath = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string()
});

/**
 * Accepted
 */
export const zAcceptInvitationResponse = zInvitation;

export const zResendInvitationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Resent
 */
export const zResendInvitationResponse = zInvitation;

export const zRevokeInvitationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Revoked
 */
export const zRevokeInvitationResponse = zInvitation;

export const zListAdminUsersQuery = /*#__PURE__*/ z.object({
    search: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected'
    ]).optional(),
    orgId: /*#__PURE__*/ z.number().nullish(),
    role: /*#__PURE__*/ z.enum([
        'superadmin',
        'user',
        'org_admin',
        'trader',
        'analyst',
        'code_reviewer',
        'viewer'
    ]).optional(),
    limit: /*#__PURE__*/ z.number().gte(1).lte(100).optional().default(50),
    offset: /*#__PURE__*/ z.number().gte(0).nullish().default(0)
});

/**
 * Paginated user list
 */
export const zListAdminUsersResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAdminUser),
    paging: /*#__PURE__*/ z.object({
        total: /*#__PURE__*/ z.number(),
        limit: /*#__PURE__*/ z.number(),
        offset: /*#__PURE__*/ z.number()
    })
});

export const zBulkUpdateUserStatusBody = zUserBulkStatusRequest;

/**
 * Bulk status update result
 */
export const zBulkUpdateUserStatusResponse = zUserBulkStatusResult;

export const zGetAdminUserPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * User detail
 */
export const zGetAdminUserResponse = zAdminUser;

export const zUpdateAdminUserBody = zAdminUserUpdate;

export const zUpdateAdminUserPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * User updated
 */
export const zUpdateAdminUserResponse = zAdminUser;

export const zResetUserPasswordPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Password reset email sent
 */
export const zResetUserPasswordResponse = zAdminActionSuccess;

export const zVerifyUserPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Verification email sent
 */
export const zVerifyUserResponse = zAdminActionSuccess;

export const zAssignUserRoleBody = zUserRoleAssign;

export const zAssignUserRolePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Role assigned
 */
export const zAssignUserRoleResponse = zAdminActionSuccess;

export const zRemoveUserRolePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    roleId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Role removed
 */
export const zRemoveUserRoleResponse = zAdminActionSuccess;

export const zGetUserAuditLogPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

export const zGetUserAuditLogQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.number().gte(1).lte(100).optional().default(50),
    offset: /*#__PURE__*/ z.number().gte(0).nullish().default(0)
});

/**
 * Audit log entries
 */
export const zGetUserAuditLogResponse = zAdminUserAuditList;

/**
 * Exchange credentials
 */
export const zListExchangeCredentialsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zExchangeCredential)
});

export const zCreateExchangeCredentialBody = zExchangeCredentialCreate;

/**
 * Created
 */
export const zCreateExchangeCredentialResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    key: zExchangeCredential
});

export const zDeleteExchangeCredentialPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteExchangeCredentialResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

/**
 * Current config (secrets masked)
 */
export const zGetNotificationConfigResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    config: zNotificationConfig
});

export const zUpdateNotificationConfigBody = zNotificationConfigUpdate;

/**
 * Updated
 */
export const zUpdateNotificationConfigResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string()
});

export const zSendNotificationBody = zNotificationSendCreate;

/**
 * Sent
 */
export const zSendNotificationResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    results: /*#__PURE__*/ z.array(zNotificationResult)
});

export const zTestNotificationBody = zNotificationTestCreate;

/**
 * Test sent
 */
export const zTestNotificationResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    results: /*#__PURE__*/ z.union([
        zNotificationResult,
        /*#__PURE__*/ z.array(zNotificationResult)
    ])
});

export const zListActiveAgentsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string().optional()
});

/**
 * List of active agents
 */
export const zListActiveAgentsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAgentSummary),
    total: /*#__PURE__*/ z.number()
});

export const zSpawnAgentBody = zAgentSpawnRequest;

/**
 * Agent spawned
 */
export const zSpawnAgentResponse = zAgentSpawnResult;

export const zTerminateAgentBody = zAgentTerminateRequest;

export const zTerminateAgentPath = /*#__PURE__*/ z.object({
    agentId: /*#__PURE__*/ z.string()
});

/**
 * Agent terminated
 */
export const zTerminateAgentResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zExecuteAgentBody = zAgentExecuteRequest;

export const zExecuteAgentPath = /*#__PURE__*/ z.object({
    agentId: /*#__PURE__*/ z.string()
});

/**
 * Execution result
 */
export const zExecuteAgentResponse = /*#__PURE__*/ z.object({
    result: zAgentExecuteResult
});

export const zGetAgentHealthQuery = /*#__PURE__*/ z.object({
    includeDeprecated: /*#__PURE__*/ z.string().optional()
});

/**
 * Agent health report
 */
export const zGetAgentHealthResponse = /*#__PURE__*/ z.object({
    report: zAgentHealthReport
});

/**
 * Pending decisions
 */
export const zListPendingDecisionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDecisionRequest),
    total: /*#__PURE__*/ z.number()
});

/**
 * Decision statistics
 */
export const zGetDecisionStatsResponse = zDecisionStats;

export const zGetDecisionPath = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string()
});

/**
 * Decision details
 */
export const zGetDecisionResponse = /*#__PURE__*/ z.object({
    request: zDecisionRequest,
    decision: /*#__PURE__*/ zDecision.nullable()
});

export const zApproveDecisionBody = zDecisionApproveRequest;

export const zApproveDecisionPath = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string()
});

/**
 * Decision approved
 */
export const zApproveDecisionResponse = /*#__PURE__*/ z.object({
    decision: zDecision
});

export const zRejectDecisionBody = zDecisionRejectRequest;

export const zRejectDecisionPath = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string()
});

/**
 * Decision rejected
 */
export const zRejectDecisionResponse = /*#__PURE__*/ z.object({
    decision: zDecision
});

export const zModifyDecisionBody = zDecisionModifyRequest;

export const zModifyDecisionPath = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string()
});

/**
 * Decision modified
 */
export const zModifyDecisionResponse = /*#__PURE__*/ z.object({
    decision: zDecision
});

export const zGetRecentMessagesQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Recent agent messages
 */
export const zGetRecentMessagesResponse = /*#__PURE__*/ z.object({
    messages: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown())
});

export const zPreviewPromptBody = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string().nullish(),
    templateId: /*#__PURE__*/ z.number().nullish(),
    name: /*#__PURE__*/ z.string().nullish(),
    description: /*#__PURE__*/ z.string().nullish(),
    systemPromptOverride: /*#__PURE__*/ z.string().nullish(),
    additionalInstructions: /*#__PURE__*/ z.string().nullish(),
    userPromptTemplate: /*#__PURE__*/ z.string().nullish(),
    userPromptFreetext: /*#__PURE__*/ z.string().nullish(),
    promptMode: /*#__PURE__*/ z.enum(['template', 'freetext']).nullish(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    outputConfig: /*#__PURE__*/ z.unknown().optional(),
    outputContract: /*#__PURE__*/ zWorkflowContract.nullish(),
    inputContracts: /*#__PURE__*/ zInputContractMap.nullish(),
    upstreamOutputs: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullish(),
    inputMapping: /*#__PURE__*/ z.unknown().optional()
});

/**
 * Assembled prompt preview
 */
export const zPreviewPromptResponse = /*#__PURE__*/ z.object({
    role: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        title: /*#__PURE__*/ z.string(),
        department: /*#__PURE__*/ z.string(),
        model: /*#__PURE__*/ z.string(),
        responsibilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        skills: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
    }),
    systemPrompt: /*#__PURE__*/ z.string(),
    defaultSystemPrompt: /*#__PURE__*/ z.string(),
    userPrompt: /*#__PURE__*/ z.string(),
    agentInput: /*#__PURE__*/ z.string(),
    estimatedTokens: /*#__PURE__*/ z.number()
});

export const zExecuteStepBody = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string(),
    input: /*#__PURE__*/ z.unknown().optional(),
    config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    systemPromptOverride: /*#__PURE__*/ z.string().optional(),
    userPromptTemplate: /*#__PURE__*/ z.string().optional()
});

/**
 * Step execution dispatched
 */
export const zExecuteStepResponse = /*#__PURE__*/ z.object({
    result: /*#__PURE__*/ z.object({
        status: /*#__PURE__*/ z.string(),
        requestId: /*#__PURE__*/ z.string()
    }),
    agentId: /*#__PURE__*/ z.string(),
    agentName: /*#__PURE__*/ z.string(),
    model: /*#__PURE__*/ z.string(),
    executionTimeMs: /*#__PURE__*/ z.number(),
    cost: /*#__PURE__*/ z.number()
});

export const zExecuteStepStreamBody = zExecuteStepStreamRequest;

/**
 * SSE stream of execution events
 */
export const zExecuteStepStreamResponse = /*#__PURE__*/ z.string();

export const zReconnectToRunPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

/**
 * SSE stream reconnection
 */
export const zReconnectToRunResponse = /*#__PURE__*/ z.string();

export const zSendFollowUpMessageBody = zFollowUpMessageRequest;

export const zSendFollowUpMessagePath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

/**
 * SSE stream for follow-up
 */
export const zSendFollowUpMessageResponse = /*#__PURE__*/ z.string();

/**
 * Active run info
 */
export const zGetActiveRunResponse = /*#__PURE__*/ z.object({
    active: /*#__PURE__*/ z.boolean(),
    runId: /*#__PURE__*/ z.string().optional(),
    templateSlug: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.string().optional(),
    textLen: /*#__PURE__*/ z.number().optional(),
    eventCount: /*#__PURE__*/ z.number().optional()
});

/**
 * All runs
 */
export const zListRunsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        runId: /*#__PURE__*/ z.string(),
        templateSlug: /*#__PURE__*/ z.string(),
        status: /*#__PURE__*/ z.string(),
        textLen: /*#__PURE__*/ z.number().optional(),
        eventCount: /*#__PURE__*/ z.number().optional()
    }))
});

export const zStopExecutionBody = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string().optional()
});

/**
 * Execution stopped
 */
export const zStopExecutionResponse = /*#__PURE__*/ z.object({
    stopped: /*#__PURE__*/ z.boolean()
});

export const zPauseExecutionBody = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string().optional()
});

/**
 * Execution paused
 */
export const zPauseExecutionResponse = /*#__PURE__*/ z.object({
    paused: /*#__PURE__*/ z.boolean()
});

export const zResumeExecutionBody = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string().optional()
});

/**
 * Execution resumed
 */
export const zResumeExecutionResponse = /*#__PURE__*/ z.object({
    resumed: /*#__PURE__*/ z.boolean()
});

/**
 * Execution status
 */
export const zGetExecutionStatusResponse = /*#__PURE__*/ z.object({
    running: /*#__PURE__*/ z.boolean(),
    sessions: /*#__PURE__*/ z.number(),
    activeRun: /*#__PURE__*/ z.object({
        runId: /*#__PURE__*/ z.string(),
        templateSlug: /*#__PURE__*/ z.string(),
        textLen: /*#__PURE__*/ z.number()
    }).nullable()
});

export const zSaveDebugStepOutputBody = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.number(),
    stepId: /*#__PURE__*/ z.string().optional(),
    stepName: /*#__PURE__*/ z.string(),
    input: /*#__PURE__*/ z.unknown().optional(),
    output: /*#__PURE__*/ z.string(),
    extractedJson: /*#__PURE__*/ z.unknown().optional(),
    agentId: /*#__PURE__*/ z.string().optional(),
    model: /*#__PURE__*/ z.string().optional(),
    durationMs: /*#__PURE__*/ z.number().optional(),
    cost: /*#__PURE__*/ z.number().optional()
});

/**
 * Debug output saved
 */
export const zSaveDebugStepOutputResponse = /*#__PURE__*/ z.object({
    run: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        templateId: /*#__PURE__*/ z.number().nullable(),
        status: /*#__PURE__*/ z.string(),
        triggeredBy: /*#__PURE__*/ z.string().nullable(),
        startedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]).nullable(),
        completedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]).nullable(),
        context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).nullable(),
        error: /*#__PURE__*/ z.string().nullable(),
        organizationId: /*#__PURE__*/ z.number()
    }),
    step: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        runId: /*#__PURE__*/ z.number(),
        stepId: /*#__PURE__*/ z.string(),
        stepName: /*#__PURE__*/ z.string().nullable(),
        agentId: /*#__PURE__*/ z.number().nullable(),
        status: /*#__PURE__*/ z.string(),
        startedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]).nullable(),
        completedAt: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.string(),
            /*#__PURE__*/ z.iso.datetime()
        ]).nullable(),
        input: /*#__PURE__*/ z.unknown().optional(),
        output: /*#__PURE__*/ z.unknown().optional(),
        error: /*#__PURE__*/ z.string().nullable(),
        model: /*#__PURE__*/ z.string().nullable(),
        costUsd: /*#__PURE__*/ z.string().nullable(),
        durationMs: /*#__PURE__*/ z.number().nullable()
    })
});

export const zGetDebugStepOutputsPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string()
});

/**
 * Debug step outputs
 */
export const zGetDebugStepOutputsResponse = /*#__PURE__*/ z.object({
    outputs: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
});

export const zGetStepBuilderContextQuery = /*#__PURE__*/ z.object({
    steps: /*#__PURE__*/ z.string().optional()
});

/**
 * Step builder context
 */
export const zGetStepBuilderContextResponse = /*#__PURE__*/ z.object({
    systemPrompt: /*#__PURE__*/ z.string(),
    portTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string()
    })),
    stepTypes: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zValidateStepBody = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().optional(),
    templateSlug: /*#__PURE__*/ z.string().optional(),
    templateId: /*#__PURE__*/ z.number().optional(),
    processorType: /*#__PURE__*/ z.string().optional(),
    executionMode: /*#__PURE__*/ z.string().optional(),
    optional: /*#__PURE__*/ z.boolean().optional(),
    timeoutMs: /*#__PURE__*/ z.number().optional(),
    retryMax: /*#__PURE__*/ z.number().optional(),
    outputPortType: /*#__PURE__*/ z.string().optional(),
    inputPorts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        type: /*#__PURE__*/ z.string()
    })).optional()
});

/**
 * Validation result
 */
export const zValidateStepResponse = /*#__PURE__*/ z.object({
    valid: /*#__PURE__*/ z.boolean(),
    errors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string())
});

export const zSuggestConnectionsBody = /*#__PURE__*/ z.object({
    inputPorts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        type: /*#__PURE__*/ z.string()
    })).optional().default([]),
    existingSteps: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        name: /*#__PURE__*/ z.string(),
        outputPorts: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
            name: /*#__PURE__*/ z.string(),
            type: /*#__PURE__*/ z.string()
        })).optional().default([])
    })).optional().default([])
});

/**
 * Compatible connections between the new step inputs and existing step outputs
 */
export const zSuggestConnectionsResponse = /*#__PURE__*/ z.object({
    suggestions: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        inputPort: /*#__PURE__*/ z.string(),
        sourceStepId: /*#__PURE__*/ z.string(),
        sourceStepName: /*#__PURE__*/ z.string(),
        sourcePort: /*#__PURE__*/ z.string(),
        method: /*#__PURE__*/ z.string()
    }))
});

export const zOptimizePromptBody = zOptimizePromptRequest;

/**
 * Optimized prompt queued
 */
export const zOptimizePromptResponse = zOptimizePromptResult;

export const zListPromptTemplatesQuery = /*#__PURE__*/ z.object({
    category: /*#__PURE__*/ z.string().optional()
});

/**
 * Prompt template list (optionally filtered by category)
 */
export const zListPromptTemplatesResponse = /*#__PURE__*/ z.array(zPromptTemplateSummary);

export const zFillTemplateBody = zFillTemplateRequest;

export const zFillTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Filled template
 */
export const zFillTemplateResponse = zFillTemplateResult;

/**
 * Skill gap analysis
 */
export const zGetToolGapsResponse = zToolGapAnalysis;

export const zSearchAgentTemplatesQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(500),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional().default(10)
});

/**
 * Results
 */
export const zSearchAgentTemplatesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAgentTemplateSearchResult),
    query: /*#__PURE__*/ z.string(),
    total: /*#__PURE__*/ z.number(),
    searchType: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ])
});

export const zRecommendAgentTemplatesQuery = /*#__PURE__*/ z.object({
    stepDescription: /*#__PURE__*/ z.string().min(1).max(500),
    workflowCategory: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(20).optional().default(5)
});

/**
 * Recommendations
 */
export const zRecommendAgentTemplatesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAgentTemplateSearchResult),
    total: /*#__PURE__*/ z.number()
});

export const zListAgentTemplateVersionsPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string()
});

/**
 * Versions
 */
export const zListAgentTemplateVersionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAgentTemplateVersion)
});

export const zCreateAgentTemplateVersionBody = zAgentTemplateVersionCreate;

export const zCreateAgentTemplateVersionPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string()
});

/**
 * Noop — content unchanged; existing draft/active version returned
 */
export const zCreateAgentTemplateVersionResponse = zAgentTemplateVersion;

export const zPromoteAgentTemplateVersionPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string(),
    versionId: /*#__PURE__*/ z.string()
});

/**
 * Promoted
 */
export const zPromoteAgentTemplateVersionResponse = zAgentTemplateVersion;

export const zRollbackAgentTemplateVersionPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string(),
    versionId: /*#__PURE__*/ z.string()
});

/**
 * Rolled back
 */
export const zRollbackAgentTemplateVersionResponse = zAgentTemplateVersion;

export const zDiffAgentTemplateVersionsPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string(),
    versionA: /*#__PURE__*/ z.int().gt(0),
    versionB: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Agent template version diff
 */
export const zDiffAgentTemplateVersionsResponse = zAgentTemplateVersionDiff;

export const zTestAgentTemplateVersionPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string(),
    versionId: /*#__PURE__*/ z.string()
});

/**
 * Eval-gate run queued
 */
export const zTestAgentTemplateVersionResponse = zAgentTemplateVersionTestResult;

export const zCompareAgentTemplateVersionsBody = zAgentTemplateVersionCompareRequest;

export const zCompareAgentTemplateVersionsPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string()
});

/**
 * Comparison enqueued (status=queued) or short-circuited (status=no_dataset)
 */
export const zCompareAgentTemplateVersionsResponse = zAgentTemplateVersionCompareResult;

export const zGetAgentTemplateVersionComparisonPath = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.string(),
    compareJobId: /*#__PURE__*/ z.string()
});

export const zGetAgentTemplateVersionComparisonQuery = /*#__PURE__*/ z.object({
    versionIds: /*#__PURE__*/ z.string().optional(),
    samples: /*#__PURE__*/ z.int().nullish()
});

/**
 * Aggregated, ranked comparison result
 */
export const zGetAgentTemplateVersionComparisonResponse = zAgentTemplateVersionComparison;

export const zPreflightTemplateUpgradeBody = zTemplateUpgradePreflightRequest;

/**
 * Template upgrade impact and compatibility preflight
 */
export const zPreflightTemplateUpgradeResponse = /*#__PURE__*/ z.object({
    data: zTemplateUpgradePreflightResult
});

export const zCreateTemplateUpgradeProposalBody = zTemplateUpgradeProposalRequest;

export const zCreateTemplateUpgradeProposalResponse = /*#__PURE__*/ z.union([
    /*#__PURE__*/ z.object({
        data: zTemplateUpgradeProposalResult
    }),
    /*#__PURE__*/ z.object({
        data: zTemplateUpgradeProposalResult
    })
]);

export const zListTemplatesQuery = /*#__PURE__*/ z.object({
    includeDisabled: /*#__PURE__*/ z.boolean().nullish().default(false),
    departmentId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'name'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false),
    q: /*#__PURE__*/ z.string().max(200).optional()
});

/**
 * Template list (paginated)
 */
export const zListTemplatesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAgentTemplateSummary)
});

export const zCreateTemplateBody = zAgentTemplateCreate;

/**
 * Created
 */
export const zCreateTemplateResponse = /*#__PURE__*/ z.object({
    template: zAgentTemplate
});

export const zDeleteTemplatePath = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string()
});

export const zDeleteTemplateQuery = /*#__PURE__*/ z.object({
    force: /*#__PURE__*/ z.string().optional()
});

/**
 * Deleted
 */
export const zDeleteTemplateResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetTemplatePath = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string()
});

/**
 * Template detail
 */
export const zGetTemplateResponse = /*#__PURE__*/ z.object({
    template: zAgentTemplate
});

export const zCreateOrUpdateTemplateBody = zAgentTemplateUpsert;

export const zCreateOrUpdateTemplatePath = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string()
});

/**
 * Upserted
 */
export const zCreateOrUpdateTemplateResponse = /*#__PURE__*/ z.object({
    template: zAgentTemplate
});

export const zSetTemplateStatusBody = zAgentTemplateStatusUpdate;

export const zSetTemplateStatusPath = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string()
});

/**
 * Status updated
 */
export const zSetTemplateStatusResponse = zSetAgentTemplateStatusResult;

export const zSetTemplateAutoUpgradeBody = zAgentTemplateAutoUpgradeUpdate;

export const zSetTemplateAutoUpgradePath = /*#__PURE__*/ z.object({
    templateSlug: /*#__PURE__*/ z.string()
});

/**
 * Auto-upgrade updated
 */
export const zSetTemplateAutoUpgradeResponse = zSetAgentTemplateAutoUpgradeResult;

export const zListSkillsQuery = /*#__PURE__*/ z.object({
    search: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    includeDisabled: /*#__PURE__*/ z.boolean().nullish(),
    limit: /*#__PURE__*/ z.number().nullish()
});

/**
 * Skill list
 */
export const zListSkillsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zSkillSummary)
});

export const zGetSkillPath = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string()
});

/**
 * Skill detail
 */
export const zGetSkillResponse = /*#__PURE__*/ z.object({
    skill: zSkill
});

/**
 * Skill library list
 */
export const zListToolLibrariesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zSkillLibrary)
});

export const zCreateToolLibraryBody = zSkillLibraryCreate;

/**
 * Created
 */
export const zCreateToolLibraryResponse = zSkillLibrary;

export const zDeleteToolLibraryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteToolLibraryResponse = zSkillLibraryActionResult;

export const zGetToolLibraryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Library detail
 */
export const zGetToolLibraryResponse = zSkillLibrary;

export const zUpdateToolLibraryBody = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    description: /*#__PURE__*/ z.string().optional(),
    sourceType: /*#__PURE__*/ z.enum([
        'git',
        'local',
        'url'
    ]).optional(),
    repoUrl: /*#__PURE__*/ z.string().optional(),
    localPath: /*#__PURE__*/ z.string().optional(),
    branch: /*#__PURE__*/ z.string().optional(),
    subdirectory: /*#__PURE__*/ z.string().optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    autoSync: /*#__PURE__*/ z.boolean().optional()
});

export const zUpdateToolLibraryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateToolLibraryResponse = zSkillLibrary;

export const zSyncToolLibraryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Sync requested
 */
export const zSyncToolLibraryResponse = zSkillLibrarySyncResult;

export const zListToolLibraryToolsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Skills in library
 */
export const zListToolLibraryToolsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zSkillLibraryTool)
});

export const zListToolsQuery = /*#__PURE__*/ z.object({
    includeDeprecated: /*#__PURE__*/ z.string().optional()
});

/**
 * Tool list
 */
export const zListToolsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zToolSummary)
});

export const zCreateToolBody = zToolCreate;

/**
 * Tool created
 */
export const zCreateToolResponse = /*#__PURE__*/ z.object({
    tool: /*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string().optional(),
        category: /*#__PURE__*/ z.string().optional()
    })
});

export const zDeleteToolPath = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string()
});

export const zDeleteToolQuery = /*#__PURE__*/ z.object({
    force: /*#__PURE__*/ z.string().optional()
});

/**
 * Tool deleted
 */
export const zDeleteToolResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetToolPath = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string()
});

/**
 * Tool detail
 */
export const zGetToolResponse = /*#__PURE__*/ z.object({
    tool: zTool
});

export const zCreateOrUpdateToolBody = zToolUpsert;

export const zCreateOrUpdateToolPath = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string()
});

/**
 * Tool created or updated
 */
export const zCreateOrUpdateToolResponse = /*#__PURE__*/ z.object({
    tool: /*#__PURE__*/ z.object({
        name: /*#__PURE__*/ z.string(),
        description: /*#__PURE__*/ z.string().optional(),
        category: /*#__PURE__*/ z.string().optional()
    })
});

export const zSetToolStatusBody = zToolStatusUpdate;

export const zSetToolStatusPath = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string()
});

/**
 * Tool status updated
 */
export const zSetToolStatusResponse = zSetToolStatusResult;

/**
 * Workflows
 */
export const zListAgentWorkflowsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowSummary)
});

export const zTriggerAgentWorkflowBody = zWorkflowTriggerRequest;

export const zTriggerAgentWorkflowPath = /*#__PURE__*/ z.object({
    workflowId: /*#__PURE__*/ z.string()
});

/**
 * Triggered
 */
export const zTriggerAgentWorkflowResponse = zWorkflowTriggerResult;

export const zGetAgentWorkflowRunPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run detail
 */
export const zGetAgentWorkflowRunResponse = /*#__PURE__*/ z.object({
    run: zWorkflowRun
});

export const zGetAgentWorkflowRunDebuggerPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

export const zGetAgentWorkflowRunDebuggerQuery = /*#__PURE__*/ z.object({
    detail: /*#__PURE__*/ z.enum([
        'summary',
        'debug',
        'full'
    ]).optional().default('summary')
});

/**
 * Workflow run debugger cockpit payload
 */
export const zGetAgentWorkflowRunDebuggerResponse = zWorkflowRunDebuggerPayload;

export const zRunAgentWorkflowRunActionBody = zWorkflowRunActionRequest;

export const zRunAgentWorkflowRunActionPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

/**
 * Workflow run action accepted or recorded
 */
export const zRunAgentWorkflowRunActionResponse = zWorkflowRunActionResult;

/**
 * All runs
 */
export const zListAgentWorkflowRunsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowRun)
});

export const zListLlmCallCostOutliersQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional().default(20),
    after: /*#__PURE__*/ z.string().optional(),
    since: /*#__PURE__*/ z.iso.datetime().optional(),
    until: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Top-N LLM calls by cost_usd (cursor-paginated, org-scoped)
 */
export const zListLlmCallCostOutliersResponse = zLlmCallOutlierList;

export const zListLlmCallLatencyOutliersQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional().default(20),
    after: /*#__PURE__*/ z.string().optional(),
    since: /*#__PURE__*/ z.iso.datetime().optional(),
    until: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Top-N LLM calls by duration_ms (cursor-paginated, org-scoped)
 */
export const zListLlmCallLatencyOutliersResponse = zLlmCallOutlierList;

export const zGetRunHealthAggregatesQuery = /*#__PURE__*/ z.object({
    since: /*#__PURE__*/ z.iso.datetime().optional(),
    until: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Aggregate LLM call health metrics (error rates, cost, latency) for a time window
 */
export const zGetRunHealthAggregatesResponse = zRunHealthAggregates;

/**
 * Model capability catalog
 */
export const zListModelsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zModelSummary)
});

export const zGetModelPath = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string()
});

/**
 * Model capability detail
 */
export const zGetModelResponse = /*#__PURE__*/ z.object({
    data: zModel
});

/**
 * The runtime policies the organization sees: the system ones and its own
 */
export const zListModelRuntimePoliciesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zModelRuntimePolicy)
});

export const zCreateModelRuntimePolicyBody = zModelRuntimePolicyUpsert;

/**
 * Created model runtime policy
 */
export const zCreateModelRuntimePolicyResponse = /*#__PURE__*/ z.object({
    data: zModelRuntimePolicy
});

export const zResolveModelRuntimePolicyBody = zModelRuntimePolicyResolveRequest;

/**
 * The policy a piece of work of this kind runs under (its carried policy when allowed, else the default)
 */
export const zResolveModelRuntimePolicyResponse = /*#__PURE__*/ z.object({
    data: zModelRuntimePolicy
});

export const zGetModelRuntimePolicyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Model runtime policy
 */
export const zGetModelRuntimePolicyResponse = /*#__PURE__*/ z.object({
    data: zModelRuntimePolicy
});

export const zUpdateModelRuntimePolicyBody = zModelRuntimePolicyUpsert;

export const zUpdateModelRuntimePolicyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated model runtime policy. Archiving or drafting it retires it: what moved to the surface defaults is counted.
 */
export const zUpdateModelRuntimePolicyResponse = /*#__PURE__*/ z.object({
    data: zModelRuntimePolicy,
    retired: /*#__PURE__*/ zRuntimePolicyRetireCounts.nullable()
});

/**
 * The rule of every surface the organization runs under
 */
export const zListRuntimePolicySurfaceRulesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zRuntimePolicySurfaceRule)
});

export const zListRuntimePolicyOptionsPath = /*#__PURE__*/ z.object({
    surface: zRuntimePolicySurface
});

/**
 * The policies a person may pick for this kind of work, the default first
 */
export const zListRuntimePolicyOptionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zRuntimePolicyOption)
});

export const zSetSystemRuntimePolicySurfaceRuleBody = zRuntimePolicySurfaceRuleWrite;

export const zSetSystemRuntimePolicySurfaceRulePath = /*#__PURE__*/ z.object({
    surface: zRuntimePolicySurface
});

/**
 * The system's rule for this kind of work
 */
export const zSetSystemRuntimePolicySurfaceRuleResponse = /*#__PURE__*/ z.object({
    data: zRuntimePolicySurfaceRule
});

export const zClearOrganizationRuntimePolicySurfaceRulePath = /*#__PURE__*/ z.object({
    surface: zRuntimePolicySurface
});

/**
 * The rule that applies now: the system's
 */
export const zClearOrganizationRuntimePolicySurfaceRuleResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ zRuntimePolicySurfaceRule.nullable()
});

export const zSetOrganizationRuntimePolicySurfaceRuleBody = zRuntimePolicySurfaceRuleWrite;

export const zSetOrganizationRuntimePolicySurfaceRulePath = /*#__PURE__*/ z.object({
    surface: zRuntimePolicySurface
});

/**
 * The organization's own rule for this kind of work (it replaces the system's)
 */
export const zSetOrganizationRuntimePolicySurfaceRuleResponse = /*#__PURE__*/ z.object({
    data: zRuntimePolicySurfaceRule
});

/**
 * Dynamic fan-out policy templates
 */
export const zListDynamicFanOutPoliciesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDynamicFanOutPolicy)
});

export const zCreateDynamicFanOutPolicyBody = zDynamicFanOutPolicyUpsert;

/**
 * Created dynamic fan-out policy
 */
export const zCreateDynamicFanOutPolicyResponse = /*#__PURE__*/ z.object({
    data: zDynamicFanOutPolicy
});

export const zResolveDynamicFanOutPolicyBody = zDynamicFanOutPolicyResolveRequest;

/**
 * Resolved dynamic fan-out policy preview
 */
export const zResolveDynamicFanOutPolicyResponse = /*#__PURE__*/ z.object({
    data: zDynamicFanOutPolicy
});

export const zGetDynamicFanOutPolicyPath = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string()
});

/**
 * Dynamic fan-out policy
 */
export const zGetDynamicFanOutPolicyResponse = /*#__PURE__*/ z.object({
    data: zDynamicFanOutPolicy
});

export const zUpdateDynamicFanOutPolicyBody = zDynamicFanOutPolicyUpsert;

export const zUpdateDynamicFanOutPolicyPath = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string()
});

/**
 * Updated dynamic fan-out policy
 */
export const zUpdateDynamicFanOutPolicyResponse = /*#__PURE__*/ z.object({
    data: zDynamicFanOutPolicy
});

export const zCallAiWorkerMcpBody = zAiWorkerMcpRequest;

export const zCallAiWorkerMcpPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1)
});

/**
 * MCP JSON-RPC response
 */
export const zCallAiWorkerMcpResponse = zAiWorkerMcpResponse;

export const zQueryAiWorkerDataBody = /*#__PURE__*/ z.object({
    sql: /*#__PURE__*/ z.string().min(1).max(200000),
    params: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    asOf: /*#__PURE__*/ z.string().optional(),
    maxRows: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zQueryAiWorkerDataPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Arrow IPC stream.
 */
export const zQueryAiWorkerDataResponse = /*#__PURE__*/ z.string();

export const zRunAiWorkerDatasetBody = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(120),
    params: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    asOf: /*#__PURE__*/ z.string().optional(),
    maxRows: /*#__PURE__*/ z.int().gt(0).optional()
});

export const zRunAiWorkerDatasetPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Arrow IPC stream.
 */
export const zRunAiWorkerDatasetResponse = /*#__PURE__*/ z.string();

export const zFetchAiWorkerDataResultPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1),
    handle: /*#__PURE__*/ z.string().min(1)
});

/**
 * Arrow IPC stream.
 */
export const zFetchAiWorkerDataResultResponse = /*#__PURE__*/ z.string();

export const zRegisterAiWorkerBody = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1).max(200),
    displayName: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    capabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(100)).min(1),
    models: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0).optional(),
        slug: /*#__PURE__*/ z.string().min(1).max(200),
        provider: /*#__PURE__*/ z.string().min(1).max(100),
        providerModel: /*#__PURE__*/ z.string().min(1).max(200),
        strengths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
        capabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
        load: /*#__PURE__*/ z.object({
            limit: /*#__PURE__*/ z.int().gt(0).nullable(),
            running: /*#__PURE__*/ z.int().gte(0),
            waiting: /*#__PURE__*/ z.int().gte(0),
            server: /*#__PURE__*/ z.object({
                running: /*#__PURE__*/ z.number().gte(0),
                waiting: /*#__PURE__*/ z.number().gte(0)
            }).optional()
        }).optional(),
        costTier: /*#__PURE__*/ z.string().min(1).max(50),
        maxTokens: /*#__PURE__*/ z.int().gt(0)
    })).optional().default([]),
    network: /*#__PURE__*/ z.object({
        privateAddresses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(64)).max(32),
        lanAddresses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(64)).max(32),
        publicEgress: /*#__PURE__*/ z.string().max(64).optional(),
        engineBoxReachable: /*#__PURE__*/ z.boolean().nullable(),
        probedAt: /*#__PURE__*/ z.string()
    }).optional()
});

/**
 * AI worker registered
 */
export const zRegisterAiWorkerResponse = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string(),
    sessionToken: /*#__PURE__*/ z.string(),
    heartbeatIntervalMs: /*#__PURE__*/ z.number(),
    commandCursor: /*#__PURE__*/ z.string(),
    models: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0).optional(),
        slug: /*#__PURE__*/ z.string().min(1),
        provider: /*#__PURE__*/ z.string().min(1),
        modelName: /*#__PURE__*/ z.string().min(1),
        displayName: /*#__PURE__*/ z.string(),
        strengths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        costTier: /*#__PURE__*/ z.enum([
            'free',
            'low',
            'medium',
            'high'
        ]),
        maxTokens: /*#__PURE__*/ z.int().gt(0),
        maxOutputTokens: /*#__PURE__*/ z.int().gt(0).nullable(),
        maxConcurrentRequests: /*#__PURE__*/ z.int().gt(0).nullish(),
        supportsVision: /*#__PURE__*/ z.boolean(),
        supportsTools: /*#__PURE__*/ z.boolean(),
        supportsStructuredOutput: /*#__PURE__*/ z.boolean(),
        supportsReasoning: /*#__PURE__*/ z.boolean(),
        supportsStreaming: /*#__PURE__*/ z.boolean(),
        supportsMultimodal: /*#__PURE__*/ z.boolean(),
        supportsRealtime: /*#__PURE__*/ z.boolean(),
        supportsProviderTools: /*#__PURE__*/ z.boolean(),
        supportsPromptCaching: /*#__PURE__*/ z.boolean(),
        supportsFiles: /*#__PURE__*/ z.boolean(),
        supportsWebSearch: /*#__PURE__*/ z.boolean(),
        dataRetentionTier: /*#__PURE__*/ z.string(),
        capabilities: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
        enabled: /*#__PURE__*/ z.boolean()
    }))
});

export const zHeartbeatAiWorkerBody = /*#__PURE__*/ z.object({
    capabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(100)).min(1),
    models: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0).optional(),
        slug: /*#__PURE__*/ z.string().min(1).max(200),
        provider: /*#__PURE__*/ z.string().min(1).max(100),
        providerModel: /*#__PURE__*/ z.string().min(1).max(200),
        strengths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
        capabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
        load: /*#__PURE__*/ z.object({
            limit: /*#__PURE__*/ z.int().gt(0).nullable(),
            running: /*#__PURE__*/ z.int().gte(0),
            waiting: /*#__PURE__*/ z.int().gte(0),
            server: /*#__PURE__*/ z.object({
                running: /*#__PURE__*/ z.number().gte(0),
                waiting: /*#__PURE__*/ z.number().gte(0)
            }).optional()
        }).optional(),
        costTier: /*#__PURE__*/ z.string().min(1).max(50),
        maxTokens: /*#__PURE__*/ z.int().gt(0)
    })).optional().default([]),
    network: /*#__PURE__*/ z.object({
        privateAddresses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(64)).max(32),
        lanAddresses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(64)).max(32),
        publicEgress: /*#__PURE__*/ z.string().max(64).optional(),
        engineBoxReachable: /*#__PURE__*/ z.boolean().nullable(),
        probedAt: /*#__PURE__*/ z.string()
    }).optional(),
    inFlight: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(200)).max(1000).optional(),
    version: /*#__PURE__*/ z.string().min(1).max(100).optional()
});

export const zHeartbeatAiWorkerPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Heartbeat accepted
 */
export const zHeartbeatAiWorkerResponse = /*#__PURE__*/ z.void();

export const zPollAiWorkerCommandsBody = /*#__PURE__*/ z.object({
    blockMs: /*#__PURE__*/ z.int().gte(0).lte(25000).optional(),
    maxCommands: /*#__PURE__*/ z.int().gte(1).lte(10).optional()
});

export const zPollAiWorkerCommandsPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Pending commands
 */
export const zPollAiWorkerCommandsResponse = /*#__PURE__*/ z.object({
    cursor: /*#__PURE__*/ z.string(),
    commands: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        command: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                type: /*#__PURE__*/ z.enum(['ai:complete']),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                model: /*#__PURE__*/ z.string(),
                modelId: /*#__PURE__*/ z.int().gt(0).optional(),
                surface: /*#__PURE__*/ z.enum([
                    'conversation',
                    'workforce',
                    'workflow',
                    'analysis',
                    'evaluation',
                    'judge',
                    'codegen',
                    'system',
                    'research'
                ]).optional(),
                messages: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    role: /*#__PURE__*/ z.enum([
                        'system',
                        'user',
                        'assistant',
                        'tool'
                    ]),
                    content: /*#__PURE__*/ z.unknown().optional(),
                    toolCalls: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).optional(),
                    toolCallId: /*#__PURE__*/ z.string().optional(),
                    toolName: /*#__PURE__*/ z.string().optional(),
                    isError: /*#__PURE__*/ z.boolean().optional()
                })),
                maxTokens: /*#__PURE__*/ z.int().gt(0).optional(),
                temperature: /*#__PURE__*/ z.number().optional(),
                responseFormat: /*#__PURE__*/ z.enum(['text', 'json']).optional(),
                responseSchema: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
                thinking: /*#__PURE__*/ z.boolean().optional(),
                tools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    name: /*#__PURE__*/ z.string(),
                    description: /*#__PURE__*/ z.string(),
                    inputSchema: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown())
                })).optional(),
                toolExecutionContext: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
                stream: /*#__PURE__*/ z.boolean().optional(),
                runtimePolicy: /*#__PURE__*/ z.object({
                    id: /*#__PURE__*/ z.number().nullable(),
                    organizationId: /*#__PURE__*/ z.number().nullable(),
                    slug: /*#__PURE__*/ z.string(),
                    name: /*#__PURE__*/ z.string(),
                    version: /*#__PURE__*/ z.int().gt(0),
                    purpose: /*#__PURE__*/ z.enum([
                        'interactive',
                        'background',
                        'evaluation',
                        'daemon',
                        'workflow',
                        'debug',
                        'bulk'
                    ]),
                    riskTier: /*#__PURE__*/ z.enum([
                        'low',
                        'medium',
                        'high',
                        'privileged'
                    ]),
                    latencyClass: /*#__PURE__*/ z.enum([
                        'realtime',
                        'interactive',
                        'batch'
                    ]),
                    costTier: /*#__PURE__*/ z.enum([
                        'free',
                        'low',
                        'medium',
                        'high'
                    ]),
                    permissionTier: /*#__PURE__*/ z.enum([
                        'observer',
                        'contributor',
                        'operator'
                    ]),
                    tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                    wallClockTimeoutMs: /*#__PURE__*/ z.int().gt(0),
                    providerRequestTimeoutMs: /*#__PURE__*/ z.int().gt(0),
                    idleTimeoutMs: /*#__PURE__*/ z.int().gt(0).nullable(),
                    maxInputTokens: /*#__PURE__*/ z.int().gt(0).nullable(),
                    maxOutputTokens: /*#__PURE__*/ z.int().gt(0),
                    maxSystemPromptChars: /*#__PURE__*/ z.int().gt(0).nullable(),
                    maxConcurrentRequests: /*#__PURE__*/ z.int().gt(0).nullish(),
                    maxToolCalls: /*#__PURE__*/ z.int().gte(0),
                    maxTurns: /*#__PURE__*/ z.int().gt(0),
                    retryMax: /*#__PURE__*/ z.int().gte(0),
                    retryBackoffMs: /*#__PURE__*/ z.int().gte(0),
                    retryBackoffMultiplier: /*#__PURE__*/ z.number().gt(0),
                    retryJitter: /*#__PURE__*/ z.boolean(),
                    spendCapUsd: /*#__PURE__*/ z.number().gte(0).nullable(),
                    permissionMode: /*#__PURE__*/ z.enum([
                        'provider_default',
                        'read_only',
                        'workspace_write',
                        'full_auto',
                        'bypass_permissions'
                    ]),
                    allowedProviderTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                    streamingEnabled: /*#__PURE__*/ z.boolean(),
                    sessionMode: /*#__PURE__*/ z.enum([
                        'provider_default',
                        'stateless',
                        'reuse_session'
                    ]),
                    promptCachingEnabled: /*#__PURE__*/ z.boolean(),
                    providerExtensions: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
                    models: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        id: /*#__PURE__*/ z.int().gt(0),
                        slug: /*#__PURE__*/ z.string().min(1)
                    })).optional().default([]),
                    fallbackPolicyId: /*#__PURE__*/ z.int().gt(0).nullish().default(null),
                    thinking: /*#__PURE__*/ z.enum([
                        'model_default',
                        'on',
                        'off'
                    ]).optional().default('model_default')
                }).optional(),
                traceparent: /*#__PURE__*/ z.string().optional(),
                tracestate: /*#__PURE__*/ z.string().optional(),
                workflowRunId: /*#__PURE__*/ z.string().optional(),
                stepId: /*#__PURE__*/ z.string().optional(),
                workspace: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    patchChain: /*#__PURE__*/ z.object({
                        links: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                            baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                            patch: /*#__PURE__*/ z.string().max(2097152),
                            message: /*#__PURE__*/ z.string().min(1).max(2000),
                            authoredAt: /*#__PURE__*/ z.iso.datetime(),
                            patchHash: /*#__PURE__*/ z.string().min(1)
                        })).max(500)
                    }),
                    commitMessage: /*#__PURE__*/ z.string().min(1).max(2000)
                }).optional()
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                type: /*#__PURE__*/ z.enum(['ai:embed']),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                model: /*#__PURE__*/ z.string().min(1),
                inputs: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(8000)).min(1).max(64),
                normalize: /*#__PURE__*/ z.boolean().optional().default(true)
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                type: /*#__PURE__*/ z.enum(['ai:rerank']),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                model: /*#__PURE__*/ z.string().min(1),
                query: /*#__PURE__*/ z.string().max(8000),
                documents: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(8000)).min(1).max(150)
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                type: /*#__PURE__*/ z.enum(['ai:finetune']),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                baseModel: /*#__PURE__*/ z.string().min(1),
                datasetArtifactId: /*#__PURE__*/ z.int().gt(0),
                dataset: /*#__PURE__*/ z.object({
                    encoding: /*#__PURE__*/ z.enum(['jsonl+gzip+base64']),
                    sha256: /*#__PURE__*/ z.string().regex(/^[0-9a-f]{64}$/),
                    examples: /*#__PURE__*/ z.int().gte(50).lte(20000),
                    platforms: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(40)).min(1).max(12),
                    payload: /*#__PURE__*/ z.string().min(1).max(16777216)
                }),
                adapterName: /*#__PURE__*/ z.string().regex(/^account-adapter:(\d{1,19}):([A-Za-z0-9_.-]{1,40}):(\d{1,6})$/),
                hyper: /*#__PURE__*/ z.object({
                    rank: /*#__PURE__*/ z.int().gte(4).lte(64),
                    alpha: /*#__PURE__*/ z.int().gte(1).lte(256),
                    lr: /*#__PURE__*/ z.number().gt(0).lte(0.01),
                    epochs: /*#__PURE__*/ z.int().gte(1).lte(5),
                    seqLen: /*#__PURE__*/ z.int().gte(256).lte(8192),
                    seed: /*#__PURE__*/ z.int().gte(0).optional().default(3407)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:sandbox.run']),
                snapshot: /*#__PURE__*/ z.object({
                    repo: /*#__PURE__*/ z.string().optional(),
                    ref: /*#__PURE__*/ z.string().optional(),
                    commitSha: /*#__PURE__*/ z.string().optional(),
                    sparsePaths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/).optional(),
                    patchChain: /*#__PURE__*/ z.object({
                        links: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                            baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                            patch: /*#__PURE__*/ z.string().max(2097152),
                            message: /*#__PURE__*/ z.string().min(1).max(2000),
                            authoredAt: /*#__PURE__*/ z.iso.datetime(),
                            patchHash: /*#__PURE__*/ z.string().min(1)
                        })).max(500)
                    }).optional()
                }).optional(),
                command: /*#__PURE__*/ z.object({
                    name: /*#__PURE__*/ z.string(),
                    command: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                    cwd: /*#__PURE__*/ z.string().optional(),
                    env: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional(),
                    profile: /*#__PURE__*/ z.object({
                        image: /*#__PURE__*/ z.string().optional(),
                        network: /*#__PURE__*/ z.enum([
                            'none',
                            'vuln-db',
                            'external-research'
                        ]),
                        readOnly: /*#__PURE__*/ z.boolean(),
                        timeoutMs: /*#__PURE__*/ z.int().gt(0).optional(),
                        memoryMb: /*#__PURE__*/ z.int().gt(0).optional(),
                        cpuCount: /*#__PURE__*/ z.number().gt(0).optional(),
                        allowedEnv: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([])
                    })
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:repoSnapshot.read']),
                request: /*#__PURE__*/ z.object({
                    snapshot: /*#__PURE__*/ z.object({
                        repo: /*#__PURE__*/ z.string(),
                        ref: /*#__PURE__*/ z.string().optional(),
                        commitSha: /*#__PURE__*/ z.string(),
                        sparsePaths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
                    }),
                    paths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).min(1),
                    maxBytesPerFile: /*#__PURE__*/ z.int().gt(0).optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.prepare']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    repoUrl: /*#__PURE__*/ z.string().max(4000).optional(),
                    ref: /*#__PURE__*/ z.string().max(200).optional(),
                    commitSha: /*#__PURE__*/ z.string().min(7).max(80).optional(),
                    patchChain: /*#__PURE__*/ z.object({
                        links: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                            baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                            patch: /*#__PURE__*/ z.string().max(2097152),
                            message: /*#__PURE__*/ z.string().min(1).max(2000),
                            authoredAt: /*#__PURE__*/ z.iso.datetime(),
                            patchHash: /*#__PURE__*/ z.string().min(1)
                        })).max(500)
                    }).optional(),
                    auth: /*#__PURE__*/ z.object({
                        username: /*#__PURE__*/ z.string().min(1).max(200),
                        password: /*#__PURE__*/ z.string().min(1).max(4096)
                    }).optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.listFiles']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    maxFiles: /*#__PURE__*/ z.int().gt(0).lte(10000).optional().default(1000)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.readFiles']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    paths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(4096)).min(1).max(100),
                    maxBytesPerFile: /*#__PURE__*/ z.int().gt(0).lte(5242880).optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.writeBatch']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    files: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        path: /*#__PURE__*/ z.string().min(1).max(4096),
                        contentBase64: /*#__PURE__*/ z.string().max(6990511),
                        executable: /*#__PURE__*/ z.boolean().optional().default(false)
                    })).max(200).optional().default([]),
                    deletePaths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(4096)).max(200).optional().default([]),
                    expectedHeadSha: /*#__PURE__*/ z.string().min(7).max(80).nullish()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.applyPatch']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    patch: /*#__PURE__*/ z.string().min(1).max(10485760),
                    expectedHeadSha: /*#__PURE__*/ z.string().min(7).max(80).nullish()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.diff']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    baseRef: /*#__PURE__*/ z.string().max(200).optional(),
                    paths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(4096)).max(200).optional(),
                    maxBytes: /*#__PURE__*/ z.int().gt(0).lte(10485760).optional().default(1048576)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.commit']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    message: /*#__PURE__*/ z.string().min(1).max(4000),
                    expectedHeadSha: /*#__PURE__*/ z.string().min(7).max(80).nullish(),
                    authorName: /*#__PURE__*/ z.string().min(1).max(200).optional(),
                    authorEmail: /*#__PURE__*/ z.email().optional(),
                    captureLink: /*#__PURE__*/ z.boolean().optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.revert']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                    expectedHeadSha: /*#__PURE__*/ z.string().min(7).max(80).nullish(),
                    message: /*#__PURE__*/ z.string().max(4000).optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.runCommand']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    command: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(1000)).min(1).max(50),
                    cwd: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    env: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional().default({}),
                    timeoutMs: /*#__PURE__*/ z.int().gt(0).lte(600000).optional().default(60000),
                    maxOutputBytes: /*#__PURE__*/ z.int().gt(0).lte(1048576).optional().default(131072)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.push']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    branch: /*#__PURE__*/ z.string().min(1).max(200),
                    remote: /*#__PURE__*/ z.string().min(1).max(200).optional().default('origin'),
                    auth: /*#__PURE__*/ z.object({
                        username: /*#__PURE__*/ z.string().min(1).max(200),
                        password: /*#__PURE__*/ z.string().min(1).max(4096)
                    }).optional(),
                    timeoutMs: /*#__PURE__*/ z.int().gt(0).lte(600000).optional().default(120000)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.cleanup']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:workspace.compactChain']),
                request: /*#__PURE__*/ z.object({
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    directPath: /*#__PURE__*/ z.string().min(1).max(4096).optional(),
                    patchChain: /*#__PURE__*/ z.object({
                        links: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                            baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                            patch: /*#__PURE__*/ z.string().max(2097152),
                            message: /*#__PURE__*/ z.string().min(1).max(2000),
                            authoredAt: /*#__PURE__*/ z.iso.datetime(),
                            patchHash: /*#__PURE__*/ z.string().min(1)
                        })).max(500)
                    })
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:codePreview.start']),
                request: /*#__PURE__*/ z.object({
                    organizationId: /*#__PURE__*/ z.int().gt(0),
                    projectId: /*#__PURE__*/ z.int().gt(0),
                    workstreamId: /*#__PURE__*/ z.int().gt(0),
                    versionId: /*#__PURE__*/ z.int().gt(0),
                    sessionId: /*#__PURE__*/ z.string().min(1),
                    mode: /*#__PURE__*/ z.enum([
                        'mock',
                        'real',
                        'mixed'
                    ]),
                    workspaceId: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[A-Za-z0-9_.:-]+$/),
                    patchChain: /*#__PURE__*/ z.object({
                        links: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                            commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                            baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                            patch: /*#__PURE__*/ z.string().max(2097152),
                            message: /*#__PURE__*/ z.string().min(1).max(2000),
                            authoredAt: /*#__PURE__*/ z.iso.datetime(),
                            patchHash: /*#__PURE__*/ z.string().min(1)
                        })).max(500)
                    }),
                    launch: /*#__PURE__*/ z.object({
                        image: /*#__PURE__*/ z.string().min(1).max(200).regex(/^[a-zA-Z0-9][a-zA-Z0-9._:\/@-]*$/),
                        install: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(500)).max(40).optional().default([]),
                        start: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(500)).min(1).max(40),
                        port: /*#__PURE__*/ z.int().gte(1024).lte(65535).optional().default(5173),
                        workdir: /*#__PURE__*/ z.string().min(1).max(200).optional().default('/workspace'),
                        env: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string().max(2048)).optional().default({}),
                        readinessPath: /*#__PURE__*/ z.string().min(1).max(200).regex(/^\/[^\0\\]*$/).optional().default('/'),
                        readinessTimeoutMs: /*#__PURE__*/ z.int().gt(0).lte(900000).optional().default(60000)
                    })
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:codePreview.stop']),
                request: /*#__PURE__*/ z.object({
                    sessionId: /*#__PURE__*/ z.string().min(1)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:codePreview.proxy']),
                request: /*#__PURE__*/ z.object({
                    sessionId: /*#__PURE__*/ z.string().min(1),
                    target: /*#__PURE__*/ z.object({
                        kind: /*#__PURE__*/ z.enum(['worker_local_http']),
                        baseUrl: /*#__PURE__*/ z.string().min(1)
                    }),
                    method: /*#__PURE__*/ z.enum([
                        'GET',
                        'HEAD',
                        'POST',
                        'PUT',
                        'PATCH',
                        'DELETE',
                        'OPTIONS'
                    ]),
                    path: /*#__PURE__*/ z.string().min(1).max(2048),
                    search: /*#__PURE__*/ z.string().max(4096).optional(),
                    headers: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional().default({}),
                    bodyBase64: /*#__PURE__*/ z.string().max(13981018).optional(),
                    maxResponseBytes: /*#__PURE__*/ z.int().gt(0).lte(10485760).optional().default(2097152),
                    timeoutMs: /*#__PURE__*/ z.int().gt(0).lte(60000).optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:content.discoverSource']),
                request: /*#__PURE__*/ z.object({
                    platform: /*#__PURE__*/ z.enum([
                        'youtube',
                        'x',
                        'rss',
                        'discord',
                        'web',
                        'github'
                    ]),
                    identifier: /*#__PURE__*/ z.string().min(1).max(2000)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:content.listItems']),
                request: /*#__PURE__*/ z.object({
                    platform: /*#__PURE__*/ z.enum([
                        'youtube',
                        'x',
                        'rss',
                        'discord',
                        'web',
                        'github'
                    ]),
                    sourceRef: /*#__PURE__*/ z.object({
                        externalId: /*#__PURE__*/ z.string().min(1).max(2000).optional(),
                        handle: /*#__PURE__*/ z.string().min(1).max(200).optional(),
                        uploadsPlaylistId: /*#__PURE__*/ z.string().min(1).max(200).optional()
                    }),
                    mode: /*#__PURE__*/ z.enum(['rss', 'api']),
                    cursor: /*#__PURE__*/ z.string().max(500).optional(),
                    since: /*#__PURE__*/ z.iso.datetime().optional(),
                    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional().default(20)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:content.fetchItem']),
                request: /*#__PURE__*/ z.object({
                    platform: /*#__PURE__*/ z.enum([
                        'youtube',
                        'x',
                        'rss',
                        'discord',
                        'web',
                        'github'
                    ]),
                    itemRef: /*#__PURE__*/ z.object({
                        externalId: /*#__PURE__*/ z.string().min(1).max(2000)
                    }),
                    want: /*#__PURE__*/ z.array(/*#__PURE__*/ z.enum([
                        'metadata',
                        'transcript',
                        'text'
                    ])).min(1),
                    languages: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(2).max(10)).max(5).optional(),
                    rawCapture: /*#__PURE__*/ z.boolean().optional().default(false)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:content.analyzeMedia']),
                request: /*#__PURE__*/ z.object({
                    platform: /*#__PURE__*/ z.enum(['youtube']),
                    itemRef: /*#__PURE__*/ z.object({
                        externalId: /*#__PURE__*/ z.string().regex(/^[A-Za-z0-9_-]{11}$/)
                    }),
                    languages: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().regex(/^[a-zA-Z-]{2,10}$/)).max(5).optional(),
                    limits: /*#__PURE__*/ z.object({
                        maxBytes: /*#__PURE__*/ z.int().gt(0).lte(8589934592).optional().default(2147483648),
                        maxDurationSeconds: /*#__PURE__*/ z.int().gt(0).lte(21600).optional().default(14400),
                        maxFrames: /*#__PURE__*/ z.int().gte(0).lte(48).optional().default(24)
                    }),
                    analysis: /*#__PURE__*/ z.object({
                        model: /*#__PURE__*/ z.string().min(1).max(120).optional(),
                        systemPrompt: /*#__PURE__*/ z.string().min(1).max(60000),
                        userPrompt: /*#__PURE__*/ z.string().min(1).max(60000),
                        responseSchema: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
                        runtimePolicy: /*#__PURE__*/ z.object({
                            id: /*#__PURE__*/ z.number().nullable(),
                            organizationId: /*#__PURE__*/ z.number().nullable(),
                            slug: /*#__PURE__*/ z.string(),
                            name: /*#__PURE__*/ z.string(),
                            version: /*#__PURE__*/ z.int().gt(0),
                            purpose: /*#__PURE__*/ z.enum([
                                'interactive',
                                'background',
                                'evaluation',
                                'daemon',
                                'workflow',
                                'debug',
                                'bulk'
                            ]),
                            riskTier: /*#__PURE__*/ z.enum([
                                'low',
                                'medium',
                                'high',
                                'privileged'
                            ]),
                            latencyClass: /*#__PURE__*/ z.enum([
                                'realtime',
                                'interactive',
                                'batch'
                            ]),
                            costTier: /*#__PURE__*/ z.enum([
                                'free',
                                'low',
                                'medium',
                                'high'
                            ]),
                            permissionTier: /*#__PURE__*/ z.enum([
                                'observer',
                                'contributor',
                                'operator'
                            ]),
                            tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                            wallClockTimeoutMs: /*#__PURE__*/ z.int().gt(0),
                            providerRequestTimeoutMs: /*#__PURE__*/ z.int().gt(0),
                            idleTimeoutMs: /*#__PURE__*/ z.int().gt(0).nullable(),
                            maxInputTokens: /*#__PURE__*/ z.int().gt(0).nullable(),
                            maxOutputTokens: /*#__PURE__*/ z.int().gt(0),
                            maxSystemPromptChars: /*#__PURE__*/ z.int().gt(0).nullable(),
                            maxConcurrentRequests: /*#__PURE__*/ z.int().gt(0).nullish(),
                            maxToolCalls: /*#__PURE__*/ z.int().gte(0),
                            maxTurns: /*#__PURE__*/ z.int().gt(0),
                            retryMax: /*#__PURE__*/ z.int().gte(0),
                            retryBackoffMs: /*#__PURE__*/ z.int().gte(0),
                            retryBackoffMultiplier: /*#__PURE__*/ z.number().gt(0),
                            retryJitter: /*#__PURE__*/ z.boolean(),
                            spendCapUsd: /*#__PURE__*/ z.number().gte(0).nullable(),
                            permissionMode: /*#__PURE__*/ z.enum([
                                'provider_default',
                                'read_only',
                                'workspace_write',
                                'full_auto',
                                'bypass_permissions'
                            ]),
                            allowedProviderTools: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                            streamingEnabled: /*#__PURE__*/ z.boolean(),
                            sessionMode: /*#__PURE__*/ z.enum([
                                'provider_default',
                                'stateless',
                                'reuse_session'
                            ]),
                            promptCachingEnabled: /*#__PURE__*/ z.boolean(),
                            providerExtensions: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()),
                            models: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                id: /*#__PURE__*/ z.int().gt(0),
                                slug: /*#__PURE__*/ z.string().min(1)
                            })).optional().default([]),
                            fallbackPolicyId: /*#__PURE__*/ z.int().gt(0).nullish().default(null),
                            thinking: /*#__PURE__*/ z.enum([
                                'model_default',
                                'on',
                                'off'
                            ]).optional().default('model_default')
                        }),
                        maxTokens: /*#__PURE__*/ z.int().gt(0).optional()
                    })
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:content.search']),
                request: /*#__PURE__*/ z.object({
                    platform: /*#__PURE__*/ z.enum(['youtube', 'github']),
                    query: /*#__PURE__*/ z.string().min(1).max(200),
                    limit: /*#__PURE__*/ z.int().gt(0).lte(50).optional().default(20),
                    since: /*#__PURE__*/ z.iso.datetime().optional()
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.string().regex(/^worker:[a-z][a-z0-9]*\.[a-zA-Z][a-zA-Z0-9]*$/),
                request: /*#__PURE__*/ z.unknown().optional()
            })
        ])
    }))
});

export const zPollAiWorkerControlCommandsBody = /*#__PURE__*/ z.object({
    blockMs: /*#__PURE__*/ z.int().gte(0).lte(25000).optional(),
    maxCommands: /*#__PURE__*/ z.int().gte(1).lte(10).optional()
});

export const zPollAiWorkerControlCommandsPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Cancels for commands this worker already holds
 */
export const zPollAiWorkerControlCommandsResponse = /*#__PURE__*/ z.object({
    commands: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.string(),
        command: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['worker:content.cancel']),
                request: /*#__PURE__*/ z.object({
                    requestId: /*#__PURE__*/ z.string().min(1).max(200)
                })
            }),
            /*#__PURE__*/ z.object({
                enqueuedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                expiresAt: /*#__PURE__*/ z.iso.datetime().optional(),
                requestId: /*#__PURE__*/ z.string(),
                source: /*#__PURE__*/ z.enum(['engine', 'server']),
                organizationId: /*#__PURE__*/ z.number().optional(),
                trustScope: /*#__PURE__*/ z.enum(['system', 'org']),
                requiredCapabilities: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional().default([]),
                type: /*#__PURE__*/ z.enum(['ai:cancel']),
                request: /*#__PURE__*/ z.object({
                    requestId: /*#__PURE__*/ z.string().min(1).max(200)
                })
            })
        ])
    }))
});

export const zPublishAiWorkerEventsBody = /*#__PURE__*/ z.object({
    events: /*#__PURE__*/ z.array(/*#__PURE__*/ z.union([
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.embedded']),
            requestId: /*#__PURE__*/ z.string(),
            vectors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.array(/*#__PURE__*/ z.number())),
            model: /*#__PURE__*/ z.string(),
            dims: /*#__PURE__*/ z.int().gt(0)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.reranked']),
            requestId: /*#__PURE__*/ z.string(),
            scores: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number())
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.finetune.progress']),
            requestId: /*#__PURE__*/ z.string(),
            phase: /*#__PURE__*/ z.enum([
                'preparing',
                'loading',
                'training',
                'saving'
            ]),
            step: /*#__PURE__*/ z.int().gte(0).optional(),
            totalSteps: /*#__PURE__*/ z.int().gte(0).optional(),
            epoch: /*#__PURE__*/ z.number().gte(0).optional(),
            loss: /*#__PURE__*/ z.number().optional(),
            tokensPerSecond: /*#__PURE__*/ z.number().gte(0).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.finetuned']),
            requestId: /*#__PURE__*/ z.string(),
            adapterSlug: /*#__PURE__*/ z.string().regex(/^account-adapter:(\d{1,19}):([A-Za-z0-9_.-]{1,40}):(\d{1,6})$/),
            metrics: /*#__PURE__*/ z.object({
                trainLoss: /*#__PURE__*/ z.number().nullable(),
                steps: /*#__PURE__*/ z.int().gte(0),
                epochs: /*#__PURE__*/ z.number().gte(0),
                trainTokens: /*#__PURE__*/ z.int().gte(0),
                runtimeSeconds: /*#__PURE__*/ z.number().gte(0),
                tokensPerSecond: /*#__PURE__*/ z.number().gte(0),
                peakMemoryGiB: /*#__PURE__*/ z.number().gte(0).nullable()
            }),
            modelCard: /*#__PURE__*/ z.object({
                contract: /*#__PURE__*/ z.enum(['adapter-model-card-v1']),
                adapterSlug: /*#__PURE__*/ z.string().regex(/^account-adapter:(\d{1,19}):([A-Za-z0-9_.-]{1,40}):(\d{1,6})$/),
                baseModel: /*#__PURE__*/ z.string().min(1),
                servedBasePath: /*#__PURE__*/ z.string().min(1),
                baseRevision: /*#__PURE__*/ z.string().nullable(),
                trainingBasePath: /*#__PURE__*/ z.string().min(1),
                datasetArtifactId: /*#__PURE__*/ z.int().gt(0),
                datasetSha256: /*#__PURE__*/ z.string().regex(/^[0-9a-f]{64}$/),
                examples: /*#__PURE__*/ z.int().gte(0),
                examplesByKind: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.int().gte(0)),
                platforms: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                hyper: /*#__PURE__*/ z.object({
                    rank: /*#__PURE__*/ z.int().gte(4).lte(64),
                    alpha: /*#__PURE__*/ z.int().gte(1).lte(256),
                    lr: /*#__PURE__*/ z.number().gt(0).lte(0.01),
                    epochs: /*#__PURE__*/ z.int().gte(1).lte(5),
                    seqLen: /*#__PURE__*/ z.int().gte(256).lte(8192),
                    seed: /*#__PURE__*/ z.int().gte(0).optional().default(3407)
                }),
                targetModules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                method: /*#__PURE__*/ z.enum(['qlora-4bit', 'lora-bf16']),
                runtime: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()),
                metrics: /*#__PURE__*/ z.object({
                    trainLoss: /*#__PURE__*/ z.number().nullable(),
                    steps: /*#__PURE__*/ z.int().gte(0),
                    epochs: /*#__PURE__*/ z.number().gte(0),
                    trainTokens: /*#__PURE__*/ z.int().gte(0),
                    runtimeSeconds: /*#__PURE__*/ z.number().gte(0),
                    tokensPerSecond: /*#__PURE__*/ z.number().gte(0),
                    peakMemoryGiB: /*#__PURE__*/ z.number().gte(0).nullable()
                }),
                evalScores: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number()),
                createdAt: /*#__PURE__*/ z.iso.datetime()
            })
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.started']),
            requestId: /*#__PURE__*/ z.string(),
            workerId: /*#__PURE__*/ z.string(),
            model: /*#__PURE__*/ z.string()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.delta']),
            requestId: /*#__PURE__*/ z.string(),
            delta: /*#__PURE__*/ z.string(),
            index: /*#__PURE__*/ z.int().gte(0)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.completed']),
            requestId: /*#__PURE__*/ z.string(),
            content: /*#__PURE__*/ z.string(),
            model: /*#__PURE__*/ z.string(),
            modelSlug: /*#__PURE__*/ z.string().optional(),
            usage: /*#__PURE__*/ z.object({
                promptTokens: /*#__PURE__*/ z.int().gte(0),
                completionTokens: /*#__PURE__*/ z.int().gte(0),
                totalTokens: /*#__PURE__*/ z.int().gte(0)
            }).optional(),
            toolCalls: /*#__PURE__*/ z.array(/*#__PURE__*/ z.unknown()).optional(),
            finishReason: /*#__PURE__*/ z.string().optional(),
            traceId: /*#__PURE__*/ z.string().optional(),
            spanId: /*#__PURE__*/ z.string().optional(),
            workspace: /*#__PURE__*/ z.object({
                changed: /*#__PURE__*/ z.boolean(),
                link: /*#__PURE__*/ z.object({
                    commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                    baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                    patch: /*#__PURE__*/ z.string().max(2097152),
                    message: /*#__PURE__*/ z.string().min(1).max(2000),
                    authoredAt: /*#__PURE__*/ z.iso.datetime(),
                    patchHash: /*#__PURE__*/ z.string().min(1)
                }).nullable(),
                changedFiles: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(4096))
            }).optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.error']),
            requestId: /*#__PURE__*/ z.string(),
            code: /*#__PURE__*/ z.string(),
            message: /*#__PURE__*/ z.string(),
            retryable: /*#__PURE__*/ z.boolean()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['ai.end']),
            requestId: /*#__PURE__*/ z.string()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['worker.started']),
            requestId: /*#__PURE__*/ z.string(),
            workerId: /*#__PURE__*/ z.string(),
            commandType: /*#__PURE__*/ z.string()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['worker.sandbox.completed']),
            requestId: /*#__PURE__*/ z.string(),
            result: /*#__PURE__*/ z.object({
                name: /*#__PURE__*/ z.string(),
                command: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                exitCode: /*#__PURE__*/ z.int(),
                stdout: /*#__PURE__*/ z.string(),
                stderr: /*#__PURE__*/ z.string(),
                durationMs: /*#__PURE__*/ z.int().gte(0),
                timedOut: /*#__PURE__*/ z.boolean()
            }),
            workspaceId: /*#__PURE__*/ z.string(),
            commitSha: /*#__PURE__*/ z.string().optional()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['worker.repoSnapshot.completed']),
            requestId: /*#__PURE__*/ z.string(),
            result: /*#__PURE__*/ z.object({
                repo: /*#__PURE__*/ z.string(),
                ref: /*#__PURE__*/ z.string().nullish(),
                commitSha: /*#__PURE__*/ z.string().optional(),
                workspaceId: /*#__PURE__*/ z.string(),
                files: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    path: /*#__PURE__*/ z.string(),
                    content: /*#__PURE__*/ z.string(),
                    sizeBytes: /*#__PURE__*/ z.int().gte(0),
                    truncated: /*#__PURE__*/ z.boolean()
                })),
                errors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    path: /*#__PURE__*/ z.string(),
                    error: /*#__PURE__*/ z.string()
                })),
                audit: /*#__PURE__*/ z.object({
                    worker: /*#__PURE__*/ z.enum(['system']),
                    operation: /*#__PURE__*/ z.enum(['repo-snapshot-read']),
                    requestedPaths: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
                    returnedFiles: /*#__PURE__*/ z.int().gte(0),
                    maxBytesPerFile: /*#__PURE__*/ z.int().gt(0)
                })
            })
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['worker.workspace.completed']),
            requestId: /*#__PURE__*/ z.string(),
            result: /*#__PURE__*/ z.object({
                workspaceId: /*#__PURE__*/ z.string(),
                operation: /*#__PURE__*/ z.enum([
                    'worker:workspace.prepare',
                    'worker:workspace.listFiles',
                    'worker:workspace.readFiles',
                    'worker:workspace.writeBatch',
                    'worker:workspace.applyPatch',
                    'worker:workspace.diff',
                    'worker:workspace.commit',
                    'worker:workspace.revert',
                    'worker:workspace.runCommand',
                    'worker:workspace.push',
                    'worker:workspace.cleanup',
                    'worker:workspace.compactChain'
                ]),
                changedFiles: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(4096)).optional().default([]),
                changedBytes: /*#__PURE__*/ z.int().gte(0).optional().default(0),
                baseCommitSha: /*#__PURE__*/ z.string().nullish(),
                headCommitSha: /*#__PURE__*/ z.string().nullish(),
                patchHash: /*#__PURE__*/ z.string().nullish(),
                link: /*#__PURE__*/ z.object({
                    commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                    baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                    patch: /*#__PURE__*/ z.string().max(2097152),
                    message: /*#__PURE__*/ z.string().min(1).max(2000),
                    authoredAt: /*#__PURE__*/ z.iso.datetime(),
                    patchHash: /*#__PURE__*/ z.string().min(1)
                }).optional(),
                compaction: /*#__PURE__*/ z.object({
                    links: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                        link: /*#__PURE__*/ z.object({
                            commitSha: /*#__PURE__*/ z.string().min(7).max(80),
                            baseCommitSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                            patch: /*#__PURE__*/ z.string().max(2097152),
                            message: /*#__PURE__*/ z.string().min(1).max(2000),
                            authoredAt: /*#__PURE__*/ z.iso.datetime(),
                            patchHash: /*#__PURE__*/ z.string().min(1)
                        }),
                        changedFiles: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(4096))
                    })),
                    previousHeadSha: /*#__PURE__*/ z.string().min(7).max(80).nullable(),
                    previousTreeSha: /*#__PURE__*/ z.string().min(7).max(80),
                    treeSha: /*#__PURE__*/ z.string().min(7).max(80),
                    fileCount: /*#__PURE__*/ z.int().gte(0)
                }).optional(),
                files: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                    path: /*#__PURE__*/ z.string().min(1).max(4096),
                    contentBase64: /*#__PURE__*/ z.string().optional(),
                    sizeBytes: /*#__PURE__*/ z.int().gte(0),
                    truncated: /*#__PURE__*/ z.boolean().optional().default(false),
                    mode: /*#__PURE__*/ z.enum(['100644', '100755']).optional()
                })).optional(),
                diff: /*#__PURE__*/ z.string().optional(),
                stdout: /*#__PURE__*/ z.string().optional(),
                stderr: /*#__PURE__*/ z.string().optional(),
                exitCode: /*#__PURE__*/ z.int().optional(),
                timedOut: /*#__PURE__*/ z.boolean().optional(),
                audit: /*#__PURE__*/ z.object({
                    worker: /*#__PURE__*/ z.string(),
                    operation: /*#__PURE__*/ z.enum([
                        'worker:workspace.prepare',
                        'worker:workspace.listFiles',
                        'worker:workspace.readFiles',
                        'worker:workspace.writeBatch',
                        'worker:workspace.applyPatch',
                        'worker:workspace.diff',
                        'worker:workspace.commit',
                        'worker:workspace.revert',
                        'worker:workspace.runCommand',
                        'worker:workspace.push',
                        'worker:workspace.cleanup',
                        'worker:workspace.compactChain'
                    ]),
                    directPath: /*#__PURE__*/ z.boolean()
                })
            })
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['preview.target.ready']),
            requestId: /*#__PURE__*/ z.string(),
            workerId: /*#__PURE__*/ z.string(),
            organizationId: /*#__PURE__*/ z.int().gt(0),
            projectId: /*#__PURE__*/ z.int().gt(0),
            workstreamId: /*#__PURE__*/ z.int().gt(0),
            versionId: /*#__PURE__*/ z.int().gt(0),
            sessionId: /*#__PURE__*/ z.string().min(1),
            mode: /*#__PURE__*/ z.enum([
                'mock',
                'real',
                'mixed'
            ]),
            target: /*#__PURE__*/ z.object({
                kind: /*#__PURE__*/ z.enum(['worker_local_http']),
                baseUrl: /*#__PURE__*/ z.string().min(1)
            })
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['preview.stopped']),
            requestId: /*#__PURE__*/ z.string(),
            workerId: /*#__PURE__*/ z.string(),
            sessionId: /*#__PURE__*/ z.string().min(1)
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['preview.proxy.completed']),
            requestId: /*#__PURE__*/ z.string(),
            response: /*#__PURE__*/ z.object({
                status: /*#__PURE__*/ z.int().gte(100).lte(599),
                statusText: /*#__PURE__*/ z.string(),
                headers: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional().default({}),
                bodyBase64: /*#__PURE__*/ z.string().max(13981018)
            })
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['worker.error']),
            requestId: /*#__PURE__*/ z.string(),
            code: /*#__PURE__*/ z.string(),
            message: /*#__PURE__*/ z.string(),
            retryable: /*#__PURE__*/ z.boolean()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['worker.end']),
            requestId: /*#__PURE__*/ z.string()
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['worker.content.completed']),
            requestId: /*#__PURE__*/ z.string(),
            result: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.object({
                    operation: /*#__PURE__*/ z.enum(['discoverSource']),
                    outcome: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['ok']),
                            identity: /*#__PURE__*/ z.object({
                                platform: /*#__PURE__*/ z.enum([
                                    'youtube',
                                    'x',
                                    'rss',
                                    'discord',
                                    'web',
                                    'github'
                                ]),
                                externalId: /*#__PURE__*/ z.string(),
                                handle: /*#__PURE__*/ z.string().optional(),
                                displayName: /*#__PURE__*/ z.string(),
                                description: /*#__PURE__*/ z.string().optional(),
                                profileUrl: /*#__PURE__*/ z.string().optional(),
                                avatarUrl: /*#__PURE__*/ z.string().optional(),
                                uploadsPlaylistId: /*#__PURE__*/ z.string().optional(),
                                followerCount: /*#__PURE__*/ z.int().gte(0).optional(),
                                postCount: /*#__PURE__*/ z.int().gte(0).optional(),
                                country: /*#__PURE__*/ z.string().optional(),
                                topics: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional()
                            })
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['error']),
                            error: /*#__PURE__*/ z.object({
                                code: /*#__PURE__*/ z.enum([
                                    'quota_exhausted',
                                    'rate_limited',
                                    'ip_blocked',
                                    'po_token_required',
                                    'not_found',
                                    'captions_unavailable',
                                    'budget_exceeded',
                                    'credentials_missing',
                                    'upstream_error',
                                    'media_too_large',
                                    'media_unavailable',
                                    'stt_failed',
                                    'provider_unsupported',
                                    'account_locked',
                                    'session_expired',
                                    'cursor_invalid'
                                ]),
                                message: /*#__PURE__*/ z.string().max(2000),
                                retryAfterSeconds: /*#__PURE__*/ z.int().gt(0).optional()
                            })
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['cancelled'])
                        })
                    ])
                }),
                /*#__PURE__*/ z.object({
                    operation: /*#__PURE__*/ z.enum(['listItems']),
                    outcome: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['ok']),
                            items: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                externalId: /*#__PURE__*/ z.string(),
                                title: /*#__PURE__*/ z.string(),
                                url: /*#__PURE__*/ z.string(),
                                publishedAt: /*#__PURE__*/ z.iso.datetime(),
                                durationSeconds: /*#__PURE__*/ z.int().gte(0).optional(),
                                text: /*#__PURE__*/ z.string().optional(),
                                language: /*#__PURE__*/ z.string().optional(),
                                stats: /*#__PURE__*/ z.object({
                                    views: /*#__PURE__*/ z.int().gte(0).optional(),
                                    likes: /*#__PURE__*/ z.int().gte(0).optional(),
                                    comments: /*#__PURE__*/ z.int().gte(0).optional(),
                                    reposts: /*#__PURE__*/ z.int().gte(0).optional(),
                                    replies: /*#__PURE__*/ z.int().gte(0).optional(),
                                    quotes: /*#__PURE__*/ z.int().gte(0).optional()
                                }).optional(),
                                author: /*#__PURE__*/ z.object({
                                    id: /*#__PURE__*/ z.string().max(100),
                                    name: /*#__PURE__*/ z.string().max(200)
                                }).optional(),
                                replyToId: /*#__PURE__*/ z.string().max(200).optional(),
                                attachments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                    kind: /*#__PURE__*/ z.enum([
                                        'image',
                                        'video',
                                        'link'
                                    ]),
                                    url: /*#__PURE__*/ z.string().max(2000)
                                })).max(20).optional()
                            })),
                            nextCursor: /*#__PURE__*/ z.string().nullable(),
                            reachedSince: /*#__PURE__*/ z.boolean().optional()
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['error']),
                            error: /*#__PURE__*/ z.object({
                                code: /*#__PURE__*/ z.enum([
                                    'quota_exhausted',
                                    'rate_limited',
                                    'ip_blocked',
                                    'po_token_required',
                                    'not_found',
                                    'captions_unavailable',
                                    'budget_exceeded',
                                    'credentials_missing',
                                    'upstream_error',
                                    'media_too_large',
                                    'media_unavailable',
                                    'stt_failed',
                                    'provider_unsupported',
                                    'account_locked',
                                    'session_expired',
                                    'cursor_invalid'
                                ]),
                                message: /*#__PURE__*/ z.string().max(2000),
                                retryAfterSeconds: /*#__PURE__*/ z.int().gt(0).optional()
                            })
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['cancelled'])
                        })
                    ])
                }),
                /*#__PURE__*/ z.object({
                    operation: /*#__PURE__*/ z.enum(['fetchItem']),
                    outcome: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['ok']),
                            item: /*#__PURE__*/ z.object({
                                externalId: /*#__PURE__*/ z.string(),
                                title: /*#__PURE__*/ z.string(),
                                url: /*#__PURE__*/ z.string(),
                                publishedAt: /*#__PURE__*/ z.iso.datetime(),
                                durationSeconds: /*#__PURE__*/ z.int().gte(0).optional(),
                                text: /*#__PURE__*/ z.string().optional(),
                                language: /*#__PURE__*/ z.string().optional(),
                                stats: /*#__PURE__*/ z.object({
                                    views: /*#__PURE__*/ z.int().gte(0).optional(),
                                    likes: /*#__PURE__*/ z.int().gte(0).optional(),
                                    comments: /*#__PURE__*/ z.int().gte(0).optional(),
                                    reposts: /*#__PURE__*/ z.int().gte(0).optional(),
                                    replies: /*#__PURE__*/ z.int().gte(0).optional(),
                                    quotes: /*#__PURE__*/ z.int().gte(0).optional()
                                }).optional(),
                                author: /*#__PURE__*/ z.object({
                                    id: /*#__PURE__*/ z.string().max(100),
                                    name: /*#__PURE__*/ z.string().max(200)
                                }).optional(),
                                replyToId: /*#__PURE__*/ z.string().max(200).optional(),
                                attachments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                    kind: /*#__PURE__*/ z.enum([
                                        'image',
                                        'video',
                                        'link'
                                    ]),
                                    url: /*#__PURE__*/ z.string().max(2000)
                                })).max(20).optional(),
                                description: /*#__PURE__*/ z.string().optional(),
                                tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
                                code: /*#__PURE__*/ z.object({
                                    language: /*#__PURE__*/ z.string().min(1).max(40),
                                    source: /*#__PURE__*/ z.string().max(500000),
                                    license: /*#__PURE__*/ z.string().max(200).optional()
                                }).optional()
                            }),
                            transcript: /*#__PURE__*/ z.object({
                                language: /*#__PURE__*/ z.string(),
                                kind: /*#__PURE__*/ z.enum(['manual', 'auto']),
                                source: /*#__PURE__*/ z.enum([
                                    'timedtext',
                                    'package',
                                    'ytdlp',
                                    'stt'
                                ]),
                                segments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                    text: /*#__PURE__*/ z.string(),
                                    start: /*#__PURE__*/ z.number().gte(0),
                                    end: /*#__PURE__*/ z.number().gte(0)
                                }))
                            }).optional(),
                            raw: /*#__PURE__*/ z.unknown().optional()
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['error']),
                            error: /*#__PURE__*/ z.object({
                                code: /*#__PURE__*/ z.enum([
                                    'quota_exhausted',
                                    'rate_limited',
                                    'ip_blocked',
                                    'po_token_required',
                                    'not_found',
                                    'captions_unavailable',
                                    'budget_exceeded',
                                    'credentials_missing',
                                    'upstream_error',
                                    'media_too_large',
                                    'media_unavailable',
                                    'stt_failed',
                                    'provider_unsupported',
                                    'account_locked',
                                    'session_expired',
                                    'cursor_invalid'
                                ]),
                                message: /*#__PURE__*/ z.string().max(2000),
                                retryAfterSeconds: /*#__PURE__*/ z.int().gt(0).optional()
                            })
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['cancelled'])
                        })
                    ])
                }),
                /*#__PURE__*/ z.object({
                    operation: /*#__PURE__*/ z.enum(['analyzeMedia']),
                    outcome: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['ok']),
                            item: /*#__PURE__*/ z.object({
                                externalId: /*#__PURE__*/ z.string(),
                                title: /*#__PURE__*/ z.string(),
                                url: /*#__PURE__*/ z.string(),
                                publishedAt: /*#__PURE__*/ z.iso.datetime(),
                                durationSeconds: /*#__PURE__*/ z.int().gte(0).optional(),
                                text: /*#__PURE__*/ z.string().optional(),
                                language: /*#__PURE__*/ z.string().optional(),
                                stats: /*#__PURE__*/ z.object({
                                    views: /*#__PURE__*/ z.int().gte(0).optional(),
                                    likes: /*#__PURE__*/ z.int().gte(0).optional(),
                                    comments: /*#__PURE__*/ z.int().gte(0).optional(),
                                    reposts: /*#__PURE__*/ z.int().gte(0).optional(),
                                    replies: /*#__PURE__*/ z.int().gte(0).optional(),
                                    quotes: /*#__PURE__*/ z.int().gte(0).optional()
                                }).optional(),
                                author: /*#__PURE__*/ z.object({
                                    id: /*#__PURE__*/ z.string().max(100),
                                    name: /*#__PURE__*/ z.string().max(200)
                                }).optional(),
                                replyToId: /*#__PURE__*/ z.string().max(200).optional(),
                                attachments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                    kind: /*#__PURE__*/ z.enum([
                                        'image',
                                        'video',
                                        'link'
                                    ]),
                                    url: /*#__PURE__*/ z.string().max(2000)
                                })).max(20).optional(),
                                description: /*#__PURE__*/ z.string().optional(),
                                tags: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
                                code: /*#__PURE__*/ z.object({
                                    language: /*#__PURE__*/ z.string().min(1).max(40),
                                    source: /*#__PURE__*/ z.string().max(500000),
                                    license: /*#__PURE__*/ z.string().max(200).optional()
                                }).optional()
                            }),
                            transcript: /*#__PURE__*/ z.object({
                                language: /*#__PURE__*/ z.string(),
                                kind: /*#__PURE__*/ z.enum(['manual', 'auto']),
                                source: /*#__PURE__*/ z.enum([
                                    'timedtext',
                                    'package',
                                    'ytdlp',
                                    'stt'
                                ]),
                                segments: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                    text: /*#__PURE__*/ z.string(),
                                    start: /*#__PURE__*/ z.number().gte(0),
                                    end: /*#__PURE__*/ z.number().gte(0)
                                }))
                            }),
                            analysis: /*#__PURE__*/ z.object({
                                model: /*#__PURE__*/ z.string(),
                                mode: /*#__PURE__*/ z.enum(['workspace_files', 'transcript_inline']).optional(),
                                framesUsed: /*#__PURE__*/ z.array(/*#__PURE__*/ z.number().gte(0)),
                                usage: /*#__PURE__*/ z.object({
                                    promptTokens: /*#__PURE__*/ z.int().gte(0),
                                    completionTokens: /*#__PURE__*/ z.int().gte(0)
                                }).optional(),
                                provider: /*#__PURE__*/ z.string().min(1).max(60).optional(),
                                result: /*#__PURE__*/ z.unknown().optional()
                            })
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['error']),
                            error: /*#__PURE__*/ z.object({
                                code: /*#__PURE__*/ z.enum([
                                    'quota_exhausted',
                                    'rate_limited',
                                    'ip_blocked',
                                    'po_token_required',
                                    'not_found',
                                    'captions_unavailable',
                                    'budget_exceeded',
                                    'credentials_missing',
                                    'upstream_error',
                                    'media_too_large',
                                    'media_unavailable',
                                    'stt_failed',
                                    'provider_unsupported',
                                    'account_locked',
                                    'session_expired',
                                    'cursor_invalid'
                                ]),
                                message: /*#__PURE__*/ z.string().max(2000),
                                retryAfterSeconds: /*#__PURE__*/ z.int().gt(0).optional()
                            })
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['cancelled'])
                        })
                    ])
                }),
                /*#__PURE__*/ z.object({
                    operation: /*#__PURE__*/ z.enum(['search']),
                    outcome: /*#__PURE__*/ z.union([
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['ok']),
                            hits: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
                                externalId: /*#__PURE__*/ z.string().min(1).max(2000),
                                title: /*#__PURE__*/ z.string().max(1000),
                                url: /*#__PURE__*/ z.string().max(2000),
                                publishedAt: /*#__PURE__*/ z.iso.datetime().optional(),
                                text: /*#__PURE__*/ z.string().max(4000).optional(),
                                durationSeconds: /*#__PURE__*/ z.int().gte(0).optional(),
                                stats: /*#__PURE__*/ z.object({
                                    views: /*#__PURE__*/ z.int().gte(0).optional(),
                                    likes: /*#__PURE__*/ z.int().gte(0).optional(),
                                    forks: /*#__PURE__*/ z.int().gte(0).optional()
                                }).optional(),
                                owner: /*#__PURE__*/ z.object({
                                    externalId: /*#__PURE__*/ z.string().min(1).max(200),
                                    name: /*#__PURE__*/ z.string().max(200),
                                    url: /*#__PURE__*/ z.string().max(2000).optional()
                                }).optional()
                            }))
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['error']),
                            error: /*#__PURE__*/ z.object({
                                code: /*#__PURE__*/ z.enum([
                                    'quota_exhausted',
                                    'rate_limited',
                                    'ip_blocked',
                                    'po_token_required',
                                    'not_found',
                                    'captions_unavailable',
                                    'budget_exceeded',
                                    'credentials_missing',
                                    'upstream_error',
                                    'media_too_large',
                                    'media_unavailable',
                                    'stt_failed',
                                    'provider_unsupported',
                                    'account_locked',
                                    'session_expired',
                                    'cursor_invalid'
                                ]),
                                message: /*#__PURE__*/ z.string().max(2000),
                                retryAfterSeconds: /*#__PURE__*/ z.int().gt(0).optional()
                            })
                        }),
                        /*#__PURE__*/ z.object({
                            status: /*#__PURE__*/ z.enum(['cancelled'])
                        })
                    ])
                })
            ]),
            audit: /*#__PURE__*/ z.object({
                worker: /*#__PURE__*/ z.string(),
                capability: /*#__PURE__*/ z.string(),
                platform: /*#__PURE__*/ z.enum([
                    'youtube',
                    'x',
                    'rss',
                    'discord',
                    'web',
                    'github'
                ]),
                endpointClass: /*#__PURE__*/ z.string(),
                requestCount: /*#__PURE__*/ z.int().gte(0),
                quotaUnitsUsed: /*#__PURE__*/ z.int().gte(0).optional(),
                readsBilled: /*#__PURE__*/ z.int().gte(0).optional(),
                egressIdentity: /*#__PURE__*/ z.string(),
                durationMs: /*#__PURE__*/ z.int().gte(0)
            })
        }),
        /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.string().regex(/^worker\.[a-z][a-z0-9]*\.[a-zA-Z][a-zA-Z0-9]*$/),
            requestId: /*#__PURE__*/ z.string(),
            result: /*#__PURE__*/ z.unknown().optional(),
            audit: /*#__PURE__*/ z.unknown().optional()
        })
    ])).min(1).max(50)
});

export const zPublishAiWorkerEventsPath = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Events accepted
 */
export const zPublishAiWorkerEventsResponse = /*#__PURE__*/ z.void();

/**
 * Accepted and forwarded to the metrics hub
 */
export const zCreateHostMetricsResponse = zHostMetricsExportResult;

export const zListSnapshotsQuery = /*#__PURE__*/ z.object({
    templateId: /*#__PURE__*/ z.int().gt(0),
    stepId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional().default(20),
    before: /*#__PURE__*/ z.number().nullish()
});

/**
 * List of snapshots
 */
export const zListSnapshotsResponse = zSnapshotList;

export const zCreateSnapshotBody = zSnapshotCreate;

/**
 * Snapshot created
 */
export const zCreateSnapshotResponse = zSnapshot;

export const zPurgeSnapshotsBody = zSnapshotPurgeRequest;

/**
 * Purge result
 */
export const zPurgeSnapshotsResponse = /*#__PURE__*/ z.object({
    deletedCount: /*#__PURE__*/ z.number()
});

export const zDeleteSnapshotPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteSnapshotResponse = zSnapshotActionResult;

export const zGetSnapshotPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Snapshot detail
 */
export const zGetSnapshotResponse = zSnapshot;

export const zUpdateSnapshotBody = zSnapshotUpdate;

export const zUpdateSnapshotPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated snapshot
 */
export const zUpdateSnapshotResponse = zSnapshot;

/**
 * Dataset list
 */
export const zListEvaluationDatasetsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zEvaluationDataset)
});

export const zCreateEvaluationDatasetBody = zEvaluationDatasetCreate;

/**
 * Created
 */
export const zCreateEvaluationDatasetResponse = zEvaluationDataset;

export const zDeleteEvaluationDatasetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteEvaluationDatasetResponse = zEvaluationActionResult;

export const zListEvaluationCasesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Case list
 */
export const zListEvaluationCasesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zEvaluationCase)
});

export const zCreateEvaluationCaseBody = zEvaluationCaseCreate;

export const zCreateEvaluationCasePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Created
 */
export const zCreateEvaluationCaseResponse = zEvaluationCase;

export const zDeleteEvaluationCasePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    caseId: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteEvaluationCaseResponse = zEvaluationActionResult;

export const zRunEvaluationDatasetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Run queued in the engine; its result is an evaluation run of this dataset when it ends
 */
export const zRunEvaluationDatasetResponse = zEvaluationDatasetRunResult;

export const zGetEvaluationRunPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run details
 */
export const zGetEvaluationRunResponse = zEvaluationRun;

export const zListReasoningEvaluationsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().max(200).optional()
});

/**
 * Reasoning evaluation runs, newest first, with their checks
 */
export const zListReasoningEvaluationsResponse = zReasoningEvaluationList;

/**
 * The call funnel of each followed source: where calls and reasons are dropped
 */
export const zGetReasoningCallSummaryResponse = zReasoningCallSummary;

/**
 * The principle funnel of each followed source, and its findings on their way to strategies: validated, drafted, measured, admitted
 */
export const zGetReasoningPrincipleSummaryResponse = zReasoningPrincipleSummary;

export const zListEvaluationTemplatesQuery = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]).optional(),
    status: /*#__PURE__*/ z.enum([
        'draft',
        'active',
        'deprecated',
        'retired'
    ]).optional(),
    visibility: /*#__PURE__*/ z.enum(['private', 'org']).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().optional(),
    before: /*#__PURE__*/ z.string().optional()
});

/**
 * Paginated list of evaluation templates
 */
export const zListEvaluationTemplatesResponse = zEvaluationTemplateList;

export const zCreateEvaluationTemplateBody = zEvaluationTemplateCreate;

/**
 * Created evaluation template with initial version
 */
export const zCreateEvaluationTemplateResponse = /*#__PURE__*/ z.object({
    data: zEvaluationTemplateWithVersions
});

export const zGetEvaluationTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Evaluation template with all versions
 */
export const zGetEvaluationTemplateResponse = /*#__PURE__*/ z.object({
    data: zEvaluationTemplateWithVersions
});

export const zUpdateEvaluationTemplateBody = zEvaluationTemplateUpdate;

export const zUpdateEvaluationTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated evaluation template
 */
export const zUpdateEvaluationTemplateResponse = /*#__PURE__*/ z.object({
    data: zEvaluationTemplate
});

export const zAddEvaluationTemplateVersionBody = zEvaluationTemplateVersionCreate;

export const zAddEvaluationTemplateVersionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * New draft version created
 */
export const zAddEvaluationTemplateVersionResponse = /*#__PURE__*/ z.object({
    data: zEvaluationTemplateVersion
});

export const zPublishEvaluationTemplateVersionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    versionId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Version published (activated + locked)
 */
export const zPublishEvaluationTemplateVersionResponse = /*#__PURE__*/ z.object({
    data: zEvaluationTemplateVersion
});

export const zApplyEvaluationTemplateBody = zEvaluationTemplateApplyRequest;

export const zApplyEvaluationTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Template applied to subject (entity_links row written on the active version)
 */
export const zApplyEvaluationTemplateResponse = /*#__PURE__*/ z.object({
    data: zEvaluationAssignment
});

export const zGetSubjectEvaluationsPath = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]),
    subjectId: /*#__PURE__*/ z.string()
});

/**
 * All evaluation assignments for this subject with per-assignment verdict
 */
export const zGetSubjectEvaluationsResponse = /*#__PURE__*/ z.object({
    data: zSubjectEvaluations
});

export const zListCatalogSourcesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string().optional(),
    statuses: /*#__PURE__*/ z.string().optional(),
    targetType: /*#__PURE__*/ z.string().optional(),
    targetTypes: /*#__PURE__*/ z.string().optional(),
    sourceType: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Catalog sources
 */
export const zListCatalogSourcesResponse = zCatalogSourceList;

export const zListCatalogCandidatesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string().optional(),
    statuses: /*#__PURE__*/ z.string().optional(),
    targetType: /*#__PURE__*/ z.string().optional(),
    targetTypes: /*#__PURE__*/ z.string().optional(),
    sourceType: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Catalog candidates
 */
export const zListCatalogCandidatesResponse = zCatalogCandidateList;

export const zGetCatalogCandidatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Catalog candidate
 */
export const zGetCatalogCandidateResponse = zCatalogCandidateDecisionResult;

export const zListCatalogReviewQueueQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string().optional(),
    statuses: /*#__PURE__*/ z.string().optional(),
    targetType: /*#__PURE__*/ z.string().optional(),
    targetTypes: /*#__PURE__*/ z.string().optional(),
    sourceType: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Catalog review queue
 */
export const zListCatalogReviewQueueResponse = zCatalogReviewQueueList;

export const zProcessCatalogReviewQueueBody = /*#__PURE__*/ z.object({
    targetDaemonName: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'blocked',
        'failed',
        'pending'
    ]).optional(),
    processNow: /*#__PURE__*/ z.boolean().optional()
});

/**
 * Review queue processing triggered
 */
export const zProcessCatalogReviewQueueResponse = zCatalogProcessResult;

export const zRevertCatalogVersionAdoptionBody = /*#__PURE__*/ z.object({
    consumerKey: /*#__PURE__*/ z.string().min(1)
});

/**
 * Catalog version adoption reverted
 */
export const zRevertCatalogVersionAdoptionResponse = zCatalogAdoptionResult;

export const zRetryCatalogReviewQueueBody = /*#__PURE__*/ z.object({
    targetDaemonName: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'blocked',
        'failed',
        'pending'
    ]).optional(),
    processNow: /*#__PURE__*/ z.boolean().optional()
});

/**
 * Review queue items requeued
 */
export const zRetryCatalogReviewQueueResponse = zCatalogRequeueResult;

export const zRetryCatalogReviewQueueItemPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Review queue item requeued
 */
export const zRetryCatalogReviewQueueItemResponse = zCatalogProcessResult;

export const zListCatalogItemVersionsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string().optional(),
    statuses: /*#__PURE__*/ z.string().optional(),
    targetType: /*#__PURE__*/ z.string().optional(),
    targetTypes: /*#__PURE__*/ z.string().optional(),
    sourceType: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Catalog item versions
 */
export const zListCatalogItemVersionsResponse = zCatalogItemVersionList;

/**
 * Catalog version adoptions
 */
export const zListCatalogVersionAdoptionsResponse = zCatalogAdoptionList;

export const zUpgradeCatalogVersionAdoptionBody = /*#__PURE__*/ z.object({
    consumerKey: /*#__PURE__*/ z.string().min(1)
});

/**
 * Catalog version adoption upgraded
 */
export const zUpgradeCatalogVersionAdoptionResponse = zCatalogAdoptionResult;

export const zRestoreCatalogItemVersionBody = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().optional()
});

export const zRestoreCatalogItemVersionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Catalog version restored
 */
export const zRestoreCatalogItemVersionResponse = zCatalogPromotionResponse;

export const zRejectCatalogCandidateBody = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().optional()
});

export const zRejectCatalogCandidatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Rejected
 */
export const zRejectCatalogCandidateResponse = zCatalogCandidateResult;

export const zDeferCatalogCandidateBody = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().optional()
});

export const zDeferCatalogCandidatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deferred
 */
export const zDeferCatalogCandidateResponse = zCatalogCandidateResult;

export const zRetryCatalogCandidateReviewPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Candidate review retried
 */
export const zRetryCatalogCandidateReviewResponse = zCatalogRetryReviewResult;

export const zPromoteCatalogCandidatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Promoted
 */
export const zPromoteCatalogCandidateResponse = zCatalogPromotionResponse;

export const zListWidgetsQuery = /*#__PURE__*/ z.object({
    category: /*#__PURE__*/ z.string().optional(),
    type: /*#__PURE__*/ z.string().optional()
});

/**
 * Widget definitions
 */
export const zListWidgetsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowOutputWidgetDefinition)
});

export const zCreateWidgetBody = zWorkflowOutputWidgetDefinitionCreate;

/**
 * Widget created
 */
export const zCreateWidgetResponse = /*#__PURE__*/ z.object({
    widget: zWorkflowOutputWidgetDefinition
});

export const zGetWidgetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Widget definition
 */
export const zGetWidgetResponse = /*#__PURE__*/ z.object({
    widget: zWorkflowOutputWidgetDefinition
});

export const zListPinnedWidgetsQuery = /*#__PURE__*/ z.object({
    dashboardId: /*#__PURE__*/ z.string()
});

/**
 * Dashboard widgets
 */
export const zListPinnedWidgetsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDashboardWidgetLegacy)
});

export const zPinWidgetBody2 = zPinWidgetBody;

/**
 * Widget pinned
 */
export const zPinWidgetResponse = /*#__PURE__*/ z.object({
    widget: zDashboardWidgetLegacy
});

export const zUnpinWidgetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Widget unpinned
 */
export const zUnpinWidgetResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zUpdatePinnedWidgetBody = zUpdateDashboardWidgetBody;

export const zUpdatePinnedWidgetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Widget updated
 */
export const zUpdatePinnedWidgetResponse = /*#__PURE__*/ z.object({
    widget: zDashboardWidgetLegacy
});

/**
 * Available output part kinds
 */
export const zListOutputPartKindsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zOutputPartKind)
});

export const zQueryOutputsQuery = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string().optional(),
    workflowId: /*#__PURE__*/ z.string().optional(),
    stepId: /*#__PURE__*/ z.string().optional(),
    kind: /*#__PURE__*/ z.string().optional(),
    title: /*#__PURE__*/ z.string().max(300).optional(),
    portType: /*#__PURE__*/ z.string().optional(),
    visibility: /*#__PURE__*/ z.string().optional(),
    sourceType: /*#__PURE__*/ z.string().optional(),
    projectId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Filtered output parts
 */
export const zQueryOutputsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkOutputPart)
});

export const zGetLatestOutputQuery = /*#__PURE__*/ z.object({
    workflowId: /*#__PURE__*/ z.string().optional(),
    stepId: /*#__PURE__*/ z.string().optional(),
    kind: /*#__PURE__*/ z.string().optional(),
    portType: /*#__PURE__*/ z.string().optional(),
    projectId: /*#__PURE__*/ z.string().optional()
});

/**
 * Latest output part
 */
export const zGetLatestOutputResponse = /*#__PURE__*/ z.object({
    output: /*#__PURE__*/ zWorkOutputPart.nullable()
});

export const zGetOutputMetricsQuery = /*#__PURE__*/ z.object({
    workflowId: /*#__PURE__*/ z.string().optional(),
    metricName: /*#__PURE__*/ z.string().optional(),
    from: /*#__PURE__*/ z.string().optional(),
    to: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Time-series metrics
 */
export const zGetOutputMetricsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zOutputMetricPoint)
});

export const zGetOutputPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Output part detail
 */
export const zGetOutputResponse = /*#__PURE__*/ z.object({
    output: zWorkOutputPart
});

export const zDownloadOutputPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * File content, JSON payload, or redirect
 */
export const zDownloadOutputResponse = /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown());

/**
 * Color map
 */
export const zGetPortTypeColorsResponse = zPortTypeColorMap;

export const zCheckPortCompatibilityQuery = /*#__PURE__*/ z.object({
    source: /*#__PURE__*/ z.string(),
    target: /*#__PURE__*/ z.string()
});

/**
 * Compatibility result
 */
export const zCheckPortCompatibilityResponse = zPortCompatibilityResult;

export const zListPortTypesQuery = /*#__PURE__*/ z.object({
    category: /*#__PURE__*/ z.enum([
        'primitive',
        'collection',
        'json',
        'domain'
    ]).optional()
});

/**
 * Port type list
 */
export const zListPortTypesResponse = /*#__PURE__*/ z.array(zPortTypeDefinition);

export const zGetPortTypePath = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string()
});

/**
 * Port type detail
 */
export const zGetPortTypeResponse = zPortTypeDefinition;

export const zListDocumentsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Document list
 */
export const zListDocumentsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowDocument)
});

export const zUploadDocumentBody = zWorkflowDocumentUpload;

export const zUploadDocumentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Document uploaded
 */
export const zUploadDocumentResponse = /*#__PURE__*/ z.object({
    document: zWorkflowDocument
});

export const zDeleteDocumentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    docId: /*#__PURE__*/ z.string()
});

/**
 * Document deleted
 */
export const zDeleteDocumentResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetDocumentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    docId: /*#__PURE__*/ z.string()
});

/**
 * Document detail
 */
export const zGetDocumentResponse = /*#__PURE__*/ z.object({
    document: zWorkflowDocument
});

export const zSetWorkflowRuntimePolicyBody = zRuntimePolicyAssignment;

export const zSetWorkflowRuntimePolicyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * The policy the workflow’s steps run under, set
 */
export const zSetWorkflowRuntimePolicyResponse = zRuntimePolicyAssignment;

export const zExportInstructionsBody = zInstructionExportBody;

/**
 * Exported instructions
 */
export const zExportInstructionsResponse = zInstructionExportResult;

export const zListWorkflowsQuery = /*#__PURE__*/ z.object({
    category: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'name'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Workflow list (paginated)
 */
export const zListWorkflowsResponse = zWorkflowDefinitionList;

export const zCreateWorkflowBody = zWorkflowCreate;

/**
 * Workflow created
 */
export const zCreateWorkflowResponse = zWorkflowTemplateResult;

export const zExportWorkflowInstructionsBody = /*#__PURE__*/ z.object({
    stepIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    scope: /*#__PURE__*/ z.enum([
        'full',
        'selected',
        'blank'
    ]),
    includeRoles: /*#__PURE__*/ z.boolean().optional(),
    includeOutputSchemas: /*#__PURE__*/ z.boolean().optional()
});

export const zExportWorkflowInstructionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Exported workflow instructions
 */
export const zExportWorkflowInstructionsResponse = zInstructionExportResult;

export const zRestoreWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workflow restored
 */
export const zRestoreWorkflowResponse = zWorkflowTemplateResult;

export const zValidateWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Validation result
 */
export const zValidateWorkflowResponse = zWorkflowValidationResult;

export const zReorderWorkflowStepsBody = zStepReorderBody;

export const zReorderWorkflowStepsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Steps reordered
 */
export const zReorderWorkflowStepsResponse = zWorkflowTemplateResult;

export const zAddWorkflowStepBody = zWorkflowStepInput;

export const zAddWorkflowStepPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Step added
 */
export const zAddWorkflowStepResponse = /*#__PURE__*/ z.object({
    template: /*#__PURE__*/ z.object({
        steps: /*#__PURE__*/ z.array(zWorkflowStep)
    })
});

export const zRemoveWorkflowStepPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    stepId: /*#__PURE__*/ z.string()
});

/**
 * Step removed
 */
export const zRemoveWorkflowStepResponse = zWorkflowTemplateResult;

export const zUpdateWorkflowStepBody = zWorkflowStepInput;

export const zUpdateWorkflowStepPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    stepId: /*#__PURE__*/ z.string()
});

/**
 * Step updated
 */
export const zUpdateWorkflowStepResponse = zWorkflowTemplateResult;

export const zSetWorkflowScheduleBody = zWorkflowScheduleBody;

export const zSetWorkflowSchedulePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Schedule updated
 */
export const zSetWorkflowScheduleResponse = zWorkflowTemplateResult;

export const zListWorkflowExecutionObservationsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListWorkflowExecutionObservationsQuery = /*#__PURE__*/ z.object({
    stepId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional().default(30)
});

/**
 * Execution-derived schema observations
 */
export const zListWorkflowExecutionObservationsResponse = zWorkflowExecutionObservationList;

export const zListWorkflowRunsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Run history
 */
export const zListWorkflowRunsResponse = zWorkflowRunList;

export const zTriggerWorkflowBody = /*#__PURE__*/ z.object({
    context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zTriggerWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workflow triggered
 */
export const zTriggerWorkflowResponse = zWorkflowDefinitionTriggerResult;

export const zListWorkflowVersionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListWorkflowVersionsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional().default(20)
});

/**
 * Workflow version history
 */
export const zListWorkflowVersionsResponse = zWorkflowVersionList;

export const zGetWorkflowVersionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow version snapshot
 */
export const zGetWorkflowVersionResponse = zWorkflowVersionResult;

export const zDiffWorkflowVersionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    versionA: /*#__PURE__*/ z.int().gt(0),
    versionB: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow version diff
 */
export const zDiffWorkflowVersionsResponse = zWorkflowVersionDiffResult;

export const zRestoreWorkflowVersionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    version: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow restored from version
 */
export const zRestoreWorkflowVersionResponse = zWorkflowTemplateResult;

export const zSaveWorkflowDefinitionGraphBody = zWorkflowGraphSave;

export const zSaveWorkflowDefinitionGraphPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Graph saved — returns the full workflow definition with updated steps and edges
 */
export const zSaveWorkflowDefinitionGraphResponse = zWorkflowTemplateResult;

export const zArchiveWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workflow archived
 */
export const zArchiveWorkflowResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workflow detail
 */
export const zGetWorkflowResponse = zWorkflowTemplateResult;

export const zUpdateWorkflowBody = zWorkflowUpdate;

export const zUpdateWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workflow updated
 */
export const zUpdateWorkflowResponse = zWorkflowTemplateResult;

export const zGetWorkflowCloseSummaryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Close summary markdown (null when workflow is not conversation-sourced)
 */
export const zGetWorkflowCloseSummaryResponse = zWorkflowCloseSummary;

/**
 * Workflow instances for the org
 */
export const zListWorkflowInstancesResponse = zWorkflowInstanceList;

export const zCreateWorkflowInstanceBody = zWorkflowInstanceCreate;

/**
 * Workflow instance created
 */
export const zCreateWorkflowInstanceResponse = zWorkflowInstanceResult;

export const zGetWorkflowInstancePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow instance
 */
export const zGetWorkflowInstanceResponse = zWorkflowInstanceResult;

export const zUpdateWorkflowInstanceBody = zWorkflowInstanceUpdate;

export const zUpdateWorkflowInstancePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow instance updated
 */
export const zUpdateWorkflowInstanceResponse = zWorkflowInstanceResult;

export const zTriggerWorkflowInstanceBody = /*#__PURE__*/ z.object({
    context: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional()
});

export const zTriggerWorkflowInstancePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Run triggered
 */
export const zTriggerWorkflowInstanceResponse = zWorkflowInstanceTriggerResult;

export const zSearchWorkflowDefinitionsQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(500),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional().default(10)
});

/**
 * Ranked workflow definition search results
 */
export const zSearchWorkflowDefinitionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowDefinitionSearchResult),
    query: /*#__PURE__*/ z.string(),
    total: /*#__PURE__*/ z.number(),
    searchType: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ])
});

export const zRecommendWorkflowDefinitionsQuery = /*#__PURE__*/ z.object({
    stepDescription: /*#__PURE__*/ z.string().min(1).max(500),
    workflowCategory: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(20).optional().default(5)
});

/**
 * Recommended workflow definitions for a given step description
 */
export const zRecommendWorkflowDefinitionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkflowDefinitionSearchResult),
    total: /*#__PURE__*/ z.number()
});

/**
 * User organizations
 */
export const zListOrganizationsResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    organizations: /*#__PURE__*/ z.array(zOrganization)
});

export const zCreateOrganizationBody = zOrganizationCreate;

/**
 * Organization created with founder invitation
 */
export const zCreateOrganizationResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    organization: zOrganization,
    invitationToken: /*#__PURE__*/ z.string()
});

/**
 * Organizations the current user belongs to
 */
export const zGetMyOrganizationsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zUserOrg)
});

export const zGetOrganizationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Organization detail — full graph including features, modules, and counts
 */
export const zGetOrganizationResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    organization: zOrganization
});

export const zUpdateOrganizationBody = zOrganizationUpdate;

export const zUpdateOrganizationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Organization updated
 */
export const zUpdateOrganizationResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    organization: zOrganization
});

export const zListOrgMembersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Organization members
 */
export const zListOrgMembersResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    members: /*#__PURE__*/ z.array(zOrgMemberSummary)
});

export const zAddOrgMemberBody = zAddMemberBody;

export const zAddOrgMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Member added
 */
export const zAddOrgMemberResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    member: zOrgMember
});

export const zAcknowledgeOrgModuleBody = zRegulatoryAckRequest;

export const zAcknowledgeOrgModulePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    moduleId: /*#__PURE__*/ z.string().min(1).max(50)
});

/**
 * Acknowledgement recorded; returns any acks still outstanding for this module
 */
export const zAcknowledgeOrgModuleResponse = zRegulatoryAckResult;

export const zListTeamsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Team list
 */
export const zListTeamsResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    teams: /*#__PURE__*/ z.array(zTeam)
});

export const zCreateTeamBody = zTeamCreate;

export const zCreateTeamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Team created
 */
export const zCreateTeamResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    team: zTeam
});

export const zGetMyTeamsInOrgPath = /*#__PURE__*/ z.object({
    orgId: /*#__PURE__*/ z.string()
});

/**
 * Current user teams in org
 */
export const zGetMyTeamsInOrgResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zUserOrgTeam)
});

export const zListTeamMembersPath = /*#__PURE__*/ z.object({
    teamId: /*#__PURE__*/ z.string()
});

/**
 * Team members
 */
export const zListTeamMembersResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    members: /*#__PURE__*/ z.array(zTeamMember)
});

export const zAddTeamMemberBody = /*#__PURE__*/ z.object({
    userId: /*#__PURE__*/ z.number(),
    role: /*#__PURE__*/ z.string().optional()
});

export const zAddTeamMemberPath = /*#__PURE__*/ z.object({
    teamId: /*#__PURE__*/ z.string()
});

/**
 * Member added
 */
export const zAddTeamMemberResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    member: zTeamMember
});

export const zRemoveTeamMemberPath = /*#__PURE__*/ z.object({
    teamId: /*#__PURE__*/ z.string(),
    userId: /*#__PURE__*/ z.string()
});

/**
 * Member removed
 */
export const zRemoveTeamMemberResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string()
});

export const zListOrgInvitationsPath = /*#__PURE__*/ z.object({
    orgId: /*#__PURE__*/ z.string()
});

/**
 * Org invitations
 */
export const zListOrgInvitationsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zInvitation)
});

export const zCreateInvitationBody = zInvitationCreate;

export const zCreateInvitationPath = /*#__PURE__*/ z.object({
    orgId: /*#__PURE__*/ z.string()
});

/**
 * Invitation created
 */
export const zCreateInvitationResponse = zInvitation;

export const zListAnalysisTemplatesQuery = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional()
});

/**
 * Template list
 */
export const zListAnalysisTemplatesResponse = zIntelAnalysisTemplateList;

export const zCreateAnalysisTemplateBody = zIntelAnalysisTemplateCreate;

/**
 * Created
 */
export const zCreateAnalysisTemplateResponse = zIntelAnalysisTemplate;

export const zDeleteAnalysisTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteAnalysisTemplateResponse = zIntelAnalysisTemplateActionResult;

export const zGetAnalysisTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Template detail
 */
export const zGetAnalysisTemplateResponse = zIntelAnalysisTemplate;

export const zUpdateAnalysisTemplateBody = zIntelAnalysisTemplateUpdate;

export const zUpdateAnalysisTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateAnalysisTemplateResponse = zIntelAnalysisTemplate;

export const zCloneAnalysisTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Cloned
 */
export const zCloneAnalysisTemplateResponse = zIntelAnalysisTemplate;

/**
 * Platform list
 */
export const zListIntelPlatformsResponse = zIntelPlatformList;

export const zCreateIntelPlatformBody = zIntelPlatformCreate;

/**
 * Created
 */
export const zCreateIntelPlatformResponse = zIntelPlatform;

export const zTestIntelPlatformPath = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string()
});

/**
 * Connection test result
 */
export const zTestIntelPlatformResponse = zIntelPlatformTestResult;

export const zGetIntelPlatformUsagePath = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string()
});

/**
 * Usage stats
 */
export const zGetIntelPlatformUsageResponse = zIntelPlatformUsageResult;

export const zUpdateIntelPlatformBody = zIntelPlatformUpdate;

export const zUpdateIntelPlatformPath = /*#__PURE__*/ z.object({
    slug: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateIntelPlatformResponse = zIntelPlatform;

export const zListIntelSourcesQuery = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    active: /*#__PURE__*/ z.boolean().nullish(),
    approvalStatus: /*#__PURE__*/ z.enum([
        'seeded',
        'approved',
        'candidate',
        'rejected'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(500).optional().default(50),
    offset: /*#__PURE__*/ z.int().gte(0).nullish().default(0)
});

/**
 * Intel source list
 */
export const zListIntelSourcesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSource),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zCreateIntelSourceBody = zIntelSourceCreate;

/**
 * Created
 */
export const zCreateIntelSourceResponse = zIntelSource;

export const zDiscoverIntelSourceBody = zIntelSourceDiscoverRequest;

/**
 * Discovery result
 */
export const zDiscoverIntelSourceResponse = /*#__PURE__*/ z.object({
    found: /*#__PURE__*/ z.boolean(),
    queued: /*#__PURE__*/ z.boolean().optional(),
    requestId: /*#__PURE__*/ z.string().optional(),
    error: /*#__PURE__*/ z.string().optional()
});

export const zBulkCreateIntelSourcesBody = /*#__PURE__*/ z.object({
    items: /*#__PURE__*/ z.array(zIntelSourceCreate).min(1).max(100)
});

/**
 * Bulk create result
 */
export const zBulkCreateIntelSourcesResponse = /*#__PURE__*/ z.object({
    created: /*#__PURE__*/ z.array(zIntelSource),
    errors: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        handle: /*#__PURE__*/ z.string(),
        error: /*#__PURE__*/ z.string()
    }))
});

export const zBatchFetchIntelSourcesBody = zIntelSourceBatchFetchRequest;

/**
 * Batch enqueue results
 */
export const zBatchFetchIntelSourcesResponse = zIntelSourceBatchFetchResult;

export const zBatchDeactivateIntelSourcesBody = /*#__PURE__*/ z.object({
    ids: /*#__PURE__*/ z.array(/*#__PURE__*/ z.int().gt(0)).min(1).max(100)
});

/**
 * Batch deactivate result
 */
export const zBatchDeactivateIntelSourcesResponse = /*#__PURE__*/ z.object({
    updated_count: /*#__PURE__*/ z.number()
});

export const zDeleteIntelSourcePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Deleted
 */
export const zDeleteIntelSourceResponse = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zGetIntelSourcePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Intel source
 */
export const zGetIntelSourceResponse = zIntelSource;

export const zUpdateIntelSourceBody = zIntelSourceUpdate;

export const zUpdateIntelSourcePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated
 */
export const zUpdateIntelSourceResponse = zIntelSource;

export const zFetchIntelSourceBody = zIntelSourceFetchRequest;

export const zFetchIntelSourcePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Fetch enqueued
 */
export const zFetchIntelSourceResponse = zIntelSourceSubscriptionEnqueueResult;

export const zGetIntelSourceHarvestedPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

export const zGetIntelSourceHarvestedQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(500).optional().default(50),
    data_type: /*#__PURE__*/ z.enum([
        'content',
        'event',
        'metric',
        'signal_raw'
    ]).optional()
});

/**
 * Intel source data
 */
export const zGetIntelSourceHarvestedResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSourceData),
    total: /*#__PURE__*/ z.number()
});

export const zCreateIntelSourceSubscriptionBody = zIntelSourceSubscriptionCreate;

export const zCreateIntelSourceSubscriptionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Subscription created
 */
export const zCreateIntelSourceSubscriptionResponse = zIntelSourceSubscription;

export const zReviewIntelSourceApprovalBody = zIntelSourceApprovalRequest;

export const zReviewIntelSourceApprovalPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Approval decision recorded
 */
export const zReviewIntelSourceApprovalResponse = zIntelSourceApprovalResult;

export const zRecordIntelSourceConsentBody = zIntelSourceConsentRequest;

export const zRecordIntelSourceConsentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Consent recorded
 */
export const zRecordIntelSourceConsentResponse = zIntelSourceConsent;

export const zCreateIntelSourceMonitorBody = zIntelSourceMonitorCreate;

export const zCreateIntelSourceMonitorPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Monitor created
 */
export const zCreateIntelSourceMonitorResponse = zIntelSourceMonitor;

export const zListIntelSourceItemInsightsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0),
    dataId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Insights extracted from one collected item
 */
export const zListIntelSourceItemInsightsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSourceItemInsight)
});

export const zListIntelSourceSubscriptionsQuery = /*#__PURE__*/ z.object({
    intelSourceId: /*#__PURE__*/ z.int().gt(0).optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'blocked',
        'pending_approval',
        'archived'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional().default(50),
    offset: /*#__PURE__*/ z.int().gte(0).nullish().default(0)
});

/**
 * Subscription list
 */
export const zListIntelSourceSubscriptionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSourceSubscriptionWithSource),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zUpdateIntelSourceSubscriptionBody = zIntelSourceSubscriptionUpdate;

export const zUpdateIntelSourceSubscriptionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated subscription
 */
export const zUpdateIntelSourceSubscriptionResponse = zIntelSourceSubscription;

export const zListIntelSourceFetchRunsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

export const zListIntelSourceFetchRunsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional().default(50),
    offset: /*#__PURE__*/ z.int().gte(0).nullish().default(0)
});

/**
 * Fetch run list
 */
export const zListIntelSourceFetchRunsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSourceFetchRun),
    total: /*#__PURE__*/ z.number()
});

export const zBackfillIntelSourceSubscriptionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Backfill enqueued
 */
export const zBackfillIntelSourceSubscriptionResponse = zIntelSourceSubscriptionEnqueueResult;

export const zListIntelSourceMonitorsQuery = /*#__PURE__*/ z.object({
    intelSourceId: /*#__PURE__*/ z.int().gt(0).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional().default(50),
    offset: /*#__PURE__*/ z.int().gte(0).nullish().default(0)
});

/**
 * Monitor list
 */
export const zListIntelSourceMonitorsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSourceMonitor),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zUpdateIntelSourceMonitorBody = zIntelSourceMonitorUpdate;

export const zUpdateIntelSourceMonitorPath = /*#__PURE__*/ z.object({
    workflowInstanceId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Monitor updated
 */
export const zUpdateIntelSourceMonitorResponse = zIntelSourceMonitor;

export const zFetchIntelSourceMonitorPath = /*#__PURE__*/ z.object({
    workflowInstanceId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Fetch triggered
 */
export const zFetchIntelSourceMonitorResponse = zIntelSourceMonitorFetchResult;

export const zListIntelSourceMonitorFetchRunsPath = /*#__PURE__*/ z.object({
    workflowInstanceId: /*#__PURE__*/ z.int().gt(0)
});

export const zListIntelSourceMonitorFetchRunsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional().default(50),
    offset: /*#__PURE__*/ z.int().gte(0).nullish().default(0)
});

/**
 * Fetch run list
 */
export const zListIntelSourceMonitorFetchRunsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntelSourceFetchRun),
    total: /*#__PURE__*/ z.number()
});

export const zListDashboardsQuery = /*#__PURE__*/ z.object({
    moduleId: /*#__PURE__*/ z.string().max(50).optional(),
    pinned: /*#__PURE__*/ z.boolean().nullish()
});

/**
 * Dashboards
 */
export const zListDashboardsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDashboard)
});

export const zCreateDashboardBody = zDashboardCreate;

/**
 * Created
 */
export const zCreateDashboardResponse = /*#__PURE__*/ z.object({
    dashboard: zDashboard
});

export const zDeleteDashboardPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteDashboardResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetDashboardPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Dashboard with widgets
 */
export const zGetDashboardResponse = /*#__PURE__*/ z.object({
    dashboard: zDashboardWithWidgets
});

export const zUpdateDashboardBody = zDashboardUpdate;

export const zUpdateDashboardPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateDashboardResponse = /*#__PURE__*/ z.object({
    dashboard: zDashboard
});

export const zAddWidgetBody = zWidgetAdd;

export const zAddWidgetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Widget added
 */
export const zAddWidgetResponse = /*#__PURE__*/ z.object({
    widget: zDashboardWidget
});

export const zReorderWidgetsBody = zWidgetReorder;

export const zReorderWidgetsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Widgets reordered
 */
export const zReorderWidgetsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zDashboardWidget)
});

export const zRemoveWidgetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    widgetId: /*#__PURE__*/ z.string()
});

/**
 * Widget removed
 */
export const zRemoveWidgetResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zUpdateWidgetBody = zWidgetUpdate;

export const zUpdateWidgetPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    widgetId: /*#__PURE__*/ z.string()
});

/**
 * Widget updated
 */
export const zUpdateWidgetResponse = /*#__PURE__*/ z.object({
    widget: zDashboardWidget
});

export const zUnpinDashboardPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Dashboard unpinned
 */
export const zUnpinDashboardResponse = zDashboardPinState;

export const zPinDashboardPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Dashboard pinned
 */
export const zPinDashboardResponse = zDashboardPinState;

/**
 * MCP connection list
 */
export const zListMcpConnectionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zMcpConnection)
});

export const zCreateMcpConnectionBody = zMcpConnectionCreate;

/**
 * Created
 */
export const zCreateMcpConnectionResponse = zMcpConnection;

export const zDeleteMcpConnectionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteMcpConnectionResponse = zMcpActionResult;

export const zGetMcpConnectionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Connection detail
 */
export const zGetMcpConnectionResponse = zMcpConnection;

export const zUpdateMcpConnectionBody = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    description: /*#__PURE__*/ z.string().optional(),
    transport: /*#__PURE__*/ z.enum([
        'stdio',
        'sse',
        'http'
    ]).optional(),
    command: /*#__PURE__*/ z.string().optional(),
    args: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()).optional(),
    serverUrl: /*#__PURE__*/ z.string().optional(),
    env: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.string()).optional(),
    enabled: /*#__PURE__*/ z.boolean().optional(),
    autoConnect: /*#__PURE__*/ z.boolean().optional(),
    toolPrefix: /*#__PURE__*/ z.string().optional(),
    permissionLevel: /*#__PURE__*/ z.string().optional(),
    maxCallsPerMinute: /*#__PURE__*/ z.number().optional(),
    timeoutMs: /*#__PURE__*/ z.number().optional(),
    trusted: /*#__PURE__*/ z.boolean().optional()
});

export const zUpdateMcpConnectionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateMcpConnectionResponse = zMcpConnection;

export const zConnectMcpConnectionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Connect command queued
 */
export const zConnectMcpConnectionResponse = zMcpCommandQueued;

export const zDisconnectMcpConnectionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Disconnect command queued
 */
export const zDisconnectMcpConnectionResponse = zMcpCommandQueued;

export const zListMcpConnectionToolsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Tools from this connection
 */
export const zListMcpConnectionToolsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zMcpTool)
});

export const zTestMcpConnectionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Test command queued
 */
export const zTestMcpConnectionResponse = zMcpCommandQueued;

export const zSearchDaemonsQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(500),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional().default(10)
});

/**
 * Ranked workforce (daemon) search results
 */
export const zSearchDaemonsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkforceSearchResult),
    query: /*#__PURE__*/ z.string(),
    total: /*#__PURE__*/ z.number(),
    searchType: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ])
});

export const zRecommendDaemonsQuery = /*#__PURE__*/ z.object({
    mandate: /*#__PURE__*/ z.string().min(1).max(500),
    department: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(20).optional().default(5)
});

/**
 * Recommended daemons matching a mandate description
 */
export const zRecommendDaemonsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkforceSearchResult),
    total: /*#__PURE__*/ z.number()
});

export const zSearchWorkforceQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(500),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional().default(10)
});

/**
 * Ranked workforce (daemon) search results
 */
export const zSearchWorkforceResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkforceSearchResult),
    query: /*#__PURE__*/ z.string(),
    total: /*#__PURE__*/ z.number(),
    searchType: /*#__PURE__*/ z.enum([
        'keyword',
        'semantic',
        'hybrid'
    ])
});

export const zRecommendWorkforceQuery = /*#__PURE__*/ z.object({
    mandate: /*#__PURE__*/ z.string().min(1).max(500),
    department: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(20).optional().default(5)
});

/**
 * Recommended daemons matching a mandate description
 */
export const zRecommendWorkforceResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWorkforceSearchResult),
    total: /*#__PURE__*/ z.number()
});

/**
 * Event catalog
 */
export const zListDaemonsEventCatalogResponse = zWorkforceEventCatalogResult;

/**
 * Fleet summary
 */
export const zGetDaemonsSummaryResponse = zWorkforceFleetSummaryResult;

/**
 * Workforce member project assignments
 */
export const zListDaemonsAssignmentsResponse = zWorkforceAssignmentList;

/**
 * Resumed
 */
export const zResumeAllDaemonsResponse = zWorkforceResumeAllResult;

/**
 * All daemons killed
 */
export const zTerminateAllDaemonsResponse = zWorkforceTerminateAllResult;

export const zReviewDaemonsFindingBody = zFindingReviewUpdate;

export const zReviewDaemonsFindingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Finding reviewed
 */
export const zReviewDaemonsFindingResponse = zWorkforceRecord;

export const zListDaemonPermissionGrantsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListDaemonPermissionGrantsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'active',
        'revoked',
        'expired',
        'all'
    ]).optional(),
    grantMode: /*#__PURE__*/ z.enum(['once', 'always']).optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Permission grants
 */
export const zListDaemonPermissionGrantsResponse = zDaemonPermissionGrantList;

export const zRevokeDaemonPermissionGrantBody = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().optional()
});

export const zRevokeDaemonPermissionGrantPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    grantId: /*#__PURE__*/ z.string()
});

/**
 * Permission grant revoked
 */
export const zRevokeDaemonPermissionGrantResponse = zWorkforceItemResult;

export const zRunDaemonPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Run triggered
 */
export const zRunDaemonResponse = zWorkforceRunTriggeredResult;

export const zListDaemonRunsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListDaemonRunsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'running',
        'completed',
        'failed',
        'skipped'
    ]).optional()
});

/**
 * Run history
 */
export const zListDaemonRunsResponse = zDaemonRunList;

export const zStreamDaemonRunsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * SSE stream
 */
export const zStreamDaemonRunsResponse = zWorkforceSseResult;

export const zGetDaemonRunPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Single run
 */
export const zGetDaemonRunResponse = zWorkforceRecord;

export const zListDaemonRunReportsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run reports
 */
export const zListDaemonRunReportsResponse = zDaemonRunReportList;

export const zListDaemonRunDecisionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run decisions
 */
export const zListDaemonRunDecisionsResponse = zDaemonRunDecisionList;

export const zListDaemonRunExecutionEnvelopesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run execution envelopes
 */
export const zListDaemonRunExecutionEnvelopesResponse = zDaemonExecutionEnvelopeList;

export const zGetDaemonRunAuditPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Full daemon run audit
 */
export const zGetDaemonRunAuditResponse = zWorkforceRunAuditResult;

export const zGrantDaemonRunExecutionEnvelopePermissionBody = zExecutionPermissionGrantCreate;

export const zGrantDaemonRunExecutionEnvelopePermissionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string(),
    envelopeId: /*#__PURE__*/ z.string()
});

/**
 * Permission grant created
 */
export const zGrantDaemonRunExecutionEnvelopePermissionResponse = zWorkforceItemResult;

export const zListDaemonTriggersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Trigger list
 */
export const zListDaemonTriggersResponse = zDaemonTriggerList;

export const zCreateDaemonTriggerBody = zDaemonTriggerCreate;

export const zCreateDaemonTriggerPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Created
 */
export const zCreateDaemonTriggerResponse = zWorkforceRecord;

export const zDeleteDaemonTriggerPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    triggerId: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteDaemonTriggerResponse = zWorkforceMessageResult;

export const zUpdateDaemonTriggerBody = zDaemonTriggerUpdate;

export const zUpdateDaemonTriggerPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    triggerId: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateDaemonTriggerResponse = zWorkforceRecord;

export const zListDaemonsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'name'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false),
    status: /*#__PURE__*/ z.enum([
        'idle',
        'running',
        'waiting',
        'error',
        'paused',
        'terminated'
    ]).optional(),
    department: /*#__PURE__*/ z.enum([
        'research',
        'security',
        'quality',
        'testing',
        'docs',
        'performance',
        'infrastructure',
        'custom'
    ]).optional(),
    enabled: /*#__PURE__*/ z.boolean().nullish(),
    q: /*#__PURE__*/ z.string().max(200).optional()
});

/**
 * Daemon list
 */
export const zListDaemonsResponse = zDaemonPaginatedList;

export const zCreateDaemonBody = zDaemonCreate;

/**
 * Created
 */
export const zCreateDaemonResponse = zDaemonRecord;

export const zGetDaemonReadinessPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Daemon readiness report
 */
export const zGetDaemonReadinessResponse = zDaemonReadinessResult;

export const zDeleteDaemonPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteDaemonResponse = zWorkforceMessageResult;

export const zGetDaemonPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Daemon
 */
export const zGetDaemonResponse = zDaemonRecord;

export const zUpdateDaemonBody = zDaemonUpdate;

export const zUpdateDaemonPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateDaemonResponse = zDaemonRecord;

export const zEnableDaemonPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Enabled
 */
export const zEnableDaemonResponse = zDaemonRecord;

export const zDisableDaemonPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Disabled
 */
export const zDisableDaemonResponse = zDaemonRecord;

export const zResetDaemonGovernancePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Governance circuit reset
 */
export const zResetDaemonGovernanceResponse = zDaemonRecord;

export const zSetDaemonRuntimePolicyBody = zEmployeeRuntimePolicyWrite;

export const zSetDaemonRuntimePolicyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * The policy the employee runs under, set
 */
export const zSetDaemonRuntimePolicyResponse = zEmployeeRuntimePolicyWrite;

export const zListDaemonReflectionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Reflection log
 */
export const zListDaemonReflectionsResponse = zDaemonReflectionList;

export const zGetDaemonTrendPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Quality trend
 */
export const zGetDaemonTrendResponse = zWorkforceTrendResult;

export const zListDaemonFindingsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListDaemonFindingsQuery = /*#__PURE__*/ z.object({
    severity: /*#__PURE__*/ z.string().optional(),
    reviewStatus: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Findings list
 */
export const zListDaemonFindingsResponse = zDaemonFindingList;

export const zListDaemonWorkflowsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workflow assignments
 */
export const zListDaemonWorkflowsResponse = zDaemonWorkflowList;

export const zAssignDaemonWorkflowBody = zDaemonWorkflowAssign;

export const zAssignDaemonWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Assigned
 */
export const zAssignDaemonWorkflowResponse = zWorkforceRecord;

export const zRemoveDaemonWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    workflowId: /*#__PURE__*/ z.string()
});

/**
 * Removed
 */
export const zRemoveDaemonWorkflowResponse = zWorkforceMessageResult;

/**
 * Event catalog
 */
export const zListWorkforceEventCatalogResponse = zWorkforceEventCatalogResult;

/**
 * Fleet summary
 */
export const zGetWorkforceSummaryResponse = zWorkforceFleetSummaryResult;

/**
 * Workforce member project assignments
 */
export const zListWorkforceAssignmentsResponse = zWorkforceAssignmentList;

/**
 * Resumed
 */
export const zResumeAllEmployeesResponse = zWorkforceResumeAllResult;

/**
 * All daemons killed
 */
export const zTerminateAllEmployeesResponse = zWorkforceTerminateAllResult;

export const zReviewWorkforceFindingBody = zFindingReviewUpdate;

export const zReviewWorkforceFindingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Finding reviewed
 */
export const zReviewWorkforceFindingResponse = zWorkforceRecord;

export const zListEmployeePermissionGrantsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListEmployeePermissionGrantsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'active',
        'revoked',
        'expired',
        'all'
    ]).optional(),
    grantMode: /*#__PURE__*/ z.enum(['once', 'always']).optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Permission grants
 */
export const zListEmployeePermissionGrantsResponse = zDaemonPermissionGrantList;

export const zRevokeEmployeePermissionGrantBody = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().optional()
});

export const zRevokeEmployeePermissionGrantPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    grantId: /*#__PURE__*/ z.string()
});

/**
 * Permission grant revoked
 */
export const zRevokeEmployeePermissionGrantResponse = zWorkforceItemResult;

export const zRunEmployeePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Run triggered
 */
export const zRunEmployeeResponse = zWorkforceRunTriggeredResult;

export const zListEmployeeRunsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListEmployeeRunsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'running',
        'completed',
        'failed',
        'skipped'
    ]).optional()
});

/**
 * Run history
 */
export const zListEmployeeRunsResponse = zDaemonRunList;

export const zStreamEmployeeRunsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * SSE stream
 */
export const zStreamEmployeeRunsResponse = zWorkforceSseResult;

export const zGetEmployeeRunPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Single run
 */
export const zGetEmployeeRunResponse = zWorkforceRecord;

export const zListEmployeeRunReportsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run reports
 */
export const zListEmployeeRunReportsResponse = zDaemonRunReportList;

export const zListEmployeeRunDecisionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run decisions
 */
export const zListEmployeeRunDecisionsResponse = zDaemonRunDecisionList;

export const zListEmployeeRunExecutionEnvelopesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Run execution envelopes
 */
export const zListEmployeeRunExecutionEnvelopesResponse = zDaemonExecutionEnvelopeList;

export const zGetEmployeeRunAuditPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string()
});

/**
 * Full daemon run audit
 */
export const zGetEmployeeRunAuditResponse = zWorkforceRunAuditResult;

export const zGrantEmployeeRunExecutionEnvelopePermissionBody = zExecutionPermissionGrantCreate;

export const zGrantEmployeeRunExecutionEnvelopePermissionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    runId: /*#__PURE__*/ z.string(),
    envelopeId: /*#__PURE__*/ z.string()
});

/**
 * Permission grant created
 */
export const zGrantEmployeeRunExecutionEnvelopePermissionResponse = zWorkforceItemResult;

export const zListEmployeeTriggersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Trigger list
 */
export const zListEmployeeTriggersResponse = zDaemonTriggerList;

export const zCreateEmployeeTriggerBody = zDaemonTriggerCreate;

export const zCreateEmployeeTriggerPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Created
 */
export const zCreateEmployeeTriggerResponse = zWorkforceRecord;

export const zDeleteEmployeeTriggerPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    triggerId: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteEmployeeTriggerResponse = zWorkforceMessageResult;

export const zUpdateEmployeeTriggerBody = zDaemonTriggerUpdate;

export const zUpdateEmployeeTriggerPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    triggerId: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateEmployeeTriggerResponse = zWorkforceRecord;

export const zListEmployeesQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'name'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false),
    status: /*#__PURE__*/ z.enum([
        'idle',
        'running',
        'waiting',
        'error',
        'paused',
        'terminated'
    ]).optional(),
    department: /*#__PURE__*/ z.enum([
        'research',
        'security',
        'quality',
        'testing',
        'docs',
        'performance',
        'infrastructure',
        'custom'
    ]).optional(),
    enabled: /*#__PURE__*/ z.boolean().nullish(),
    q: /*#__PURE__*/ z.string().max(200).optional()
});

/**
 * Daemon list
 */
export const zListEmployeesResponse = zDaemonPaginatedList;

export const zCreateEmployeeBody = zDaemonCreate;

/**
 * Created
 */
export const zCreateEmployeeResponse = zDaemonRecord;

export const zGetEmployeeReadinessPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Daemon readiness report
 */
export const zGetEmployeeReadinessResponse = zDaemonReadinessResult;

export const zDeleteEmployeePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteEmployeeResponse = zWorkforceMessageResult;

export const zGetEmployeePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Daemon
 */
export const zGetEmployeeResponse = zDaemonRecord;

export const zUpdateEmployeeBody = zDaemonUpdate;

export const zUpdateEmployeePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateEmployeeResponse = zDaemonRecord;

export const zEnableEmployeePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Enabled
 */
export const zEnableEmployeeResponse = zDaemonRecord;

export const zDisableEmployeePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Disabled
 */
export const zDisableEmployeeResponse = zDaemonRecord;

export const zResetEmployeeGovernancePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Governance circuit reset
 */
export const zResetEmployeeGovernanceResponse = zDaemonRecord;

export const zSetEmployeeRuntimePolicyBody = zEmployeeRuntimePolicyWrite;

export const zSetEmployeeRuntimePolicyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * The policy the employee runs under, set
 */
export const zSetEmployeeRuntimePolicyResponse = zEmployeeRuntimePolicyWrite;

export const zListEmployeeReflectionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Reflection log
 */
export const zListEmployeeReflectionsResponse = zDaemonReflectionList;

export const zGetEmployeeTrendPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Quality trend
 */
export const zGetEmployeeTrendResponse = zWorkforceTrendResult;

export const zListEmployeeFindingsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListEmployeeFindingsQuery = /*#__PURE__*/ z.object({
    severity: /*#__PURE__*/ z.string().optional(),
    reviewStatus: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Findings list
 */
export const zListEmployeeFindingsResponse = zDaemonFindingList;

export const zListEmployeeWorkflowsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workflow assignments
 */
export const zListEmployeeWorkflowsResponse = zDaemonWorkflowList;

export const zAssignEmployeeWorkflowBody = zDaemonWorkflowAssign;

export const zAssignEmployeeWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Assigned
 */
export const zAssignEmployeeWorkflowResponse = zWorkforceRecord;

export const zRemoveEmployeeWorkflowPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    workflowId: /*#__PURE__*/ z.string()
});

/**
 * Removed
 */
export const zRemoveEmployeeWorkflowResponse = zWorkforceMessageResult;

export const zSetDecisionRuntimePolicyBody = zRuntimePolicyAssignment;

export const zSetDecisionRuntimePolicyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * The request’s runtime policy, changed
 */
export const zSetDecisionRuntimePolicyResponse = /*#__PURE__*/ z.object({
    runtimePolicy: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.int().gt(0),
        name: /*#__PURE__*/ z.string().min(1).max(200),
        surface: /*#__PURE__*/ z.enum([
            'conversation',
            'workforce',
            'workflow',
            'analysis',
            'evaluation',
            'judge',
            'codegen',
            'system',
            'research'
        ]),
        changeable: /*#__PURE__*/ z.boolean()
    })
});

export const zGetDaemonDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Daemon decision
 */
export const zGetDaemonDecisionResponse = zDaemonDecision;

export const zApproveDaemonDecisionBody = zDaemonDecisionReviewRequest;

export const zApproveDaemonDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated daemon decision
 */
export const zApproveDaemonDecisionResponse = zDaemonDecision;

export const zRejectDaemonDecisionBody = zDaemonDecisionReviewRequest;

export const zRejectDaemonDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated daemon decision
 */
export const zRejectDaemonDecisionResponse = zDaemonDecision;

export const zDeferDaemonDecisionBody = zDaemonDecisionReviewRequest;

export const zDeferDaemonDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated daemon decision
 */
export const zDeferDaemonDecisionResponse = zDaemonDecision;

export const zListImprovementProposalsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'idea',
        'specced',
        'implementing',
        'auditing',
        'ready_for_human',
        'approved',
        'rejected',
        'applying',
        'applied',
        'measured',
        'failed',
        'superseded'
    ]).optional(),
    kind: /*#__PURE__*/ z.enum([
        'finance_bank_entity',
        'platform_code',
        'template_tuning',
        'data_source',
        'process'
    ]).optional(),
    riskClass: /*#__PURE__*/ z.enum([
        'low',
        'medium',
        'high',
        'critical'
    ]).optional(),
    pendingDesignReview: /*#__PURE__*/ z.enum(['true', 'false']).optional(),
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional().default(50),
    offset: /*#__PURE__*/ z.int().gte(0).nullish().default(0)
});

/**
 * Improvement proposals
 */
export const zListImprovementProposalsResponse = zImprovementProposalList;

export const zGetImprovementProposalPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Improvement proposal
 */
export const zGetImprovementProposalResponse = zImprovementProposal;

export const zDecideImprovementProposalBody = zImprovementProposalDecisionBody;

export const zDecideImprovementProposalPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Decision recorded
 */
export const zDecideImprovementProposalResponse = zImprovementProposalDecision;

export const zDecideImprovementProposalDesignBody = zImprovementProposalDesignDecisionBody;

export const zDecideImprovementProposalDesignPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Design decision accepted (engine resolves the checkpoint on consumption)
 */
export const zDecideImprovementProposalDesignResponse = zImprovementProposalDesignDecision;

export const zGetImprovementMetricsQuery = /*#__PURE__*/ z.object({
    windowDays: /*#__PURE__*/ z.int().gt(0).lte(365).optional().default(30)
});

/**
 * Computed self-improvement metrics
 */
export const zGetImprovementMetricsResponse = zImprovementMetrics;

/**
 * Per-lane tier status
 */
export const zGetImprovementTierStatusResponse = zImprovementTierStatus;

export const zExpandImprovementTierBody = zImprovementTierExpandRequest;

/**
 * Tier expanded
 */
export const zExpandImprovementTierResponse = zImprovementTierExpansion;

export const zListWorkflowGatesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional().default(20)
});

/**
 * Workflow gate list
 */
export const zListWorkflowGatesResponse = /*#__PURE__*/ z.array(zWorkflowGate);

export const zGetWorkflowGatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow gate
 */
export const zGetWorkflowGateResponse = zWorkflowGate;

export const zApproveWorkflowGateBody = zWorkflowGateApproveRequest;

export const zApproveWorkflowGatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow gate
 */
export const zApproveWorkflowGateResponse = zWorkflowGate;

export const zRejectWorkflowGateBody = zWorkflowGateRejectRequest;

export const zRejectWorkflowGatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Workflow gate
 */
export const zRejectWorkflowGateResponse = zWorkflowGate;

export const zListMarketplaceListingsQuery = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    search: /*#__PURE__*/ z.string().optional(),
    pricing: /*#__PURE__*/ z.enum(['free', 'paid']).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional()
});

/**
 * Published listings
 */
export const zListMarketplaceListingsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zMarketplaceListing)
});

export const zPublishMarketplaceListingBody = zMarketplaceListingCreate;

/**
 * Published
 */
export const zPublishMarketplaceListingResponse = zMarketplaceListing;

export const zDeleteMarketplaceListingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().nullish()
});

/**
 * Removed
 */
export const zDeleteMarketplaceListingResponse = zMarketplaceActionResult;

export const zInstallMarketplaceListingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().nullish()
});

/**
 * Acquired
 */
export const zInstallMarketplaceListingResponse = zEntity;

export const zForkMarketplaceListingBody = zMarketplaceForkRequest;

export const zForkMarketplaceListingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().nullish()
});

/**
 * Forked
 */
export const zForkMarketplaceListingResponse = zMarketplaceForkedEntity;

/**
 * Entities this organization acquired
 */
export const zListMarketplaceInstallationsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zEntity)
});

export const zListMarketplaceUpdatesQuery = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum([
        'tool',
        'skill',
        'agent_template',
        'strategy',
        'bucket',
        'indicator',
        'workflow',
        'workforce',
        'strategy_template',
        'mutation_recipe',
        'evaluation_template'
    ]).optional()
});

/**
 * Acquired entities whose source has published different content since
 */
export const zListMarketplaceUpdatesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zMarketplaceAcquisition)
});

export const zApplyMarketplaceUpdatesBody = zMarketplaceUpdateAllRequest;

/**
 * Every acquired entity with an update moved to its newest version
 */
export const zApplyMarketplaceUpdatesResponse = zMarketplaceUpdateAllResult;

export const zGetMarketplaceEntityVersionsPath = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * One acquired entity with every version its source published
 */
export const zGetMarketplaceEntityVersionsResponse = zMarketplaceAcquisition;

export const zUpdateMarketplaceEntityBody = zMarketplaceEntityUpdateRequest;

export const zUpdateMarketplaceEntityPath = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * The entity now runs the newest version of its source, or the version named
 */
export const zUpdateMarketplaceEntityResponse = zMarketplaceAcquisitionMove;

/**
 * Held entities that reach an MCP tool, directly or through what they link, and have no binding yet
 */
export const zListMarketplaceNeedsSetupResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zMarketplaceNeedsSetupEntity)
});

export const zUnbindMarketplaceEntityConnectionPath = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number().nullish()
});

/**
 * Unbound
 */
export const zUnbindMarketplaceEntityConnectionResponse = zMarketplaceActionResult;

export const zBindMarketplaceEntityConnectionBody = zBindConnectionRequest;

export const zBindMarketplaceEntityConnectionPath = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.number().nullish()
});

/**
 * Bound
 */
export const zBindMarketplaceEntityConnectionResponse = zMarketplaceActionResult;

export const zGetMarketplaceBundlePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Marketplace bundle detail
 */
export const zGetMarketplaceBundleResponse = zMarketplaceBundle;

export const zCreateMarketplaceBundleBody = zMarketplaceBundleCreate;

/**
 * Bundle created
 */
export const zCreateMarketplaceBundleResponse = zMarketplaceBundle;

export const zAddMarketplaceBundleEntityBody = zMarketplaceBundleAddEntity;

export const zAddMarketplaceBundleEntityPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().nullish()
});

/**
 * Entity added
 */
export const zAddMarketplaceBundleEntityResponse = zMarketplaceActionResult;

export const zRemoveMarketplaceBundleEntityPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.number().nullish(),
    entityId: /*#__PURE__*/ z.number().nullish()
});

/**
 * Entity removed
 */
export const zRemoveMarketplaceBundleEntityResponse = zMarketplaceActionResult;

export const zListEntityVersionsPath = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Version history
 */
export const zListEntityVersionsResponse = zEntityVersionList;

export const zCreateEntityVersionDraftBody = zEntityDraftCreate;

export const zCreateEntityVersionDraftPath = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Draft opened
 */
export const zCreateEntityVersionDraftResponse = zEntityVersion;

export const zActivateEntityVersionPath = /*#__PURE__*/ z.object({
    entityId: /*#__PURE__*/ z.int().gt(0),
    versionId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Now the active version
 */
export const zActivateEntityVersionResponse = zEntityVersion;

/**
 * ML service health
 */
export const zGetMlHealthResponse = zMlHealth;

/**
 * Current market regime
 */
export const zGetMlRegimeResponse = zMlRegime;

/**
 * Strategy regime scores
 */
export const zGetMlStrategyScoresResponse = zMlStrategyScores;

export const zCreateWorkerRunBody = zWorkerRunCreate;

/**
 * Run accepted
 */
export const zCreateWorkerRunResponse = zWorkerRun;

export const zCancelWorkerRunPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

export const zCancelWorkerRunQuery = /*#__PURE__*/ z.object({
    reason: /*#__PURE__*/ z.string().max(500).optional()
});

/**
 * Cancellation enqueued
 */
export const zCancelWorkerRunResponse = /*#__PURE__*/ z.void();

export const zGetWorkerRunPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

export const zGetWorkerRunResponse = /*#__PURE__*/ z.union([
    zWorkerRun,
    zWorkerRunPending
]);

export const zFollowUpWorkerRunBody = zWorkerRunFollowUpRequest;

export const zFollowUpWorkerRunPath = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

/**
 * Follow-up accepted
 */
export const zFollowUpWorkerRunResponse = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.string()
});

export const zCallPlatformMcpBody = zPlatformMcpRequest;

/**
 * MCP JSON-RPC response
 */
export const zCallPlatformMcpResponse = zPlatformMcpResponse;

export const zListApiKeysQuery = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'worker_sdk',
        'service_account',
        'user',
        'host_reporter'
    ]).optional()
});

/**
 * API keys for the org (bare array — bounded list)
 */
export const zListApiKeysResponse = /*#__PURE__*/ z.array(zApiKey);

export const zCreateApiKeyBody = zApiKeyCreate;

/**
 * API key created — plaintext returned once
 */
export const zCreateApiKeyResponse = zIssuedApiKey;

/**
 * The entity permission keys a user key may be narrowed to (`metadata.grants`) — generated from the entity skills
 */
export const zListApiKeyGrantablePermissionsResponse = zApiKeyGrantablePermissions;

export const zGetApiKeyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * API key
 */
export const zGetApiKeyResponse = zApiKey;

export const zUpdateApiKeyBody = zApiKeyUpdate;

export const zUpdateApiKeyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Updated API key
 */
export const zUpdateApiKeyResponse = zApiKey;

export const zRevokeApiKeyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Revoked API key (revokedAt populated)
 */
export const zRevokeApiKeyResponse = zApiKey;

export const zRotateApiKeyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Rotated API key — new plaintext returned once
 */
export const zRotateApiKeyResponse = zIssuedApiKey;

export const zListJourneysQuery = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.int().gt(0).optional(),
    actorId: /*#__PURE__*/ z.string().min(1).max(240).optional(),
    contextType: /*#__PURE__*/ zJourneyContextType.optional(),
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    cursor: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Granular product/LLM journeys for reconstructing user, workflow, Code, and review flows
 */
export const zListJourneysResponse = zJourneyList;

export const zListJourneyEventsPath = /*#__PURE__*/ z.object({
    journeyId: /*#__PURE__*/ z.string()
});

export const zListJourneyEventsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    cursor: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Journey events with raw evidence omitted
 */
export const zListJourneyEventsResponse = zJourneyEventList;

export const zListJourneyRawEventsPath = /*#__PURE__*/ z.object({
    journeyId: /*#__PURE__*/ z.string()
});

export const zListJourneyRawEventsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    cursor: /*#__PURE__*/ z.iso.datetime().optional(),
    purpose: /*#__PURE__*/ z.string().min(3).max(400)
});

/**
 * Journey events including raw evidence. Purpose is required and access is itself recorded.
 */
export const zListJourneyRawEventsResponse = zJourneyRawEventList;

export const zListDepartmentsQuery = /*#__PURE__*/ z.object({
    module_id: /*#__PURE__*/ z.string().min(1).max(50).optional()
});

/**
 * Bounded list of departments (bare array, ≤100 rows in practice)
 */
export const zListDepartmentsResponse = /*#__PURE__*/ z.array(zDepartment);

/**
 * Enabled modules
 */
export const zListMyModulesResponse = zModuleList;

export const zGetWaitingOnMeQuery = /*#__PURE__*/ z.object({
    moduleId: /*#__PURE__*/ z.string().max(50).optional()
});

/**
 * Waiting-on-me summary
 */
export const zGetWaitingOnMeResponse = zWaitingOnMe;

/**
 * Conversation groups for this organization
 */
export const zListConversationGroupsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zConversationGroup)
});

export const zCreateConversationGroupBody = zConversationGroupCreate;

/**
 * Created (or the existing group of that name)
 */
export const zCreateConversationGroupResponse = zConversationGroup;

export const zDeleteConversationGroupPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteConversationGroupResponse = /*#__PURE__*/ z.object({
    deleted: /*#__PURE__*/ z.boolean()
});

export const zListConversationsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'lastActivityAt',
        'topic'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false),
    kind: /*#__PURE__*/ z.enum([
        'user-agent',
        'agent-agent',
        'team',
        'assistant-ui'
    ]).optional(),
    include_assistant_ui: /*#__PURE__*/ z.boolean().nullish().default(false),
    projectId: /*#__PURE__*/ z.string().optional(),
    teamId: /*#__PURE__*/ z.string().optional(),
    parentConversationId: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'idle',
        'completed',
        'errored'
    ]).optional(),
    moduleId: /*#__PURE__*/ z.string().max(50).optional(),
    needsUser: /*#__PURE__*/ z.boolean().nullish(),
    q: /*#__PURE__*/ z.string().max(200).optional(),
    involvesMe: /*#__PURE__*/ z.boolean().nullish(),
    groupId: /*#__PURE__*/ z.string().regex(/^(none|\d+)$/).optional(),
    expand: /*#__PURE__*/ z.string().optional()
});

/**
 * Paginated conversation list
 */
export const zListConversationsResponse = zConversationList;

export const zCreateConversationBody = zConversationCreate;

/**
 * Conversation created
 */
export const zCreateConversationResponse = zConversation;

export const zStartConversationFromMessageBody = zConversationQuickStart;

/**
 * Conversation created from the first user message
 */
export const zStartConversationFromMessageResponse = zConversationQuickStartResult;

export const zDeleteConversationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteConversationResponse = zConversationActionResult;

export const zGetConversationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zGetConversationQuery = /*#__PURE__*/ z.object({
    expand: /*#__PURE__*/ z.string().optional()
});

/**
 * Conversation
 */
export const zGetConversationResponse = zConversation;

export const zUpdateConversationBody = zConversationUpdate;

export const zUpdateConversationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated conversation
 */
export const zUpdateConversationResponse = zConversation;

export const zListConversationMembersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListConversationMembersQuery = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'persona',
        'workforce_member',
        'external_agent',
        'agent_instance'
    ]).optional(),
    includeLeft: /*#__PURE__*/ z.boolean().nullish()
});

/**
 * Conversation member list
 */
export const zListConversationMembersResponse = /*#__PURE__*/ z.array(zConversationMember);

export const zInviteToConversationBody = zConversationInviteRequest;

export const zInviteToConversationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Member added
 */
export const zInviteToConversationResponse = zConversationMember;

export const zRemoveConversationMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    memberId: /*#__PURE__*/ z.string()
});

/**
 * Member removed
 */
export const zRemoveConversationMemberResponse = zConversationMemberActionResult;

export const zSetConversationLeadPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    memberId: /*#__PURE__*/ z.string()
});

/**
 * The member now leads
 */
export const zSetConversationLeadResponse = zConversationMember;

export const zListConversationEntitiesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * The records the conversation works on, newest first (at most 200)
 */
export const zListConversationEntitiesResponse = /*#__PURE__*/ z.array(zConversationEntity);

export const zListConversationAttachmentsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListConversationAttachmentsQuery = /*#__PURE__*/ z.object({
    attachedType: /*#__PURE__*/ z.enum([
        'artifact',
        'memory',
        'task',
        'conversation',
        'project',
        'workflow'
    ]).optional()
});

/**
 * Conversation attachment list
 */
export const zListConversationAttachmentsResponse = /*#__PURE__*/ z.array(zConversationAttachment);

export const zAttachToConversationBody = zConversationAttachRequest;

export const zAttachToConversationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Attachment created
 */
export const zAttachToConversationResponse = zConversationAttachment;

export const zDetachFromConversationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    attachmentId: /*#__PURE__*/ z.string()
});

/**
 * Attachment removed
 */
export const zDetachFromConversationResponse = zConversationAttachmentActionResult;

export const zListConversationIntentsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListConversationIntentsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional()
});

/**
 * Paginated intent classifications, newest first
 */
export const zListConversationIntentsResponse = zIntentList;

export const zDisambiguateConversationIntentBody = zConversationIntentDisambiguateRequest;

export const zDisambiguateConversationIntentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    decision_id: /*#__PURE__*/ z.string()
});

/**
 * Disambiguation accepted; new decision row created and dispatched
 */
export const zDisambiguateConversationIntentResponse = zConversationIntentDisambiguateResult;

export const zEnableConversationIntentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Intent classification re-enabled for this conversation
 */
export const zEnableConversationIntentResponse = zConversationIntentSettings;

export const zDisableConversationIntentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Intent classification disabled for this conversation
 */
export const zDisableConversationIntentResponse = zConversationIntentSettings;

export const zGetConversationMessageByIdPath = /*#__PURE__*/ z.object({
    messageId: /*#__PURE__*/ z.string()
});

/**
 * Conversation message
 */
export const zGetConversationMessageByIdResponse = zConversationMessage;

export const zListConversationMessagesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListConversationMessagesQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Paginated message list
 */
export const zListConversationMessagesResponse = zConversationMessageList;

export const zReplyToConversationBody = zConversationReplyRequest;

export const zReplyToConversationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Message created (with intent classification on user messages)
 */
export const zReplyToConversationResponse = zConversationReply;

export const zSubmitConversationInteractionBody = zConversationInteractionSubmitRequest;

export const zSubmitConversationInteractionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    interactionId: /*#__PURE__*/ z.string()
});

/**
 * Structured interaction response submitted
 */
export const zSubmitConversationInteractionResponse = zConversationReply;

export const zCloseContextPanelBody = zConversationClosePanelRequest;

export const zCloseContextPanelPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Close-summary system message posted to the parent conversation
 */
export const zCloseContextPanelResponse = zConversationReply;

export const zSubscribeConversationEventsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zSubscribeConversationEventsQuery = /*#__PURE__*/ z.object({
    last_event_id: /*#__PURE__*/ z.string().optional()
});

/**
 * SSE stream — text/event-stream. Each frame is a JSON-serialised ConversationEventEnvelope. See Spec 66 §6 for envelope schema.
 */
export const zSubscribeConversationEventsResponse = /*#__PURE__*/ z.string();

export const zSetConversationTypingBody = zConversationTypingRequest;

export const zSetConversationTypingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Typing indicator updated
 */
export const zSetConversationTypingResponse = /*#__PURE__*/ z.void();

export const zSetConversationRuntimePolicyBody = zConversationRuntimePolicyWrite;

export const zSetConversationRuntimePolicyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * The conversation's policy, set
 */
export const zSetConversationRuntimePolicyResponse = zConversationRuntimePolicyWrite;

export const zPatchConversationSettingsBody = zConversationSettingsPatch;

export const zPatchConversationSettingsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Settings applied
 */
export const zPatchConversationSettingsResponse = zConversationSettingsPatchResult;

export const zGetConversationContextPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Conversation context pack public view and settings
 */
export const zGetConversationContextResponse = zConversationContextResult;

export const zListConversationArtifactsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListConversationArtifactsQuery = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().optional(),
    before: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'title'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false),
    include_deleted: /*#__PURE__*/ z.boolean().nullish().default(false),
    view: /*#__PURE__*/ z.enum(['full', 'summary']).optional().default('summary')
});

/**
 * Paginated list of artifacts scoped to this conversation
 */
export const zListConversationArtifactsResponse = /*#__PURE__*/ z.union([
    zArtifactList,
    zArtifactSummaryList
]);

export const zPresignUploadBody = zUploadPresignRequest;

/**
 * A pending upload and its PUT URL
 */
export const zPresignUploadResponse = zUploadPresignResult;

export const zFinalizeUploadPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int()
});

/**
 * The upload, ready
 */
export const zFinalizeUploadResponse = zUpload;

export const zGetUploadContentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int()
});

/**
 * The file, to its owner only
 */
export const zGetUploadContentResponse = /*#__PURE__*/ z.string();

export const zDeleteUploadPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int()
});

/**
 * Removed
 */
export const zDeleteUploadResponse = /*#__PURE__*/ z.void();

export const zListMemoriesQuery = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]).optional(),
    subjectType: /*#__PURE__*/ z.enum([
        'conversation_id',
        'team_id',
        'task_id',
        'project_id',
        'agent_template_id',
        'daemon_id',
        'organization_id'
    ]).optional(),
    subjectId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().optional(),
    before: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum(['createdAt']).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false),
    include_deleted: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Paginated memory list
 */
export const zListMemoriesResponse = zMemoryList;

export const zCreateMemoryBody = zMemoryCreate;

/**
 * Memory created
 */
export const zCreateMemoryResponse = zMemory;

export const zSearchMemoriesQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(200),
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().optional()
});

/**
 * Full-text search results (paginated)
 */
export const zSearchMemoriesResponse = zMemoryList;

export const zDeleteMemoryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Memory soft-deleted
 */
export const zDeleteMemoryResponse = zMemoryActionResult;

export const zGetMemoryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Memory
 */
export const zGetMemoryResponse = zMemory;

export const zUpdateMemoryBody = zMemoryUpdate;

export const zUpdateMemoryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated memory
 */
export const zUpdateMemoryResponse = zMemory;

export const zPromoteMemoryBody = zMemoryPromoteRequest;

export const zPromoteMemoryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Promoted memory (new row at wider scope)
 */
export const zPromoteMemoryResponse = zMemory;

export const zListArtifactsQuery = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]).optional(),
    subjectType: /*#__PURE__*/ z.string().optional(),
    subjectId: /*#__PURE__*/ z.string().optional(),
    kind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().optional(),
    before: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'title'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false),
    include_deleted: /*#__PURE__*/ z.boolean().nullish().default(false),
    view: /*#__PURE__*/ z.enum(['full', 'summary']).optional().default('full')
});

/**
 * Paginated artifact list
 */
export const zListArtifactsResponse = /*#__PURE__*/ z.union([
    zArtifactList,
    zArtifactSummaryList
]);

export const zCreateArtifactBody = zArtifactCreate;

/**
 * Artifact created
 */
export const zCreateArtifactResponse = zArtifact;

export const zSearchArtifactsQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(200),
    scope: /*#__PURE__*/ z.enum([
        'conversation',
        'team',
        'task',
        'project',
        'agent',
        'org'
    ]).optional(),
    kind: /*#__PURE__*/ z.enum([
        'decision',
        'plan',
        'draft',
        'report',
        'code',
        'spec',
        'design',
        'custom'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().optional(),
    view: /*#__PURE__*/ z.enum(['full', 'summary']).optional().default('full')
});

/**
 * Full-text search results (paginated)
 */
export const zSearchArtifactsResponse = /*#__PURE__*/ z.union([
    zArtifactList,
    zArtifactSummaryList
]);

export const zDeleteArtifactPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Artifact soft-deleted
 */
export const zDeleteArtifactResponse = zArtifactActionResult;

export const zGetArtifactPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Artifact
 */
export const zGetArtifactResponse = zArtifact;

export const zUpdateArtifactBody = zArtifactUpdate;

export const zUpdateArtifactPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated artifact
 */
export const zUpdateArtifactResponse = zArtifact;

export const zListProjectTeamMembersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string()
});

export const zListProjectTeamMembersQuery = /*#__PURE__*/ z.object({
    includeInactive: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Team member list
 */
export const zListProjectTeamMembersResponse = /*#__PURE__*/ z.array(zProjectTeamMember);

export const zAddProjectTeamMemberBody = zTeamMemberAddRequest;

export const zAddProjectTeamMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string()
});

/**
 * Member added
 */
export const zAddProjectTeamMemberResponse = zProjectTeamMember;

export const zRemoveProjectTeamMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string(),
    memberId: /*#__PURE__*/ z.string()
});

export const zRemoveProjectTeamMemberQuery = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ])
});

/**
 * Member removed
 */
export const zRemoveProjectTeamMemberResponse = /*#__PURE__*/ z.void();

export const zUpdateProjectTeamMemberBody = zTeamMemberUpdateRoleRequest;

export const zUpdateProjectTeamMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string(),
    memberId: /*#__PURE__*/ z.string()
});

export const zUpdateProjectTeamMemberQuery = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ])
});

/**
 * Member role updated
 */
export const zUpdateProjectTeamMemberResponse = zProjectTeamMember;

export const zListProjectTeamsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project team list
 */
export const zListProjectTeamsResponse = /*#__PURE__*/ z.array(zProjectTeam);

export const zCreateProjectTeamBody = zProjectTeamCreate;

export const zCreateProjectTeamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Team created
 */
export const zCreateProjectTeamResponse = zProjectTeam;

export const zDeleteProjectTeamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string()
});

/**
 * Team archived
 */
export const zDeleteProjectTeamResponse = /*#__PURE__*/ z.void();

export const zGetProjectTeamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string()
});

/**
 * Project team
 */
export const zGetProjectTeamResponse = zProjectTeam;

export const zUpdateProjectTeamBody = zProjectTeamUpdate;

export const zUpdateProjectTeamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    teamId: /*#__PURE__*/ z.string()
});

/**
 * Team updated
 */
export const zUpdateProjectTeamResponse = zProjectTeam;

export const zListProjectMembersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListProjectMembersQuery = /*#__PURE__*/ z.object({
    role: /*#__PURE__*/ z.enum([
        'owner',
        'manager',
        'contributor',
        'observer'
    ]).optional(),
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]).optional(),
    includeInactive: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Project member list
 */
export const zListProjectMembersResponse = /*#__PURE__*/ z.array(zProjectMember);

export const zAddProjectMemberBody = zProjectMemberAddRequest;

export const zAddProjectMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Member added
 */
export const zAddProjectMemberResponse = zProjectMember;

export const zRemoveProjectMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    memberId: /*#__PURE__*/ z.string()
});

export const zRemoveProjectMemberQuery = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ])
});

/**
 * Member removed
 */
export const zRemoveProjectMemberResponse = /*#__PURE__*/ z.void();

export const zUpdateProjectMemberRoleBody = zProjectMemberUpdateRoleRequest;

export const zUpdateProjectMemberRolePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    memberId: /*#__PURE__*/ z.string()
});

export const zUpdateProjectMemberRoleQuery = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ])
});

/**
 * Member role updated
 */
export const zUpdateProjectMemberRoleResponse = zProjectMember;

export const zGetProjectStatePath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

/**
 * Durable state projections for gates, blockers, handoffs, action queue, and events
 */
export const zGetProjectStateResponse = zProjectState;

export const zListProjectStateEventsPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

export const zListProjectStateEventsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(500).optional()
});

/**
 * Recent durable state events for a project
 */
export const zListProjectStateEventsResponse = zStateEventList;

export const zListProjectsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'active',
        'on_hold',
        'archived',
        'closed'
    ]).optional(),
    moduleId: /*#__PURE__*/ z.string().optional(),
    memberId: /*#__PURE__*/ z.int().gt(0).optional(),
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ]).optional(),
    search: /*#__PURE__*/ z.string().max(200).optional(),
    includeDeleted: /*#__PURE__*/ z.boolean().nullish().default(false),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    after: /*#__PURE__*/ z.string().optional(),
    before: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'name'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Paginated project list
 */
export const zListProjectsResponse = zProjectList;

export const zCreateProjectBody = zProjectCreate;

/**
 * Project created
 */
export const zCreateProjectResponse = zProject;

export const zGetProjectCommandCenterPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project command center
 */
export const zGetProjectCommandCenterResponse = zProjectCommandCenter;

export const zListProjectWorkModeTemplatesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project work-mode templates with platform defaults and project overrides merged
 */
export const zListProjectWorkModeTemplatesResponse = /*#__PURE__*/ z.array(zProjectWorkModeTemplate);

export const zReplaceProjectWorkModeTemplatesBody = /*#__PURE__*/ z.object({
    templates: /*#__PURE__*/ z.array(zProjectWorkModeTemplateInput)
});

export const zReplaceProjectWorkModeTemplatesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project work-mode templates after replacing project overrides
 */
export const zReplaceProjectWorkModeTemplatesResponse = /*#__PURE__*/ z.array(zProjectWorkModeTemplate);

export const zListProjectThreadsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project threads
 */
export const zListProjectThreadsResponse = /*#__PURE__*/ z.array(zProjectThread);

export const zCreateProjectThreadBody = zProjectThreadCreate;

export const zCreateProjectThreadPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project thread created
 */
export const zCreateProjectThreadResponse = zProjectThread;

export const zUpdateProjectThreadBody = zProjectThreadUpdate;

export const zUpdateProjectThreadPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    threadId: /*#__PURE__*/ z.string()
});

/**
 * Project thread updated
 */
export const zUpdateProjectThreadResponse = zProjectThread;

export const zListProjectChangesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListProjectChangesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'draft',
        'open',
        'review',
        'blocked',
        'merged',
        'stalled',
        'closed'
    ]).optional(),
    branches: /*#__PURE__*/ z.string().optional(),
    author: /*#__PURE__*/ z.enum([
        'all',
        'human',
        'agent'
    ]).optional(),
    sort: /*#__PURE__*/ z.enum([
        'updated',
        'opened',
        'number',
        'status'
    ]).optional(),
    q: /*#__PURE__*/ z.string().max(200).optional(),
    projectThreadId: /*#__PURE__*/ z.int().gt(0).optional()
});

/**
 * Project changes with stats
 */
export const zListProjectChangesResponse = zProjectChangesResult;

export const zCreateProjectChangeBody = zProjectChangeCreate;

export const zCreateProjectChangePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project change created
 */
export const zCreateProjectChangeResponse = zProjectChange;

export const zGetProjectChangePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    changeId: /*#__PURE__*/ z.string()
});

export const zGetProjectChangeQuery = /*#__PURE__*/ z.object({
    expand: /*#__PURE__*/ z.string().optional()
});

/**
 * Change detail with tiered hydration
 */
export const zGetProjectChangeResponse = zProjectChangeView;

export const zUpdateProjectChangeBody = zProjectChangeUpdate;

export const zUpdateProjectChangePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    changeId: /*#__PURE__*/ z.string()
});

/**
 * Project change updated
 */
export const zUpdateProjectChangeResponse = zProjectChange;

export const zGetProjectLogPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zGetProjectLogQuery = /*#__PURE__*/ z.object({
    range: /*#__PURE__*/ z.enum([
        '1d',
        '7d',
        '30d',
        '90d',
        'all'
    ]).optional().default('7d'),
    phase: /*#__PURE__*/ z.string().optional(),
    type: /*#__PURE__*/ z.string().optional()
});

/**
 * Project activity log (swimlane view)
 */
export const zGetProjectLogResponse = zProjectLogResult;

export const zCreateProjectChangeRevisionBody = zProjectChangeRevisionCreate;

export const zCreateProjectChangeRevisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    changeId: /*#__PURE__*/ z.string()
});

/**
 * Project change revision created
 */
export const zCreateProjectChangeRevisionResponse = zProjectChangeRevision;

export const zLinkProjectThreadResourceBody = zProjectThreadResourceCreate;

export const zLinkProjectThreadResourcePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project thread resource linked
 */
export const zLinkProjectThreadResourceResponse = zProjectThreadResource;

export const zSoftDeleteProjectPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project soft-deleted
 */
export const zSoftDeleteProjectResponse = /*#__PURE__*/ z.void();

export const zGetProjectPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project
 */
export const zGetProjectResponse = zProject;

export const zUpdateProjectBody = zProjectUpdate;

export const zUpdateProjectPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated project
 */
export const zUpdateProjectResponse = zProject;

export const zArchiveProjectPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project archived
 */
export const zArchiveProjectResponse = zProject;

export const zReactivateProjectPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project reactivated
 */
export const zReactivateProjectResponse = zProject;

export const zCloseProjectBody = zProjectCloseRequest;

export const zCloseProjectPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project closed
 */
export const zCloseProjectResponse = zProject;

export const zGetProjectSummaryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Project summary with counts
 */
export const zGetProjectSummaryResponse = zProjectSummary;

export const zListActionQueueQuery = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.int().gt(0).optional(),
    targetActorType: /*#__PURE__*/ z.enum([
        'human_user',
        'agent',
        'daemon',
        'system',
        'worker',
        'api',
        'service_account'
    ]).optional(),
    targetActorId: /*#__PURE__*/ z.string().optional(),
    targetActorClass: /*#__PURE__*/ z.string().optional(),
    statuses: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(500).optional()
});

/**
 * Open or filtered action queue items visible to the caller capability surface
 */
export const zListActionQueueResponse = zActionQueueList;

export const zClaimActionQueueItemBody = zActionQueueClaimInput;

export const zClaimActionQueueItemPath = /*#__PURE__*/ z.object({
    itemId: /*#__PURE__*/ z.string()
});

/**
 * Action queue item claimed by the current actor
 */
export const zClaimActionQueueItemResponse = zCoordinationActionQueueItem;

export const zResolveActionQueueItemBody = zActionQueueResolveInput;

export const zResolveActionQueueItemPath = /*#__PURE__*/ z.object({
    itemId: /*#__PURE__*/ z.string()
});

/**
 * Action queue item resolved by the current actor
 */
export const zResolveActionQueueItemResponse = zCoordinationActionQueueItem;

export const zDecideGateBody = zGateDecisionInput;

export const zDecideGatePath = /*#__PURE__*/ z.object({
    gateId: /*#__PURE__*/ z.string()
});

/**
 * Gate decided
 */
export const zDecideGateResponse = zCoordinationGate;

export const zTransitionBlockerBody = zBlockerTransitionInput;

export const zTransitionBlockerPath = /*#__PURE__*/ z.object({
    blockerId: /*#__PURE__*/ z.string()
});

/**
 * Blocker transitioned
 */
export const zTransitionBlockerResponse = zCoordinationBlocker;

export const zTransitionHandoffBody = zHandoffTransitionInput;

export const zTransitionHandoffPath = /*#__PURE__*/ z.object({
    handoffId: /*#__PURE__*/ z.string()
});

/**
 * Handoff transitioned
 */
export const zTransitionHandoffResponse = zCoordinationHandoff;

export const zListTaskDecisionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Pending decisions for this task (bounded, typically 0–3)
 */
export const zListTaskDecisionsResponse = /*#__PURE__*/ z.array(zTaskDecision);

export const zStartTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task started (pending → in_progress)
 */
export const zStartTaskResponse = zTask;

export const zCancelTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task cancelled
 */
export const zCancelTaskResponse = zTask;

export const zApproveTaskActionBody = zTaskApproveActionRequest;

export const zApproveTaskActionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Action approved; task resumes
 */
export const zApproveTaskActionResponse = zTask;

export const zRejectTaskActionBody = zTaskRejectActionRequest;

export const zRejectTaskActionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Action rejected; task transitions to failed
 */
export const zRejectTaskActionResponse = zTask;

export const zExtendApprovalTimeoutPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Approval timer reset; task remains in awaiting_approval
 */
export const zExtendApprovalTimeoutResponse = zTask;

export const zCompleteTaskBody = zTaskCompleteRequest;

export const zCompleteTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task completed; memories promoted as requested
 */
export const zCompleteTaskResponse = zTask;

export const zRetryTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task reset for retry
 */
export const zRetryTaskResponse = zTask;

export const zReassignTaskBody = zTaskReassignRequest;

export const zReassignTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task reassigned
 */
export const zReassignTaskResponse = zTask;

export const zTransferTaskTeamBody = zTaskTransferTeamRequest;

export const zTransferTaskTeamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task team transferred
 */
export const zTransferTaskTeamResponse = zTask;

export const zListTasksQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.enum([
            'pending',
            'in_progress',
            'awaiting_approval',
            'awaiting_user',
            'completed',
            'failed',
            'cancelled'
        ]),
        /*#__PURE__*/ z.string()
    ]).optional(),
    projectId: /*#__PURE__*/ z.int().gt(0).optional(),
    teamId: /*#__PURE__*/ z.int().gt(0).optional(),
    baseTemplateId: /*#__PURE__*/ z.int().gt(0).optional(),
    createdBy: /*#__PURE__*/ z.int().gt(0).optional(),
    originType: /*#__PURE__*/ z.enum([
        'manual',
        'conversation',
        'project',
        'workflow_step',
        'daemon_finding',
        'artifact',
        'api',
        'decision'
    ]).optional(),
    assigneeType: /*#__PURE__*/ z.enum([
        'user',
        'workforce_member',
        'daemon',
        'template',
        'tool',
        'workflow'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'deadlineAt',
        'status'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Paginated task list
 */
export const zListTasksResponse = zTaskList;

export const zCreateTaskBody = zTaskCreate;

/**
 * Task created
 */
export const zCreateTaskResponse = zTask;

export const zDeleteTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task deleted
 */
export const zDeleteTaskResponse = /*#__PURE__*/ z.object({
    message: /*#__PURE__*/ z.string()
});

export const zGetTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task detail
 */
export const zGetTaskResponse = zTask;

export const zUpdateTaskBody = zTaskUpdate;

export const zUpdateTaskPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Task updated
 */
export const zUpdateTaskResponse = zTask;

export const zListInterventionsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'open',
        'reviewing',
        'routed',
        'resolved',
        'rejected'
    ]).optional(),
    type: /*#__PURE__*/ z.enum([
        'fix',
        'improve',
        'investigate',
        'decision',
        'contract_repair',
        'version_change',
        'worker_unavailable',
        'policy_blocker'
    ]).optional(),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'warning',
        'error',
        'critical'
    ]).optional(),
    requestedOutcome: /*#__PURE__*/ z.enum([
        'task',
        'decision',
        'workflow_draft',
        'workflow_version',
        'workforce_route',
        'workstream_link',
        'log_only'
    ]).optional(),
    sourceType: /*#__PURE__*/ z.enum([
        'workflow',
        'workflow_run',
        'workflow_step',
        'task',
        'template',
        'project',
        'artifact',
        'workforce',
        'daemon',
        'catalog_item',
        'catalog_version',
        'decision'
    ]).optional(),
    assignedToId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional()
});

/**
 * Action Requests
 */
export const zListInterventionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zIntervention)
});

export const zCreateInterventionBody = zInterventionCreate;

/**
 * Created
 */
export const zCreateInterventionResponse = zIntervention;

export const zGetInterventionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Action Request detail
 */
export const zGetInterventionResponse = /*#__PURE__*/ z.object({
    request: zIntervention,
    timeline: /*#__PURE__*/ z.array(zInterventionEvent)
});

export const zRouteInterventionBody = zInterventionRouteRequest;

export const zRouteInterventionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Routed
 */
export const zRouteInterventionResponse = zIntervention;

export const zResolveInterventionBody = zInterventionResolveRequest;

export const zResolveInterventionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Resolved
 */
export const zResolveInterventionResponse = zIntervention;

export const zRejectInterventionBody = zInterventionRejectRequest;

export const zRejectInterventionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Rejected
 */
export const zRejectInterventionResponse = zIntervention;

export const zListWorkstreamMembersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Active workstream members (oldest first)
 */
export const zListWorkstreamMembersResponse = /*#__PURE__*/ z.array(zWorkstreamMember);

export const zAddWorkstreamMemberBody = zWorkstreamMemberAdd;

export const zAddWorkstreamMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Member added
 */
export const zAddWorkstreamMemberResponse = zWorkstreamMember;

export const zRemoveWorkstreamMemberPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    memberId: /*#__PURE__*/ z.string()
});

export const zRemoveWorkstreamMemberQuery = /*#__PURE__*/ z.object({
    memberType: /*#__PURE__*/ z.enum([
        'user',
        'agent_instance',
        'workforce_member'
    ])
});

/**
 * Member removed
 */
export const zRemoveWorkstreamMemberResponse = /*#__PURE__*/ z.object({
    removed: /*#__PURE__*/ z.boolean()
});

export const zListWorkstreamDecisionsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListWorkstreamDecisionsQuery = /*#__PURE__*/ z.object({
    decisionType: /*#__PURE__*/ z.string().max(200).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional()
});

/**
 * Paginated decision audit trail
 */
export const zListWorkstreamDecisionsResponse = zDecisionList;

export const zListWorkstreamsQuery = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.int().gt(0).optional(),
    projectChangeId: /*#__PURE__*/ z.int().gt(0).optional(),
    status: /*#__PURE__*/ z.enum([
        'active',
        'paused',
        'archived',
        'completed'
    ]).optional(),
    focus: /*#__PURE__*/ z.enum([
        'feature',
        'marketing',
        'research',
        'ops',
        'support',
        'general'
    ]).optional(),
    managerAgentId: /*#__PURE__*/ z.int().gt(0).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    before: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    sort_by: /*#__PURE__*/ z.enum([
        'createdAt',
        'updatedAt',
        'name'
    ]).optional(),
    sort_order: /*#__PURE__*/ z.enum(['asc', 'desc']).optional(),
    include_total: /*#__PURE__*/ z.boolean().nullish().default(false)
});

/**
 * Paginated workstream list
 */
export const zListWorkstreamsResponse = zWorkstreamList;

export const zCreateWorkstreamBody = zWorkstreamCreate;

/**
 * Created
 */
export const zCreateWorkstreamResponse = zWorkstream;

export const zArchiveWorkstreamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Archived
 */
export const zArchiveWorkstreamResponse = zWorkstream;

export const zGetWorkstreamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Workstream
 */
export const zGetWorkstreamResponse = zWorkstream;

export const zUpdateWorkstreamBody = zWorkstreamUpdate;

export const zUpdateWorkstreamPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdateWorkstreamResponse = zWorkstream;

export const zListApproverDelegationsQuery = /*#__PURE__*/ z.object({
    activeOnly: /*#__PURE__*/ z.boolean().nullish().default(true)
});

/**
 * Delegations involving the caller (granted or received)
 */
export const zListApproverDelegationsResponse = /*#__PURE__*/ z.array(zApproverDelegation);

export const zCreateApproverDelegationBody = zApproverDelegationCreate;

/**
 * Delegation granted
 */
export const zCreateApproverDelegationResponse = zApproverDelegation;

export const zRevokeApproverDelegationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Delegation revoked
 */
export const zRevokeApproverDelegationResponse = zApproverDelegation;

export const zListPromotionCandidatesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['pending', 'all']).optional().default('pending'),
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional()
});

/**
 * Promotion candidates (default: pending only)
 */
export const zListPromotionCandidatesResponse = /*#__PURE__*/ z.array(zPromotionCandidate);

export const zGetPromotionCandidatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Candidate
 */
export const zGetPromotionCandidateResponse = zPromotionCandidate;

export const zAcceptPromotionCandidatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Candidate accepted; unified diff returned
 */
export const zAcceptPromotionCandidateResponse = zPromotionAcceptResult;

export const zRejectPromotionCandidatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Candidate rejected
 */
export const zRejectPromotionCandidateResponse = zPromotionCandidate;

export const zListAdminDaemonFindingsQuery = /*#__PURE__*/ z.object({
    category: /*#__PURE__*/ z.enum([
        'vulnerability',
        'quality-issue',
        'optimization',
        'insight',
        'alert',
        'template-ecosystem',
        'promotion_candidate',
        'intent_classification_review',
        'edge_decay',
        'survivorship_bias_report'
    ]).optional(),
    severity: /*#__PURE__*/ z.enum([
        'info',
        'low',
        'medium',
        'high',
        'critical'
    ]).optional(),
    reviewStatus: /*#__PURE__*/ z.enum([
        'pending',
        'approved',
        'rejected',
        'deferred',
        'quarantined'
    ]).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional()
});

/**
 * Daemon findings for the org
 */
export const zListAdminDaemonFindingsResponse = /*#__PURE__*/ z.array(zDaemonFinding);

export const zListDeadLetterEntriesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'quarantined',
        'replaying',
        'replayed',
        'discarded'
    ]).optional(),
    stream: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional(),
    offset: /*#__PURE__*/ z.int().gte(0).nullish()
});

/**
 * Dead-letter entries (filterable by status/stream)
 */
export const zListDeadLetterEntriesResponse = zDeadLetterEntryList;

export const zReplayDeadLetterEntryPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Entry replayed onto its origin stream; updated entry returned
 */
export const zReplayDeadLetterEntryResponse = zDeadLetterEntry;

/**
 * Platform runtime flags with resolved value and source
 */
export const zListPlatformRuntimeFlagsResponse = zRuntimeFlagList;

export const zSetPlatformRuntimeFlagBody = zRuntimeFlagUpdate;

export const zSetPlatformRuntimeFlagPath = /*#__PURE__*/ z.object({
    key: /*#__PURE__*/ z.enum([
        'platform.server_runs_schedulers',
        'platform.server_runs_market_data_aggregator',
        'platform.finance_pynecore_validation_enabled',
        'platform.finance_signal_aggregation_enabled',
        'platform.finance_signal_outcome_scoring_enabled',
        'platform.finance_strategy_runner_enabled',
        'platform.tool_scout_enabled',
        'finance.live_trading_enabled',
        'marketplace.auto_upgrade_acquisitions'
    ])
});

/**
 * Flag written; resolved state returned
 */
export const zSetPlatformRuntimeFlagResponse = zRuntimeFlag;

/**
 * Organization runtime flags with resolved value and source
 */
export const zListOrganizationRuntimeFlagsResponse = zRuntimeFlagList;

export const zSetOrganizationRuntimeFlagBody = zRuntimeFlagUpdate;

export const zSetOrganizationRuntimeFlagPath = /*#__PURE__*/ z.object({
    key: /*#__PURE__*/ z.enum([
        'platform.server_runs_schedulers',
        'platform.server_runs_market_data_aggregator',
        'platform.finance_pynecore_validation_enabled',
        'platform.finance_signal_aggregation_enabled',
        'platform.finance_signal_outcome_scoring_enabled',
        'platform.finance_strategy_runner_enabled',
        'platform.tool_scout_enabled',
        'finance.live_trading_enabled',
        'marketplace.auto_upgrade_acquisitions'
    ])
});

/**
 * Flag written for the caller organization; resolved state returned
 */
export const zSetOrganizationRuntimeFlagResponse = zRuntimeFlag;

/**
 * Boxes, databases and what needs attention
 */
export const zGetSystemOverviewResponse = zSystemOverview;

export const zGetSystemHostPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^[a-z][a-z0-9-]{0,39}$/)
});

/**
 * One box now
 */
export const zGetSystemHostResponse = zSystemHost;

export const zGetSystemHostSeriesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^[a-z][a-z0-9-]{0,39}$/)
});

export const zGetSystemHostSeriesQuery = /*#__PURE__*/ z.object({
    panel: /*#__PURE__*/ z.enum([
        'cpu',
        'load',
        'memory',
        'pressure',
        'disk-busy',
        'disk-io',
        'filesystems',
        'network',
        'temperature',
        'gpu',
        'gpu-temperature',
        'gpu-power',
        'units-cpu',
        'units-memory'
    ]),
    range: /*#__PURE__*/ z.enum([
        '1h',
        '6h',
        '24h',
        '7d',
        '30d',
        '90d',
        '1y'
    ]).optional().default('24h')
});

/**
 * One chart of a box's history
 */
export const zGetSystemHostSeriesResponse = zMetricSeriesSet;

export const zGetSystemDatabasePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.enum(['app', 'market'])
});

/**
 * One database now
 */
export const zGetSystemDatabaseResponse = zSystemDatabase;

export const zGetSystemDatabaseSeriesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.enum(['app', 'market'])
});

export const zGetSystemDatabaseSeriesQuery = /*#__PURE__*/ z.object({
    panel: /*#__PURE__*/ z.enum([
        'transactions',
        'rows',
        'connections',
        'connections-used',
        'cache-hit',
        'locks',
        'transaction-age',
        'temp',
        'wal',
        'size',
        'xid-age'
    ]),
    range: /*#__PURE__*/ z.enum([
        '1h',
        '6h',
        '24h',
        '7d',
        '30d',
        '90d',
        '1y'
    ]).optional().default('24h')
});

/**
 * One chart of a database's history
 */
export const zGetSystemDatabaseSeriesResponse = zMetricSeriesSet;

export const zListSystemDatabaseStatementsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.enum(['app', 'market'])
});

export const zListSystemDatabaseStatementsQuery = /*#__PURE__*/ z.object({
    range: /*#__PURE__*/ z.enum([
        '1h',
        '6h',
        '24h',
        '7d',
        '30d',
        '90d',
        '1y'
    ]).optional().default('24h')
});

/**
 * The statements that took the most database time in the range
 */
export const zListSystemDatabaseStatementsResponse = /*#__PURE__*/ z.array(zSystemStatement);

/**
 * Redis now and the platform streams' backlog
 */
export const zGetSystemRedisResponse = zSystemRedis;

export const zGetSystemRedisSeriesQuery = /*#__PURE__*/ z.object({
    panel: /*#__PURE__*/ z.enum([
        'memory',
        'commands',
        'clients'
    ]),
    range: /*#__PURE__*/ z.enum([
        '1h',
        '6h',
        '24h',
        '7d',
        '30d',
        '90d',
        '1y'
    ]).optional().default('24h')
});

/**
 * One chart of Redis's history
 */
export const zGetSystemRedisSeriesResponse = zMetricSeriesSet;

export const zCancelAllOrdersQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().optional()
});

/**
 * All orders cancelled
 */
export const zCancelAllOrdersResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    cancelled: /*#__PURE__*/ z.number()
});

export const zListOrdersQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum(['open', 'all']).optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Order list
 */
export const zListOrdersResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zOrder),
    count: /*#__PURE__*/ z.number()
});

export const zCreateOrderBody = zOrderCreate;

/**
 * Order created
 */
export const zCreateOrderResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    order: zOrder
});

export const zCancelOrderPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Order cancelled
 */
export const zCancelOrderResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string()
});

export const zGetOrderPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Order detail
 */
export const zGetOrderResponse = /*#__PURE__*/ z.object({
    order: zOrder
});

export const zListTradesQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().optional(),
    strategyId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Trade history
 */
export const zListTradesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zTrade),
    count: /*#__PURE__*/ z.number()
});

export const zGetTradeStatsQuery = /*#__PURE__*/ z.object({
    days: /*#__PURE__*/ z.string().optional()
});

/**
 * Trading statistics
 */
export const zGetTradeStatsResponse = /*#__PURE__*/ z.object({
    period: /*#__PURE__*/ z.string(),
    stats: /*#__PURE__*/ z.unknown().optional()
});

/**
 * Open positions
 */
export const zListPositionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zPosition),
    count: /*#__PURE__*/ z.number()
});

export const zGetPositionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Position details
 */
export const zGetPositionResponse = /*#__PURE__*/ z.object({
    position: zPosition
});

export const zClosePositionBody = zPositionCloseRequest;

export const zClosePositionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Close order submitted
 */
export const zClosePositionResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string(),
    order: /*#__PURE__*/ z.object({
        id: /*#__PURE__*/ z.number(),
        status: /*#__PURE__*/ z.string()
    })
});

export const zListRiskLimitsQuery = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.enum([
        'org',
        'account',
        'strategy'
    ]).optional(),
    metric: /*#__PURE__*/ z.string().optional(),
    scope_id: /*#__PURE__*/ z.string().optional(),
    enabled: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Paginated list of risk limits
 */
export const zListRiskLimitsResponse = zRiskLimitList;

export const zCreateRiskLimitBody = zRiskLimitCreate;

/**
 * Risk limit created
 */
export const zCreateRiskLimitResponse = zRiskLimit;

export const zDeleteRiskLimitPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Risk limit disabled (soft delete)
 */
export const zDeleteRiskLimitResponse = zRiskLimit;

export const zUpdateRiskLimitBody = zRiskLimitUpdate;

export const zUpdateRiskLimitPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Risk limit updated
 */
export const zUpdateRiskLimitResponse = zRiskLimit;

export const zListRiskBreachesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'open',
        'alerted',
        'escalated',
        'accepted',
        'resolved'
    ]).optional(),
    scope: /*#__PURE__*/ z.enum([
        'org',
        'account',
        'strategy'
    ]).optional(),
    halted: /*#__PURE__*/ z.string().optional(),
    after: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Paginated list of risk breaches
 */
export const zListRiskBreachesResponse = zRiskBreachList;

export const zAcceptRiskBreachPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Breach accepted
 */
export const zAcceptRiskBreachResponse = zRiskBreach;

export const zResolveRiskBreachPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Breach resolved
 */
export const zResolveRiskBreachResponse = zRiskBreach;

export const zEscalateRiskBreachBody = zRiskBreachEscalate;

export const zEscalateRiskBreachPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Breach escalated and linked to the governance decision (the prerequisite for an org/account halt commit)
 */
export const zEscalateRiskBreachResponse = zRiskBreach;

export const zListRiskHaltsQuery = /*#__PURE__*/ z.object({
    after: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Paginated list of halted risk breaches
 */
export const zListRiskHaltsResponse = zRiskHaltList;

export const zActivateRiskHaltBody = zRiskHaltActivate;

/**
 * Halt activated
 */
export const zActivateRiskHaltResponse = zRiskBreachForHalt;

export const zResumeRiskHaltPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Halt resumed
 */
export const zResumeRiskHaltResponse = zRiskBreachForHalt;

/**
 * Current risk status for the organization
 */
export const zGetRiskStatusResponse = zRiskStatus;

/**
 * Active strategies
 */
export const zListActiveStrategiesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zActiveStrategy),
    count: /*#__PURE__*/ z.number()
});

export const zCreateActiveStrategyBody = zActiveStrategyCreate;

/**
 * Strategy created and started
 */
export const zCreateActiveStrategyResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    strategy: zActiveStrategy
});

export const zRemoveActiveStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Removed
 */
export const zRemoveActiveStrategyResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    message: /*#__PURE__*/ z.string()
});

export const zGetActiveStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Active strategy details
 */
export const zGetActiveStrategyResponse = zActiveStrategy;

export const zUpdateStrategyParametersBody = zActiveStrategyParametersUpdate;

export const zUpdateStrategyParametersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Parameters updated
 */
export const zUpdateStrategyParametersResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ]))
});

export const zStartStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Started
 */
export const zStartStrategyResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    isActive: /*#__PURE__*/ z.boolean()
});

export const zStopStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Stopped
 */
export const zStopStrategyResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    isActive: /*#__PURE__*/ z.boolean()
});

export const zDeployStrategyBody = zStrategyDeployCreate;

export const zDeployStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deployed
 */
export const zDeployStrategyResponse = zStrategyDeploymentActionResult;

export const zUndeployStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Undeployed
 */
export const zUndeployStrategyResponse = zStrategyDeploymentActionResult;

export const zGetStrategyDeploymentStatusPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deployment status
 */
export const zGetStrategyDeploymentStatusResponse = zStrategyDeploymentStatus;

export const zGenerateStrategyDocsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Documentation generated
 */
export const zGenerateStrategyDocsResponse = zStrategyDocsResult;

export const zCheckDeploymentReadinessPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Readiness check
 */
export const zCheckDeploymentReadinessResponse = zStrategyDeploymentReadinessResult;

/**
 * Available strategies
 */
export const zListStrategiesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zStrategy),
    count: /*#__PURE__*/ z.number()
});

export const zRunBacktestBody = zBacktestCreate;

/**
 * Backtest results
 */
export const zRunBacktestResponse = zBacktestRunResult;

export const zGetStrategyPath = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string()
});

/**
 * Strategy details
 */
export const zGetStrategyResponse = zStrategy;

/**
 * Market-data ingestion jobs configured for the caller's organization
 */
export const zListIngestionJobsResponse = /*#__PURE__*/ z.array(zIngestionJob);

export const zRunIngestionJobBody = zIngestionJobRunRequest;

export const zRunIngestionJobPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Run started on the scheduler rail — the job is returned with `run` populated
 */
export const zRunIngestionJobResponse = zIngestionJob;

export const zListCandlesQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    start: /*#__PURE__*/ z.string().optional(),
    end: /*#__PURE__*/ z.string().optional(),
    exchange: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Candle data
 */
export const zListCandlesResponse = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string(),
    timeframe: /*#__PURE__*/ z.string(),
    exchange: /*#__PURE__*/ z.string(),
    count: /*#__PURE__*/ z.number(),
    candles: /*#__PURE__*/ z.array(zCandle)
});

export const zGetPricePath = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string()
});

/**
 * Current price
 */
export const zGetPriceResponse = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string(),
    price: /*#__PURE__*/ z.number(),
    timestamp: /*#__PURE__*/ z.string()
});

export const zListPricesQuery = /*#__PURE__*/ z.object({
    symbols: /*#__PURE__*/ z.string()
});

/**
 * Multiple prices
 */
export const zListPricesResponse = /*#__PURE__*/ z.object({
    prices: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.number().nullable()),
    timestamp: /*#__PURE__*/ z.string()
});

export const zGetOrderBookPath = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string()
});

/**
 * Order book snapshot
 */
export const zGetOrderBookResponse = zOrderBookResult;

export const zCreateBackfillBody = zBackfillCreate;

export const zCheckMarketDataQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1),
    timeframe: /*#__PURE__*/ z.string().min(1),
    start: /*#__PURE__*/ z.string(),
    end: /*#__PURE__*/ z.string()
});

/**
 * Availability check
 */
export const zCheckMarketDataResponse = zMarketDataAvailabilityResult;

/**
 * Upcoming economic events
 */
export const zListEconomicEventsResponse = zEconomicCalendar;

export const zRunAnalysisAgentsBody = zAnalysisAgentRunCreate;

/**
 * Agent analysis results with consensus
 */
export const zRunAnalysisAgentsResponse = zAnalysisAgentRunResult;

/**
 * Agent status information
 */
export const zGetAgentStatusResponse = zAnalysisAgentStatusResult;

export const zSetAgentEnabledBody = zAnalysisAgentEnabledUpdate;

export const zSetAgentEnabledPath = /*#__PURE__*/ z.object({
    name: /*#__PURE__*/ z.string()
});

/**
 * Agent enabled state updated
 */
export const zSetAgentEnabledResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    agent: /*#__PURE__*/ z.string(),
    enabled: /*#__PURE__*/ z.boolean()
});

/**
 * Current trading session
 */
export const zGetCurrentSessionResponse = zCurrentSession;

/**
 * All trading session times
 */
export const zGetSessionTimesResponse = zSessionTimesResult;

export const zCalculateOrbBody = zSessionAnalysisCreate;

/**
 * Opening Range Breakout calculation result
 */
export const zCalculateOrbResponse = zOpeningRangeResult;

export const zGetSessionStatsBody = zSessionAnalysisCreate;

/**
 * Session statistics and detected patterns
 */
export const zGetSessionStatsResponse = zSessionStatsResult;

export const zAnalyzeOrderBookBody = zOrderBookAnalyzeCreate;

/**
 * Order book analysis
 */
export const zAnalyzeOrderBookResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    analysis: zOrderBookAnalysis
});

export const zGenerateOrderBookHeatmapBody = zOrderBookHeatmapCreate;

/**
 * Order book heatmap data
 */
export const zGenerateOrderBookHeatmapResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    symbol: /*#__PURE__*/ z.string(),
    midPrice: /*#__PURE__*/ z.number(),
    heatmap: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        price: /*#__PURE__*/ z.number(),
        bidVolume: /*#__PURE__*/ z.number(),
        askVolume: /*#__PURE__*/ z.number()
    }))
});

export const zAnalyzeConfluenceBody = zConfluenceAnalyzeCreate;

/**
 * Confluence analysis result
 */
export const zAnalyzeConfluenceResponse = zConfluenceAnalysisResult;

export const zAnalyzeConfluenceFromSignalsBody = zConfluenceFromSignalsCreate;

/**
 * Confluence analysis built from strategy signals
 */
export const zAnalyzeConfluenceFromSignalsResponse = zConfluenceAnalysisResult;

/**
 * Discovery dashboard overview
 */
export const zGetDiscoverySummaryResponse = zDiscoverySummaryResult;

export const zRunStrategyDiscoveryWorkflowBody = zDiscoveryRunNowRequest;

/**
 * Strategy discovery workflow trigger accepted
 */
export const zRunStrategyDiscoveryWorkflowResponse = zDiscoveryRunNowResult;

export const zValidateStrategyDefinitionBody = zStrategyDefinitionInput;

/**
 * Strategy definition validation result
 */
export const zValidateStrategyDefinitionResponse = zStrategyDefinitionValidateResult;

export const zListStrategyDefinitionsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy definitions
 */
export const zListStrategyDefinitionsResponse = zDiscoveryPaginatedList;

export const zUpsertStrategyDefinitionBody = zStrategyDefinitionInput;

/**
 * Strategy definition persisted
 */
export const zUpsertStrategyDefinitionResponse = zStrategyDefinitionPersistResult;

export const zCreateStrategyDefinitionValidationRunBody = zStrategyDefinitionValidationRunInput;

/**
 * Strategy definition validation evaluation and adapter resolution
 */
export const zCreateStrategyDefinitionValidationRunResponse = zDiscoveryCreatedResult;

export const zImportFinanceStrategyCorpusBody = zStrategyCorpusIngestionInput;

/**
 * Strategy corpus ingestion dry-run or persistence report
 */
export const zImportFinanceStrategyCorpusResponse = zStrategyCorpusIngestionResult;

export const zGetStrategyDefinitionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Strategy definition detail
 */
export const zGetStrategyDefinitionResponse = zDiscoveryCreatedResult;

export const zListStrategyDefinitionEvaluationsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListStrategyDefinitionEvaluationsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy definition evaluations
 */
export const zListStrategyDefinitionEvaluationsResponse = zDiscoveryPaginatedList;

export const zCreateStrategyDefinitionEvaluationBody = zStrategyDefinitionEvaluationInput;

/**
 * Strategy definition evaluation persisted
 */
export const zCreateStrategyDefinitionEvaluationResponse = zDiscoveryCreatedResult;

export const zValidateStrategyBucketDefinitionBody = zStrategyBucketDefinitionInput;

/**
 * Strategy bucket validation result
 */
export const zValidateStrategyBucketDefinitionResponse = zStrategyDefinitionValidateResult;

export const zListStrategyBucketDefinitionsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy buckets
 */
export const zListStrategyBucketDefinitionsResponse = zDiscoveryPaginatedList;

export const zUpsertStrategyBucketDefinitionBody = zStrategyBucketDefinitionInput;

/**
 * Strategy bucket persisted
 */
export const zUpsertStrategyBucketDefinitionResponse = zStrategyBucketPersistResult;

export const zListStrategyBucketEvaluationsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListStrategyBucketEvaluationsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy bucket evaluations
 */
export const zListStrategyBucketEvaluationsResponse = zDiscoveryPaginatedList;

export const zGetStrategyBucketDefinitionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Strategy bucket detail
 */
export const zGetStrategyBucketDefinitionResponse = zDiscoveryCreatedResult;

export const zPatchStrategyBucketDefinitionBody = zStrategyBucketPatchInput;

export const zPatchStrategyBucketDefinitionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Bucket definition patched
 */
export const zPatchStrategyBucketDefinitionResponse = zStrategyBucketPersistResult;

export const zDispatchStrategyBucketBacktestBody = zStrategyBucketBacktestInput;

export const zDispatchStrategyBucketBacktestPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Combined backtest run request enqueued
 */
export const zDispatchStrategyBucketBacktestResponse = zStrategyBucketBacktestResult;

export const zCreateStrategyBucketEvaluationBody = zStrategyBucketEvaluationInput;

/**
 * Strategy bucket evaluation persisted
 */
export const zCreateStrategyBucketEvaluationResponse = zDiscoveryCreatedResult;

export const zValidateStrategyExtensionDescriptorBody = zStrategyExtensionDescriptorInput;

/**
 * Strategy extension descriptor validation result
 */
export const zValidateStrategyExtensionDescriptorResponse = zStrategyDefinitionValidateResult;

export const zListStrategyExtensionDescriptorsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy extension descriptors
 */
export const zListStrategyExtensionDescriptorsResponse = zDiscoveryPaginatedList;

export const zUpsertStrategyExtensionDescriptorBody = zStrategyExtensionDescriptorInput;

/**
 * Strategy extension descriptor persisted
 */
export const zUpsertStrategyExtensionDescriptorResponse = zDiscoveryCreatedResult;

export const zResolveStrategyAdaptersBody = zStrategyAdapterResolutionRequestInput;

/**
 * Strategy adapter resolution result
 */
export const zResolveStrategyAdaptersResponse = zDiscoveryCreatedResult;

export const zListStrategyAdapterResolutionsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy adapter resolutions
 */
export const zListStrategyAdapterResolutionsResponse = zDiscoveryPaginatedList;

export const zCreateStrategyAdapterResolutionBody = zStrategyAdapterResolutionInput;

/**
 * Strategy adapter resolution persisted
 */
export const zCreateStrategyAdapterResolutionResponse = zDiscoveryCreatedResult;

export const zListFinanceDataBlockersQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Data blocker remediations
 */
export const zListFinanceDataBlockersResponse = zDiscoveryPaginatedList;

export const zUpsertFinanceDataBlockerBody = zDataBlockerInput;

/**
 * Data blocker remediation persisted
 */
export const zUpsertFinanceDataBlockerResponse = zDiscoveryCreatedResult;

export const zListTopSourcesQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    by: /*#__PURE__*/ z.string().optional()
});

/**
 * Top contributors
 */
export const zListTopSourcesResponse = zDiscoveryList;

export const zListSourcesQuery = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().optional(),
    active: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Contributor list
 */
export const zListSourcesResponse = zDiscoveryPaginatedList;

export const zCreateSourceBody = zContributorCreate;

/**
 * Contributor created
 */
export const zCreateSourceResponse = zDiscoveryCreatedResult;

export const zGetSourcePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Contributor details
 */
export const zGetSourceResponse = zDiscoverySourceDetailResult;

/**
 * Content statistics
 */
export const zGetContentStatsResponse = zDiscoveryContentStatsResult;

export const zListHarvestedContentQuery = /*#__PURE__*/ z.object({
    platform: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'pending',
        'harvested',
        'extracting',
        'extracted',
        'completed',
        'failed',
        'actionable',
        'explored',
        'dismissed',
        'style_extracted',
        'style_skipped'
    ]).optional(),
    hasTradingContent: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Harvested content list
 */
export const zListHarvestedContentResponse = zDiscoveryPaginatedList;

export const zGetContentDetailsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Content details with strategies
 */
export const zGetContentDetailsResponse = zDiscoveryContentDetailResult;

export const zListApprovedStrategiesQuery = /*#__PURE__*/ z.object({
    category: /*#__PURE__*/ z.string().optional(),
    minSharpe: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Approved strategies
 */
export const zListApprovedStrategiesResponse = zDiscoveryList;

/**
 * Strategy discovery statistics
 */
export const zGetStrategyDiscoveryStatsResponse = zDiscoveryStrategyStatsResult;

export const zListDiscoveredStrategiesQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.string().optional(),
    category: /*#__PURE__*/ z.string().optional(),
    minCompleteness: /*#__PURE__*/ z.string().optional(),
    include: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Discovered strategy list
 */
export const zListDiscoveredStrategiesResponse = zDiscoveryPaginatedList;

export const zGetDiscoveredStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Strategy details
 */
export const zGetDiscoveredStrategyResponse = zDiscoveryCreatedResult;

export const zUpdateDiscoveredStrategyStatusBody = zDiscoveredStrategyStatusUpdate;

export const zUpdateDiscoveredStrategyStatusPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Status updated
 */
export const zUpdateDiscoveredStrategyStatusResponse = zDiscoveryCreatedResult;

export const zGetAssetSentimentPath = /*#__PURE__*/ z.object({
    asset: /*#__PURE__*/ z.string()
});

export const zGetAssetSentimentQuery = /*#__PURE__*/ z.object({
    hoursBack: /*#__PURE__*/ z.string().optional()
});

/**
 * Aggregated sentiment
 */
export const zGetAssetSentimentResponse = zAssetSentimentResult;

export const zGetSignalAccuracyQuery = /*#__PURE__*/ z.object({
    intelSourceId: /*#__PURE__*/ z.string().optional()
});

/**
 * Signal accuracy by asset
 */
export const zGetSignalAccuracyResponse = zSignalAccuracyList;

export const zGetSignalActivityQuery = /*#__PURE__*/ z.object({
    days: /*#__PURE__*/ z.string().optional()
});

/**
 * Recent signal activity
 */
export const zGetSignalActivityResponse = zSignalActivityList;

export const zListSignalsQuery = /*#__PURE__*/ z.object({
    asset: /*#__PURE__*/ z.string().optional(),
    intelSourceId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Signal list
 */
export const zListSignalsResponse = zSignalList;

/**
 * Test webhook processed (IP whitelist bypassed)
 */
export const zTestTradingViewWebhookResponse = /*#__PURE__*/ zTradingViewWebhookResult.and(/*#__PURE__*/ z.object({
    note: /*#__PURE__*/ z.string().optional()
}));

export const zGeneratePineScriptBody = zPineScriptCreate;

/**
 * Pine Script template generated
 */
export const zGeneratePineScriptResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    script: /*#__PURE__*/ z.string()
});

/**
 * TradingView webhook config for this org
 */
export const zGetTradingViewConfigResponse = zTradingViewConfig;

/**
 * New webhook token (shown once — store it securely)
 */
export const zRotateTradingViewTokenResponse = zTradingViewTokenResult;

export const zReceiveTradingViewAlertPath = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string().min(1)
});

/**
 * Alert received and processed
 */
export const zReceiveTradingViewAlertResponse = zTradingViewWebhookResult;

export const zListWatchlistQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'active',
        'archived',
        'under-review'
    ]).optional()
});

/**
 * Watchlist
 */
export const zListWatchlistResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWatchlistEntry)
});

export const zAddToWatchlistBody = zWatchlistAdd;

/**
 * Added
 */
export const zAddToWatchlistResponse = /*#__PURE__*/ z.object({
    entry: zWatchlistEntry
});

export const zRemoveFromWatchlistPath = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string()
});

/**
 * Archived
 */
export const zRemoveFromWatchlistResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetWatchlistEntryPath = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string()
});

/**
 * Entry
 */
export const zGetWatchlistEntryResponse = /*#__PURE__*/ z.object({
    entry: zWatchlistEntry
});

export const zListAnalysesPath = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string()
});

export const zListAnalysesQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Analyses
 */
export const zListAnalysesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWatchlistAnalysis)
});

export const zGetAnalysisPath = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string(),
    analysisId: /*#__PURE__*/ z.string()
});

/**
 * Analysis
 */
export const zGetAnalysisResponse = /*#__PURE__*/ z.object({
    analysis: zWatchlistAnalysis
});

export const zAnalyzeTickerAdHocPath = /*#__PURE__*/ z.object({
    ticker: /*#__PURE__*/ z.string()
});

/**
 * Queued
 */
export const zAnalyzeTickerAdHocResponse = /*#__PURE__*/ z.object({
    request_id: /*#__PURE__*/ z.string(),
    status: /*#__PURE__*/ z.string(),
    ticker: /*#__PURE__*/ z.string()
});

export const zComparePortfoliosQuery = /*#__PURE__*/ z.object({
    ids: /*#__PURE__*/ z.string()
});

/**
 * Side-by-side comparison
 */
export const zComparePortfoliosResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zPortfolioComparison)
});

/**
 * Available risk profiles
 */
export const zGetRiskProfilesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zRiskProfile)
});

export const zListPortfoliosQuery = /*#__PURE__*/ z.object({
    ownerType: /*#__PURE__*/ z.enum(['organization', 'user']).optional(),
    portfolioType: /*#__PURE__*/ z.enum(['testing', 'production']).optional(),
    riskTier: /*#__PURE__*/ z.enum([
        'conservative',
        'balanced',
        'growth',
        'aggressive'
    ]).optional()
});

/**
 * List of portfolios
 */
export const zListPortfoliosResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zPortfolio)
});

export const zCreatePortfolioBody = zPortfolioCreate;

/**
 * Portfolio created
 */
export const zCreatePortfolioResponse = /*#__PURE__*/ z.object({
    portfolio: zPortfolio
});

export const zGetPortfolioPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Portfolio detail with holdings
 */
export const zGetPortfolioResponse = /*#__PURE__*/ z.object({
    portfolio: zPortfolio,
    holdings: /*#__PURE__*/ z.array(zHolding)
});

export const zUpdatePortfolioBody = zPortfolioUpdate;

export const zUpdatePortfolioPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zUpdatePortfolioResponse = /*#__PURE__*/ z.object({
    portfolio: zPortfolio
});

export const zGetPerformanceMetricsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Performance metrics
 */
export const zGetPerformanceMetricsResponse = /*#__PURE__*/ z.object({
    metrics: zPerformanceMetrics,
    snapshotCount: /*#__PURE__*/ z.number()
});

export const zListPortfolioSnapshotsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListPortfolioSnapshotsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Portfolio snapshots
 */
export const zListPortfolioSnapshotsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zPortfolioSnapshot)
});

export const zGetPortfolioSnapshotPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    snapshotId: /*#__PURE__*/ z.string()
});

/**
 * Snapshot detail
 */
export const zGetPortfolioSnapshotResponse = /*#__PURE__*/ z.object({
    snapshot: zPortfolioSnapshot
});

export const zGetRecommendationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Latest recommendation
 */
export const zGetRecommendationResponse = /*#__PURE__*/ z.object({
    recommendation: /*#__PURE__*/ zAllocationRecommendation.nullable()
});

export const zApproveRecommendationBody = zRecommendationAction;

export const zApproveRecommendationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Approved
 */
export const zApproveRecommendationResponse = /*#__PURE__*/ z.object({
    result: zAllocationRecommendation
});

export const zRejectRecommendationBody = zRecommendationAction;

export const zRejectRecommendationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Rejected
 */
export const zRejectRecommendationResponse = /*#__PURE__*/ z.object({
    result: zAllocationRecommendation
});

export const zListHoldingsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Holdings list
 */
export const zListHoldingsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zHolding)
});

export const zCreateHoldingBody = zHoldingCreate;

export const zCreateHoldingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Holding created
 */
export const zCreateHoldingResponse = /*#__PURE__*/ z.object({
    holding: zHolding
});

export const zDeleteHoldingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    ticker: /*#__PURE__*/ z.string()
});

/**
 * Removed
 */
export const zDeleteHoldingResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zUpdateHoldingBody = zHoldingUpdate;

export const zUpdateHoldingPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string(),
    ticker: /*#__PURE__*/ z.string()
});

/**
 * Holding updated
 */
export const zUpdateHoldingResponse = /*#__PURE__*/ z.object({
    holding: zHolding
});

export const zListContractEventsQuery = /*#__PURE__*/ z.object({
    runId: /*#__PURE__*/ z.int().gt(0).optional(),
    stepId: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(500).optional().default(50)
});

/**
 * Contract events
 */
export const zListContractEventsResponse = zContractEventList;

export const zGetContractHealthQuery = /*#__PURE__*/ z.object({
    workflowId: /*#__PURE__*/ z.int().gt(0).optional()
});

/**
 * Contract health stats
 */
export const zGetContractHealthResponse = zContractHealth;

export const zApplyContractResolutionBody = zContractApplyRequest;

/**
 * Refreshed contract health after applying the fix
 */
export const zApplyContractResolutionResponse = zContractHealth;

export const zCheckAlertPriceBody = zAlertCheckCreate;

/**
 * Triggered alerts
 */
export const zCheckAlertPriceResponse = zAlertCheckResult;

export const zListAlertsBySymbolPath = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string()
});

/**
 * Alerts for symbol
 */
export const zListAlertsBySymbolResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zPriceAlert)
});

/**
 * All price alerts
 */
export const zListAlertsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zPriceAlert),
    stats: zAlertStats
});

export const zCreateAlertBody = zPriceAlertCreate;

/**
 * Alert created
 */
export const zCreateAlertResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    alert: zPriceAlert
});

export const zDeleteAlertPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteAlertResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zSetAlertEnabledBody = zAlertEnabledUpdate;

export const zSetAlertEnabledPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated
 */
export const zSetAlertEnabledResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    enabled: /*#__PURE__*/ z.boolean()
});

export const zResetAlertPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Reset
 */
export const zResetAlertResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zListAlertRulesQuery = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ zAlertRuleKind.optional(),
    symbol: /*#__PURE__*/ z.string().optional(),
    enabled: /*#__PURE__*/ z.enum(['true', 'false']).optional()
});

/**
 * Alert rules for the organization
 */
export const zListAlertRulesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAlertRule)
});

export const zCreateAlertRuleBody = zAlertRuleCreate;

/**
 * Alert rule created
 */
export const zCreateAlertRuleResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    rule: zAlertRule
});

export const zDeleteAlertRulePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteAlertRuleResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetAlertRulePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Alert rule
 */
export const zGetAlertRuleResponse = /*#__PURE__*/ z.object({
    rule: zAlertRule
});

export const zUpdateAlertRuleBody = zAlertRuleUpdate;

export const zUpdateAlertRulePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Alert rule updated
 */
export const zUpdateAlertRuleResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean(),
    rule: zAlertRule
});

/**
 * The reactions an organization can arm
 */
export const zListMarketEventReactionTypesResponse = /*#__PURE__*/ z.array(zMarketEventReactionType);

/**
 * The reactions this organization has armed
 */
export const zListMarketEventReactionsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zMarketEventReaction)
});

export const zCreateMarketEventReactionBody = zMarketEventReactionCreate;

/**
 * Armed: the detector rule and the trigger that runs the playbook
 */
export const zCreateMarketEventReactionResponse = zMarketEventReaction;

export const zDeleteMarketEventReactionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Disarmed: the trigger and its detector rule are gone
 */
export const zDeleteMarketEventReactionResponse = /*#__PURE__*/ z.void();

export const zListWalletWatchesQuery = /*#__PURE__*/ z.object({
    includeRemoved: /*#__PURE__*/ z.enum(['true', 'false']).optional()
});

/**
 * The wallets the organization watches
 */
export const zListWalletWatchesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zWalletWatch)
});

export const zCreateWalletWatchBody = zWalletWatchCreate;

/**
 * The watch (an existing one when the wallet was already watched)
 */
export const zCreateWalletWatchResponse = /*#__PURE__*/ z.object({
    watch: zWalletWatch,
    created: /*#__PURE__*/ z.boolean()
});

export const zDeleteWalletWatchPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Stopped watching; the watch stays as history
 */
export const zDeleteWalletWatchResponse = /*#__PURE__*/ z.object({
    success: /*#__PURE__*/ z.boolean()
});

export const zGetWalletWatchPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * The wallet, its newest moves and the rules each fired
 */
export const zGetWalletWatchResponse = zWalletWatchDetail;

export const zListFinanceStrategyRunsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional(),
    scope: /*#__PURE__*/ z.string().optional(),
    runMode: /*#__PURE__*/ z.enum([
        'research',
        'backtest',
        'walk_forward',
        'cross_validation',
        'monte_carlo',
        'paper',
        'shadow',
        'canary',
        'live'
    ]).optional(),
    runStatus: /*#__PURE__*/ z.enum([
        'scheduled',
        'running',
        'finished',
        'failed',
        'killed'
    ]).optional(),
    researchOnly: /*#__PURE__*/ z.string().optional(),
    passed: /*#__PURE__*/ z.string().optional(),
    definitionId: /*#__PURE__*/ z.string().optional(),
    bucketDefinitionId: /*#__PURE__*/ z.string().optional(),
    minSharpe: /*#__PURE__*/ z.string().optional(),
    maxDrawdown: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy runs
 */
export const zListFinanceStrategyRunsResponse = zStrategyRunList;

export const zCreateFinanceStrategyRunBody = zStrategyRunInput;

/**
 * Strategy run persisted
 */
export const zCreateFinanceStrategyRunResponse = zStrategyRunPersistResult;

export const zListFinanceStrategyRunRequestsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'queued',
        'blocked',
        'dispatched',
        'running',
        'completed',
        'failed',
        'cancelled',
        'awaiting_preregistration'
    ]).optional(),
    scope: /*#__PURE__*/ z.string().optional(),
    runMode: /*#__PURE__*/ z.enum([
        'research',
        'backtest',
        'walk_forward',
        'cross_validation',
        'monte_carlo',
        'paper',
        'shadow',
        'canary',
        'live'
    ]).optional(),
    requestedEngine: /*#__PURE__*/ z.string().optional(),
    researchOnly: /*#__PURE__*/ z.string().optional(),
    definitionId: /*#__PURE__*/ z.string().optional(),
    bucketDefinitionId: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy run requests
 */
export const zListFinanceStrategyRunRequestsResponse = zStrategyRunRequestList;

export const zCreateFinanceStrategyRunRequestBody = zStrategyRunRequestInput;

/**
 * Strategy run request queued for workflow/worker execution
 */
export const zCreateFinanceStrategyRunRequestResponse = zStrategyRunRequestPersistResult;

export const zGetFinanceStrategyRunRequestPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Strategy run request detail
 */
export const zGetFinanceStrategyRunRequestResponse = /*#__PURE__*/ z.object({
    data: zStrategyRunRequestRecord
});

export const zGetFinanceStrategyRunPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Strategy run detail
 */
export const zGetFinanceStrategyRunResponse = /*#__PURE__*/ z.object({
    data: zStrategyRunRecord
});

export const zGetStrategyRunResultPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Run header, summary statistics, and normalized artifact index
 */
export const zGetStrategyRunResultResponse = zStrategyRunResultResult;

export const zGetStrategyRunArtifactPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1),
    kind: /*#__PURE__*/ z.string().min(1).max(64).regex(/^[a-z0-9_]+$/)
});

export const zGetStrategyRunArtifactQuery = /*#__PURE__*/ z.object({
    from: /*#__PURE__*/ z.string().optional(),
    to: /*#__PURE__*/ z.string().optional(),
    resolution: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Series kinds return LTTB-downsampled points; tabular kinds return an offset/limit page; every other kind returns the stored payload unchanged
 */
export const zGetStrategyRunArtifactResponse = zStrategyRunArtifactResult;

export const zGetStrategyRunAnalyticsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * The run's analysis — key stats, periodical P&L, benchmarking, exposure, run-ups and drawdowns, P&L by side and signal, the trades and their distribution, streaks and time patterns — computed once per run
 */
export const zGetStrategyRunAnalyticsResponse = zStrategyRunAnalytics;

export const zListStrategyDefinitionGroupsQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().max(200).optional(),
    tier: /*#__PURE__*/ z.enum(['works_now', 'proven']).optional(),
    assetClass: /*#__PURE__*/ z.string().max(40).optional(),
    category: /*#__PURE__*/ z.enum([
        'trend_following',
        'time_series_momentum',
        'cross_sectional_momentum',
        'momentum',
        'mean_reversion',
        'breakout',
        'volatility_breakout',
        'pattern',
        'indicator_system',
        'carry',
        'fx_specific',
        'stat_arb',
        'pairs',
        'intermarket',
        'sector_rotation',
        'factor',
        'anomaly',
        'options_volatility',
        'crypto_onchain',
        'sentiment_news',
        'regime_adaptive',
        'portfolio_allocation',
        'arbitrage',
        'hybrid',
        'technical',
        'fundamental',
        'custom'
    ]).optional(),
    lifecycle: /*#__PURE__*/ z.enum([
        'candidate',
        'backtest',
        'risk',
        'paper',
        'live',
        'retired'
    ]).optional(),
    sort: /*#__PURE__*/ z.enum(['score', 'updated']).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional(),
    offset: /*#__PURE__*/ z.int().gte(0).nullish(),
    base: /*#__PURE__*/ z.string().max(200).optional(),
    includeWeak: /*#__PURE__*/ z.enum(['true', 'false']).optional()
});

/**
 * The organization's strategies by base strategy (the template they were born from), each led by its best variant; weak variants (grade D or F) left out unless asked for
 */
export const zListStrategyDefinitionGroupsResponse = zStrategyDefinitionGroupList;

export const zListStrategyDefinitionSummariesQuery = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.string().regex(/^[1-9]\d{0,18}$/).optional(),
    q: /*#__PURE__*/ z.string().max(200).optional(),
    tier: /*#__PURE__*/ z.enum(['works_now', 'proven']).optional(),
    assetClass: /*#__PURE__*/ z.string().max(40).optional(),
    category: /*#__PURE__*/ z.enum([
        'trend_following',
        'time_series_momentum',
        'cross_sectional_momentum',
        'momentum',
        'mean_reversion',
        'breakout',
        'volatility_breakout',
        'pattern',
        'indicator_system',
        'carry',
        'fx_specific',
        'stat_arb',
        'pairs',
        'intermarket',
        'sector_rotation',
        'factor',
        'anomaly',
        'options_volatility',
        'crypto_onchain',
        'sentiment_news',
        'regime_adaptive',
        'portfolio_allocation',
        'arbitrage',
        'hybrid',
        'technical',
        'fundamental',
        'custom'
    ]).optional(),
    lifecycle: /*#__PURE__*/ z.enum([
        'candidate',
        'backtest',
        'risk',
        'paper',
        'live',
        'retired'
    ]).optional(),
    sort: /*#__PURE__*/ z.enum(['score', 'updated']).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional(),
    offset: /*#__PURE__*/ z.int().gte(0).nullish(),
    base: /*#__PURE__*/ z.string().max(200).optional(),
    includeWeak: /*#__PURE__*/ z.enum(['true', 'false']).optional()
});

/**
 * The organization's strategies (at most 200 a page), each with its score, latest finished run, lifecycle and tier standing
 */
export const zListStrategyDefinitionSummariesResponse = /*#__PURE__*/ z.array(zStrategyDefinitionSummary);

export const zListStrategyDefinitionRunsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

export const zListStrategyDefinitionRunsQuery = /*#__PURE__*/ z.object({
    latest: /*#__PURE__*/ z.enum(['true', 'false']).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional(),
    includeVersions: /*#__PURE__*/ z.enum(['true', 'false']).optional()
});

/**
 * Thin run projections for a strategy definition, newest finished first
 */
export const zListStrategyDefinitionRunsResponse = zStrategyDefinitionRunList;

export const zCreateStrategyDefinitionRunBody = zCreateStrategyDefinitionRunRequest;

export const zCreateStrategyDefinitionRunPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Run request enqueued for this definition with the supplied parameter values
 */
export const zCreateStrategyDefinitionRunResponse = zCreateStrategyDefinitionRunResult;

export const zAmendStrategyDefinitionParametersBody = zAmendStrategyDefinitionParametersRequest;

export const zAmendStrategyDefinitionParametersPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Parameters amended — a new definitionVersion of the same strategy when anything changed, the existing version when the patch was a no-op
 */
export const zAmendStrategyDefinitionParametersResponse = zAmendStrategyDefinitionParametersResult;

export const zForkStrategyDefinitionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Deep-copy of the definition into a NEW candidate lineage — a fresh sourceCandidateId at definitionVersion 1, lifecycle candidate — with the indicator bindings re-persisted
 */
export const zForkStrategyDefinitionResponse = zForkStrategyDefinitionResult;

/**
 * Active strategy templates for this organization
 */
export const zListFinanceStrategyTemplatesResponse = zStrategyTemplateList;

export const zGetFinanceStrategyTemplatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Strategy template detail
 */
export const zGetFinanceStrategyTemplateResponse = zStrategyTemplateGetResult;

export const zPreviewFinanceStrategyTemplateBody = zStrategyTemplatePreviewRequest;

/**
 * Compiled template preview (no persistence)
 */
export const zPreviewFinanceStrategyTemplateResponse = zStrategyTemplatePreviewResult;

export const zEnqueueFinanceStrategyTemplateRunBody = zStrategyTemplateEnqueueRequest;

/**
 * Strategy run request enqueued
 */
export const zEnqueueFinanceStrategyTemplateRunResponse = zStrategyTemplateEnqueueResult;

export const zListFinanceProviderUnlockPromptsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.string().optional(),
    scope: /*#__PURE__*/ z.string().optional(),
    assetClass: /*#__PURE__*/ z.string().optional(),
    requiredSecret: /*#__PURE__*/ z.string().optional()
});

/**
 * Provider unlock prompts for finance strategy testing and promotion gates
 */
export const zListFinanceProviderUnlockPromptsResponse = zFinanceProviderUnlockPromptList;

export const zGetFinanceProviderUnlockPromptPath = /*#__PURE__*/ z.object({
    unlockId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Provider unlock prompt detail
 */
export const zGetFinanceProviderUnlockPromptResponse = zFinanceProviderUnlockPromptDetailResult;

export const zListFinanceStrategyCostModelsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional(),
    costModelId: /*#__PURE__*/ z.string().optional(),
    realismLevel: /*#__PURE__*/ z.string().optional(),
    slippageModelKind: /*#__PURE__*/ z.string().optional(),
    feeModelKind: /*#__PURE__*/ z.string().optional(),
    fillModelKind: /*#__PURE__*/ z.string().optional(),
    costAssumptionSource: /*#__PURE__*/ z.string().optional()
});

/**
 * List finance strategy cost models
 */
export const zListFinanceStrategyCostModelsResponse = zFinanceStrategyCostModelList;

export const zCreateFinanceStrategyCostModelBody = /*#__PURE__*/ z.object({
    type: /*#__PURE__*/ z.enum(['strategy_cost_model']).optional().default('strategy_cost_model'),
    schemaVersion: /*#__PURE__*/ z.enum(['finance-strategy-cost-model/v1']).optional().default('finance-strategy-cost-model/v1'),
    costModelId: /*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/),
    version: /*#__PURE__*/ z.string().min(1),
    name: /*#__PURE__*/ z.string().min(1).optional(),
    realismLevel: /*#__PURE__*/ z.enum([
        'none',
        'default_broker',
        'custom'
    ]).optional().default('custom'),
    brokerageModel: /*#__PURE__*/ z.string().optional(),
    slippageModel: /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'none',
                'fixed_basis_points',
                'constant_percent',
                'fixed_spread',
                'spread_fraction',
                'proportional_price',
                'volume_share',
                'square_root_impact',
                'almgren_chriss',
                'custom'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
        costAssumptionSource: /*#__PURE__*/ z.enum([
            'none',
            'measured',
            'vendor_feed',
            'static_assumption',
            'heuristic'
        ]).optional().default('none'),
        applyOnOpen: /*#__PURE__*/ z.boolean().optional(),
        allowFillBeyondLimit: /*#__PURE__*/ z.boolean().optional()
    }).nullish().default({
        kind: 'none',
        config: {},
        costAssumptionSource: 'none'
    }),
    feeModel: /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'none',
                'per_share',
                'per_trade',
                'per_dollar',
                'per_contract',
                'maker_taker',
                'tiered',
                'proportional_plus_fixed',
                'brokerage_named',
                'custom'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
        currency: /*#__PURE__*/ z.string().min(1).optional(),
        regulatoryFees: /*#__PURE__*/ z.object({
            side: /*#__PURE__*/ z.union([
                /*#__PURE__*/ z.enum([
                    'buy',
                    'sell',
                    'both'
                ]),
                /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
            ]).optional(),
            secFeeBps: /*#__PURE__*/ z.number().gte(0).optional(),
            finraTafPerShare: /*#__PURE__*/ z.number().gte(0).optional(),
            exchangeFeePerShare: /*#__PURE__*/ z.number().gte(0).optional(),
            clearingFeePerTrade: /*#__PURE__*/ z.number().gte(0).optional()
        }).optional(),
        costAssumptionSource: /*#__PURE__*/ z.enum([
            'none',
            'measured',
            'vendor_feed',
            'static_assumption',
            'heuristic'
        ]).optional().default('none')
    }).nullish().default({
        kind: 'none',
        config: {},
        costAssumptionSource: 'none'
    }),
    latencyModel: /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'zero',
                'fixed_ms',
                'uniform_ms',
                'normal_ms',
                'distribution',
                'custom'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
        fixedLatencyMs: /*#__PURE__*/ z.number().gte(0).optional(),
        latencyMeanMs: /*#__PURE__*/ z.number().gte(0).optional(),
        latencyStdMs: /*#__PURE__*/ z.number().gte(0).optional(),
        adverseSelectionBps: /*#__PURE__*/ z.number().optional(),
        costAssumptionSource: /*#__PURE__*/ z.enum([
            'none',
            'measured',
            'vendor_feed',
            'static_assumption',
            'heuristic'
        ]).optional().default('none')
    }).nullish().default({
        kind: 'zero',
        config: {},
        costAssumptionSource: 'none'
    }),
    fillModel: /*#__PURE__*/ z.object({
        kind: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'immediate',
                'equity',
                'future',
                'future_option',
                'best_price',
                'parametric',
                'size_aware',
                'partial',
                'volume_sensitive',
                'session_aware',
                'competition_aware',
                'custom'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        fillTiming: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.enum([
                'same_bar_close',
                'next_bar_open',
                'next_bar_vwap',
                'mid',
                'worst_of_bar',
                'quote_cross'
            ]),
            /*#__PURE__*/ z.string().min(3).max(240).regex(/^(builtin|plugin|model|vendor|engine|portfolio|execution|risk|indicator|operator|data|validator|llm):[A-Za-z0-9_.:\/@+-]+$/)
        ]).optional(),
        idealizedFills: /*#__PURE__*/ z.boolean().optional().default(false),
        config: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({}),
        queue: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional().default({})
    }).nullish().default({
        kind: 'immediate',
        fillTiming: 'next_bar_open',
        idealizedFills: false,
        config: {},
        queue: {}
    }),
    borrowCostModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    financingCostModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    settlementModel: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.unknown()).optional(),
    sourceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/)).optional().default([]),
    evidenceIds: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().min(1).max(160).regex(/^[A-Za-z0-9_.:-]+$/)).optional().default([])
});

/**
 * Persist a versioned finance strategy cost model
 */
export const zCreateFinanceStrategyCostModelResponse = zFinanceStrategyCostModelPersistResult;

export const zGetFinanceStrategyCostModelPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

export const zGetFinanceStrategyCostModelQuery = /*#__PURE__*/ z.object({
    version: /*#__PURE__*/ z.string().optional()
});

/**
 * Finance strategy cost model detail
 */
export const zGetFinanceStrategyCostModelResponse = zFinanceStrategyCostModelDetailResult;

export const zListFinanceStrategyLifecycleTransitionsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional(),
    definitionId: /*#__PURE__*/ z.string().optional(),
    bucketDefinitionId: /*#__PURE__*/ z.string().optional(),
    toState: /*#__PURE__*/ z.enum([
        'candidate',
        'research_brief',
        'backtest_pending',
        'backtest_done_pass',
        'backtest_done_fail',
        'risk_pending',
        'risk_cleared',
        'risk_rejected',
        'paper_trading',
        'paper_trading_completed',
        'pending_live_approval',
        'live_trading',
        'retired',
        'archived',
        'watchlist'
    ]).optional(),
    transitionType: /*#__PURE__*/ z.string().optional(),
    sourceRunId: /*#__PURE__*/ z.string().optional()
});

/**
 * List finance strategy lifecycle transitions
 */
export const zListFinanceStrategyLifecycleTransitionsResponse = zFinanceStrategyLifecycleTransitionList;

export const zCreateFinanceStrategyLifecycleTransitionBody = zFinanceStrategyLifecycleTransitionCreateInput;

/**
 * Create an auditable finance strategy lifecycle transition
 */
export const zCreateFinanceStrategyLifecycleTransitionResponse = zFinanceStrategyLifecycleTransitionCreateResult;

export const zCommitFinanceStrategyLifecycleTransitionBody = zFinanceStrategyLifecycleCommitInput;

/**
 * Commit an approved capital-facing lifecycle transition
 */
export const zCommitFinanceStrategyLifecycleTransitionResponse = zFinanceStrategyLifecycleTransitionCreateResult;

export const zGetFinanceArtifactPreviewPath = /*#__PURE__*/ z.object({
    artifactId: /*#__PURE__*/ z.string()
});

/**
 * Metadata-only preview of a finance conversation artifact
 */
export const zGetFinanceArtifactPreviewResponse = /*#__PURE__*/ z.union([
    zFinanceArtifactPreviewResult,
    zFinanceArtifactUnsupportedPreviewResult
]);

/**
 * Research workflow list
 */
export const zListFinanceResearchWorkflowsResponse = zFinanceResearchWorkflowList;

export const zStartFinanceResearchWorkflowRunPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Research workflow run triggered
 */
export const zStartFinanceResearchWorkflowRunResponse = zFinanceResearchRunStartResult;

export const zListFinancePlannerRecommendationsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Ranked WTN planner recommendations
 */
export const zListFinancePlannerRecommendationsResponse = zFinancePlannerRecommendationsResult;

export const zGetFinanceBucketCompositionQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Bucket composition status with evaluations, run requests, and scores
 */
export const zGetFinanceBucketCompositionResponse = zFinanceBucketCompositionResult;

export const zApplyFinanceBucketDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Decision applied successfully; bucket definition updated
 */
export const zApplyFinanceBucketDecisionResponse = zFinanceBucketDecisionApplyResult;

export const zProposeFinanceBucketReweightBody = zFinanceProposeReweightBody;

/**
 * Pending reweight_bucket decision created (or an identical pending proposal returned)
 */
export const zProposeFinanceBucketReweightResponse = zFinanceProposeReweightResult;

export const zListFinanceIndicatorDecisionsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * List of indicator decision requests for the organization
 */
export const zListFinanceIndicatorDecisionsResponse = zFinanceIndicatorDecisionList;

export const zEnqueueFinanceIndicatorDecisionBody = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1).max(40),
    exchange: /*#__PURE__*/ z.string().min(1).max(80).optional(),
    assetClass: /*#__PURE__*/ z.string().min(1).max(80).optional(),
    timeframe: /*#__PURE__*/ z.string().min(1).max(20),
    windowStart: /*#__PURE__*/ z.iso.datetime(),
    windowEnd: /*#__PURE__*/ z.iso.datetime(),
    indicator: /*#__PURE__*/ z.object({
        canonicalKey: /*#__PURE__*/ z.string().min(1).max(120)
    }),
    parameters: /*#__PURE__*/ z.record(/*#__PURE__*/ z.string(), /*#__PURE__*/ z.union([
        /*#__PURE__*/ z.number(),
        /*#__PURE__*/ z.string(),
        /*#__PURE__*/ z.boolean()
    ])).optional(),
    rules: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        signalId: /*#__PURE__*/ z.string().min(1).max(160).optional(),
        side: /*#__PURE__*/ z.enum(['long', 'short']),
        description: /*#__PURE__*/ z.string().min(1).max(500),
        left: /*#__PURE__*/ z.object({
            type: /*#__PURE__*/ z.enum(['indicator']),
            indicatorId: /*#__PURE__*/ z.string().min(1).max(160),
            output: /*#__PURE__*/ z.string().min(1).max(120)
        }),
        op: /*#__PURE__*/ z.enum([
            '>',
            '>=',
            '<',
            '<=',
            '==',
            '!=',
            'crosses_above',
            'crosses_below',
            'between',
            'score_above'
        ]),
        right: /*#__PURE__*/ z.union([
            /*#__PURE__*/ z.object({
                type: /*#__PURE__*/ z.enum(['indicator']),
                indicatorId: /*#__PURE__*/ z.string().min(1).max(160),
                output: /*#__PURE__*/ z.string().min(1).max(120)
            }),
            /*#__PURE__*/ z.object({
                type: /*#__PURE__*/ z.enum(['constant']),
                value: /*#__PURE__*/ z.union([
                    /*#__PURE__*/ z.number(),
                    /*#__PURE__*/ z.string(),
                    /*#__PURE__*/ z.boolean()
                ])
            }),
            /*#__PURE__*/ z.object({
                type: /*#__PURE__*/ z.enum(['field']),
                field: /*#__PURE__*/ z.string().min(1).max(80)
            })
        ])
    })).min(1).max(4),
    idempotencyKey: /*#__PURE__*/ z.string().min(1).max(240).optional()
});

/**
 * Indicator decision request enqueued
 */
export const zEnqueueFinanceIndicatorDecisionResponse = zFinanceIndicatorDecisionEnqueueResult;

export const zGetFinanceIndicatorDecisionPath = /*#__PURE__*/ z.object({
    requestId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Indicator decision request summary
 */
export const zGetFinanceIndicatorDecisionResponse = zFinanceIndicatorDecisionGetResult;

export const zListFinanceStrategyDecisionsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Strategy decision summaries
 */
export const zListFinanceStrategyDecisionsResponse = zStrategyDecisionList;

export const zGetFinanceStrategyDecisionPath = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.string()
});

/**
 * Strategy decision summary
 */
export const zGetFinanceStrategyDecisionResponse = zFinanceStrategyDecisionGetResult;

export const zEvaluateFinanceStrategyDecisionBody = zStrategyDecisionEvaluateRequest;

export const zEvaluateFinanceStrategyDecisionPath = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.string()
});

/**
 * Run request enqueued
 */
export const zEvaluateFinanceStrategyDecisionResponse = zStrategyDecisionEvaluateResult;

export const zEvaluateFinanceStrategyDefinitionBody = zStrategyEvaluationRunRequest;

export const zEvaluateFinanceStrategyDefinitionPath = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Evaluation run result — assignments evaluated → satisfaction, or no_assignments when no plan is applied
 */
export const zEvaluateFinanceStrategyDefinitionResponse = /*#__PURE__*/ z.object({
    data: zStrategyEvaluationRunResult
});

export const zGetFinanceOperationsSummaryQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Aggregate finance operations summary
 */
export const zGetFinanceOperationsSummaryResponse = zFinanceOperationsSummaryResult;

export const zLookupFinanceCommandOptionsQuery = /*#__PURE__*/ z.object({
    command: /*#__PURE__*/ z.enum([
        'indicator',
        'strategy',
        'ticker',
        'research',
        'timeframe'
    ]),
    q: /*#__PURE__*/ z.string().max(120).optional(),
    limit: /*#__PURE__*/ z.string().optional()
});

/**
 * Command lookup options
 */
export const zLookupFinanceCommandOptionsResponse = zFinanceCommandLookupResult;

/**
 * Active finance conversation personas for the org (bounded list)
 */
export const zListFinanceConversationPersonasResponse = /*#__PURE__*/ z.array(zFinanceConversationPersona);

export const zPreviewFinanceIndicatorImportBody = zIndicatorImportPreviewBody;

/**
 * Non-executable indicator candidate preview from Pine Script source or URL
 */
export const zPreviewFinanceIndicatorImportResponse = zIndicatorImportPreviewResult;

export const zTranspileFinanceIndicatorImportBody = zIndicatorImportTranspileBody;

/**
 * DRAFT indicator definition + PyneCore implementation created. pyneCode is stored in DB only — execution requires harness proof + governed promotion.
 */
export const zTranspileFinanceIndicatorImportResponse = zIndicatorImportTranspileResult;

export const zListFinanceIndicatorsQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().max(120).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(100).optional()
});

/**
 * Indicator catalog — org-scoped definitions + marketplace definitions with implementations summary
 */
export const zListFinanceIndicatorsResponse = zIndicatorCatalogList;

export const zApplyFinanceIndicatorPromotionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Decision applied; implementation promoted to active
 */
export const zApplyFinanceIndicatorPromotionResponse = zFinanceIndicatorPromotionApplyResult;

export const zCreateTickerResearchNoteBody = zTickerResearchNoteCreate;

/**
 * Ticker research note created. Source commentary — not a trading signal.
 */
export const zCreateTickerResearchNoteResponse = zTickerResearchNote;

export const zListVarEstimatesQuery = /*#__PURE__*/ z.object({
    subjectScope: /*#__PURE__*/ z.string().optional(),
    subjectId: /*#__PURE__*/ z.string().optional(),
    method: /*#__PURE__*/ z.enum([
        'parametric',
        'historical',
        'monte_carlo'
    ]).optional(),
    confidence: /*#__PURE__*/ z.enum(['0.95', '0.99']).optional(),
    horizon: /*#__PURE__*/ z.enum([
        '1d',
        '5d',
        '10d',
        '20d'
    ]).optional(),
    status: /*#__PURE__*/ z.enum(['current', 'superseded']).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Portfolio VaR estimates for the organization
 */
export const zListVarEstimatesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zVarEstimate),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zListVarBacktestsQuery = /*#__PURE__*/ z.object({
    subjectScope: /*#__PURE__*/ z.string().optional(),
    subjectId: /*#__PURE__*/ z.string().optional(),
    method: /*#__PURE__*/ z.enum([
        'parametric',
        'historical',
        'monte_carlo'
    ]).optional(),
    confidence: /*#__PURE__*/ z.enum(['0.95', '0.99']).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * VaR backtest results (Kupiec/Christoffersen coverage tests)
 */
export const zListVarBacktestsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zVarBacktest),
    total: /*#__PURE__*/ z.number()
});

export const zGetVarEstimatePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Portfolio VaR estimate detail
 */
export const zGetVarEstimateResponse = /*#__PURE__*/ z.object({
    data: zVarEstimate
});

export const zListVarComponentsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Tail-attribution components for the VaR estimate
 */
export const zListVarComponentsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zVarComponentRow)
});

export const zListStressScenariosQuery = /*#__PURE__*/ z.object({
    kind: /*#__PURE__*/ z.enum([
        'historical_episode',
        'correlation_to_one',
        'factor_shock',
        'sector_shock',
        'rate_twist',
        'idiosyncratic'
    ]).optional()
});

/**
 * In-tree stress scenario library (no DB — always available)
 */
export const zListStressScenariosResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        scenarioKey: /*#__PURE__*/ z.string(),
        kind: /*#__PURE__*/ z.enum([
            'historical_episode',
            'correlation_to_one',
            'factor_shock',
            'sector_shock',
            'rate_twist',
            'idiosyncratic'
        ]),
        spec: zStressScenarioSpec
    })),
    total: /*#__PURE__*/ z.number()
});

export const zGetStressScenarioPath = /*#__PURE__*/ z.object({
    scenarioKey: /*#__PURE__*/ z.string().min(1)
});

/**
 * Stress scenario library entry
 */
export const zGetStressScenarioResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.object({
        scenarioKey: /*#__PURE__*/ z.string(),
        kind: /*#__PURE__*/ z.enum([
            'historical_episode',
            'correlation_to_one',
            'factor_shock',
            'sector_shock',
            'rate_twist',
            'idiosyncratic'
        ]),
        spec: zStressScenarioSpec
    })
});

export const zListStressResultsQuery = /*#__PURE__*/ z.object({
    scenarioKey: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'ready',
        'degraded',
        'blocked'
    ]).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Persisted stress results for the organization (latest first)
 */
export const zListStressResultsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zStressResultContract),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zGetStressResultPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Full stress result including loss, contributions, stressed vol, riskByBlock, diagnostics
 */
export const zGetStressResultResponse = /*#__PURE__*/ z.object({
    data: zStressResultContract
});

export const zListAttributionRunsQuery = /*#__PURE__*/ z.object({
    subjectId: /*#__PURE__*/ z.string().optional(),
    method: /*#__PURE__*/ z.enum(['brinson', 'factor']).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Attribution runs for the organization, latest computedAt first
 */
export const zListAttributionRunsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAttributionRun),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zGetAttributionRunPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Full attribution run including manifest and all effect rows
 */
export const zGetAttributionRunResponse = /*#__PURE__*/ z.object({
    data: zAttributionRun
});

export const zListAttributionEffectsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListAttributionEffectsQuery = /*#__PURE__*/ z.object({
    method: /*#__PURE__*/ z.enum(['brinson', 'factor']).optional(),
    effectKind: /*#__PURE__*/ z.enum([
        'allocation',
        'selection',
        'interaction',
        'factor_return',
        'specific',
        'total'
    ]).optional(),
    periodIndex: /*#__PURE__*/ z.string().optional()
});

/**
 * Attribution effect rows for the run, optionally filtered
 */
export const zListAttributionEffectsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zAttributionEffectRow),
    total: /*#__PURE__*/ z.number()
});

export const zListTcaScorecardsQuery = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.string().optional().default('strategy_definition'),
    subjectId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * TCA best-execution scorecards for the subject, all scopes (tca:all, per-venue, per-symbol)
 */
export const zListTcaScorecardsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zTcaScorecard),
    total: /*#__PURE__*/ z.number()
});

export const zListCrowdingScoresQuery = /*#__PURE__*/ z.object({
    scope: /*#__PURE__*/ z.string().max(240).optional()
});

/**
 * Current crowding vectors (scoreType=crowding) for the org, newest first (per subject × scope × regime). Read-only.
 */
export const zListCrowdingScoresResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCrowdingScore),
    total: /*#__PURE__*/ z.number()
});

export const zListCapitalAllocationsQuery = /*#__PURE__*/ z.object({
    poolKey: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Capital allocation proposals for the organization, latest first
 */
export const zListCapitalAllocationsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCapitalAllocationDigest),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zGetCapitalAllocationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Full capital allocation proposal including manifest and sleeves
 */
export const zGetCapitalAllocationResponse = /*#__PURE__*/ z.object({
    data: zCapitalAllocationProposal
});

export const zListCapitalAllocationSleevesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Sleeve allocation lines for one capital allocation proposal
 */
export const zListCapitalAllocationSleevesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCapitalAllocationSleeve),
    total: /*#__PURE__*/ z.number()
});

export const zSubmitCapitalAllocationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Submit result — new or existing pending daemon_decisions row. No capital is moved.
 */
export const zSubmitCapitalAllocationResponse = /*#__PURE__*/ z.object({
    data: zCapitalAllocationSubmitResult
});

export const zListCapacityCurvesQuery = /*#__PURE__*/ z.object({
    sleeveKind: /*#__PURE__*/ z.enum([
        'bucket',
        'strategy',
        'external'
    ]).optional(),
    status: /*#__PURE__*/ z.enum([
        'ready',
        'research_only',
        'blocked'
    ]).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Capacity curves for the organization, latest computedAt first
 */
export const zListCapacityCurvesResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zCapacityCurve),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zGetCapacityCurvePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Full capacity curve including manifest
 */
export const zGetCapacityCurveResponse = /*#__PURE__*/ z.object({
    data: zCapacityCurve
});

export const zGetTradingAccountPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Trading account header and net-liquidation
 */
export const zGetTradingAccountResponse = /*#__PURE__*/ z.object({
    data: zTradingAccount
});

export const zCreateDepositBody = /*#__PURE__*/ z.object({
    amount: /*#__PURE__*/ z.number().gt(0),
    currency: /*#__PURE__*/ z.string().regex(/^[A-Z0-9]{3,10}$/).optional().default('USD'),
    idempotency_key: /*#__PURE__*/ z.string().min(1).max(200).optional()
});

export const zCreateDepositPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deposit applied (applied:false means idempotency no-op)
 */
export const zCreateDepositResponse = /*#__PURE__*/ z.object({
    data: zCashMovementResult
});

export const zCreateWithdrawalBody = /*#__PURE__*/ z.object({
    amount: /*#__PURE__*/ z.number().gt(0),
    currency: /*#__PURE__*/ z.string().regex(/^[A-Z0-9]{3,10}$/).optional().default('USD'),
    idempotency_key: /*#__PURE__*/ z.string().min(1).max(200).optional()
});

export const zCreateWithdrawalPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Withdrawal applied (applied:false means idempotency no-op)
 */
export const zCreateWithdrawalResponse = /*#__PURE__*/ z.object({
    data: zCashMovementResult
});

export const zCreateAdjustmentBody = /*#__PURE__*/ z.object({
    amount: /*#__PURE__*/ z.number(),
    currency: /*#__PURE__*/ z.string().regex(/^[A-Z0-9]{3,10}$/).optional().default('USD'),
    idempotency_key: /*#__PURE__*/ z.string().min(1).max(200).optional()
});

export const zCreateAdjustmentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Adjustment applied (applied:false means idempotency no-op)
 */
export const zCreateAdjustmentResponse = /*#__PURE__*/ z.object({
    data: zCashMovementResult
});

export const zGetAccountFxCashPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zGetAccountFxCashQuery = /*#__PURE__*/ z.object({
    as_of: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * FX-translated cash breakdown per currency with base-currency total
 */
export const zGetAccountFxCashResponse = /*#__PURE__*/ z.object({
    data: zAccountFxCash
});

export const zListPositionLotsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListPositionLotsQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum(['open', 'closed']).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Position lots for the account, newest first
 */
export const zListPositionLotsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zPositionLot),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zListLotDisposalsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListLotDisposalsQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().optional(),
    holding_term: /*#__PURE__*/ z.enum(['short', 'long']).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Lot disposals for the account, newest first
 */
export const zListLotDisposalsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zLotDisposal),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zListBookSnapshotsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

export const zListBookSnapshotsQuery = /*#__PURE__*/ z.object({
    snapshot_type: /*#__PURE__*/ z.enum(['sod', 'eod']).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * SOD/EOD lot-book snapshots for the account, newest as_of first
 */
export const zListBookSnapshotsResponse = /*#__PURE__*/ z.object({
    data: /*#__PURE__*/ z.array(zBookSnapshot),
    total: /*#__PURE__*/ z.number(),
    limit: /*#__PURE__*/ z.number(),
    offset: /*#__PURE__*/ z.number()
});

export const zDtiOperatorKillSwitchBody = zDtiKillSwitchRequest;

export const zDtiOperatorKillSwitchPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Run paused by operator kill-switch
 */
export const zDtiOperatorKillSwitchResponse = zDtiKillSwitchResult;

export const zDtiOperatorResumeBody = zDtiResumeRequest;

export const zDtiOperatorResumePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Run resumed by operator
 */
export const zDtiOperatorResumeResponse = zDtiKillSwitchResult;

export const zCreateDiscretionaryRunBody = zCreateDiscretionaryRunRequest;

/**
 * Discretionary paper forward run created (or existing run returned)
 */
export const zCreateDiscretionaryRunResponse = zCreateDiscretionaryRunResult;

export const zGetIntelSourceStyleProfilePath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Current trader-style profile for the source
 */
export const zGetIntelSourceStyleProfileResponse = zIntelSourceStyleProfileResult;

export const zGetIntelSourceViewConfirmationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Per-horizon hit-rate + agreement + pending summary for this source
 */
export const zGetIntelSourceViewConfirmationResponse = zIntelSourceViewConfirmationResponse;

export const zGetFinanceAuditLedgerChainQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional().default(50),
    cursor_seq: /*#__PURE__*/ z.int().gte(0).nullish()
});

/**
 * Keyset-paginated ledger chain. next_cursor_seq is null when no further pages exist.
 */
export const zGetFinanceAuditLedgerChainResponse = zAuditLedgerEntryList;

export const zGetFinanceAuditLedgerOrderHistoryPath = /*#__PURE__*/ z.object({
    order_id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * All ledger entries referencing the given order, ordered by chain_seq.
 */
export const zGetFinanceAuditLedgerOrderHistoryResponse = /*#__PURE__*/ z.object({
    entries: /*#__PURE__*/ z.array(zAuditLedgerEntry)
});

/**
 * Current chain head — highest committed seq + hash + entry count.
 */
export const zGetFinanceAuditLedgerHeadResponse = zAuditLedgerHead;

export const zVerifyFinanceAuditLedgerChainQuery = /*#__PURE__*/ z.object({
    from_seq: /*#__PURE__*/ z.int().gte(0).nullish(),
    to_seq: /*#__PURE__*/ z.int().gte(0).nullish()
});

/**
 * Chain integrity result. valid=true means all hashes and linkages are intact in the requested range.
 */
export const zVerifyFinanceAuditLedgerChainResponse = zAuditLedgerChainVerificationResult;

export const zListExecutionDeploymentsQuery = /*#__PURE__*/ z.object({
    venue: /*#__PURE__*/ z.enum(['paper', 'live']).optional(),
    scope: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'scheduled',
        'running',
        'finished',
        'failed',
        'killed'
    ]).optional(),
    definition_id: /*#__PURE__*/ z.string().optional(),
    bucket_definition_id: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Execution deployments (capital-facing strategy runs) for the organization
 */
export const zListExecutionDeploymentsResponse = zExecutionDeploymentList;

export const zCreateExecutionDeploymentBody = zExecutionDeploymentCreate;

/**
 * Execution deployment enqueued successfully
 */
export const zCreateExecutionDeploymentResponse = /*#__PURE__*/ z.object({
    data: zExecutionDeployment
});

export const zGetExecutionDeploymentPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Execution deployment detail with emitted orders and fills
 */
export const zGetExecutionDeploymentResponse = /*#__PURE__*/ z.object({
    data: zExecutionDeploymentRun
});

export const zGetPortfolioValuationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Computed marks for all holdings in a portfolio
 */
export const zGetPortfolioValuationResponse = /*#__PURE__*/ z.object({
    valuation: zPortfolioValuationResult
});

export const zGetPositionValuationPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Computed mark for a single position
 */
export const zGetPositionValuationResponse = /*#__PURE__*/ z.object({
    mark: zMarkResult
});

export const zListFinanceModelLineageQuery = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.enum(['strategy_definition', 'strategy_bucket_definition']).optional(),
    lifecycleState: /*#__PURE__*/ z.string().optional(),
    slug: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional(),
    offset: /*#__PURE__*/ z.int().gte(0).nullish()
});

/**
 * Paginated list of model-lineage projections for the org
 */
export const zListFinanceModelLineageResponse = zModelLineageRecordList;

export const zGetFinanceModelLineageHistoryPath = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.enum(['strategy_definition', 'strategy_bucket_definition']),
    subjectId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Version history records for one model
 */
export const zGetFinanceModelLineageHistoryResponse = zModelLineageRecordList;

export const zGetFinanceModelLineagePath = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.enum(['strategy_definition', 'strategy_bucket_definition']),
    subjectId: /*#__PURE__*/ z.int().gt(0),
    version: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Full lineage chain (record + edges) for a specific model version
 */
export const zGetFinanceModelLineageResponse = zModelLineageGraph;

export const zGetFinanceModelLineageGraphPath = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.enum(['strategy_definition', 'strategy_bucket_definition']),
    subjectId: /*#__PURE__*/ z.int().gt(0),
    version: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Provenance edge list for a specific model version
 */
export const zGetFinanceModelLineageGraphResponse = zModelLineageGraph;

export const zGetFinanceKgRegimeProfilePath = /*#__PURE__*/ z.object({
    subjectKind: /*#__PURE__*/ z.string().min(1).max(48),
    subjectId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Regime-conditional scoring profile for a subject. byScoreType groups the global (regime="") score with per-regime breakdowns. isRegimeConditional=true means the signal performs differently across regimes.
 */
export const zGetFinanceKgRegimeProfileResponse = zKgRegimeProfile;

export const zGetFinanceKgNodeEdgesPath = /*#__PURE__*/ z.object({
    nodeId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Active KG edges for a node (src OR dst = nodeId). linkedNode is the other endpoint, batch-loaded (no N+1).
 */
export const zGetFinanceKgNodeEdgesResponse = zKgNodeEdges;

export const zSearchFinanceKgQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(200),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional().default(20)
});

/**
 * Hybrid lexical + pgvector node search, fused via reciprocal-rank fusion (RRF_K=60). match_type indicates which half(s) matched: keyword | semantic | hybrid. When Ollama is unreachable the vector half is skipped (keyword-only, not an error).
 */
export const zSearchFinanceKgResponse = zKgSearchResultList;

/**
 * List of broker credentials
 */
export const zListBrokerCredentialsResponse = zBrokerCredentialList;

export const zCreateBrokerCredentialBody = zBrokerCredentialCreate;

/**
 * Broker credential created
 */
export const zCreateBrokerCredentialResponse = zBrokerCredential;

export const zDeleteBrokerCredentialPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Deleted
 */
export const zDeleteBrokerCredentialResponse = /*#__PURE__*/ z.void();

export const zGetBrokerCredentialPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Broker credential
 */
export const zGetBrokerCredentialResponse = zBrokerCredential;

export const zUpdateBrokerCredentialBody = zBrokerCredentialUpdate;

export const zUpdateBrokerCredentialPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Updated broker credential
 */
export const zUpdateBrokerCredentialResponse = zBrokerCredential;

export const zVerifyBrokerCredentialPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Verification result
 */
export const zVerifyBrokerCredentialResponse = zBrokerCredentialVerifyResult;

export const zListExecutionAlgosQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum([
        'working',
        'completed',
        'cancelled',
        'expired',
        'failed',
        'paused'
    ]).optional()
});

/**
 * Execution algos for the organization
 */
export const zListExecutionAlgosResponse = zExecutionAlgoList;

export const zCreateExecutionAlgoBody = zExecutionAlgoCreate;

/**
 * Execution algo created and scheduled
 */
export const zCreateExecutionAlgoResponse = zExecutionAlgo;

export const zGetExecutionAlgoPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Execution algo with worked quantity and in-flight child count
 */
export const zGetExecutionAlgoResponse = zExecutionAlgoWithSummary;

export const zCancelExecutionAlgoPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Execution algo cancelled; in-flight children cancelled where possible
 */
export const zCancelExecutionAlgoResponse = zExecutionAlgo;

export const zPauseExecutionAlgoPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Execution algo paused
 */
export const zPauseExecutionAlgoResponse = zExecutionAlgo;

export const zResumeExecutionAlgoPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string()
});

/**
 * Execution algo resumed
 */
export const zResumeExecutionAlgoResponse = zExecutionAlgo;

export const zListForwardRunsQuery = /*#__PURE__*/ z.object({
    definitionId: /*#__PURE__*/ z.string().optional(),
    bucketDefinitionId: /*#__PURE__*/ z.string().optional(),
    status: /*#__PURE__*/ z.enum([
        'warming_up',
        'active',
        'paused',
        'stopped'
    ]).optional(),
    limit: /*#__PURE__*/ z.string().optional(),
    offset: /*#__PURE__*/ z.string().optional()
});

/**
 * Forward runs for the organization, newest first
 */
export const zListForwardRunsResponse = zForwardRunList;

export const zCreateSystematicForwardRunBody = zCreateForwardRunBody;

/**
 * Systematic paper forward run created (or existing run returned)
 */
export const zCreateSystematicForwardRunResponse = zForwardRunCreateResult;

export const zCreateBucketForwardRunBody2 = zCreateBucketForwardRunBody;

/**
 * Bucket forward run created with PIT-frozen component weights (or existing run returned)
 */
export const zCreateBucketForwardRunResponse = zForwardRunCreateResult;

export const zGetForwardRunPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().min(1)
});

/**
 * Forward run detail including paper equity and current positions
 */
export const zGetForwardRunResponse = zForwardRun;

/**
 * Shadow-mode certification status for all 4 brain daemons
 */
export const zListShadowModeDaemonsResponse = zShadowDaemonCertList;

export const zGetShadowModeDaemonPath = /*#__PURE__*/ z.object({
    daemonId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Shadow-mode certification status for one brain daemon
 */
export const zGetShadowModeDaemonResponse = zShadowDaemonCertData;

export const zUpdateShadowModeDaemonEnrollmentBody = zShadowDaemonEnrollUpdate;

export const zUpdateShadowModeDaemonEnrollmentPath = /*#__PURE__*/ z.object({
    daemonId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Enrollment mode updated
 */
export const zUpdateShadowModeDaemonEnrollmentResponse = zShadowDaemonCertData;

export const zCertifyShadowModeDaemonPath = /*#__PURE__*/ z.object({
    daemonId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Daemon certified — mode set to "certified" in the cert payload
 */
export const zCertifyShadowModeDaemonResponse = zShadowDaemonCertData;

export const zGraduateShadowModeDaemonPath = /*#__PURE__*/ z.object({
    daemonId: /*#__PURE__*/ z.int().gt(0)
});

/**
 * Daemon graduated — daemon.enabled flipped to true for live execution
 */
export const zGraduateShadowModeDaemonResponse = zShadowDaemonCertData;

export const zGetProjectCodeOperationalMetricsPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

/**
 * Operational generated-code review, source sync, and gate carryover metrics
 */
export const zGetProjectCodeOperationalMetricsResponse = zProjectCodeOperationalMetrics;

export const zGetProjectCodeWorkspacePath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

/**
 * Project code workspace projection
 */
export const zGetProjectCodeWorkspaceResponse = zCodeWorkspaceState;

export const zListProjectCodeRepositoryConnectionsPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

/**
 * Active repository connections available to this project
 */
export const zListProjectCodeRepositoryConnectionsResponse = zCodeRepositoryConnectionList;

export const zCreateProjectCodeRepositoryConnectionBody = zCodeRepositoryConnectionCreateInput;

export const zCreateProjectCodeRepositoryConnectionPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

/**
 * Repository connection created for this project
 */
export const zCreateProjectCodeRepositoryConnectionResponse = zCodeRepositoryConnection;

export const zEnableProjectCodeWorkspaceBody = zCodeWorkspaceEnableInput;

export const zEnableProjectCodeWorkspacePath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

/**
 * Code workspace enablement accepted
 */
export const zEnableProjectCodeWorkspaceResponse = zCodeWorkspaceEnableResult;

export const zListProjectCodeCheckpointsPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

export const zListProjectCodeCheckpointsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    cursor: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Project code checkpoints
 */
export const zListProjectCodeCheckpointsResponse = zCodeWorkspaceCheckpointsList;

export const zListProjectCodeWorkspaceOperationsPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

export const zListProjectCodeWorkspaceOperationsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    cursor: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Project code workspace operations
 */
export const zListProjectCodeWorkspaceOperationsResponse = zCodeWorkspaceOperationsList;

export const zMaterializeProjectChangeCodeBody = zCodeWorkspaceMaterializeInput;

export const zMaterializeProjectChangeCodePath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    changeId: /*#__PURE__*/ z.string()
});

/**
 * Code materialization operation queued
 */
export const zMaterializeProjectChangeCodeResponse = zCodeWorkspaceOperationResult;

export const zOpenProjectChangeCodeReviewBody = zCodeWorkspaceOpenReviewInput;

export const zOpenProjectChangeCodeReviewPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    changeId: /*#__PURE__*/ z.string()
});

/**
 * Open-review operation queued
 */
export const zOpenProjectChangeCodeReviewResponse = zCodeWorkspaceOperationResult;

export const zRollbackProjectCodeCheckpointBody = zCodeWorkspaceRollbackInput;

export const zRollbackProjectCodeCheckpointPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    checkpointId: /*#__PURE__*/ z.string()
});

/**
 * Rollback operation queued
 */
export const zRollbackProjectCodeCheckpointResponse = zCodeWorkspaceOperationResult;

export const zGetProjectCodeClientDatabasePath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

export const zGetProjectCodeClientDatabaseQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    migrationCursor: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    snapshotCursor: /*#__PURE__*/ z.string().min(1).max(200).optional()
});

/**
 * Project client database target, migration ledger, and DB snapshot markers
 */
export const zGetProjectCodeClientDatabaseResponse = zCodeClientDatabaseState;

export const zConfigureProjectCodeClientDatabaseBody = zCodeClientDatabaseConfigureInput;

export const zConfigureProjectCodeClientDatabasePath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string()
});

/**
 * Configured project client database target
 */
export const zConfigureProjectCodeClientDatabaseResponse = zCodeClientDatabaseState;

export const zGetProjectWorkstreamCodeTuningViewPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string()
});

/**
 * Code tuning view for a focused workstream
 */
export const zGetProjectWorkstreamCodeTuningViewResponse = zCodeTuningView;

export const zEnableProjectWorkstreamCodeWorkforcePath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string()
});

export const zEnableProjectWorkstreamCodeWorkforceQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    cursor: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Ensure the code Project Manager is hired and visible for this workstream
 */
export const zEnableProjectWorkstreamCodeWorkforceResponse = zCodeWorkforceEnable;

export const zCreateProjectWorkstreamCodeGenerationRunBody = zCodeGenerationRunCreateInput;

export const zCreateProjectWorkstreamCodeGenerationRunPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string()
});

/**
 * Code generation workflow run queued for this workstream
 */
export const zCreateProjectWorkstreamCodeGenerationRunResponse = zCodeGenerationRunQueued;

export const zListProjectWorkstreamCodeReviewRequestsPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string()
});

export const zListProjectWorkstreamCodeReviewRequestsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gt(0).lte(200).optional(),
    cursor: /*#__PURE__*/ z.iso.datetime().optional()
});

/**
 * Code review requests for a focused workstream
 */
export const zListProjectWorkstreamCodeReviewRequestsResponse = zCodeReviewRequestList;

export const zCreateProjectWorkstreamCodeReviewRequestBody = zCodeReviewRequestCreate;

export const zCreateProjectWorkstreamCodeReviewRequestPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    versionId: /*#__PURE__*/ z.string()
});

/**
 * Code review request created for this generated version
 */
export const zCreateProjectWorkstreamCodeReviewRequestResponse = zCodeReviewRequest;

export const zGetProjectWorkstreamCodeReviewRequestPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    reviewRequestId: /*#__PURE__*/ z.string()
});

/**
 * Code review request with redacted evidence summaries
 */
export const zGetProjectWorkstreamCodeReviewRequestResponse = zCodeReviewRequest;

export const zDecideProjectWorkstreamCodeReviewRequestBody = zCodeReviewRequestDecisionInput;

export const zDecideProjectWorkstreamCodeReviewRequestPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    reviewRequestId: /*#__PURE__*/ z.string()
});

/**
 * Code review request resolved
 */
export const zDecideProjectWorkstreamCodeReviewRequestResponse = zCodeReviewRequest;

export const zCreateProjectWorkstreamCodePreviewSessionBody = zCodePreviewSessionCreateBody;

export const zCreateProjectWorkstreamCodePreviewSessionPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string()
});

/**
 * Created or resumed an opaque server-owned code preview session
 */
export const zCreateProjectWorkstreamCodePreviewSessionResponse = zCodePreviewSession;

export const zHeartbeatProjectWorkstreamCodePreviewSessionPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    sessionId: /*#__PURE__*/ z.string().min(1)
});

export const zHeartbeatProjectWorkstreamCodePreviewSessionQuery = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string().min(1)
});

/**
 * Extended the code preview session TTL
 */
export const zHeartbeatProjectWorkstreamCodePreviewSessionResponse = zCodePreviewSession;

export const zStreamProjectWorkstreamCodePreviewSessionEventsPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    sessionId: /*#__PURE__*/ z.string().min(1)
});

export const zStreamProjectWorkstreamCodePreviewSessionEventsQuery = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string().min(1)
});

/**
 * SSE stream for a token-scoped code preview session
 */
export const zStreamProjectWorkstreamCodePreviewSessionEventsResponse = /*#__PURE__*/ z.string();

export const zViewProjectWorkstreamCodePreviewSessionPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    sessionId: /*#__PURE__*/ z.string().min(1)
});

export const zViewProjectWorkstreamCodePreviewSessionQuery = /*#__PURE__*/ z.object({
    token: /*#__PURE__*/ z.string().min(1)
});

/**
 * Stable iframe HTML entrypoint for a token-scoped code preview session
 */
export const zViewProjectWorkstreamCodePreviewSessionResponse = /*#__PURE__*/ z.string();

export const zDeleteProjectWorkstreamCodePreviewSessionPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    sessionId: /*#__PURE__*/ z.string().min(1)
});

/**
 * Disposed an active code preview session when present
 */
export const zDeleteProjectWorkstreamCodePreviewSessionResponse = zCodePreviewSessionDispose;

export const zAcceptProjectWorkstreamCodeTuningVersionPath = /*#__PURE__*/ z.object({
    projectId: /*#__PURE__*/ z.string(),
    workstreamId: /*#__PURE__*/ z.string(),
    versionId: /*#__PURE__*/ z.string()
});

/**
 * Accepted code tuning version promoted to a project change revision
 */
export const zAcceptProjectWorkstreamCodeTuningVersionResponse = zCodeTuningProjectChangeRevision;

/**
 * GitHub webhook accepted for code workspace reconciliation
 */
export const zHandleGitHubCodeWorkspaceWebhookResponse = zCodeWorkspaceWebhookResult;

export const zApiListDecisionsQuery = /*#__PURE__*/ z.object({
    status: /*#__PURE__*/ z.enum(['pending', 'recent']).optional(),
    mine: /*#__PURE__*/ z.enum(['true', 'false']).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional()
});

/**
 * Requests waiting on a person (or recently decided)
 */
export const zApiListDecisionsResponse = zApiDecisionList;

export const zApiApproveDecisionBody = zApiDecisionApproveRequest;

export const zApiApproveDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^\d+$/)
});

/**
 * Approve a pending request as the key’s person
 */
export const zApiApproveDecisionResponse = zApiDecisionReviewResult;

export const zApiRejectDecisionBody = zApiDecisionRejectRequest;

export const zApiRejectDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^\d+$/)
});

/**
 * Turn down a pending request, with the reason
 */
export const zApiRejectDecisionResponse = zApiDecisionReviewResult;

export const zApiGetWorkflowRunPartPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^\d+$/),
    runId: /*#__PURE__*/ z.string().regex(/^\d+$/),
    partId: /*#__PURE__*/ z.string().regex(/^\d+$/)
});

/**
 * One output part of a workflow run, whole (≤ 512 KB inline)
 */
export const zApiGetWorkflowRunPartResponse = zApiOutputPartResult;

export const zApiGetDashboardDataPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^\d+$/)
});

/**
 * A dashboard with what each widget shows now
 */
export const zApiGetDashboardDataResponse = zApiDashboardResult;

export const zApiListIntelSourcesQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional()
});

/**
 * The sources (channels, accounts, feeds) the organization knows, and whether it follows each
 */
export const zApiListIntelSourcesResponse = zApiIntelSourceList;

export const zApiListIntelSourceItemsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^\d+$/)
});

export const zApiListIntelSourceItemsQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(25).optional()
});

/**
 * A source’s newest items (videos, posts, articles), each marked analysed or not
 */
export const zApiListIntelSourceItemsResponse = zApiIntelSourceItemList;

export const zApiCancelDecisionPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^\d+$/)
});

/**
 * Withdraw a pending request the key’s person raised
 */
export const zApiCancelDecisionResponse = zApiDecisionCancelResult;

export const zApiListStrategiesQuery = /*#__PURE__*/ z.object({
    limit: /*#__PURE__*/ z.int().gte(1).lte(200).optional(),
    stage: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    source: /*#__PURE__*/ z.enum(['content']).optional(),
    tier: /*#__PURE__*/ z.string().min(1).max(80).optional()
});

/**
 * The organization’s strategies
 */
export const zApiListStrategiesResponse = zApiStrategyList;

export const zApiGetStrategyPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^(def|run):\d+$/)
});

/**
 * One strategy: its metrics, definition, parameters, readiness and per-regime results
 */
export const zApiGetStrategyResponse = zApiStrategyResult;

export const zApiListStrategyBucketsQuery = /*#__PURE__*/ z.object({
    q: /*#__PURE__*/ z.string().min(1).max(200).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional()
});

/**
 * The organization’s strategy buckets
 */
export const zApiListStrategyBucketsResponse = zApiStrategyBucketList;

export const zApiGetStrategyBucketPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^\d+$/)
});

/**
 * One bucket: its legs, their weights and each leg’s latest backtest
 */
export const zApiGetStrategyBucketResponse = zApiStrategyBucketResult;

export const zApiCompareBacktestsQuery = /*#__PURE__*/ z.object({
    ids: /*#__PURE__*/ z.string()
});

/**
 * Two to five simulations side by side, with the leader of each column
 */
export const zApiCompareBacktestsResponse = zApiBacktestComparisonResult;

export const zApiListMarketRegimesQuery = /*#__PURE__*/ z.object({
    symbols: /*#__PURE__*/ z.string(),
    timeframe: /*#__PURE__*/ z.string().regex(/^\d+(m|h|d|w|M)$/).optional()
});

/**
 * The current market regime of each symbol
 */
export const zApiListMarketRegimesResponse = zApiMarketRegimeList;

export const zApiListBacktestsQuery = /*#__PURE__*/ z.object({
    since: /*#__PURE__*/ z.string().min(1).optional(),
    source: /*#__PURE__*/ z.enum(['content']).optional(),
    strategyId: /*#__PURE__*/ z.string().regex(/^(def|run):\d+$/).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(50).optional()
});

/**
 * Simulations on record, newest first (one strategy’s, or the organization’s)
 */
export const zApiListBacktestsResponse = zApiBacktestList;

export const zApiCreateBacktestBody = zApiBacktestCreate;

/**
 * Queue a research-only simulation of a strategy
 */
export const zApiCreateBacktestResponse = zApiBacktestRunResult;

export const zApiGetBacktestPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^(?:(?:run|bt):)?\d+$/)
});

/**
 * One simulation: its window, full statistics, scores and series sizes
 */
export const zApiGetBacktestResponse = zApiBacktestResult;

export const zApiListBacktestSeriesPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^(?:(?:run|bt):)?\d+$/),
    kind: /*#__PURE__*/ z.enum([
        'equity',
        'trades',
        'regimes',
        'drawdown_series',
        'buy_hold_equity',
        'oos_returns_series'
    ])
});

export const zApiListBacktestSeriesQuery = /*#__PURE__*/ z.object({
    cursor: /*#__PURE__*/ z.string().optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(1000).optional()
});

/**
 * One page of a simulation's series (equity, trades, regimes, drawdown_series, buy_hold_equity, oos_returns_series)
 */
export const zApiListBacktestSeriesResponse = zApiBacktestSeriesPage;

export const zApiGetBacktestAnalyticsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^(?:(?:run|bt):)?\d+$/)
});

/**
 * A simulation’s full analysis, computed once per run (the same as the platform’s Strategy Tester)
 */
export const zApiGetBacktestAnalyticsResponse = zApiBacktestAnalyticsResult;

export const zApiGetCandlesQuery = /*#__PURE__*/ z.object({
    symbol: /*#__PURE__*/ z.string().min(1).max(40),
    timeframe: /*#__PURE__*/ z.string().regex(/^\d+(m|h|d|w|M)$/),
    from: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    to: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    cursor: /*#__PURE__*/ z.string().min(1).max(500).optional(),
    exchange: /*#__PURE__*/ z.string().min(1).max(40).optional(),
    format: /*#__PURE__*/ z.enum(['json', 'columnar']).optional(),
    limit: /*#__PURE__*/ z.int().gte(1).lte(5000).optional(),
    countback: /*#__PURE__*/ z.int().gte(1).lte(5000).optional()
});

/**
 * A window of stored OHLCV bars for a chart ([from, to), newest page first in time order)
 */
export const zApiGetCandlesResponse = zApiCandleWindow;

export const zApiStreamBacktestEventsPath = /*#__PURE__*/ z.object({
    id: /*#__PURE__*/ z.string().regex(/^(?:(?:run|bt):\d+|[A-Za-z0-9][A-Za-z0-9:_.-]{2,199})$/)
});

/**
 * A simulation’s status and progress as server-sent events, until it is done — server-sent events status / progress / done / error; each frame's data is this schema
 */
export const zApiStreamBacktestEventsResponse = zApiRunEvent;

export const zGetMarketDataBackupQuery = /*#__PURE__*/ z.object({
    days: /*#__PURE__*/ z.int().gte(1).lte(3650).optional()
});

/**
 * The backup file (gzip’d SQL), named by its cut and day in `content-disposition`
 */
export const zGetMarketDataBackupResponse = /*#__PURE__*/ z.string();

export const zCreateMarketDataGrantsBody = /*#__PURE__*/ z.object({
    workerId: /*#__PURE__*/ z.string().min(1).max(200),
    network: /*#__PURE__*/ z.object({
        privateAddresses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(64)).max(32),
        lanAddresses: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string().max(64)).max(32),
        publicEgress: /*#__PURE__*/ z.string().max(64).optional(),
        engineBoxReachable: /*#__PURE__*/ z.boolean().nullable(),
        probedAt: /*#__PURE__*/ z.string()
    }).nullable()
});

/**
 * The grants, possibly none
 */
export const zCreateMarketDataGrantsResponse = /*#__PURE__*/ z.object({
    grants: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        instanceId: /*#__PURE__*/ z.string(),
        organizationId: /*#__PURE__*/ z.int(),
        platform: /*#__PURE__*/ z.boolean(),
        mode: /*#__PURE__*/ z.enum(['primary', 'replica']),
        urls: /*#__PURE__*/ z.array(/*#__PURE__*/ z.string()),
        token: /*#__PURE__*/ z.string(),
        expiresAt: /*#__PURE__*/ z.string()
    }))
});

/**
 * The platform's market coverage snapshot
 */
export const zGetMarketDataCoverageResponse = /*#__PURE__*/ z.object({
    computedAt: /*#__PURE__*/ z.string(),
    rows: /*#__PURE__*/ z.array(/*#__PURE__*/ z.object({
        table: /*#__PURE__*/ z.string(),
        entity: /*#__PURE__*/ z.string().nullable(),
        timeframe: /*#__PURE__*/ z.string().nullable(),
        firstAt: /*#__PURE__*/ z.string().nullable(),
        lastAt: /*#__PURE__*/ z.string().nullable(),
        rowCount: /*#__PURE__*/ z.int()
    }))
});
